var uc = Object.defineProperty;
var lc = (r, e, s) => e in r ? uc(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s;
var Va = (r, e, s) => (lc(r, typeof e != "symbol" ? e + "" : e, s), s);
import { ref, watch as watch$3, openBlock, createElementBlock, toDisplayString, createCommentVNode, createElementVNode, withModifiers, defineComponent, Fragment, renderList, resolveComponent, createVNode, renderSlot, normalizeClass, createTextVNode, createBlock, pushScopeId, popScopeId, watchEffect } from "vue";
import { defineStore, storeToRefs, createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
var TransactionServerStatusesEnum = /* @__PURE__ */ ((r) => (r.pending = "pending", r.fail = "fail", r.invalid = "invalid", r.success = "success", r.executed = "executed", r.notExecuted = "not executed", r.rewardReverted = "reward-reverted", r))(TransactionServerStatusesEnum || {}), TransactionBatchStatusesEnum = /* @__PURE__ */ ((r) => (r.signed = "signed", r.cancelled = "cancelled", r.success = "success", r.sent = "sent", r.fail = "fail", r.timedOut = "timedOut", r))(TransactionBatchStatusesEnum || {}), LoginMethodsEnum = /* @__PURE__ */ ((r) => (r.ledger = "ledger", r.walletconnect = "walletconnect", r.walletconnectv2 = "walletconnectv2", r.wallet = "wallet", r.extension = "extension", r.extra = "extra", r.none = "", r))(LoginMethodsEnum || {}), NotificationTypesEnum = /* @__PURE__ */ ((r) => (r.warning = "warning", r.error = "error", r.success = "success", r))(NotificationTypesEnum || {}), TypesOfSmartContractCallsEnum = /* @__PURE__ */ ((r) => (r.MultiESDTNFTTransfer = "MultiESDTNFTTransfer", r.ESDTNFTTransfer = "ESDTNFTTransfer", r))(TypesOfSmartContractCallsEnum || {}), EnvironmentsEnum = /* @__PURE__ */ ((r) => (r.testnet = "testnet", r.devnet = "devnet", r.mainnet = "mainnet", r))(EnvironmentsEnum || {}), ToastsEnum = /* @__PURE__ */ ((r) => (r.custom = "custom", r.transaction = "transaction", r))(ToastsEnum || {}), TransactionsDefaultTitles = /* @__PURE__ */ ((r) => (r.success = "Transaction successful", r.failed = "Transaction failed", r.pending = "Processing transaction", r.timedOut = "Transaction timed out", r))(TransactionsDefaultTitles || {}), PlatformsEnum = /* @__PURE__ */ ((r) => (r.ios = "ios", r.reactNative = "reactNative", r.web = "web", r))(PlatformsEnum || {}), WebViewProviderRequestEnums = /* @__PURE__ */ ((r) => (r.signTransactionsRequest = "SIGN_TRANSACTIONS_REQUEST", r.signMessageRequest = "SIGN_MESSAGE_REQUEST", r.loginRequest = "LOGIN_REQUEST", r.logoutRequest = "LOGOUT_REQUEST", r.reloginRequest = "RELOGIN_REQUEST", r))(WebViewProviderRequestEnums || {}), WebViewProviderResponseEnums = /* @__PURE__ */ ((r) => (r.signTransactionsResponse = "SIGN_TRANSACTIONS_RESPONSE", r.signMessageResponse = "SIGN_MESSAGE_RESPONSE", r.loginResponse = "LOGIN_RESPONSE", r.reloginResponse = "RELOGIN_RESPONSE", r))(WebViewProviderResponseEnums || {}), TransactionActionsEnum = /* @__PURE__ */ ((r) => (r.transfer = "transfer", r.unBond = "unBond", r.unStake = "unStake", r.delegate = "delegate", r.stake = "stake", r.unDelegate = "unDelegate", r.stakeClaimRewards = "claimRewards", r.reDelegateRewards = "reDelegateRewards", r.withdraw = "withdraw", r.claimLockedAssets = "claimLockedAssets", r.swapTokensFixedInput = "swapTokensFixedInput", r.swapTokensFixedOutput = "swapTokensFixedOutput", r.swap = "swap", r.addLiquidity = "addLiquidity", r.addLiquidityProxy = "addLiquidityProxy", r.removeLiquidity = "removeLiquidity", r.removeLiquidityProxy = "removeLiquidityProxy", r.enterFarm = "enterFarm", r.enterFarmProxy = "enterFarmProxy", r.enterFarmAndLockRewards = "enterFarmAndLockRewards", r.enterFarmAndLockRewardsProxy = "enterFarmAndLockRewardsProxy", r.exitFarm = "exitFarm", r.exitFarmProxy = "exitFarmProxy", r.claimRewards = "claimRewards", r.claimRewardsProxy = "claimRewardsProxy", r.compoundRewards = "compoundRewards", r.compoundRewardsProxy = "compoundRewardsProxy", r.wrapEgld = "wrapEgld", r.unwrapEgld = "unwrapEgld", r.unlockAssets = "unlockAssets", r.mergeLockedAssetTokens = "mergeLockedAssetTokens", r.stakeFarm = "stakeFarm", r.stakeFarmProxy = "stakeFarmProxy", r.stakeFarmTokens = "stakeFarmTokens", r.stakeFarmTokensProxy = "stakeFarmTokensProxy", r.unstakeFarm = "unstakeFarm", r.unstakeFarmProxy = "unstakeFarmProxy", r.unstakeFarmTokens = "unstakeFarmTokens", r.unstakeFarmTokensProxy = "unstakeFarmTokensProxy", r.claimDualYield = "claimDualYield", r.claimDualYieldProxy = "claimDualYieldProxy", r.unbondFarm = "unbondFarm", r.ping = "ping", r))(TransactionActionsEnum || {});
const fallbackNetworkConfigurations = {
  devnet: {
    id: "devnet",
    chainId: "D",
    name: "Devnet",
    egldLabel: "xEGLD",
    decimals: "18",
    digits: "4",
    gasPerDataByte: "1500",
    walletConnectDeepLink: "https://maiar.page.link/?apn=com.elrond.maiar.wallet&isi=1519405832&ibi=com.elrond.maiar.wallet&link=https://xportal.com/",
    walletConnectBridgeAddresses: ["https://bridge.walletconnect.org"],
    walletConnectV2RelayAddresses: ["wss://relay.walletconnect.com"],
    walletAddress: "https://devnet-wallet.multiversx.com",
    apiAddress: "https://devnet-api.multiversx.com",
    explorerAddress: "http://devnet-explorer.multiversx.com",
    apiTimeout: "4000"
  },
  testnet: {
    id: "testnet",
    chainId: "T",
    name: "Testnet",
    egldLabel: "xEGLD",
    decimals: "18",
    digits: "4",
    gasPerDataByte: "1500",
    walletConnectDeepLink: "https://maiar.page.link/?apn=com.elrond.maiar.wallet&isi=1519405832&ibi=com.elrond.maiar.wallet&link=https://xportal.com/",
    walletConnectBridgeAddresses: ["https://bridge.walletconnect.org"],
    walletConnectV2RelayAddresses: ["wss://relay.walletconnect.com"],
    walletAddress: "https://testnet-wallet.multiversx.com",
    apiAddress: "https://testnet-api.multiversx.com",
    explorerAddress: "http://testnet-explorer.multiversx.com",
    apiTimeout: "4000"
  },
  mainnet: {
    id: "mainnet",
    chainId: "1",
    name: "Mainnet",
    egldLabel: "EGLD",
    decimals: "18",
    digits: "4",
    gasPerDataByte: "1500",
    walletConnectDeepLink: "https://maiar.page.link/?apn=com.elrond.maiar.wallet&isi=1519405832&ibi=com.elrond.maiar.wallet&link=https://xportal.com/",
    walletConnectBridgeAddresses: ["https://bridge.walletconnect.org"],
    walletConnectV2RelayAddresses: ["wss://relay.walletconnect.com"],
    walletAddress: "https://wallet.multiversx.com",
    apiAddress: "https://api.multiversx.com",
    explorerAddress: "https://explorer.multiversx.com",
    apiTimeout: "4000"
  }
}, {
  chainId: DEVNET_CHAIN_ID,
  egldLabel: DEVNET_EGLD_LABEL
} = fallbackNetworkConfigurations[EnvironmentsEnum.devnet], {
  chainId: TESTNET_CHAIN_ID,
  egldLabel: TESTNET_EGLD_LABEL
} = fallbackNetworkConfigurations[EnvironmentsEnum.testnet], {
  chainId: MAINNET_CHAIN_ID,
  egldLabel: MAINNET_EGLD_LABEL
} = fallbackNetworkConfigurations[EnvironmentsEnum.mainnet];
EnvironmentsEnum.devnet + "", EnvironmentsEnum.testnet + "", EnvironmentsEnum.mainnet + "";
DEVNET_CHAIN_ID + "", EnvironmentsEnum.devnet, TESTNET_CHAIN_ID + "", EnvironmentsEnum.testnet, MAINNET_CHAIN_ID + "", EnvironmentsEnum.mainnet;
function getRandomAddressFromNetwork(r) {
  return r[Math.floor(Math.random() * r.length)];
}
const ledgerErrorCodes = {
  36864: {
    code: "codeSuccess",
    message: "Success"
  },
  27013: {
    code: "ERR_USER_DENIED",
    message: "Rejected by user"
  },
  27904: {
    code: "ERR_UNKNOWN_INSTRUCTION",
    message: "Unknown instruction"
  },
  28160: {
    code: "ERR_WRONG_CLA",
    message: "Wrong CLA"
  },
  28161: {
    code: "ERR_INVALID_ARGUMENTS",
    message: "Invalid arguments"
  },
  28162: {
    code: "ERR_INVALID_MESSAGE",
    message: "Invalid message"
  },
  28163: {
    code: "ERR_INVALID_P1",
    message: "Invalid P1"
  },
  28164: {
    code: "ERR_MESSAGE_TOO_LONG",
    message: "Message too long"
  },
  28165: {
    code: "ERR_RECEIVER_TOO_LONG",
    message: "Receiver too long"
  },
  28166: {
    code: "ERR_AMOUNT_TOO_LONG",
    message: "Amount too long"
  },
  28167: {
    code: "ERR_CONTRACT_DATA_DISABLED",
    message: "Contract data disabled in app options"
  },
  28168: {
    code: "ERR_MESSAGE_INCOMPLETE",
    message: "Message incomplete"
  },
  28176: {
    code: "ERR_SIGNATURE_FAILED",
    message: "Signature failed"
  },
  28169: {
    code: "ERR_WRONG_TX_VERSION",
    message: "Wrong TX version"
  },
  28170: {
    code: "ERR_NONCE_TOO_LONG",
    message: "Nonce too long"
  },
  28171: {
    code: "ERR_INVALID_AMOUNT",
    message: "Invalid amount"
  },
  28172: {
    code: "ERR_INVALID_FEE",
    message: "Invalid fee"
  },
  28173: {
    code: "ERR_PRETTY_FAILED",
    message: "Pretty failed"
  },
  28174: {
    code: "ERR_DATA_TOO_LONG",
    message: "Data too long"
  },
  28175: {
    code: "ERR_WRONG_TX_OPTIONS",
    message: "Invalid transaction options"
  },
  28177: {
    code: "ERR_SIGN_TX_DEPRECATED",
    message: "Regular transaction signing is deprecated in this version. Use hash signing."
  }
}, ledgerAppErrorText = "Check if Elrond app is open on Ledger", notConnectedCode = 28161, wrongClaCode = 28160, inactiveAppCodes = [notConnectedCode, wrongClaCode];
function getLedgerErrorCodes(r) {
  let e = null;
  if ((r == null ? void 0 : r.statusCode) in ledgerErrorCodes) {
    const s = r == null ? void 0 : r.statusCode, { message: o } = ledgerErrorCodes[s];
    e = inactiveAppCodes.includes(s) ? ledgerAppErrorText : o;
  }
  return {
    errorMessage: e,
    defaultErrorMessage: ledgerAppErrorText
  };
}
let preventRedirect = !1;
const preventRedirects = (r = !0) => {
  preventRedirect = r;
}, safeRedirect = (r, e = 0) => {
  preventRedirect || setTimeout(() => {
    window.location.href = r;
  }, e);
}, DEFAULT_TIMEOUT = 200;
function optionalRedirect$1({
  callbackRoute: r,
  onLoginRedirect: e,
  options: s
}) {
  const o = Boolean(r), fe = typeof e == "function", me = fe ? 0 : DEFAULT_TIMEOUT;
  o && r != null && setTimeout(() => {
    if (fe)
      return e(r, s);
    window.location.pathname.includes(r) || safeRedirect(r);
  }, me);
}
const ERROR_SIGNING = "error when signing", TRANSACTION_CANCELLED = "Transaction canceled", ERROR_SIGNING_TX = "error signing transaction", PROVIDER_NOT_INITIALIZED = "provider not initialized", MISSING_PROVIDER_MESSAGE = "You need a signer/valid signer to send a transaction,use either WalletProvider, LedgerProvider or WalletConnect", SECOND_LOGIN_ATTEMPT_ERROR = "Action not allowed. User is logged in. Call logout() first", TRANSACTION_STATUS_TOAST_ID = "transaction-status-toast-id", GAS_PRICE_MODIFIER = 0.01, GAS_PER_DATA_BYTE = 1500, GAS_LIMIT = 1e7, GAS_PRICE = 1e9, DECIMALS = 18, DIGITS = 4, VERSION$2 = 1, LEDGER_CONTRACT_DATA_ENABLED_VALUE = 1, DAPP_INIT_ROUTE$1 = "/dapp/init", WALLET_SIGN_SESSION = "signSession", ZERO = "0", defaultNetwork = {
  id: "not-configured",
  chainId: "",
  name: "NOT CONFIGURED",
  egldLabel: "",
  decimals: "18",
  digits: "4",
  gasPerDataByte: "1500",
  walletConnectDeepLink: "",
  walletConnectBridgeAddress: "",
  walletConnectV2RelayAddress: "",
  walletConnectV2ProjectId: "",
  walletConnectV2Options: {},
  walletAddress: "",
  apiAddress: "",
  explorerAddress: "",
  apiTimeout: "4000"
}, emptyAccount$1 = {
  balance: "...",
  address: "",
  nonce: 0,
  txCount: 0,
  scrCount: 0,
  claimableRewards: ZERO
}, initialState$8 = {
  network: defaultNetwork,
  chainID: "",
  accountInfo: emptyAccount$1
}, useDappStore = defineStore("erdjs-dapp", {
  state: () => ({ ...initialState$8 }),
  persist: !0,
  getters: {
    getNetworkConfig: (r) => r.network,
    getChainId: (r) => r.chainID,
    getAccountInfo: (r) => r.accountInfo,
    getApiAddress: (r) => r.network.apiAddress,
    getWalletConnectBridgeAddress: (r) => r.network.walletConnectBridgeAddress,
    getWalletConnectDeepLink: (r) => r.network.walletConnectDeepLink,
    getEgldLabel: (r) => r.network.egldLabel,
    getWalletConnectV2RelaySelector: (r) => r.network.walletConnectV2RelayAddress,
    getWalletConnectV2ProjectIdSelector: (r) => r.network.walletConnectV2ProjectId,
    getWalletConnectV2OptionsSelector: (r) => r.network.walletConnectV2Options
  },
  actions: {
    updateNetworkConfig(r) {
      const e = getRandomAddressFromNetwork(
        r.walletConnectBridgeAddresses
      ), s = getRandomAddressFromNetwork(
        r.walletConnectV2RelayAddresses
      ), o = r.walletConnectV2ProjectId ? r.walletConnectV2ProjectId : "";
      if (!o)
        throw new Error("Missing Wallet Connect V2 Project ID. You can generate one here: https://cloud.walletconnect.com/app");
      const fe = r;
      this.network = {
        ...fe,
        walletConnectBridgeAddress: e,
        walletConnectV2ProjectId: o,
        walletConnectV2RelayAddress: s
      };
    },
    updateAccountInfo(r) {
      this.accountInfo = r;
    },
    updateChainId(r) {
      this.chainID = r;
    }
  }
});
var isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER$4 = 9007199254740991, POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], SQRT_BASE = 1e7, MAX$1 = 1e9;
function clone(r) {
  var e, s, o, fe = Yr.prototype = { constructor: Yr, toString: null, valueOf: null }, me = new Yr(1), ye = 20, fr = 4, Er = -7, br = 21, wr = -1e7, kr = 1e7, Gr = !1, Vr = 1, jr = 0, Kr = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: "\xA0",
    suffix: ""
  }, bn = "0123456789abcdefghijklmnopqrstuvwxyz";
  function Yr(Br, Hr) {
    var Pn, ei, oi, Nn, En, qr, Jr, ri, Sn = this;
    if (!(Sn instanceof Yr))
      return new Yr(Br, Hr);
    if (Hr == null) {
      if (Br && Br._isBigNumber === !0) {
        Sn.s = Br.s, !Br.c || Br.e > kr ? Sn.c = Sn.e = null : Br.e < wr ? Sn.c = [Sn.e = 0] : (Sn.e = Br.e, Sn.c = Br.c.slice());
        return;
      }
      if ((qr = typeof Br == "number") && Br * 0 == 0) {
        if (Sn.s = 1 / Br < 0 ? (Br = -Br, -1) : 1, Br === ~~Br) {
          for (Nn = 0, En = Br; En >= 10; En /= 10, Nn++)
            ;
          Nn > kr ? Sn.c = Sn.e = null : (Sn.e = Nn, Sn.c = [Br]);
          return;
        }
        ri = String(Br);
      } else {
        if (!isNumeric.test(ri = String(Br)))
          return o(Sn, ri, qr);
        Sn.s = ri.charCodeAt(0) == 45 ? (ri = ri.slice(1), -1) : 1;
      }
      (Nn = ri.indexOf(".")) > -1 && (ri = ri.replace(".", "")), (En = ri.search(/e/i)) > 0 ? (Nn < 0 && (Nn = En), Nn += +ri.slice(En + 1), ri = ri.substring(0, En)) : Nn < 0 && (Nn = ri.length);
    } else {
      if (intCheck(Hr, 2, bn.length, "Base"), Hr == 10)
        return Sn = new Yr(Br), ni(Sn, ye + Sn.e + 1, fr);
      if (ri = String(Br), qr = typeof Br == "number") {
        if (Br * 0 != 0)
          return o(Sn, ri, qr, Hr);
        if (Sn.s = 1 / Br < 0 ? (ri = ri.slice(1), -1) : 1, Yr.DEBUG && ri.replace(/^0\.0*|\./, "").length > 15)
          throw Error(tooManyDigits + Br);
      } else
        Sn.s = ri.charCodeAt(0) === 45 ? (ri = ri.slice(1), -1) : 1;
      for (Pn = bn.slice(0, Hr), Nn = En = 0, Jr = ri.length; En < Jr; En++)
        if (Pn.indexOf(ei = ri.charAt(En)) < 0) {
          if (ei == ".") {
            if (En > Nn) {
              Nn = Jr;
              continue;
            }
          } else if (!oi && (ri == ri.toUpperCase() && (ri = ri.toLowerCase()) || ri == ri.toLowerCase() && (ri = ri.toUpperCase()))) {
            oi = !0, En = -1, Nn = 0;
            continue;
          }
          return o(Sn, String(Br), qr, Hr);
        }
      qr = !1, ri = s(ri, Hr, 10, Sn.s), (Nn = ri.indexOf(".")) > -1 ? ri = ri.replace(".", "") : Nn = ri.length;
    }
    for (En = 0; ri.charCodeAt(En) === 48; En++)
      ;
    for (Jr = ri.length; ri.charCodeAt(--Jr) === 48; )
      ;
    if (ri = ri.slice(En, ++Jr)) {
      if (Jr -= En, qr && Yr.DEBUG && Jr > 15 && (Br > MAX_SAFE_INTEGER$4 || Br !== mathfloor(Br)))
        throw Error(tooManyDigits + Sn.s * Br);
      if ((Nn = Nn - En - 1) > kr)
        Sn.c = Sn.e = null;
      else if (Nn < wr)
        Sn.c = [Sn.e = 0];
      else {
        if (Sn.e = Nn, Sn.c = [], En = (Nn + 1) % LOG_BASE, Nn < 0 && (En += LOG_BASE), En < Jr) {
          for (En && Sn.c.push(+ri.slice(0, En)), Jr -= LOG_BASE; En < Jr; )
            Sn.c.push(+ri.slice(En, En += LOG_BASE));
          En = LOG_BASE - (ri = ri.slice(En)).length;
        } else
          En -= Jr;
        for (; En--; ri += "0")
          ;
        Sn.c.push(+ri);
      }
    } else
      Sn.c = [Sn.e = 0];
  }
  Yr.clone = clone, Yr.ROUND_UP = 0, Yr.ROUND_DOWN = 1, Yr.ROUND_CEIL = 2, Yr.ROUND_FLOOR = 3, Yr.ROUND_HALF_UP = 4, Yr.ROUND_HALF_DOWN = 5, Yr.ROUND_HALF_EVEN = 6, Yr.ROUND_HALF_CEIL = 7, Yr.ROUND_HALF_FLOOR = 8, Yr.EUCLID = 9, Yr.config = Yr.set = function(Br) {
    var Hr, Pn;
    if (Br != null)
      if (typeof Br == "object") {
        if (Br.hasOwnProperty(Hr = "DECIMAL_PLACES") && (Pn = Br[Hr], intCheck(Pn, 0, MAX$1, Hr), ye = Pn), Br.hasOwnProperty(Hr = "ROUNDING_MODE") && (Pn = Br[Hr], intCheck(Pn, 0, 8, Hr), fr = Pn), Br.hasOwnProperty(Hr = "EXPONENTIAL_AT") && (Pn = Br[Hr], Pn && Pn.pop ? (intCheck(Pn[0], -MAX$1, 0, Hr), intCheck(Pn[1], 0, MAX$1, Hr), Er = Pn[0], br = Pn[1]) : (intCheck(Pn, -MAX$1, MAX$1, Hr), Er = -(br = Pn < 0 ? -Pn : Pn))), Br.hasOwnProperty(Hr = "RANGE"))
          if (Pn = Br[Hr], Pn && Pn.pop)
            intCheck(Pn[0], -MAX$1, -1, Hr), intCheck(Pn[1], 1, MAX$1, Hr), wr = Pn[0], kr = Pn[1];
          else if (intCheck(Pn, -MAX$1, MAX$1, Hr), Pn)
            wr = -(kr = Pn < 0 ? -Pn : Pn);
          else
            throw Error(bignumberError + Hr + " cannot be zero: " + Pn);
        if (Br.hasOwnProperty(Hr = "CRYPTO"))
          if (Pn = Br[Hr], Pn === !!Pn)
            if (Pn)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                Gr = Pn;
              else
                throw Gr = !Pn, Error(bignumberError + "crypto unavailable");
            else
              Gr = Pn;
          else
            throw Error(bignumberError + Hr + " not true or false: " + Pn);
        if (Br.hasOwnProperty(Hr = "MODULO_MODE") && (Pn = Br[Hr], intCheck(Pn, 0, 9, Hr), Vr = Pn), Br.hasOwnProperty(Hr = "POW_PRECISION") && (Pn = Br[Hr], intCheck(Pn, 0, MAX$1, Hr), jr = Pn), Br.hasOwnProperty(Hr = "FORMAT"))
          if (Pn = Br[Hr], typeof Pn == "object")
            Kr = Pn;
          else
            throw Error(bignumberError + Hr + " not an object: " + Pn);
        if (Br.hasOwnProperty(Hr = "ALPHABET"))
          if (Pn = Br[Hr], typeof Pn == "string" && !/^.$|[+-.\s]|(.).*\1/.test(Pn))
            bn = Pn;
          else
            throw Error(bignumberError + Hr + " invalid: " + Pn);
      } else
        throw Error(bignumberError + "Object expected: " + Br);
    return {
      DECIMAL_PLACES: ye,
      ROUNDING_MODE: fr,
      EXPONENTIAL_AT: [Er, br],
      RANGE: [wr, kr],
      CRYPTO: Gr,
      MODULO_MODE: Vr,
      POW_PRECISION: jr,
      FORMAT: Kr,
      ALPHABET: bn
    };
  }, Yr.isBigNumber = function(Br) {
    if (!Br || Br._isBigNumber !== !0)
      return !1;
    if (!Yr.DEBUG)
      return !0;
    var Hr, Pn, ei = Br.c, oi = Br.e, Nn = Br.s;
    e:
      if ({}.toString.call(ei) == "[object Array]") {
        if ((Nn === 1 || Nn === -1) && oi >= -MAX$1 && oi <= MAX$1 && oi === mathfloor(oi)) {
          if (ei[0] === 0) {
            if (oi === 0 && ei.length === 1)
              return !0;
            break e;
          }
          if (Hr = (oi + 1) % LOG_BASE, Hr < 1 && (Hr += LOG_BASE), String(ei[0]).length == Hr) {
            for (Hr = 0; Hr < ei.length; Hr++)
              if (Pn = ei[Hr], Pn < 0 || Pn >= BASE || Pn !== mathfloor(Pn))
                break e;
            if (Pn !== 0)
              return !0;
          }
        }
      } else if (ei === null && oi === null && (Nn === null || Nn === 1 || Nn === -1))
        return !0;
    throw Error(bignumberError + "Invalid BigNumber: " + Br);
  }, Yr.maximum = Yr.max = function() {
    return ti(arguments, fe.lt);
  }, Yr.minimum = Yr.min = function() {
    return ti(arguments, fe.gt);
  }, Yr.random = function() {
    var Br = 9007199254740992, Hr = Math.random() * Br & 2097151 ? function() {
      return mathfloor(Math.random() * Br);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(Pn) {
      var ei, oi, Nn, En, qr, Jr = 0, ri = [], Sn = new Yr(me);
      if (Pn == null ? Pn = ye : intCheck(Pn, 0, MAX$1), En = mathceil(Pn / LOG_BASE), Gr)
        if (crypto.getRandomValues) {
          for (ei = crypto.getRandomValues(new Uint32Array(En *= 2)); Jr < En; )
            qr = ei[Jr] * 131072 + (ei[Jr + 1] >>> 11), qr >= 9e15 ? (oi = crypto.getRandomValues(new Uint32Array(2)), ei[Jr] = oi[0], ei[Jr + 1] = oi[1]) : (ri.push(qr % 1e14), Jr += 2);
          Jr = En / 2;
        } else if (crypto.randomBytes) {
          for (ei = crypto.randomBytes(En *= 7); Jr < En; )
            qr = (ei[Jr] & 31) * 281474976710656 + ei[Jr + 1] * 1099511627776 + ei[Jr + 2] * 4294967296 + ei[Jr + 3] * 16777216 + (ei[Jr + 4] << 16) + (ei[Jr + 5] << 8) + ei[Jr + 6], qr >= 9e15 ? crypto.randomBytes(7).copy(ei, Jr) : (ri.push(qr % 1e14), Jr += 7);
          Jr = En / 7;
        } else
          throw Gr = !1, Error(bignumberError + "crypto unavailable");
      if (!Gr)
        for (; Jr < En; )
          qr = Hr(), qr < 9e15 && (ri[Jr++] = qr % 1e14);
      for (En = ri[--Jr], Pn %= LOG_BASE, En && Pn && (qr = POWS_TEN[LOG_BASE - Pn], ri[Jr] = mathfloor(En / qr) * qr); ri[Jr] === 0; ri.pop(), Jr--)
        ;
      if (Jr < 0)
        ri = [Nn = 0];
      else {
        for (Nn = -1; ri[0] === 0; ri.splice(0, 1), Nn -= LOG_BASE)
          ;
        for (Jr = 1, qr = ri[0]; qr >= 10; qr /= 10, Jr++)
          ;
        Jr < LOG_BASE && (Nn -= LOG_BASE - Jr);
      }
      return Sn.e = Nn, Sn.c = ri, Sn;
    };
  }(), Yr.sum = function() {
    for (var Br = 1, Hr = arguments, Pn = new Yr(Hr[0]); Br < Hr.length; )
      Pn = Pn.plus(Hr[Br++]);
    return Pn;
  }, s = function() {
    var Br = "0123456789";
    function Hr(Pn, ei, oi, Nn) {
      for (var En, qr = [0], Jr, ri = 0, Sn = Pn.length; ri < Sn; ) {
        for (Jr = qr.length; Jr--; qr[Jr] *= ei)
          ;
        for (qr[0] += Nn.indexOf(Pn.charAt(ri++)), En = 0; En < qr.length; En++)
          qr[En] > oi - 1 && (qr[En + 1] == null && (qr[En + 1] = 0), qr[En + 1] += qr[En] / oi | 0, qr[En] %= oi);
      }
      return qr.reverse();
    }
    return function(Pn, ei, oi, Nn, En) {
      var qr, Jr, ri, Sn, ai, di, ii, fi, Ei = Pn.indexOf("."), bi = ye, Si = fr;
      for (Ei >= 0 && (Sn = jr, jr = 0, Pn = Pn.replace(".", ""), fi = new Yr(ei), di = fi.pow(Pn.length - Ei), jr = Sn, fi.c = Hr(
        toFixedPoint(coeffToString(di.c), di.e, "0"),
        10,
        oi,
        Br
      ), fi.e = fi.c.length), ii = Hr(Pn, ei, oi, En ? (qr = bn, Br) : (qr = Br, bn)), ri = Sn = ii.length; ii[--Sn] == 0; ii.pop())
        ;
      if (!ii[0])
        return qr.charAt(0);
      if (Ei < 0 ? --ri : (di.c = ii, di.e = ri, di.s = Nn, di = e(di, fi, bi, Si, oi), ii = di.c, ai = di.r, ri = di.e), Jr = ri + bi + 1, Ei = ii[Jr], Sn = oi / 2, ai = ai || Jr < 0 || ii[Jr + 1] != null, ai = Si < 4 ? (Ei != null || ai) && (Si == 0 || Si == (di.s < 0 ? 3 : 2)) : Ei > Sn || Ei == Sn && (Si == 4 || ai || Si == 6 && ii[Jr - 1] & 1 || Si == (di.s < 0 ? 8 : 7)), Jr < 1 || !ii[0])
        Pn = ai ? toFixedPoint(qr.charAt(1), -bi, qr.charAt(0)) : qr.charAt(0);
      else {
        if (ii.length = Jr, ai)
          for (--oi; ++ii[--Jr] > oi; )
            ii[Jr] = 0, Jr || (++ri, ii = [1].concat(ii));
        for (Sn = ii.length; !ii[--Sn]; )
          ;
        for (Ei = 0, Pn = ""; Ei <= Sn; Pn += qr.charAt(ii[Ei++]))
          ;
        Pn = toFixedPoint(Pn, ri, qr.charAt(0));
      }
      return Pn;
    };
  }(), e = function() {
    function Br(ei, oi, Nn) {
      var En, qr, Jr, ri, Sn = 0, ai = ei.length, di = oi % SQRT_BASE, ii = oi / SQRT_BASE | 0;
      for (ei = ei.slice(); ai--; )
        Jr = ei[ai] % SQRT_BASE, ri = ei[ai] / SQRT_BASE | 0, En = ii * Jr + ri * di, qr = di * Jr + En % SQRT_BASE * SQRT_BASE + Sn, Sn = (qr / Nn | 0) + (En / SQRT_BASE | 0) + ii * ri, ei[ai] = qr % Nn;
      return Sn && (ei = [Sn].concat(ei)), ei;
    }
    function Hr(ei, oi, Nn, En) {
      var qr, Jr;
      if (Nn != En)
        Jr = Nn > En ? 1 : -1;
      else
        for (qr = Jr = 0; qr < Nn; qr++)
          if (ei[qr] != oi[qr]) {
            Jr = ei[qr] > oi[qr] ? 1 : -1;
            break;
          }
      return Jr;
    }
    function Pn(ei, oi, Nn, En) {
      for (var qr = 0; Nn--; )
        ei[Nn] -= qr, qr = ei[Nn] < oi[Nn] ? 1 : 0, ei[Nn] = qr * En + ei[Nn] - oi[Nn];
      for (; !ei[0] && ei.length > 1; ei.splice(0, 1))
        ;
    }
    return function(ei, oi, Nn, En, qr) {
      var Jr, ri, Sn, ai, di, ii, fi, Ei, bi, Si, Ii, yi, ui, hi, gi, Qr, wn, ci = ei.s == oi.s ? 1 : -1, vi = ei.c, Ni = oi.c;
      if (!vi || !vi[0] || !Ni || !Ni[0])
        return new Yr(
          !ei.s || !oi.s || (vi ? Ni && vi[0] == Ni[0] : !Ni) ? NaN : vi && vi[0] == 0 || !Ni ? ci * 0 : ci / 0
        );
      for (Ei = new Yr(ci), bi = Ei.c = [], ri = ei.e - oi.e, ci = Nn + ri + 1, qr || (qr = BASE, ri = bitFloor(ei.e / LOG_BASE) - bitFloor(oi.e / LOG_BASE), ci = ci / LOG_BASE | 0), Sn = 0; Ni[Sn] == (vi[Sn] || 0); Sn++)
        ;
      if (Ni[Sn] > (vi[Sn] || 0) && ri--, ci < 0)
        bi.push(1), ai = !0;
      else {
        for (hi = vi.length, Qr = Ni.length, Sn = 0, ci += 2, di = mathfloor(qr / (Ni[0] + 1)), di > 1 && (Ni = Br(Ni, di, qr), vi = Br(vi, di, qr), Qr = Ni.length, hi = vi.length), ui = Qr, Si = vi.slice(0, Qr), Ii = Si.length; Ii < Qr; Si[Ii++] = 0)
          ;
        wn = Ni.slice(), wn = [0].concat(wn), gi = Ni[0], Ni[1] >= qr / 2 && gi++;
        do {
          if (di = 0, Jr = Hr(Ni, Si, Qr, Ii), Jr < 0) {
            if (yi = Si[0], Qr != Ii && (yi = yi * qr + (Si[1] || 0)), di = mathfloor(yi / gi), di > 1)
              for (di >= qr && (di = qr - 1), ii = Br(Ni, di, qr), fi = ii.length, Ii = Si.length; Hr(ii, Si, fi, Ii) == 1; )
                di--, Pn(ii, Qr < fi ? wn : Ni, fi, qr), fi = ii.length, Jr = 1;
            else
              di == 0 && (Jr = di = 1), ii = Ni.slice(), fi = ii.length;
            if (fi < Ii && (ii = [0].concat(ii)), Pn(Si, ii, Ii, qr), Ii = Si.length, Jr == -1)
              for (; Hr(Ni, Si, Qr, Ii) < 1; )
                di++, Pn(Si, Qr < Ii ? wn : Ni, Ii, qr), Ii = Si.length;
          } else
            Jr === 0 && (di++, Si = [0]);
          bi[Sn++] = di, Si[0] ? Si[Ii++] = vi[ui] || 0 : (Si = [vi[ui]], Ii = 1);
        } while ((ui++ < hi || Si[0] != null) && ci--);
        ai = Si[0] != null, bi[0] || bi.splice(0, 1);
      }
      if (qr == BASE) {
        for (Sn = 1, ci = bi[0]; ci >= 10; ci /= 10, Sn++)
          ;
        ni(Ei, Nn + (Ei.e = Sn + ri * LOG_BASE - 1) + 1, En, ai);
      } else
        Ei.e = ri, Ei.r = +ai;
      return Ei;
    };
  }();
  function Zr(Br, Hr, Pn, ei) {
    var oi, Nn, En, qr, Jr;
    if (Pn == null ? Pn = fr : intCheck(Pn, 0, 8), !Br.c)
      return Br.toString();
    if (oi = Br.c[0], En = Br.e, Hr == null)
      Jr = coeffToString(Br.c), Jr = ei == 1 || ei == 2 && (En <= Er || En >= br) ? toExponential(Jr, En) : toFixedPoint(Jr, En, "0");
    else if (Br = ni(new Yr(Br), Hr, Pn), Nn = Br.e, Jr = coeffToString(Br.c), qr = Jr.length, ei == 1 || ei == 2 && (Hr <= Nn || Nn <= Er)) {
      for (; qr < Hr; Jr += "0", qr++)
        ;
      Jr = toExponential(Jr, Nn);
    } else if (Hr -= En, Jr = toFixedPoint(Jr, Nn, "0"), Nn + 1 > qr) {
      if (--Hr > 0)
        for (Jr += "."; Hr--; Jr += "0")
          ;
    } else if (Hr += Nn - qr, Hr > 0)
      for (Nn + 1 == qr && (Jr += "."); Hr--; Jr += "0")
        ;
    return Br.s < 0 && oi ? "-" + Jr : Jr;
  }
  function ti(Br, Hr) {
    for (var Pn, ei = 1, oi = new Yr(Br[0]); ei < Br.length; ei++)
      if (Pn = new Yr(Br[ei]), Pn.s)
        Hr.call(oi, Pn) && (oi = Pn);
      else {
        oi = Pn;
        break;
      }
    return oi;
  }
  function On(Br, Hr, Pn) {
    for (var ei = 1, oi = Hr.length; !Hr[--oi]; Hr.pop())
      ;
    for (oi = Hr[0]; oi >= 10; oi /= 10, ei++)
      ;
    return (Pn = ei + Pn * LOG_BASE - 1) > kr ? Br.c = Br.e = null : Pn < wr ? Br.c = [Br.e = 0] : (Br.e = Pn, Br.c = Hr), Br;
  }
  o = function() {
    var Br = /^(-?)0([xbo])(?=\w[\w.]*$)/i, Hr = /^([^.]+)\.$/, Pn = /^\.([^.]+)$/, ei = /^-?(Infinity|NaN)$/, oi = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(Nn, En, qr, Jr) {
      var ri, Sn = qr ? En : En.replace(oi, "");
      if (ei.test(Sn))
        Nn.s = isNaN(Sn) ? null : Sn < 0 ? -1 : 1;
      else {
        if (!qr && (Sn = Sn.replace(Br, function(ai, di, ii) {
          return ri = (ii = ii.toLowerCase()) == "x" ? 16 : ii == "b" ? 2 : 8, !Jr || Jr == ri ? di : ai;
        }), Jr && (ri = Jr, Sn = Sn.replace(Hr, "$1").replace(Pn, "0.$1")), En != Sn))
          return new Yr(Sn, ri);
        if (Yr.DEBUG)
          throw Error(bignumberError + "Not a" + (Jr ? " base " + Jr : "") + " number: " + En);
        Nn.s = null;
      }
      Nn.c = Nn.e = null;
    };
  }();
  function ni(Br, Hr, Pn, ei) {
    var oi, Nn, En, qr, Jr, ri, Sn, ai = Br.c, di = POWS_TEN;
    if (ai) {
      e: {
        for (oi = 1, qr = ai[0]; qr >= 10; qr /= 10, oi++)
          ;
        if (Nn = Hr - oi, Nn < 0)
          Nn += LOG_BASE, En = Hr, Jr = ai[ri = 0], Sn = Jr / di[oi - En - 1] % 10 | 0;
        else if (ri = mathceil((Nn + 1) / LOG_BASE), ri >= ai.length)
          if (ei) {
            for (; ai.length <= ri; ai.push(0))
              ;
            Jr = Sn = 0, oi = 1, Nn %= LOG_BASE, En = Nn - LOG_BASE + 1;
          } else
            break e;
        else {
          for (Jr = qr = ai[ri], oi = 1; qr >= 10; qr /= 10, oi++)
            ;
          Nn %= LOG_BASE, En = Nn - LOG_BASE + oi, Sn = En < 0 ? 0 : Jr / di[oi - En - 1] % 10 | 0;
        }
        if (ei = ei || Hr < 0 || ai[ri + 1] != null || (En < 0 ? Jr : Jr % di[oi - En - 1]), ei = Pn < 4 ? (Sn || ei) && (Pn == 0 || Pn == (Br.s < 0 ? 3 : 2)) : Sn > 5 || Sn == 5 && (Pn == 4 || ei || Pn == 6 && (Nn > 0 ? En > 0 ? Jr / di[oi - En] : 0 : ai[ri - 1]) % 10 & 1 || Pn == (Br.s < 0 ? 8 : 7)), Hr < 1 || !ai[0])
          return ai.length = 0, ei ? (Hr -= Br.e + 1, ai[0] = di[(LOG_BASE - Hr % LOG_BASE) % LOG_BASE], Br.e = -Hr || 0) : ai[0] = Br.e = 0, Br;
        if (Nn == 0 ? (ai.length = ri, qr = 1, ri--) : (ai.length = ri + 1, qr = di[LOG_BASE - Nn], ai[ri] = En > 0 ? mathfloor(Jr / di[oi - En] % di[En]) * qr : 0), ei)
          for (; ; )
            if (ri == 0) {
              for (Nn = 1, En = ai[0]; En >= 10; En /= 10, Nn++)
                ;
              for (En = ai[0] += qr, qr = 1; En >= 10; En /= 10, qr++)
                ;
              Nn != qr && (Br.e++, ai[0] == BASE && (ai[0] = 1));
              break;
            } else {
              if (ai[ri] += qr, ai[ri] != BASE)
                break;
              ai[ri--] = 0, qr = 1;
            }
        for (Nn = ai.length; ai[--Nn] === 0; ai.pop())
          ;
      }
      Br.e > kr ? Br.c = Br.e = null : Br.e < wr && (Br.c = [Br.e = 0]);
    }
    return Br;
  }
  function In(Br) {
    var Hr, Pn = Br.e;
    return Pn === null ? Br.toString() : (Hr = coeffToString(Br.c), Hr = Pn <= Er || Pn >= br ? toExponential(Hr, Pn) : toFixedPoint(Hr, Pn, "0"), Br.s < 0 ? "-" + Hr : Hr);
  }
  return fe.absoluteValue = fe.abs = function() {
    var Br = new Yr(this);
    return Br.s < 0 && (Br.s = 1), Br;
  }, fe.comparedTo = function(Br, Hr) {
    return compare$p(this, new Yr(Br, Hr));
  }, fe.decimalPlaces = fe.dp = function(Br, Hr) {
    var Pn, ei, oi, Nn = this;
    if (Br != null)
      return intCheck(Br, 0, MAX$1), Hr == null ? Hr = fr : intCheck(Hr, 0, 8), ni(new Yr(Nn), Br + Nn.e + 1, Hr);
    if (!(Pn = Nn.c))
      return null;
    if (ei = ((oi = Pn.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE, oi = Pn[oi])
      for (; oi % 10 == 0; oi /= 10, ei--)
        ;
    return ei < 0 && (ei = 0), ei;
  }, fe.dividedBy = fe.div = function(Br, Hr) {
    return e(this, new Yr(Br, Hr), ye, fr);
  }, fe.dividedToIntegerBy = fe.idiv = function(Br, Hr) {
    return e(this, new Yr(Br, Hr), 0, 1);
  }, fe.exponentiatedBy = fe.pow = function(Br, Hr) {
    var Pn, ei, oi, Nn, En, qr, Jr, ri, Sn, ai = this;
    if (Br = new Yr(Br), Br.c && !Br.isInteger())
      throw Error(bignumberError + "Exponent not an integer: " + In(Br));
    if (Hr != null && (Hr = new Yr(Hr)), qr = Br.e > 14, !ai.c || !ai.c[0] || ai.c[0] == 1 && !ai.e && ai.c.length == 1 || !Br.c || !Br.c[0])
      return Sn = new Yr(Math.pow(+In(ai), qr ? 2 - isOdd(Br) : +In(Br))), Hr ? Sn.mod(Hr) : Sn;
    if (Jr = Br.s < 0, Hr) {
      if (Hr.c ? !Hr.c[0] : !Hr.s)
        return new Yr(NaN);
      ei = !Jr && ai.isInteger() && Hr.isInteger(), ei && (ai = ai.mod(Hr));
    } else {
      if (Br.e > 9 && (ai.e > 0 || ai.e < -1 || (ai.e == 0 ? ai.c[0] > 1 || qr && ai.c[1] >= 24e7 : ai.c[0] < 8e13 || qr && ai.c[0] <= 9999975e7)))
        return Nn = ai.s < 0 && isOdd(Br) ? -0 : 0, ai.e > -1 && (Nn = 1 / Nn), new Yr(Jr ? 1 / Nn : Nn);
      jr && (Nn = mathceil(jr / LOG_BASE + 2));
    }
    for (qr ? (Pn = new Yr(0.5), Jr && (Br.s = 1), ri = isOdd(Br)) : (oi = Math.abs(+In(Br)), ri = oi % 2), Sn = new Yr(me); ; ) {
      if (ri) {
        if (Sn = Sn.times(ai), !Sn.c)
          break;
        Nn ? Sn.c.length > Nn && (Sn.c.length = Nn) : ei && (Sn = Sn.mod(Hr));
      }
      if (oi) {
        if (oi = mathfloor(oi / 2), oi === 0)
          break;
        ri = oi % 2;
      } else if (Br = Br.times(Pn), ni(Br, Br.e + 1, 1), Br.e > 14)
        ri = isOdd(Br);
      else {
        if (oi = +In(Br), oi === 0)
          break;
        ri = oi % 2;
      }
      ai = ai.times(ai), Nn ? ai.c && ai.c.length > Nn && (ai.c.length = Nn) : ei && (ai = ai.mod(Hr));
    }
    return ei ? Sn : (Jr && (Sn = me.div(Sn)), Hr ? Sn.mod(Hr) : Nn ? ni(Sn, jr, fr, En) : Sn);
  }, fe.integerValue = function(Br) {
    var Hr = new Yr(this);
    return Br == null ? Br = fr : intCheck(Br, 0, 8), ni(Hr, Hr.e + 1, Br);
  }, fe.isEqualTo = fe.eq = function(Br, Hr) {
    return compare$p(this, new Yr(Br, Hr)) === 0;
  }, fe.isFinite = function() {
    return !!this.c;
  }, fe.isGreaterThan = fe.gt = function(Br, Hr) {
    return compare$p(this, new Yr(Br, Hr)) > 0;
  }, fe.isGreaterThanOrEqualTo = fe.gte = function(Br, Hr) {
    return (Hr = compare$p(this, new Yr(Br, Hr))) === 1 || Hr === 0;
  }, fe.isInteger = function() {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  }, fe.isLessThan = fe.lt = function(Br, Hr) {
    return compare$p(this, new Yr(Br, Hr)) < 0;
  }, fe.isLessThanOrEqualTo = fe.lte = function(Br, Hr) {
    return (Hr = compare$p(this, new Yr(Br, Hr))) === -1 || Hr === 0;
  }, fe.isNaN = function() {
    return !this.s;
  }, fe.isNegative = function() {
    return this.s < 0;
  }, fe.isPositive = function() {
    return this.s > 0;
  }, fe.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, fe.minus = function(Br, Hr) {
    var Pn, ei, oi, Nn, En = this, qr = En.s;
    if (Br = new Yr(Br, Hr), Hr = Br.s, !qr || !Hr)
      return new Yr(NaN);
    if (qr != Hr)
      return Br.s = -Hr, En.plus(Br);
    var Jr = En.e / LOG_BASE, ri = Br.e / LOG_BASE, Sn = En.c, ai = Br.c;
    if (!Jr || !ri) {
      if (!Sn || !ai)
        return Sn ? (Br.s = -Hr, Br) : new Yr(ai ? En : NaN);
      if (!Sn[0] || !ai[0])
        return ai[0] ? (Br.s = -Hr, Br) : new Yr(Sn[0] ? En : fr == 3 ? -0 : 0);
    }
    if (Jr = bitFloor(Jr), ri = bitFloor(ri), Sn = Sn.slice(), qr = Jr - ri) {
      for ((Nn = qr < 0) ? (qr = -qr, oi = Sn) : (ri = Jr, oi = ai), oi.reverse(), Hr = qr; Hr--; oi.push(0))
        ;
      oi.reverse();
    } else
      for (ei = (Nn = (qr = Sn.length) < (Hr = ai.length)) ? qr : Hr, qr = Hr = 0; Hr < ei; Hr++)
        if (Sn[Hr] != ai[Hr]) {
          Nn = Sn[Hr] < ai[Hr];
          break;
        }
    if (Nn && (oi = Sn, Sn = ai, ai = oi, Br.s = -Br.s), Hr = (ei = ai.length) - (Pn = Sn.length), Hr > 0)
      for (; Hr--; Sn[Pn++] = 0)
        ;
    for (Hr = BASE - 1; ei > qr; ) {
      if (Sn[--ei] < ai[ei]) {
        for (Pn = ei; Pn && !Sn[--Pn]; Sn[Pn] = Hr)
          ;
        --Sn[Pn], Sn[ei] += BASE;
      }
      Sn[ei] -= ai[ei];
    }
    for (; Sn[0] == 0; Sn.splice(0, 1), --ri)
      ;
    return Sn[0] ? On(Br, Sn, ri) : (Br.s = fr == 3 ? -1 : 1, Br.c = [Br.e = 0], Br);
  }, fe.modulo = fe.mod = function(Br, Hr) {
    var Pn, ei, oi = this;
    return Br = new Yr(Br, Hr), !oi.c || !Br.s || Br.c && !Br.c[0] ? new Yr(NaN) : !Br.c || oi.c && !oi.c[0] ? new Yr(oi) : (Vr == 9 ? (ei = Br.s, Br.s = 1, Pn = e(oi, Br, 0, 3), Br.s = ei, Pn.s *= ei) : Pn = e(oi, Br, 0, Vr), Br = oi.minus(Pn.times(Br)), !Br.c[0] && Vr == 1 && (Br.s = oi.s), Br);
  }, fe.multipliedBy = fe.times = function(Br, Hr) {
    var Pn, ei, oi, Nn, En, qr, Jr, ri, Sn, ai, di, ii, fi, Ei, bi, Si = this, Ii = Si.c, yi = (Br = new Yr(Br, Hr)).c;
    if (!Ii || !yi || !Ii[0] || !yi[0])
      return !Si.s || !Br.s || Ii && !Ii[0] && !yi || yi && !yi[0] && !Ii ? Br.c = Br.e = Br.s = null : (Br.s *= Si.s, !Ii || !yi ? Br.c = Br.e = null : (Br.c = [0], Br.e = 0)), Br;
    for (ei = bitFloor(Si.e / LOG_BASE) + bitFloor(Br.e / LOG_BASE), Br.s *= Si.s, Jr = Ii.length, ai = yi.length, Jr < ai && (fi = Ii, Ii = yi, yi = fi, oi = Jr, Jr = ai, ai = oi), oi = Jr + ai, fi = []; oi--; fi.push(0))
      ;
    for (Ei = BASE, bi = SQRT_BASE, oi = ai; --oi >= 0; ) {
      for (Pn = 0, di = yi[oi] % bi, ii = yi[oi] / bi | 0, En = Jr, Nn = oi + En; Nn > oi; )
        ri = Ii[--En] % bi, Sn = Ii[En] / bi | 0, qr = ii * ri + Sn * di, ri = di * ri + qr % bi * bi + fi[Nn] + Pn, Pn = (ri / Ei | 0) + (qr / bi | 0) + ii * Sn, fi[Nn--] = ri % Ei;
      fi[Nn] = Pn;
    }
    return Pn ? ++ei : fi.splice(0, 1), On(Br, fi, ei);
  }, fe.negated = function() {
    var Br = new Yr(this);
    return Br.s = -Br.s || null, Br;
  }, fe.plus = function(Br, Hr) {
    var Pn, ei = this, oi = ei.s;
    if (Br = new Yr(Br, Hr), Hr = Br.s, !oi || !Hr)
      return new Yr(NaN);
    if (oi != Hr)
      return Br.s = -Hr, ei.minus(Br);
    var Nn = ei.e / LOG_BASE, En = Br.e / LOG_BASE, qr = ei.c, Jr = Br.c;
    if (!Nn || !En) {
      if (!qr || !Jr)
        return new Yr(oi / 0);
      if (!qr[0] || !Jr[0])
        return Jr[0] ? Br : new Yr(qr[0] ? ei : oi * 0);
    }
    if (Nn = bitFloor(Nn), En = bitFloor(En), qr = qr.slice(), oi = Nn - En) {
      for (oi > 0 ? (En = Nn, Pn = Jr) : (oi = -oi, Pn = qr), Pn.reverse(); oi--; Pn.push(0))
        ;
      Pn.reverse();
    }
    for (oi = qr.length, Hr = Jr.length, oi - Hr < 0 && (Pn = Jr, Jr = qr, qr = Pn, Hr = oi), oi = 0; Hr; )
      oi = (qr[--Hr] = qr[Hr] + Jr[Hr] + oi) / BASE | 0, qr[Hr] = BASE === qr[Hr] ? 0 : qr[Hr] % BASE;
    return oi && (qr = [oi].concat(qr), ++En), On(Br, qr, En);
  }, fe.precision = fe.sd = function(Br, Hr) {
    var Pn, ei, oi, Nn = this;
    if (Br != null && Br !== !!Br)
      return intCheck(Br, 1, MAX$1), Hr == null ? Hr = fr : intCheck(Hr, 0, 8), ni(new Yr(Nn), Br, Hr);
    if (!(Pn = Nn.c))
      return null;
    if (oi = Pn.length - 1, ei = oi * LOG_BASE + 1, oi = Pn[oi]) {
      for (; oi % 10 == 0; oi /= 10, ei--)
        ;
      for (oi = Pn[0]; oi >= 10; oi /= 10, ei++)
        ;
    }
    return Br && Nn.e + 1 > ei && (ei = Nn.e + 1), ei;
  }, fe.shiftedBy = function(Br) {
    return intCheck(Br, -MAX_SAFE_INTEGER$4, MAX_SAFE_INTEGER$4), this.times("1e" + Br);
  }, fe.squareRoot = fe.sqrt = function() {
    var Br, Hr, Pn, ei, oi, Nn = this, En = Nn.c, qr = Nn.s, Jr = Nn.e, ri = ye + 4, Sn = new Yr("0.5");
    if (qr !== 1 || !En || !En[0])
      return new Yr(!qr || qr < 0 && (!En || En[0]) ? NaN : En ? Nn : 1 / 0);
    if (qr = Math.sqrt(+In(Nn)), qr == 0 || qr == 1 / 0 ? (Hr = coeffToString(En), (Hr.length + Jr) % 2 == 0 && (Hr += "0"), qr = Math.sqrt(+Hr), Jr = bitFloor((Jr + 1) / 2) - (Jr < 0 || Jr % 2), qr == 1 / 0 ? Hr = "5e" + Jr : (Hr = qr.toExponential(), Hr = Hr.slice(0, Hr.indexOf("e") + 1) + Jr), Pn = new Yr(Hr)) : Pn = new Yr(qr + ""), Pn.c[0]) {
      for (Jr = Pn.e, qr = Jr + ri, qr < 3 && (qr = 0); ; )
        if (oi = Pn, Pn = Sn.times(oi.plus(e(Nn, oi, ri, 1))), coeffToString(oi.c).slice(0, qr) === (Hr = coeffToString(Pn.c)).slice(0, qr))
          if (Pn.e < Jr && --qr, Hr = Hr.slice(qr - 3, qr + 1), Hr == "9999" || !ei && Hr == "4999") {
            if (!ei && (ni(oi, oi.e + ye + 2, 0), oi.times(oi).eq(Nn))) {
              Pn = oi;
              break;
            }
            ri += 4, qr += 4, ei = 1;
          } else {
            (!+Hr || !+Hr.slice(1) && Hr.charAt(0) == "5") && (ni(Pn, Pn.e + ye + 2, 1), Br = !Pn.times(Pn).eq(Nn));
            break;
          }
    }
    return ni(Pn, Pn.e + ye + 1, fr, Br);
  }, fe.toExponential = function(Br, Hr) {
    return Br != null && (intCheck(Br, 0, MAX$1), Br++), Zr(this, Br, Hr, 1);
  }, fe.toFixed = function(Br, Hr) {
    return Br != null && (intCheck(Br, 0, MAX$1), Br = Br + this.e + 1), Zr(this, Br, Hr);
  }, fe.toFormat = function(Br, Hr, Pn) {
    var ei, oi = this;
    if (Pn == null)
      Br != null && Hr && typeof Hr == "object" ? (Pn = Hr, Hr = null) : Br && typeof Br == "object" ? (Pn = Br, Br = Hr = null) : Pn = Kr;
    else if (typeof Pn != "object")
      throw Error(bignumberError + "Argument not an object: " + Pn);
    if (ei = oi.toFixed(Br, Hr), oi.c) {
      var Nn, En = ei.split("."), qr = +Pn.groupSize, Jr = +Pn.secondaryGroupSize, ri = Pn.groupSeparator || "", Sn = En[0], ai = En[1], di = oi.s < 0, ii = di ? Sn.slice(1) : Sn, fi = ii.length;
      if (Jr && (Nn = qr, qr = Jr, Jr = Nn, fi -= Nn), qr > 0 && fi > 0) {
        for (Nn = fi % qr || qr, Sn = ii.substr(0, Nn); Nn < fi; Nn += qr)
          Sn += ri + ii.substr(Nn, qr);
        Jr > 0 && (Sn += ri + ii.slice(Nn)), di && (Sn = "-" + Sn);
      }
      ei = ai ? Sn + (Pn.decimalSeparator || "") + ((Jr = +Pn.fractionGroupSize) ? ai.replace(
        new RegExp("\\d{" + Jr + "}\\B", "g"),
        "$&" + (Pn.fractionGroupSeparator || "")
      ) : ai) : Sn;
    }
    return (Pn.prefix || "") + ei + (Pn.suffix || "");
  }, fe.toFraction = function(Br) {
    var Hr, Pn, ei, oi, Nn, En, qr, Jr, ri, Sn, ai, di, ii = this, fi = ii.c;
    if (Br != null && (qr = new Yr(Br), !qr.isInteger() && (qr.c || qr.s !== 1) || qr.lt(me)))
      throw Error(bignumberError + "Argument " + (qr.isInteger() ? "out of range: " : "not an integer: ") + In(qr));
    if (!fi)
      return new Yr(ii);
    for (Hr = new Yr(me), ri = Pn = new Yr(me), ei = Jr = new Yr(me), di = coeffToString(fi), Nn = Hr.e = di.length - ii.e - 1, Hr.c[0] = POWS_TEN[(En = Nn % LOG_BASE) < 0 ? LOG_BASE + En : En], Br = !Br || qr.comparedTo(Hr) > 0 ? Nn > 0 ? Hr : ri : qr, En = kr, kr = 1 / 0, qr = new Yr(di), Jr.c[0] = 0; Sn = e(qr, Hr, 0, 1), oi = Pn.plus(Sn.times(ei)), oi.comparedTo(Br) != 1; )
      Pn = ei, ei = oi, ri = Jr.plus(Sn.times(oi = ri)), Jr = oi, Hr = qr.minus(Sn.times(oi = Hr)), qr = oi;
    return oi = e(Br.minus(Pn), ei, 0, 1), Jr = Jr.plus(oi.times(ri)), Pn = Pn.plus(oi.times(ei)), Jr.s = ri.s = ii.s, Nn = Nn * 2, ai = e(ri, ei, Nn, fr).minus(ii).abs().comparedTo(
      e(Jr, Pn, Nn, fr).minus(ii).abs()
    ) < 1 ? [ri, ei] : [Jr, Pn], kr = En, ai;
  }, fe.toNumber = function() {
    return +In(this);
  }, fe.toPrecision = function(Br, Hr) {
    return Br != null && intCheck(Br, 1, MAX$1), Zr(this, Br, Hr, 2);
  }, fe.toString = function(Br) {
    var Hr, Pn = this, ei = Pn.s, oi = Pn.e;
    return oi === null ? ei ? (Hr = "Infinity", ei < 0 && (Hr = "-" + Hr)) : Hr = "NaN" : (Br == null ? Hr = oi <= Er || oi >= br ? toExponential(coeffToString(Pn.c), oi) : toFixedPoint(coeffToString(Pn.c), oi, "0") : Br === 10 ? (Pn = ni(new Yr(Pn), ye + oi + 1, fr), Hr = toFixedPoint(coeffToString(Pn.c), Pn.e, "0")) : (intCheck(Br, 2, bn.length, "Base"), Hr = s(toFixedPoint(coeffToString(Pn.c), oi, "0"), 10, Br, ei, !0)), ei < 0 && Pn.c[0] && (Hr = "-" + Hr)), Hr;
  }, fe.valueOf = fe.toJSON = function() {
    return In(this);
  }, fe._isBigNumber = !0, fe[Symbol.toStringTag] = "BigNumber", fe[Symbol.for("nodejs.util.inspect.custom")] = fe.valueOf, r != null && Yr.set(r), Yr;
}
function bitFloor(r) {
  var e = r | 0;
  return r > 0 || r === e ? e : e - 1;
}
function coeffToString(r) {
  for (var e, s, o = 1, fe = r.length, me = r[0] + ""; o < fe; ) {
    for (e = r[o++] + "", s = LOG_BASE - e.length; s--; e = "0" + e)
      ;
    me += e;
  }
  for (fe = me.length; me.charCodeAt(--fe) === 48; )
    ;
  return me.slice(0, fe + 1 || 1);
}
function compare$p(r, e) {
  var s, o, fe = r.c, me = e.c, ye = r.s, fr = e.s, Er = r.e, br = e.e;
  if (!ye || !fr)
    return null;
  if (s = fe && !fe[0], o = me && !me[0], s || o)
    return s ? o ? 0 : -fr : ye;
  if (ye != fr)
    return ye;
  if (s = ye < 0, o = Er == br, !fe || !me)
    return o ? 0 : !fe ^ s ? 1 : -1;
  if (!o)
    return Er > br ^ s ? 1 : -1;
  for (fr = (Er = fe.length) < (br = me.length) ? Er : br, ye = 0; ye < fr; ye++)
    if (fe[ye] != me[ye])
      return fe[ye] > me[ye] ^ s ? 1 : -1;
  return Er == br ? 0 : Er > br ^ s ? 1 : -1;
}
function intCheck(r, e, s, o) {
  if (r < e || r > s || r !== mathfloor(r))
    throw Error(bignumberError + (o || "Argument") + (typeof r == "number" ? r < e || r > s ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(r));
}
function isOdd(r) {
  var e = r.c.length - 1;
  return bitFloor(r.e / LOG_BASE) == e && r.c[e] % 2 != 0;
}
function toExponential(r, e) {
  return (r.length > 1 ? r.charAt(0) + "." + r.slice(1) : r) + (e < 0 ? "e" : "e+") + e;
}
function toFixedPoint(r, e, s) {
  var o, fe;
  if (e < 0) {
    for (fe = s + "."; ++e; fe += s)
      ;
    r = fe + r;
  } else if (o = r.length, ++e > o) {
    for (fe = s, e -= o; --e; fe += s)
      ;
    r += fe;
  } else
    e < o && (r = r.slice(0, e) + "." + r.slice(e));
  return r;
}
var BigNumber$1 = clone();
const bignumber = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BigNumber: BigNumber$1,
  default: BigNumber$1
}, Symbol.toStringTag, { value: "Module" }));
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {};
function getAugmentedNamespace(r) {
  var e = r.default;
  if (typeof e == "function") {
    var s = function() {
      return e.apply(this, arguments);
    };
    s.prototype = e.prototype;
  } else
    s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(r).forEach(function(o) {
    var fe = Object.getOwnPropertyDescriptor(r, o);
    Object.defineProperty(s, o, fe.get ? fe : {
      enumerable: !0,
      get: function() {
        return r[o];
      }
    });
  }), s;
}
var out$4 = {}, buffer = {}, base64Js = {}, hasRequiredBase64Js;
function requireBase64Js() {
  if (hasRequiredBase64Js)
    return base64Js;
  hasRequiredBase64Js = 1, base64Js.byteLength = fr, base64Js.toByteArray = br, base64Js.fromByteArray = Gr;
  for (var r = [], e = [], s = typeof Uint8Array < "u" ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", fe = 0, me = o.length; fe < me; ++fe)
    r[fe] = o[fe], e[o.charCodeAt(fe)] = fe;
  e["-".charCodeAt(0)] = 62, e["_".charCodeAt(0)] = 63;
  function ye(Vr) {
    var jr = Vr.length;
    if (jr % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var Kr = Vr.indexOf("=");
    Kr === -1 && (Kr = jr);
    var bn = Kr === jr ? 0 : 4 - Kr % 4;
    return [Kr, bn];
  }
  function fr(Vr) {
    var jr = ye(Vr), Kr = jr[0], bn = jr[1];
    return (Kr + bn) * 3 / 4 - bn;
  }
  function Er(Vr, jr, Kr) {
    return (jr + Kr) * 3 / 4 - Kr;
  }
  function br(Vr) {
    var jr, Kr = ye(Vr), bn = Kr[0], Yr = Kr[1], Zr = new s(Er(Vr, bn, Yr)), ti = 0, On = Yr > 0 ? bn - 4 : bn, ni;
    for (ni = 0; ni < On; ni += 4)
      jr = e[Vr.charCodeAt(ni)] << 18 | e[Vr.charCodeAt(ni + 1)] << 12 | e[Vr.charCodeAt(ni + 2)] << 6 | e[Vr.charCodeAt(ni + 3)], Zr[ti++] = jr >> 16 & 255, Zr[ti++] = jr >> 8 & 255, Zr[ti++] = jr & 255;
    return Yr === 2 && (jr = e[Vr.charCodeAt(ni)] << 2 | e[Vr.charCodeAt(ni + 1)] >> 4, Zr[ti++] = jr & 255), Yr === 1 && (jr = e[Vr.charCodeAt(ni)] << 10 | e[Vr.charCodeAt(ni + 1)] << 4 | e[Vr.charCodeAt(ni + 2)] >> 2, Zr[ti++] = jr >> 8 & 255, Zr[ti++] = jr & 255), Zr;
  }
  function wr(Vr) {
    return r[Vr >> 18 & 63] + r[Vr >> 12 & 63] + r[Vr >> 6 & 63] + r[Vr & 63];
  }
  function kr(Vr, jr, Kr) {
    for (var bn, Yr = [], Zr = jr; Zr < Kr; Zr += 3)
      bn = (Vr[Zr] << 16 & 16711680) + (Vr[Zr + 1] << 8 & 65280) + (Vr[Zr + 2] & 255), Yr.push(wr(bn));
    return Yr.join("");
  }
  function Gr(Vr) {
    for (var jr, Kr = Vr.length, bn = Kr % 3, Yr = [], Zr = 16383, ti = 0, On = Kr - bn; ti < On; ti += Zr)
      Yr.push(kr(Vr, ti, ti + Zr > On ? On : ti + Zr));
    return bn === 1 ? (jr = Vr[Kr - 1], Yr.push(
      r[jr >> 2] + r[jr << 4 & 63] + "=="
    )) : bn === 2 && (jr = (Vr[Kr - 2] << 8) + Vr[Kr - 1], Yr.push(
      r[jr >> 10] + r[jr >> 4 & 63] + r[jr << 2 & 63] + "="
    )), Yr.join("");
  }
  return base64Js;
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hasRequiredIeee754;
function requireIeee754() {
  return hasRequiredIeee754 || (hasRequiredIeee754 = 1, ieee754.read = function(r, e, s, o, fe) {
    var me, ye, fr = fe * 8 - o - 1, Er = (1 << fr) - 1, br = Er >> 1, wr = -7, kr = s ? fe - 1 : 0, Gr = s ? -1 : 1, Vr = r[e + kr];
    for (kr += Gr, me = Vr & (1 << -wr) - 1, Vr >>= -wr, wr += fr; wr > 0; me = me * 256 + r[e + kr], kr += Gr, wr -= 8)
      ;
    for (ye = me & (1 << -wr) - 1, me >>= -wr, wr += o; wr > 0; ye = ye * 256 + r[e + kr], kr += Gr, wr -= 8)
      ;
    if (me === 0)
      me = 1 - br;
    else {
      if (me === Er)
        return ye ? NaN : (Vr ? -1 : 1) * (1 / 0);
      ye = ye + Math.pow(2, o), me = me - br;
    }
    return (Vr ? -1 : 1) * ye * Math.pow(2, me - o);
  }, ieee754.write = function(r, e, s, o, fe, me) {
    var ye, fr, Er, br = me * 8 - fe - 1, wr = (1 << br) - 1, kr = wr >> 1, Gr = fe === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Vr = o ? 0 : me - 1, jr = o ? 1 : -1, Kr = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (fr = isNaN(e) ? 1 : 0, ye = wr) : (ye = Math.floor(Math.log(e) / Math.LN2), e * (Er = Math.pow(2, -ye)) < 1 && (ye--, Er *= 2), ye + kr >= 1 ? e += Gr / Er : e += Gr * Math.pow(2, 1 - kr), e * Er >= 2 && (ye++, Er /= 2), ye + kr >= wr ? (fr = 0, ye = wr) : ye + kr >= 1 ? (fr = (e * Er - 1) * Math.pow(2, fe), ye = ye + kr) : (fr = e * Math.pow(2, kr - 1) * Math.pow(2, fe), ye = 0)); fe >= 8; r[s + Vr] = fr & 255, Vr += jr, fr /= 256, fe -= 8)
      ;
    for (ye = ye << fe | fr, br += fe; br > 0; r[s + Vr] = ye & 255, Vr += jr, ye /= 256, br -= 8)
      ;
    r[s + Vr - jr] |= Kr * 128;
  }), ieee754;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var hasRequiredBuffer;
function requireBuffer() {
  return hasRequiredBuffer || (hasRequiredBuffer = 1, function(r) {
    const e = requireBase64Js(), s = requireIeee754(), o = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    r.Buffer = fr, r.SlowBuffer = Zr, r.INSPECT_MAX_BYTES = 50;
    const fe = 2147483647;
    r.kMaxLength = fe, fr.TYPED_ARRAY_SUPPORT = me(), !fr.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function me() {
      try {
        const si = new Uint8Array(1), Wr = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(Wr, Uint8Array.prototype), Object.setPrototypeOf(si, Wr), si.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(fr.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (!!fr.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(fr.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (!!fr.isBuffer(this))
          return this.byteOffset;
      }
    });
    function ye(si) {
      if (si > fe)
        throw new RangeError('The value "' + si + '" is invalid for option "size"');
      const Wr = new Uint8Array(si);
      return Object.setPrototypeOf(Wr, fr.prototype), Wr;
    }
    function fr(si, Wr, Xr) {
      if (typeof si == "number") {
        if (typeof Wr == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return kr(si);
      }
      return Er(si, Wr, Xr);
    }
    fr.poolSize = 8192;
    function Er(si, Wr, Xr) {
      if (typeof si == "string")
        return Gr(si, Wr);
      if (ArrayBuffer.isView(si))
        return jr(si);
      if (si == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof si
        );
      if (Vi(si, ArrayBuffer) || si && Vi(si.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Vi(si, SharedArrayBuffer) || si && Vi(si.buffer, SharedArrayBuffer)))
        return Kr(si, Wr, Xr);
      if (typeof si == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const li = si.valueOf && si.valueOf();
      if (li != null && li !== si)
        return fr.from(li, Wr, Xr);
      const _i = bn(si);
      if (_i)
        return _i;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof si[Symbol.toPrimitive] == "function")
        return fr.from(si[Symbol.toPrimitive]("string"), Wr, Xr);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof si
      );
    }
    fr.from = function(si, Wr, Xr) {
      return Er(si, Wr, Xr);
    }, Object.setPrototypeOf(fr.prototype, Uint8Array.prototype), Object.setPrototypeOf(fr, Uint8Array);
    function br(si) {
      if (typeof si != "number")
        throw new TypeError('"size" argument must be of type number');
      if (si < 0)
        throw new RangeError('The value "' + si + '" is invalid for option "size"');
    }
    function wr(si, Wr, Xr) {
      return br(si), si <= 0 ? ye(si) : Wr !== void 0 ? typeof Xr == "string" ? ye(si).fill(Wr, Xr) : ye(si).fill(Wr) : ye(si);
    }
    fr.alloc = function(si, Wr, Xr) {
      return wr(si, Wr, Xr);
    };
    function kr(si) {
      return br(si), ye(si < 0 ? 0 : Yr(si) | 0);
    }
    fr.allocUnsafe = function(si) {
      return kr(si);
    }, fr.allocUnsafeSlow = function(si) {
      return kr(si);
    };
    function Gr(si, Wr) {
      if ((typeof Wr != "string" || Wr === "") && (Wr = "utf8"), !fr.isEncoding(Wr))
        throw new TypeError("Unknown encoding: " + Wr);
      const Xr = ti(si, Wr) | 0;
      let li = ye(Xr);
      const _i = li.write(si, Wr);
      return _i !== Xr && (li = li.slice(0, _i)), li;
    }
    function Vr(si) {
      const Wr = si.length < 0 ? 0 : Yr(si.length) | 0, Xr = ye(Wr);
      for (let li = 0; li < Wr; li += 1)
        Xr[li] = si[li] & 255;
      return Xr;
    }
    function jr(si) {
      if (Vi(si, Uint8Array)) {
        const Wr = new Uint8Array(si);
        return Kr(Wr.buffer, Wr.byteOffset, Wr.byteLength);
      }
      return Vr(si);
    }
    function Kr(si, Wr, Xr) {
      if (Wr < 0 || si.byteLength < Wr)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (si.byteLength < Wr + (Xr || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let li;
      return Wr === void 0 && Xr === void 0 ? li = new Uint8Array(si) : Xr === void 0 ? li = new Uint8Array(si, Wr) : li = new Uint8Array(si, Wr, Xr), Object.setPrototypeOf(li, fr.prototype), li;
    }
    function bn(si) {
      if (fr.isBuffer(si)) {
        const Wr = Yr(si.length) | 0, Xr = ye(Wr);
        return Xr.length === 0 || si.copy(Xr, 0, 0, Wr), Xr;
      }
      if (si.length !== void 0)
        return typeof si.length != "number" || Yi(si.length) ? ye(0) : Vr(si);
      if (si.type === "Buffer" && Array.isArray(si.data))
        return Vr(si.data);
    }
    function Yr(si) {
      if (si >= fe)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + fe.toString(16) + " bytes");
      return si | 0;
    }
    function Zr(si) {
      return +si != si && (si = 0), fr.alloc(+si);
    }
    fr.isBuffer = function(Wr) {
      return Wr != null && Wr._isBuffer === !0 && Wr !== fr.prototype;
    }, fr.compare = function(Wr, Xr) {
      if (Vi(Wr, Uint8Array) && (Wr = fr.from(Wr, Wr.offset, Wr.byteLength)), Vi(Xr, Uint8Array) && (Xr = fr.from(Xr, Xr.offset, Xr.byteLength)), !fr.isBuffer(Wr) || !fr.isBuffer(Xr))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (Wr === Xr)
        return 0;
      let li = Wr.length, _i = Xr.length;
      for (let $i = 0, Ai = Math.min(li, _i); $i < Ai; ++$i)
        if (Wr[$i] !== Xr[$i]) {
          li = Wr[$i], _i = Xr[$i];
          break;
        }
      return li < _i ? -1 : _i < li ? 1 : 0;
    }, fr.isEncoding = function(Wr) {
      switch (String(Wr).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, fr.concat = function(Wr, Xr) {
      if (!Array.isArray(Wr))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (Wr.length === 0)
        return fr.alloc(0);
      let li;
      if (Xr === void 0)
        for (Xr = 0, li = 0; li < Wr.length; ++li)
          Xr += Wr[li].length;
      const _i = fr.allocUnsafe(Xr);
      let $i = 0;
      for (li = 0; li < Wr.length; ++li) {
        let Ai = Wr[li];
        if (Vi(Ai, Uint8Array))
          $i + Ai.length > _i.length ? (fr.isBuffer(Ai) || (Ai = fr.from(Ai)), Ai.copy(_i, $i)) : Uint8Array.prototype.set.call(
            _i,
            Ai,
            $i
          );
        else if (fr.isBuffer(Ai))
          Ai.copy(_i, $i);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        $i += Ai.length;
      }
      return _i;
    };
    function ti(si, Wr) {
      if (fr.isBuffer(si))
        return si.length;
      if (ArrayBuffer.isView(si) || Vi(si, ArrayBuffer))
        return si.byteLength;
      if (typeof si != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof si
        );
      const Xr = si.length, li = arguments.length > 2 && arguments[2] === !0;
      if (!li && Xr === 0)
        return 0;
      let _i = !1;
      for (; ; )
        switch (Wr) {
          case "ascii":
          case "latin1":
          case "binary":
            return Xr;
          case "utf8":
          case "utf-8":
            return Li(si).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Xr * 2;
          case "hex":
            return Xr >>> 1;
          case "base64":
            return zi(si).length;
          default:
            if (_i)
              return li ? -1 : Li(si).length;
            Wr = ("" + Wr).toLowerCase(), _i = !0;
        }
    }
    fr.byteLength = ti;
    function On(si, Wr, Xr) {
      let li = !1;
      if ((Wr === void 0 || Wr < 0) && (Wr = 0), Wr > this.length || ((Xr === void 0 || Xr > this.length) && (Xr = this.length), Xr <= 0) || (Xr >>>= 0, Wr >>>= 0, Xr <= Wr))
        return "";
      for (si || (si = "utf8"); ; )
        switch (si) {
          case "hex":
            return di(this, Wr, Xr);
          case "utf8":
          case "utf-8":
            return qr(this, Wr, Xr);
          case "ascii":
            return Sn(this, Wr, Xr);
          case "latin1":
          case "binary":
            return ai(this, Wr, Xr);
          case "base64":
            return En(this, Wr, Xr);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ii(this, Wr, Xr);
          default:
            if (li)
              throw new TypeError("Unknown encoding: " + si);
            si = (si + "").toLowerCase(), li = !0;
        }
    }
    fr.prototype._isBuffer = !0;
    function ni(si, Wr, Xr) {
      const li = si[Wr];
      si[Wr] = si[Xr], si[Xr] = li;
    }
    fr.prototype.swap16 = function() {
      const Wr = this.length;
      if (Wr % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let Xr = 0; Xr < Wr; Xr += 2)
        ni(this, Xr, Xr + 1);
      return this;
    }, fr.prototype.swap32 = function() {
      const Wr = this.length;
      if (Wr % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let Xr = 0; Xr < Wr; Xr += 4)
        ni(this, Xr, Xr + 3), ni(this, Xr + 1, Xr + 2);
      return this;
    }, fr.prototype.swap64 = function() {
      const Wr = this.length;
      if (Wr % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let Xr = 0; Xr < Wr; Xr += 8)
        ni(this, Xr, Xr + 7), ni(this, Xr + 1, Xr + 6), ni(this, Xr + 2, Xr + 5), ni(this, Xr + 3, Xr + 4);
      return this;
    }, fr.prototype.toString = function() {
      const Wr = this.length;
      return Wr === 0 ? "" : arguments.length === 0 ? qr(this, 0, Wr) : On.apply(this, arguments);
    }, fr.prototype.toLocaleString = fr.prototype.toString, fr.prototype.equals = function(Wr) {
      if (!fr.isBuffer(Wr))
        throw new TypeError("Argument must be a Buffer");
      return this === Wr ? !0 : fr.compare(this, Wr) === 0;
    }, fr.prototype.inspect = function() {
      let Wr = "";
      const Xr = r.INSPECT_MAX_BYTES;
      return Wr = this.toString("hex", 0, Xr).replace(/(.{2})/g, "$1 ").trim(), this.length > Xr && (Wr += " ... "), "<Buffer " + Wr + ">";
    }, o && (fr.prototype[o] = fr.prototype.inspect), fr.prototype.compare = function(Wr, Xr, li, _i, $i) {
      if (Vi(Wr, Uint8Array) && (Wr = fr.from(Wr, Wr.offset, Wr.byteLength)), !fr.isBuffer(Wr))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Wr
        );
      if (Xr === void 0 && (Xr = 0), li === void 0 && (li = Wr ? Wr.length : 0), _i === void 0 && (_i = 0), $i === void 0 && ($i = this.length), Xr < 0 || li > Wr.length || _i < 0 || $i > this.length)
        throw new RangeError("out of range index");
      if (_i >= $i && Xr >= li)
        return 0;
      if (_i >= $i)
        return -1;
      if (Xr >= li)
        return 1;
      if (Xr >>>= 0, li >>>= 0, _i >>>= 0, $i >>>= 0, this === Wr)
        return 0;
      let Ai = $i - _i, Di = li - Xr;
      const Mi = Math.min(Ai, Di), to = this.slice(_i, $i), so = Wr.slice(Xr, li);
      for (let no = 0; no < Mi; ++no)
        if (to[no] !== so[no]) {
          Ai = to[no], Di = so[no];
          break;
        }
      return Ai < Di ? -1 : Di < Ai ? 1 : 0;
    };
    function In(si, Wr, Xr, li, _i) {
      if (si.length === 0)
        return -1;
      if (typeof Xr == "string" ? (li = Xr, Xr = 0) : Xr > 2147483647 ? Xr = 2147483647 : Xr < -2147483648 && (Xr = -2147483648), Xr = +Xr, Yi(Xr) && (Xr = _i ? 0 : si.length - 1), Xr < 0 && (Xr = si.length + Xr), Xr >= si.length) {
        if (_i)
          return -1;
        Xr = si.length - 1;
      } else if (Xr < 0)
        if (_i)
          Xr = 0;
        else
          return -1;
      if (typeof Wr == "string" && (Wr = fr.from(Wr, li)), fr.isBuffer(Wr))
        return Wr.length === 0 ? -1 : Br(si, Wr, Xr, li, _i);
      if (typeof Wr == "number")
        return Wr = Wr & 255, typeof Uint8Array.prototype.indexOf == "function" ? _i ? Uint8Array.prototype.indexOf.call(si, Wr, Xr) : Uint8Array.prototype.lastIndexOf.call(si, Wr, Xr) : Br(si, [Wr], Xr, li, _i);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Br(si, Wr, Xr, li, _i) {
      let $i = 1, Ai = si.length, Di = Wr.length;
      if (li !== void 0 && (li = String(li).toLowerCase(), li === "ucs2" || li === "ucs-2" || li === "utf16le" || li === "utf-16le")) {
        if (si.length < 2 || Wr.length < 2)
          return -1;
        $i = 2, Ai /= 2, Di /= 2, Xr /= 2;
      }
      function Mi(so, no) {
        return $i === 1 ? so[no] : so.readUInt16BE(no * $i);
      }
      let to;
      if (_i) {
        let so = -1;
        for (to = Xr; to < Ai; to++)
          if (Mi(si, to) === Mi(Wr, so === -1 ? 0 : to - so)) {
            if (so === -1 && (so = to), to - so + 1 === Di)
              return so * $i;
          } else
            so !== -1 && (to -= to - so), so = -1;
      } else
        for (Xr + Di > Ai && (Xr = Ai - Di), to = Xr; to >= 0; to--) {
          let so = !0;
          for (let no = 0; no < Di; no++)
            if (Mi(si, to + no) !== Mi(Wr, no)) {
              so = !1;
              break;
            }
          if (so)
            return to;
        }
      return -1;
    }
    fr.prototype.includes = function(Wr, Xr, li) {
      return this.indexOf(Wr, Xr, li) !== -1;
    }, fr.prototype.indexOf = function(Wr, Xr, li) {
      return In(this, Wr, Xr, li, !0);
    }, fr.prototype.lastIndexOf = function(Wr, Xr, li) {
      return In(this, Wr, Xr, li, !1);
    };
    function Hr(si, Wr, Xr, li) {
      Xr = Number(Xr) || 0;
      const _i = si.length - Xr;
      li ? (li = Number(li), li > _i && (li = _i)) : li = _i;
      const $i = Wr.length;
      li > $i / 2 && (li = $i / 2);
      let Ai;
      for (Ai = 0; Ai < li; ++Ai) {
        const Di = parseInt(Wr.substr(Ai * 2, 2), 16);
        if (Yi(Di))
          return Ai;
        si[Xr + Ai] = Di;
      }
      return Ai;
    }
    function Pn(si, Wr, Xr, li) {
      return Ki(Li(Wr, si.length - Xr), si, Xr, li);
    }
    function ei(si, Wr, Xr, li) {
      return Ki(oo(Wr), si, Xr, li);
    }
    function oi(si, Wr, Xr, li) {
      return Ki(zi(Wr), si, Xr, li);
    }
    function Nn(si, Wr, Xr, li) {
      return Ki(ao(Wr, si.length - Xr), si, Xr, li);
    }
    fr.prototype.write = function(Wr, Xr, li, _i) {
      if (Xr === void 0)
        _i = "utf8", li = this.length, Xr = 0;
      else if (li === void 0 && typeof Xr == "string")
        _i = Xr, li = this.length, Xr = 0;
      else if (isFinite(Xr))
        Xr = Xr >>> 0, isFinite(li) ? (li = li >>> 0, _i === void 0 && (_i = "utf8")) : (_i = li, li = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const $i = this.length - Xr;
      if ((li === void 0 || li > $i) && (li = $i), Wr.length > 0 && (li < 0 || Xr < 0) || Xr > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      _i || (_i = "utf8");
      let Ai = !1;
      for (; ; )
        switch (_i) {
          case "hex":
            return Hr(this, Wr, Xr, li);
          case "utf8":
          case "utf-8":
            return Pn(this, Wr, Xr, li);
          case "ascii":
          case "latin1":
          case "binary":
            return ei(this, Wr, Xr, li);
          case "base64":
            return oi(this, Wr, Xr, li);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Nn(this, Wr, Xr, li);
          default:
            if (Ai)
              throw new TypeError("Unknown encoding: " + _i);
            _i = ("" + _i).toLowerCase(), Ai = !0;
        }
    }, fr.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function En(si, Wr, Xr) {
      return Wr === 0 && Xr === si.length ? e.fromByteArray(si) : e.fromByteArray(si.slice(Wr, Xr));
    }
    function qr(si, Wr, Xr) {
      Xr = Math.min(si.length, Xr);
      const li = [];
      let _i = Wr;
      for (; _i < Xr; ) {
        const $i = si[_i];
        let Ai = null, Di = $i > 239 ? 4 : $i > 223 ? 3 : $i > 191 ? 2 : 1;
        if (_i + Di <= Xr) {
          let Mi, to, so, no;
          switch (Di) {
            case 1:
              $i < 128 && (Ai = $i);
              break;
            case 2:
              Mi = si[_i + 1], (Mi & 192) === 128 && (no = ($i & 31) << 6 | Mi & 63, no > 127 && (Ai = no));
              break;
            case 3:
              Mi = si[_i + 1], to = si[_i + 2], (Mi & 192) === 128 && (to & 192) === 128 && (no = ($i & 15) << 12 | (Mi & 63) << 6 | to & 63, no > 2047 && (no < 55296 || no > 57343) && (Ai = no));
              break;
            case 4:
              Mi = si[_i + 1], to = si[_i + 2], so = si[_i + 3], (Mi & 192) === 128 && (to & 192) === 128 && (so & 192) === 128 && (no = ($i & 15) << 18 | (Mi & 63) << 12 | (to & 63) << 6 | so & 63, no > 65535 && no < 1114112 && (Ai = no));
          }
        }
        Ai === null ? (Ai = 65533, Di = 1) : Ai > 65535 && (Ai -= 65536, li.push(Ai >>> 10 & 1023 | 55296), Ai = 56320 | Ai & 1023), li.push(Ai), _i += Di;
      }
      return ri(li);
    }
    const Jr = 4096;
    function ri(si) {
      const Wr = si.length;
      if (Wr <= Jr)
        return String.fromCharCode.apply(String, si);
      let Xr = "", li = 0;
      for (; li < Wr; )
        Xr += String.fromCharCode.apply(
          String,
          si.slice(li, li += Jr)
        );
      return Xr;
    }
    function Sn(si, Wr, Xr) {
      let li = "";
      Xr = Math.min(si.length, Xr);
      for (let _i = Wr; _i < Xr; ++_i)
        li += String.fromCharCode(si[_i] & 127);
      return li;
    }
    function ai(si, Wr, Xr) {
      let li = "";
      Xr = Math.min(si.length, Xr);
      for (let _i = Wr; _i < Xr; ++_i)
        li += String.fromCharCode(si[_i]);
      return li;
    }
    function di(si, Wr, Xr) {
      const li = si.length;
      (!Wr || Wr < 0) && (Wr = 0), (!Xr || Xr < 0 || Xr > li) && (Xr = li);
      let _i = "";
      for (let $i = Wr; $i < Xr; ++$i)
        _i += eo[si[$i]];
      return _i;
    }
    function ii(si, Wr, Xr) {
      const li = si.slice(Wr, Xr);
      let _i = "";
      for (let $i = 0; $i < li.length - 1; $i += 2)
        _i += String.fromCharCode(li[$i] + li[$i + 1] * 256);
      return _i;
    }
    fr.prototype.slice = function(Wr, Xr) {
      const li = this.length;
      Wr = ~~Wr, Xr = Xr === void 0 ? li : ~~Xr, Wr < 0 ? (Wr += li, Wr < 0 && (Wr = 0)) : Wr > li && (Wr = li), Xr < 0 ? (Xr += li, Xr < 0 && (Xr = 0)) : Xr > li && (Xr = li), Xr < Wr && (Xr = Wr);
      const _i = this.subarray(Wr, Xr);
      return Object.setPrototypeOf(_i, fr.prototype), _i;
    };
    function fi(si, Wr, Xr) {
      if (si % 1 !== 0 || si < 0)
        throw new RangeError("offset is not uint");
      if (si + Wr > Xr)
        throw new RangeError("Trying to access beyond buffer length");
    }
    fr.prototype.readUintLE = fr.prototype.readUIntLE = function(Wr, Xr, li) {
      Wr = Wr >>> 0, Xr = Xr >>> 0, li || fi(Wr, Xr, this.length);
      let _i = this[Wr], $i = 1, Ai = 0;
      for (; ++Ai < Xr && ($i *= 256); )
        _i += this[Wr + Ai] * $i;
      return _i;
    }, fr.prototype.readUintBE = fr.prototype.readUIntBE = function(Wr, Xr, li) {
      Wr = Wr >>> 0, Xr = Xr >>> 0, li || fi(Wr, Xr, this.length);
      let _i = this[Wr + --Xr], $i = 1;
      for (; Xr > 0 && ($i *= 256); )
        _i += this[Wr + --Xr] * $i;
      return _i;
    }, fr.prototype.readUint8 = fr.prototype.readUInt8 = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 1, this.length), this[Wr];
    }, fr.prototype.readUint16LE = fr.prototype.readUInt16LE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 2, this.length), this[Wr] | this[Wr + 1] << 8;
    }, fr.prototype.readUint16BE = fr.prototype.readUInt16BE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 2, this.length), this[Wr] << 8 | this[Wr + 1];
    }, fr.prototype.readUint32LE = fr.prototype.readUInt32LE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 4, this.length), (this[Wr] | this[Wr + 1] << 8 | this[Wr + 2] << 16) + this[Wr + 3] * 16777216;
    }, fr.prototype.readUint32BE = fr.prototype.readUInt32BE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 4, this.length), this[Wr] * 16777216 + (this[Wr + 1] << 16 | this[Wr + 2] << 8 | this[Wr + 3]);
    }, fr.prototype.readBigUInt64LE = Ui(function(Wr) {
      Wr = Wr >>> 0, vi(Wr, "offset");
      const Xr = this[Wr], li = this[Wr + 7];
      (Xr === void 0 || li === void 0) && Ni(Wr, this.length - 8);
      const _i = Xr + this[++Wr] * 2 ** 8 + this[++Wr] * 2 ** 16 + this[++Wr] * 2 ** 24, $i = this[++Wr] + this[++Wr] * 2 ** 8 + this[++Wr] * 2 ** 16 + li * 2 ** 24;
      return BigInt(_i) + (BigInt($i) << BigInt(32));
    }), fr.prototype.readBigUInt64BE = Ui(function(Wr) {
      Wr = Wr >>> 0, vi(Wr, "offset");
      const Xr = this[Wr], li = this[Wr + 7];
      (Xr === void 0 || li === void 0) && Ni(Wr, this.length - 8);
      const _i = Xr * 2 ** 24 + this[++Wr] * 2 ** 16 + this[++Wr] * 2 ** 8 + this[++Wr], $i = this[++Wr] * 2 ** 24 + this[++Wr] * 2 ** 16 + this[++Wr] * 2 ** 8 + li;
      return (BigInt(_i) << BigInt(32)) + BigInt($i);
    }), fr.prototype.readIntLE = function(Wr, Xr, li) {
      Wr = Wr >>> 0, Xr = Xr >>> 0, li || fi(Wr, Xr, this.length);
      let _i = this[Wr], $i = 1, Ai = 0;
      for (; ++Ai < Xr && ($i *= 256); )
        _i += this[Wr + Ai] * $i;
      return $i *= 128, _i >= $i && (_i -= Math.pow(2, 8 * Xr)), _i;
    }, fr.prototype.readIntBE = function(Wr, Xr, li) {
      Wr = Wr >>> 0, Xr = Xr >>> 0, li || fi(Wr, Xr, this.length);
      let _i = Xr, $i = 1, Ai = this[Wr + --_i];
      for (; _i > 0 && ($i *= 256); )
        Ai += this[Wr + --_i] * $i;
      return $i *= 128, Ai >= $i && (Ai -= Math.pow(2, 8 * Xr)), Ai;
    }, fr.prototype.readInt8 = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 1, this.length), this[Wr] & 128 ? (255 - this[Wr] + 1) * -1 : this[Wr];
    }, fr.prototype.readInt16LE = function(Wr, Xr) {
      Wr = Wr >>> 0, Xr || fi(Wr, 2, this.length);
      const li = this[Wr] | this[Wr + 1] << 8;
      return li & 32768 ? li | 4294901760 : li;
    }, fr.prototype.readInt16BE = function(Wr, Xr) {
      Wr = Wr >>> 0, Xr || fi(Wr, 2, this.length);
      const li = this[Wr + 1] | this[Wr] << 8;
      return li & 32768 ? li | 4294901760 : li;
    }, fr.prototype.readInt32LE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 4, this.length), this[Wr] | this[Wr + 1] << 8 | this[Wr + 2] << 16 | this[Wr + 3] << 24;
    }, fr.prototype.readInt32BE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 4, this.length), this[Wr] << 24 | this[Wr + 1] << 16 | this[Wr + 2] << 8 | this[Wr + 3];
    }, fr.prototype.readBigInt64LE = Ui(function(Wr) {
      Wr = Wr >>> 0, vi(Wr, "offset");
      const Xr = this[Wr], li = this[Wr + 7];
      (Xr === void 0 || li === void 0) && Ni(Wr, this.length - 8);
      const _i = this[Wr + 4] + this[Wr + 5] * 2 ** 8 + this[Wr + 6] * 2 ** 16 + (li << 24);
      return (BigInt(_i) << BigInt(32)) + BigInt(Xr + this[++Wr] * 2 ** 8 + this[++Wr] * 2 ** 16 + this[++Wr] * 2 ** 24);
    }), fr.prototype.readBigInt64BE = Ui(function(Wr) {
      Wr = Wr >>> 0, vi(Wr, "offset");
      const Xr = this[Wr], li = this[Wr + 7];
      (Xr === void 0 || li === void 0) && Ni(Wr, this.length - 8);
      const _i = (Xr << 24) + this[++Wr] * 2 ** 16 + this[++Wr] * 2 ** 8 + this[++Wr];
      return (BigInt(_i) << BigInt(32)) + BigInt(this[++Wr] * 2 ** 24 + this[++Wr] * 2 ** 16 + this[++Wr] * 2 ** 8 + li);
    }), fr.prototype.readFloatLE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 4, this.length), s.read(this, Wr, !0, 23, 4);
    }, fr.prototype.readFloatBE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 4, this.length), s.read(this, Wr, !1, 23, 4);
    }, fr.prototype.readDoubleLE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 8, this.length), s.read(this, Wr, !0, 52, 8);
    }, fr.prototype.readDoubleBE = function(Wr, Xr) {
      return Wr = Wr >>> 0, Xr || fi(Wr, 8, this.length), s.read(this, Wr, !1, 52, 8);
    };
    function Ei(si, Wr, Xr, li, _i, $i) {
      if (!fr.isBuffer(si))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (Wr > _i || Wr < $i)
        throw new RangeError('"value" argument is out of bounds');
      if (Xr + li > si.length)
        throw new RangeError("Index out of range");
    }
    fr.prototype.writeUintLE = fr.prototype.writeUIntLE = function(Wr, Xr, li, _i) {
      if (Wr = +Wr, Xr = Xr >>> 0, li = li >>> 0, !_i) {
        const Di = Math.pow(2, 8 * li) - 1;
        Ei(this, Wr, Xr, li, Di, 0);
      }
      let $i = 1, Ai = 0;
      for (this[Xr] = Wr & 255; ++Ai < li && ($i *= 256); )
        this[Xr + Ai] = Wr / $i & 255;
      return Xr + li;
    }, fr.prototype.writeUintBE = fr.prototype.writeUIntBE = function(Wr, Xr, li, _i) {
      if (Wr = +Wr, Xr = Xr >>> 0, li = li >>> 0, !_i) {
        const Di = Math.pow(2, 8 * li) - 1;
        Ei(this, Wr, Xr, li, Di, 0);
      }
      let $i = li - 1, Ai = 1;
      for (this[Xr + $i] = Wr & 255; --$i >= 0 && (Ai *= 256); )
        this[Xr + $i] = Wr / Ai & 255;
      return Xr + li;
    }, fr.prototype.writeUint8 = fr.prototype.writeUInt8 = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 1, 255, 0), this[Xr] = Wr & 255, Xr + 1;
    }, fr.prototype.writeUint16LE = fr.prototype.writeUInt16LE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 2, 65535, 0), this[Xr] = Wr & 255, this[Xr + 1] = Wr >>> 8, Xr + 2;
    }, fr.prototype.writeUint16BE = fr.prototype.writeUInt16BE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 2, 65535, 0), this[Xr] = Wr >>> 8, this[Xr + 1] = Wr & 255, Xr + 2;
    }, fr.prototype.writeUint32LE = fr.prototype.writeUInt32LE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 4, 4294967295, 0), this[Xr + 3] = Wr >>> 24, this[Xr + 2] = Wr >>> 16, this[Xr + 1] = Wr >>> 8, this[Xr] = Wr & 255, Xr + 4;
    }, fr.prototype.writeUint32BE = fr.prototype.writeUInt32BE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 4, 4294967295, 0), this[Xr] = Wr >>> 24, this[Xr + 1] = Wr >>> 16, this[Xr + 2] = Wr >>> 8, this[Xr + 3] = Wr & 255, Xr + 4;
    };
    function bi(si, Wr, Xr, li, _i) {
      ci(Wr, li, _i, si, Xr, 7);
      let $i = Number(Wr & BigInt(4294967295));
      si[Xr++] = $i, $i = $i >> 8, si[Xr++] = $i, $i = $i >> 8, si[Xr++] = $i, $i = $i >> 8, si[Xr++] = $i;
      let Ai = Number(Wr >> BigInt(32) & BigInt(4294967295));
      return si[Xr++] = Ai, Ai = Ai >> 8, si[Xr++] = Ai, Ai = Ai >> 8, si[Xr++] = Ai, Ai = Ai >> 8, si[Xr++] = Ai, Xr;
    }
    function Si(si, Wr, Xr, li, _i) {
      ci(Wr, li, _i, si, Xr, 7);
      let $i = Number(Wr & BigInt(4294967295));
      si[Xr + 7] = $i, $i = $i >> 8, si[Xr + 6] = $i, $i = $i >> 8, si[Xr + 5] = $i, $i = $i >> 8, si[Xr + 4] = $i;
      let Ai = Number(Wr >> BigInt(32) & BigInt(4294967295));
      return si[Xr + 3] = Ai, Ai = Ai >> 8, si[Xr + 2] = Ai, Ai = Ai >> 8, si[Xr + 1] = Ai, Ai = Ai >> 8, si[Xr] = Ai, Xr + 8;
    }
    fr.prototype.writeBigUInt64LE = Ui(function(Wr, Xr = 0) {
      return bi(this, Wr, Xr, BigInt(0), BigInt("0xffffffffffffffff"));
    }), fr.prototype.writeBigUInt64BE = Ui(function(Wr, Xr = 0) {
      return Si(this, Wr, Xr, BigInt(0), BigInt("0xffffffffffffffff"));
    }), fr.prototype.writeIntLE = function(Wr, Xr, li, _i) {
      if (Wr = +Wr, Xr = Xr >>> 0, !_i) {
        const Mi = Math.pow(2, 8 * li - 1);
        Ei(this, Wr, Xr, li, Mi - 1, -Mi);
      }
      let $i = 0, Ai = 1, Di = 0;
      for (this[Xr] = Wr & 255; ++$i < li && (Ai *= 256); )
        Wr < 0 && Di === 0 && this[Xr + $i - 1] !== 0 && (Di = 1), this[Xr + $i] = (Wr / Ai >> 0) - Di & 255;
      return Xr + li;
    }, fr.prototype.writeIntBE = function(Wr, Xr, li, _i) {
      if (Wr = +Wr, Xr = Xr >>> 0, !_i) {
        const Mi = Math.pow(2, 8 * li - 1);
        Ei(this, Wr, Xr, li, Mi - 1, -Mi);
      }
      let $i = li - 1, Ai = 1, Di = 0;
      for (this[Xr + $i] = Wr & 255; --$i >= 0 && (Ai *= 256); )
        Wr < 0 && Di === 0 && this[Xr + $i + 1] !== 0 && (Di = 1), this[Xr + $i] = (Wr / Ai >> 0) - Di & 255;
      return Xr + li;
    }, fr.prototype.writeInt8 = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 1, 127, -128), Wr < 0 && (Wr = 255 + Wr + 1), this[Xr] = Wr & 255, Xr + 1;
    }, fr.prototype.writeInt16LE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 2, 32767, -32768), this[Xr] = Wr & 255, this[Xr + 1] = Wr >>> 8, Xr + 2;
    }, fr.prototype.writeInt16BE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 2, 32767, -32768), this[Xr] = Wr >>> 8, this[Xr + 1] = Wr & 255, Xr + 2;
    }, fr.prototype.writeInt32LE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 4, 2147483647, -2147483648), this[Xr] = Wr & 255, this[Xr + 1] = Wr >>> 8, this[Xr + 2] = Wr >>> 16, this[Xr + 3] = Wr >>> 24, Xr + 4;
    }, fr.prototype.writeInt32BE = function(Wr, Xr, li) {
      return Wr = +Wr, Xr = Xr >>> 0, li || Ei(this, Wr, Xr, 4, 2147483647, -2147483648), Wr < 0 && (Wr = 4294967295 + Wr + 1), this[Xr] = Wr >>> 24, this[Xr + 1] = Wr >>> 16, this[Xr + 2] = Wr >>> 8, this[Xr + 3] = Wr & 255, Xr + 4;
    }, fr.prototype.writeBigInt64LE = Ui(function(Wr, Xr = 0) {
      return bi(this, Wr, Xr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), fr.prototype.writeBigInt64BE = Ui(function(Wr, Xr = 0) {
      return Si(this, Wr, Xr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function Ii(si, Wr, Xr, li, _i, $i) {
      if (Xr + li > si.length)
        throw new RangeError("Index out of range");
      if (Xr < 0)
        throw new RangeError("Index out of range");
    }
    function yi(si, Wr, Xr, li, _i) {
      return Wr = +Wr, Xr = Xr >>> 0, _i || Ii(si, Wr, Xr, 4), s.write(si, Wr, Xr, li, 23, 4), Xr + 4;
    }
    fr.prototype.writeFloatLE = function(Wr, Xr, li) {
      return yi(this, Wr, Xr, !0, li);
    }, fr.prototype.writeFloatBE = function(Wr, Xr, li) {
      return yi(this, Wr, Xr, !1, li);
    };
    function ui(si, Wr, Xr, li, _i) {
      return Wr = +Wr, Xr = Xr >>> 0, _i || Ii(si, Wr, Xr, 8), s.write(si, Wr, Xr, li, 52, 8), Xr + 8;
    }
    fr.prototype.writeDoubleLE = function(Wr, Xr, li) {
      return ui(this, Wr, Xr, !0, li);
    }, fr.prototype.writeDoubleBE = function(Wr, Xr, li) {
      return ui(this, Wr, Xr, !1, li);
    }, fr.prototype.copy = function(Wr, Xr, li, _i) {
      if (!fr.isBuffer(Wr))
        throw new TypeError("argument should be a Buffer");
      if (li || (li = 0), !_i && _i !== 0 && (_i = this.length), Xr >= Wr.length && (Xr = Wr.length), Xr || (Xr = 0), _i > 0 && _i < li && (_i = li), _i === li || Wr.length === 0 || this.length === 0)
        return 0;
      if (Xr < 0)
        throw new RangeError("targetStart out of bounds");
      if (li < 0 || li >= this.length)
        throw new RangeError("Index out of range");
      if (_i < 0)
        throw new RangeError("sourceEnd out of bounds");
      _i > this.length && (_i = this.length), Wr.length - Xr < _i - li && (_i = Wr.length - Xr + li);
      const $i = _i - li;
      return this === Wr && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Xr, li, _i) : Uint8Array.prototype.set.call(
        Wr,
        this.subarray(li, _i),
        Xr
      ), $i;
    }, fr.prototype.fill = function(Wr, Xr, li, _i) {
      if (typeof Wr == "string") {
        if (typeof Xr == "string" ? (_i = Xr, Xr = 0, li = this.length) : typeof li == "string" && (_i = li, li = this.length), _i !== void 0 && typeof _i != "string")
          throw new TypeError("encoding must be a string");
        if (typeof _i == "string" && !fr.isEncoding(_i))
          throw new TypeError("Unknown encoding: " + _i);
        if (Wr.length === 1) {
          const Ai = Wr.charCodeAt(0);
          (_i === "utf8" && Ai < 128 || _i === "latin1") && (Wr = Ai);
        }
      } else
        typeof Wr == "number" ? Wr = Wr & 255 : typeof Wr == "boolean" && (Wr = Number(Wr));
      if (Xr < 0 || this.length < Xr || this.length < li)
        throw new RangeError("Out of range index");
      if (li <= Xr)
        return this;
      Xr = Xr >>> 0, li = li === void 0 ? this.length : li >>> 0, Wr || (Wr = 0);
      let $i;
      if (typeof Wr == "number")
        for ($i = Xr; $i < li; ++$i)
          this[$i] = Wr;
      else {
        const Ai = fr.isBuffer(Wr) ? Wr : fr.from(Wr, _i), Di = Ai.length;
        if (Di === 0)
          throw new TypeError('The value "' + Wr + '" is invalid for argument "value"');
        for ($i = 0; $i < li - Xr; ++$i)
          this[$i + Xr] = Ai[$i % Di];
      }
      return this;
    };
    const hi = {};
    function gi(si, Wr, Xr) {
      hi[si] = class extends Xr {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: Wr.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${si}]`, this.stack, delete this.name;
        }
        get code() {
          return si;
        }
        set code(_i) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: _i,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${si}]: ${this.message}`;
        }
      };
    }
    gi(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(si) {
        return si ? `${si} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), gi(
      "ERR_INVALID_ARG_TYPE",
      function(si, Wr) {
        return `The "${si}" argument must be of type number. Received type ${typeof Wr}`;
      },
      TypeError
    ), gi(
      "ERR_OUT_OF_RANGE",
      function(si, Wr, Xr) {
        let li = `The value of "${si}" is out of range.`, _i = Xr;
        return Number.isInteger(Xr) && Math.abs(Xr) > 2 ** 32 ? _i = Qr(String(Xr)) : typeof Xr == "bigint" && (_i = String(Xr), (Xr > BigInt(2) ** BigInt(32) || Xr < -(BigInt(2) ** BigInt(32))) && (_i = Qr(_i)), _i += "n"), li += ` It must be ${Wr}. Received ${_i}`, li;
      },
      RangeError
    );
    function Qr(si) {
      let Wr = "", Xr = si.length;
      const li = si[0] === "-" ? 1 : 0;
      for (; Xr >= li + 4; Xr -= 3)
        Wr = `_${si.slice(Xr - 3, Xr)}${Wr}`;
      return `${si.slice(0, Xr)}${Wr}`;
    }
    function wn(si, Wr, Xr) {
      vi(Wr, "offset"), (si[Wr] === void 0 || si[Wr + Xr] === void 0) && Ni(Wr, si.length - (Xr + 1));
    }
    function ci(si, Wr, Xr, li, _i, $i) {
      if (si > Xr || si < Wr) {
        const Ai = typeof Wr == "bigint" ? "n" : "";
        let Di;
        throw $i > 3 ? Wr === 0 || Wr === BigInt(0) ? Di = `>= 0${Ai} and < 2${Ai} ** ${($i + 1) * 8}${Ai}` : Di = `>= -(2${Ai} ** ${($i + 1) * 8 - 1}${Ai}) and < 2 ** ${($i + 1) * 8 - 1}${Ai}` : Di = `>= ${Wr}${Ai} and <= ${Xr}${Ai}`, new hi.ERR_OUT_OF_RANGE("value", Di, si);
      }
      wn(li, _i, $i);
    }
    function vi(si, Wr) {
      if (typeof si != "number")
        throw new hi.ERR_INVALID_ARG_TYPE(Wr, "number", si);
    }
    function Ni(si, Wr, Xr) {
      throw Math.floor(si) !== si ? (vi(si, Xr), new hi.ERR_OUT_OF_RANGE(Xr || "offset", "an integer", si)) : Wr < 0 ? new hi.ERR_BUFFER_OUT_OF_BOUNDS() : new hi.ERR_OUT_OF_RANGE(
        Xr || "offset",
        `>= ${Xr ? 1 : 0} and <= ${Wr}`,
        si
      );
    }
    const Fi = /[^+/0-9A-Za-z-_]/g;
    function Pi(si) {
      if (si = si.split("=")[0], si = si.trim().replace(Fi, ""), si.length < 2)
        return "";
      for (; si.length % 4 !== 0; )
        si = si + "=";
      return si;
    }
    function Li(si, Wr) {
      Wr = Wr || 1 / 0;
      let Xr;
      const li = si.length;
      let _i = null;
      const $i = [];
      for (let Ai = 0; Ai < li; ++Ai) {
        if (Xr = si.charCodeAt(Ai), Xr > 55295 && Xr < 57344) {
          if (!_i) {
            if (Xr > 56319) {
              (Wr -= 3) > -1 && $i.push(239, 191, 189);
              continue;
            } else if (Ai + 1 === li) {
              (Wr -= 3) > -1 && $i.push(239, 191, 189);
              continue;
            }
            _i = Xr;
            continue;
          }
          if (Xr < 56320) {
            (Wr -= 3) > -1 && $i.push(239, 191, 189), _i = Xr;
            continue;
          }
          Xr = (_i - 55296 << 10 | Xr - 56320) + 65536;
        } else
          _i && (Wr -= 3) > -1 && $i.push(239, 191, 189);
        if (_i = null, Xr < 128) {
          if ((Wr -= 1) < 0)
            break;
          $i.push(Xr);
        } else if (Xr < 2048) {
          if ((Wr -= 2) < 0)
            break;
          $i.push(
            Xr >> 6 | 192,
            Xr & 63 | 128
          );
        } else if (Xr < 65536) {
          if ((Wr -= 3) < 0)
            break;
          $i.push(
            Xr >> 12 | 224,
            Xr >> 6 & 63 | 128,
            Xr & 63 | 128
          );
        } else if (Xr < 1114112) {
          if ((Wr -= 4) < 0)
            break;
          $i.push(
            Xr >> 18 | 240,
            Xr >> 12 & 63 | 128,
            Xr >> 6 & 63 | 128,
            Xr & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return $i;
    }
    function oo(si) {
      const Wr = [];
      for (let Xr = 0; Xr < si.length; ++Xr)
        Wr.push(si.charCodeAt(Xr) & 255);
      return Wr;
    }
    function ao(si, Wr) {
      let Xr, li, _i;
      const $i = [];
      for (let Ai = 0; Ai < si.length && !((Wr -= 2) < 0); ++Ai)
        Xr = si.charCodeAt(Ai), li = Xr >> 8, _i = Xr % 256, $i.push(_i), $i.push(li);
      return $i;
    }
    function zi(si) {
      return e.toByteArray(Pi(si));
    }
    function Ki(si, Wr, Xr, li) {
      let _i;
      for (_i = 0; _i < li && !(_i + Xr >= Wr.length || _i >= si.length); ++_i)
        Wr[_i + Xr] = si[_i];
      return _i;
    }
    function Vi(si, Wr) {
      return si instanceof Wr || si != null && si.constructor != null && si.constructor.name != null && si.constructor.name === Wr.name;
    }
    function Yi(si) {
      return si !== si;
    }
    const eo = function() {
      const si = "0123456789abcdef", Wr = new Array(256);
      for (let Xr = 0; Xr < 16; ++Xr) {
        const li = Xr * 16;
        for (let _i = 0; _i < 16; ++_i)
          Wr[li + _i] = si[Xr] + si[_i];
      }
      return Wr;
    }();
    function Ui(si) {
      return typeof BigInt > "u" ? ji : si;
    }
    function ji() {
      throw new Error("BigInt not supported");
    }
  }(buffer)), buffer;
}
globalThis.Buffer || (globalThis.Buffer = requireBuffer().Buffer);
var account = {}, address$2 = {}, ALPHABET$2 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP$1 = {};
for (var z$2 = 0; z$2 < ALPHABET$2.length; z$2++) {
  var x$2 = ALPHABET$2.charAt(z$2);
  if (ALPHABET_MAP$1[x$2] !== void 0)
    throw new TypeError(x$2 + " is ambiguous");
  ALPHABET_MAP$1[x$2] = z$2;
}
function polymodStep$1(r) {
  var e = r >> 25;
  return (r & 33554431) << 5 ^ -(e >> 0 & 1) & 996825010 ^ -(e >> 1 & 1) & 642813549 ^ -(e >> 2 & 1) & 513874426 ^ -(e >> 3 & 1) & 1027748829 ^ -(e >> 4 & 1) & 705979059;
}
function prefixChk$1(r) {
  for (var e = 1, s = 0; s < r.length; ++s) {
    var o = r.charCodeAt(s);
    if (o < 33 || o > 126)
      return "Invalid prefix (" + r + ")";
    e = polymodStep$1(e) ^ o >> 5;
  }
  for (e = polymodStep$1(e), s = 0; s < r.length; ++s) {
    var fe = r.charCodeAt(s);
    e = polymodStep$1(e) ^ fe & 31;
  }
  return e;
}
function encode$a(r, e, s) {
  if (s = s || 90, r.length + 7 + e.length > s)
    throw new TypeError("Exceeds length limit");
  r = r.toLowerCase();
  var o = prefixChk$1(r);
  if (typeof o == "string")
    throw new Error(o);
  for (var fe = r + "1", me = 0; me < e.length; ++me) {
    var ye = e[me];
    if (ye >> 5 !== 0)
      throw new Error("Non 5-bit word");
    o = polymodStep$1(o) ^ ye, fe += ALPHABET$2.charAt(ye);
  }
  for (me = 0; me < 6; ++me)
    o = polymodStep$1(o);
  for (o ^= 1, me = 0; me < 6; ++me) {
    var fr = o >> (5 - me) * 5 & 31;
    fe += ALPHABET$2.charAt(fr);
  }
  return fe;
}
function __decode(r, e) {
  if (e = e || 90, r.length < 8)
    return r + " too short";
  if (r.length > e)
    return "Exceeds length limit";
  var s = r.toLowerCase(), o = r.toUpperCase();
  if (r !== s && r !== o)
    return "Mixed-case string " + r;
  r = s;
  var fe = r.lastIndexOf("1");
  if (fe === -1)
    return "No separator character for " + r;
  if (fe === 0)
    return "Missing prefix for " + r;
  var me = r.slice(0, fe), ye = r.slice(fe + 1);
  if (ye.length < 6)
    return "Data too short";
  var fr = prefixChk$1(me);
  if (typeof fr == "string")
    return fr;
  for (var Er = [], br = 0; br < ye.length; ++br) {
    var wr = ye.charAt(br), kr = ALPHABET_MAP$1[wr];
    if (kr === void 0)
      return "Unknown character " + wr;
    fr = polymodStep$1(fr) ^ kr, !(br + 6 >= ye.length) && Er.push(kr);
  }
  return fr !== 1 ? "Invalid checksum for " + r : { prefix: me, words: Er };
}
function decodeUnsafe() {
  var r = __decode.apply(null, arguments);
  if (typeof r == "object")
    return r;
}
function decode$8(r) {
  var e = __decode.apply(null, arguments);
  if (typeof e == "object")
    return e;
  throw new Error(e);
}
function convert$2(r, e, s, o) {
  for (var fe = 0, me = 0, ye = (1 << s) - 1, fr = [], Er = 0; Er < r.length; ++Er)
    for (fe = fe << e | r[Er], me += e; me >= s; )
      me -= s, fr.push(fe >> me & ye);
  if (o)
    me > 0 && fr.push(fe << s - me & ye);
  else {
    if (me >= e)
      return "Excess padding";
    if (fe << s - me & ye)
      return "Non-zero padding";
  }
  return fr;
}
function toWordsUnsafe(r) {
  var e = convert$2(r, 8, 5, !0);
  if (Array.isArray(e))
    return e;
}
function toWords$1(r) {
  var e = convert$2(r, 8, 5, !0);
  if (Array.isArray(e))
    return e;
  throw new Error(e);
}
function fromWordsUnsafe$1(r) {
  var e = convert$2(r, 5, 8, !1);
  if (Array.isArray(e))
    return e;
}
function fromWords$1(r) {
  var e = convert$2(r, 5, 8, !1);
  if (Array.isArray(e))
    return e;
  throw new Error(e);
}
var bech32$2 = {
  decodeUnsafe,
  decode: decode$8,
  encode: encode$a,
  toWordsUnsafe,
  toWords: toWords$1,
  fromWordsUnsafe: fromWordsUnsafe$1,
  fromWords: fromWords$1
}, errors$q = {};
Object.defineProperty(errors$q, "__esModule", { value: !0 });
errors$q.ErrIsCompletedFieldIsMissingOnTransaction = errors$q.ErrGasLimitShouldBe0ForInnerTransaction = errors$q.ErrInvalidRelayedV2BuilderArguments = errors$q.ErrInvalidRelayedV1BuilderArguments = errors$q.ErrNotImplemented = errors$q.ErrContractInteraction = errors$q.ErrCodec = errors$q.ErrCannotParseTransactionOutcome = errors$q.ErrCannotParseContractResults = errors$q.ErrMissingFieldOnEnum = errors$q.ErrMissingFieldOnStruct = errors$q.ErrTypingSystem = errors$q.ErrMock = errors$q.ErrContractHasNoAddress = errors$q.ErrContract = errors$q.ErrExpectedTransactionEventsNotFound = errors$q.ErrExpectedTransactionStatusNotReached = errors$q.ErrTransactionWatcherTimeout = errors$q.ErrAsyncTimerAborted = errors$q.ErrAsyncTimerAlreadyRunning = errors$q.ErrInvalidFunctionName = errors$q.ErrSignatureCannotCreate = errors$q.ErrTransactionOptionsInvalid = errors$q.ErrTransactionVersionInvalid = errors$q.ErrNonceInvalid = errors$q.ErrNotEnoughGas = errors$q.ErrAddressEmpty = errors$q.ErrAddressBadHrp = errors$q.ErrAddressCannotCreate = errors$q.ErrUnexpectedCondition = errors$q.ErrInvariantFailed = errors$q.ErrBadType = errors$q.ErrUnsupportedOperation = errors$q.ErrInvalidArgument = errors$q.Err = void 0;
class Err$2 extends Error {
  constructor(e, s) {
    super(e), this.inner = void 0, this.inner = s;
  }
  summary() {
    let e = [];
    e.push({ name: this.name, message: this.message });
    let s = this.inner;
    for (; s; )
      e.push({ name: s.name, message: s.message }), s = s.inner;
    return e;
  }
}
errors$q.Err = Err$2;
class ErrInvalidArgument extends Err$2 {
  constructor(e, s) {
    super(`Invalid argument: ${e}`, s);
  }
}
errors$q.ErrInvalidArgument = ErrInvalidArgument;
class ErrUnsupportedOperation extends Err$2 {
  constructor(e, s = "not specified") {
    super(`Operation "${e}" not supported. Reason: ${s}`);
  }
}
errors$q.ErrUnsupportedOperation = ErrUnsupportedOperation;
class ErrBadType extends Err$2 {
  constructor(e, s, o) {
    super(`Bad type of "${e}": ${o}. Expected type: ${s}`);
  }
}
errors$q.ErrBadType = ErrBadType;
class ErrInvariantFailed extends Err$2 {
  constructor(e) {
    super(`Invariant failed: [${e}]`);
  }
}
errors$q.ErrInvariantFailed = ErrInvariantFailed;
class ErrUnexpectedCondition$1 extends Err$2 {
  constructor(e) {
    super(`Unexpected condition: [${e}]`);
  }
}
errors$q.ErrUnexpectedCondition = ErrUnexpectedCondition$1;
class ErrAddressCannotCreate extends Err$2 {
  constructor(e, s) {
    let o = `Cannot create address from: ${e}`;
    super(o, s);
  }
}
errors$q.ErrAddressCannotCreate = ErrAddressCannotCreate;
class ErrAddressBadHrp extends Err$2 {
  constructor(e, s) {
    super(`Wrong address HRP. Expected: ${e}, got ${s}`);
  }
}
errors$q.ErrAddressBadHrp = ErrAddressBadHrp;
class ErrAddressEmpty extends Err$2 {
  constructor() {
    super("Address is empty");
  }
}
errors$q.ErrAddressEmpty = ErrAddressEmpty;
class ErrNotEnoughGas extends Err$2 {
  constructor(e) {
    super(`Not enough gas provided: ${e}`);
  }
}
errors$q.ErrNotEnoughGas = ErrNotEnoughGas;
class ErrNonceInvalid extends Err$2 {
  constructor(e) {
    super(`Invalid nonce: ${e}`);
  }
}
errors$q.ErrNonceInvalid = ErrNonceInvalid;
class ErrTransactionVersionInvalid extends Err$2 {
  constructor(e) {
    super(`Invalid transaction version: ${e}`);
  }
}
errors$q.ErrTransactionVersionInvalid = ErrTransactionVersionInvalid;
class ErrTransactionOptionsInvalid extends Err$2 {
  constructor(e) {
    super(`Invalid transaction options: ${e}`);
  }
}
errors$q.ErrTransactionOptionsInvalid = ErrTransactionOptionsInvalid;
class ErrSignatureCannotCreate extends Err$2 {
  constructor(e, s) {
    let o = `Cannot create signature from: ${e}`;
    super(o, s);
  }
}
errors$q.ErrSignatureCannotCreate = ErrSignatureCannotCreate;
class ErrInvalidFunctionName extends Err$2 {
  constructor() {
    super("Invalid function name");
  }
}
errors$q.ErrInvalidFunctionName = ErrInvalidFunctionName;
class ErrAsyncTimerAlreadyRunning extends Err$2 {
  constructor() {
    super("Async timer already running");
  }
}
errors$q.ErrAsyncTimerAlreadyRunning = ErrAsyncTimerAlreadyRunning;
class ErrAsyncTimerAborted extends Err$2 {
  constructor() {
    super("Async timer aborted");
  }
}
errors$q.ErrAsyncTimerAborted = ErrAsyncTimerAborted;
class ErrTransactionWatcherTimeout extends Err$2 {
  constructor() {
    super("TransactionWatcher has timed out");
  }
}
errors$q.ErrTransactionWatcherTimeout = ErrTransactionWatcherTimeout;
class ErrExpectedTransactionStatusNotReached extends Err$2 {
  constructor() {
    super("Expected transaction status not reached");
  }
}
errors$q.ErrExpectedTransactionStatusNotReached = ErrExpectedTransactionStatusNotReached;
class ErrExpectedTransactionEventsNotFound extends Err$2 {
  constructor() {
    super("Expected transaction events not found");
  }
}
errors$q.ErrExpectedTransactionEventsNotFound = ErrExpectedTransactionEventsNotFound;
class ErrContract extends Err$2 {
  constructor(e) {
    super(e);
  }
}
errors$q.ErrContract = ErrContract;
class ErrContractHasNoAddress extends ErrContract {
  constructor() {
    super(`
The smart contract has no address set. Make sure you provide the address in the constructor, or call setAddress() appropriately.
If you need to recompute the address of the contract, make use of SmartContract.computeAddress() (static method). 
`);
  }
}
errors$q.ErrContractHasNoAddress = ErrContractHasNoAddress;
class ErrMock extends Err$2 {
  constructor(e) {
    super(e);
  }
}
errors$q.ErrMock = ErrMock;
class ErrTypingSystem extends Err$2 {
  constructor(e) {
    super(e);
  }
}
errors$q.ErrTypingSystem = ErrTypingSystem;
class ErrMissingFieldOnStruct extends Err$2 {
  constructor(e, s) {
    super(`field ${e} does not exist on struct ${s}`);
  }
}
errors$q.ErrMissingFieldOnStruct = ErrMissingFieldOnStruct;
class ErrMissingFieldOnEnum extends Err$2 {
  constructor(e, s) {
    super(`field ${e} does not exist on enum ${s}`);
  }
}
errors$q.ErrMissingFieldOnEnum = ErrMissingFieldOnEnum;
class ErrCannotParseContractResults extends Err$2 {
  constructor(e) {
    super(`cannot parse contract results: ${e}`);
  }
}
errors$q.ErrCannotParseContractResults = ErrCannotParseContractResults;
class ErrCannotParseTransactionOutcome extends Err$2 {
  constructor(e, s) {
    super(`cannot parse outcome of transaction ${e}: ${s}`);
  }
}
errors$q.ErrCannotParseTransactionOutcome = ErrCannotParseTransactionOutcome;
class ErrCodec extends Err$2 {
  constructor(e) {
    super(e);
  }
}
errors$q.ErrCodec = ErrCodec;
class ErrContractInteraction extends Err$2 {
  constructor(e) {
    super(e);
  }
}
errors$q.ErrContractInteraction = ErrContractInteraction;
class ErrNotImplemented extends Err$2 {
  constructor() {
    super("Method not yet implemented");
  }
}
errors$q.ErrNotImplemented = ErrNotImplemented;
class ErrInvalidRelayedV1BuilderArguments extends Err$2 {
  constructor() {
    super("invalid arguments for relayed v1 builder");
  }
}
errors$q.ErrInvalidRelayedV1BuilderArguments = ErrInvalidRelayedV1BuilderArguments;
class ErrInvalidRelayedV2BuilderArguments extends Err$2 {
  constructor() {
    super("invalid arguments for relayed v2 builder");
  }
}
errors$q.ErrInvalidRelayedV2BuilderArguments = ErrInvalidRelayedV2BuilderArguments;
class ErrGasLimitShouldBe0ForInnerTransaction extends Err$2 {
  constructor() {
    super("gas limit must be 0 for the inner transaction for relayed v2");
  }
}
errors$q.ErrGasLimitShouldBe0ForInnerTransaction = ErrGasLimitShouldBe0ForInnerTransaction;
class ErrIsCompletedFieldIsMissingOnTransaction extends Err$2 {
  constructor() {
    super("The transaction watcher requires the `isCompleted` property to be defined on the transaction object. Perhaps you've used the sdk-network-provider's `ProxyNetworkProvider.getTransaction()` and in that case you should also pass `withProcessStatus=true`.");
  }
}
errors$q.ErrIsCompletedFieldIsMissingOnTransaction = ErrIsCompletedFieldIsMissingOnTransaction;
var __createBinding$l = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$l = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$l = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$l(e, r, s);
  return __setModuleDefault$l(e, r), e;
};
Object.defineProperty(address$2, "__esModule", { value: !0 });
address$2.Address = void 0;
const bech32$1 = __importStar$l(bech32$2), errors$p = __importStar$l(errors$q), HRP$1 = "erd", PUBKEY_LENGTH = 32, SMART_CONTRACT_HEX_PUBKEY_PREFIX = "0".repeat(16);
class Address$1 {
  constructor(e) {
    if (this.valueHex = "", !!e) {
      if (e instanceof Address$1)
        return Address$1.fromAddress(e);
      if (e instanceof Buffer)
        return Address$1.fromBuffer(e);
      if (typeof e == "string")
        return Address$1.fromString(e);
      throw new errors$p.ErrAddressCannotCreate(e);
    }
  }
  static fromAddress(e) {
    return Address$1.fromValidHex(e.valueHex);
  }
  static fromValidHex(e) {
    let s = new Address$1();
    return s.valueHex = e, s;
  }
  static fromBuffer(e) {
    if (e.length != PUBKEY_LENGTH)
      throw new errors$p.ErrAddressCannotCreate(e);
    return Address$1.fromValidHex(e.toString("hex"));
  }
  static fromString(e) {
    return Address$1.isValidHex(e) ? Address$1.fromValidHex(e) : Address$1.fromBech32(e);
  }
  static isValidHex(e) {
    return Buffer.from(e, "hex").length == PUBKEY_LENGTH;
  }
  static fromHex(e) {
    if (!Address$1.isValidHex(e))
      throw new errors$p.ErrAddressCannotCreate(e);
    return Address$1.fromValidHex(e);
  }
  static empty() {
    return new Address$1();
  }
  static fromBech32(e) {
    let s;
    try {
      s = bech32$1.decode(e);
    } catch (me) {
      throw new errors$p.ErrAddressCannotCreate(e, me);
    }
    let o = s.prefix;
    if (o != HRP$1)
      throw new errors$p.ErrAddressBadHrp(HRP$1, o);
    let fe = Buffer.from(bech32$1.fromWords(s.words));
    if (fe.length != PUBKEY_LENGTH)
      throw new errors$p.ErrAddressCannotCreate(e);
    return Address$1.fromValidHex(fe.toString("hex"));
  }
  static isValid(e) {
    const s = bech32$1.decodeUnsafe(e), o = s == null ? void 0 : s.prefix, fe = s ? Buffer.from(bech32$1.fromWords(s.words)) : void 0;
    return !(o !== HRP$1 || (fe == null ? void 0 : fe.length) !== PUBKEY_LENGTH);
  }
  hex() {
    return this.isEmpty() ? "" : this.valueHex;
  }
  bech32() {
    if (this.isEmpty())
      return "";
    let e = bech32$1.toWords(this.pubkey());
    return bech32$1.encode(HRP$1, e);
  }
  pubkey() {
    return this.isEmpty() ? Buffer.from([]) : Buffer.from(this.valueHex, "hex");
  }
  isEmpty() {
    return !this.valueHex;
  }
  equals(e) {
    return e ? this.valueHex == e.valueHex : !1;
  }
  toString() {
    return this.bech32();
  }
  toJSON() {
    return {
      bech32: this.bech32(),
      pubkey: this.hex()
    };
  }
  static Zero() {
    return new Address$1("0".repeat(64));
  }
  isContractAddress() {
    return this.hex().startsWith(SMART_CONTRACT_HEX_PUBKEY_PREFIX);
  }
}
address$2.Address = Address$1;
Object.defineProperty(account, "__esModule", { value: !0 });
account.Account = void 0;
const address_1$h = address$2;
class Account {
  constructor(e) {
    this.address = new address_1$h.Address(), this.nonce = 0, this.balance = "0", this.address = e;
  }
  update(e) {
    this.nonce = e.nonce, this.balance = e.balance;
  }
  incrementNonce() {
    this.nonce = this.nonce.valueOf() + 1;
  }
  getNonceThenIncrement() {
    let e = this.nonce;
    return this.nonce = this.nonce.valueOf() + 1, e;
  }
  toJSON() {
    return {
      address: this.address.bech32(),
      nonce: this.nonce.valueOf(),
      balance: this.balance.toString()
    };
  }
}
account.Account = Account;
var asyncTimer = {}, logger$1 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Logger = r.LogLevel = void 0;
  var e;
  (function(o) {
    o[o.Trace = 0] = "Trace", o[o.Debug = 1] = "Debug", o[o.Info = 2] = "Info", o[o.Warn = 3] = "Warn", o[o.Error = 4] = "Error", o[o.None = 5] = "None";
  })(e = r.LogLevel || (r.LogLevel = {}));
  class s {
    static setLevel(fe) {
      s.logLevel = fe;
    }
    static trace(fe, ...me) {
      s.logLevel >= e.Debug || console.debug(fe, me);
    }
    static debug(fe, ...me) {
      s.logLevel >= e.Debug || console.debug(fe, me);
    }
    static info(fe, ...me) {
      s.logLevel >= e.Info || console.log(fe, me);
    }
    static warn(fe, ...me) {
      s.logLevel >= e.Warn || console.warn(fe, me);
    }
    static error(fe, ...me) {
      s.logLevel >= e.Error || console.error(fe, me);
    }
  }
  r.Logger = s, s.logLevel = e.Debug;
})(logger$1);
var __createBinding$k = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$k = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$k = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$k(e, r, s);
  return __setModuleDefault$k(e, r), e;
};
Object.defineProperty(asyncTimer, "__esModule", { value: !0 });
asyncTimer.AsyncTimer = void 0;
const errors$o = __importStar$k(errors$q), errors_1$h = errors$q, logger_1$4 = logger$1;
class AsyncTimer {
  constructor(e) {
    this.timeoutHandle = null, this.rejectionFunc = null, this.name = e, this.correlationTag = 0;
  }
  start(e) {
    if (this.timeoutHandle)
      throw new errors$o.ErrAsyncTimerAlreadyRunning();
    return this.correlationTag++, logger_1$4.Logger.trace(`AsyncTimer[${this.name}'${this.correlationTag}].start()`), new Promise((s, o) => {
      this.rejectionFunc = o;
      let fe = () => {
        this.rejectionFunc = null, this.stop(), s();
      };
      this.timeoutHandle = setTimeout(fe, e);
    });
  }
  abort() {
    logger_1$4.Logger.trace(`AsyncTimer[${this.name}'${this.correlationTag}].abort()`), this.rejectionFunc && (this.rejectionFunc(new errors_1$h.ErrAsyncTimerAborted()), this.rejectionFunc = null), this.stop();
  }
  stop() {
    this.isStopped() || (logger_1$4.Logger.trace(`AsyncTimer[${this.name}'${this.correlationTag}].stop()`), this.timeoutHandle && (clearTimeout(this.timeoutHandle), this.timeoutHandle = null));
  }
  isStopped() {
    return !this.timeoutHandle;
  }
}
asyncTimer.AsyncTimer = AsyncTimer;
var gasEstimator = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.GasEstimator = r.DefaultGasConfiguration = void 0, r.DefaultGasConfiguration = {
    minGasLimit: 5e4,
    gasPerDataByte: 1500,
    gasCostESDTTransfer: 2e5,
    gasCostESDTNFTTransfer: 2e5,
    gasCostESDTNFTMultiTransfer: 2e5
  };
  const e = 1e5, s = 8e5;
  class o {
    constructor(me) {
      this.gasConfiguration = me || r.DefaultGasConfiguration;
    }
    forEGLDTransfer(me) {
      return this.gasConfiguration.minGasLimit + this.gasConfiguration.gasPerDataByte * me;
    }
    forESDTTransfer(me) {
      return this.gasConfiguration.minGasLimit + this.gasConfiguration.gasCostESDTTransfer + this.gasConfiguration.gasPerDataByte * me + e;
    }
    forESDTNFTTransfer(me) {
      return this.gasConfiguration.minGasLimit + this.gasConfiguration.gasCostESDTNFTTransfer + this.gasConfiguration.gasPerDataByte * me + s;
    }
    forMultiESDTNFTTransfer(me, ye) {
      return this.gasConfiguration.minGasLimit + (this.gasConfiguration.gasCostESDTNFTMultiTransfer + s) * ye + this.gasConfiguration.gasPerDataByte * me;
    }
  }
  r.GasEstimator = o;
})(gasEstimator);
var _interface$1 = {};
Object.defineProperty(_interface$1, "__esModule", { value: !0 });
var interfaceOfNetwork = {};
Object.defineProperty(interfaceOfNetwork, "__esModule", { value: !0 });
var networkParams = {}, constants$c = {};
Object.defineProperty(constants$c, "__esModule", { value: !0 });
constants$c.ARGUMENTS_SEPARATOR = constants$c.ESDT_TRANSFER_VALUE = constants$c.MULTI_ESDTNFT_TRANSFER_FUNCTION_NAME = constants$c.ESDTNFT_TRANSFER_FUNCTION_NAME = constants$c.ESDT_TRANSFER_FUNCTION_NAME = constants$c.ESDT_TRANSFER_GAS_LIMIT = constants$c.TRANSACTION_VERSION_WITH_OPTIONS = constants$c.TRANSACTION_VERSION_DEFAULT = constants$c.TRANSACTION_OPTIONS_TX_GUARDED = constants$c.TRANSACTION_OPTIONS_TX_HASH_SIGN = constants$c.TRANSACTION_OPTIONS_DEFAULT = constants$c.TRANSACTION_MIN_GAS_PRICE = void 0;
constants$c.TRANSACTION_MIN_GAS_PRICE = 1e9;
constants$c.TRANSACTION_OPTIONS_DEFAULT = 0;
constants$c.TRANSACTION_OPTIONS_TX_HASH_SIGN = 1;
constants$c.TRANSACTION_OPTIONS_TX_GUARDED = 2;
constants$c.TRANSACTION_VERSION_DEFAULT = 1;
constants$c.TRANSACTION_VERSION_WITH_OPTIONS = 2;
constants$c.ESDT_TRANSFER_GAS_LIMIT = 5e5;
constants$c.ESDT_TRANSFER_FUNCTION_NAME = "ESDTTransfer";
constants$c.ESDTNFT_TRANSFER_FUNCTION_NAME = "ESDTNFTTransfer";
constants$c.MULTI_ESDTNFT_TRANSFER_FUNCTION_NAME = "MultiESDTNFTTransfer";
constants$c.ESDT_TRANSFER_VALUE = "0";
constants$c.ARGUMENTS_SEPARATOR = "@";
var __createBinding$j = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$j = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$j = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$j(e, r, s);
  return __setModuleDefault$j(e, r), e;
};
Object.defineProperty(networkParams, "__esModule", { value: !0 });
networkParams.TransactionOptions = networkParams.TransactionVersion = void 0;
const constants_1$d = constants$c, errors$n = __importStar$j(errors$q);
class TransactionVersion {
  constructor(e) {
    if (e = Number(e), e < 1)
      throw new errors$n.ErrTransactionVersionInvalid(e);
    this.value = e;
  }
  static withDefaultVersion() {
    return new TransactionVersion(constants_1$d.TRANSACTION_VERSION_DEFAULT);
  }
  static withTxOptions() {
    return new TransactionVersion(constants_1$d.TRANSACTION_VERSION_WITH_OPTIONS);
  }
  valueOf() {
    return this.value;
  }
}
networkParams.TransactionVersion = TransactionVersion;
class TransactionOptions {
  constructor(e) {
    if (e = Number(e), e < 0)
      throw new errors$n.ErrTransactionOptionsInvalid(e);
    this.value = e;
  }
  static withDefaultOptions() {
    return new TransactionOptions(constants_1$d.TRANSACTION_OPTIONS_DEFAULT);
  }
  static withOptions(e) {
    let s = 0;
    return e.hashSign && (s |= constants_1$d.TRANSACTION_OPTIONS_TX_HASH_SIGN), e.guarded && (s |= constants_1$d.TRANSACTION_OPTIONS_TX_GUARDED), new TransactionOptions(s);
  }
  isWithHashSign() {
    return (this.value & constants_1$d.TRANSACTION_OPTIONS_TX_HASH_SIGN) == constants_1$d.TRANSACTION_OPTIONS_TX_HASH_SIGN;
  }
  isWithGuardian() {
    return (this.value & constants_1$d.TRANSACTION_OPTIONS_TX_GUARDED) == constants_1$d.TRANSACTION_OPTIONS_TX_GUARDED;
  }
  setWithHashSign() {
    this.value |= constants_1$d.TRANSACTION_OPTIONS_TX_HASH_SIGN;
  }
  setWithGuardian() {
    this.value |= constants_1$d.TRANSACTION_OPTIONS_TX_GUARDED;
  }
  valueOf() {
    return this.value;
  }
}
networkParams.TransactionOptions = TransactionOptions;
var relayedTransactionV1Builder = {};
const require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(bignumber);
var transaction = {}, compatibility = {};
Object.defineProperty(compatibility, "__esModule", { value: !0 });
compatibility.Compatibility = void 0;
const address_1$g = address$2;
class Compatibility {
  static guardAddressIsSetAndNonZero(e, s, o) {
    !this.areWarningsEnabled || (!e || e.bech32() == "" ? console.warn(`${s}: address should be set; ${o}. In the future, this will throw an exception instead of emitting a WARN.`) : e.bech32() == address_1$g.Address.Zero().bech32() && console.warn(`${s}: address should not be the 'zero' address (also known as the 'contracts deployment address'); ${o}. In the future, this will throw an exception instead of emitting a WARN.`));
  }
}
compatibility.Compatibility = Compatibility;
Compatibility.areWarningsEnabled = !0;
var hash$1 = {}, __createBinding$i = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$i = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$i = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$i(e, r, s);
  return __setModuleDefault$i(e, r), e;
};
Object.defineProperty(hash$1, "__esModule", { value: !0 });
hash$1.Hash = void 0;
const errors$m = __importStar$i(errors$q);
class Hash {
  constructor(e) {
    if (!e)
      this.hash = Buffer.from([]);
    else if (e instanceof Buffer)
      this.hash = e;
    else if (typeof e == "string")
      this.hash = Buffer.from(e, "hex");
    else
      throw new errors$m.ErrBadType("hash", "buffer | string", e);
  }
  static empty() {
    return new Hash(Buffer.from([]));
  }
  isEmpty() {
    return this.hash.length == 0;
  }
  toString() {
    return this.hex();
  }
  hex() {
    return this.hash.toString("hex");
  }
  valueOf() {
    return this.hash;
  }
}
hash$1.Hash = Hash;
var proto = {}, serializer = {}, utils$b = {}, utils_codec = {}, __importDefault$l = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(utils_codec, "__esModule", { value: !0 });
utils_codec.zeroPadStringIfOddLength = utils_codec.isPaddedHex = utils_codec.numberToPaddedHex = void 0;
const bignumber_js_1$j = __importDefault$l(require$$1$2);
function numberToPaddedHex$1(r) {
  let e = new bignumber_js_1$j.default(r).toString(16);
  return zeroPadStringIfOddLength$1(e);
}
utils_codec.numberToPaddedHex = numberToPaddedHex$1;
function isPaddedHex$1(r) {
  r = r || "";
  let e = Buffer.from(r, "hex").toString("hex");
  return r.toUpperCase() == e.toUpperCase();
}
utils_codec.isPaddedHex = isPaddedHex$1;
function zeroPadStringIfOddLength$1(r) {
  return r = r || "", r.length % 2 == 1 ? "0" + r : r;
}
utils_codec.zeroPadStringIfOddLength = zeroPadStringIfOddLength$1;
var __importDefault$k = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(utils$b, "__esModule", { value: !0 });
utils$b.prependByteToBuffer = utils$b.flipBufferBitsInPlace = utils$b.getHexMagnitudeOfBigInt = utils$b.bigIntToBuffer = utils$b.bufferToBigInt = utils$b.cloneBuffer = utils$b.isMsbZero = utils$b.isMsbOne = void 0;
const bignumber_js_1$i = __importDefault$k(require$$1$2), utils_codec_1 = utils_codec;
function isMsbOne(r, e = 0) {
  return r[e] >> 7 == 1;
}
utils$b.isMsbOne = isMsbOne;
function isMsbZero(r, e = 0) {
  return !isMsbOne(r, e);
}
utils$b.isMsbZero = isMsbZero;
function cloneBuffer(r) {
  let e = Buffer.alloc(r.length);
  return r.copy(e), e;
}
utils$b.cloneBuffer = cloneBuffer;
function bufferToBigInt$1(r) {
  let e = r.toString("hex");
  return new bignumber_js_1$i.default(`0x${e}`, 16);
}
utils$b.bufferToBigInt = bufferToBigInt$1;
function bigIntToBuffer$1(r) {
  let e = getHexMagnitudeOfBigInt(r);
  return Buffer.from(e, "hex");
}
utils$b.bigIntToBuffer = bigIntToBuffer$1;
function getHexMagnitudeOfBigInt(r) {
  return r = new bignumber_js_1$i.default(r), r ? (r.isNegative() && (r = r.multipliedBy(new bignumber_js_1$i.default(-1))), utils_codec_1.numberToPaddedHex(r)) : "";
}
utils$b.getHexMagnitudeOfBigInt = getHexMagnitudeOfBigInt;
function flipBufferBitsInPlace(r) {
  for (let e = 0; e < r.length; e++)
    r[e] = ~r[e];
}
utils$b.flipBufferBitsInPlace = flipBufferBitsInPlace;
function prependByteToBuffer(r, e) {
  return Buffer.concat([Buffer.from([e]), r]);
}
utils$b.prependByteToBuffer = prependByteToBuffer;
var minimal$1 = { exports: {} }, indexMinimal = {}, minimal = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise)
    return aspromise;
  hasRequiredAspromise = 1, aspromise = r;
  function r(e, s) {
    for (var o = new Array(arguments.length - 1), fe = 0, me = 2, ye = !0; me < arguments.length; )
      o[fe++] = arguments[me++];
    return new Promise(function(Er, br) {
      o[fe] = function(kr) {
        if (ye)
          if (ye = !1, kr)
            br(kr);
          else {
            for (var Gr = new Array(arguments.length - 1), Vr = 0; Vr < Gr.length; )
              Gr[Vr++] = arguments[Vr];
            Er.apply(null, Gr);
          }
      };
      try {
        e.apply(s || null, o);
      } catch (wr) {
        ye && (ye = !1, br(wr));
      }
    });
  }
  return aspromise;
}
var base64$2 = {}, hasRequiredBase64;
function requireBase64() {
  return hasRequiredBase64 || (hasRequiredBase64 = 1, function(r) {
    var e = r;
    e.length = function(fr) {
      var Er = fr.length;
      if (!Er)
        return 0;
      for (var br = 0; --Er % 4 > 1 && fr.charAt(Er) === "="; )
        ++br;
      return Math.ceil(fr.length * 3) / 4 - br;
    };
    for (var s = new Array(64), o = new Array(123), fe = 0; fe < 64; )
      o[s[fe] = fe < 26 ? fe + 65 : fe < 52 ? fe + 71 : fe < 62 ? fe - 4 : fe - 59 | 43] = fe++;
    e.encode = function(fr, Er, br) {
      for (var wr = null, kr = [], Gr = 0, Vr = 0, jr; Er < br; ) {
        var Kr = fr[Er++];
        switch (Vr) {
          case 0:
            kr[Gr++] = s[Kr >> 2], jr = (Kr & 3) << 4, Vr = 1;
            break;
          case 1:
            kr[Gr++] = s[jr | Kr >> 4], jr = (Kr & 15) << 2, Vr = 2;
            break;
          case 2:
            kr[Gr++] = s[jr | Kr >> 6], kr[Gr++] = s[Kr & 63], Vr = 0;
            break;
        }
        Gr > 8191 && ((wr || (wr = [])).push(String.fromCharCode.apply(String, kr)), Gr = 0);
      }
      return Vr && (kr[Gr++] = s[jr], kr[Gr++] = 61, Vr === 1 && (kr[Gr++] = 61)), wr ? (Gr && wr.push(String.fromCharCode.apply(String, kr.slice(0, Gr))), wr.join("")) : String.fromCharCode.apply(String, kr.slice(0, Gr));
    };
    var me = "invalid encoding";
    e.decode = function(fr, Er, br) {
      for (var wr = br, kr = 0, Gr, Vr = 0; Vr < fr.length; ) {
        var jr = fr.charCodeAt(Vr++);
        if (jr === 61 && kr > 1)
          break;
        if ((jr = o[jr]) === void 0)
          throw Error(me);
        switch (kr) {
          case 0:
            Gr = jr, kr = 1;
            break;
          case 1:
            Er[br++] = Gr << 2 | (jr & 48) >> 4, Gr = jr, kr = 2;
            break;
          case 2:
            Er[br++] = (Gr & 15) << 4 | (jr & 60) >> 2, Gr = jr, kr = 3;
            break;
          case 3:
            Er[br++] = (Gr & 3) << 6 | jr, kr = 0;
            break;
        }
      }
      if (kr === 1)
        throw Error(me);
      return br - wr;
    }, e.test = function(fr) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(fr);
    };
  }(base64$2)), base64$2;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter)
    return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = r;
  function r() {
    this._listeners = {};
  }
  return r.prototype.on = function(s, o, fe) {
    return (this._listeners[s] || (this._listeners[s] = [])).push({
      fn: o,
      ctx: fe || this
    }), this;
  }, r.prototype.off = function(s, o) {
    if (s === void 0)
      this._listeners = {};
    else if (o === void 0)
      this._listeners[s] = [];
    else
      for (var fe = this._listeners[s], me = 0; me < fe.length; )
        fe[me].fn === o ? fe.splice(me, 1) : ++me;
    return this;
  }, r.prototype.emit = function(s) {
    var o = this._listeners[s];
    if (o) {
      for (var fe = [], me = 1; me < arguments.length; )
        fe.push(arguments[me++]);
      for (me = 0; me < o.length; )
        o[me].fn.apply(o[me++].ctx, fe);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat)
    return float;
  hasRequiredFloat = 1, float = r(r);
  function r(me) {
    return typeof Float32Array < "u" ? function() {
      var ye = new Float32Array([-0]), fr = new Uint8Array(ye.buffer), Er = fr[3] === 128;
      function br(Vr, jr, Kr) {
        ye[0] = Vr, jr[Kr] = fr[0], jr[Kr + 1] = fr[1], jr[Kr + 2] = fr[2], jr[Kr + 3] = fr[3];
      }
      function wr(Vr, jr, Kr) {
        ye[0] = Vr, jr[Kr] = fr[3], jr[Kr + 1] = fr[2], jr[Kr + 2] = fr[1], jr[Kr + 3] = fr[0];
      }
      me.writeFloatLE = Er ? br : wr, me.writeFloatBE = Er ? wr : br;
      function kr(Vr, jr) {
        return fr[0] = Vr[jr], fr[1] = Vr[jr + 1], fr[2] = Vr[jr + 2], fr[3] = Vr[jr + 3], ye[0];
      }
      function Gr(Vr, jr) {
        return fr[3] = Vr[jr], fr[2] = Vr[jr + 1], fr[1] = Vr[jr + 2], fr[0] = Vr[jr + 3], ye[0];
      }
      me.readFloatLE = Er ? kr : Gr, me.readFloatBE = Er ? Gr : kr;
    }() : function() {
      function ye(Er, br, wr, kr) {
        var Gr = br < 0 ? 1 : 0;
        if (Gr && (br = -br), br === 0)
          Er(1 / br > 0 ? 0 : 2147483648, wr, kr);
        else if (isNaN(br))
          Er(2143289344, wr, kr);
        else if (br > 34028234663852886e22)
          Er((Gr << 31 | 2139095040) >>> 0, wr, kr);
        else if (br < 11754943508222875e-54)
          Er((Gr << 31 | Math.round(br / 1401298464324817e-60)) >>> 0, wr, kr);
        else {
          var Vr = Math.floor(Math.log(br) / Math.LN2), jr = Math.round(br * Math.pow(2, -Vr) * 8388608) & 8388607;
          Er((Gr << 31 | Vr + 127 << 23 | jr) >>> 0, wr, kr);
        }
      }
      me.writeFloatLE = ye.bind(null, e), me.writeFloatBE = ye.bind(null, s);
      function fr(Er, br, wr) {
        var kr = Er(br, wr), Gr = (kr >> 31) * 2 + 1, Vr = kr >>> 23 & 255, jr = kr & 8388607;
        return Vr === 255 ? jr ? NaN : Gr * (1 / 0) : Vr === 0 ? Gr * 1401298464324817e-60 * jr : Gr * Math.pow(2, Vr - 150) * (jr + 8388608);
      }
      me.readFloatLE = fr.bind(null, o), me.readFloatBE = fr.bind(null, fe);
    }(), typeof Float64Array < "u" ? function() {
      var ye = new Float64Array([-0]), fr = new Uint8Array(ye.buffer), Er = fr[7] === 128;
      function br(Vr, jr, Kr) {
        ye[0] = Vr, jr[Kr] = fr[0], jr[Kr + 1] = fr[1], jr[Kr + 2] = fr[2], jr[Kr + 3] = fr[3], jr[Kr + 4] = fr[4], jr[Kr + 5] = fr[5], jr[Kr + 6] = fr[6], jr[Kr + 7] = fr[7];
      }
      function wr(Vr, jr, Kr) {
        ye[0] = Vr, jr[Kr] = fr[7], jr[Kr + 1] = fr[6], jr[Kr + 2] = fr[5], jr[Kr + 3] = fr[4], jr[Kr + 4] = fr[3], jr[Kr + 5] = fr[2], jr[Kr + 6] = fr[1], jr[Kr + 7] = fr[0];
      }
      me.writeDoubleLE = Er ? br : wr, me.writeDoubleBE = Er ? wr : br;
      function kr(Vr, jr) {
        return fr[0] = Vr[jr], fr[1] = Vr[jr + 1], fr[2] = Vr[jr + 2], fr[3] = Vr[jr + 3], fr[4] = Vr[jr + 4], fr[5] = Vr[jr + 5], fr[6] = Vr[jr + 6], fr[7] = Vr[jr + 7], ye[0];
      }
      function Gr(Vr, jr) {
        return fr[7] = Vr[jr], fr[6] = Vr[jr + 1], fr[5] = Vr[jr + 2], fr[4] = Vr[jr + 3], fr[3] = Vr[jr + 4], fr[2] = Vr[jr + 5], fr[1] = Vr[jr + 6], fr[0] = Vr[jr + 7], ye[0];
      }
      me.readDoubleLE = Er ? kr : Gr, me.readDoubleBE = Er ? Gr : kr;
    }() : function() {
      function ye(Er, br, wr, kr, Gr, Vr) {
        var jr = kr < 0 ? 1 : 0;
        if (jr && (kr = -kr), kr === 0)
          Er(0, Gr, Vr + br), Er(1 / kr > 0 ? 0 : 2147483648, Gr, Vr + wr);
        else if (isNaN(kr))
          Er(0, Gr, Vr + br), Er(2146959360, Gr, Vr + wr);
        else if (kr > 17976931348623157e292)
          Er(0, Gr, Vr + br), Er((jr << 31 | 2146435072) >>> 0, Gr, Vr + wr);
        else {
          var Kr;
          if (kr < 22250738585072014e-324)
            Kr = kr / 5e-324, Er(Kr >>> 0, Gr, Vr + br), Er((jr << 31 | Kr / 4294967296) >>> 0, Gr, Vr + wr);
          else {
            var bn = Math.floor(Math.log(kr) / Math.LN2);
            bn === 1024 && (bn = 1023), Kr = kr * Math.pow(2, -bn), Er(Kr * 4503599627370496 >>> 0, Gr, Vr + br), Er((jr << 31 | bn + 1023 << 20 | Kr * 1048576 & 1048575) >>> 0, Gr, Vr + wr);
          }
        }
      }
      me.writeDoubleLE = ye.bind(null, e, 0, 4), me.writeDoubleBE = ye.bind(null, s, 4, 0);
      function fr(Er, br, wr, kr, Gr) {
        var Vr = Er(kr, Gr + br), jr = Er(kr, Gr + wr), Kr = (jr >> 31) * 2 + 1, bn = jr >>> 20 & 2047, Yr = 4294967296 * (jr & 1048575) + Vr;
        return bn === 2047 ? Yr ? NaN : Kr * (1 / 0) : bn === 0 ? Kr * 5e-324 * Yr : Kr * Math.pow(2, bn - 1075) * (Yr + 4503599627370496);
      }
      me.readDoubleLE = fr.bind(null, o, 0, 4), me.readDoubleBE = fr.bind(null, fe, 4, 0);
    }(), me;
  }
  function e(me, ye, fr) {
    ye[fr] = me & 255, ye[fr + 1] = me >>> 8 & 255, ye[fr + 2] = me >>> 16 & 255, ye[fr + 3] = me >>> 24;
  }
  function s(me, ye, fr) {
    ye[fr] = me >>> 24, ye[fr + 1] = me >>> 16 & 255, ye[fr + 2] = me >>> 8 & 255, ye[fr + 3] = me & 255;
  }
  function o(me, ye) {
    return (me[ye] | me[ye + 1] << 8 | me[ye + 2] << 16 | me[ye + 3] << 24) >>> 0;
  }
  function fe(me, ye) {
    return (me[ye] << 24 | me[ye + 1] << 16 | me[ye + 2] << 8 | me[ye + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire)
    return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (r) {
    }
    return null;
  }
  return inquire_1;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  return hasRequiredUtf8 || (hasRequiredUtf8 = 1, function(r) {
    var e = r;
    e.length = function(o) {
      for (var fe = 0, me = 0, ye = 0; ye < o.length; ++ye)
        me = o.charCodeAt(ye), me < 128 ? fe += 1 : me < 2048 ? fe += 2 : (me & 64512) === 55296 && (o.charCodeAt(ye + 1) & 64512) === 56320 ? (++ye, fe += 4) : fe += 3;
      return fe;
    }, e.read = function(o, fe, me) {
      var ye = me - fe;
      if (ye < 1)
        return "";
      for (var fr = null, Er = [], br = 0, wr; fe < me; )
        wr = o[fe++], wr < 128 ? Er[br++] = wr : wr > 191 && wr < 224 ? Er[br++] = (wr & 31) << 6 | o[fe++] & 63 : wr > 239 && wr < 365 ? (wr = ((wr & 7) << 18 | (o[fe++] & 63) << 12 | (o[fe++] & 63) << 6 | o[fe++] & 63) - 65536, Er[br++] = 55296 + (wr >> 10), Er[br++] = 56320 + (wr & 1023)) : Er[br++] = (wr & 15) << 12 | (o[fe++] & 63) << 6 | o[fe++] & 63, br > 8191 && ((fr || (fr = [])).push(String.fromCharCode.apply(String, Er)), br = 0);
      return fr ? (br && fr.push(String.fromCharCode.apply(String, Er.slice(0, br))), fr.join("")) : String.fromCharCode.apply(String, Er.slice(0, br));
    }, e.write = function(o, fe, me) {
      for (var ye = me, fr, Er, br = 0; br < o.length; ++br)
        fr = o.charCodeAt(br), fr < 128 ? fe[me++] = fr : fr < 2048 ? (fe[me++] = fr >> 6 | 192, fe[me++] = fr & 63 | 128) : (fr & 64512) === 55296 && ((Er = o.charCodeAt(br + 1)) & 64512) === 56320 ? (fr = 65536 + ((fr & 1023) << 10) + (Er & 1023), ++br, fe[me++] = fr >> 18 | 240, fe[me++] = fr >> 12 & 63 | 128, fe[me++] = fr >> 6 & 63 | 128, fe[me++] = fr & 63 | 128) : (fe[me++] = fr >> 12 | 224, fe[me++] = fr >> 6 & 63 | 128, fe[me++] = fr & 63 | 128);
      return me - ye;
    };
  }(utf8)), utf8;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool)
    return pool_1;
  hasRequiredPool = 1, pool_1 = r;
  function r(e, s, o) {
    var fe = o || 8192, me = fe >>> 1, ye = null, fr = fe;
    return function(br) {
      if (br < 1 || br > me)
        return e(br);
      fr + br > fe && (ye = e(fe), fr = 0);
      var wr = s.call(ye, fr, fr += br);
      return fr & 7 && (fr = (fr | 7) + 1), wr;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = e;
  var r = requireMinimal$1();
  function e(me, ye) {
    this.lo = me >>> 0, this.hi = ye >>> 0;
  }
  var s = e.zero = new e(0, 0);
  s.toNumber = function() {
    return 0;
  }, s.zzEncode = s.zzDecode = function() {
    return this;
  }, s.length = function() {
    return 1;
  };
  var o = e.zeroHash = "\0\0\0\0\0\0\0\0";
  e.fromNumber = function(ye) {
    if (ye === 0)
      return s;
    var fr = ye < 0;
    fr && (ye = -ye);
    var Er = ye >>> 0, br = (ye - Er) / 4294967296 >>> 0;
    return fr && (br = ~br >>> 0, Er = ~Er >>> 0, ++Er > 4294967295 && (Er = 0, ++br > 4294967295 && (br = 0))), new e(Er, br);
  }, e.from = function(ye) {
    if (typeof ye == "number")
      return e.fromNumber(ye);
    if (r.isString(ye))
      if (r.Long)
        ye = r.Long.fromString(ye);
      else
        return e.fromNumber(parseInt(ye, 10));
    return ye.low || ye.high ? new e(ye.low >>> 0, ye.high >>> 0) : s;
  }, e.prototype.toNumber = function(ye) {
    if (!ye && this.hi >>> 31) {
      var fr = ~this.lo + 1 >>> 0, Er = ~this.hi >>> 0;
      return fr || (Er = Er + 1 >>> 0), -(fr + Er * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, e.prototype.toLong = function(ye) {
    return r.Long ? new r.Long(this.lo | 0, this.hi | 0, Boolean(ye)) : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(ye) };
  };
  var fe = String.prototype.charCodeAt;
  return e.fromHash = function(ye) {
    return ye === o ? s : new e(
      (fe.call(ye, 0) | fe.call(ye, 1) << 8 | fe.call(ye, 2) << 16 | fe.call(ye, 3) << 24) >>> 0,
      (fe.call(ye, 4) | fe.call(ye, 5) << 8 | fe.call(ye, 6) << 16 | fe.call(ye, 7) << 24) >>> 0
    );
  }, e.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, e.prototype.zzEncode = function() {
    var ye = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ ye) >>> 0, this.lo = (this.lo << 1 ^ ye) >>> 0, this;
  }, e.prototype.zzDecode = function() {
    var ye = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ ye) >>> 0, this.hi = (this.hi >>> 1 ^ ye) >>> 0, this;
  }, e.prototype.length = function() {
    var ye = this.lo, fr = (this.lo >>> 28 | this.hi << 4) >>> 0, Er = this.hi >>> 24;
    return Er === 0 ? fr === 0 ? ye < 16384 ? ye < 128 ? 1 : 2 : ye < 2097152 ? 3 : 4 : fr < 16384 ? fr < 128 ? 5 : 6 : fr < 2097152 ? 7 : 8 : Er < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, function(r) {
    var e = r;
    e.asPromise = requireAspromise(), e.base64 = requireBase64(), e.EventEmitter = requireEventemitter(), e.float = requireFloat(), e.inquire = requireInquire(), e.utf8 = requireUtf8(), e.pool = requirePool(), e.LongBits = requireLongbits(), e.isNode = Boolean(typeof globalThis < "u" && globalThis && globalThis.process && globalThis.process.versions && globalThis.process.versions.node), e.global = e.isNode && globalThis || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, e.emptyArray = Object.freeze ? Object.freeze([]) : [], e.emptyObject = Object.freeze ? Object.freeze({}) : {}, e.isInteger = Number.isInteger || function(me) {
      return typeof me == "number" && isFinite(me) && Math.floor(me) === me;
    }, e.isString = function(me) {
      return typeof me == "string" || me instanceof String;
    }, e.isObject = function(me) {
      return me && typeof me == "object";
    }, e.isset = e.isSet = function(me, ye) {
      var fr = me[ye];
      return fr != null && me.hasOwnProperty(ye) ? typeof fr != "object" || (Array.isArray(fr) ? fr.length : Object.keys(fr).length) > 0 : !1;
    }, e.Buffer = function() {
      try {
        var fe = e.inquire("buffer").Buffer;
        return fe.prototype.utf8Write ? fe : null;
      } catch {
        return null;
      }
    }(), e._Buffer_from = null, e._Buffer_allocUnsafe = null, e.newBuffer = function(me) {
      return typeof me == "number" ? e.Buffer ? e._Buffer_allocUnsafe(me) : new e.Array(me) : e.Buffer ? e._Buffer_from(me) : typeof Uint8Array > "u" ? me : new Uint8Array(me);
    }, e.Array = typeof Uint8Array < "u" ? Uint8Array : Array, e.Long = e.global.dcodeIO && e.global.dcodeIO.Long || e.global.Long || e.inquire("long"), e.key2Re = /^true|false|0|1$/, e.key32Re = /^-?(?:0|[1-9][0-9]*)$/, e.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, e.longToHash = function(me) {
      return me ? e.LongBits.from(me).toHash() : e.LongBits.zeroHash;
    }, e.longFromHash = function(me, ye) {
      var fr = e.LongBits.fromHash(me);
      return e.Long ? e.Long.fromBits(fr.lo, fr.hi, ye) : fr.toNumber(Boolean(ye));
    };
    function s(fe, me, ye) {
      for (var fr = Object.keys(me), Er = 0; Er < fr.length; ++Er)
        (fe[fr[Er]] === void 0 || !ye) && (fe[fr[Er]] = me[fr[Er]]);
      return fe;
    }
    e.merge = s, e.lcFirst = function(me) {
      return me.charAt(0).toLowerCase() + me.substring(1);
    };
    function o(fe) {
      function me(ye, fr) {
        if (!(this instanceof me))
          return new me(ye, fr);
        Object.defineProperty(this, "message", { get: function() {
          return ye;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, me) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), fr && s(this, fr);
      }
      return me.prototype = Object.create(Error.prototype, {
        constructor: {
          value: me,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return fe;
          },
          set: void 0,
          enumerable: !1,
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), me;
    }
    e.newError = o, e.ProtocolError = o("ProtocolError"), e.oneOfGetter = function(me) {
      for (var ye = {}, fr = 0; fr < me.length; ++fr)
        ye[me[fr]] = 1;
      return function() {
        for (var Er = Object.keys(this), br = Er.length - 1; br > -1; --br)
          if (ye[Er[br]] === 1 && this[Er[br]] !== void 0 && this[Er[br]] !== null)
            return Er[br];
      };
    }, e.oneOfSetter = function(me) {
      return function(ye) {
        for (var fr = 0; fr < me.length; ++fr)
          me[fr] !== ye && delete this[me[fr]];
      };
    }, e.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, e._configure = function() {
      var fe = e.Buffer;
      if (!fe) {
        e._Buffer_from = e._Buffer_allocUnsafe = null;
        return;
      }
      e._Buffer_from = fe.from !== Uint8Array.from && fe.from || function(ye, fr) {
        return new fe(ye, fr);
      }, e._Buffer_allocUnsafe = fe.allocUnsafe || function(ye) {
        return new fe(ye);
      };
    };
  }(minimal)), minimal;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter)
    return writer;
  hasRequiredWriter = 1, writer = Er;
  var r = requireMinimal$1(), e, s = r.LongBits, o = r.base64, fe = r.utf8;
  function me(bn, Yr, Zr) {
    this.fn = bn, this.len = Yr, this.next = void 0, this.val = Zr;
  }
  function ye() {
  }
  function fr(bn) {
    this.head = bn.head, this.tail = bn.tail, this.len = bn.len, this.next = bn.states;
  }
  function Er() {
    this.len = 0, this.head = new me(ye, 0, 0), this.tail = this.head, this.states = null;
  }
  var br = function() {
    return r.Buffer ? function() {
      return (Er.create = function() {
        return new e();
      })();
    } : function() {
      return new Er();
    };
  };
  Er.create = br(), Er.alloc = function(Yr) {
    return new r.Array(Yr);
  }, r.Array !== Array && (Er.alloc = r.pool(Er.alloc, r.Array.prototype.subarray)), Er.prototype._push = function(Yr, Zr, ti) {
    return this.tail = this.tail.next = new me(Yr, Zr, ti), this.len += Zr, this;
  };
  function wr(bn, Yr, Zr) {
    Yr[Zr] = bn & 255;
  }
  function kr(bn, Yr, Zr) {
    for (; bn > 127; )
      Yr[Zr++] = bn & 127 | 128, bn >>>= 7;
    Yr[Zr] = bn;
  }
  function Gr(bn, Yr) {
    this.len = bn, this.next = void 0, this.val = Yr;
  }
  Gr.prototype = Object.create(me.prototype), Gr.prototype.fn = kr, Er.prototype.uint32 = function(Yr) {
    return this.len += (this.tail = this.tail.next = new Gr(
      (Yr = Yr >>> 0) < 128 ? 1 : Yr < 16384 ? 2 : Yr < 2097152 ? 3 : Yr < 268435456 ? 4 : 5,
      Yr
    )).len, this;
  }, Er.prototype.int32 = function(Yr) {
    return Yr < 0 ? this._push(Vr, 10, s.fromNumber(Yr)) : this.uint32(Yr);
  }, Er.prototype.sint32 = function(Yr) {
    return this.uint32((Yr << 1 ^ Yr >> 31) >>> 0);
  };
  function Vr(bn, Yr, Zr) {
    for (; bn.hi; )
      Yr[Zr++] = bn.lo & 127 | 128, bn.lo = (bn.lo >>> 7 | bn.hi << 25) >>> 0, bn.hi >>>= 7;
    for (; bn.lo > 127; )
      Yr[Zr++] = bn.lo & 127 | 128, bn.lo = bn.lo >>> 7;
    Yr[Zr++] = bn.lo;
  }
  Er.prototype.uint64 = function(Yr) {
    var Zr = s.from(Yr);
    return this._push(Vr, Zr.length(), Zr);
  }, Er.prototype.int64 = Er.prototype.uint64, Er.prototype.sint64 = function(Yr) {
    var Zr = s.from(Yr).zzEncode();
    return this._push(Vr, Zr.length(), Zr);
  }, Er.prototype.bool = function(Yr) {
    return this._push(wr, 1, Yr ? 1 : 0);
  };
  function jr(bn, Yr, Zr) {
    Yr[Zr] = bn & 255, Yr[Zr + 1] = bn >>> 8 & 255, Yr[Zr + 2] = bn >>> 16 & 255, Yr[Zr + 3] = bn >>> 24;
  }
  Er.prototype.fixed32 = function(Yr) {
    return this._push(jr, 4, Yr >>> 0);
  }, Er.prototype.sfixed32 = Er.prototype.fixed32, Er.prototype.fixed64 = function(Yr) {
    var Zr = s.from(Yr);
    return this._push(jr, 4, Zr.lo)._push(jr, 4, Zr.hi);
  }, Er.prototype.sfixed64 = Er.prototype.fixed64, Er.prototype.float = function(Yr) {
    return this._push(r.float.writeFloatLE, 4, Yr);
  }, Er.prototype.double = function(Yr) {
    return this._push(r.float.writeDoubleLE, 8, Yr);
  };
  var Kr = r.Array.prototype.set ? function(Yr, Zr, ti) {
    Zr.set(Yr, ti);
  } : function(Yr, Zr, ti) {
    for (var On = 0; On < Yr.length; ++On)
      Zr[ti + On] = Yr[On];
  };
  return Er.prototype.bytes = function(Yr) {
    var Zr = Yr.length >>> 0;
    if (!Zr)
      return this._push(wr, 1, 0);
    if (r.isString(Yr)) {
      var ti = Er.alloc(Zr = o.length(Yr));
      o.decode(Yr, ti, 0), Yr = ti;
    }
    return this.uint32(Zr)._push(Kr, Zr, Yr);
  }, Er.prototype.string = function(Yr) {
    var Zr = fe.length(Yr);
    return Zr ? this.uint32(Zr)._push(fe.write, Zr, Yr) : this._push(wr, 1, 0);
  }, Er.prototype.fork = function() {
    return this.states = new fr(this), this.head = this.tail = new me(ye, 0, 0), this.len = 0, this;
  }, Er.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new me(ye, 0, 0), this.len = 0), this;
  }, Er.prototype.ldelim = function() {
    var Yr = this.head, Zr = this.tail, ti = this.len;
    return this.reset().uint32(ti), ti && (this.tail.next = Yr.next, this.tail = Zr, this.len += ti), this;
  }, Er.prototype.finish = function() {
    for (var Yr = this.head.next, Zr = this.constructor.alloc(this.len), ti = 0; Yr; )
      Yr.fn(Yr.val, Zr, ti), ti += Yr.len, Yr = Yr.next;
    return Zr;
  }, Er._configure = function(bn) {
    e = bn, Er.create = br(), e._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer)
    return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = s;
  var r = requireWriter();
  (s.prototype = Object.create(r.prototype)).constructor = s;
  var e = requireMinimal$1();
  function s() {
    r.call(this);
  }
  s._configure = function() {
    s.alloc = e._Buffer_allocUnsafe, s.writeBytesBuffer = e.Buffer && e.Buffer.prototype instanceof Uint8Array && e.Buffer.prototype.set.name === "set" ? function(me, ye, fr) {
      ye.set(me, fr);
    } : function(me, ye, fr) {
      if (me.copy)
        me.copy(ye, fr, 0, me.length);
      else
        for (var Er = 0; Er < me.length; )
          ye[fr++] = me[Er++];
    };
  }, s.prototype.bytes = function(me) {
    e.isString(me) && (me = e._Buffer_from(me, "base64"));
    var ye = me.length >>> 0;
    return this.uint32(ye), ye && this._push(s.writeBytesBuffer, ye, me), this;
  };
  function o(fe, me, ye) {
    fe.length < 40 ? e.utf8.write(fe, me, ye) : me.utf8Write ? me.utf8Write(fe, ye) : me.write(fe, ye);
  }
  return s.prototype.string = function(me) {
    var ye = e.Buffer.byteLength(me);
    return this.uint32(ye), ye && this._push(o, ye, me), this;
  }, s._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader)
    return reader;
  hasRequiredReader = 1, reader = me;
  var r = requireMinimal$1(), e, s = r.LongBits, o = r.utf8;
  function fe(kr, Gr) {
    return RangeError("index out of range: " + kr.pos + " + " + (Gr || 1) + " > " + kr.len);
  }
  function me(kr) {
    this.buf = kr, this.pos = 0, this.len = kr.length;
  }
  var ye = typeof Uint8Array < "u" ? function(Gr) {
    if (Gr instanceof Uint8Array || Array.isArray(Gr))
      return new me(Gr);
    throw Error("illegal buffer");
  } : function(Gr) {
    if (Array.isArray(Gr))
      return new me(Gr);
    throw Error("illegal buffer");
  }, fr = function() {
    return r.Buffer ? function(Vr) {
      return (me.create = function(Kr) {
        return r.Buffer.isBuffer(Kr) ? new e(Kr) : ye(Kr);
      })(Vr);
    } : ye;
  };
  me.create = fr(), me.prototype._slice = r.Array.prototype.subarray || r.Array.prototype.slice, me.prototype.uint32 = function() {
    var Gr = 4294967295;
    return function() {
      if (Gr = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (Gr = (Gr | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (Gr = (Gr | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (Gr = (Gr | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (Gr = (Gr | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
        return Gr;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, fe(this, 10);
      return Gr;
    };
  }(), me.prototype.int32 = function() {
    return this.uint32() | 0;
  }, me.prototype.sint32 = function() {
    var Gr = this.uint32();
    return Gr >>> 1 ^ -(Gr & 1) | 0;
  };
  function Er() {
    var kr = new s(0, 0), Gr = 0;
    if (this.len - this.pos > 4) {
      for (; Gr < 4; ++Gr)
        if (kr.lo = (kr.lo | (this.buf[this.pos] & 127) << Gr * 7) >>> 0, this.buf[this.pos++] < 128)
          return kr;
      if (kr.lo = (kr.lo | (this.buf[this.pos] & 127) << 28) >>> 0, kr.hi = (kr.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return kr;
      Gr = 0;
    } else {
      for (; Gr < 3; ++Gr) {
        if (this.pos >= this.len)
          throw fe(this);
        if (kr.lo = (kr.lo | (this.buf[this.pos] & 127) << Gr * 7) >>> 0, this.buf[this.pos++] < 128)
          return kr;
      }
      return kr.lo = (kr.lo | (this.buf[this.pos++] & 127) << Gr * 7) >>> 0, kr;
    }
    if (this.len - this.pos > 4) {
      for (; Gr < 5; ++Gr)
        if (kr.hi = (kr.hi | (this.buf[this.pos] & 127) << Gr * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return kr;
    } else
      for (; Gr < 5; ++Gr) {
        if (this.pos >= this.len)
          throw fe(this);
        if (kr.hi = (kr.hi | (this.buf[this.pos] & 127) << Gr * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return kr;
      }
    throw Error("invalid varint encoding");
  }
  me.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function br(kr, Gr) {
    return (kr[Gr - 4] | kr[Gr - 3] << 8 | kr[Gr - 2] << 16 | kr[Gr - 1] << 24) >>> 0;
  }
  me.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw fe(this, 4);
    return br(this.buf, this.pos += 4);
  }, me.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw fe(this, 4);
    return br(this.buf, this.pos += 4) | 0;
  };
  function wr() {
    if (this.pos + 8 > this.len)
      throw fe(this, 8);
    return new s(br(this.buf, this.pos += 4), br(this.buf, this.pos += 4));
  }
  return me.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw fe(this, 4);
    var Gr = r.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, Gr;
  }, me.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw fe(this, 4);
    var Gr = r.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, Gr;
  }, me.prototype.bytes = function() {
    var Gr = this.uint32(), Vr = this.pos, jr = this.pos + Gr;
    if (jr > this.len)
      throw fe(this, Gr);
    return this.pos += Gr, Array.isArray(this.buf) ? this.buf.slice(Vr, jr) : Vr === jr ? new this.buf.constructor(0) : this._slice.call(this.buf, Vr, jr);
  }, me.prototype.string = function() {
    var Gr = this.bytes();
    return o.read(Gr, 0, Gr.length);
  }, me.prototype.skip = function(Gr) {
    if (typeof Gr == "number") {
      if (this.pos + Gr > this.len)
        throw fe(this, Gr);
      this.pos += Gr;
    } else
      do
        if (this.pos >= this.len)
          throw fe(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, me.prototype.skipType = function(kr) {
    switch (kr) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (kr = this.uint32() & 7) !== 4; )
          this.skipType(kr);
        break;
      case 5:
        this.skip(4);
        break;
      default:
        throw Error("invalid wire type " + kr + " at offset " + this.pos);
    }
    return this;
  }, me._configure = function(kr) {
    e = kr, me.create = fr(), e._configure();
    var Gr = r.Long ? "toLong" : "toNumber";
    r.merge(me.prototype, {
      int64: function() {
        return Er.call(this)[Gr](!1);
      },
      uint64: function() {
        return Er.call(this)[Gr](!0);
      },
      sint64: function() {
        return Er.call(this).zzDecode()[Gr](!1);
      },
      fixed64: function() {
        return wr.call(this)[Gr](!0);
      },
      sfixed64: function() {
        return wr.call(this)[Gr](!1);
      }
    });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer)
    return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = s;
  var r = requireReader();
  (s.prototype = Object.create(r.prototype)).constructor = s;
  var e = requireMinimal$1();
  function s(o) {
    r.call(this, o);
  }
  return s._configure = function() {
    e.Buffer && (s.prototype._slice = e.Buffer.prototype.slice);
  }, s.prototype.string = function() {
    var fe = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + fe, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + fe, this.len));
  }, s._configure(), reader_buffer;
}
var rpc = {}, service, hasRequiredService;
function requireService() {
  if (hasRequiredService)
    return service;
  hasRequiredService = 1, service = e;
  var r = requireMinimal$1();
  (e.prototype = Object.create(r.EventEmitter.prototype)).constructor = e;
  function e(s, o, fe) {
    if (typeof s != "function")
      throw TypeError("rpcImpl must be a function");
    r.EventEmitter.call(this), this.rpcImpl = s, this.requestDelimited = Boolean(o), this.responseDelimited = Boolean(fe);
  }
  return e.prototype.rpcCall = function s(o, fe, me, ye, fr) {
    if (!ye)
      throw TypeError("request must be specified");
    var Er = this;
    if (!fr)
      return r.asPromise(s, Er, o, fe, me, ye);
    if (!Er.rpcImpl) {
      setTimeout(function() {
        fr(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return Er.rpcImpl(
        o,
        fe[Er.requestDelimited ? "encodeDelimited" : "encode"](ye).finish(),
        function(wr, kr) {
          if (wr)
            return Er.emit("error", wr, o), fr(wr);
          if (kr === null) {
            Er.end(!0);
            return;
          }
          if (!(kr instanceof me))
            try {
              kr = me[Er.responseDelimited ? "decodeDelimited" : "decode"](kr);
            } catch (Gr) {
              return Er.emit("error", Gr, o), fr(Gr);
            }
          return Er.emit("data", kr, o), fr(null, kr);
        }
      );
    } catch (br) {
      Er.emit("error", br, o), setTimeout(function() {
        fr(br);
      }, 0);
      return;
    }
  }, e.prototype.end = function(o) {
    return this.rpcImpl && (o || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, function(r) {
    var e = r;
    e.Service = requireService();
  }(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, function(r) {
    var e = r;
    e.build = "minimal", e.Writer = requireWriter(), e.BufferWriter = requireWriter_buffer(), e.Reader = requireReader(), e.BufferReader = requireReader_buffer(), e.util = requireMinimal$1(), e.rpc = requireRpc(), e.roots = requireRoots(), e.configure = s;
    function s() {
      e.util._configure(), e.Writer._configure(e.BufferWriter), e.Reader._configure(e.BufferReader);
    }
    s();
  }(indexMinimal)), indexMinimal;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(r) {
    r.exports = requireIndexMinimal();
  }(minimal$1)), minimal$1.exports;
}
var compiled, hasRequiredCompiled;
function requireCompiled() {
  if (hasRequiredCompiled)
    return compiled;
  hasRequiredCompiled = 1;
  var r = requireMinimal(), e = r.Reader, s = r.Writer, o = r.util, fe = r.roots.default || (r.roots.default = {});
  return fe.proto = function() {
    var me = {};
    return me.Transaction = function() {
      function ye(fr) {
        if (fr)
          for (var Er = Object.keys(fr), br = 0; br < Er.length; ++br)
            fr[Er[br]] != null && (this[Er[br]] = fr[Er[br]]);
      }
      return ye.prototype.Nonce = o.Long ? o.Long.fromBits(0, 0, !0) : 0, ye.prototype.Value = o.newBuffer([]), ye.prototype.RcvAddr = o.newBuffer([]), ye.prototype.RcvUserName = o.newBuffer([]), ye.prototype.SndAddr = o.newBuffer([]), ye.prototype.SndUserName = o.newBuffer([]), ye.prototype.GasPrice = o.Long ? o.Long.fromBits(0, 0, !0) : 0, ye.prototype.GasLimit = o.Long ? o.Long.fromBits(0, 0, !0) : 0, ye.prototype.Data = o.newBuffer([]), ye.prototype.ChainID = o.newBuffer([]), ye.prototype.Version = 0, ye.prototype.Signature = o.newBuffer([]), ye.prototype.Options = 0, ye.prototype.GuardAddr = o.newBuffer([]), ye.prototype.GuardSignature = o.newBuffer([]), ye.create = function(Er) {
        return new ye(Er);
      }, ye.encode = function(Er, br) {
        return br || (br = s.create()), Er.Nonce != null && Object.hasOwnProperty.call(Er, "Nonce") && br.uint32(8).uint64(Er.Nonce), Er.Value != null && Object.hasOwnProperty.call(Er, "Value") && br.uint32(18).bytes(Er.Value), Er.RcvAddr != null && Object.hasOwnProperty.call(Er, "RcvAddr") && br.uint32(26).bytes(Er.RcvAddr), Er.RcvUserName != null && Object.hasOwnProperty.call(Er, "RcvUserName") && br.uint32(34).bytes(Er.RcvUserName), Er.SndAddr != null && Object.hasOwnProperty.call(Er, "SndAddr") && br.uint32(42).bytes(Er.SndAddr), Er.SndUserName != null && Object.hasOwnProperty.call(Er, "SndUserName") && br.uint32(50).bytes(Er.SndUserName), Er.GasPrice != null && Object.hasOwnProperty.call(Er, "GasPrice") && br.uint32(56).uint64(Er.GasPrice), Er.GasLimit != null && Object.hasOwnProperty.call(Er, "GasLimit") && br.uint32(64).uint64(Er.GasLimit), Er.Data != null && Object.hasOwnProperty.call(Er, "Data") && br.uint32(74).bytes(Er.Data), Er.ChainID != null && Object.hasOwnProperty.call(Er, "ChainID") && br.uint32(82).bytes(Er.ChainID), Er.Version != null && Object.hasOwnProperty.call(Er, "Version") && br.uint32(88).uint32(Er.Version), Er.Signature != null && Object.hasOwnProperty.call(Er, "Signature") && br.uint32(98).bytes(Er.Signature), Er.Options != null && Object.hasOwnProperty.call(Er, "Options") && br.uint32(104).uint32(Er.Options), Er.GuardAddr != null && Object.hasOwnProperty.call(Er, "GuardAddr") && br.uint32(114).bytes(Er.GuardAddr), Er.GuardSignature != null && Object.hasOwnProperty.call(Er, "GuardSignature") && br.uint32(122).bytes(Er.GuardSignature), br;
      }, ye.encodeDelimited = function(Er, br) {
        return this.encode(Er, br).ldelim();
      }, ye.decode = function(Er, br) {
        Er instanceof e || (Er = e.create(Er));
        for (var wr = br === void 0 ? Er.len : Er.pos + br, kr = new fe.proto.Transaction(); Er.pos < wr; ) {
          var Gr = Er.uint32();
          switch (Gr >>> 3) {
            case 1:
              kr.Nonce = Er.uint64();
              break;
            case 2:
              kr.Value = Er.bytes();
              break;
            case 3:
              kr.RcvAddr = Er.bytes();
              break;
            case 4:
              kr.RcvUserName = Er.bytes();
              break;
            case 5:
              kr.SndAddr = Er.bytes();
              break;
            case 6:
              kr.SndUserName = Er.bytes();
              break;
            case 7:
              kr.GasPrice = Er.uint64();
              break;
            case 8:
              kr.GasLimit = Er.uint64();
              break;
            case 9:
              kr.Data = Er.bytes();
              break;
            case 10:
              kr.ChainID = Er.bytes();
              break;
            case 11:
              kr.Version = Er.uint32();
              break;
            case 12:
              kr.Signature = Er.bytes();
              break;
            case 13:
              kr.Options = Er.uint32();
              break;
            case 14:
              kr.GuardAddr = Er.bytes();
              break;
            case 15:
              kr.GuardSignature = Er.bytes();
              break;
            default:
              Er.skipType(Gr & 7);
              break;
          }
        }
        return kr;
      }, ye.decodeDelimited = function(Er) {
        return Er instanceof e || (Er = new e(Er)), this.decode(Er, Er.uint32());
      }, ye.verify = function(Er) {
        return typeof Er != "object" || Er === null ? "object expected" : Er.Nonce != null && Er.hasOwnProperty("Nonce") && !o.isInteger(Er.Nonce) && !(Er.Nonce && o.isInteger(Er.Nonce.low) && o.isInteger(Er.Nonce.high)) ? "Nonce: integer|Long expected" : Er.Value != null && Er.hasOwnProperty("Value") && !(Er.Value && typeof Er.Value.length == "number" || o.isString(Er.Value)) ? "Value: buffer expected" : Er.RcvAddr != null && Er.hasOwnProperty("RcvAddr") && !(Er.RcvAddr && typeof Er.RcvAddr.length == "number" || o.isString(Er.RcvAddr)) ? "RcvAddr: buffer expected" : Er.RcvUserName != null && Er.hasOwnProperty("RcvUserName") && !(Er.RcvUserName && typeof Er.RcvUserName.length == "number" || o.isString(Er.RcvUserName)) ? "RcvUserName: buffer expected" : Er.SndAddr != null && Er.hasOwnProperty("SndAddr") && !(Er.SndAddr && typeof Er.SndAddr.length == "number" || o.isString(Er.SndAddr)) ? "SndAddr: buffer expected" : Er.SndUserName != null && Er.hasOwnProperty("SndUserName") && !(Er.SndUserName && typeof Er.SndUserName.length == "number" || o.isString(Er.SndUserName)) ? "SndUserName: buffer expected" : Er.GasPrice != null && Er.hasOwnProperty("GasPrice") && !o.isInteger(Er.GasPrice) && !(Er.GasPrice && o.isInteger(Er.GasPrice.low) && o.isInteger(Er.GasPrice.high)) ? "GasPrice: integer|Long expected" : Er.GasLimit != null && Er.hasOwnProperty("GasLimit") && !o.isInteger(Er.GasLimit) && !(Er.GasLimit && o.isInteger(Er.GasLimit.low) && o.isInteger(Er.GasLimit.high)) ? "GasLimit: integer|Long expected" : Er.Data != null && Er.hasOwnProperty("Data") && !(Er.Data && typeof Er.Data.length == "number" || o.isString(Er.Data)) ? "Data: buffer expected" : Er.ChainID != null && Er.hasOwnProperty("ChainID") && !(Er.ChainID && typeof Er.ChainID.length == "number" || o.isString(Er.ChainID)) ? "ChainID: buffer expected" : Er.Version != null && Er.hasOwnProperty("Version") && !o.isInteger(Er.Version) ? "Version: integer expected" : Er.Signature != null && Er.hasOwnProperty("Signature") && !(Er.Signature && typeof Er.Signature.length == "number" || o.isString(Er.Signature)) ? "Signature: buffer expected" : Er.Options != null && Er.hasOwnProperty("Options") && !o.isInteger(Er.Options) ? "Options: integer expected" : Er.GuardAddr != null && Er.hasOwnProperty("GuardAddr") && !(Er.GuardAddr && typeof Er.GuardAddr.length == "number" || o.isString(Er.GuardAddr)) ? "GuardAddr: buffer expected" : Er.GuardSignature != null && Er.hasOwnProperty("GuardSignature") && !(Er.GuardSignature && typeof Er.GuardSignature.length == "number" || o.isString(Er.GuardSignature)) ? "GuardSignature: buffer expected" : null;
      }, ye.fromObject = function(Er) {
        if (Er instanceof fe.proto.Transaction)
          return Er;
        var br = new fe.proto.Transaction();
        return Er.Nonce != null && (o.Long ? (br.Nonce = o.Long.fromValue(Er.Nonce)).unsigned = !0 : typeof Er.Nonce == "string" ? br.Nonce = parseInt(Er.Nonce, 10) : typeof Er.Nonce == "number" ? br.Nonce = Er.Nonce : typeof Er.Nonce == "object" && (br.Nonce = new o.LongBits(Er.Nonce.low >>> 0, Er.Nonce.high >>> 0).toNumber(!0))), Er.Value != null && (typeof Er.Value == "string" ? o.base64.decode(Er.Value, br.Value = o.newBuffer(o.base64.length(Er.Value)), 0) : Er.Value.length && (br.Value = Er.Value)), Er.RcvAddr != null && (typeof Er.RcvAddr == "string" ? o.base64.decode(Er.RcvAddr, br.RcvAddr = o.newBuffer(o.base64.length(Er.RcvAddr)), 0) : Er.RcvAddr.length && (br.RcvAddr = Er.RcvAddr)), Er.RcvUserName != null && (typeof Er.RcvUserName == "string" ? o.base64.decode(Er.RcvUserName, br.RcvUserName = o.newBuffer(o.base64.length(Er.RcvUserName)), 0) : Er.RcvUserName.length && (br.RcvUserName = Er.RcvUserName)), Er.SndAddr != null && (typeof Er.SndAddr == "string" ? o.base64.decode(Er.SndAddr, br.SndAddr = o.newBuffer(o.base64.length(Er.SndAddr)), 0) : Er.SndAddr.length && (br.SndAddr = Er.SndAddr)), Er.SndUserName != null && (typeof Er.SndUserName == "string" ? o.base64.decode(Er.SndUserName, br.SndUserName = o.newBuffer(o.base64.length(Er.SndUserName)), 0) : Er.SndUserName.length && (br.SndUserName = Er.SndUserName)), Er.GasPrice != null && (o.Long ? (br.GasPrice = o.Long.fromValue(Er.GasPrice)).unsigned = !0 : typeof Er.GasPrice == "string" ? br.GasPrice = parseInt(Er.GasPrice, 10) : typeof Er.GasPrice == "number" ? br.GasPrice = Er.GasPrice : typeof Er.GasPrice == "object" && (br.GasPrice = new o.LongBits(Er.GasPrice.low >>> 0, Er.GasPrice.high >>> 0).toNumber(!0))), Er.GasLimit != null && (o.Long ? (br.GasLimit = o.Long.fromValue(Er.GasLimit)).unsigned = !0 : typeof Er.GasLimit == "string" ? br.GasLimit = parseInt(Er.GasLimit, 10) : typeof Er.GasLimit == "number" ? br.GasLimit = Er.GasLimit : typeof Er.GasLimit == "object" && (br.GasLimit = new o.LongBits(Er.GasLimit.low >>> 0, Er.GasLimit.high >>> 0).toNumber(!0))), Er.Data != null && (typeof Er.Data == "string" ? o.base64.decode(Er.Data, br.Data = o.newBuffer(o.base64.length(Er.Data)), 0) : Er.Data.length && (br.Data = Er.Data)), Er.ChainID != null && (typeof Er.ChainID == "string" ? o.base64.decode(Er.ChainID, br.ChainID = o.newBuffer(o.base64.length(Er.ChainID)), 0) : Er.ChainID.length && (br.ChainID = Er.ChainID)), Er.Version != null && (br.Version = Er.Version >>> 0), Er.Signature != null && (typeof Er.Signature == "string" ? o.base64.decode(Er.Signature, br.Signature = o.newBuffer(o.base64.length(Er.Signature)), 0) : Er.Signature.length && (br.Signature = Er.Signature)), Er.Options != null && (br.Options = Er.Options >>> 0), Er.GuardAddr != null && (typeof Er.GuardAddr == "string" ? o.base64.decode(Er.GuardAddr, br.GuardAddr = o.newBuffer(o.base64.length(Er.GuardAddr)), 0) : Er.GuardAddr.length && (br.GuardAddr = Er.GuardAddr)), Er.GuardSignature != null && (typeof Er.GuardSignature == "string" ? o.base64.decode(Er.GuardSignature, br.GuardSignature = o.newBuffer(o.base64.length(Er.GuardSignature)), 0) : Er.GuardSignature.length && (br.GuardSignature = Er.GuardSignature)), br;
      }, ye.toObject = function(Er, br) {
        br || (br = {});
        var wr = {};
        if (br.defaults) {
          if (o.Long) {
            var kr = new o.Long(0, 0, !0);
            wr.Nonce = br.longs === String ? kr.toString() : br.longs === Number ? kr.toNumber() : kr;
          } else
            wr.Nonce = br.longs === String ? "0" : 0;
          if (br.bytes === String ? wr.Value = "" : (wr.Value = [], br.bytes !== Array && (wr.Value = o.newBuffer(wr.Value))), br.bytes === String ? wr.RcvAddr = "" : (wr.RcvAddr = [], br.bytes !== Array && (wr.RcvAddr = o.newBuffer(wr.RcvAddr))), br.bytes === String ? wr.RcvUserName = "" : (wr.RcvUserName = [], br.bytes !== Array && (wr.RcvUserName = o.newBuffer(wr.RcvUserName))), br.bytes === String ? wr.SndAddr = "" : (wr.SndAddr = [], br.bytes !== Array && (wr.SndAddr = o.newBuffer(wr.SndAddr))), br.bytes === String ? wr.SndUserName = "" : (wr.SndUserName = [], br.bytes !== Array && (wr.SndUserName = o.newBuffer(wr.SndUserName))), o.Long) {
            var kr = new o.Long(0, 0, !0);
            wr.GasPrice = br.longs === String ? kr.toString() : br.longs === Number ? kr.toNumber() : kr;
          } else
            wr.GasPrice = br.longs === String ? "0" : 0;
          if (o.Long) {
            var kr = new o.Long(0, 0, !0);
            wr.GasLimit = br.longs === String ? kr.toString() : br.longs === Number ? kr.toNumber() : kr;
          } else
            wr.GasLimit = br.longs === String ? "0" : 0;
          br.bytes === String ? wr.Data = "" : (wr.Data = [], br.bytes !== Array && (wr.Data = o.newBuffer(wr.Data))), br.bytes === String ? wr.ChainID = "" : (wr.ChainID = [], br.bytes !== Array && (wr.ChainID = o.newBuffer(wr.ChainID))), wr.Version = 0, br.bytes === String ? wr.Signature = "" : (wr.Signature = [], br.bytes !== Array && (wr.Signature = o.newBuffer(wr.Signature))), wr.Options = 0, br.bytes === String ? wr.GuardAddr = "" : (wr.GuardAddr = [], br.bytes !== Array && (wr.GuardAddr = o.newBuffer(wr.GuardAddr))), br.bytes === String ? wr.GuardSignature = "" : (wr.GuardSignature = [], br.bytes !== Array && (wr.GuardSignature = o.newBuffer(wr.GuardSignature)));
        }
        return Er.Nonce != null && Er.hasOwnProperty("Nonce") && (typeof Er.Nonce == "number" ? wr.Nonce = br.longs === String ? String(Er.Nonce) : Er.Nonce : wr.Nonce = br.longs === String ? o.Long.prototype.toString.call(Er.Nonce) : br.longs === Number ? new o.LongBits(Er.Nonce.low >>> 0, Er.Nonce.high >>> 0).toNumber(!0) : Er.Nonce), Er.Value != null && Er.hasOwnProperty("Value") && (wr.Value = br.bytes === String ? o.base64.encode(Er.Value, 0, Er.Value.length) : br.bytes === Array ? Array.prototype.slice.call(Er.Value) : Er.Value), Er.RcvAddr != null && Er.hasOwnProperty("RcvAddr") && (wr.RcvAddr = br.bytes === String ? o.base64.encode(Er.RcvAddr, 0, Er.RcvAddr.length) : br.bytes === Array ? Array.prototype.slice.call(Er.RcvAddr) : Er.RcvAddr), Er.RcvUserName != null && Er.hasOwnProperty("RcvUserName") && (wr.RcvUserName = br.bytes === String ? o.base64.encode(Er.RcvUserName, 0, Er.RcvUserName.length) : br.bytes === Array ? Array.prototype.slice.call(Er.RcvUserName) : Er.RcvUserName), Er.SndAddr != null && Er.hasOwnProperty("SndAddr") && (wr.SndAddr = br.bytes === String ? o.base64.encode(Er.SndAddr, 0, Er.SndAddr.length) : br.bytes === Array ? Array.prototype.slice.call(Er.SndAddr) : Er.SndAddr), Er.SndUserName != null && Er.hasOwnProperty("SndUserName") && (wr.SndUserName = br.bytes === String ? o.base64.encode(Er.SndUserName, 0, Er.SndUserName.length) : br.bytes === Array ? Array.prototype.slice.call(Er.SndUserName) : Er.SndUserName), Er.GasPrice != null && Er.hasOwnProperty("GasPrice") && (typeof Er.GasPrice == "number" ? wr.GasPrice = br.longs === String ? String(Er.GasPrice) : Er.GasPrice : wr.GasPrice = br.longs === String ? o.Long.prototype.toString.call(Er.GasPrice) : br.longs === Number ? new o.LongBits(Er.GasPrice.low >>> 0, Er.GasPrice.high >>> 0).toNumber(!0) : Er.GasPrice), Er.GasLimit != null && Er.hasOwnProperty("GasLimit") && (typeof Er.GasLimit == "number" ? wr.GasLimit = br.longs === String ? String(Er.GasLimit) : Er.GasLimit : wr.GasLimit = br.longs === String ? o.Long.prototype.toString.call(Er.GasLimit) : br.longs === Number ? new o.LongBits(Er.GasLimit.low >>> 0, Er.GasLimit.high >>> 0).toNumber(!0) : Er.GasLimit), Er.Data != null && Er.hasOwnProperty("Data") && (wr.Data = br.bytes === String ? o.base64.encode(Er.Data, 0, Er.Data.length) : br.bytes === Array ? Array.prototype.slice.call(Er.Data) : Er.Data), Er.ChainID != null && Er.hasOwnProperty("ChainID") && (wr.ChainID = br.bytes === String ? o.base64.encode(Er.ChainID, 0, Er.ChainID.length) : br.bytes === Array ? Array.prototype.slice.call(Er.ChainID) : Er.ChainID), Er.Version != null && Er.hasOwnProperty("Version") && (wr.Version = Er.Version), Er.Signature != null && Er.hasOwnProperty("Signature") && (wr.Signature = br.bytes === String ? o.base64.encode(Er.Signature, 0, Er.Signature.length) : br.bytes === Array ? Array.prototype.slice.call(Er.Signature) : Er.Signature), Er.Options != null && Er.hasOwnProperty("Options") && (wr.Options = Er.Options), Er.GuardAddr != null && Er.hasOwnProperty("GuardAddr") && (wr.GuardAddr = br.bytes === String ? o.base64.encode(Er.GuardAddr, 0, Er.GuardAddr.length) : br.bytes === Array ? Array.prototype.slice.call(Er.GuardAddr) : Er.GuardAddr), Er.GuardSignature != null && Er.hasOwnProperty("GuardSignature") && (wr.GuardSignature = br.bytes === String ? o.base64.encode(Er.GuardSignature, 0, Er.GuardSignature.length) : br.bytes === Array ? Array.prototype.slice.call(Er.GuardSignature) : Er.GuardSignature), wr;
      }, ye.prototype.toJSON = function() {
        return this.constructor.toObject(this, r.util.toJSONOptions);
      }, ye;
    }(), me;
  }(), compiled = fe, compiled;
}
var __createBinding$h = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$h = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$h = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$h(e, r, s);
  return __setModuleDefault$h(e, r), e;
}, __importDefault$j = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(serializer, "__esModule", { value: !0 });
serializer.ProtoSerializer = void 0;
const bignumber_js_1$h = __importDefault$j(require$$1$2), address_1$f = address$2, constants_1$c = constants$c, errors$l = __importStar$h(errors$q), utils_1$c = utils$b;
class ProtoSerializer {
  serializeTransaction(e) {
    const s = requireCompiled().proto, o = new address_1$f.Address(e.getReceiver().bech32()).pubkey(), fe = new address_1$f.Address(e.getSender().bech32()).pubkey();
    let me = new s.Transaction({
      Nonce: e.getNonce().valueOf() ? e.getNonce().valueOf() : void 0,
      Value: this.serializeTransactionValue(e.getValue()),
      RcvAddr: o,
      RcvUserName: e.getReceiverUsername() ? Buffer.from(e.getReceiverUsername()).toString("base64") : void 0,
      SndAddr: fe,
      SndUserName: e.getSenderUsername() ? Buffer.from(e.getSenderUsername()).toString("base64") : void 0,
      GasPrice: e.getGasPrice().valueOf(),
      GasLimit: e.getGasLimit().valueOf(),
      Data: e.getData().length() == 0 ? null : e.getData().valueOf(),
      ChainID: Buffer.from(e.getChainID().valueOf()),
      Version: e.getVersion().valueOf(),
      Signature: e.getSignature()
    });
    if (e.getOptions().valueOf() !== constants_1$c.TRANSACTION_OPTIONS_DEFAULT && (me.Options = e.getOptions().valueOf()), e.isGuardedTransaction()) {
      const Er = e.getGuardian();
      me.GuardAddr = new address_1$f.Address(Er.bech32()).pubkey(), me.GuardSignature = e.getGuardianSignature();
    }
    const ye = s.Transaction.encode(me).finish();
    return Buffer.from(ye);
  }
  serializeTransactionValue(e) {
    let s = new bignumber_js_1$h.default(e.toString());
    if (s.isZero())
      return Buffer.from([0, 0]);
    let o = utils_1$c.bigIntToBuffer(s);
    return o = Buffer.concat([Buffer.from([0]), o]), o;
  }
  deserializeTransaction(e) {
    throw new errors$l.ErrUnsupportedOperation("deserializeTransaction");
  }
}
serializer.ProtoSerializer = ProtoSerializer;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(serializer, r);
})(proto);
var signature = {}, __createBinding$g = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$g = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$g = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$g(e, r, s);
  return __setModuleDefault$g(e, r), e;
};
Object.defineProperty(signature, "__esModule", { value: !0 });
signature.interpretSignatureAsBuffer = Signature_1 = signature.Signature = void 0;
const errors$k = __importStar$g(errors$q), SIGNATURE_LENGTH = 64;
class Signature {
  constructor(e) {
    if (this.valueHex = "", !!e) {
      if (typeof e == "string")
        return Signature.fromHex(e);
      if (e instanceof Buffer)
        return Signature.fromBuffer(e);
    }
  }
  static empty() {
    return new Signature();
  }
  static fromHex(e) {
    if (e.startsWith("0x") && (e = e.slice(2)), !Signature.isValidHex(e))
      throw new errors$k.ErrSignatureCannotCreate(e);
    return Signature.fromValidHex(e);
  }
  static isValidHex(e) {
    return Buffer.from(e, "hex").length == SIGNATURE_LENGTH;
  }
  static fromValidHex(e) {
    let s = new Signature();
    return s.valueHex = e, s;
  }
  static fromBuffer(e) {
    if (e.length != SIGNATURE_LENGTH)
      throw new errors$k.ErrSignatureCannotCreate(e);
    return Signature.fromValidHex(e.toString("hex"));
  }
  hex() {
    return this.valueHex;
  }
}
var Signature_1 = signature.Signature = Signature;
function interpretSignatureAsBuffer(r) {
  if (ArrayBuffer.isView(r))
    return Buffer.from(r);
  if (r.hex != null)
    return Buffer.from(r.hex(), "hex");
  throw new Error(`Object cannot be interpreted as a signature: ${r}`);
}
signature.interpretSignatureAsBuffer = interpretSignatureAsBuffer;
var transactionPayload = {};
Object.defineProperty(transactionPayload, "__esModule", { value: !0 });
transactionPayload.TransactionPayload = void 0;
class TransactionPayload {
  constructor(e) {
    this.data = Buffer.from(e || []);
  }
  static fromEncoded(e) {
    if (!e)
      return new TransactionPayload("");
    let s = Buffer.from(e, "base64").toString();
    return new TransactionPayload(s);
  }
  isEmpty() {
    return this.data.length == 0;
  }
  encoded() {
    return this.data.toString("base64");
  }
  valueOf() {
    return this.data;
  }
  toString() {
    return this.data.toString();
  }
  getEncodedArguments() {
    return this.toString().split("@");
  }
  getRawArguments() {
    return this.getEncodedArguments().map((e) => Buffer.from(e, "hex"));
  }
  length() {
    return Buffer.from(this.data).length;
  }
}
transactionPayload.TransactionPayload = TransactionPayload;
var utils$a = {}, __createBinding$f = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$f = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$f = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$f(e, r, s);
  return __setModuleDefault$f(e, r), e;
};
Object.defineProperty(utils$a, "__esModule", { value: !0 });
utils$a.isEmpty = utils$a.guardEmpty = utils$a.guardNotEmpty = utils$a.guardLength = utils$a.guardSameLength = utils$a.guardValueIsSetWithMessage = utils$a.guardValueIsSet = utils$a.guardTrue = void 0;
const errors$j = __importStar$f(errors$q);
function guardTrue(r, e) {
  if (!r)
    throw new errors$j.ErrInvariantFailed(`[<${e}>] isn't true`);
}
utils$a.guardTrue = guardTrue;
function guardValueIsSet(r, e) {
  guardValueIsSetWithMessage(`${r} isn't set (null or undefined)`, e);
}
utils$a.guardValueIsSet = guardValueIsSet;
function guardValueIsSetWithMessage(r, e) {
  if (e == null || e === void 0)
    throw new errors$j.ErrInvariantFailed(r);
}
utils$a.guardValueIsSetWithMessage = guardValueIsSetWithMessage;
function guardSameLength(r, e) {
  if (r = r || [], e = e || [], r.length != e.length)
    throw new errors$j.ErrInvariantFailed("arrays do not have the same length");
}
utils$a.guardSameLength = guardSameLength;
function guardLength(r, e) {
  let s = r.length || 0;
  if (s != e)
    throw new errors$j.ErrInvariantFailed(`wrong length, expected: ${e}, actual: ${s}`);
}
utils$a.guardLength = guardLength;
function guardNotEmpty(r, e) {
  if (isEmpty(r))
    throw new errors$j.ErrInvariantFailed(`${e} is empty`);
}
utils$a.guardNotEmpty = guardNotEmpty;
function guardEmpty(r, e) {
  if (!isEmpty(r))
    throw new errors$j.ErrInvariantFailed(`${e} is not empty`);
}
utils$a.guardEmpty = guardEmpty;
function isEmpty(r) {
  return r.isEmpty ? r.isEmpty() : r.length === 0;
}
utils$a.isEmpty = isEmpty;
var blake2b$1 = { exports: {} };
assert$2.notEqual = notEqual;
assert$2.notOk = notOk;
assert$2.equal = equal$1;
assert$2.ok = assert$2;
var nanoassert = assert$2;
function equal$1(r, e, s) {
  assert$2(r == e, s);
}
function notEqual(r, e, s) {
  assert$2(r != e, s);
}
function notOk(r, e) {
  assert$2(!r, e);
}
function assert$2(r, e) {
  if (!r)
    throw new Error(e || "AssertionError");
}
var blake2bWasm = { exports: {} };
function commonjsRequire(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var blake2b = loadWebAssembly;
loadWebAssembly.supported = typeof WebAssembly < "u";
function loadWebAssembly(r) {
  if (!loadWebAssembly.supported)
    return null;
  var e = r && r.imports, s = toUint8Array("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"), o = null, fe = {
    buffer: s,
    memory: null,
    exports: null,
    realloc: me,
    onload: ye
  };
  return ye(function() {
  }), fe;
  function me(Er) {
    fe.exports.memory.grow(Math.ceil(Math.abs(Er - fe.memory.length) / 65536)), fe.memory = new Uint8Array(fe.exports.memory.buffer);
  }
  function ye(Er) {
    if (fe.exports)
      return Er();
    if (o) {
      o.then(Er.bind(null, null)).catch(Er);
      return;
    }
    try {
      if (r && r.async)
        throw new Error("async");
      fr({ instance: new WebAssembly.Instance(new WebAssembly.Module(s), e) });
    } catch {
      o = WebAssembly.instantiate(s, e).then(fr);
    }
    ye(Er);
  }
  function fr(Er) {
    fe.exports = Er.instance.exports, fe.memory = fe.exports.memory && fe.exports.memory.buffer && new Uint8Array(fe.exports.memory.buffer);
  }
}
function toUint8Array(r) {
  return typeof atob == "function" ? new Uint8Array(atob(r).split("").map(charCodeAt)) : new (commonjsRequire("buffer")).Buffer(r, "base64");
}
function charCodeAt(r) {
  return r.charCodeAt(0);
}
var assert$1 = nanoassert, wasm = blake2b(), head = 64, freeList = [];
blake2bWasm.exports = Blake2b$1;
var BYTES_MIN$1 = blake2bWasm.exports.BYTES_MIN = 16, BYTES_MAX$1 = blake2bWasm.exports.BYTES_MAX = 64;
blake2bWasm.exports.BYTES = 32;
var KEYBYTES_MIN$1 = blake2bWasm.exports.KEYBYTES_MIN = 16, KEYBYTES_MAX$1 = blake2bWasm.exports.KEYBYTES_MAX = 64;
blake2bWasm.exports.KEYBYTES = 32;
var SALTBYTES$1 = blake2bWasm.exports.SALTBYTES = 16, PERSONALBYTES$1 = blake2bWasm.exports.PERSONALBYTES = 16;
function Blake2b$1(r, e, s, o, fe) {
  if (!(this instanceof Blake2b$1))
    return new Blake2b$1(r, e, s, o, fe);
  if (!(wasm && wasm.exports))
    throw new Error("WASM not loaded. Wait for Blake2b.ready(cb)");
  r || (r = 32), fe !== !0 && (assert$1(r >= BYTES_MIN$1, "digestLength must be at least " + BYTES_MIN$1 + ", was given " + r), assert$1(r <= BYTES_MAX$1, "digestLength must be at most " + BYTES_MAX$1 + ", was given " + r), e != null && assert$1(e.length >= KEYBYTES_MIN$1, "key must be at least " + KEYBYTES_MIN$1 + ", was given " + e.length), e != null && assert$1(e.length <= KEYBYTES_MAX$1, "key must be at least " + KEYBYTES_MAX$1 + ", was given " + e.length), s != null && assert$1(s.length === SALTBYTES$1, "salt must be exactly " + SALTBYTES$1 + ", was given " + s.length), o != null && assert$1(o.length === PERSONALBYTES$1, "personal must be exactly " + PERSONALBYTES$1 + ", was given " + o.length)), freeList.length || (freeList.push(head), head += 216), this.digestLength = r, this.finalized = !1, this.pointer = freeList.pop(), wasm.memory.fill(0, 0, 64), wasm.memory[0] = this.digestLength, wasm.memory[1] = e ? e.length : 0, wasm.memory[2] = 1, wasm.memory[3] = 1, s && wasm.memory.set(s, 32), o && wasm.memory.set(o, 48), this.pointer + 216 > wasm.memory.length && wasm.realloc(this.pointer + 216), wasm.exports.blake2b_init(this.pointer, this.digestLength), e && (this.update(e), wasm.memory.fill(0, head, head + e.length), wasm.memory[this.pointer + 200] = 128);
}
Blake2b$1.prototype.update = function(r) {
  return assert$1(this.finalized === !1, "Hash instance finalized"), assert$1(r, "input must be TypedArray or Buffer"), head + r.length > wasm.memory.length && wasm.realloc(head + r.length), wasm.memory.set(r, head), wasm.exports.blake2b_update(this.pointer, head, head + r.length), this;
};
Blake2b$1.prototype.digest = function(r) {
  if (assert$1(this.finalized === !1, "Hash instance finalized"), this.finalized = !0, freeList.push(this.pointer), wasm.exports.blake2b_final(this.pointer), !r || r === "binary")
    return wasm.memory.slice(this.pointer + 128, this.pointer + 128 + this.digestLength);
  if (r === "hex")
    return hexSlice$1(wasm.memory, this.pointer + 128, this.digestLength);
  assert$1(r.length >= this.digestLength, "input must be TypedArray or Buffer");
  for (var e = 0; e < this.digestLength; e++)
    r[e] = wasm.memory[this.pointer + 128 + e];
  return r;
};
Blake2b$1.prototype.final = Blake2b$1.prototype.digest;
Blake2b$1.WASM = wasm && wasm.buffer;
Blake2b$1.SUPPORTED = typeof WebAssembly < "u";
Blake2b$1.ready = function(r) {
  if (r || (r = noop$5), !wasm)
    return r(new Error("WebAssembly not supported"));
  var e = new Promise(function(s, o) {
    wasm.onload(function(fe) {
      fe ? o() : s(), r(fe);
    });
  });
  return e;
};
Blake2b$1.prototype.ready = Blake2b$1.ready;
function noop$5() {
}
function hexSlice$1(r, e, s) {
  for (var o = "", fe = 0; fe < s; fe++)
    o += toHex$1(r[e + fe]);
  return o;
}
function toHex$1(r) {
  return r < 16 ? "0" + r.toString(16) : r.toString(16);
}
var assert = nanoassert, b2wasm = blake2bWasm.exports;
function ADD64AA(r, e, s) {
  var o = r[e] + r[s], fe = r[e + 1] + r[s + 1];
  o >= 4294967296 && fe++, r[e] = o, r[e + 1] = fe;
}
function ADD64AC(r, e, s, o) {
  var fe = r[e] + s;
  s < 0 && (fe += 4294967296);
  var me = r[e + 1] + o;
  fe >= 4294967296 && me++, r[e] = fe, r[e + 1] = me;
}
function B2B_GET32(r, e) {
  return r[e] ^ r[e + 1] << 8 ^ r[e + 2] << 16 ^ r[e + 3] << 24;
}
function B2B_G(r, e, s, o, fe, me) {
  var ye = m$1[fe], fr = m$1[fe + 1], Er = m$1[me], br = m$1[me + 1];
  ADD64AA(v$2, r, e), ADD64AC(v$2, r, ye, fr);
  var wr = v$2[o] ^ v$2[r], kr = v$2[o + 1] ^ v$2[r + 1];
  v$2[o] = kr, v$2[o + 1] = wr, ADD64AA(v$2, s, o), wr = v$2[e] ^ v$2[s], kr = v$2[e + 1] ^ v$2[s + 1], v$2[e] = wr >>> 24 ^ kr << 8, v$2[e + 1] = kr >>> 24 ^ wr << 8, ADD64AA(v$2, r, e), ADD64AC(v$2, r, Er, br), wr = v$2[o] ^ v$2[r], kr = v$2[o + 1] ^ v$2[r + 1], v$2[o] = wr >>> 16 ^ kr << 16, v$2[o + 1] = kr >>> 16 ^ wr << 16, ADD64AA(v$2, s, o), wr = v$2[e] ^ v$2[s], kr = v$2[e + 1] ^ v$2[s + 1], v$2[e] = kr >>> 31 ^ wr << 1, v$2[e + 1] = wr >>> 31 ^ kr << 1;
}
var BLAKE2B_IV32 = new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), SIGMA8 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
], SIGMA82 = new Uint8Array(SIGMA8.map(function(r) {
  return r * 2;
})), v$2 = new Uint32Array(32), m$1 = new Uint32Array(32);
function blake2bCompress(r, e) {
  var s = 0;
  for (s = 0; s < 16; s++)
    v$2[s] = r.h[s], v$2[s + 16] = BLAKE2B_IV32[s];
  for (v$2[24] = v$2[24] ^ r.t, v$2[25] = v$2[25] ^ r.t / 4294967296, e && (v$2[28] = ~v$2[28], v$2[29] = ~v$2[29]), s = 0; s < 32; s++)
    m$1[s] = B2B_GET32(r.b, 4 * s);
  for (s = 0; s < 12; s++)
    B2B_G(0, 8, 16, 24, SIGMA82[s * 16 + 0], SIGMA82[s * 16 + 1]), B2B_G(2, 10, 18, 26, SIGMA82[s * 16 + 2], SIGMA82[s * 16 + 3]), B2B_G(4, 12, 20, 28, SIGMA82[s * 16 + 4], SIGMA82[s * 16 + 5]), B2B_G(6, 14, 22, 30, SIGMA82[s * 16 + 6], SIGMA82[s * 16 + 7]), B2B_G(0, 10, 20, 30, SIGMA82[s * 16 + 8], SIGMA82[s * 16 + 9]), B2B_G(2, 12, 22, 24, SIGMA82[s * 16 + 10], SIGMA82[s * 16 + 11]), B2B_G(4, 14, 16, 26, SIGMA82[s * 16 + 12], SIGMA82[s * 16 + 13]), B2B_G(6, 8, 18, 28, SIGMA82[s * 16 + 14], SIGMA82[s * 16 + 15]);
  for (s = 0; s < 16; s++)
    r.h[s] = r.h[s] ^ v$2[s] ^ v$2[s + 16];
}
var parameter_block = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0
]);
function Blake2b(r, e, s, o) {
  parameter_block.fill(0), this.b = new Uint8Array(128), this.h = new Uint32Array(16), this.t = 0, this.c = 0, this.outlen = r, parameter_block[0] = r, e && (parameter_block[1] = e.length), parameter_block[2] = 1, parameter_block[3] = 1, s && parameter_block.set(s, 32), o && parameter_block.set(o, 48);
  for (var fe = 0; fe < 16; fe++)
    this.h[fe] = BLAKE2B_IV32[fe] ^ B2B_GET32(parameter_block, fe * 4);
  e && (blake2bUpdate(this, e), this.c = 128);
}
Blake2b.prototype.update = function(r) {
  return assert(r != null, "input must be Uint8Array or Buffer"), blake2bUpdate(this, r), this;
};
Blake2b.prototype.digest = function(r) {
  var e = !r || r === "binary" || r === "hex" ? new Uint8Array(this.outlen) : r;
  return assert(e.length >= this.outlen, "out must have at least outlen bytes of space"), blake2bFinal(this, e), r === "hex" ? hexSlice(e) : e;
};
Blake2b.prototype.final = Blake2b.prototype.digest;
Blake2b.ready = function(r) {
  b2wasm.ready(function() {
    r();
  });
};
function blake2bUpdate(r, e) {
  for (var s = 0; s < e.length; s++)
    r.c === 128 && (r.t += r.c, blake2bCompress(r, !1), r.c = 0), r.b[r.c++] = e[s];
}
function blake2bFinal(r, e) {
  for (r.t += r.c; r.c < 128; )
    r.b[r.c++] = 0;
  blake2bCompress(r, !0);
  for (var s = 0; s < r.outlen; s++)
    e[s] = r.h[s >> 2] >> 8 * (s & 3);
  return e;
}
function hexSlice(r) {
  for (var e = "", s = 0; s < r.length; s++)
    e += toHex(r[s]);
  return e;
}
function toHex(r) {
  return r < 16 ? "0" + r.toString(16) : r.toString(16);
}
var Proto = Blake2b;
blake2b$1.exports = function r(e, s, o, fe, me) {
  return me !== !0 && (assert(e >= BYTES_MIN, "outlen must be at least " + BYTES_MIN + ", was given " + e), assert(e <= BYTES_MAX, "outlen must be at most " + BYTES_MAX + ", was given " + e), s != null && assert(s.length >= KEYBYTES_MIN, "key must be at least " + KEYBYTES_MIN + ", was given " + s.length), s != null && assert(s.length <= KEYBYTES_MAX, "key must be at most " + KEYBYTES_MAX + ", was given " + s.length), o != null && assert(o.length === SALTBYTES, "salt must be exactly " + SALTBYTES + ", was given " + o.length), fe != null && assert(fe.length === PERSONALBYTES, "personal must be exactly " + PERSONALBYTES + ", was given " + fe.length)), new Proto(e, s, o, fe);
};
blake2b$1.exports.ready = function(r) {
  b2wasm.ready(function() {
    r();
  });
};
blake2b$1.exports.WASM_SUPPORTED = b2wasm.SUPPORTED;
blake2b$1.exports.WASM_LOADED = !1;
var BYTES_MIN = blake2b$1.exports.BYTES_MIN = 16, BYTES_MAX = blake2b$1.exports.BYTES_MAX = 64;
blake2b$1.exports.BYTES = 32;
var KEYBYTES_MIN = blake2b$1.exports.KEYBYTES_MIN = 16, KEYBYTES_MAX = blake2b$1.exports.KEYBYTES_MAX = 64;
blake2b$1.exports.KEYBYTES = 32;
var SALTBYTES = blake2b$1.exports.SALTBYTES = 16, PERSONALBYTES = blake2b$1.exports.PERSONALBYTES = 16;
b2wasm.ready(function(r) {
  r || (blake2b$1.exports.WASM_LOADED = !0, Proto = b2wasm);
});
var __createBinding$e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$e = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$e = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$e(e, r, s);
  return __setModuleDefault$e(e, r), e;
};
Object.defineProperty(transaction, "__esModule", { value: !0 });
transaction.TransactionHash = transaction.Transaction = void 0;
const bignumber_js_1$g = require$$1$2, address_1$e = address$2, compatibility_1$2 = compatibility, constants_1$b = constants$c, errors$i = __importStar$e(errors$q), hash_1$1 = hash$1, networkParams_1$1 = networkParams, proto_1 = proto, signature_1$1 = signature, transactionPayload_1$4 = transactionPayload, utils_1$b = utils$a, createTransactionHasher = blake2b$1.exports, TRANSACTION_HASH_LENGTH = 32;
class Transaction {
  constructor({ nonce: e, value: s, sender: o, receiver: fe, senderUsername: me, receiverUsername: ye, gasPrice: fr, gasLimit: Er, data: br, chainID: wr, version: kr, options: Gr, guardian: Vr }) {
    this.nonce = e || 0, this.value = s ? new bignumber_js_1$g.BigNumber(s.toString()).toFixed(0) : 0, this.sender = o, this.receiver = fe, this.senderUsername = me || "", this.receiverUsername = ye || "", this.gasPrice = fr || constants_1$b.TRANSACTION_MIN_GAS_PRICE, this.gasLimit = Er, this.data = br || new transactionPayload_1$4.TransactionPayload(), this.chainID = wr, this.version = kr ? new networkParams_1$1.TransactionVersion(kr.valueOf()) : networkParams_1$1.TransactionVersion.withDefaultVersion(), this.options = Gr ? new networkParams_1$1.TransactionOptions(Gr.valueOf()) : networkParams_1$1.TransactionOptions.withDefaultOptions(), this.guardian = Vr || address_1$e.Address.empty(), this.signature = Buffer.from([]), this.guardianSignature = Buffer.from([]), this.hash = TransactionHash.empty();
  }
  getNonce() {
    return this.nonce;
  }
  setNonce(e) {
    this.nonce = e;
  }
  getValue() {
    return this.value;
  }
  setValue(e) {
    this.value = e;
  }
  getSender() {
    return this.sender;
  }
  setSender(e) {
    this.sender = e;
  }
  getReceiver() {
    return this.receiver;
  }
  getSenderUsername() {
    return this.senderUsername;
  }
  setSenderUsername(e) {
    this.senderUsername = e;
  }
  getReceiverUsername() {
    return this.receiverUsername;
  }
  setReceiverUsername(e) {
    this.receiverUsername = e;
  }
  getGuardian() {
    return this.guardian;
  }
  getGasPrice() {
    return this.gasPrice;
  }
  setGasPrice(e) {
    this.gasPrice = e;
  }
  getGasLimit() {
    return this.gasLimit;
  }
  setGasLimit(e) {
    this.gasLimit = e;
  }
  getData() {
    return this.data;
  }
  getChainID() {
    return this.chainID;
  }
  setChainID(e) {
    this.chainID = e;
  }
  getVersion() {
    return this.version;
  }
  setVersion(e) {
    this.version = new networkParams_1$1.TransactionVersion(e.valueOf());
  }
  getOptions() {
    return new networkParams_1$1.TransactionOptions(this.options.valueOf());
  }
  setOptions(e) {
    this.options = new networkParams_1$1.TransactionOptions(e.valueOf());
  }
  getSignature() {
    return this.signature;
  }
  getGuardianSignature() {
    return this.guardianSignature;
  }
  setGuardian(e) {
    this.guardian = e;
  }
  getHash() {
    return utils_1$b.guardNotEmpty(this.hash, "hash"), this.hash;
  }
  serializeForSigning() {
    let e = this.toPlainObject();
    e.signature && delete e.signature, e.guardianSignature && delete e.guardianSignature, e.guardian || delete e.guardian;
    let s = JSON.stringify(e);
    return Buffer.from(s);
  }
  isGuardedTransaction() {
    const e = this.guardian.bech32().length > 0, s = this.guardianSignature.length > 0;
    return this.getOptions().isWithGuardian() && e && s;
  }
  toPlainObject() {
    var e;
    const s = {
      nonce: this.nonce.valueOf(),
      value: this.value.toString(),
      receiver: this.receiver.bech32(),
      sender: this.sender.bech32(),
      senderUsername: this.senderUsername ? Buffer.from(this.senderUsername).toString("base64") : void 0,
      receiverUsername: this.receiverUsername ? Buffer.from(this.receiverUsername).toString("base64") : void 0,
      gasPrice: this.gasPrice.valueOf(),
      gasLimit: this.gasLimit.valueOf(),
      data: this.data.length() == 0 ? void 0 : this.data.encoded(),
      chainID: this.chainID.valueOf(),
      version: this.getVersion().valueOf(),
      options: this.getOptions().valueOf() == 0 ? void 0 : this.getOptions().valueOf(),
      guardian: !((e = this.guardian) === null || e === void 0) && e.bech32() ? this.guardian.bech32() == "" ? void 0 : this.guardian.bech32() : void 0,
      signature: this.signature.toString("hex") ? this.signature.toString("hex") : void 0,
      guardianSignature: this.guardianSignature.toString("hex") ? this.guardianSignature.toString("hex") : void 0
    };
    return compatibility_1$2.Compatibility.guardAddressIsSetAndNonZero(new address_1$e.Address(s.sender), "'sender' of transaction", "pass the actual sender to the Transaction constructor"), s;
  }
  static fromPlainObject(e) {
    const s = new Transaction({
      nonce: Number(e.nonce),
      value: new bignumber_js_1$g.BigNumber(e.value).toFixed(0),
      receiver: address_1$e.Address.fromString(e.receiver),
      receiverUsername: e.receiverUsername ? Buffer.from(e.receiverUsername, "base64").toString() : void 0,
      sender: address_1$e.Address.fromString(e.sender),
      senderUsername: e.senderUsername ? Buffer.from(e.senderUsername, "base64").toString() : void 0,
      guardian: e.guardian ? address_1$e.Address.fromString(e.guardian) : void 0,
      gasPrice: Number(e.gasPrice),
      gasLimit: Number(e.gasLimit),
      data: new transactionPayload_1$4.TransactionPayload(Buffer.from(e.data || "", "base64")),
      chainID: String(e.chainID),
      version: new networkParams_1$1.TransactionVersion(e.version),
      options: e.options != null ? new networkParams_1$1.TransactionOptions(e.options) : void 0
    });
    return e.signature && s.applySignature(new signature_1$1.Signature(e.signature)), e.guardianSignature && s.applyGuardianSignature(new signature_1$1.Signature(e.guardianSignature)), s;
  }
  applySignature(e) {
    this.signature = signature_1$1.interpretSignatureAsBuffer(e), this.hash = TransactionHash.compute(this);
  }
  applyGuardianSignature(e) {
    this.guardianSignature = signature_1$1.interpretSignatureAsBuffer(e), this.hash = TransactionHash.compute(this);
  }
  toSendable() {
    return this.toPlainObject();
  }
  computeFee(e) {
    let s = e.MinGasLimit.valueOf() + this.data.length() * e.GasPerDataByte.valueOf();
    if (s > this.gasLimit.valueOf())
      throw new errors$i.ErrNotEnoughGas(this.gasLimit.valueOf());
    let o = new bignumber_js_1$g.BigNumber(this.gasPrice.valueOf()), fe = new bignumber_js_1$g.BigNumber(s).multipliedBy(o);
    if (s === this.gasLimit.valueOf())
      return fe;
    let me = new bignumber_js_1$g.BigNumber(this.gasLimit.valueOf() - s), ye = o.multipliedBy(new bignumber_js_1$g.BigNumber(e.GasPriceModifier.valueOf())), fr = me.multipliedBy(ye);
    return fe.plus(fr);
  }
}
transaction.Transaction = Transaction;
class TransactionHash extends hash_1$1.Hash {
  constructor(e) {
    super(e);
  }
  static compute(e) {
    let o = new proto_1.ProtoSerializer().serializeTransaction(e), fe = createTransactionHasher(TRANSACTION_HASH_LENGTH).update(o).digest("hex");
    return new TransactionHash(fe);
  }
}
transaction.TransactionHash = TransactionHash;
var __importDefault$i = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(relayedTransactionV1Builder, "__esModule", { value: !0 });
relayedTransactionV1Builder.RelayedTransactionV1Builder = void 0;
const bignumber_js_1$f = __importDefault$i(require$$1$2), address_1$d = address$2, errors_1$g = errors$q, transaction_1$5 = transaction, transactionPayload_1$3 = transactionPayload;
class RelayedTransactionV1Builder {
  setInnerTransaction(e) {
    return this.innerTransaction = e, this;
  }
  setNetworkConfig(e) {
    return this.netConfig = e, this;
  }
  setRelayerAddress(e) {
    return this.relayerAddress = e, this;
  }
  setRelayerNonce(e) {
    return this.relayerNonce = e, this;
  }
  setRelayedTransactionVersion(e) {
    return this.relayedTransactionVersion = e, this;
  }
  setRelayedTransactionOptions(e) {
    return this.relayedTransactionOptions = e, this;
  }
  setRelayedTransactionGuardian(e) {
    return this.relayedTransactionGuardian = e, this;
  }
  build() {
    if (!this.innerTransaction || !this.netConfig || !this.relayerAddress || !this.innerTransaction.getSignature())
      throw new errors_1$g.ErrInvalidRelayedV1BuilderArguments();
    const e = this.prepareInnerTransaction(), s = `relayedTx@${Buffer.from(e).toString("hex")}`, o = new transactionPayload_1$3.TransactionPayload(s), fe = this.netConfig.MinGasLimit + this.netConfig.GasPerDataByte * o.length() + this.innerTransaction.getGasLimit().valueOf();
    let me = new transaction_1$5.Transaction({
      nonce: this.relayerNonce,
      sender: this.relayerAddress,
      receiver: this.innerTransaction.getSender(),
      value: 0,
      gasLimit: fe,
      data: o,
      chainID: this.netConfig.ChainID,
      version: this.relayedTransactionVersion,
      options: this.relayedTransactionOptions,
      guardian: this.relayedTransactionGuardian
    });
    return this.relayerNonce && me.setNonce(this.relayerNonce), me;
  }
  prepareInnerTransaction() {
    if (!this.innerTransaction)
      return "";
    const e = {
      nonce: this.innerTransaction.getNonce().valueOf(),
      sender: new address_1$d.Address(this.innerTransaction.getSender().bech32()).pubkey().toString("base64"),
      receiver: new address_1$d.Address(this.innerTransaction.getReceiver().bech32()).pubkey().toString("base64"),
      value: new bignumber_js_1$f.default(this.innerTransaction.getValue().toString(), 10).toNumber(),
      gasPrice: this.innerTransaction.getGasPrice().valueOf(),
      gasLimit: this.innerTransaction.getGasLimit().valueOf(),
      data: this.innerTransaction.getData().valueOf().toString("base64"),
      signature: this.innerTransaction.getSignature().toString("base64"),
      chainID: Buffer.from(this.innerTransaction.getChainID().valueOf()).toString("base64"),
      version: this.innerTransaction.getVersion().valueOf(),
      options: this.innerTransaction.getOptions().valueOf() == 0 ? void 0 : this.innerTransaction.getOptions().valueOf(),
      guardian: this.innerTransaction.getGuardian().bech32() ? new address_1$d.Address(this.innerTransaction.getGuardian().bech32()).pubkey().toString("base64") : void 0,
      guardianSignature: this.innerTransaction.getGuardianSignature().toString("hex") ? this.innerTransaction.getGuardianSignature().toString("base64") : void 0,
      sndUserName: this.innerTransaction.getSenderUsername() ? Buffer.from(this.innerTransaction.getSenderUsername()).toString("base64") : void 0,
      rcvUserName: this.innerTransaction.getReceiverUsername() ? Buffer.from(this.innerTransaction.getReceiverUsername()).toString("base64") : void 0
    };
    return JSON.stringify(e);
  }
}
relayedTransactionV1Builder.RelayedTransactionV1Builder = RelayedTransactionV1Builder;
var relayedTransactionV2Builder = {}, smartcontracts = {}, argSerializer = {}, codec$1 = {}, binary$1 = {}, typesystem = {}, abiRegistry = {}, endpoint = {}, typeExpressionParser = {}, types$2 = {}, reflection = {};
Object.defineProperty(reflection, "__esModule", { value: !0 });
reflection.getJavascriptPrototypesInHierarchy = void 0;
function getJavascriptPrototypesInHierarchy(r, e) {
  let s = [], o = Object.getPrototypeOf(r);
  for (; o && e(o); )
    s.push(o), o = Object.getPrototypeOf(o);
  return s;
}
reflection.getJavascriptPrototypesInHierarchy = getJavascriptPrototypesInHierarchy;
Object.defineProperty(types$2, "__esModule", { value: !0 });
types$2.NullType = types$2.TypePlaceholder = types$2.isTyped = types$2.PrimitiveValue = types$2.TypedValue = types$2.CustomType = types$2.PrimitiveType = types$2.TypeCardinality = types$2.Type = void 0;
const reflection_1 = reflection, utils_1$a = utils$a;
class Type {
  constructor(e, s = [], o = TypeCardinality.fixed(1)) {
    utils_1$a.guardValueIsSet("name", e), this.name = e, this.typeParameters = s, this.cardinality = o;
  }
  getName() {
    return this.name;
  }
  getClassName() {
    return Type.ClassName;
  }
  getClassHierarchy() {
    return reflection_1.getJavascriptPrototypesInHierarchy(this, (o) => o.belongsToTypesystem).map((o) => o.getClassName()).reverse();
  }
  getFullyQualifiedName() {
    let e = this.getTypeParameters().map((s) => s.getFullyQualifiedName()).join(", ");
    return this.isGenericType() ? `multiversx:types:${this.getName()}<${e}>` : `multiversx:types:${this.getName()}`;
  }
  hasExactClass(e) {
    return this.getClassName() == e;
  }
  hasClassOrSuperclass(e) {
    return this.getClassHierarchy().includes(e);
  }
  getTypeParameters() {
    return this.typeParameters;
  }
  isGenericType() {
    return this.typeParameters.length > 0;
  }
  getFirstTypeParameter() {
    return utils_1$a.guardTrue(this.typeParameters.length > 0, "type parameters length > 0"), this.typeParameters[0];
  }
  toString() {
    let e = this.getTypeParameters().map((o) => o.toString()).join(", "), s = e ? `<${e}>` : "";
    return `${this.name}${s}`;
  }
  equals(e) {
    return Type.equals(this, e);
  }
  static equals(e, s) {
    return e.getFullyQualifiedName() == s.getFullyQualifiedName();
  }
  static equalsMany(e, s) {
    return e.every((o, fe) => o.equals(s[fe]));
  }
  static isAssignableFromMany(e, s) {
    return e.every((o, fe) => o.isAssignableFrom(s[fe]));
  }
  differs(e) {
    return !this.equals(e);
  }
  valueOf() {
    return this.name;
  }
  isAssignableFrom(e) {
    if (!Type.equalsMany(this.getTypeParameters(), e.getTypeParameters()))
      return !1;
    let o = this.getFullyQualifiedName();
    return Type.getFullyQualifiedNamesInHierarchy(e).includes(o) ? !0 : e.hasClassOrSuperclass(this.getClassName());
  }
  static getFullyQualifiedNamesInHierarchy(e) {
    return reflection_1.getJavascriptPrototypesInHierarchy(e, (fe) => fe.belongsToTypesystem).map((fe) => fe.getFullyQualifiedName.call(e));
  }
  getNamesOfDependencies() {
    const e = [];
    for (const s of this.typeParameters)
      e.push(s.getName()), e.push(...s.getNamesOfDependencies());
    return [...new Set(e)];
  }
  toJSON() {
    return {
      name: this.name,
      typeParameters: this.typeParameters.map((e) => e.toJSON())
    };
  }
  getCardinality() {
    return this.cardinality;
  }
  belongsToTypesystem() {
  }
}
types$2.Type = Type;
Type.ClassName = "Type";
class TypeCardinality {
  constructor(e, s) {
    this.lowerBound = e, this.upperBound = s;
  }
  static fixed(e) {
    return new TypeCardinality(e, e);
  }
  static variable(e) {
    return new TypeCardinality(0, e);
  }
  isSingular() {
    return this.lowerBound == 1 && this.upperBound == 1;
  }
  isSingularOrNone() {
    return this.lowerBound == 0 && this.upperBound == 1;
  }
  isComposite() {
    return this.upperBound != 1;
  }
  isFixed() {
    return this.lowerBound == this.upperBound;
  }
  getLowerBound() {
    return this.lowerBound;
  }
  getUpperBound() {
    return this.upperBound || TypeCardinality.MaxCardinality;
  }
}
types$2.TypeCardinality = TypeCardinality;
TypeCardinality.MaxCardinality = 4096;
class PrimitiveType extends Type {
  constructor(e) {
    super(e);
  }
  getClassName() {
    return PrimitiveType.ClassName;
  }
}
types$2.PrimitiveType = PrimitiveType;
PrimitiveType.ClassName = "PrimitiveType";
class CustomType extends Type {
  getClassName() {
    return CustomType.ClassName;
  }
}
types$2.CustomType = CustomType;
CustomType.ClassName = "CustomType";
class TypedValue {
  constructor(e) {
    this.type = e;
  }
  getClassName() {
    return TypedValue.ClassName;
  }
  getClassHierarchy() {
    return reflection_1.getJavascriptPrototypesInHierarchy(this, (o) => o.belongsToTypesystem).map((o) => o.getClassName()).reverse();
  }
  getType() {
    return this.type;
  }
  hasExactClass(e) {
    return this.getClassName() == e;
  }
  hasClassOrSuperclass(e) {
    return this.getClassHierarchy().includes(e);
  }
  belongsToTypesystem() {
  }
}
types$2.TypedValue = TypedValue;
TypedValue.ClassName = "TypedValue";
class PrimitiveValue extends TypedValue {
  constructor(e) {
    super(e);
  }
  getClassName() {
    return PrimitiveValue.ClassName;
  }
}
types$2.PrimitiveValue = PrimitiveValue;
PrimitiveValue.ClassName = "PrimitiveValue";
function isTyped(r) {
  return r.belongsToTypesystem !== void 0;
}
types$2.isTyped = isTyped;
class TypePlaceholder extends Type {
  constructor() {
    super("...");
  }
  getClassName() {
    return TypePlaceholder.ClassName;
  }
}
types$2.TypePlaceholder = TypePlaceholder;
TypePlaceholder.ClassName = "TypePlaceholder";
class NullType extends Type {
  constructor() {
    super("?");
  }
  getClassName() {
    return NullType.ClassName;
  }
}
types$2.NullType = NullType;
NullType.ClassName = "NullType";
var backslash$1 = { exports: {} };
const maxInt = 2147483647, base$1 = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", regexPunycode = /^xn--/, regexNonASCII = /[^\0-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, errors$h = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, baseMinusTMin = base$1 - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode;
function error(r) {
  throw new RangeError(errors$h[r]);
}
function map$2(r, e) {
  const s = [];
  let o = r.length;
  for (; o--; )
    s[o] = e(r[o]);
  return s;
}
function mapDomain(r, e) {
  const s = r.split("@");
  let o = "";
  s.length > 1 && (o = s[0] + "@", r = s[1]), r = r.replace(regexSeparators, ".");
  const fe = r.split("."), me = map$2(fe, e).join(".");
  return o + me;
}
function ucs2decode(r) {
  const e = [];
  let s = 0;
  const o = r.length;
  for (; s < o; ) {
    const fe = r.charCodeAt(s++);
    if (fe >= 55296 && fe <= 56319 && s < o) {
      const me = r.charCodeAt(s++);
      (me & 64512) == 56320 ? e.push(((fe & 1023) << 10) + (me & 1023) + 65536) : (e.push(fe), s--);
    } else
      e.push(fe);
  }
  return e;
}
const ucs2encode = (r) => String.fromCodePoint(...r), basicToDigit = function(r) {
  return r - 48 < 10 ? r - 22 : r - 65 < 26 ? r - 65 : r - 97 < 26 ? r - 97 : base$1;
}, digitToBasic = function(r, e) {
  return r + 22 + 75 * (r < 26) - ((e != 0) << 5);
}, adapt = function(r, e, s) {
  let o = 0;
  for (r = s ? floor(r / damp) : r >> 1, r += floor(r / e); r > baseMinusTMin * tMax >> 1; o += base$1)
    r = floor(r / baseMinusTMin);
  return floor(o + (baseMinusTMin + 1) * r / (r + skew));
}, decode$7 = function(r) {
  const e = [], s = r.length;
  let o = 0, fe = initialN, me = initialBias, ye = r.lastIndexOf(delimiter);
  ye < 0 && (ye = 0);
  for (let fr = 0; fr < ye; ++fr)
    r.charCodeAt(fr) >= 128 && error("not-basic"), e.push(r.charCodeAt(fr));
  for (let fr = ye > 0 ? ye + 1 : 0; fr < s; ) {
    let Er = o;
    for (let wr = 1, kr = base$1; ; kr += base$1) {
      fr >= s && error("invalid-input");
      const Gr = basicToDigit(r.charCodeAt(fr++));
      (Gr >= base$1 || Gr > floor((maxInt - o) / wr)) && error("overflow"), o += Gr * wr;
      const Vr = kr <= me ? tMin : kr >= me + tMax ? tMax : kr - me;
      if (Gr < Vr)
        break;
      const jr = base$1 - Vr;
      wr > floor(maxInt / jr) && error("overflow"), wr *= jr;
    }
    const br = e.length + 1;
    me = adapt(o - Er, br, Er == 0), floor(o / br) > maxInt - fe && error("overflow"), fe += floor(o / br), o %= br, e.splice(o++, 0, fe);
  }
  return String.fromCodePoint(...e);
}, encode$9 = function(r) {
  const e = [];
  r = ucs2decode(r);
  let s = r.length, o = initialN, fe = 0, me = initialBias;
  for (const Er of r)
    Er < 128 && e.push(stringFromCharCode(Er));
  let ye = e.length, fr = ye;
  for (ye && e.push(delimiter); fr < s; ) {
    let Er = maxInt;
    for (const wr of r)
      wr >= o && wr < Er && (Er = wr);
    const br = fr + 1;
    Er - o > floor((maxInt - fe) / br) && error("overflow"), fe += (Er - o) * br, o = Er;
    for (const wr of r)
      if (wr < o && ++fe > maxInt && error("overflow"), wr == o) {
        let kr = fe;
        for (let Gr = base$1; ; Gr += base$1) {
          const Vr = Gr <= me ? tMin : Gr >= me + tMax ? tMax : Gr - me;
          if (kr < Vr)
            break;
          const jr = kr - Vr, Kr = base$1 - Vr;
          e.push(
            stringFromCharCode(digitToBasic(Vr + jr % Kr, 0))
          ), kr = floor(jr / Kr);
        }
        e.push(stringFromCharCode(digitToBasic(kr, 0))), me = adapt(fe, br, fr == ye), fe = 0, ++fr;
      }
    ++fe, ++o;
  }
  return e.join("");
}, toUnicode = function(r) {
  return mapDomain(r, function(e) {
    return regexPunycode.test(e) ? decode$7(e.slice(4).toLowerCase()) : e;
  });
}, toASCII = function(r) {
  return mapDomain(r, function(e) {
    return regexNonASCII.test(e) ? "xn--" + encode$9(e) : e;
  });
}, punycode$1 = {
  version: "2.1.0",
  ucs2: {
    decode: ucs2decode,
    encode: ucs2encode
  },
  decode: decode$7,
  encode: encode$9,
  toASCII,
  toUnicode
}, punycode_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ucs2decode,
  ucs2encode,
  decode: decode$7,
  encode: encode$9,
  toASCII,
  toUnicode,
  default: punycode$1
}, Symbol.toStringTag, { value: "Module" })), require$$0$5 = /* @__PURE__ */ getAugmentedNamespace(punycode_es6);
var punycode = require$$0$5;
function BackslashError(r, e) {
  this.__proto__ = new Error(e), this.__proto__.name = "BackslashError", this.offset = r;
}
function isOctalDigit(r) {
  return r >= "0" && r <= "7";
}
function isHexDigit(r) {
  return r >= "0" && r <= "9" || r >= "a" && r <= "f" || r >= "A" && r <= "F";
}
function parseHex(r) {
  return r = parseInt(r, 16), punycode.ucs2.encode([r]);
}
function process$1(r, e, s) {
  var o = !1, fe = [];
  function me(Er) {
    var br = r[Er];
    if (!isHexDigit(br))
      throw new BackslashError(Er, "Unexpected token ILLEGAL");
    return br;
  }
  for (; e < r.length; ) {
    var ye = r[e];
    if (e++, o) {
      switch (o = !1, ye) {
        case "n":
          fe.push(`
`);
          continue;
        case "r":
          fe.push("\r");
          continue;
        case "f":
          fe.push("\f");
          continue;
        case "b":
          fe.push("\b");
          continue;
        case "t":
          fe.push("	");
          continue;
        case "v":
          fe.push("\v");
          continue;
        case "\\":
          fe.push("\\");
          continue;
      }
      if (ye === "x") {
        fe.push(parseHex(me(e) + me(e + 1))), e += 2;
        continue;
      }
      if (ye === "u") {
        fe.push(parseHex(me(e) + me(e + 1) + me(e + 2) + me(e + 3))), e += 4;
        continue;
      }
      if (isOctalDigit(ye)) {
        var fr;
        isOctalDigit(fr = r[e]) && (e++, ye += fr, isOctalDigit(fr = r[e]) && ye[0] <= "3" && (e++, ye += fr)), fe.push(punycode.ucs2.encode([parseInt(ye, 8)]));
        continue;
      }
      fe.push(ye);
    } else if (ye === "\\")
      o = !0;
    else if (ye === s) {
      e--;
      break;
    } else
      fe.push(ye);
  }
  return arguments.length === 3 ? { end: e, value: fe.join("") } : fe.join("");
}
backslash$1.exports = function r(e) {
  return process$1(e, 0);
};
backslash$1.exports.parseUntil = function r(e, s, o) {
  return process$1(e, s, o);
};
var backslash = backslash$1.exports, jsonDuplicateKeyHandle = {
  validate,
  parse: parse$i
};
function validate(r, e) {
  var s;
  if (e = e || !1, typeof r != "string")
    s = "Input must be a string";
  else
    try {
      _findValue(r, 0, e, !1);
    } catch (o) {
      s = o.message;
    }
  return s;
}
function parse$i(r, e) {
  if (typeof r != "string")
    throw new Error("Input must be a string");
  e = e || !1;
  var s = _findValue(r, 0, e, !0);
  return s.value;
}
function _findSeparator(r, e) {
  for (var s = r.length, o = e, fe, me = e; me < s; me++) {
    var ye = r[me];
    if (ye === ",") {
      fe = me;
      break;
    } else if (ye === "]" || ye === "}") {
      fe = me - 1;
      break;
    } else if (!_isWhiteSpace(ye))
      throw _syntaxError(r, me, "expecting end of expression or separator");
  }
  var fr;
  return fe === void 0 ? (fe = s, fr = r[fe]) : (fr = r[fe], fe++), {
    start: o,
    end: fe,
    value: fr
  };
}
function _findSemiColonSeparator(r, e) {
  for (var s = r.length, o = e, fe, me = e; me < s; me++) {
    var ye = r[me];
    if (ye === ":") {
      fe = me;
      break;
    } else if (!_isWhiteSpace(ye))
      throw _syntaxError(r, me, "expecting ':'");
  }
  if (fe === void 0)
    throw _syntaxError(r, me, "expecting ':'");
  return fe++, {
    start: o,
    end: fe
  };
}
function _findValue(r, e, s, o) {
  for (var fe = r.length, me, ye, fr = !1, Er = !1, br = !1, wr = !1, kr = !1, Gr = !1, Vr, jr = e; jr < fe; jr++) {
    var Kr = r[jr];
    if (me === void 0) {
      if (!_isWhiteSpace(Kr)) {
        if (Kr === "[")
          fr = !0;
        else if (Kr === "{")
          Er = !0;
        else if (Kr === '"')
          br = !0;
        else if (_isTrueFromIndex(r, jr)) {
          me = jr, jr = jr + 3, ye = jr, Vr = !0;
          break;
        } else if (_isFalseFromIndex(r, jr)) {
          me = jr, jr = jr + 4, ye = jr, Vr = !1;
          break;
        } else if (_isNullFromIndex(r, jr)) {
          me = jr, jr = jr + 3, ye = jr, Vr = null;
          break;
        } else if (_isNumber(Kr))
          wr = !0;
        else if (Kr === "-")
          wr = !0;
        else
          throw _syntaxError(r, jr, "");
        me = jr;
      }
    } else if (fr) {
      var bn = _findArray(r, jr, s, o);
      ye = bn.end, Vr = bn.value;
      break;
    } else if (Er) {
      var Yr = _findObject(r, jr, s, o);
      ye = Yr.end, Vr = Yr.value;
      break;
    } else if (br && Kr === '"' && _hasEvenNumberOfBackSlash(r, jr - 1)) {
      ye = jr, Vr = backslash(r.substring(me + 1, ye));
      break;
    } else if (wr)
      if (_isWhiteSpace(Kr))
        Gr = !0;
      else if (Kr === "," || Kr === "]" || Kr === "}") {
        Vr = parseFloat(r.substring(me, ye), 10), ye = jr - 1;
        break;
      } else {
        if (_isNumber(Kr) && !Gr)
          continue;
        if (Kr === "." && !kr && !Gr)
          kr = !0;
        else
          throw _syntaxError(r, jr, "expecting number");
      }
  }
  if (ye === void 0)
    if (wr)
      Vr = parseFloat(r.substring(me, jr), 10), ye = jr - 1;
    else
      throw _syntaxError(r, jr, "unclosed statement");
  return ye++, {
    value: Vr,
    start: me,
    end: ye
  };
}
function _findKey(r, e) {
  for (var s = r.length, o, fe, me = e; me < s; me++) {
    var ye = r[me];
    if (o === void 0) {
      if (!_isWhiteSpace(ye)) {
        if (ye !== '"')
          throw _syntaxError(r, me, "expecting String");
        o = me;
      }
    } else if (ye === '"' && _hasEvenNumberOfBackSlash(r, me - 1)) {
      fe = me;
      break;
    }
  }
  if (fe === void 0)
    throw _syntaxError(r, s, "expecting String");
  var fr = backslash(r.substring(o + 1, fe));
  if (fr === "")
    throw _syntaxError(r, o, "empty string");
  return fe++, {
    start: o,
    end: fe,
    value: fr
  };
}
function _findObject(r, e, s, o) {
  for (var fe = e, me = ",", ye = {}, fr = [], Er = [], br = e; _isWhiteSpace(r[br]); )
    br++;
  if (r[br] === "}")
    return {
      start: e,
      end: br,
      value: ye
    };
  for (; me === ","; ) {
    var wr = _findKey(r, fe), kr = _findSemiColonSeparator(r, wr.end), Gr = _findValue(r, kr.end, s, o), Vr = _findSeparator(r, Gr.end);
    s || fr.indexOf(wr.value) !== -1 && (wr.value = wr.value + "1"), fr.push(wr.value), Er.push(Gr.value), fe = Vr.end, me = Vr.value;
  }
  if (o) {
    var jr = 0;
    for (jr = 0; jr < fr.length; jr++)
      ye[fr[jr]] = Er[jr];
  }
  return {
    start: e,
    end: fe,
    value: ye
  };
}
function _hasEvenNumberOfBackSlash(r, e) {
  for (var s = e, o = 0; s > -1 && r[s] === "\\"; )
    o++, s--;
  return o % 2 === 0;
}
function _findArray(r, e, s, o) {
  for (var fe = e, me = ",", ye = [], fr = e; _isWhiteSpace(r[fr]); )
    fr++;
  if (r[fr] === "]")
    return {
      start: e,
      end: fr,
      value: ye
    };
  for (; me === ","; ) {
    var Er = _findValue(r, fe, s, o), br = _findSeparator(r, Er.end);
    o && ye.push(Er.value), fe = br.end, me = br.value;
  }
  return {
    start: e,
    end: fe,
    value: ye
  };
}
function _isTrueFromIndex(r, e) {
  return r.substr(e, 4) === "true";
}
function _isFalseFromIndex(r, e) {
  return r.substr(e, 5) === "false";
}
function _isNullFromIndex(r, e) {
  return r.substr(e, 4) === "null";
}
var white = new RegExp(/^\s$/);
function _isWhiteSpace(r) {
  return white.test(r);
}
var numberReg = new RegExp(/^\d$/);
function _isNumber(r) {
  return numberReg.test(r);
}
function _syntaxError(r, e, s) {
  var o = 10, fe;
  r.length < e + o ? fe = r.substr(_normalizeNegativeNumber(r.length - o), r.length) : e - o / 2 < 0 ? fe = r.substr(0, o) : fe = r.substr(_normalizeNegativeNumber(e - o / 2), o);
  var me;
  return s ? me = "Syntax error: " + s + " near " + fe : me = "Syntax error near " + fe, new Error(me);
}
function _normalizeNegativeNumber(r) {
  return r < 0 ? 0 : r;
}
var __createBinding$d = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$d = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$d = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$d(e, r, s);
  return __setModuleDefault$d(e, r), e;
};
Object.defineProperty(typeExpressionParser, "__esModule", { value: !0 });
typeExpressionParser.TypeExpressionParser = void 0;
const errors$g = __importStar$d(errors$q), types_1$h = types$2;
var jsonHandler = jsonDuplicateKeyHandle;
class TypeExpressionParser {
  parse(e) {
    let s = this.doParse(e), o = Object.keys(s);
    if (o.length != 1)
      throw new errors$g.ErrTypingSystem(`bad type expression: ${e}`);
    let fe = o[0];
    return this.nodeToType(fe, s[fe]);
  }
  doParse(e) {
    let s = this.getJsonedString(e);
    try {
      return jsonHandler.parse(s);
    } catch {
      throw new errors$g.ErrTypingSystem(`cannot parse type expression: ${e}. internal json: ${s}.`);
    }
  }
  getJsonedString(e) {
    let s = "";
    for (var o = 0; o < e.length; o++) {
      let ye = e.charAt(o), fr = e.charAt(o - 1), Er = e.charAt(o + 1);
      ye == "<" ? s += ": {" : ye == ">" ? fr != ">" ? s += ": {} }" : s += "}" : ye == "," ? Er == ">" || (fr == ">" ? s += "," : s += ": {},") : s += ye;
    }
    let fe = /(:|\{|\}|,|\s)/, me = s.replace(/utf\-8\sstring/ig, "utf-8-string").split(fe).filter((ye) => ye);
    return s = me.map((ye) => fe.test(ye) ? ye : `"${ye}"`).map((ye) => ye.replace(/utf\-8\-string/ig, "utf-8 string")).join(""), me.length == 1 ? `{${s}: {}}` : `{${s}}`;
  }
  nodeToType(e, s) {
    e.charAt(e.length - 1) === "1" && (e = e.slice(0, -1));
    let o = Object.keys(s).map((fe) => this.nodeToType(fe, s[fe]));
    return new types_1$h.Type(e, o);
  }
}
typeExpressionParser.TypeExpressionParser = TypeExpressionParser;
Object.defineProperty(endpoint, "__esModule", { value: !0 });
endpoint.EndpointParameterDefinition = endpoint.EndpointModifiers = endpoint.EndpointDefinition = void 0;
const typeExpressionParser_1$2 = typeExpressionParser, NamePlaceholder$1 = "?", DescriptionPlaceholder = "N / A";
class EndpointDefinition {
  constructor(e, s, o, fe) {
    this.input = [], this.output = [], this.name = e, this.input = s || [], this.output = o || [], this.modifiers = fe;
  }
  isConstructor() {
    return this.name == "constructor";
  }
  static fromJSON(e) {
    e.name = e.name == null ? NamePlaceholder$1 : e.name, e.onlyOwner = e.onlyOwner || !1, e.payableInTokens = e.payableInTokens || [], e.inputs = e.inputs || [], e.outputs = e.outputs || [];
    let s = e.inputs.map((me) => EndpointParameterDefinition.fromJSON(me)), o = e.outputs.map((me) => EndpointParameterDefinition.fromJSON(me)), fe = new EndpointModifiers(e.mutability, e.payableInTokens, e.onlyOwner);
    return new EndpointDefinition(e.name, s, o, fe);
  }
}
endpoint.EndpointDefinition = EndpointDefinition;
class EndpointModifiers {
  constructor(e, s, o) {
    this.mutability = e || "", this.payableInTokens = s || [], this.onlyOwner = o || !1;
  }
  isPayableInEGLD() {
    return this.isPayableInToken("EGLD");
  }
  isPayableInToken(e) {
    return this.payableInTokens.includes(e) ? !0 : this.payableInTokens.includes(`!${e}`) ? !1 : !!this.payableInTokens.includes("*");
  }
  isPayable() {
    return this.payableInTokens.length != 0;
  }
  isReadonly() {
    return this.mutability == "readonly";
  }
  isOnlyOwner() {
    return this.onlyOwner;
  }
}
endpoint.EndpointModifiers = EndpointModifiers;
class EndpointParameterDefinition {
  constructor(e, s, o) {
    this.name = e, this.description = s, this.type = o;
  }
  static fromJSON(e) {
    let s = new typeExpressionParser_1$2.TypeExpressionParser().parse(e.type);
    return new EndpointParameterDefinition(e.name || NamePlaceholder$1, e.description || DescriptionPlaceholder, s);
  }
}
endpoint.EndpointParameterDefinition = EndpointParameterDefinition;
var _enum$1 = {}, fields$1 = {}, __createBinding$c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$c = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$c = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$c(e, r, s);
  return __setModuleDefault$c(e, r), e;
};
Object.defineProperty(fields$1, "__esModule", { value: !0 });
fields$1.Fields = fields$1.Field = fields$1.FieldDefinition = void 0;
const errors$f = __importStar$c(errors$q), typeExpressionParser_1$1 = typeExpressionParser;
class FieldDefinition {
  constructor(e, s, o) {
    this.name = e, this.description = s, this.type = o;
  }
  static fromJSON(e) {
    let s = new typeExpressionParser_1$1.TypeExpressionParser().parse(e.type);
    return new FieldDefinition(e.name, e.description, s);
  }
}
fields$1.FieldDefinition = FieldDefinition;
class Field {
  constructor(e, s = "") {
    this.value = e, this.name = s;
  }
  checkTyping(e) {
    const s = this.value.getType();
    if (!s.equals(e.type))
      throw new errors$f.ErrTypingSystem(`check type of field "${e.name}; expected: ${e.type}, actual: ${s}"`);
    if (this.name != e.name)
      throw new errors$f.ErrTypingSystem(`check name of field "${e.name}"`);
  }
  equals(e) {
    return this.name == e.name && this.value.equals(e.value);
  }
}
fields$1.Field = Field;
class Fields {
  static checkTyping(e, s) {
    if (e.length != s.length)
      throw new errors$f.ErrTypingSystem("fields length vs. field definitions length");
    for (let o = 0; o < e.length; o++) {
      let fe = e[o], me = s[o];
      fe.checkTyping(me);
    }
  }
  static equals(e, s) {
    if (e.length != s.length)
      return !1;
    for (let o = 0; o < e.length; o++) {
      let fe = e[o], me = s[o];
      if (!fe.equals(me))
        return !1;
    }
    return !0;
  }
  static getNamesOfTypeDependencies(e) {
    const s = [];
    for (const o of e)
      s.push(o.type.getName()), s.push(...o.type.getNamesOfDependencies());
    return [...new Set(s)];
  }
}
fields$1.Fields = Fields;
Object.defineProperty(_enum$1, "__esModule", { value: !0 });
_enum$1.EnumValue = _enum$1.EnumVariantDefinition = _enum$1.EnumType = void 0;
const errors_1$f = errors$q, utils_1$9 = utils$a, fields_1$5 = fields$1, types_1$g = types$2, SimpleEnumMaxDiscriminant = 256;
class EnumType extends types_1$g.CustomType {
  constructor(e, s) {
    super(e), this.variants = [], this.variants = s;
  }
  getClassName() {
    return EnumType.ClassName;
  }
  static fromJSON(e) {
    const o = EnumType.assignMissingDiscriminants(e.variants || []).map((fe) => EnumVariantDefinition.fromJSON(fe));
    return new EnumType(e.name, o);
  }
  static assignMissingDiscriminants(e) {
    return e.every((o) => o.discriminant == null) ? e.map((o, fe) => Object.assign(Object.assign({}, o), { discriminant: fe })) : e;
  }
  getVariantByDiscriminant(e) {
    let s = this.variants.find((o) => o.discriminant == e);
    return utils_1$9.guardValueIsSet(`variant by discriminant (${e})`, s), s;
  }
  getVariantByName(e) {
    let s = this.variants.find((o) => o.name == e);
    return utils_1$9.guardValueIsSet(`variant by name (${e})`, s), s;
  }
  getNamesOfDependencies() {
    const e = [];
    for (const s of this.variants)
      e.push(...s.getNamesOfDependencies());
    return [...new Set(e)];
  }
}
_enum$1.EnumType = EnumType;
EnumType.ClassName = "EnumType";
class EnumVariantDefinition {
  constructor(e, s, o = []) {
    this.fieldsDefinitions = [], utils_1$9.guardTrue(s < SimpleEnumMaxDiscriminant, `discriminant for simple enum should be less than ${SimpleEnumMaxDiscriminant}`), this.name = e, this.discriminant = s, this.fieldsDefinitions = o;
  }
  static fromJSON(e) {
    let s = (e.fields || []).map((o) => fields_1$5.FieldDefinition.fromJSON(o));
    return new EnumVariantDefinition(e.name, e.discriminant, s);
  }
  getFieldsDefinitions() {
    return this.fieldsDefinitions;
  }
  getFieldDefinition(e) {
    return this.fieldsDefinitions.find((s) => s.name == e);
  }
  getNamesOfDependencies() {
    return fields_1$5.Fields.getNamesOfTypeDependencies(this.fieldsDefinitions);
  }
}
_enum$1.EnumVariantDefinition = EnumVariantDefinition;
class EnumValue extends types_1$g.TypedValue {
  constructor(e, s, o) {
    super(e), this.fields = [], this.name = s.name, this.discriminant = s.discriminant, this.fields = o, this.fieldsByName = new Map(o.map((me) => [me.name, me]));
    let fe = s.getFieldsDefinitions();
    fields_1$5.Fields.checkTyping(this.fields, fe);
  }
  getClassName() {
    return EnumValue.ClassName;
  }
  static fromName(e, s) {
    let o = e.getVariantByName(s);
    return new EnumValue(e, o, []);
  }
  static fromDiscriminant(e, s) {
    let o = e.getVariantByDiscriminant(s);
    return new EnumValue(e, o, []);
  }
  equals(e) {
    if (!this.getType().equals(e.getType()))
      return !1;
    let s = this.getFields(), o = e.getFields();
    const fe = this.name == e.name, me = this.discriminant == e.discriminant, ye = fields_1$5.Fields.equals(s, o);
    return fe && me && ye;
  }
  getFields() {
    return this.fields;
  }
  getFieldValue(e) {
    let s = this.fieldsByName.get(e);
    if (s)
      return s.value.valueOf();
    throw new errors_1$f.ErrMissingFieldOnEnum(e, this.getType().getName());
  }
  valueOf() {
    let e = { name: this.name, fields: [] };
    return this.fields.forEach((s, o) => e.fields[o] = s.value.valueOf()), e;
  }
}
_enum$1.EnumValue = EnumValue;
EnumValue.ClassName = "EnumValue";
var event = {};
Object.defineProperty(event, "__esModule", { value: !0 });
event.EventTopicDefinition = event.EventDefinition = void 0;
const typeExpressionParser_1 = typeExpressionParser, NamePlaceholder = "?";
class EventDefinition {
  constructor(e, s) {
    this.inputs = [], this.identifier = e, this.inputs = s || [];
  }
  static fromJSON(e) {
    e.identifier = e.identifier == null ? NamePlaceholder : e.identifier, e.inputs = e.inputs || [];
    const s = e.inputs.map((o) => EventTopicDefinition.fromJSON(o));
    return new EventDefinition(e.identifier, s);
  }
}
event.EventDefinition = EventDefinition;
class EventTopicDefinition {
  constructor(e) {
    this.name = e.name, this.type = e.type, this.indexed = e.indexed;
  }
  static fromJSON(e) {
    const s = new typeExpressionParser_1.TypeExpressionParser().parse(e.type);
    return new EventTopicDefinition({
      name: e.name || NamePlaceholder,
      type: s,
      indexed: e.indexed
    });
  }
}
event.EventTopicDefinition = EventTopicDefinition;
var struct$1 = {};
Object.defineProperty(struct$1, "__esModule", { value: !0 });
struct$1.Struct = struct$1.StructType = void 0;
const errors_1$e = errors$q, fields_1$4 = fields$1, types_1$f = types$2;
class StructType extends types_1$f.CustomType {
  constructor(e, s) {
    super(e), this.fieldsDefinitions = [], this.fieldsDefinitions = s;
  }
  getClassName() {
    return StructType.ClassName;
  }
  static fromJSON(e) {
    let s = (e.fields || []).map((o) => fields_1$4.FieldDefinition.fromJSON(o));
    return new StructType(e.name, s);
  }
  getFieldsDefinitions() {
    return this.fieldsDefinitions;
  }
  getFieldDefinition(e) {
    return this.fieldsDefinitions.find((s) => s.name == e);
  }
  getNamesOfDependencies() {
    return fields_1$4.Fields.getNamesOfTypeDependencies(this.fieldsDefinitions);
  }
}
struct$1.StructType = StructType;
StructType.ClassName = "StructType";
class Struct extends types_1$f.TypedValue {
  constructor(e, s) {
    super(e), this.fields = s, this.fieldsByName = new Map(s.map((o) => [o.name, o])), this.checkTyping();
  }
  getClassName() {
    return Struct.ClassName;
  }
  checkTyping() {
    let s = this.getType().getFieldsDefinitions();
    fields_1$4.Fields.checkTyping(this.fields, s);
  }
  getFields() {
    return this.fields;
  }
  getFieldValue(e) {
    let s = this.fieldsByName.get(e);
    if (s)
      return s.value.valueOf();
    throw new errors_1$e.ErrMissingFieldOnStruct(e, this.getType().getName());
  }
  valueOf() {
    let e = {};
    for (const s of this.fields)
      e[s.name] = s.value.valueOf();
    return e;
  }
  equals(e) {
    if (!this.getType().equals(e.getType()))
      return !1;
    let s = this.getFields(), o = e.getFields();
    return fields_1$4.Fields.equals(s, o);
  }
}
struct$1.Struct = Struct;
Struct.ClassName = "Struct";
var typeMapper = {}, address$1 = {};
Object.defineProperty(address$1, "__esModule", { value: !0 });
address$1.AddressValue = address$1.AddressType = void 0;
const address_1$c = address$2, types_1$e = types$2;
class AddressType extends types_1$e.PrimitiveType {
  constructor() {
    super("Address");
  }
  getClassName() {
    return AddressType.ClassName;
  }
}
address$1.AddressType = AddressType;
AddressType.ClassName = "AddressType";
class AddressValue extends types_1$e.PrimitiveValue {
  constructor(e) {
    super(new AddressType()), this.value = new address_1$c.Address(e.bech32());
  }
  getClassName() {
    return AddressValue.ClassName;
  }
  equals(e) {
    return this.value.equals(e.value);
  }
  valueOf() {
    return this.value;
  }
}
address$1.AddressValue = AddressValue;
AddressValue.ClassName = "AddressValue";
var algebraic = {};
Object.defineProperty(algebraic, "__esModule", { value: !0 });
algebraic.OptionalValue = algebraic.OptionalType = void 0;
const utils_1$8 = utils$a, types_1$d = types$2;
class OptionalType extends types_1$d.Type {
  constructor(e) {
    super("Optional", [e], types_1$d.TypeCardinality.variable(1));
  }
  getClassName() {
    return OptionalType.ClassName;
  }
  isAssignableFrom(e) {
    if (!e.hasExactClass(OptionalType.ClassName))
      return !1;
    let s = this.getFirstTypeParameter().equals(e.getFirstTypeParameter()), o = e.getFirstTypeParameter().hasExactClass(types_1$d.NullType.ClassName);
    return s || o;
  }
}
algebraic.OptionalType = OptionalType;
OptionalType.ClassName = "OptionalType";
class OptionalValue extends types_1$d.TypedValue {
  constructor(e, s = null) {
    super(e), this.value = s;
  }
  getClassName() {
    return OptionalValue.ClassName;
  }
  static newMissing() {
    let e = new OptionalType(new types_1$d.NullType());
    return new OptionalValue(e);
  }
  isSet() {
    return !!this.value;
  }
  getTypedValue() {
    return utils_1$8.guardValueIsSet("value", this.value), this.value;
  }
  valueOf() {
    return this.value ? this.value.valueOf() : null;
  }
  equals(e) {
    var s;
    return ((s = this.value) === null || s === void 0 ? void 0 : s.equals(e.value)) || !1;
  }
}
algebraic.OptionalValue = OptionalValue;
OptionalValue.ClassName = "OptionalValue";
var boolean$1 = {};
Object.defineProperty(boolean$1, "__esModule", { value: !0 });
boolean$1.BooleanValue = boolean$1.BooleanType = void 0;
const types_1$c = types$2;
class BooleanType extends types_1$c.PrimitiveType {
  constructor() {
    super("bool");
  }
  getClassName() {
    return BooleanType.ClassName;
  }
}
boolean$1.BooleanType = BooleanType;
BooleanType.ClassName = "BooleanType";
class BooleanValue extends types_1$c.PrimitiveValue {
  constructor(e) {
    super(new BooleanType()), this.value = e;
  }
  getClassName() {
    return BooleanValue.ClassName;
  }
  equals(e) {
    return this.value === e.value;
  }
  isTrue() {
    return this.value === !0;
  }
  isFalse() {
    return !this.isTrue();
  }
  valueOf() {
    return this.value;
  }
}
boolean$1.BooleanValue = BooleanValue;
BooleanValue.ClassName = "BooleanValue";
var bytes$1 = {};
Object.defineProperty(bytes$1, "__esModule", { value: !0 });
bytes$1.BytesValue = bytes$1.BytesType = void 0;
const types_1$b = types$2;
class BytesType extends types_1$b.PrimitiveType {
  constructor() {
    super("bytes");
  }
  getClassName() {
    return BytesType.ClassName;
  }
}
bytes$1.BytesType = BytesType;
BytesType.ClassName = "BytesType";
class BytesValue extends types_1$b.PrimitiveValue {
  constructor(e) {
    super(new BytesType()), this.value = e;
  }
  getClassName() {
    return BytesValue.ClassName;
  }
  static fromUTF8(e) {
    let s = Buffer.from(e, "utf-8");
    return new BytesValue(s);
  }
  static fromHex(e) {
    let s = Buffer.from(e, "hex");
    return new BytesValue(s);
  }
  getLength() {
    return this.value.length;
  }
  equals(e) {
    return this.getLength() != e.getLength() ? !1 : this.value.equals(e.value);
  }
  valueOf() {
    return this.value;
  }
  toString() {
    return this.value.toString();
  }
}
bytes$1.BytesValue = BytesValue;
BytesValue.ClassName = "BytesValue";
var codeMetadata$1 = {};
Object.defineProperty(codeMetadata$1, "__esModule", { value: !0 });
codeMetadata$1.CodeMetadataValue = codeMetadata$1.CodeMetadataType = void 0;
const types_1$a = types$2;
class CodeMetadataType extends types_1$a.PrimitiveType {
  constructor() {
    super("CodeMetadata");
  }
}
codeMetadata$1.CodeMetadataType = CodeMetadataType;
class CodeMetadataValue extends types_1$a.PrimitiveValue {
  constructor(e) {
    super(new CodeMetadataType()), this.value = e;
  }
  equals(e) {
    return this.value.equals(e.value);
  }
  valueOf() {
    return this.value;
  }
}
codeMetadata$1.CodeMetadataValue = CodeMetadataValue;
var composite = {};
Object.defineProperty(composite, "__esModule", { value: !0 });
composite.CompositeValue = composite.CompositeType = void 0;
const utils_1$7 = utils$a, types_1$9 = types$2;
class CompositeType extends types_1$9.Type {
  constructor(...e) {
    super("Composite", e, types_1$9.TypeCardinality.variable(e.length));
  }
  getClassName() {
    return CompositeType.ClassName;
  }
}
composite.CompositeType = CompositeType;
CompositeType.ClassName = "CompositeType";
class CompositeValue extends types_1$9.TypedValue {
  constructor(e, s) {
    super(e), utils_1$7.guardLength(s, e.getTypeParameters().length), this.items = s;
  }
  getClassName() {
    return CompositeValue.ClassName;
  }
  static fromItems(...e) {
    let s = e.map((fe) => fe.getType()), o = new CompositeType(...s);
    return new CompositeValue(o, e);
  }
  getItems() {
    return this.items;
  }
  valueOf() {
    return this.items.map((e) => e == null ? void 0 : e.valueOf());
  }
  equals(e) {
    if (this.getType().differs(e.getType()))
      return !1;
    for (let s = 0; s < this.items.length; s++) {
      let o = this.items[s], fe = e.items[s];
      if (!o.equals(fe))
        return !1;
    }
    return !0;
  }
}
composite.CompositeValue = CompositeValue;
CompositeValue.ClassName = "CompositeValue";
var generic = {}, collections = {};
Object.defineProperty(collections, "__esModule", { value: !0 });
collections.CollectionOfTypedValues = void 0;
class CollectionOfTypedValues {
  constructor(e) {
    this.items = e;
  }
  getLength() {
    return this.items.length;
  }
  getItems() {
    return this.items;
  }
  valueOf() {
    return this.items.map((e) => e.valueOf());
  }
  equals(e) {
    if (this.getLength() != e.getLength())
      return !1;
    for (let s = 0; s < this.getLength(); s++) {
      let o = this.items[s], fe = e.items[s];
      if (!o.equals(fe))
        return !1;
    }
    return !0;
  }
}
collections.CollectionOfTypedValues = CollectionOfTypedValues;
Object.defineProperty(generic, "__esModule", { value: !0 });
generic.List = generic.OptionValue = generic.ListType = generic.OptionType = void 0;
const utils_1$6 = utils$a, collections_1$1 = collections, types_1$8 = types$2;
class OptionType extends types_1$8.Type {
  constructor(e) {
    super("Option", [e]);
  }
  getClassName() {
    return OptionType.ClassName;
  }
  isAssignableFrom(e) {
    if (!e.hasExactClass(OptionType.ClassName))
      return !1;
    let s = this.getFirstTypeParameter().equals(e.getFirstTypeParameter()), o = e.getFirstTypeParameter().hasExactClass(types_1$8.NullType.ClassName);
    return s || o;
  }
}
generic.OptionType = OptionType;
OptionType.ClassName = "OptionType";
class ListType extends types_1$8.Type {
  constructor(e) {
    super("List", [e]);
  }
  getClassName() {
    return ListType.ClassName;
  }
}
generic.ListType = ListType;
ListType.ClassName = "ListType";
class OptionValue extends types_1$8.TypedValue {
  constructor(e, s = null) {
    super(e), this.value = s;
  }
  getClassName() {
    return OptionValue.ClassName;
  }
  static newMissing() {
    let e = new OptionType(new types_1$8.NullType());
    return new OptionValue(e);
  }
  static newMissingTyped(e) {
    return new OptionValue(new OptionType(e));
  }
  static newProvided(e) {
    let s = new OptionType(e.getType());
    return new OptionValue(s, e);
  }
  isSet() {
    return !!this.value;
  }
  getTypedValue() {
    return utils_1$6.guardValueIsSet("value", this.value), this.value;
  }
  valueOf() {
    return this.value ? this.value.valueOf() : null;
  }
  equals(e) {
    var s;
    return ((s = this.value) === null || s === void 0 ? void 0 : s.equals(e.value)) || !1;
  }
}
generic.OptionValue = OptionValue;
OptionValue.ClassName = "OptionValue";
class List extends types_1$8.TypedValue {
  constructor(e, s) {
    super(e), this.backingCollection = new collections_1$1.CollectionOfTypedValues(s);
  }
  getClassName() {
    return List.ClassName;
  }
  static fromItems(e) {
    if (e.length == 0)
      return new List(new types_1$8.TypePlaceholder(), []);
    let s = e[0].getType(), o = new ListType(s);
    return new List(o, e);
  }
  getLength() {
    return this.backingCollection.getLength();
  }
  getItems() {
    return this.backingCollection.getItems();
  }
  valueOf() {
    return this.backingCollection.valueOf();
  }
  equals(e) {
    return this.backingCollection.equals(e.backingCollection);
  }
}
generic.List = List;
List.ClassName = "List";
var genericArray = {};
Object.defineProperty(genericArray, "__esModule", { value: !0 });
genericArray.ArrayVec = genericArray.ArrayVecType = void 0;
const utils_1$5 = utils$a, collections_1 = collections, types_1$7 = types$2;
class ArrayVecType extends types_1$7.Type {
  constructor(e, s) {
    super("Array", [s]), utils_1$5.guardTrue(e > 0, "array length > 0"), this.length = e;
  }
  getClassName() {
    return ArrayVecType.ClassName;
  }
}
genericArray.ArrayVecType = ArrayVecType;
ArrayVecType.ClassName = "ArrayVecType";
class ArrayVec extends types_1$7.TypedValue {
  constructor(e, s) {
    super(e), utils_1$5.guardLength(s, e.length), this.backingCollection = new collections_1.CollectionOfTypedValues(s);
  }
  getClassName() {
    return ArrayVec.ClassName;
  }
  getLength() {
    return this.backingCollection.getLength();
  }
  getItems() {
    return this.backingCollection.getItems();
  }
  valueOf() {
    return this.backingCollection.valueOf();
  }
  equals(e) {
    return this.backingCollection.equals(e.backingCollection);
  }
}
genericArray.ArrayVec = ArrayVec;
ArrayVec.ClassName = "ArrayVec";
var h256$1 = {};
Object.defineProperty(h256$1, "__esModule", { value: !0 });
h256$1.H256Value = h256$1.H256Type = void 0;
const types_1$6 = types$2;
class H256Type extends types_1$6.PrimitiveType {
  constructor() {
    super("H256");
  }
  getClassName() {
    return H256Type.ClassName;
  }
}
h256$1.H256Type = H256Type;
H256Type.ClassName = "H256Type";
class H256Value extends types_1$6.PrimitiveValue {
  constructor(e) {
    super(new H256Type()), this.value = e;
  }
  getClassName() {
    return H256Value.ClassName;
  }
  equals(e) {
    return this.value.equals(e.value);
  }
  valueOf() {
    return this.value;
  }
}
h256$1.H256Value = H256Value;
H256Value.ClassName = "H256Value";
var nothing$1 = {};
Object.defineProperty(nothing$1, "__esModule", { value: !0 });
nothing$1.NothingValue = nothing$1.NothingType = void 0;
const types_1$5 = types$2;
class NothingType extends types_1$5.PrimitiveType {
  constructor() {
    super("nothing");
  }
  getClassName() {
    return NothingType.ClassName;
  }
}
nothing$1.NothingType = NothingType;
NothingType.ClassName = "NothingType";
class NothingValue extends types_1$5.PrimitiveValue {
  constructor() {
    super(new NothingType());
  }
  getClassName() {
    return NothingValue.ClassName;
  }
  equals(e) {
    return !1;
  }
  valueOf() {
    return {};
  }
}
nothing$1.NothingValue = NothingValue;
NothingValue.ClassName = "NothingValue";
var numerical$1 = {}, __createBinding$b = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$b = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$b = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$b(e, r, s);
  return __setModuleDefault$b(e, r), e;
}, __importDefault$h = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(numerical$1, "__esModule", { value: !0 });
numerical$1.BigIntValue = numerical$1.BigUIntValue = numerical$1.I64Value = numerical$1.U64Value = numerical$1.I32Value = numerical$1.U32Value = numerical$1.I16Value = numerical$1.U16Value = numerical$1.I8Value = numerical$1.U8Value = numerical$1.NumericalValue = numerical$1.BigIntType = numerical$1.BigUIntType = numerical$1.I64Type = numerical$1.U64Type = numerical$1.I32Type = numerical$1.U32Type = numerical$1.I16Type = numerical$1.U16Type = numerical$1.I8Type = numerical$1.U8Type = numerical$1.NumericalType = void 0;
const errors$e = __importStar$b(errors$q), types_1$4 = types$2, bignumber_js_1$e = __importDefault$h(require$$1$2);
class NumericalType extends types_1$4.PrimitiveType {
  constructor(e, s, o) {
    super(e), this.sizeInBytes = s, this.withSign = o;
  }
  getClassName() {
    return NumericalType.ClassName;
  }
  hasFixedSize() {
    return !!this.sizeInBytes;
  }
  hasArbitrarySize() {
    return !this.hasFixedSize();
  }
}
numerical$1.NumericalType = NumericalType;
NumericalType.ClassName = "NumericalType";
class U8Type extends NumericalType {
  constructor() {
    super("u8", 1, !1);
  }
  getClassName() {
    return U8Type.ClassName;
  }
}
numerical$1.U8Type = U8Type;
U8Type.ClassName = "U8Type";
class I8Type extends NumericalType {
  constructor() {
    super("i8", 1, !0);
  }
  getClassName() {
    return I8Type.ClassName;
  }
}
numerical$1.I8Type = I8Type;
I8Type.ClassName = "I8Type";
class U16Type extends NumericalType {
  constructor() {
    super("u16", 2, !1);
  }
  getClassName() {
    return U16Type.ClassName;
  }
}
numerical$1.U16Type = U16Type;
U16Type.ClassName = "U16Type";
class I16Type extends NumericalType {
  constructor() {
    super("i16", 2, !0);
  }
  getClassName() {
    return I16Type.ClassName;
  }
}
numerical$1.I16Type = I16Type;
I16Type.ClassName = "I16Type";
class U32Type extends NumericalType {
  constructor() {
    super("u32", 4, !1);
  }
  getClassName() {
    return U32Type.ClassName;
  }
}
numerical$1.U32Type = U32Type;
U32Type.ClassName = "U32Type";
class I32Type extends NumericalType {
  constructor() {
    super("i32", 4, !0);
  }
  getClassName() {
    return I32Type.ClassName;
  }
}
numerical$1.I32Type = I32Type;
I32Type.ClassName = "I32Type";
class U64Type extends NumericalType {
  constructor() {
    super("u64", 8, !1);
  }
  getClassName() {
    return U64Type.ClassName;
  }
}
numerical$1.U64Type = U64Type;
U64Type.ClassName = "U64Type";
class I64Type extends NumericalType {
  constructor() {
    super("i64", 8, !0);
  }
  getClassName() {
    return I64Type.ClassName;
  }
}
numerical$1.I64Type = I64Type;
I64Type.ClassName = "I64Type";
class BigUIntType extends NumericalType {
  constructor() {
    super("BigUint", 0, !1);
  }
  getClassName() {
    return BigUIntType.ClassName;
  }
}
numerical$1.BigUIntType = BigUIntType;
BigUIntType.ClassName = "BigUIntType";
class BigIntType extends NumericalType {
  constructor() {
    super("Bigint", 0, !0);
  }
  getClassName() {
    return BigIntType.ClassName;
  }
}
numerical$1.BigIntType = BigIntType;
BigIntType.ClassName = "BigIntType";
class NumericalValue extends types_1$4.PrimitiveValue {
  constructor(e, s) {
    if (super(e), this.value = new bignumber_js_1$e.default(s), this.sizeInBytes = e.sizeInBytes, this.withSign = e.withSign, this.value.isNaN())
      throw new errors$e.ErrInvalidArgument(`not a number: ${s}`);
    if (!this.withSign && this.value.isNegative())
      throw new errors$e.ErrInvalidArgument(`negative, but type is unsigned: ${s}`);
  }
  getClassName() {
    return NumericalValue.ClassName;
  }
  equals(e) {
    return this.value.isEqualTo(e.value);
  }
  valueOf() {
    return this.value;
  }
  toString() {
    return this.value.toString();
  }
}
numerical$1.NumericalValue = NumericalValue;
NumericalValue.ClassName = "NumericalValue";
class U8Value extends NumericalValue {
  constructor(e) {
    super(new U8Type(), new bignumber_js_1$e.default(e));
  }
  getClassName() {
    return U8Value.ClassName;
  }
}
numerical$1.U8Value = U8Value;
U8Value.ClassName = "U8Value";
class I8Value extends NumericalValue {
  constructor(e) {
    super(new I8Type(), new bignumber_js_1$e.default(e));
  }
  getClassName() {
    return I8Value.ClassName;
  }
}
numerical$1.I8Value = I8Value;
I8Value.ClassName = "I8Value";
class U16Value extends NumericalValue {
  constructor(e) {
    super(new U16Type(), new bignumber_js_1$e.default(e));
  }
  getClassName() {
    return U16Value.ClassName;
  }
}
numerical$1.U16Value = U16Value;
U16Value.ClassName = "U16Value";
class I16Value extends NumericalValue {
  constructor(e) {
    super(new I16Type(), new bignumber_js_1$e.default(e));
  }
  getClassName() {
    return I16Value.ClassName;
  }
}
numerical$1.I16Value = I16Value;
I16Value.ClassName = "I16Value";
class U32Value extends NumericalValue {
  constructor(e) {
    super(new U32Type(), new bignumber_js_1$e.default(e));
  }
  getClassName() {
    return U32Value.ClassName;
  }
}
numerical$1.U32Value = U32Value;
U32Value.ClassName = "U32Value";
class I32Value extends NumericalValue {
  constructor(e) {
    super(new I32Type(), new bignumber_js_1$e.default(e));
  }
  getClassName() {
    return I32Value.ClassName;
  }
}
numerical$1.I32Value = I32Value;
I32Value.ClassName = "I32Value";
class U64Value extends NumericalValue {
  constructor(e) {
    super(new U64Type(), e);
  }
  getClassName() {
    return U64Value.ClassName;
  }
}
numerical$1.U64Value = U64Value;
U64Value.ClassName = "U64Value";
class I64Value extends NumericalValue {
  constructor(e) {
    super(new I64Type(), e);
  }
  getClassName() {
    return I64Value.ClassName;
  }
}
numerical$1.I64Value = I64Value;
I64Value.ClassName = "I64Value";
class BigUIntValue extends NumericalValue {
  constructor(e) {
    super(new BigUIntType(), e);
  }
  getClassName() {
    return BigUIntValue.ClassName;
  }
}
numerical$1.BigUIntValue = BigUIntValue;
BigUIntValue.ClassName = "BigUIntValue";
class BigIntValue extends NumericalValue {
  constructor(e) {
    super(new BigIntType(), e);
  }
  getClassName() {
    return BigIntValue.ClassName;
  }
}
numerical$1.BigIntValue = BigIntValue;
BigIntValue.ClassName = "BigIntValue";
var string$2 = {};
Object.defineProperty(string$2, "__esModule", { value: !0 });
string$2.StringValue = string$2.StringType = void 0;
const types_1$3 = types$2;
class StringType extends types_1$3.PrimitiveType {
  constructor() {
    super("utf-8 string");
  }
  getClassName() {
    return StringType.ClassName;
  }
}
string$2.StringType = StringType;
StringType.ClassName = "StringType";
class StringValue extends types_1$3.PrimitiveValue {
  constructor(e) {
    super(new StringType()), this.value = e;
  }
  getClassName() {
    return StringValue.ClassName;
  }
  static fromUTF8(e) {
    return new StringValue(e);
  }
  static fromHex(e) {
    let s = Buffer.from(e, "hex").toString();
    return new StringValue(s);
  }
  getLength() {
    return this.value.length;
  }
  equals(e) {
    return this.value === e.value;
  }
  valueOf() {
    return this.value;
  }
}
string$2.StringValue = StringValue;
StringValue.ClassName = "StringValue";
var tokenIdentifier$1 = {};
Object.defineProperty(tokenIdentifier$1, "__esModule", { value: !0 });
tokenIdentifier$1.TokenIdentifierValue = tokenIdentifier$1.TokenIdentifierType = void 0;
const types_1$2 = types$2, EGLDTokenIdentifier$1 = "EGLD";
class TokenIdentifierType extends types_1$2.PrimitiveType {
  constructor() {
    super("TokenIdentifier");
  }
  getClassName() {
    return TokenIdentifierType.ClassName;
  }
}
tokenIdentifier$1.TokenIdentifierType = TokenIdentifierType;
TokenIdentifierType.ClassName = "TokenIdentifierType";
class TokenIdentifierValue extends types_1$2.PrimitiveValue {
  constructor(e) {
    super(new TokenIdentifierType()), this.value = e;
  }
  static egld() {
    return new TokenIdentifierValue(EGLDTokenIdentifier$1);
  }
  static esdtTokenIdentifier(e) {
    return new TokenIdentifierValue(e);
  }
  getClassName() {
    return TokenIdentifierValue.ClassName;
  }
  getLength() {
    return this.value.length;
  }
  equals(e) {
    return this.getLength() != e.getLength() ? !1 : this.value == e.value;
  }
  valueOf() {
    return this.value;
  }
  toString() {
    return this.value.toString();
  }
}
tokenIdentifier$1.TokenIdentifierValue = TokenIdentifierValue;
TokenIdentifierValue.ClassName = "TokenIdentifierValue";
var tuple$1 = {}, __createBinding$a = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$a = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$a = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$a(e, r, s);
  return __setModuleDefault$a(e, r), e;
};
Object.defineProperty(tuple$1, "__esModule", { value: !0 });
tuple$1.Tuple = tuple$1.TupleType = void 0;
const errors$d = __importStar$a(errors$q), fields_1$3 = fields$1, struct_1$5 = struct$1;
class TupleType extends struct_1$5.StructType {
  constructor(...e) {
    super(TupleType.prepareName(e), TupleType.prepareFieldDefinitions(e));
  }
  getClassName() {
    return TupleType.ClassName;
  }
  static prepareName(e) {
    return `tuple<${e.map((fe) => fe.toString()).join(", ")}>`;
  }
  static prepareFieldDefinitions(e) {
    return e.map((o, fe) => new fields_1$3.FieldDefinition(prepareFieldName(fe), "anonymous tuple field", o));
  }
}
tuple$1.TupleType = TupleType;
TupleType.ClassName = "TupleType";
function prepareFieldName(r) {
  return `field${r}`;
}
class Tuple extends struct_1$5.Struct {
  constructor(e, s) {
    super(e, s);
  }
  getClassName() {
    return Tuple.ClassName;
  }
  static fromItems(e) {
    if (e.length < 1)
      throw new errors$d.ErrTypingSystem("bad tuple items");
    let s = e.map((me) => me.getType()), o = new TupleType(...s), fe = e.map((me, ye) => new fields_1$3.Field(me, prepareFieldName(ye)));
    return new Tuple(o, fe);
  }
}
tuple$1.Tuple = Tuple;
Tuple.ClassName = "Tuple";
var variadic = {};
Object.defineProperty(variadic, "__esModule", { value: !0 });
variadic.VariadicValue = variadic.CountedVariadicType = variadic.VariadicType = void 0;
const types_1$1 = types$2;
class VariadicType extends types_1$1.Type {
  constructor(e, s = !1) {
    super("Variadic", [e], types_1$1.TypeCardinality.variable()), this.isCounted = s;
  }
  getClassName() {
    return VariadicType.ClassName;
  }
}
variadic.VariadicType = VariadicType;
VariadicType.ClassName = "VariadicType";
class CountedVariadicType extends types_1$1.Type {
  constructor(e) {
    super("Variadic", [e], types_1$1.TypeCardinality.variable());
  }
  getClassName() {
    return VariadicType.ClassName;
  }
}
variadic.CountedVariadicType = CountedVariadicType;
CountedVariadicType.ClassName = "VariadicType";
class VariadicValue extends types_1$1.TypedValue {
  constructor(e, s) {
    super(e), this.items = s;
  }
  getClassName() {
    return VariadicValue.ClassName;
  }
  static fromItems(...e) {
    return this.createFromItems(e, !1);
  }
  static fromItemsCounted(...e) {
    return this.createFromItems(e, !0);
  }
  static createFromItems(e, s) {
    if (e.length == 0)
      return new VariadicValue(new VariadicType(new types_1$1.TypePlaceholder(), s), []);
    const o = e[0].getType();
    return new VariadicValue(new VariadicType(o, s), e);
  }
  getItems() {
    return this.items;
  }
  valueOf() {
    return this.items.map((e) => e.valueOf());
  }
  equals(e) {
    if (this.getType().differs(e.getType()))
      return !1;
    for (let s = 0; s < this.items.length; s++) {
      let o = this.items[s], fe = e.items[s];
      if (!o.equals(fe))
        return !1;
    }
    return !0;
  }
}
variadic.VariadicValue = VariadicValue;
VariadicValue.ClassName = "VariadicValue";
var __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$9(e, r, s);
  return __setModuleDefault$9(e, r), e;
};
Object.defineProperty(typeMapper, "__esModule", { value: !0 });
typeMapper.TypeMapper = void 0;
const errors$c = __importStar$9(errors$q), address_1$b = address$1, algebraic_1$1 = algebraic, boolean_1$2 = boolean$1, bytes_1$5 = bytes$1, codeMetadata_1$1 = codeMetadata$1, composite_1$1 = composite, enum_1$3 = _enum$1, fields_1$2 = fields$1, generic_1$2 = generic, genericArray_1$1 = genericArray, h256_1$3 = h256$1, nothing_1$2 = nothing$1, numerical_1$2 = numerical$1, string_1$2 = string$2, struct_1$4 = struct$1, tokenIdentifier_1$4 = tokenIdentifier$1, tuple_1$2 = tuple$1, variadic_1$1 = variadic;
class TypeMapper {
  constructor(e = []) {
    this.openTypesFactories = /* @__PURE__ */ new Map([
      ["Option", (...s) => new generic_1$2.OptionType(s[0])],
      ["List", (...s) => new generic_1$2.ListType(s[0])],
      ["VarArgs", (...s) => new variadic_1$1.VariadicType(s[0])],
      ["MultiResultVec", (...s) => new variadic_1$1.VariadicType(s[0])],
      ["variadic", (...s) => new variadic_1$1.VariadicType(s[0])],
      ["counted-variadic", (...s) => new variadic_1$1.VariadicType(s[0], !0)],
      ["OptionalArg", (...s) => new algebraic_1$1.OptionalType(s[0])],
      ["optional", (...s) => new algebraic_1$1.OptionalType(s[0])],
      ["OptionalResult", (...s) => new algebraic_1$1.OptionalType(s[0])],
      ["multi", (...s) => new composite_1$1.CompositeType(...s)],
      ["MultiArg", (...s) => new composite_1$1.CompositeType(...s)],
      ["MultiResult", (...s) => new composite_1$1.CompositeType(...s)],
      ["multi", (...s) => new composite_1$1.CompositeType(...s)],
      ["tuple", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple2", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple3", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple4", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple5", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple6", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple7", (...s) => new tuple_1$2.TupleType(...s)],
      ["tuple8", (...s) => new tuple_1$2.TupleType(...s)],
      ["array2", (...s) => new genericArray_1$1.ArrayVecType(2, s[0])],
      ["array8", (...s) => new genericArray_1$1.ArrayVecType(8, s[0])],
      ["array16", (...s) => new genericArray_1$1.ArrayVecType(16, s[0])],
      ["array20", (...s) => new genericArray_1$1.ArrayVecType(20, s[0])],
      ["array32", (...s) => new genericArray_1$1.ArrayVecType(32, s[0])],
      ["array46", (...s) => new genericArray_1$1.ArrayVecType(46, s[0])],
      ["array48", (...s) => new genericArray_1$1.ArrayVecType(48, s[0])],
      ["array64", (...s) => new genericArray_1$1.ArrayVecType(64, s[0])],
      ["array128", (...s) => new genericArray_1$1.ArrayVecType(128, s[0])],
      ["array256", (...s) => new genericArray_1$1.ArrayVecType(256, s[0])]
    ]), this.closedTypesMap = /* @__PURE__ */ new Map([
      ["u8", new numerical_1$2.U8Type()],
      ["u16", new numerical_1$2.U16Type()],
      ["u32", new numerical_1$2.U32Type()],
      ["u64", new numerical_1$2.U64Type()],
      ["U64", new numerical_1$2.U64Type()],
      ["BigUint", new numerical_1$2.BigUIntType()],
      ["i8", new numerical_1$2.I8Type()],
      ["i16", new numerical_1$2.I16Type()],
      ["i32", new numerical_1$2.I32Type()],
      ["i64", new numerical_1$2.I64Type()],
      ["Bigint", new numerical_1$2.BigIntType()],
      ["BigInt", new numerical_1$2.BigIntType()],
      ["bool", new boolean_1$2.BooleanType()],
      ["bytes", new bytes_1$5.BytesType()],
      ["Address", new address_1$b.AddressType()],
      ["H256", new h256_1$3.H256Type()],
      ["utf-8 string", new string_1$2.StringType()],
      ["TokenIdentifier", new tokenIdentifier_1$4.TokenIdentifierType()],
      ["EgldOrEsdtTokenIdentifier", new tokenIdentifier_1$4.TokenIdentifierType()],
      ["CodeMetadata", new codeMetadata_1$1.CodeMetadataType()],
      ["nothing", new nothing_1$2.NothingType()],
      ["AsyncCall", new nothing_1$2.NothingType()]
    ]), this.learnedTypesMap = /* @__PURE__ */ new Map();
    for (const s of e)
      this.learnedTypesMap.set(s.getName(), s);
  }
  mapType(e) {
    let s = this.mapTypeRecursively(e);
    if (s)
      return s.isGenericType() || this.learnType(s), s;
    throw new errors$c.ErrTypingSystem(`Cannot map the type "${e.getName()}" to a known type`);
  }
  mapTypeRecursively(e) {
    let s = e.isGenericType(), o = this.learnedTypesMap.get(e.getName());
    if (o)
      return o;
    let fe = this.closedTypesMap.get(e.getName());
    return fe || (e.hasExactClass(enum_1$3.EnumType.ClassName) ? this.mapEnumType(e) : e.hasExactClass(struct_1$4.StructType.ClassName) ? this.mapStructType(e) : s ? this.mapGenericType(e) : null);
  }
  learnType(e) {
    this.learnedTypesMap.delete(e.getName()), this.learnedTypesMap.set(e.getName(), e);
  }
  mapStructType(e) {
    let s = this.mappedFields(e.getFieldsDefinitions());
    return new struct_1$4.StructType(e.getName(), s);
  }
  mapEnumType(e) {
    let s = e.variants.map((fe) => new enum_1$3.EnumVariantDefinition(fe.name, fe.discriminant, this.mappedFields(fe.getFieldsDefinitions())));
    return new enum_1$3.EnumType(e.getName(), s);
  }
  mappedFields(e) {
    return e.map((s) => new fields_1$2.FieldDefinition(s.name, s.description, this.mapType(s.type)));
  }
  mapGenericType(e) {
    let o = e.getTypeParameters().map((me) => this.mapType(me)), fe = this.openTypesFactories.get(e.getName());
    if (!fe)
      throw new errors$c.ErrTypingSystem(`Cannot map the generic type "${e.getName()}" to a known type`);
    return fe(...o);
  }
}
typeMapper.TypeMapper = TypeMapper;
var __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$8(e, r, s);
  return __setModuleDefault$8(e, r), e;
};
Object.defineProperty(abiRegistry, "__esModule", { value: !0 });
abiRegistry.AbiRegistry = void 0;
const errors$b = __importStar$8(errors$q), utils_1$4 = utils$a, endpoint_1 = endpoint, enum_1$2 = _enum$1, event_1 = event, struct_1$3 = struct$1, typeMapper_1 = typeMapper, interfaceNamePlaceholder = "?";
class AbiRegistry {
  constructor(e) {
    this.endpoints = [], this.customTypes = [], this.events = [], this.name = e.name, this.constructorDefinition = e.constructorDefinition, this.endpoints = e.endpoints, this.customTypes = e.customTypes, this.events = e.events || [];
  }
  static create(e) {
    const s = e.name || interfaceNamePlaceholder, o = e.constructor || {}, fe = e.endpoints || [], me = e.types || {}, ye = e.events || [], fr = endpoint_1.EndpointDefinition.fromJSON(Object.assign({ name: "constructor" }, o)), Er = fe.map((Vr) => endpoint_1.EndpointDefinition.fromJSON(Vr)), br = [];
    for (const Vr in me) {
      const jr = me[Vr];
      if (jr.type == "struct")
        br.push(struct_1$3.StructType.fromJSON({ name: Vr, fields: jr.fields }));
      else if (jr.type == "enum" || jr.type == "explicit-enum")
        br.push(enum_1$2.EnumType.fromJSON({ name: Vr, variants: jr.variants }));
      else
        throw new errors$b.ErrTypingSystem(`Cannot handle custom type: ${Vr}`);
    }
    const wr = ye.map((Vr) => event_1.EventDefinition.fromJSON(Vr));
    return new AbiRegistry({
      name: s,
      constructorDefinition: fr,
      endpoints: Er,
      customTypes: br,
      events: wr
    }).remapToKnownTypes();
  }
  getCustomType(e) {
    const s = this.customTypes.find((o) => o.getName() == e);
    return utils_1$4.guardValueIsSetWithMessage(`custom type [${e}] not found`, s), s;
  }
  getStruct(e) {
    const s = this.customTypes.find((o) => o.getName() == e && o.hasExactClass(struct_1$3.StructType.ClassName));
    return utils_1$4.guardValueIsSetWithMessage(`struct [${e}] not found`, s), s;
  }
  getStructs(e) {
    return e.map((s) => this.getStruct(s));
  }
  getEnum(e) {
    const s = this.customTypes.find((o) => o.getName() == e && o.hasExactClass(enum_1$2.EnumType.ClassName));
    return utils_1$4.guardValueIsSetWithMessage(`enum [${e}] not found`, s), s;
  }
  getEnums(e) {
    return e.map((s) => this.getEnum(s));
  }
  getEndpoints() {
    return this.endpoints;
  }
  getEndpoint(e) {
    const s = this.endpoints.find((o) => o.name == e);
    return utils_1$4.guardValueIsSetWithMessage(`endpoint [${e}] not found`, s), s;
  }
  getEvent(e) {
    const s = this.events.find((o) => o.identifier == e);
    return utils_1$4.guardValueIsSetWithMessage(`event [${e}] not found`, s), s;
  }
  remapToKnownTypes() {
    const e = new typeMapper_1.TypeMapper([]), s = [];
    for (const fr of this.customTypes)
      this.mapCustomTypeDepthFirst(fr, this.customTypes, e, s);
    if (this.customTypes.length != s.length)
      throw new errors$b.ErrTypingSystem("Did not re-map all custom types");
    const o = mapEndpoint(this.constructorDefinition, e), fe = [];
    for (const fr of this.endpoints)
      fe.push(mapEndpoint(fr, e));
    const me = this.events.map((fr) => mapEvent(fr, e));
    return new AbiRegistry({
      name: this.name,
      constructorDefinition: o,
      endpoints: fe,
      customTypes: s,
      events: me
    });
  }
  mapCustomTypeDepthFirst(e, s, o, fe) {
    if (fe.findIndex((fr) => fr.getName() == e.getName()) >= 0)
      return;
    for (const fr of e.getNamesOfDependencies()) {
      const Er = s.find((br) => br.getName() == fr);
      !Er || this.mapCustomTypeDepthFirst(Er, s, o, fe);
    }
    const ye = o.mapType(e);
    fe.push(ye);
  }
}
abiRegistry.AbiRegistry = AbiRegistry;
function mapEndpoint(r, e) {
  const s = r.input.map((fe) => new endpoint_1.EndpointParameterDefinition(fe.name, fe.description, e.mapType(fe.type))), o = r.output.map((fe) => new endpoint_1.EndpointParameterDefinition(fe.name, fe.description, e.mapType(fe.type)));
  return new endpoint_1.EndpointDefinition(r.name, s, o, r.modifiers);
}
function mapEvent(r, e) {
  const s = r.inputs.map((o) => new event_1.EventTopicDefinition({
    name: o.name,
    type: e.mapType(o.type),
    indexed: o.indexed
  }));
  return new event_1.EventDefinition(r.identifier, s);
}
var factory = {};
Object.defineProperty(factory, "__esModule", { value: !0 });
factory.createListOfTokenIdentifiers = factory.createListOfAddresses = void 0;
const address_1$a = address$1, generic_1$1 = generic, tokenIdentifier_1$3 = tokenIdentifier$1;
function createListOfAddresses(r) {
  let e = r.map((o) => new address_1$a.AddressValue(o));
  return generic_1$1.List.fromItems(e);
}
factory.createListOfAddresses = createListOfAddresses;
function createListOfTokenIdentifiers(r) {
  let e = r.map((o) => new tokenIdentifier_1$3.TokenIdentifierValue(o));
  return generic_1$1.List.fromItems(e);
}
factory.createListOfTokenIdentifiers = createListOfTokenIdentifiers;
var matchers = {}, __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$7(e, r, s);
  return __setModuleDefault$7(e, r), e;
};
Object.defineProperty(matchers, "__esModule", { value: !0 });
matchers.onPrimitiveTypeSelect = matchers.onPrimitiveValueSelect = matchers.onTypedValueSelect = matchers.onTypeSelect = void 0;
const errors$a = __importStar$7(errors$q), address_1$9 = address$1, boolean_1$1 = boolean$1, bytes_1$4 = bytes$1, enum_1$1 = _enum$1, generic_1 = generic, h256_1$2 = h256$1, numerical_1$1 = numerical$1, nothing_1$1 = nothing$1, struct_1$2 = struct$1, tokenIdentifier_1$2 = tokenIdentifier$1, tuple_1$1 = tuple$1, types_1 = types$2, genericArray_1 = genericArray, string_1$1 = string$2;
function onTypeSelect(r, e) {
  if (r.hasExactClass(generic_1.OptionType.ClassName))
    return e.onOption();
  if (r.hasExactClass(generic_1.ListType.ClassName))
    return e.onList();
  if (r.hasExactClass(genericArray_1.ArrayVecType.ClassName))
    return e.onArray();
  if (r.hasClassOrSuperclass(types_1.PrimitiveType.ClassName))
    return e.onPrimitive();
  if (r.hasExactClass(struct_1$2.StructType.ClassName))
    return e.onStruct();
  if (r.hasExactClass(tuple_1$1.TupleType.ClassName))
    return e.onTuple();
  if (r.hasExactClass(enum_1$1.EnumType.ClassName))
    return e.onEnum();
  if (e.onOther)
    return e.onOther();
  throw new errors$a.ErrTypingSystem(`type isn't known: ${r}`);
}
matchers.onTypeSelect = onTypeSelect;
function onTypedValueSelect(r, e) {
  if (r.hasClassOrSuperclass(types_1.PrimitiveValue.ClassName))
    return e.onPrimitive();
  if (r.hasExactClass(generic_1.OptionValue.ClassName))
    return e.onOption();
  if (r.hasExactClass(generic_1.List.ClassName))
    return e.onList();
  if (r.hasExactClass(genericArray_1.ArrayVec.ClassName))
    return e.onArray();
  if (r.hasExactClass(struct_1$2.Struct.ClassName))
    return e.onStruct();
  if (r.hasExactClass(tuple_1$1.Tuple.ClassName))
    return e.onTuple();
  if (r.hasExactClass(enum_1$1.EnumValue.ClassName))
    return e.onEnum();
  if (e.onOther)
    return e.onOther();
  throw new errors$a.ErrTypingSystem(`value isn't typed: ${r}`);
}
matchers.onTypedValueSelect = onTypedValueSelect;
function onPrimitiveValueSelect(r, e) {
  if (r.hasExactClass(boolean_1$1.BooleanValue.ClassName))
    return e.onBoolean();
  if (r.hasClassOrSuperclass(numerical_1$1.NumericalValue.ClassName))
    return e.onNumerical();
  if (r.hasExactClass(address_1$9.AddressValue.ClassName))
    return e.onAddress();
  if (r.hasExactClass(bytes_1$4.BytesValue.ClassName))
    return e.onBytes();
  if (r.hasExactClass(string_1$1.StringValue.ClassName))
    return e.onString();
  if (r.hasExactClass(h256_1$2.H256Value.ClassName))
    return e.onH256();
  if (r.hasExactClass(tokenIdentifier_1$2.TokenIdentifierValue.ClassName))
    return e.onTypeIdentifier();
  if (r.hasExactClass(nothing_1$1.NothingValue.ClassName))
    return e.onNothing();
  if (e.onOther)
    return e.onOther();
  throw new errors$a.ErrTypingSystem(`value isn't a primitive: ${r.getType()}`);
}
matchers.onPrimitiveValueSelect = onPrimitiveValueSelect;
function onPrimitiveTypeSelect(r, e) {
  if (r.hasExactClass(boolean_1$1.BooleanType.ClassName))
    return e.onBoolean();
  if (r.hasClassOrSuperclass(numerical_1$1.NumericalType.ClassName))
    return e.onNumerical();
  if (r.hasExactClass(address_1$9.AddressType.ClassName))
    return e.onAddress();
  if (r.hasExactClass(bytes_1$4.BytesType.ClassName))
    return e.onBytes();
  if (r.hasExactClass(string_1$1.StringType.ClassName))
    return e.onString();
  if (r.hasExactClass(h256_1$2.H256Type.ClassName))
    return e.onH256();
  if (r.hasExactClass(tokenIdentifier_1$2.TokenIdentifierType.ClassName))
    return e.onTokenIndetifier();
  if (r.hasExactClass(nothing_1$1.NothingType.ClassName))
    return e.onNothing();
  if (e.onOther)
    return e.onOther();
  throw new errors$a.ErrTypingSystem(`type isn't a known primitive: ${r}`);
}
matchers.onPrimitiveTypeSelect = onPrimitiveTypeSelect;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(abiRegistry, r), s(address$1, r), s(algebraic, r), s(boolean$1, r), s(bytes$1, r), s(composite, r), s(endpoint, r), s(_enum$1, r), s(factory, r), s(fields$1, r), s(generic, r), s(genericArray, r), s(h256$1, r), s(matchers, r), s(nothing$1, r), s(numerical$1, r), s(string$2, r), s(struct$1, r), s(tokenIdentifier$1, r), s(tuple$1, r), s(typeExpressionParser, r), s(typeMapper, r), s(types$2, r), s(variadic, r);
})(typesystem);
var option = {}, __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$6(e, r, s);
  return __setModuleDefault$6(e, r), e;
};
Object.defineProperty(option, "__esModule", { value: !0 });
option.OptionValueBinaryCodec = void 0;
const errors$9 = __importStar$6(errors$q), typesystem_1$g = typesystem;
class OptionValueBinaryCodec {
  constructor(e) {
    this.binaryCodec = e;
  }
  decodeNested(e, s) {
    if (e[0] == 0)
      return [typesystem_1$g.OptionValue.newMissingTyped(s), 1];
    if (e[0] != 1)
      throw new errors$9.ErrCodec("invalid buffer for optional value");
    let [o, fe] = this.binaryCodec.decodeNested(e.slice(1), s);
    return [typesystem_1$g.OptionValue.newProvided(o), fe + 1];
  }
  decodeTopLevel(e, s) {
    if (e.length == 0)
      return new typesystem_1$g.OptionValue(s);
    if (e[0] != 1)
      throw new errors$9.ErrCodec("invalid buffer for optional value");
    let [o, fe] = this.binaryCodec.decodeNested(e.slice(1), s);
    return new typesystem_1$g.OptionValue(s, o);
  }
  encodeNested(e) {
    return e.isSet() ? Buffer.concat([Buffer.from([1]), this.binaryCodec.encodeNested(e.getTypedValue())]) : Buffer.from([0]);
  }
  encodeTopLevel(e) {
    return e.isSet() ? Buffer.concat([Buffer.from([1]), this.binaryCodec.encodeNested(e.getTypedValue())]) : Buffer.from([]);
  }
}
option.OptionValueBinaryCodec = OptionValueBinaryCodec;
var primitive = {}, address = {};
Object.defineProperty(address, "__esModule", { value: !0 });
address.AddressBinaryCodec = void 0;
const address_1$8 = address$2, typesystem_1$f = typesystem;
class AddressBinaryCodec {
  decodeNested(e) {
    let s = e.slice(0, 32), o = new address_1$8.Address(s);
    return [new typesystem_1$f.AddressValue(o), 32];
  }
  decodeTopLevel(e) {
    let [s, o] = this.decodeNested(e);
    return s;
  }
  encodeNested(e) {
    return e.valueOf().pubkey();
  }
  encodeTopLevel(e) {
    return e.valueOf().pubkey();
  }
}
address.AddressBinaryCodec = AddressBinaryCodec;
var boolean = {}, __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$5(e, r, s);
  return __setModuleDefault$5(e, r), e;
};
Object.defineProperty(boolean, "__esModule", { value: !0 });
boolean.BooleanBinaryCodec = void 0;
const errors$8 = __importStar$5(errors$q), typesystem_1$e = typesystem;
class BooleanBinaryCodec {
  decodeNested(e) {
    let s = e.readUInt8(0);
    return [new typesystem_1$e.BooleanValue(s == BooleanBinaryCodec.TRUE), 1];
  }
  decodeTopLevel(e) {
    if (e.length > 1)
      throw new errors$8.ErrInvalidArgument("buffer should be of size <= 1");
    let s = e[0];
    return new typesystem_1$e.BooleanValue(s == BooleanBinaryCodec.TRUE);
  }
  encodeNested(e) {
    return e.isTrue() ? Buffer.from([BooleanBinaryCodec.TRUE]) : Buffer.from([BooleanBinaryCodec.FALSE]);
  }
  encodeTopLevel(e) {
    return e.isTrue() ? Buffer.from([BooleanBinaryCodec.TRUE]) : Buffer.from([]);
  }
}
boolean.BooleanBinaryCodec = BooleanBinaryCodec;
BooleanBinaryCodec.TRUE = 1;
BooleanBinaryCodec.FALSE = 0;
var numerical = {}, constants$b = {};
Object.defineProperty(constants$b, "__esModule", { value: !0 });
constants$b.SizeOfU32 = void 0;
constants$b.SizeOfU32 = 4;
var __importDefault$g = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(numerical, "__esModule", { value: !0 });
numerical.NumericalBinaryCodec = void 0;
const bignumber_js_1$d = __importDefault$g(require$$1$2), typesystem_1$d = typesystem, constants_1$a = constants$b, utils_1$3 = utils$b;
class NumericalBinaryCodec {
  decodeNested(e, s) {
    let o = 0, fe = s.sizeInBytes;
    fe || (o = constants_1$a.SizeOfU32, fe = e.readUInt32BE(0));
    let me = e.slice(o, o + fe), ye = this.decodeTopLevel(me, s), fr = fe + o;
    return [ye, fr];
  }
  decodeTopLevel(e, s) {
    let o = utils_1$3.cloneBuffer(e);
    if (e.length == 0)
      return new typesystem_1$d.NumericalValue(s, new bignumber_js_1$d.default(0));
    if (!s.withSign || utils_1$3.isMsbZero(o)) {
      let br = utils_1$3.bufferToBigInt(o);
      return new typesystem_1$d.NumericalValue(s, br);
    }
    utils_1$3.flipBufferBitsInPlace(o);
    let Er = utils_1$3.bufferToBigInt(o).multipliedBy(new bignumber_js_1$d.default(-1)).minus(new bignumber_js_1$d.default(1));
    return new typesystem_1$d.NumericalValue(s, Er);
  }
  encodeNested(e) {
    if (e.sizeInBytes)
      return this.encodeNestedFixedSize(e, e.sizeInBytes);
    let s = this.encodeTopLevel(e), o = Buffer.alloc(constants_1$a.SizeOfU32);
    return o.writeUInt32BE(s.length), Buffer.concat([o, s]);
  }
  encodeNestedFixedSize(e, s) {
    if (e.value.isZero())
      return Buffer.alloc(s, 0);
    if (!e.withSign) {
      const ye = utils_1$3.bigIntToBuffer(e.value), fr = Buffer.alloc(s - ye.length, 0);
      return Buffer.concat([fr, ye]);
    }
    if (e.value.isPositive()) {
      let ye = utils_1$3.bigIntToBuffer(e.value);
      utils_1$3.isMsbOne(ye) && (ye = utils_1$3.prependByteToBuffer(ye, 0));
      const fr = Buffer.alloc(s - ye.length, 0);
      return Buffer.concat([fr, ye]);
    }
    let o = e.value.plus(new bignumber_js_1$d.default(1)), fe = utils_1$3.bigIntToBuffer(o);
    utils_1$3.flipBufferBitsInPlace(fe), utils_1$3.isMsbZero(fe) && (fe = utils_1$3.prependByteToBuffer(fe, 255));
    const me = Buffer.alloc(s - fe.length, 255);
    return Buffer.concat([me, fe]);
  }
  encodeTopLevel(e) {
    let s = e.withSign;
    return e.value.isZero() ? Buffer.alloc(0) : s ? this.encodePrimitive(e) : utils_1$3.bigIntToBuffer(e.value);
  }
  encodePrimitive(e) {
    if (e.value.isPositive()) {
      let fe = utils_1$3.bigIntToBuffer(e.value);
      return utils_1$3.isMsbOne(fe) && (fe = utils_1$3.prependByteToBuffer(fe, 0)), fe;
    }
    let s = e.value.plus(new bignumber_js_1$d.default(1)), o = utils_1$3.bigIntToBuffer(s);
    return utils_1$3.flipBufferBitsInPlace(o), utils_1$3.isMsbZero(o) && (o = utils_1$3.prependByteToBuffer(o, 255)), o;
  }
}
numerical.NumericalBinaryCodec = NumericalBinaryCodec;
var h256 = {};
Object.defineProperty(h256, "__esModule", { value: !0 });
h256.H256BinaryCodec = void 0;
const h256_1$1 = h256$1;
class H256BinaryCodec {
  decodeNested(e) {
    let s = e.slice(0, 32);
    return [new h256_1$1.H256Value(s), 32];
  }
  decodeTopLevel(e) {
    let [s, o] = this.decodeNested(e);
    return s;
  }
  encodeNested(e) {
    return e.valueOf();
  }
  encodeTopLevel(e) {
    return e.valueOf();
  }
}
h256.H256BinaryCodec = H256BinaryCodec;
var bytes = {};
Object.defineProperty(bytes, "__esModule", { value: !0 });
bytes.BytesBinaryCodec = void 0;
const bytes_1$3 = bytes$1, constants_1$9 = constants$b;
class BytesBinaryCodec {
  decodeNested(e) {
    let s = e.readUInt32BE(0), o = e.slice(constants_1$9.SizeOfU32, constants_1$9.SizeOfU32 + s);
    return [new bytes_1$3.BytesValue(o), constants_1$9.SizeOfU32 + s];
  }
  decodeTopLevel(e) {
    return new bytes_1$3.BytesValue(e);
  }
  encodeNested(e) {
    let s = Buffer.alloc(constants_1$9.SizeOfU32);
    return s.writeUInt32BE(e.getLength()), Buffer.concat([s, e.valueOf()]);
  }
  encodeTopLevel(e) {
    return e.valueOf();
  }
}
bytes.BytesBinaryCodec = BytesBinaryCodec;
var tokenIdentifier = {};
Object.defineProperty(tokenIdentifier, "__esModule", { value: !0 });
tokenIdentifier.TokenIdentifierCodec = void 0;
const bytes_1$2 = bytes$1, tokenIdentifier_1$1 = tokenIdentifier$1, bytes_2$1 = bytes;
class TokenIdentifierCodec {
  constructor() {
    this.bytesCodec = new bytes_2$1.BytesBinaryCodec();
  }
  decodeNested(e) {
    let [s, o] = this.bytesCodec.decodeNested(e);
    return [new tokenIdentifier_1$1.TokenIdentifierValue(s.toString()), o];
  }
  decodeTopLevel(e) {
    let s = this.bytesCodec.decodeTopLevel(e);
    return new tokenIdentifier_1$1.TokenIdentifierValue(s.toString());
  }
  encodeNested(e) {
    let s = bytes_1$2.BytesValue.fromUTF8(e.valueOf());
    return this.bytesCodec.encodeNested(s);
  }
  encodeTopLevel(e) {
    return Buffer.from(e.valueOf());
  }
}
tokenIdentifier.TokenIdentifierCodec = TokenIdentifierCodec;
var nothing = {};
Object.defineProperty(nothing, "__esModule", { value: !0 });
nothing.NothingCodec = void 0;
const typesystem_1$c = typesystem;
class NothingCodec {
  decodeNested() {
    return [new typesystem_1$c.NothingValue(), 0];
  }
  decodeTopLevel() {
    return new typesystem_1$c.NothingValue();
  }
  encodeNested() {
    return Buffer.from([]);
  }
  encodeTopLevel() {
    return Buffer.from([]);
  }
}
nothing.NothingCodec = NothingCodec;
var string$1 = {};
Object.defineProperty(string$1, "__esModule", { value: !0 });
string$1.StringBinaryCodec = void 0;
const typesystem_1$b = typesystem, bytes_1$1 = bytes$1, bytes_2 = bytes;
class StringBinaryCodec {
  constructor() {
    this.bytesBinaryCodec = new bytes_2.BytesBinaryCodec();
  }
  decodeNested(e) {
    let [s, o] = this.bytesBinaryCodec.decodeNested(e);
    return [new typesystem_1$b.StringValue(s.valueOf().toString()), o];
  }
  decodeTopLevel(e) {
    return new typesystem_1$b.StringValue(e.toString());
  }
  encodeNested(e) {
    let s = bytes_1$1.BytesValue.fromUTF8(e.valueOf());
    return this.bytesBinaryCodec.encodeNested(s);
  }
  encodeTopLevel(e) {
    return Buffer.from(e.valueOf());
  }
}
string$1.StringBinaryCodec = StringBinaryCodec;
Object.defineProperty(primitive, "__esModule", { value: !0 });
primitive.PrimitiveBinaryCodec = void 0;
const typesystem_1$a = typesystem, address_1$7 = address, boolean_1 = boolean, numerical_1 = numerical, h256_1 = h256, bytes_1 = bytes, tokenIdentifier_1 = tokenIdentifier, nothing_1 = nothing, string_1 = string$1;
class PrimitiveBinaryCodec {
  constructor(e) {
    this.binaryCodec = e, this.booleanCodec = new boolean_1.BooleanBinaryCodec(), this.numericalCodec = new numerical_1.NumericalBinaryCodec(), this.addressCodec = new address_1$7.AddressBinaryCodec(), this.h256Codec = new h256_1.H256BinaryCodec(), this.bytesCodec = new bytes_1.BytesBinaryCodec(), this.stringCodec = new string_1.StringBinaryCodec(), this.tokenIdentifierCodec = new tokenIdentifier_1.TokenIdentifierCodec(), this.nothingCodec = new nothing_1.NothingCodec();
  }
  decodeNested(e, s) {
    return typesystem_1$a.onPrimitiveTypeSelect(s, {
      onBoolean: () => this.booleanCodec.decodeNested(e),
      onNumerical: () => this.numericalCodec.decodeNested(e, s),
      onAddress: () => this.addressCodec.decodeNested(e),
      onBytes: () => this.bytesCodec.decodeNested(e),
      onString: () => this.stringCodec.decodeNested(e),
      onH256: () => this.h256Codec.decodeNested(e),
      onTokenIndetifier: () => this.tokenIdentifierCodec.decodeNested(e),
      onNothing: () => this.nothingCodec.decodeNested()
    });
  }
  decodeTopLevel(e, s) {
    return typesystem_1$a.onPrimitiveTypeSelect(s, {
      onBoolean: () => this.booleanCodec.decodeTopLevel(e),
      onNumerical: () => this.numericalCodec.decodeTopLevel(e, s),
      onAddress: () => this.addressCodec.decodeTopLevel(e),
      onBytes: () => this.bytesCodec.decodeTopLevel(e),
      onString: () => this.stringCodec.decodeTopLevel(e),
      onH256: () => this.h256Codec.decodeTopLevel(e),
      onTokenIndetifier: () => this.tokenIdentifierCodec.decodeTopLevel(e),
      onNothing: () => this.nothingCodec.decodeTopLevel()
    });
  }
  encodeNested(e) {
    return typesystem_1$a.onPrimitiveValueSelect(e, {
      onBoolean: () => this.booleanCodec.encodeNested(e),
      onNumerical: () => this.numericalCodec.encodeNested(e),
      onAddress: () => this.addressCodec.encodeNested(e),
      onBytes: () => this.bytesCodec.encodeNested(e),
      onString: () => this.stringCodec.encodeNested(e),
      onH256: () => this.h256Codec.encodeNested(e),
      onTypeIdentifier: () => this.tokenIdentifierCodec.encodeNested(e),
      onNothing: () => this.nothingCodec.encodeNested()
    });
  }
  encodeTopLevel(e) {
    return typesystem_1$a.onPrimitiveValueSelect(e, {
      onBoolean: () => this.booleanCodec.encodeTopLevel(e),
      onNumerical: () => this.numericalCodec.encodeTopLevel(e),
      onAddress: () => this.addressCodec.encodeTopLevel(e),
      onBytes: () => this.bytesCodec.encodeTopLevel(e),
      onString: () => this.stringCodec.encodeTopLevel(e),
      onH256: () => this.h256Codec.encodeTopLevel(e),
      onTypeIdentifier: () => this.tokenIdentifierCodec.encodeTopLevel(e),
      onNothing: () => this.nothingCodec.encodeTopLevel()
    });
  }
}
primitive.PrimitiveBinaryCodec = PrimitiveBinaryCodec;
var list = {};
Object.defineProperty(list, "__esModule", { value: !0 });
list.ListBinaryCodec = void 0;
const typesystem_1$9 = typesystem, constants_1$8 = constants$b;
class ListBinaryCodec {
  constructor(e) {
    this.binaryCodec = e;
  }
  decodeNested(e, s) {
    let o = s.getFirstTypeParameter(), fe = [], me = e.readUInt32BE(0);
    this.binaryCodec.constraints.checkListLength(me);
    let ye = e, fr = constants_1$8.SizeOfU32;
    e = ye.slice(fr);
    for (let Er = 0; Er < me; Er++) {
      let [br, wr] = this.binaryCodec.decodeNested(e, o);
      fe.push(br), fr += wr, e = ye.slice(fr);
    }
    return [new typesystem_1$9.List(s, fe), fr];
  }
  decodeTopLevel(e, s) {
    let o = s.getFirstTypeParameter(), fe = [], me = e, ye = 0;
    for (; e.length > 0; ) {
      let [fr, Er] = this.binaryCodec.decodeNested(e, o);
      fe.push(fr), ye += Er, e = me.slice(ye), this.binaryCodec.constraints.checkListLength(fe.length);
    }
    return new typesystem_1$9.List(s, fe);
  }
  encodeNested(e) {
    this.binaryCodec.constraints.checkListLength(e.getLength());
    let s = Buffer.alloc(constants_1$8.SizeOfU32);
    s.writeUInt32BE(e.getLength());
    let o = [];
    for (const me of e.getItems()) {
      let ye = this.binaryCodec.encodeNested(me);
      o.push(ye);
    }
    return Buffer.concat([s, ...o]);
  }
  encodeTopLevel(e) {
    this.binaryCodec.constraints.checkListLength(e.getLength());
    let s = [];
    for (const fe of e.getItems()) {
      let me = this.binaryCodec.encodeNested(fe);
      s.push(me);
    }
    return Buffer.concat(s);
  }
}
list.ListBinaryCodec = ListBinaryCodec;
var struct = {}, fields = {};
Object.defineProperty(fields, "__esModule", { value: !0 });
fields.FieldsBinaryCodec = void 0;
const typesystem_1$8 = typesystem;
class FieldsBinaryCodec {
  constructor(e) {
    this.binaryCodec = e;
  }
  decodeNested(e, s) {
    let o = [], fe = 0;
    for (const me of s) {
      let [ye, fr] = this.binaryCodec.decodeNested(e, me.type);
      e = e.slice(fr), fe += fr;
      let Er = new typesystem_1$8.Field(ye, me.name);
      o.push(Er);
    }
    return [o, fe];
  }
  encodeNested(e) {
    let s = [];
    for (const o of e) {
      let fe = this.binaryCodec.encodeNested(o.value);
      s.push(fe);
    }
    return Buffer.concat(s);
  }
}
fields.FieldsBinaryCodec = FieldsBinaryCodec;
Object.defineProperty(struct, "__esModule", { value: !0 });
struct.StructBinaryCodec = void 0;
const typesystem_1$7 = typesystem, fields_1$1 = fields;
class StructBinaryCodec {
  constructor(e) {
    this.fieldsCodec = new fields_1$1.FieldsBinaryCodec(e);
  }
  decodeTopLevel(e, s) {
    let [o] = this.decodeNested(e, s);
    return o;
  }
  decodeNested(e, s) {
    let o = s.getFieldsDefinitions(), [fe, me] = this.fieldsCodec.decodeNested(e, o);
    return [new typesystem_1$7.Struct(s, fe), me];
  }
  encodeNested(e) {
    let s = e.getFields();
    return this.fieldsCodec.encodeNested(s);
  }
  encodeTopLevel(e) {
    return this.encodeNested(e);
  }
}
struct.StructBinaryCodec = StructBinaryCodec;
var _enum = {};
Object.defineProperty(_enum, "__esModule", { value: !0 });
_enum.EnumBinaryCodec = void 0;
const typesystem_1$6 = typesystem, fields_1 = fields;
class EnumBinaryCodec {
  constructor(e) {
    this.binaryCodec = e, this.fieldsCodec = new fields_1.FieldsBinaryCodec(e);
  }
  decodeTopLevel(e, s) {
    let [o] = this.decodeNested(e, s);
    return o;
  }
  decodeNested(e, s) {
    let [o, fe] = this.readDiscriminant(e);
    e = e.slice(fe);
    let me = s.getVariantByDiscriminant(o), ye = me.getFieldsDefinitions(), [fr, Er] = this.fieldsCodec.decodeNested(e, ye);
    return [new typesystem_1$6.EnumValue(s, me, fr), fe + Er];
  }
  readDiscriminant(e) {
    let [s, o] = this.binaryCodec.decodeNested(e, new typesystem_1$6.U8Type());
    return [s.valueOf(), o];
  }
  encodeNested(e) {
    let s = new typesystem_1$6.U8Value(e.discriminant), o = this.binaryCodec.encodeNested(s), fe = e.getFields(), me = this.fieldsCodec.encodeNested(fe);
    return Buffer.concat([o, me]);
  }
  encodeTopLevel(e) {
    let s = e.getFields(), o = s.length > 0, fe = this.fieldsCodec.encodeNested(s), me = new typesystem_1$6.U8Value(e.discriminant), ye = o ? this.binaryCodec.encodeNested(me) : this.binaryCodec.encodeTopLevel(me);
    return Buffer.concat([ye, fe]);
  }
}
_enum.EnumBinaryCodec = EnumBinaryCodec;
var tuple = {};
Object.defineProperty(tuple, "__esModule", { value: !0 });
tuple.TupleBinaryCodec = void 0;
const struct_1$1 = struct;
class TupleBinaryCodec {
  constructor(e) {
    this.structCodec = new struct_1$1.StructBinaryCodec(e);
  }
  decodeTopLevel(e, s) {
    return this.structCodec.decodeTopLevel(e, s);
  }
  decodeNested(e, s) {
    return this.structCodec.decodeNested(e, s);
  }
  encodeNested(e) {
    return this.structCodec.encodeNested(e);
  }
  encodeTopLevel(e) {
    return this.structCodec.encodeTopLevel(e);
  }
}
tuple.TupleBinaryCodec = TupleBinaryCodec;
var arrayVec = {};
Object.defineProperty(arrayVec, "__esModule", { value: !0 });
arrayVec.ArrayVecBinaryCodec = void 0;
const typesystem_1$5 = typesystem;
class ArrayVecBinaryCodec {
  constructor(e) {
    this.binaryCodec = e;
  }
  decodeNested(e, s) {
    let o = s.length, fe = s.getFirstTypeParameter(), me = [], ye = 0;
    for (let fr = 0; fr < o; fr++) {
      let [Er, br] = this.binaryCodec.decodeNested(e, fe);
      me.push(Er), ye += br, e = e.slice(br);
    }
    return [new typesystem_1$5.ArrayVec(s, me), ye];
  }
  decodeTopLevel(e, s) {
    let [o, fe] = this.decodeNested(e, s);
    return o;
  }
  encodeNested(e) {
    let s = [];
    for (const o of e.getItems()) {
      let fe = this.binaryCodec.encodeNested(o);
      s.push(fe);
    }
    return Buffer.concat(s);
  }
  encodeTopLevel(e) {
    return this.encodeNested(e);
  }
}
arrayVec.ArrayVecBinaryCodec = ArrayVecBinaryCodec;
var __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$4(e, r, s);
  return __setModuleDefault$4(e, r), e;
};
Object.defineProperty(binary$1, "__esModule", { value: !0 });
binary$1.BinaryCodecConstraints = binary$1.BinaryCodec = void 0;
const errors$7 = __importStar$4(errors$q), typesystem_1$4 = typesystem, utils_1$2 = utils$a, option_1 = option, primitive_1 = primitive, list_1 = list, struct_1 = struct, enum_1 = _enum, tuple_1 = tuple, arrayVec_1 = arrayVec;
class BinaryCodec {
  constructor(e = null) {
    this.constraints = e || new BinaryCodecConstraints(), this.optionCodec = new option_1.OptionValueBinaryCodec(this), this.listCodec = new list_1.ListBinaryCodec(this), this.arrayCodec = new arrayVec_1.ArrayVecBinaryCodec(this), this.primitiveCodec = new primitive_1.PrimitiveBinaryCodec(this), this.structCodec = new struct_1.StructBinaryCodec(this), this.tupleCodec = new tuple_1.TupleBinaryCodec(this), this.enumCodec = new enum_1.EnumBinaryCodec(this);
  }
  decodeTopLevel(e, s) {
    return this.constraints.checkBufferLength(e), typesystem_1$4.onTypeSelect(s, {
      onOption: () => this.optionCodec.decodeTopLevel(e, s.getFirstTypeParameter()),
      onList: () => this.listCodec.decodeTopLevel(e, s),
      onArray: () => this.arrayCodec.decodeTopLevel(e, s),
      onPrimitive: () => this.primitiveCodec.decodeTopLevel(e, s),
      onStruct: () => this.structCodec.decodeTopLevel(e, s),
      onTuple: () => this.tupleCodec.decodeTopLevel(e, s),
      onEnum: () => this.enumCodec.decodeTopLevel(e, s)
    });
  }
  decodeNested(e, s) {
    this.constraints.checkBufferLength(e);
    let [o, fe] = typesystem_1$4.onTypeSelect(s, {
      onOption: () => this.optionCodec.decodeNested(e, s.getFirstTypeParameter()),
      onList: () => this.listCodec.decodeNested(e, s),
      onArray: () => this.arrayCodec.decodeNested(e, s),
      onPrimitive: () => this.primitiveCodec.decodeNested(e, s),
      onStruct: () => this.structCodec.decodeNested(e, s),
      onTuple: () => this.tupleCodec.decodeNested(e, s),
      onEnum: () => this.enumCodec.decodeNested(e, s)
    });
    return [o, fe];
  }
  encodeNested(e) {
    return utils_1$2.guardTrue(e.getType().getCardinality().isSingular(), "singular cardinality, thus encodable type"), typesystem_1$4.onTypedValueSelect(e, {
      onPrimitive: () => this.primitiveCodec.encodeNested(e),
      onOption: () => this.optionCodec.encodeNested(e),
      onList: () => this.listCodec.encodeNested(e),
      onArray: () => this.arrayCodec.encodeNested(e),
      onStruct: () => this.structCodec.encodeNested(e),
      onTuple: () => this.tupleCodec.encodeNested(e),
      onEnum: () => this.enumCodec.encodeNested(e)
    });
  }
  encodeTopLevel(e) {
    return utils_1$2.guardTrue(e.getType().getCardinality().isSingular(), "singular cardinality, thus encodable type"), typesystem_1$4.onTypedValueSelect(e, {
      onPrimitive: () => this.primitiveCodec.encodeTopLevel(e),
      onOption: () => this.optionCodec.encodeTopLevel(e),
      onList: () => this.listCodec.encodeTopLevel(e),
      onArray: () => this.arrayCodec.encodeTopLevel(e),
      onStruct: () => this.structCodec.encodeTopLevel(e),
      onTuple: () => this.tupleCodec.encodeTopLevel(e),
      onEnum: () => this.enumCodec.encodeTopLevel(e)
    });
  }
}
binary$1.BinaryCodec = BinaryCodec;
class BinaryCodecConstraints {
  constructor(e) {
    this.maxBufferLength = (e == null ? void 0 : e.maxBufferLength) || 256e3, this.maxListLength = (e == null ? void 0 : e.maxListLength) || 128e3;
  }
  checkBufferLength(e) {
    if (e.length > this.maxBufferLength)
      throw new errors$7.ErrCodec(`Buffer too large: ${e.length} > ${this.maxBufferLength}`);
  }
  checkListLength(e) {
    if (e > this.maxListLength)
      throw new errors$7.ErrCodec(`List too large: ${e} > ${this.maxListLength}`);
  }
}
binary$1.BinaryCodecConstraints = BinaryCodecConstraints;
var binaryCodecUtils = {}, __importDefault$f = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(binaryCodecUtils, "__esModule", { value: !0 });
binaryCodecUtils.decodeBigNumber = binaryCodecUtils.decodeString = binaryCodecUtils.decodeBool = binaryCodecUtils.decodeUnsignedNumber = void 0;
const bignumber_js_1$c = __importDefault$f(require$$1$2), typesystem_1$3 = typesystem, binary_1$1 = binary$1, Codec$1 = new binary_1$1.BinaryCodec();
function decodeUnsignedNumber(r) {
  let e = Codec$1.decodeTopLevel(r, new typesystem_1$3.BigUIntType());
  return Number(e.valueOf());
}
binaryCodecUtils.decodeUnsignedNumber = decodeUnsignedNumber;
function decodeBool(r) {
  let e = Codec$1.decodeTopLevel(r, new typesystem_1$3.BooleanType());
  return Boolean(e.valueOf());
}
binaryCodecUtils.decodeBool = decodeBool;
function decodeString(r) {
  let e = Codec$1.decodeTopLevel(r, new typesystem_1$3.BytesType());
  return String(e.valueOf());
}
binaryCodecUtils.decodeString = decodeString;
function decodeBigNumber(r) {
  let e = Codec$1.decodeTopLevel(r, new typesystem_1$3.BigUIntType());
  return new bignumber_js_1$c.default(e.valueOf());
}
binaryCodecUtils.decodeBigNumber = decodeBigNumber;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(binary$1, r), s(binaryCodecUtils, r);
})(codec$1);
Object.defineProperty(argSerializer, "__esModule", { value: !0 });
argSerializer.ArgSerializer = void 0;
const constants_1$7 = constants$c, codec_1$2 = codec$1, typesystem_1$2 = typesystem, algebraic_1 = algebraic, composite_1 = composite, variadic_1 = variadic, defaultArgSerializerOptions = {
  codec: new codec_1$2.BinaryCodec()
};
class ArgSerializer {
  constructor(e) {
    e = Object.assign(Object.assign({}, defaultArgSerializerOptions), e), this.codec = e.codec;
  }
  stringToValues(e, s) {
    let o = this.stringToBuffers(e);
    return this.buffersToValues(o, s);
  }
  stringToBuffers(e) {
    return e.split(constants_1$7.ARGUMENTS_SEPARATOR).map((s) => Buffer.from(s, "hex"));
  }
  buffersToValues(e, s) {
    const o = this;
    e = e || [];
    let fe = [], me = 0, ye = e.length;
    for (let kr = 0; kr < s.length; kr++) {
      let Vr = s[kr].type, jr = fr(Vr);
      fe.push(jr);
    }
    function fr(kr) {
      if (kr.hasExactClass(algebraic_1.OptionalType.ClassName)) {
        const Vr = fr(kr.getFirstTypeParameter());
        return new algebraic_1.OptionalValue(kr, Vr);
      }
      if (kr.hasExactClass(variadic_1.VariadicType.ClassName))
        return Er(kr);
      if (kr.hasExactClass(composite_1.CompositeType.ClassName)) {
        const Vr = [];
        for (const jr of kr.getTypeParameters())
          Vr.push(fr(jr));
        return new composite_1.CompositeValue(kr, Vr);
      }
      return br(kr);
    }
    function Er(kr) {
      const Gr = kr, Vr = [];
      if (Gr.isCounted) {
        const jr = fr(new typesystem_1$2.U32Type()).valueOf().toNumber();
        for (let Kr = 0; Kr < jr; Kr++)
          Vr.push(fr(kr.getFirstTypeParameter()));
      } else
        for (; !wr(); )
          Vr.push(fr(kr.getFirstTypeParameter()));
      return new variadic_1.VariadicValue(Gr, Vr);
    }
    function br(kr) {
      if (wr())
        return null;
      let Gr = e[me++];
      return o.codec.decodeTopLevel(Gr, kr);
    }
    function wr() {
      return me >= ye;
    }
    return fe;
  }
  valuesToString(e) {
    let s = this.valuesToStrings(e), o = s.join(constants_1$7.ARGUMENTS_SEPARATOR), fe = s.length;
    return { argumentsString: o, count: fe };
  }
  valuesToStrings(e) {
    return this.valuesToBuffers(e).map((fe) => fe.toString("hex"));
  }
  valuesToBuffers(e) {
    const s = this, o = [];
    for (const ye of e)
      fe(ye);
    function fe(ye) {
      if (ye.hasExactClass(algebraic_1.OptionalValue.ClassName)) {
        const Er = ye;
        Er.isSet() && fe(Er.getTypedValue());
        return;
      }
      if (ye.hasExactClass(variadic_1.VariadicValue.ClassName)) {
        me(ye);
        return;
      }
      if (ye.hasExactClass(composite_1.CompositeValue.ClassName)) {
        const Er = ye;
        for (const br of Er.getItems())
          fe(br);
        return;
      }
      const fr = s.codec.encodeTopLevel(ye);
      o.push(fr);
    }
    function me(ye) {
      if (ye.getType().isCounted) {
        const Er = new typesystem_1$2.U32Value(ye.getItems().length);
        o.push(s.codec.encodeTopLevel(Er));
      }
      for (const Er of ye.getItems())
        fe(Er);
    }
    return o;
  }
}
argSerializer.ArgSerializer = ArgSerializer;
var code$1 = {};
Object.defineProperty(code$1, "__esModule", { value: !0 });
code$1.Code = void 0;
const createHasher = blake2b$1.exports, CODE_HASH_LENGTH = 32;
class Code {
  constructor(e) {
    this.hex = e;
  }
  static fromBuffer(e) {
    return new Code(e.toString("hex"));
  }
  static fromHex(e) {
    return new Code(e);
  }
  toString() {
    return this.hex;
  }
  valueOf() {
    return Buffer.from(this.hex, "hex");
  }
  computeHash() {
    const e = createHasher(CODE_HASH_LENGTH).update(this.valueOf()).digest();
    return Buffer.from(e);
  }
}
code$1.Code = Code;
var codeMetadata = {};
Object.defineProperty(codeMetadata, "__esModule", { value: !0 });
codeMetadata.CodeMetadata = void 0;
class CodeMetadata {
  constructor(e = !0, s = !1, o = !1, fe = !1) {
    this.upgradeable = e, this.readable = s, this.payable = o, this.payableBySc = fe;
  }
  static fromBuffer(e) {
    if (e.length < 2)
      throw new Error("Buffer is too short.");
    const s = e[0], o = e[1], fe = (s & CodeMetadata.ByteZero.Upgradeable) !== 0, me = (s & CodeMetadata.ByteZero.Readable) !== 0, ye = (o & CodeMetadata.ByteOne.Payable) !== 0, fr = (o & CodeMetadata.ByteOne.PayableBySc) !== 0;
    return new CodeMetadata(fe, me, ye, fr);
  }
  toggleUpgradeable(e) {
    this.upgradeable = e;
  }
  toggleReadable(e) {
    this.readable = e;
  }
  togglePayable(e) {
    this.payable = e;
  }
  togglePayableBySc(e) {
    this.payableBySc = e;
  }
  toBuffer() {
    let e = 0, s = 0;
    return this.upgradeable && (e |= CodeMetadata.ByteZero.Upgradeable), this.readable && (e |= CodeMetadata.ByteZero.Readable), this.payable && (s |= CodeMetadata.ByteOne.Payable), this.payableBySc && (s |= CodeMetadata.ByteOne.PayableBySc), Buffer.from([e, s]);
  }
  toString() {
    return this.toBuffer().toString("hex");
  }
  toJSON() {
    return {
      upgradeable: this.upgradeable,
      readable: this.readable,
      payable: this.payable,
      payableBySc: this.payableBySc
    };
  }
  equals(e) {
    return this.upgradeable == e.upgradeable && this.readable == e.readable && this.payable == e.payable && this.payableBySc == e.payableBySc;
  }
}
codeMetadata.CodeMetadata = CodeMetadata;
CodeMetadata.ByteZero = {
  Upgradeable: 1,
  Reserved2: 2,
  Readable: 4
};
CodeMetadata.ByteOne = {
  Reserved1: 1,
  Payable: 2,
  PayableBySc: 4
};
var _function = {}, __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$3(e, r, s);
  return __setModuleDefault$3(e, r), e;
};
Object.defineProperty(_function, "__esModule", { value: !0 });
_function.ContractFunction = void 0;
const errors$6 = __importStar$3(errors$q);
class ContractFunction {
  constructor(e) {
    if (this.name = e, e == null)
      throw new errors$6.ErrInvalidFunctionName();
  }
  static none() {
    return new ContractFunction("untitled");
  }
  toString() {
    return this.name;
  }
  valueOf() {
    return this.name;
  }
}
_function.ContractFunction = ContractFunction;
var interaction = {}, interactionChecker = {}, __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$2(e, r, s);
  return __setModuleDefault$2(e, r), e;
}, __importDefault$e = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(interactionChecker, "__esModule", { value: !0 });
interactionChecker.InteractionChecker = void 0;
const errors$5 = __importStar$2(errors$q), bignumber_js_1$b = __importDefault$e(require$$1$2);
class InteractionChecker {
  checkInteraction(e, s) {
    this.checkPayable(e, s), this.checkArguments(e, s);
  }
  checkPayable(e, s) {
    let o = !new bignumber_js_1$b.default(e.getValue().toString()).isZero(), fe = s.modifiers.isPayableInEGLD();
    if (o && !fe)
      throw new errors$5.ErrContractInteraction("cannot send EGLD value to non-payable");
  }
  checkArguments(e, s) {
    let o = s.input, fe = e.getArguments(), me = o.length, ye = fe.length;
    if (me != ye)
      throw new errors$5.ErrContractInteraction(`bad arguments, expected: ${me}, got: ${ye}`);
    for (let fr = 0; fr < me; fr++) {
      let Er = o[fr].type, wr = fe[fr].getType();
      if (!Er.isAssignableFrom(wr))
        throw new errors$5.ErrContractInteraction(`type mismatch at index ${fr}, expected: ${Er}, got: ${wr}`);
    }
  }
}
interactionChecker.InteractionChecker = InteractionChecker;
var query = {};
Object.defineProperty(query, "__esModule", { value: !0 });
query.Query = void 0;
const address_1$6 = address$2, argSerializer_1$2 = argSerializer;
class Query {
  constructor(e) {
    this.caller = e.caller || new address_1$6.Address(), this.address = e.address, this.func = e.func, this.args = e.args || [], this.value = e.value || 0;
  }
  getEncodedArguments() {
    return new argSerializer_1$2.ArgSerializer().valuesToStrings(this.args);
  }
}
query.Query = Query;
Object.defineProperty(interaction, "__esModule", { value: !0 });
interaction.Interaction = void 0;
const address_1$5 = address$2, compatibility_1$1 = compatibility, constants_1$6 = constants$c, function_1$1 = _function, interactionChecker_1 = interactionChecker, query_1$1 = query, typesystem_1$1 = typesystem;
class Interaction {
  constructor(e, s, o) {
    this.nonce = 0, this.value = "0", this.gasLimit = 0, this.gasPrice = void 0, this.chainID = "", this.querent = new address_1$5.Address(), this.sender = new address_1$5.Address(), this.isWithSingleESDTTransfer = !1, this.isWithSingleESDTNFTTransfer = !1, this.isWithMultiESDTNFTTransfer = !1, this.contract = e, this.function = s, this.args = o, this.tokenTransfers = new TokenTransfersWithinInteraction([], this);
  }
  getContractAddress() {
    return this.contract.getAddress();
  }
  getFunction() {
    return this.function;
  }
  getEndpoint() {
    return this.contract.getEndpoint(this.function);
  }
  getArguments() {
    return this.args;
  }
  getValue() {
    return this.value;
  }
  getTokenTransfers() {
    return this.tokenTransfers.getTransfers();
  }
  getGasLimit() {
    return this.gasLimit;
  }
  getExplicitReceiver() {
    return this.explicitReceiver;
  }
  buildTransaction() {
    compatibility_1$1.Compatibility.guardAddressIsSetAndNonZero(this.sender, "'sender' of interaction", "use interaction.withSender()");
    let e = this.explicitReceiver || this.contract.getAddress(), s = this.function, o = this.args;
    this.isWithSingleESDTTransfer ? (s = new function_1$1.ContractFunction(constants_1$6.ESDT_TRANSFER_FUNCTION_NAME), o = this.tokenTransfers.buildArgsForSingleESDTTransfer()) : this.isWithSingleESDTNFTTransfer ? (e = this.sender, s = new function_1$1.ContractFunction(constants_1$6.ESDTNFT_TRANSFER_FUNCTION_NAME), o = this.tokenTransfers.buildArgsForSingleESDTNFTTransfer()) : this.isWithMultiESDTNFTTransfer && (e = this.sender, s = new function_1$1.ContractFunction(constants_1$6.MULTI_ESDTNFT_TRANSFER_FUNCTION_NAME), o = this.tokenTransfers.buildArgsForMultiESDTNFTTransfer());
    let fe = this.contract.call({
      func: s,
      gasLimit: this.gasLimit,
      gasPrice: this.gasPrice,
      args: o,
      value: this.value,
      receiver: e,
      chainID: this.chainID,
      caller: this.sender
    });
    return fe.setNonce(this.nonce), fe;
  }
  buildQuery() {
    return new query_1$1.Query({
      address: this.contract.getAddress(),
      func: this.function,
      args: this.args,
      value: this.value,
      caller: this.querent
    });
  }
  withValue(e) {
    return this.value = e, this;
  }
  withSingleESDTTransfer(e) {
    return this.isWithSingleESDTTransfer = !0, this.tokenTransfers = new TokenTransfersWithinInteraction([e], this), this;
  }
  withSingleESDTNFTTransfer(e, s) {
    return this.isWithSingleESDTNFTTransfer = !0, this.tokenTransfers = new TokenTransfersWithinInteraction([e], this), s && (this.sender = s), this;
  }
  withMultiESDTNFTTransfer(e, s) {
    return this.isWithMultiESDTNFTTransfer = !0, this.tokenTransfers = new TokenTransfersWithinInteraction(e, this), s && (this.sender = s), this;
  }
  withGasLimit(e) {
    return this.gasLimit = e, this;
  }
  withGasPrice(e) {
    return this.gasPrice = e, this;
  }
  withNonce(e) {
    return this.nonce = e, this;
  }
  useThenIncrementNonceOf(e) {
    return this.withNonce(e.getNonceThenIncrement());
  }
  withChainID(e) {
    return this.chainID = e, this;
  }
  withSender(e) {
    return this.sender = e, this;
  }
  withQuerent(e) {
    return this.querent = e, this;
  }
  withExplicitReceiver(e) {
    return this.explicitReceiver = e, this;
  }
  check() {
    return new interactionChecker_1.InteractionChecker().checkInteraction(this, this.getEndpoint()), this;
  }
}
interaction.Interaction = Interaction;
class TokenTransfersWithinInteraction {
  constructor(e, s) {
    this.transfers = e, this.interaction = s;
  }
  getTransfers() {
    return this.transfers;
  }
  buildArgsForSingleESDTTransfer() {
    let e = this.transfers[0];
    return [
      this.getTypedTokenIdentifier(e),
      this.getTypedTokenQuantity(e),
      this.getTypedInteractionFunction(),
      ...this.getInteractionArguments()
    ];
  }
  buildArgsForSingleESDTNFTTransfer() {
    let e = this.transfers[0];
    return [
      this.getTypedTokenIdentifier(e),
      this.getTypedTokenNonce(e),
      this.getTypedTokenQuantity(e),
      this.getTypedTokensReceiver(),
      this.getTypedInteractionFunction(),
      ...this.getInteractionArguments()
    ];
  }
  buildArgsForMultiESDTNFTTransfer() {
    let e = [];
    e.push(this.getTypedTokensReceiver()), e.push(this.getTypedNumberOfTransfers());
    for (const s of this.transfers)
      e.push(this.getTypedTokenIdentifier(s)), e.push(this.getTypedTokenNonce(s)), e.push(this.getTypedTokenQuantity(s));
    return e.push(this.getTypedInteractionFunction()), e.push(...this.getInteractionArguments()), e;
  }
  getTypedNumberOfTransfers() {
    return new typesystem_1$1.U8Value(this.transfers.length);
  }
  getTypedTokenIdentifier(e) {
    return typesystem_1$1.BytesValue.fromUTF8(e.tokenIdentifier);
  }
  getTypedTokenNonce(e) {
    return new typesystem_1$1.U64Value(e.nonce);
  }
  getTypedTokenQuantity(e) {
    return new typesystem_1$1.BigUIntValue(e.amountAsBigInteger);
  }
  getTypedTokensReceiver() {
    return new typesystem_1$1.AddressValue(this.interaction.getContractAddress());
  }
  getTypedInteractionFunction() {
    return typesystem_1$1.BytesValue.fromUTF8(this.interaction.getFunction().valueOf());
  }
  getInteractionArguments() {
    return this.interaction.getArguments();
  }
}
var _interface = {};
Object.defineProperty(_interface, "__esModule", { value: !0 });
var nativeSerializer = {}, argumentErrorContext = {};
Object.defineProperty(argumentErrorContext, "__esModule", { value: !0 });
argumentErrorContext.ArgumentErrorContext = void 0;
const errors_1$d = errors$q;
class ArgumentErrorContext {
  constructor(e, s, o) {
    this.endpointName = e, this.argumentIndex = s, this.parameterDefinition = o;
  }
  throwError(e) {
    throw new errors_1$d.ErrInvalidArgument(`Error when converting arguments for endpoint (endpoint name: ${this.endpointName}, argument index: ${this.argumentIndex}, name: ${this.parameterDefinition.name}, type: ${this.parameterDefinition.type})
Nested error: ${e}`);
  }
  convertError(e, s) {
    this.throwError(`Can't convert argument (argument: ${e}, type ${typeof e}), wanted type: ${s})`);
  }
  unhandledType(e, s) {
    this.throwError(`Unhandled type (function: ${e}, type: ${s})`);
  }
  guardSameLength(e, s) {
    e = e || [], e.length != s.length && this.throwError(`Incorrect composite type length: have ${e.length}, expected ${s.length} (argument: ${e})`);
  }
  guardHasField(e, s) {
    e = e || {}, s in e || this.throwError(`Struct argument does not contain a field named "${s}" (argument: ${JSON.stringify(e)})`);
  }
}
argumentErrorContext.ArgumentErrorContext = ArgumentErrorContext;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__importDefault || function(Er) {
    return Er && Er.__esModule ? Er : { default: Er };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.NativeSerializer = void 0;
  const s = e(require$$1$2), o = address$2, fe = errors$q, me = utils_codec, ye = argumentErrorContext, fr = typesystem;
  (function(Er) {
    function br(Nn, En) {
      Nn = Nn || [], wr(Nn, En), kr(En) && (Nn = Gr(Nn, En));
      let qr = En.input, Jr = [];
      for (let ri = 0; ri < qr.length; ri++) {
        let Sn = qr[ri], ai = new ye.ArgumentErrorContext(En.name, ri, Sn), di = jr(Nn[ri], Sn.type, ai);
        Jr.push(di);
      }
      return Jr;
    }
    Er.nativeToTypedValues = br;
    function wr(Nn, En) {
      const { min: qr, max: Jr } = Vr(En.input);
      if (!(qr <= Nn.length && Nn.length <= Jr))
        throw new fe.ErrInvalidArgument(`Wrong number of arguments for endpoint ${En.name}: expected between ${qr} and ${Jr} arguments, have ${Nn.length}`);
    }
    function kr(Nn) {
      const En = Nn.input[Nn.input.length - 1];
      return (En == null ? void 0 : En.type) instanceof fr.VariadicType && !En.type.isCounted;
    }
    function Gr(Nn, En) {
      const qr = En.input.length - 1, Jr = Nn[qr];
      if (Jr != null && Jr.belongsToTypesystem) {
        if (!Jr.hasClassOrSuperclass(fr.VariadicValue.ClassName))
          throw new fe.ErrInvalidArgument(`Wrong argument type for endpoint ${En.name}: typed value provided; expected variadic type, have ${Jr.getClassName()}`);
      } else
        Nn[qr] = Nn.slice(qr);
      return Nn;
    }
    function Vr(Nn) {
      let En = [...Nn].reverse(), qr = Nn.length, Jr = Nn.length, ri = !1;
      En.length > 0 && En[0].type.getCardinality().isComposite() && (Jr = 1 / 0, ri = !0);
      for (let Sn of En) {
        if (Sn.type.getCardinality().isSingular())
          break;
        qr -= 1;
      }
      return { min: qr, max: Jr, variadic: ri };
    }
    function jr(Nn, En, qr) {
      if (Nn && Nn.belongsToTypesystem)
        return Nn;
      if (En instanceof fr.OptionType)
        return Kr(Nn, En, qr);
      if (En instanceof fr.OptionalType)
        return bn(Nn, En, qr);
      if (En instanceof fr.VariadicType)
        return Yr(Nn, En, qr);
      if (En instanceof fr.CompositeType)
        return ti(Nn, En, qr);
      if (En instanceof fr.TupleType)
        return On(Nn, En, qr);
      if (En instanceof fr.StructType)
        return ni(Nn, En, qr);
      if (En instanceof fr.ListType)
        return Zr(Nn, En, qr);
      if (En instanceof fr.PrimitiveType)
        return In(Nn, En, qr);
      if (En instanceof fr.EnumType)
        return Br(Nn, En, qr);
      qr.throwError(`convertToTypedValue: unhandled type ${En}`);
    }
    function Kr(Nn, En, qr) {
      if (Nn == null)
        return fr.OptionValue.newMissing();
      let Jr = jr(Nn, En.getFirstTypeParameter(), qr);
      return fr.OptionValue.newProvided(Jr);
    }
    function bn(Nn, En, qr) {
      if (Nn == null)
        return new fr.OptionalValue(En);
      let Jr = jr(Nn, En.getFirstTypeParameter(), qr);
      return new fr.OptionalValue(En, Jr);
    }
    function Yr(Nn, En, qr) {
      if (En.isCounted)
        throw new fe.ErrInvalidArgument('Counted variadic arguments must be explicitly typed. E.g. use "VariadicValue.fromItemsCounted()" or "new VariadicValue()"');
      Nn == null && (Nn = []), Nn.map === void 0 && qr.convertError(Nn, "Variadic");
      let Jr = Nn.map(function(ri) {
        return jr(ri, En.getFirstTypeParameter(), qr);
      });
      return new fr.VariadicValue(En, Jr);
    }
    function Zr(Nn, En, qr) {
      Nn.map === void 0 && qr.convertError(Nn, "List");
      let Jr = Nn.map(function(ri) {
        return jr(ri, En.getFirstTypeParameter(), qr);
      });
      return new fr.List(En, Jr);
    }
    function ti(Nn, En, qr) {
      let Jr = [], ri = En.getTypeParameters();
      qr.guardSameLength(Nn, ri);
      for (let Sn = 0; Sn < ri.length; Sn++)
        Jr.push(jr(Nn[Sn], ri[Sn], qr));
      return new fr.CompositeValue(En, Jr);
    }
    function On(Nn, En, qr) {
      let Jr = [];
      const ri = En.getFieldsDefinitions();
      qr.guardSameLength(Nn, ri);
      for (let Sn = 0; Sn < ri.length; Sn++)
        Jr.push(jr(Nn[Sn], ri[Sn].type, qr));
      return fr.Tuple.fromItems(Jr);
    }
    function ni(Nn, En, qr) {
      let Jr = [];
      const ri = En.getFieldsDefinitions();
      for (let Sn = 0; Sn < ri.length; Sn++) {
        const ai = ri[Sn].name;
        qr.guardHasField(Nn, ai);
        const di = Nn[ai], ii = jr(di, ri[Sn].type, qr);
        Jr.push(new fr.Field(ii, ai));
      }
      return new fr.Struct(En, Jr);
    }
    function In(Nn, En, qr) {
      if (En instanceof fr.NumericalType) {
        let Jr = new s.default(Nn);
        return oi(Jr, En, qr);
      }
      if (En instanceof fr.BytesType)
        return Hr(Nn, qr);
      if (En instanceof fr.AddressType)
        return new fr.AddressValue(ei(Nn, qr));
      if (En instanceof fr.BooleanType)
        return new fr.BooleanValue(Nn);
      if (En instanceof fr.TokenIdentifierType)
        return new fr.TokenIdentifierValue(Pn(Nn, qr));
      qr.throwError(`(function: toPrimitive) unsupported type ${En}`);
    }
    function Br(Nn, En, qr) {
      if (typeof Nn == "number")
        return fr.EnumValue.fromDiscriminant(En, Nn);
      if (typeof Nn == "string")
        return fr.EnumValue.fromName(En, Nn);
      if (typeof Nn == "object") {
        qr.guardHasField(Nn, "name");
        const Jr = En.getVariantByName(Nn.name);
        qr.guardHasField(Nn, "fields");
        const ri = Nn.fields, Sn = [], ai = Jr.getFieldsDefinitions();
        for (let di = 0; di < ai.length; di++) {
          const ii = ai[di].name;
          qr.guardHasField(ri, ii);
          const fi = ri[ii], Ei = jr(fi, ai[di].type, qr);
          Sn.push(new fr.Field(Ei, ii));
        }
        return new fr.EnumValue(En, Jr, Sn);
      }
      qr.throwError(`(function: toEnumValue) unsupported native type ${typeof Nn}`);
    }
    function Hr(Nn, En) {
      const qr = Nn.valueOf();
      if (Nn === void 0 && En.convertError(Nn, "BytesValue"), Nn instanceof Buffer)
        return new fr.BytesValue(Nn);
      if (typeof Nn == "string")
        return fr.BytesValue.fromUTF8(Nn);
      if (qr instanceof Buffer)
        return new fr.BytesValue(qr);
      if (typeof qr == "number")
        return fr.BytesValue.fromHex(me.numberToPaddedHex(qr));
      En.convertError(Nn, "BytesValue");
    }
    function Pn(Nn, En) {
      if (Nn === void 0 && En.convertError(Nn, "Buffer"), Nn instanceof Buffer)
        return Nn.toString();
      if (typeof Nn == "string")
        return Nn;
      En.convertError(Nn, "Buffer");
    }
    function ei(Nn, En) {
      if (Nn.bech32)
        return Nn;
      if (Nn.getAddress)
        return Nn.getAddress();
      switch (Nn.constructor) {
        case Buffer:
        case String:
          return new o.Address(Nn);
        default:
          En.convertError(Nn, "Address");
      }
    }
    Er.convertNativeToAddress = ei;
    function oi(Nn, En, qr) {
      switch (En.constructor) {
        case fr.U8Type:
          return new fr.U8Value(Nn);
        case fr.I8Type:
          return new fr.I8Value(Nn);
        case fr.U16Type:
          return new fr.U16Value(Nn);
        case fr.I16Type:
          return new fr.I16Value(Nn);
        case fr.U32Type:
          return new fr.U32Value(Nn);
        case fr.I32Type:
          return new fr.I32Value(Nn);
        case fr.U64Type:
          return new fr.U64Value(Nn);
        case fr.I64Type:
          return new fr.I64Value(Nn);
        case fr.BigUIntType:
          return new fr.BigUIntValue(Nn);
        case fr.BigIntType:
          return new fr.BigIntValue(Nn);
        default:
          qr.unhandledType("convertNumericalType", En);
      }
    }
  })(r.NativeSerializer || (r.NativeSerializer = {}));
})(nativeSerializer);
var resultsParser = {}, transaction_decoder = {}, dist = {};
Object.defineProperty(dist, "__esModule", { value: !0 });
dist.bech32m = dist.bech32 = void 0;
const ALPHABET$1 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP = {};
for (let r = 0; r < ALPHABET$1.length; r++) {
  const e = ALPHABET$1.charAt(r);
  ALPHABET_MAP[e] = r;
}
function polymodStep(r) {
  const e = r >> 25;
  return (r & 33554431) << 5 ^ -(e >> 0 & 1) & 996825010 ^ -(e >> 1 & 1) & 642813549 ^ -(e >> 2 & 1) & 513874426 ^ -(e >> 3 & 1) & 1027748829 ^ -(e >> 4 & 1) & 705979059;
}
function prefixChk(r) {
  let e = 1;
  for (let s = 0; s < r.length; ++s) {
    const o = r.charCodeAt(s);
    if (o < 33 || o > 126)
      return "Invalid prefix (" + r + ")";
    e = polymodStep(e) ^ o >> 5;
  }
  e = polymodStep(e);
  for (let s = 0; s < r.length; ++s) {
    const o = r.charCodeAt(s);
    e = polymodStep(e) ^ o & 31;
  }
  return e;
}
function convert$1(r, e, s, o) {
  let fe = 0, me = 0;
  const ye = (1 << s) - 1, fr = [];
  for (let Er = 0; Er < r.length; ++Er)
    for (fe = fe << e | r[Er], me += e; me >= s; )
      me -= s, fr.push(fe >> me & ye);
  if (o)
    me > 0 && fr.push(fe << s - me & ye);
  else {
    if (me >= e)
      return "Excess padding";
    if (fe << s - me & ye)
      return "Non-zero padding";
  }
  return fr;
}
function toWords(r) {
  return convert$1(r, 8, 5, !0);
}
function fromWordsUnsafe(r) {
  const e = convert$1(r, 5, 8, !1);
  if (Array.isArray(e))
    return e;
}
function fromWords(r) {
  const e = convert$1(r, 5, 8, !1);
  if (Array.isArray(e))
    return e;
  throw new Error(e);
}
function getLibraryFromEncoding(r) {
  let e;
  r === "bech32" ? e = 1 : e = 734539939;
  function s(ye, fr, Er) {
    if (Er = Er || 90, ye.length + 7 + fr.length > Er)
      throw new TypeError("Exceeds length limit");
    ye = ye.toLowerCase();
    let br = prefixChk(ye);
    if (typeof br == "string")
      throw new Error(br);
    let wr = ye + "1";
    for (let kr = 0; kr < fr.length; ++kr) {
      const Gr = fr[kr];
      if (Gr >> 5 !== 0)
        throw new Error("Non 5-bit word");
      br = polymodStep(br) ^ Gr, wr += ALPHABET$1.charAt(Gr);
    }
    for (let kr = 0; kr < 6; ++kr)
      br = polymodStep(br);
    br ^= e;
    for (let kr = 0; kr < 6; ++kr) {
      const Gr = br >> (5 - kr) * 5 & 31;
      wr += ALPHABET$1.charAt(Gr);
    }
    return wr;
  }
  function o(ye, fr) {
    if (fr = fr || 90, ye.length < 8)
      return ye + " too short";
    if (ye.length > fr)
      return "Exceeds length limit";
    const Er = ye.toLowerCase(), br = ye.toUpperCase();
    if (ye !== Er && ye !== br)
      return "Mixed-case string " + ye;
    ye = Er;
    const wr = ye.lastIndexOf("1");
    if (wr === -1)
      return "No separator character for " + ye;
    if (wr === 0)
      return "Missing prefix for " + ye;
    const kr = ye.slice(0, wr), Gr = ye.slice(wr + 1);
    if (Gr.length < 6)
      return "Data too short";
    let Vr = prefixChk(kr);
    if (typeof Vr == "string")
      return Vr;
    const jr = [];
    for (let Kr = 0; Kr < Gr.length; ++Kr) {
      const bn = Gr.charAt(Kr), Yr = ALPHABET_MAP[bn];
      if (Yr === void 0)
        return "Unknown character " + bn;
      Vr = polymodStep(Vr) ^ Yr, !(Kr + 6 >= Gr.length) && jr.push(Yr);
    }
    return Vr !== e ? "Invalid checksum for " + ye : { prefix: kr, words: jr };
  }
  function fe(ye, fr) {
    const Er = o(ye, fr);
    if (typeof Er == "object")
      return Er;
  }
  function me(ye, fr) {
    const Er = o(ye, fr);
    if (typeof Er == "object")
      return Er;
    throw new Error(Er);
  }
  return {
    decodeUnsafe: fe,
    decode: me,
    encode: s,
    toWords,
    fromWordsUnsafe,
    fromWords
  };
}
dist.bech32 = getLibraryFromEncoding("bech32");
dist.bech32m = getLibraryFromEncoding("bech32m");
Object.defineProperty(transaction_decoder, "__esModule", { value: !0 });
transaction_decoder.TokenTransferProperties = transaction_decoder.TransactionMetadataTransfer = transaction_decoder.TransactionMetadata = transaction_decoder.TransactionToDecode = transaction_decoder.TransactionDecoder = void 0;
const bech32_1 = dist;
class TransactionDecoder {
  getTransactionMetadata(e) {
    const s = this.getNormalTransactionMetadata(e), o = this.getEsdtTransactionMetadata(s);
    if (o)
      return o;
    const fe = this.getNftTransferMetadata(s);
    if (fe)
      return fe;
    const me = this.getMultiTransferMetadata(s);
    return me || s;
  }
  getNormalTransactionMetadata(e) {
    const s = new TransactionMetadata();
    if (s.sender = e.sender, s.receiver = e.receiver, s.value = BigInt(e.value), e.data) {
      const fe = this.base64Decode(e.data).split("@"), me = fe.slice(1);
      if (me.every((ye) => this.isSmartContractArgument(ye)) && (s.functionName = fe[0], s.functionArgs = me), s.functionName === "relayedTx" && s.functionArgs && s.functionArgs.length === 1)
        try {
          const ye = JSON.parse(this.hexToString(s.functionArgs[0]));
          return ye.value = ye.value.toString(), ye.sender = this.bech32Encode(this.base64ToHex(ye.sender)), ye.receiver = this.bech32Encode(this.base64ToHex(ye.receiver)), this.getNormalTransactionMetadata(ye);
        } catch {
        }
      if (s.functionName === "relayedTxV2" && s.functionArgs && s.functionArgs.length === 4)
        try {
          const ye = new TransactionToDecode();
          return ye.sender = e.receiver, ye.receiver = this.bech32Encode(s.functionArgs[0]), ye.data = this.base64Encode(this.hexToString(s.functionArgs[2])), ye.value = "0", this.getNormalTransactionMetadata(ye);
        } catch {
        }
    }
    return s;
  }
  getMultiTransferMetadata(e) {
    if (e.sender !== e.receiver || e.functionName !== "MultiESDTNFTTransfer")
      return;
    const s = e.functionArgs;
    if (!s || s.length < 3 || !this.isAddressValid(s[0]))
      return;
    const o = this.bech32Encode(s[0]), fe = this.hexToNumber(s[1]), me = new TransactionMetadata();
    me.transfers || (me.transfers = []);
    let ye = 2;
    for (let fr = 0; fr < fe; fr++) {
      const Er = this.hexToString(s[ye++]), br = s[ye++], wr = this.hexToBigInt(s[ye++]);
      br ? me.transfers.push({
        value: wr,
        properties: {
          collection: Er,
          identifier: `${Er}-${br}`
        }
      }) : me.transfers.push({
        value: wr,
        properties: {
          token: Er
        }
      });
    }
    return me.sender = e.sender, me.receiver = o, s.length > ye && (me.functionName = this.hexToString(s[ye++]), me.functionArgs = s.slice(ye++)), me;
  }
  getNftTransferMetadata(e) {
    if (e.sender !== e.receiver || e.functionName !== "ESDTNFTTransfer")
      return;
    const s = e.functionArgs;
    if (!s || s.length < 4 || !this.isAddressValid(s[3]))
      return;
    const o = this.hexToString(s[0]), fe = s[1], me = this.hexToBigInt(s[2]), ye = this.bech32Encode(s[3]), fr = new TransactionMetadata();
    return fr.sender = e.sender, fr.receiver = ye, fr.value = me, s.length > 4 && (fr.functionName = this.hexToString(s[4]), fr.functionArgs = s.slice(5)), fr.transfers = [{
      value: me,
      properties: {
        collection: o,
        identifier: `${o}-${fe}`
      }
    }], fr;
  }
  base64Encode(e) {
    return Buffer.from(e).toString("base64");
  }
  base64Decode(e) {
    return Buffer.from(e, "base64").toString("binary");
  }
  hexToNumber(e) {
    return parseInt(e, 16);
  }
  getEsdtTransactionMetadata(e) {
    if (e.functionName !== "ESDTTransfer")
      return;
    const s = e.functionArgs;
    if (!s || s.length < 2)
      return;
    const o = this.hexToString(s[0]), fe = this.hexToBigInt(s[1]), me = new TransactionMetadata();
    return me.sender = e.sender, me.receiver = e.receiver, s.length > 2 && (me.functionName = this.hexToString(s[2]), me.functionArgs = s.slice(3)), me.transfers = [{
      value: fe,
      properties: {
        identifier: o
      }
    }], me.value = fe, me;
  }
  bech32Encode(e) {
    const s = Buffer.from(e, "hex"), o = bech32_1.bech32.toWords(s);
    return bech32_1.bech32.encode("erd", o);
  }
  isAddressValid(e) {
    return Buffer.from(e, "hex").length == 32;
  }
  isSmartContractArgument(e) {
    return !(!this.isHex(e) || e.length % 2 !== 0);
  }
  isHex(e) {
    return new RegExp(/[^a-f0-9]/gi).test(e) === !1;
  }
  base64ToHex(e) {
    return Buffer.from(e, "base64").toString("hex");
  }
  hexToString(e) {
    return Buffer.from(e, "hex").toString("ascii");
  }
  hexToBigInt(e) {
    return BigInt(e ? "0x" + e : 0);
  }
}
transaction_decoder.TransactionDecoder = TransactionDecoder;
class TransactionToDecode {
  constructor() {
    this.sender = "", this.receiver = "", this.data = "", this.value = "0";
  }
}
transaction_decoder.TransactionToDecode = TransactionToDecode;
class TransactionMetadata {
  constructor() {
    this.sender = "", this.receiver = "", this.value = BigInt(0);
  }
}
transaction_decoder.TransactionMetadata = TransactionMetadata;
class TransactionMetadataTransfer {
  constructor() {
    this.value = BigInt(0);
  }
}
transaction_decoder.TransactionMetadataTransfer = TransactionMetadataTransfer;
class TokenTransferProperties {
}
transaction_decoder.TokenTransferProperties = TokenTransferProperties;
var returnCode = {};
Object.defineProperty(returnCode, "__esModule", { value: !0 });
returnCode.ReturnCode = void 0;
class ReturnCode {
  constructor(e) {
    this.text = e;
  }
  static fromBuffer(e) {
    let s = e.toString();
    return new ReturnCode(s);
  }
  toString() {
    return this.text;
  }
  valueOf() {
    return this.text;
  }
  equals(e) {
    return e ? this.text == e.text : !1;
  }
  isSuccess() {
    return this.equals(ReturnCode.Ok) || this.equals(ReturnCode.None);
  }
}
returnCode.ReturnCode = ReturnCode;
ReturnCode.None = new ReturnCode("");
ReturnCode.Ok = new ReturnCode("ok");
ReturnCode.FunctionNotFound = new ReturnCode("function not found");
ReturnCode.FunctionWrongSignature = new ReturnCode("wrong signature for function");
ReturnCode.ContractNotFound = new ReturnCode("contract not found");
ReturnCode.UserError = new ReturnCode("user error");
ReturnCode.OutOfGas = new ReturnCode("out of gas");
ReturnCode.AccountCollision = new ReturnCode("account collision");
ReturnCode.OutOfFunds = new ReturnCode("out of funds");
ReturnCode.CallStackOverFlow = new ReturnCode("call stack overflow");
ReturnCode.ContractInvalid = new ReturnCode("contract invalid");
ReturnCode.ExecutionFailed = new ReturnCode("execution failed");
ReturnCode.Unknown = new ReturnCode("unknown");
Object.defineProperty(resultsParser, "__esModule", { value: !0 });
resultsParser.ResultsParser = void 0;
const transaction_decoder_1 = transaction_decoder, address_1$4 = address$2, errors_1$c = errors$q, logger_1$3 = logger$1, argSerializer_1$1 = argSerializer, returnCode_1 = returnCode;
var WellKnownEvents;
(function(r) {
  r.OnTransactionCompleted = "completedTxEvent", r.OnSignalError = "signalError", r.OnWriteLog = "writeLog";
})(WellKnownEvents || (WellKnownEvents = {}));
var WellKnownTopics;
(function(r) {
  r.TooMuchGas = "@too much gas provided for processing";
})(WellKnownTopics || (WellKnownTopics = {}));
const defaultResultsParserOptions = {
  argsSerializer: new argSerializer_1$1.ArgSerializer()
};
class ResultsParser {
  constructor(e) {
    e = Object.assign(Object.assign({}, defaultResultsParserOptions), e), this.argsSerializer = e.argsSerializer;
  }
  parseQueryResponse(e, s) {
    let o = e.getReturnDataParts(), fe = this.argsSerializer.buffersToValues(o, s.output);
    return {
      returnCode: new returnCode_1.ReturnCode(e.returnCode.toString()),
      returnMessage: e.returnMessage,
      values: fe,
      firstValue: fe[0],
      secondValue: fe[1],
      thirdValue: fe[2],
      lastValue: fe[fe.length - 1]
    };
  }
  parseUntypedQueryResponse(e) {
    return {
      returnCode: new returnCode_1.ReturnCode(e.returnCode.toString()),
      returnMessage: e.returnMessage,
      values: e.getReturnDataParts()
    };
  }
  parseOutcome(e, s) {
    let o = this.parseUntypedOutcome(e), fe = this.argsSerializer.buffersToValues(o.values, s.output);
    return {
      returnCode: o.returnCode,
      returnMessage: o.returnMessage,
      values: fe,
      firstValue: fe[0],
      secondValue: fe[1],
      thirdValue: fe[2],
      lastValue: fe[fe.length - 1]
    };
  }
  parseUntypedOutcome(e) {
    let s, o = this.parseTransactionMetadata(e);
    if (s = this.createBundleOnSimpleMoveBalance(e), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): on simple move balance"), s;
    if (s = this.createBundleOnInvalidTransaction(e), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): on invalid transaction"), s;
    if (s = this.createBundleOnEasilyFoundResultWithReturnData(e.contractResults), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): on easily found result with return data"), s;
    if (s = this.createBundleOnSignalError(e.logs), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): on signal error"), s;
    if (s = this.createBundleOnTooMuchGasWarning(e.logs), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): on 'too much gas' warning"), s;
    if (s = this.createBundleOnWriteLogWhereFirstTopicEqualsAddress(e.logs, e.sender), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): on writelog with topics[0] == tx.sender"), s;
    if (s = this.createBundleWithCustomHeuristics(e, o), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): with custom heuristics"), s;
    if (s = this.createBundleWithFallbackHeuristics(e, o), s)
      return logger_1$3.Logger.trace("parseUntypedOutcome(): with fallback heuristics"), s;
    throw new errors_1$c.ErrCannotParseContractResults(`transaction ${e.hash.toString()}`);
  }
  parseTransactionMetadata(e) {
    return new transaction_decoder_1.TransactionDecoder().getTransactionMetadata({
      sender: e.sender.bech32(),
      receiver: e.receiver.bech32(),
      data: e.data.toString("base64"),
      value: e.value.toString()
    });
  }
  createBundleOnSimpleMoveBalance(e) {
    let s = e.contractResults.items.length == 0, o = e.logs.events.length == 0;
    return s && o ? {
      returnCode: returnCode_1.ReturnCode.None,
      returnMessage: returnCode_1.ReturnCode.None.toString(),
      values: []
    } : null;
  }
  createBundleOnInvalidTransaction(e) {
    return e.status.isInvalid() && e.receipt.data ? {
      returnCode: returnCode_1.ReturnCode.OutOfFunds,
      returnMessage: e.receipt.data,
      values: []
    } : null;
  }
  createBundleOnEasilyFoundResultWithReturnData(e) {
    let s = e.items.find((ye) => ye.nonce.valueOf() != 0 && ye.data.startsWith("@"));
    if (!s)
      return null;
    let { returnCode: o, returnDataParts: fe } = this.sliceDataFieldInParts(s.data), me = s.returnMessage || o.toString();
    return {
      returnCode: o,
      returnMessage: me,
      values: fe
    };
  }
  createBundleOnSignalError(e) {
    let s = e.findSingleOrNoneEvent(WellKnownEvents.OnSignalError);
    if (!s)
      return null;
    let { returnCode: o, returnDataParts: fe } = this.sliceDataFieldInParts(s.data), me = s.getLastTopic(), ye = (me == null ? void 0 : me.toString()) || o.toString();
    return {
      returnCode: o,
      returnMessage: ye,
      values: fe
    };
  }
  createBundleOnTooMuchGasWarning(e) {
    let s = e.findSingleOrNoneEvent(WellKnownEvents.OnWriteLog, (fr) => fr.findFirstOrNoneTopic((Er) => Er.toString().startsWith(WellKnownTopics.TooMuchGas)) != null);
    if (!s)
      return null;
    let { returnCode: o, returnDataParts: fe } = this.sliceDataFieldInParts(s.data), me = s.getLastTopic(), ye = (me == null ? void 0 : me.toString()) || o.toString();
    return {
      returnCode: o,
      returnMessage: ye,
      values: fe
    };
  }
  createBundleOnWriteLogWhereFirstTopicEqualsAddress(e, s) {
    let o = new address_1$4.Address(s.bech32()).hex(), fe = e.findSingleOrNoneEvent(WellKnownEvents.OnWriteLog, (Er) => Er.findFirstOrNoneTopic((br) => br.hex() == o) != null);
    if (!fe)
      return null;
    let { returnCode: me, returnDataParts: ye } = this.sliceDataFieldInParts(fe.data), fr = me.toString();
    return {
      returnCode: me,
      returnMessage: fr,
      values: ye
    };
  }
  createBundleWithCustomHeuristics(e, s) {
    return null;
  }
  createBundleWithFallbackHeuristics(e, s) {
    let o = new address_1$4.Address(s.receiver);
    for (const fe of e.contractResults.items) {
      let me = fe.logs.findSingleOrNoneEvent(WellKnownEvents.OnWriteLog, (ye) => {
        var fr;
        let Er = ye.address.bech32() == e.sender.bech32(), br = ((fr = ye.topics[0]) === null || fr === void 0 ? void 0 : fr.hex()) == o.hex();
        return Er && br;
      });
      if (me) {
        let { returnCode: ye, returnDataParts: fr } = this.sliceDataFieldInParts(me.data), Er = ye.toString();
        return {
          returnCode: ye,
          returnMessage: Er,
          values: fr
        };
      }
    }
    return null;
  }
  sliceDataFieldInParts(e) {
    let s = 1;
    e.startsWith("ESDTTransfer") && (s = 3);
    let o = this.argsSerializer.stringToBuffers(e), fe = o[s] || Buffer.from([]), me = o.slice(s + 1);
    if (fe.length == 0)
      throw new errors_1$c.ErrCannotParseContractResults("no return code");
    return { returnCode: returnCode_1.ReturnCode.fromBuffer(fe), returnDataParts: me };
  }
  parseEvent(e, s) {
    var o, fe;
    const me = {}, ye = e.topics.map((Vr) => Buffer.from(Vr.valueOf())).slice(1), fr = ((o = e.dataPayload) === null || o === void 0 ? void 0 : o.valueOf()) || Buffer.from([]), Er = ((fe = e.additionalData) === null || fe === void 0 ? void 0 : fe.map((Vr) => Buffer.from(Vr.valueOf()))) || [];
    Er.length == 0 && fr.length > 0 && Er.push(Buffer.from(fr));
    const br = s.inputs.filter((Vr) => Vr.indexed), wr = this.argsSerializer.buffersToValues(ye, br);
    for (let Vr = 0; Vr < br.length; Vr++)
      me[br[Vr].name] = wr[Vr].valueOf();
    const kr = s.inputs.filter((Vr) => !Vr.indexed), Gr = this.argsSerializer.buffersToValues(Er, kr);
    for (let Vr = 0; Vr < kr.length; Vr++)
      me[kr[Vr].name] = Gr[Vr].valueOf();
    return me;
  }
}
resultsParser.ResultsParser = ResultsParser;
var smartContract = {}, transactionPayloadBuilders = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.ContractCallPayloadBuilder = r.ContractUpgradePayloadBuilder = r.ContractDeployPayloadBuilder = r.ArwenVirtualMachine = void 0;
  const e = transactionPayload, s = utils$a, o = argSerializer;
  r.ArwenVirtualMachine = "0500";
  class fe {
    constructor() {
      this.code = null, this.codeMetadata = "", this.arguments = [];
    }
    setCode(br) {
      return this.code = br, this;
    }
    setCodeMetadata(br) {
      return this.codeMetadata = br, this;
    }
    addInitArg(br) {
      return this.arguments.push(br), this;
    }
    setInitArgs(br) {
      return this.arguments = br, this;
    }
    build() {
      s.guardValueIsSet("code", this.code);
      let br = this.code.toString(), wr = this.codeMetadata.toString(), kr = `${br}@${r.ArwenVirtualMachine}@${wr}`;
      return kr = fr(kr, this.arguments), new e.TransactionPayload(kr);
    }
  }
  r.ContractDeployPayloadBuilder = fe;
  class me {
    constructor() {
      this.code = null, this.codeMetadata = "", this.arguments = [];
    }
    setCode(br) {
      return this.code = br, this;
    }
    setCodeMetadata(br) {
      return this.codeMetadata = br, this;
    }
    addInitArg(br) {
      return this.arguments.push(br), this;
    }
    setInitArgs(br) {
      return this.arguments = br, this;
    }
    build() {
      s.guardValueIsSet("code", this.code);
      let br = this.code.toString(), wr = this.codeMetadata.toString(), kr = `upgradeContract@${br}@${wr}`;
      return kr = fr(kr, this.arguments), new e.TransactionPayload(kr);
    }
  }
  r.ContractUpgradePayloadBuilder = me;
  class ye {
    constructor() {
      this.contractFunction = null, this.arguments = [];
    }
    setFunction(br) {
      return this.contractFunction = br, this;
    }
    addArg(br) {
      return this.arguments.push(br), this;
    }
    setArgs(br) {
      return this.arguments = br, this;
    }
    build() {
      s.guardValueIsSet("calledFunction", this.contractFunction);
      let br = this.contractFunction.toString();
      return br = fr(br, this.arguments), new e.TransactionPayload(br);
    }
  }
  r.ContractCallPayloadBuilder = ye;
  function fr(Er, br) {
    let { argumentsString: wr, count: kr } = new o.ArgSerializer().valuesToString(br);
    return kr == 0 ? Er : `${Er}@${wr}`;
  }
})(transactionPayloadBuilders);
var readableBrowser = { exports: {} }, events = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function r(e, s, o) {
  return Function.prototype.apply.call(e, s, o);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : ReflectOwnKeys = function(e) {
  return Object.getOwnPropertyNames(e);
};
function ProcessEmitWarning(r) {
  console && console.warn && console.warn(r);
}
var NumberIsNaN = Number.isNaN || function r(e) {
  return e !== e;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once$2;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(r) {
  if (typeof r != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(r) {
    if (typeof r != "number" || r < 0 || NumberIsNaN(r))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + r + ".");
    defaultMaxListeners = r;
  }
});
EventEmitter.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function r(e) {
  if (typeof e != "number" || e < 0 || NumberIsNaN(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function _getMaxListeners(r) {
  return r._maxListeners === void 0 ? EventEmitter.defaultMaxListeners : r._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function r() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function r(e) {
  for (var s = [], o = 1; o < arguments.length; o++)
    s.push(arguments[o]);
  var fe = e === "error", me = this._events;
  if (me !== void 0)
    fe = fe && me.error === void 0;
  else if (!fe)
    return !1;
  if (fe) {
    var ye;
    if (s.length > 0 && (ye = s[0]), ye instanceof Error)
      throw ye;
    var fr = new Error("Unhandled error." + (ye ? " (" + ye.message + ")" : ""));
    throw fr.context = ye, fr;
  }
  var Er = me[e];
  if (Er === void 0)
    return !1;
  if (typeof Er == "function")
    ReflectApply(Er, this, s);
  else
    for (var br = Er.length, wr = arrayClone(Er, br), o = 0; o < br; ++o)
      ReflectApply(wr[o], this, s);
  return !0;
};
function _addListener(r, e, s, o) {
  var fe, me, ye;
  if (checkListener(s), me = r._events, me === void 0 ? (me = r._events = /* @__PURE__ */ Object.create(null), r._eventsCount = 0) : (me.newListener !== void 0 && (r.emit(
    "newListener",
    e,
    s.listener ? s.listener : s
  ), me = r._events), ye = me[e]), ye === void 0)
    ye = me[e] = s, ++r._eventsCount;
  else if (typeof ye == "function" ? ye = me[e] = o ? [s, ye] : [ye, s] : o ? ye.unshift(s) : ye.push(s), fe = _getMaxListeners(r), fe > 0 && ye.length > fe && !ye.warned) {
    ye.warned = !0;
    var fr = new Error("Possible EventEmitter memory leak detected. " + ye.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    fr.name = "MaxListenersExceededWarning", fr.emitter = r, fr.type = e, fr.count = ye.length, ProcessEmitWarning(fr);
  }
  return r;
}
EventEmitter.prototype.addListener = function r(e, s) {
  return _addListener(this, e, s, !1);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function r(e, s) {
  return _addListener(this, e, s, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(r, e, s) {
  var o = { fired: !1, wrapFn: void 0, target: r, type: e, listener: s }, fe = onceWrapper.bind(o);
  return fe.listener = s, o.wrapFn = fe, fe;
}
EventEmitter.prototype.once = function r(e, s) {
  return checkListener(s), this.on(e, _onceWrap(this, e, s)), this;
};
EventEmitter.prototype.prependOnceListener = function r(e, s) {
  return checkListener(s), this.prependListener(e, _onceWrap(this, e, s)), this;
};
EventEmitter.prototype.removeListener = function r(e, s) {
  var o, fe, me, ye, fr;
  if (checkListener(s), fe = this._events, fe === void 0)
    return this;
  if (o = fe[e], o === void 0)
    return this;
  if (o === s || o.listener === s)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete fe[e], fe.removeListener && this.emit("removeListener", e, o.listener || s));
  else if (typeof o != "function") {
    for (me = -1, ye = o.length - 1; ye >= 0; ye--)
      if (o[ye] === s || o[ye].listener === s) {
        fr = o[ye].listener, me = ye;
        break;
      }
    if (me < 0)
      return this;
    me === 0 ? o.shift() : spliceOne(o, me), o.length === 1 && (fe[e] = o[0]), fe.removeListener !== void 0 && this.emit("removeListener", e, fr || s);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function r(e) {
  var s, o, fe;
  if (o = this._events, o === void 0)
    return this;
  if (o.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : o[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete o[e]), this;
  if (arguments.length === 0) {
    var me = Object.keys(o), ye;
    for (fe = 0; fe < me.length; ++fe)
      ye = me[fe], ye !== "removeListener" && this.removeAllListeners(ye);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (s = o[e], typeof s == "function")
    this.removeListener(e, s);
  else if (s !== void 0)
    for (fe = s.length - 1; fe >= 0; fe--)
      this.removeListener(e, s[fe]);
  return this;
};
function _listeners(r, e, s) {
  var o = r._events;
  if (o === void 0)
    return [];
  var fe = o[e];
  return fe === void 0 ? [] : typeof fe == "function" ? s ? [fe.listener || fe] : [fe] : s ? unwrapListeners(fe) : arrayClone(fe, fe.length);
}
EventEmitter.prototype.listeners = function r(e) {
  return _listeners(this, e, !0);
};
EventEmitter.prototype.rawListeners = function r(e) {
  return _listeners(this, e, !1);
};
EventEmitter.listenerCount = function(r, e) {
  return typeof r.listenerCount == "function" ? r.listenerCount(e) : listenerCount.call(r, e);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(r) {
  var e = this._events;
  if (e !== void 0) {
    var s = e[r];
    if (typeof s == "function")
      return 1;
    if (s !== void 0)
      return s.length;
  }
  return 0;
}
EventEmitter.prototype.eventNames = function r() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(r, e) {
  for (var s = new Array(e), o = 0; o < e; ++o)
    s[o] = r[o];
  return s;
}
function spliceOne(r, e) {
  for (; e + 1 < r.length; e++)
    r[e] = r[e + 1];
  r.pop();
}
function unwrapListeners(r) {
  for (var e = new Array(r.length), s = 0; s < e.length; ++s)
    e[s] = r[s].listener || r[s];
  return e;
}
function once$2(r, e) {
  return new Promise(function(s, o) {
    function fe(ye) {
      r.removeListener(e, me), o(ye);
    }
    function me() {
      typeof r.removeListener == "function" && r.removeListener("error", fe), s([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(r, e, me, { once: !0 }), e !== "error" && addErrorHandlerIfEventEmitter(r, fe, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(r, e, s) {
  typeof r.on == "function" && eventTargetAgnosticAddListener(r, "error", e, s);
}
function eventTargetAgnosticAddListener(r, e, s, o) {
  if (typeof r.on == "function")
    o.once ? r.once(e, s) : r.on(e, s);
  else if (typeof r.addEventListener == "function")
    r.addEventListener(e, function fe(me) {
      o.once && r.removeEventListener(e, fe), s(me);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
}
var streamBrowser = events.exports.EventEmitter;
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list)
    return buffer_list;
  hasRequiredBuffer_list = 1;
  function r(Gr, Vr) {
    var jr = Object.keys(Gr);
    if (Object.getOwnPropertySymbols) {
      var Kr = Object.getOwnPropertySymbols(Gr);
      Vr && (Kr = Kr.filter(function(bn) {
        return Object.getOwnPropertyDescriptor(Gr, bn).enumerable;
      })), jr.push.apply(jr, Kr);
    }
    return jr;
  }
  function e(Gr) {
    for (var Vr = 1; Vr < arguments.length; Vr++) {
      var jr = arguments[Vr] != null ? arguments[Vr] : {};
      Vr % 2 ? r(Object(jr), !0).forEach(function(Kr) {
        s(Gr, Kr, jr[Kr]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Gr, Object.getOwnPropertyDescriptors(jr)) : r(Object(jr)).forEach(function(Kr) {
        Object.defineProperty(Gr, Kr, Object.getOwnPropertyDescriptor(jr, Kr));
      });
    }
    return Gr;
  }
  function s(Gr, Vr, jr) {
    return Vr in Gr ? Object.defineProperty(Gr, Vr, { value: jr, enumerable: !0, configurable: !0, writable: !0 }) : Gr[Vr] = jr, Gr;
  }
  function o(Gr, Vr) {
    if (!(Gr instanceof Vr))
      throw new TypeError("Cannot call a class as a function");
  }
  function fe(Gr, Vr) {
    for (var jr = 0; jr < Vr.length; jr++) {
      var Kr = Vr[jr];
      Kr.enumerable = Kr.enumerable || !1, Kr.configurable = !0, "value" in Kr && (Kr.writable = !0), Object.defineProperty(Gr, Kr.key, Kr);
    }
  }
  function me(Gr, Vr, jr) {
    return Vr && fe(Gr.prototype, Vr), jr && fe(Gr, jr), Gr;
  }
  var ye = requireBuffer(), fr = ye.Buffer, Er = require$$0$4, br = Er.inspect, wr = br && br.custom || "inspect";
  function kr(Gr, Vr, jr) {
    fr.prototype.copy.call(Gr, Vr, jr);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Gr() {
      o(this, Gr), this.head = null, this.tail = null, this.length = 0;
    }
    return me(Gr, [{
      key: "push",
      value: function(jr) {
        var Kr = {
          data: jr,
          next: null
        };
        this.length > 0 ? this.tail.next = Kr : this.head = Kr, this.tail = Kr, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(jr) {
        var Kr = {
          data: jr,
          next: this.head
        };
        this.length === 0 && (this.tail = Kr), this.head = Kr, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var jr = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, jr;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(jr) {
        if (this.length === 0)
          return "";
        for (var Kr = this.head, bn = "" + Kr.data; Kr = Kr.next; )
          bn += jr + Kr.data;
        return bn;
      }
    }, {
      key: "concat",
      value: function(jr) {
        if (this.length === 0)
          return fr.alloc(0);
        for (var Kr = fr.allocUnsafe(jr >>> 0), bn = this.head, Yr = 0; bn; )
          kr(bn.data, Kr, Yr), Yr += bn.data.length, bn = bn.next;
        return Kr;
      }
    }, {
      key: "consume",
      value: function(jr, Kr) {
        var bn;
        return jr < this.head.data.length ? (bn = this.head.data.slice(0, jr), this.head.data = this.head.data.slice(jr)) : jr === this.head.data.length ? bn = this.shift() : bn = Kr ? this._getString(jr) : this._getBuffer(jr), bn;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
    }, {
      key: "_getString",
      value: function(jr) {
        var Kr = this.head, bn = 1, Yr = Kr.data;
        for (jr -= Yr.length; Kr = Kr.next; ) {
          var Zr = Kr.data, ti = jr > Zr.length ? Zr.length : jr;
          if (ti === Zr.length ? Yr += Zr : Yr += Zr.slice(0, jr), jr -= ti, jr === 0) {
            ti === Zr.length ? (++bn, Kr.next ? this.head = Kr.next : this.head = this.tail = null) : (this.head = Kr, Kr.data = Zr.slice(ti));
            break;
          }
          ++bn;
        }
        return this.length -= bn, Yr;
      }
    }, {
      key: "_getBuffer",
      value: function(jr) {
        var Kr = fr.allocUnsafe(jr), bn = this.head, Yr = 1;
        for (bn.data.copy(Kr), jr -= bn.data.length; bn = bn.next; ) {
          var Zr = bn.data, ti = jr > Zr.length ? Zr.length : jr;
          if (Zr.copy(Kr, Kr.length - jr, 0, ti), jr -= ti, jr === 0) {
            ti === Zr.length ? (++Yr, bn.next ? this.head = bn.next : this.head = this.tail = null) : (this.head = bn, bn.data = Zr.slice(ti));
            break;
          }
          ++Yr;
        }
        return this.length -= Yr, Kr;
      }
    }, {
      key: wr,
      value: function(jr, Kr) {
        return br(this, e({}, Kr, {
          depth: 0,
          customInspect: !1
        }));
      }
    }]), Gr;
  }(), buffer_list;
}
function destroy(r, e) {
  var s = this, o = this._readableState && this._readableState.destroyed, fe = this._writableState && this._writableState.destroyed;
  return o || fe ? (e ? e(r) : r && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(emitErrorNT, this, r)) : process.nextTick(emitErrorNT, this, r)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(r || null, function(me) {
    !e && me ? s._writableState ? s._writableState.errorEmitted ? process.nextTick(emitCloseNT, s) : (s._writableState.errorEmitted = !0, process.nextTick(emitErrorAndCloseNT, s, me)) : process.nextTick(emitErrorAndCloseNT, s, me) : e ? (process.nextTick(emitCloseNT, s), e(me)) : process.nextTick(emitCloseNT, s);
  }), this);
}
function emitErrorAndCloseNT(r, e) {
  emitErrorNT(r, e), emitCloseNT(r);
}
function emitCloseNT(r) {
  r._writableState && !r._writableState.emitClose || r._readableState && !r._readableState.emitClose || r.emit("close");
}
function undestroy() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function emitErrorNT(r, e) {
  r.emit("error", e);
}
function errorOrDestroy(r, e) {
  var s = r._readableState, o = r._writableState;
  s && s.autoDestroy || o && o.autoDestroy ? r.destroy(e) : r.emit("error", e);
}
var destroy_1 = {
  destroy,
  undestroy,
  errorOrDestroy
}, errorsBrowser = {};
function _inheritsLoose(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.__proto__ = e;
}
var codes = {};
function createErrorType(r, e, s) {
  s || (s = Error);
  function o(me, ye, fr) {
    return typeof e == "string" ? e : e(me, ye, fr);
  }
  var fe = /* @__PURE__ */ function(me) {
    _inheritsLoose(ye, me);
    function ye(fr, Er, br) {
      return me.call(this, o(fr, Er, br)) || this;
    }
    return ye;
  }(s);
  fe.prototype.name = s.name, fe.prototype.code = r, codes[r] = fe;
}
function oneOf(r, e) {
  if (Array.isArray(r)) {
    var s = r.length;
    return r = r.map(function(o) {
      return String(o);
    }), s > 2 ? "one of ".concat(e, " ").concat(r.slice(0, s - 1).join(", "), ", or ") + r[s - 1] : s === 2 ? "one of ".concat(e, " ").concat(r[0], " or ").concat(r[1]) : "of ".concat(e, " ").concat(r[0]);
  } else
    return "of ".concat(e, " ").concat(String(r));
}
function startsWith(r, e, s) {
  return r.substr(!s || s < 0 ? 0 : +s, e.length) === e;
}
function endsWith$1(r, e, s) {
  return (s === void 0 || s > r.length) && (s = r.length), r.substring(s - e.length, s) === e;
}
function includes(r, e, s) {
  return typeof s != "number" && (s = 0), s + e.length > r.length ? !1 : r.indexOf(e, s) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(r, e) {
  return 'The value "' + e + '" is invalid for option "' + r + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(r, e, s) {
  var o;
  typeof e == "string" && startsWith(e, "not ") ? (o = "must not be", e = e.replace(/^not /, "")) : o = "must be";
  var fe;
  if (endsWith$1(r, " argument"))
    fe = "The ".concat(r, " ").concat(o, " ").concat(oneOf(e, "type"));
  else {
    var me = includes(r, ".") ? "property" : "argument";
    fe = 'The "'.concat(r, '" ').concat(me, " ").concat(o, " ").concat(oneOf(e, "type"));
  }
  return fe += ". Received type ".concat(typeof s), fe;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(r) {
  return "The " + r + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(r) {
  return "Cannot call " + r + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(r) {
  return "Unknown encoding: " + r;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
errorsBrowser.codes = codes;
var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(r, e, s) {
  return r.highWaterMark != null ? r.highWaterMark : e ? r[s] : null;
}
function getHighWaterMark(r, e, s, o) {
  var fe = highWaterMarkFrom(e, o, s);
  if (fe != null) {
    if (!(isFinite(fe) && Math.floor(fe) === fe) || fe < 0) {
      var me = o ? s : "highWaterMark";
      throw new ERR_INVALID_OPT_VALUE(me, fe);
    }
    return Math.floor(fe);
  }
  return r.objectMode ? 16 : 16 * 1024;
}
var state = {
  getHighWaterMark
}, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(e, s) {
  s && (e.super_ = s, e.prototype = Object.create(s.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(e, s) {
  if (s) {
    e.super_ = s;
    var o = function() {
    };
    o.prototype = s.prototype, e.prototype = new o(), e.prototype.constructor = e;
  }
};
var browser$4 = deprecate;
function deprecate(r, e) {
  if (config$2("noDeprecation"))
    return r;
  var s = !1;
  function o() {
    if (!s) {
      if (config$2("throwDeprecation"))
        throw new Error(e);
      config$2("traceDeprecation") ? console.trace(e) : console.warn(e), s = !0;
    }
    return r.apply(this, arguments);
  }
  return o;
}
function config$2(r) {
  try {
    if (!globalThis.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var e = globalThis.localStorage[r];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable)
    return _stream_writable;
  hasRequired_stream_writable = 1, _stream_writable = Hr;
  function r(yi) {
    var ui = this;
    this.next = null, this.entry = null, this.finish = function() {
      Ii(ui, yi);
    };
  }
  var e;
  Hr.WritableState = In;
  var s = {
    deprecate: browser$4
  }, o = streamBrowser, fe = requireBuffer().Buffer, me = globalThis.Uint8Array || function() {
  };
  function ye(yi) {
    return fe.from(yi);
  }
  function fr(yi) {
    return fe.isBuffer(yi) || yi instanceof me;
  }
  var Er = destroy_1, br = state, wr = br.getHighWaterMark, kr = errorsBrowser.codes, Gr = kr.ERR_INVALID_ARG_TYPE, Vr = kr.ERR_METHOD_NOT_IMPLEMENTED, jr = kr.ERR_MULTIPLE_CALLBACK, Kr = kr.ERR_STREAM_CANNOT_PIPE, bn = kr.ERR_STREAM_DESTROYED, Yr = kr.ERR_STREAM_NULL_VALUES, Zr = kr.ERR_STREAM_WRITE_AFTER_END, ti = kr.ERR_UNKNOWN_ENCODING, On = Er.errorOrDestroy;
  inherits_browser.exports(Hr, o);
  function ni() {
  }
  function In(yi, ui, hi) {
    e = e || require_stream_duplex(), yi = yi || {}, typeof hi != "boolean" && (hi = ui instanceof e), this.objectMode = !!yi.objectMode, hi && (this.objectMode = this.objectMode || !!yi.writableObjectMode), this.highWaterMark = wr(this, yi, "writableHighWaterMark", hi), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var gi = yi.decodeStrings === !1;
    this.decodeStrings = !gi, this.defaultEncoding = yi.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Qr) {
      ri(ui, Qr);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = yi.emitClose !== !1, this.autoDestroy = !!yi.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new r(this);
  }
  In.prototype.getBuffer = function() {
    for (var ui = this.bufferedRequest, hi = []; ui; )
      hi.push(ui), ui = ui.next;
    return hi;
  }, function() {
    try {
      Object.defineProperty(In.prototype, "buffer", {
        get: s.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Br;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Br = Function.prototype[Symbol.hasInstance], Object.defineProperty(Hr, Symbol.hasInstance, {
    value: function(ui) {
      return Br.call(this, ui) ? !0 : this !== Hr ? !1 : ui && ui._writableState instanceof In;
    }
  })) : Br = function(ui) {
    return ui instanceof this;
  };
  function Hr(yi) {
    e = e || require_stream_duplex();
    var ui = this instanceof e;
    if (!ui && !Br.call(Hr, this))
      return new Hr(yi);
    this._writableState = new In(yi, this, ui), this.writable = !0, yi && (typeof yi.write == "function" && (this._write = yi.write), typeof yi.writev == "function" && (this._writev = yi.writev), typeof yi.destroy == "function" && (this._destroy = yi.destroy), typeof yi.final == "function" && (this._final = yi.final)), o.call(this);
  }
  Hr.prototype.pipe = function() {
    On(this, new Kr());
  };
  function Pn(yi, ui) {
    var hi = new Zr();
    On(yi, hi), process.nextTick(ui, hi);
  }
  function ei(yi, ui, hi, gi) {
    var Qr;
    return hi === null ? Qr = new Yr() : typeof hi != "string" && !ui.objectMode && (Qr = new Gr("chunk", ["string", "Buffer"], hi)), Qr ? (On(yi, Qr), process.nextTick(gi, Qr), !1) : !0;
  }
  Hr.prototype.write = function(yi, ui, hi) {
    var gi = this._writableState, Qr = !1, wn = !gi.objectMode && fr(yi);
    return wn && !fe.isBuffer(yi) && (yi = ye(yi)), typeof ui == "function" && (hi = ui, ui = null), wn ? ui = "buffer" : ui || (ui = gi.defaultEncoding), typeof hi != "function" && (hi = ni), gi.ending ? Pn(this, hi) : (wn || ei(this, gi, yi, hi)) && (gi.pendingcb++, Qr = Nn(this, gi, wn, yi, ui, hi)), Qr;
  }, Hr.prototype.cork = function() {
    this._writableState.corked++;
  }, Hr.prototype.uncork = function() {
    var yi = this._writableState;
    yi.corked && (yi.corked--, !yi.writing && !yi.corked && !yi.bufferProcessing && yi.bufferedRequest && di(this, yi));
  }, Hr.prototype.setDefaultEncoding = function(ui) {
    if (typeof ui == "string" && (ui = ui.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((ui + "").toLowerCase()) > -1))
      throw new ti(ui);
    return this._writableState.defaultEncoding = ui, this;
  }, Object.defineProperty(Hr.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function oi(yi, ui, hi) {
    return !yi.objectMode && yi.decodeStrings !== !1 && typeof ui == "string" && (ui = fe.from(ui, hi)), ui;
  }
  Object.defineProperty(Hr.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Nn(yi, ui, hi, gi, Qr, wn) {
    if (!hi) {
      var ci = oi(ui, gi, Qr);
      gi !== ci && (hi = !0, Qr = "buffer", gi = ci);
    }
    var vi = ui.objectMode ? 1 : gi.length;
    ui.length += vi;
    var Ni = ui.length < ui.highWaterMark;
    if (Ni || (ui.needDrain = !0), ui.writing || ui.corked) {
      var Fi = ui.lastBufferedRequest;
      ui.lastBufferedRequest = {
        chunk: gi,
        encoding: Qr,
        isBuf: hi,
        callback: wn,
        next: null
      }, Fi ? Fi.next = ui.lastBufferedRequest : ui.bufferedRequest = ui.lastBufferedRequest, ui.bufferedRequestCount += 1;
    } else
      En(yi, ui, !1, vi, gi, Qr, wn);
    return Ni;
  }
  function En(yi, ui, hi, gi, Qr, wn, ci) {
    ui.writelen = gi, ui.writecb = ci, ui.writing = !0, ui.sync = !0, ui.destroyed ? ui.onwrite(new bn("write")) : hi ? yi._writev(Qr, ui.onwrite) : yi._write(Qr, wn, ui.onwrite), ui.sync = !1;
  }
  function qr(yi, ui, hi, gi, Qr) {
    --ui.pendingcb, hi ? (process.nextTick(Qr, gi), process.nextTick(bi, yi, ui), yi._writableState.errorEmitted = !0, On(yi, gi)) : (Qr(gi), yi._writableState.errorEmitted = !0, On(yi, gi), bi(yi, ui));
  }
  function Jr(yi) {
    yi.writing = !1, yi.writecb = null, yi.length -= yi.writelen, yi.writelen = 0;
  }
  function ri(yi, ui) {
    var hi = yi._writableState, gi = hi.sync, Qr = hi.writecb;
    if (typeof Qr != "function")
      throw new jr();
    if (Jr(hi), ui)
      qr(yi, hi, gi, ui, Qr);
    else {
      var wn = ii(hi) || yi.destroyed;
      !wn && !hi.corked && !hi.bufferProcessing && hi.bufferedRequest && di(yi, hi), gi ? process.nextTick(Sn, yi, hi, wn, Qr) : Sn(yi, hi, wn, Qr);
    }
  }
  function Sn(yi, ui, hi, gi) {
    hi || ai(yi, ui), ui.pendingcb--, gi(), bi(yi, ui);
  }
  function ai(yi, ui) {
    ui.length === 0 && ui.needDrain && (ui.needDrain = !1, yi.emit("drain"));
  }
  function di(yi, ui) {
    ui.bufferProcessing = !0;
    var hi = ui.bufferedRequest;
    if (yi._writev && hi && hi.next) {
      var gi = ui.bufferedRequestCount, Qr = new Array(gi), wn = ui.corkedRequestsFree;
      wn.entry = hi;
      for (var ci = 0, vi = !0; hi; )
        Qr[ci] = hi, hi.isBuf || (vi = !1), hi = hi.next, ci += 1;
      Qr.allBuffers = vi, En(yi, ui, !0, ui.length, Qr, "", wn.finish), ui.pendingcb++, ui.lastBufferedRequest = null, wn.next ? (ui.corkedRequestsFree = wn.next, wn.next = null) : ui.corkedRequestsFree = new r(ui), ui.bufferedRequestCount = 0;
    } else {
      for (; hi; ) {
        var Ni = hi.chunk, Fi = hi.encoding, Pi = hi.callback, Li = ui.objectMode ? 1 : Ni.length;
        if (En(yi, ui, !1, Li, Ni, Fi, Pi), hi = hi.next, ui.bufferedRequestCount--, ui.writing)
          break;
      }
      hi === null && (ui.lastBufferedRequest = null);
    }
    ui.bufferedRequest = hi, ui.bufferProcessing = !1;
  }
  Hr.prototype._write = function(yi, ui, hi) {
    hi(new Vr("_write()"));
  }, Hr.prototype._writev = null, Hr.prototype.end = function(yi, ui, hi) {
    var gi = this._writableState;
    return typeof yi == "function" ? (hi = yi, yi = null, ui = null) : typeof ui == "function" && (hi = ui, ui = null), yi != null && this.write(yi, ui), gi.corked && (gi.corked = 1, this.uncork()), gi.ending || Si(this, gi, hi), this;
  }, Object.defineProperty(Hr.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function ii(yi) {
    return yi.ending && yi.length === 0 && yi.bufferedRequest === null && !yi.finished && !yi.writing;
  }
  function fi(yi, ui) {
    yi._final(function(hi) {
      ui.pendingcb--, hi && On(yi, hi), ui.prefinished = !0, yi.emit("prefinish"), bi(yi, ui);
    });
  }
  function Ei(yi, ui) {
    !ui.prefinished && !ui.finalCalled && (typeof yi._final == "function" && !ui.destroyed ? (ui.pendingcb++, ui.finalCalled = !0, process.nextTick(fi, yi, ui)) : (ui.prefinished = !0, yi.emit("prefinish")));
  }
  function bi(yi, ui) {
    var hi = ii(ui);
    if (hi && (Ei(yi, ui), ui.pendingcb === 0 && (ui.finished = !0, yi.emit("finish"), ui.autoDestroy))) {
      var gi = yi._readableState;
      (!gi || gi.autoDestroy && gi.endEmitted) && yi.destroy();
    }
    return hi;
  }
  function Si(yi, ui, hi) {
    ui.ending = !0, bi(yi, ui), hi && (ui.finished ? process.nextTick(hi) : yi.once("finish", hi)), ui.ended = !0, yi.writable = !1;
  }
  function Ii(yi, ui, hi) {
    var gi = yi.entry;
    for (yi.entry = null; gi; ) {
      var Qr = gi.callback;
      ui.pendingcb--, Qr(hi), gi = gi.next;
    }
    ui.corkedRequestsFree.next = yi;
  }
  return Object.defineProperty(Hr.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(ui) {
      !this._writableState || (this._writableState.destroyed = ui);
    }
  }), Hr.prototype.destroy = Er.destroy, Hr.prototype._undestroy = Er.undestroy, Hr.prototype._destroy = function(yi, ui) {
    ui(yi);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex)
    return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var r = Object.keys || function(br) {
    var wr = [];
    for (var kr in br)
      wr.push(kr);
    return wr;
  };
  _stream_duplex = ye;
  var e = require_stream_readable(), s = require_stream_writable();
  inherits_browser.exports(ye, e);
  for (var o = r(s.prototype), fe = 0; fe < o.length; fe++) {
    var me = o[fe];
    ye.prototype[me] || (ye.prototype[me] = s.prototype[me]);
  }
  function ye(br) {
    if (!(this instanceof ye))
      return new ye(br);
    e.call(this, br), s.call(this, br), this.allowHalfOpen = !0, br && (br.readable === !1 && (this.readable = !1), br.writable === !1 && (this.writable = !1), br.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", fr)));
  }
  Object.defineProperty(ye.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(ye.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(ye.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function fr() {
    this._writableState.ended || process.nextTick(Er, this);
  }
  function Er(br) {
    br.end();
  }
  return Object.defineProperty(ye.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(wr) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = wr, this._writableState.destroyed = wr);
    }
  }), _stream_duplex;
}
var string_decoder = {}, safeBuffer = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(r, e) {
    var s = requireBuffer(), o = s.Buffer;
    function fe(ye, fr) {
      for (var Er in ye)
        fr[Er] = ye[Er];
    }
    o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? r.exports = s : (fe(s, e), e.Buffer = me);
    function me(ye, fr, Er) {
      return o(ye, fr, Er);
    }
    me.prototype = Object.create(o.prototype), fe(o, me), me.from = function(ye, fr, Er) {
      if (typeof ye == "number")
        throw new TypeError("Argument must not be a number");
      return o(ye, fr, Er);
    }, me.alloc = function(ye, fr, Er) {
      if (typeof ye != "number")
        throw new TypeError("Argument must be a number");
      var br = o(ye);
      return fr !== void 0 ? typeof Er == "string" ? br.fill(fr, Er) : br.fill(fr) : br.fill(0), br;
    }, me.allocUnsafe = function(ye) {
      if (typeof ye != "number")
        throw new TypeError("Argument must be a number");
      return o(ye);
    }, me.allocUnsafeSlow = function(ye) {
      if (typeof ye != "number")
        throw new TypeError("Argument must be a number");
      return s.SlowBuffer(ye);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder)
    return string_decoder;
  hasRequiredString_decoder = 1;
  var r = requireSafeBuffer().Buffer, e = r.isEncoding || function(Yr) {
    switch (Yr = "" + Yr, Yr && Yr.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function s(Yr) {
    if (!Yr)
      return "utf8";
    for (var Zr; ; )
      switch (Yr) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return Yr;
        default:
          if (Zr)
            return;
          Yr = ("" + Yr).toLowerCase(), Zr = !0;
      }
  }
  function o(Yr) {
    var Zr = s(Yr);
    if (typeof Zr != "string" && (r.isEncoding === e || !e(Yr)))
      throw new Error("Unknown encoding: " + Yr);
    return Zr || Yr;
  }
  string_decoder.StringDecoder = fe;
  function fe(Yr) {
    this.encoding = o(Yr);
    var Zr;
    switch (this.encoding) {
      case "utf16le":
        this.text = kr, this.end = Gr, Zr = 4;
        break;
      case "utf8":
        this.fillLast = Er, Zr = 4;
        break;
      case "base64":
        this.text = Vr, this.end = jr, Zr = 3;
        break;
      default:
        this.write = Kr, this.end = bn;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(Zr);
  }
  fe.prototype.write = function(Yr) {
    if (Yr.length === 0)
      return "";
    var Zr, ti;
    if (this.lastNeed) {
      if (Zr = this.fillLast(Yr), Zr === void 0)
        return "";
      ti = this.lastNeed, this.lastNeed = 0;
    } else
      ti = 0;
    return ti < Yr.length ? Zr ? Zr + this.text(Yr, ti) : this.text(Yr, ti) : Zr || "";
  }, fe.prototype.end = wr, fe.prototype.text = br, fe.prototype.fillLast = function(Yr) {
    if (this.lastNeed <= Yr.length)
      return Yr.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Yr.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, Yr.length), this.lastNeed -= Yr.length;
  };
  function me(Yr) {
    return Yr <= 127 ? 0 : Yr >> 5 === 6 ? 2 : Yr >> 4 === 14 ? 3 : Yr >> 3 === 30 ? 4 : Yr >> 6 === 2 ? -1 : -2;
  }
  function ye(Yr, Zr, ti) {
    var On = Zr.length - 1;
    if (On < ti)
      return 0;
    var ni = me(Zr[On]);
    return ni >= 0 ? (ni > 0 && (Yr.lastNeed = ni - 1), ni) : --On < ti || ni === -2 ? 0 : (ni = me(Zr[On]), ni >= 0 ? (ni > 0 && (Yr.lastNeed = ni - 2), ni) : --On < ti || ni === -2 ? 0 : (ni = me(Zr[On]), ni >= 0 ? (ni > 0 && (ni === 2 ? ni = 0 : Yr.lastNeed = ni - 3), ni) : 0));
  }
  function fr(Yr, Zr, ti) {
    if ((Zr[0] & 192) !== 128)
      return Yr.lastNeed = 0, "\uFFFD";
    if (Yr.lastNeed > 1 && Zr.length > 1) {
      if ((Zr[1] & 192) !== 128)
        return Yr.lastNeed = 1, "\uFFFD";
      if (Yr.lastNeed > 2 && Zr.length > 2 && (Zr[2] & 192) !== 128)
        return Yr.lastNeed = 2, "\uFFFD";
    }
  }
  function Er(Yr) {
    var Zr = this.lastTotal - this.lastNeed, ti = fr(this, Yr);
    if (ti !== void 0)
      return ti;
    if (this.lastNeed <= Yr.length)
      return Yr.copy(this.lastChar, Zr, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Yr.copy(this.lastChar, Zr, 0, Yr.length), this.lastNeed -= Yr.length;
  }
  function br(Yr, Zr) {
    var ti = ye(this, Yr, Zr);
    if (!this.lastNeed)
      return Yr.toString("utf8", Zr);
    this.lastTotal = ti;
    var On = Yr.length - (ti - this.lastNeed);
    return Yr.copy(this.lastChar, 0, On), Yr.toString("utf8", Zr, On);
  }
  function wr(Yr) {
    var Zr = Yr && Yr.length ? this.write(Yr) : "";
    return this.lastNeed ? Zr + "\uFFFD" : Zr;
  }
  function kr(Yr, Zr) {
    if ((Yr.length - Zr) % 2 === 0) {
      var ti = Yr.toString("utf16le", Zr);
      if (ti) {
        var On = ti.charCodeAt(ti.length - 1);
        if (On >= 55296 && On <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = Yr[Yr.length - 2], this.lastChar[1] = Yr[Yr.length - 1], ti.slice(0, -1);
      }
      return ti;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = Yr[Yr.length - 1], Yr.toString("utf16le", Zr, Yr.length - 1);
  }
  function Gr(Yr) {
    var Zr = Yr && Yr.length ? this.write(Yr) : "";
    if (this.lastNeed) {
      var ti = this.lastTotal - this.lastNeed;
      return Zr + this.lastChar.toString("utf16le", 0, ti);
    }
    return Zr;
  }
  function Vr(Yr, Zr) {
    var ti = (Yr.length - Zr) % 3;
    return ti === 0 ? Yr.toString("base64", Zr) : (this.lastNeed = 3 - ti, this.lastTotal = 3, ti === 1 ? this.lastChar[0] = Yr[Yr.length - 1] : (this.lastChar[0] = Yr[Yr.length - 2], this.lastChar[1] = Yr[Yr.length - 1]), Yr.toString("base64", Zr, Yr.length - ti));
  }
  function jr(Yr) {
    var Zr = Yr && Yr.length ? this.write(Yr) : "";
    return this.lastNeed ? Zr + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Zr;
  }
  function Kr(Yr) {
    return Yr.toString(this.encoding);
  }
  function bn(Yr) {
    return Yr && Yr.length ? this.write(Yr) : "";
  }
  return string_decoder;
}
var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
function once$1(r) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var s = arguments.length, o = new Array(s), fe = 0; fe < s; fe++)
        o[fe] = arguments[fe];
      r.apply(this, o);
    }
  };
}
function noop$4() {
}
function isRequest$1(r) {
  return r.setHeader && typeof r.abort == "function";
}
function eos$1(r, e, s) {
  if (typeof e == "function")
    return eos$1(r, null, e);
  e || (e = {}), s = once$1(s || noop$4);
  var o = e.readable || e.readable !== !1 && r.readable, fe = e.writable || e.writable !== !1 && r.writable, me = function() {
    r.writable || fr();
  }, ye = r._writableState && r._writableState.finished, fr = function() {
    fe = !1, ye = !0, o || s.call(r);
  }, Er = r._readableState && r._readableState.endEmitted, br = function() {
    o = !1, Er = !0, fe || s.call(r);
  }, wr = function(jr) {
    s.call(r, jr);
  }, kr = function() {
    var jr;
    if (o && !Er)
      return (!r._readableState || !r._readableState.ended) && (jr = new ERR_STREAM_PREMATURE_CLOSE()), s.call(r, jr);
    if (fe && !ye)
      return (!r._writableState || !r._writableState.ended) && (jr = new ERR_STREAM_PREMATURE_CLOSE()), s.call(r, jr);
  }, Gr = function() {
    r.req.on("finish", fr);
  };
  return isRequest$1(r) ? (r.on("complete", fr), r.on("abort", kr), r.req ? Gr() : r.on("request", Gr)) : fe && !r._writableState && (r.on("end", me), r.on("close", me)), r.on("end", br), r.on("finish", fr), e.error !== !1 && r.on("error", wr), r.on("close", kr), function() {
    r.removeListener("complete", fr), r.removeListener("abort", kr), r.removeListener("request", Gr), r.req && r.req.removeListener("finish", fr), r.removeListener("end", me), r.removeListener("close", me), r.removeListener("finish", fr), r.removeListener("end", br), r.removeListener("error", wr), r.removeListener("close", kr);
  };
}
var endOfStream = eos$1, async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator)
    return async_iterator;
  hasRequiredAsync_iterator = 1;
  var r;
  function e(Yr, Zr, ti) {
    return Zr in Yr ? Object.defineProperty(Yr, Zr, { value: ti, enumerable: !0, configurable: !0, writable: !0 }) : Yr[Zr] = ti, Yr;
  }
  var s = endOfStream, o = Symbol("lastResolve"), fe = Symbol("lastReject"), me = Symbol("error"), ye = Symbol("ended"), fr = Symbol("lastPromise"), Er = Symbol("handlePromise"), br = Symbol("stream");
  function wr(Yr, Zr) {
    return {
      value: Yr,
      done: Zr
    };
  }
  function kr(Yr) {
    var Zr = Yr[o];
    if (Zr !== null) {
      var ti = Yr[br].read();
      ti !== null && (Yr[fr] = null, Yr[o] = null, Yr[fe] = null, Zr(wr(ti, !1)));
    }
  }
  function Gr(Yr) {
    process.nextTick(kr, Yr);
  }
  function Vr(Yr, Zr) {
    return function(ti, On) {
      Yr.then(function() {
        if (Zr[ye]) {
          ti(wr(void 0, !0));
          return;
        }
        Zr[Er](ti, On);
      }, On);
    };
  }
  var jr = Object.getPrototypeOf(function() {
  }), Kr = Object.setPrototypeOf((r = {
    get stream() {
      return this[br];
    },
    next: function() {
      var Zr = this, ti = this[me];
      if (ti !== null)
        return Promise.reject(ti);
      if (this[ye])
        return Promise.resolve(wr(void 0, !0));
      if (this[br].destroyed)
        return new Promise(function(Br, Hr) {
          process.nextTick(function() {
            Zr[me] ? Hr(Zr[me]) : Br(wr(void 0, !0));
          });
        });
      var On = this[fr], ni;
      if (On)
        ni = new Promise(Vr(On, this));
      else {
        var In = this[br].read();
        if (In !== null)
          return Promise.resolve(wr(In, !1));
        ni = new Promise(this[Er]);
      }
      return this[fr] = ni, ni;
    }
  }, e(r, Symbol.asyncIterator, function() {
    return this;
  }), e(r, "return", function() {
    var Zr = this;
    return new Promise(function(ti, On) {
      Zr[br].destroy(null, function(ni) {
        if (ni) {
          On(ni);
          return;
        }
        ti(wr(void 0, !0));
      });
    });
  }), r), jr), bn = function(Zr) {
    var ti, On = Object.create(Kr, (ti = {}, e(ti, br, {
      value: Zr,
      writable: !0
    }), e(ti, o, {
      value: null,
      writable: !0
    }), e(ti, fe, {
      value: null,
      writable: !0
    }), e(ti, me, {
      value: null,
      writable: !0
    }), e(ti, ye, {
      value: Zr._readableState.endEmitted,
      writable: !0
    }), e(ti, Er, {
      value: function(In, Br) {
        var Hr = On[br].read();
        Hr ? (On[fr] = null, On[o] = null, On[fe] = null, In(wr(Hr, !1))) : (On[o] = In, On[fe] = Br);
      },
      writable: !0
    }), ti));
    return On[fr] = null, s(Zr, function(ni) {
      if (ni && ni.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var In = On[fe];
        In !== null && (On[fr] = null, On[o] = null, On[fe] = null, In(ni)), On[me] = ni;
        return;
      }
      var Br = On[o];
      Br !== null && (On[fr] = null, On[o] = null, On[fe] = null, Br(wr(void 0, !0))), On[ye] = !0;
    }), Zr.on("readable", Gr.bind(null, On)), On;
  };
  return async_iterator = bn, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable)
    return _stream_readable;
  hasRequired_stream_readable = 1, _stream_readable = Pn;
  var r;
  Pn.ReadableState = Hr, events.exports.EventEmitter;
  var e = function(ci, vi) {
    return ci.listeners(vi).length;
  }, s = streamBrowser, o = requireBuffer().Buffer, fe = globalThis.Uint8Array || function() {
  };
  function me(wn) {
    return o.from(wn);
  }
  function ye(wn) {
    return o.isBuffer(wn) || wn instanceof fe;
  }
  var fr = require$$0$4, Er;
  fr && fr.debuglog ? Er = fr.debuglog("stream") : Er = function() {
  };
  var br = requireBuffer_list(), wr = destroy_1, kr = state, Gr = kr.getHighWaterMark, Vr = errorsBrowser.codes, jr = Vr.ERR_INVALID_ARG_TYPE, Kr = Vr.ERR_STREAM_PUSH_AFTER_EOF, bn = Vr.ERR_METHOD_NOT_IMPLEMENTED, Yr = Vr.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Zr, ti, On;
  inherits_browser.exports(Pn, s);
  var ni = wr.errorOrDestroy, In = ["error", "close", "destroy", "pause", "resume"];
  function Br(wn, ci, vi) {
    if (typeof wn.prependListener == "function")
      return wn.prependListener(ci, vi);
    !wn._events || !wn._events[ci] ? wn.on(ci, vi) : Array.isArray(wn._events[ci]) ? wn._events[ci].unshift(vi) : wn._events[ci] = [vi, wn._events[ci]];
  }
  function Hr(wn, ci, vi) {
    r = r || require_stream_duplex(), wn = wn || {}, typeof vi != "boolean" && (vi = ci instanceof r), this.objectMode = !!wn.objectMode, vi && (this.objectMode = this.objectMode || !!wn.readableObjectMode), this.highWaterMark = Gr(this, wn, "readableHighWaterMark", vi), this.buffer = new br(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = wn.emitClose !== !1, this.autoDestroy = !!wn.autoDestroy, this.destroyed = !1, this.defaultEncoding = wn.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, wn.encoding && (Zr || (Zr = requireString_decoder().StringDecoder), this.decoder = new Zr(wn.encoding), this.encoding = wn.encoding);
  }
  function Pn(wn) {
    if (r = r || require_stream_duplex(), !(this instanceof Pn))
      return new Pn(wn);
    var ci = this instanceof r;
    this._readableState = new Hr(wn, this, ci), this.readable = !0, wn && (typeof wn.read == "function" && (this._read = wn.read), typeof wn.destroy == "function" && (this._destroy = wn.destroy)), s.call(this);
  }
  Object.defineProperty(Pn.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(ci) {
      !this._readableState || (this._readableState.destroyed = ci);
    }
  }), Pn.prototype.destroy = wr.destroy, Pn.prototype._undestroy = wr.undestroy, Pn.prototype._destroy = function(wn, ci) {
    ci(wn);
  }, Pn.prototype.push = function(wn, ci) {
    var vi = this._readableState, Ni;
    return vi.objectMode ? Ni = !0 : typeof wn == "string" && (ci = ci || vi.defaultEncoding, ci !== vi.encoding && (wn = o.from(wn, ci), ci = ""), Ni = !0), ei(this, wn, ci, !1, Ni);
  }, Pn.prototype.unshift = function(wn) {
    return ei(this, wn, null, !0, !1);
  };
  function ei(wn, ci, vi, Ni, Fi) {
    Er("readableAddChunk", ci);
    var Pi = wn._readableState;
    if (ci === null)
      Pi.reading = !1, ri(wn, Pi);
    else {
      var Li;
      if (Fi || (Li = Nn(Pi, ci)), Li)
        ni(wn, Li);
      else if (Pi.objectMode || ci && ci.length > 0)
        if (typeof ci != "string" && !Pi.objectMode && Object.getPrototypeOf(ci) !== o.prototype && (ci = me(ci)), Ni)
          Pi.endEmitted ? ni(wn, new Yr()) : oi(wn, Pi, ci, !0);
        else if (Pi.ended)
          ni(wn, new Kr());
        else {
          if (Pi.destroyed)
            return !1;
          Pi.reading = !1, Pi.decoder && !vi ? (ci = Pi.decoder.write(ci), Pi.objectMode || ci.length !== 0 ? oi(wn, Pi, ci, !1) : di(wn, Pi)) : oi(wn, Pi, ci, !1);
        }
      else
        Ni || (Pi.reading = !1, di(wn, Pi));
    }
    return !Pi.ended && (Pi.length < Pi.highWaterMark || Pi.length === 0);
  }
  function oi(wn, ci, vi, Ni) {
    ci.flowing && ci.length === 0 && !ci.sync ? (ci.awaitDrain = 0, wn.emit("data", vi)) : (ci.length += ci.objectMode ? 1 : vi.length, Ni ? ci.buffer.unshift(vi) : ci.buffer.push(vi), ci.needReadable && Sn(wn)), di(wn, ci);
  }
  function Nn(wn, ci) {
    var vi;
    return !ye(ci) && typeof ci != "string" && ci !== void 0 && !wn.objectMode && (vi = new jr("chunk", ["string", "Buffer", "Uint8Array"], ci)), vi;
  }
  Pn.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Pn.prototype.setEncoding = function(wn) {
    Zr || (Zr = requireString_decoder().StringDecoder);
    var ci = new Zr(wn);
    this._readableState.decoder = ci, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var vi = this._readableState.buffer.head, Ni = ""; vi !== null; )
      Ni += ci.write(vi.data), vi = vi.next;
    return this._readableState.buffer.clear(), Ni !== "" && this._readableState.buffer.push(Ni), this._readableState.length = Ni.length, this;
  };
  var En = 1073741824;
  function qr(wn) {
    return wn >= En ? wn = En : (wn--, wn |= wn >>> 1, wn |= wn >>> 2, wn |= wn >>> 4, wn |= wn >>> 8, wn |= wn >>> 16, wn++), wn;
  }
  function Jr(wn, ci) {
    return wn <= 0 || ci.length === 0 && ci.ended ? 0 : ci.objectMode ? 1 : wn !== wn ? ci.flowing && ci.length ? ci.buffer.head.data.length : ci.length : (wn > ci.highWaterMark && (ci.highWaterMark = qr(wn)), wn <= ci.length ? wn : ci.ended ? ci.length : (ci.needReadable = !0, 0));
  }
  Pn.prototype.read = function(wn) {
    Er("read", wn), wn = parseInt(wn, 10);
    var ci = this._readableState, vi = wn;
    if (wn !== 0 && (ci.emittedReadable = !1), wn === 0 && ci.needReadable && ((ci.highWaterMark !== 0 ? ci.length >= ci.highWaterMark : ci.length > 0) || ci.ended))
      return Er("read: emitReadable", ci.length, ci.ended), ci.length === 0 && ci.ended ? hi(this) : Sn(this), null;
    if (wn = Jr(wn, ci), wn === 0 && ci.ended)
      return ci.length === 0 && hi(this), null;
    var Ni = ci.needReadable;
    Er("need readable", Ni), (ci.length === 0 || ci.length - wn < ci.highWaterMark) && (Ni = !0, Er("length less than watermark", Ni)), ci.ended || ci.reading ? (Ni = !1, Er("reading or ended", Ni)) : Ni && (Er("do read"), ci.reading = !0, ci.sync = !0, ci.length === 0 && (ci.needReadable = !0), this._read(ci.highWaterMark), ci.sync = !1, ci.reading || (wn = Jr(vi, ci)));
    var Fi;
    return wn > 0 ? Fi = ui(wn, ci) : Fi = null, Fi === null ? (ci.needReadable = ci.length <= ci.highWaterMark, wn = 0) : (ci.length -= wn, ci.awaitDrain = 0), ci.length === 0 && (ci.ended || (ci.needReadable = !0), vi !== wn && ci.ended && hi(this)), Fi !== null && this.emit("data", Fi), Fi;
  };
  function ri(wn, ci) {
    if (Er("onEofChunk"), !ci.ended) {
      if (ci.decoder) {
        var vi = ci.decoder.end();
        vi && vi.length && (ci.buffer.push(vi), ci.length += ci.objectMode ? 1 : vi.length);
      }
      ci.ended = !0, ci.sync ? Sn(wn) : (ci.needReadable = !1, ci.emittedReadable || (ci.emittedReadable = !0, ai(wn)));
    }
  }
  function Sn(wn) {
    var ci = wn._readableState;
    Er("emitReadable", ci.needReadable, ci.emittedReadable), ci.needReadable = !1, ci.emittedReadable || (Er("emitReadable", ci.flowing), ci.emittedReadable = !0, process.nextTick(ai, wn));
  }
  function ai(wn) {
    var ci = wn._readableState;
    Er("emitReadable_", ci.destroyed, ci.length, ci.ended), !ci.destroyed && (ci.length || ci.ended) && (wn.emit("readable"), ci.emittedReadable = !1), ci.needReadable = !ci.flowing && !ci.ended && ci.length <= ci.highWaterMark, yi(wn);
  }
  function di(wn, ci) {
    ci.readingMore || (ci.readingMore = !0, process.nextTick(ii, wn, ci));
  }
  function ii(wn, ci) {
    for (; !ci.reading && !ci.ended && (ci.length < ci.highWaterMark || ci.flowing && ci.length === 0); ) {
      var vi = ci.length;
      if (Er("maybeReadMore read 0"), wn.read(0), vi === ci.length)
        break;
    }
    ci.readingMore = !1;
  }
  Pn.prototype._read = function(wn) {
    ni(this, new bn("_read()"));
  }, Pn.prototype.pipe = function(wn, ci) {
    var vi = this, Ni = this._readableState;
    switch (Ni.pipesCount) {
      case 0:
        Ni.pipes = wn;
        break;
      case 1:
        Ni.pipes = [Ni.pipes, wn];
        break;
      default:
        Ni.pipes.push(wn);
        break;
    }
    Ni.pipesCount += 1, Er("pipe count=%d opts=%j", Ni.pipesCount, ci);
    var Fi = (!ci || ci.end !== !1) && wn !== process.stdout && wn !== process.stderr, Pi = Fi ? oo : ji;
    Ni.endEmitted ? process.nextTick(Pi) : vi.once("end", Pi), wn.on("unpipe", Li);
    function Li(si, Wr) {
      Er("onunpipe"), si === vi && Wr && Wr.hasUnpiped === !1 && (Wr.hasUnpiped = !0, Ki());
    }
    function oo() {
      Er("onend"), wn.end();
    }
    var ao = fi(vi);
    wn.on("drain", ao);
    var zi = !1;
    function Ki() {
      Er("cleanup"), wn.removeListener("close", eo), wn.removeListener("finish", Ui), wn.removeListener("drain", ao), wn.removeListener("error", Yi), wn.removeListener("unpipe", Li), vi.removeListener("end", oo), vi.removeListener("end", ji), vi.removeListener("data", Vi), zi = !0, Ni.awaitDrain && (!wn._writableState || wn._writableState.needDrain) && ao();
    }
    vi.on("data", Vi);
    function Vi(si) {
      Er("ondata");
      var Wr = wn.write(si);
      Er("dest.write", Wr), Wr === !1 && ((Ni.pipesCount === 1 && Ni.pipes === wn || Ni.pipesCount > 1 && Qr(Ni.pipes, wn) !== -1) && !zi && (Er("false write response, pause", Ni.awaitDrain), Ni.awaitDrain++), vi.pause());
    }
    function Yi(si) {
      Er("onerror", si), ji(), wn.removeListener("error", Yi), e(wn, "error") === 0 && ni(wn, si);
    }
    Br(wn, "error", Yi);
    function eo() {
      wn.removeListener("finish", Ui), ji();
    }
    wn.once("close", eo);
    function Ui() {
      Er("onfinish"), wn.removeListener("close", eo), ji();
    }
    wn.once("finish", Ui);
    function ji() {
      Er("unpipe"), vi.unpipe(wn);
    }
    return wn.emit("pipe", vi), Ni.flowing || (Er("pipe resume"), vi.resume()), wn;
  };
  function fi(wn) {
    return function() {
      var vi = wn._readableState;
      Er("pipeOnDrain", vi.awaitDrain), vi.awaitDrain && vi.awaitDrain--, vi.awaitDrain === 0 && e(wn, "data") && (vi.flowing = !0, yi(wn));
    };
  }
  Pn.prototype.unpipe = function(wn) {
    var ci = this._readableState, vi = {
      hasUnpiped: !1
    };
    if (ci.pipesCount === 0)
      return this;
    if (ci.pipesCount === 1)
      return wn && wn !== ci.pipes ? this : (wn || (wn = ci.pipes), ci.pipes = null, ci.pipesCount = 0, ci.flowing = !1, wn && wn.emit("unpipe", this, vi), this);
    if (!wn) {
      var Ni = ci.pipes, Fi = ci.pipesCount;
      ci.pipes = null, ci.pipesCount = 0, ci.flowing = !1;
      for (var Pi = 0; Pi < Fi; Pi++)
        Ni[Pi].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var Li = Qr(ci.pipes, wn);
    return Li === -1 ? this : (ci.pipes.splice(Li, 1), ci.pipesCount -= 1, ci.pipesCount === 1 && (ci.pipes = ci.pipes[0]), wn.emit("unpipe", this, vi), this);
  }, Pn.prototype.on = function(wn, ci) {
    var vi = s.prototype.on.call(this, wn, ci), Ni = this._readableState;
    return wn === "data" ? (Ni.readableListening = this.listenerCount("readable") > 0, Ni.flowing !== !1 && this.resume()) : wn === "readable" && !Ni.endEmitted && !Ni.readableListening && (Ni.readableListening = Ni.needReadable = !0, Ni.flowing = !1, Ni.emittedReadable = !1, Er("on readable", Ni.length, Ni.reading), Ni.length ? Sn(this) : Ni.reading || process.nextTick(bi, this)), vi;
  }, Pn.prototype.addListener = Pn.prototype.on, Pn.prototype.removeListener = function(wn, ci) {
    var vi = s.prototype.removeListener.call(this, wn, ci);
    return wn === "readable" && process.nextTick(Ei, this), vi;
  }, Pn.prototype.removeAllListeners = function(wn) {
    var ci = s.prototype.removeAllListeners.apply(this, arguments);
    return (wn === "readable" || wn === void 0) && process.nextTick(Ei, this), ci;
  };
  function Ei(wn) {
    var ci = wn._readableState;
    ci.readableListening = wn.listenerCount("readable") > 0, ci.resumeScheduled && !ci.paused ? ci.flowing = !0 : wn.listenerCount("data") > 0 && wn.resume();
  }
  function bi(wn) {
    Er("readable nexttick read 0"), wn.read(0);
  }
  Pn.prototype.resume = function() {
    var wn = this._readableState;
    return wn.flowing || (Er("resume"), wn.flowing = !wn.readableListening, Si(this, wn)), wn.paused = !1, this;
  };
  function Si(wn, ci) {
    ci.resumeScheduled || (ci.resumeScheduled = !0, process.nextTick(Ii, wn, ci));
  }
  function Ii(wn, ci) {
    Er("resume", ci.reading), ci.reading || wn.read(0), ci.resumeScheduled = !1, wn.emit("resume"), yi(wn), ci.flowing && !ci.reading && wn.read(0);
  }
  Pn.prototype.pause = function() {
    return Er("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Er("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function yi(wn) {
    var ci = wn._readableState;
    for (Er("flow", ci.flowing); ci.flowing && wn.read() !== null; )
      ;
  }
  Pn.prototype.wrap = function(wn) {
    var ci = this, vi = this._readableState, Ni = !1;
    wn.on("end", function() {
      if (Er("wrapped end"), vi.decoder && !vi.ended) {
        var Li = vi.decoder.end();
        Li && Li.length && ci.push(Li);
      }
      ci.push(null);
    }), wn.on("data", function(Li) {
      if (Er("wrapped data"), vi.decoder && (Li = vi.decoder.write(Li)), !(vi.objectMode && Li == null) && !(!vi.objectMode && (!Li || !Li.length))) {
        var oo = ci.push(Li);
        oo || (Ni = !0, wn.pause());
      }
    });
    for (var Fi in wn)
      this[Fi] === void 0 && typeof wn[Fi] == "function" && (this[Fi] = function(oo) {
        return function() {
          return wn[oo].apply(wn, arguments);
        };
      }(Fi));
    for (var Pi = 0; Pi < In.length; Pi++)
      wn.on(In[Pi], this.emit.bind(this, In[Pi]));
    return this._read = function(Li) {
      Er("wrapped _read", Li), Ni && (Ni = !1, wn.resume());
    }, this;
  }, typeof Symbol == "function" && (Pn.prototype[Symbol.asyncIterator] = function() {
    return ti === void 0 && (ti = requireAsync_iterator()), ti(this);
  }), Object.defineProperty(Pn.prototype, "readableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(Pn.prototype, "readableBuffer", {
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(Pn.prototype, "readableFlowing", {
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(ci) {
      this._readableState && (this._readableState.flowing = ci);
    }
  }), Pn._fromList = ui, Object.defineProperty(Pn.prototype, "readableLength", {
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function ui(wn, ci) {
    if (ci.length === 0)
      return null;
    var vi;
    return ci.objectMode ? vi = ci.buffer.shift() : !wn || wn >= ci.length ? (ci.decoder ? vi = ci.buffer.join("") : ci.buffer.length === 1 ? vi = ci.buffer.first() : vi = ci.buffer.concat(ci.length), ci.buffer.clear()) : vi = ci.buffer.consume(wn, ci.decoder), vi;
  }
  function hi(wn) {
    var ci = wn._readableState;
    Er("endReadable", ci.endEmitted), ci.endEmitted || (ci.ended = !0, process.nextTick(gi, ci, wn));
  }
  function gi(wn, ci) {
    if (Er("endReadableNT", wn.endEmitted, wn.length), !wn.endEmitted && wn.length === 0 && (wn.endEmitted = !0, ci.readable = !1, ci.emit("end"), wn.autoDestroy)) {
      var vi = ci._writableState;
      (!vi || vi.autoDestroy && vi.finished) && ci.destroy();
    }
  }
  typeof Symbol == "function" && (Pn.from = function(wn, ci) {
    return On === void 0 && (On = requireFromBrowser()), On(Pn, wn, ci);
  });
  function Qr(wn, ci) {
    for (var vi = 0, Ni = wn.length; vi < Ni; vi++)
      if (wn[vi] === ci)
        return vi;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform = Transform$3, _require$codes$1 = errorsBrowser.codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0, Duplex = require_stream_duplex();
inherits_browser.exports(Transform$3, Duplex);
function afterTransform(r, e) {
  var s = this._transformState;
  s.transforming = !1;
  var o = s.writecb;
  if (o === null)
    return this.emit("error", new ERR_MULTIPLE_CALLBACK());
  s.writechunk = null, s.writecb = null, e != null && this.push(e), o(r);
  var fe = this._readableState;
  fe.reading = !1, (fe.needReadable || fe.length < fe.highWaterMark) && this._read(fe.highWaterMark);
}
function Transform$3(r) {
  if (!(this instanceof Transform$3))
    return new Transform$3(r);
  Duplex.call(this, r), this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, r && (typeof r.transform == "function" && (this._transform = r.transform), typeof r.flush == "function" && (this._flush = r.flush)), this.on("prefinish", prefinish);
}
function prefinish() {
  var r = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, s) {
    done(r, e, s);
  }) : done(this, null, null);
}
Transform$3.prototype.push = function(r, e) {
  return this._transformState.needTransform = !1, Duplex.prototype.push.call(this, r, e);
};
Transform$3.prototype._transform = function(r, e, s) {
  s(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform$3.prototype._write = function(r, e, s) {
  var o = this._transformState;
  if (o.writecb = s, o.writechunk = r, o.writeencoding = e, !o.transforming) {
    var fe = this._readableState;
    (o.needTransform || fe.needReadable || fe.length < fe.highWaterMark) && this._read(fe.highWaterMark);
  }
};
Transform$3.prototype._read = function(r) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
Transform$3.prototype._destroy = function(r, e) {
  Duplex.prototype._destroy.call(this, r, function(s) {
    e(s);
  });
};
function done(r, e, s) {
  if (e)
    return r.emit("error", e);
  if (s != null && r.push(s), r._writableState.length)
    throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (r._transformState.transforming)
    throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return r.push(null);
}
var _stream_passthrough = PassThrough, Transform$2 = _stream_transform;
inherits_browser.exports(PassThrough, Transform$2);
function PassThrough(r) {
  if (!(this instanceof PassThrough))
    return new PassThrough(r);
  Transform$2.call(this, r);
}
PassThrough.prototype._transform = function(r, e, s) {
  s(null, r);
};
var eos;
function once(r) {
  var e = !1;
  return function() {
    e || (e = !0, r.apply(void 0, arguments));
  };
}
var _require$codes = errorsBrowser.codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop$3(r) {
  if (r)
    throw r;
}
function isRequest(r) {
  return r.setHeader && typeof r.abort == "function";
}
function destroyer(r, e, s, o) {
  o = once(o);
  var fe = !1;
  r.on("close", function() {
    fe = !0;
  }), eos === void 0 && (eos = endOfStream), eos(r, {
    readable: e,
    writable: s
  }, function(ye) {
    if (ye)
      return o(ye);
    fe = !0, o();
  });
  var me = !1;
  return function(ye) {
    if (!fe && !me) {
      if (me = !0, isRequest(r))
        return r.abort();
      if (typeof r.destroy == "function")
        return r.destroy();
      o(ye || new ERR_STREAM_DESTROYED("pipe"));
    }
  };
}
function call(r) {
  r();
}
function pipe$1(r, e) {
  return r.pipe(e);
}
function popCallback(r) {
  return !r.length || typeof r[r.length - 1] != "function" ? noop$3 : r.pop();
}
function pipeline() {
  for (var r = arguments.length, e = new Array(r), s = 0; s < r; s++)
    e[s] = arguments[s];
  var o = popCallback(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new ERR_MISSING_ARGS("streams");
  var fe, me = e.map(function(ye, fr) {
    var Er = fr < e.length - 1, br = fr > 0;
    return destroyer(ye, Er, br, function(wr) {
      fe || (fe = wr), wr && me.forEach(call), !Er && (me.forEach(call), o(fe));
    });
  });
  return e.reduce(pipe$1);
}
var pipeline_1 = pipeline;
(function(r, e) {
  e = r.exports = require_stream_readable(), e.Stream = e, e.Readable = e, e.Writable = require_stream_writable(), e.Duplex = require_stream_duplex(), e.Transform = _stream_transform, e.PassThrough = _stream_passthrough, e.finished = endOfStream, e.pipeline = pipeline_1;
})(readableBrowser, readableBrowser.exports);
const { Transform: Transform$1 } = readableBrowser.exports;
var keccak$1 = (r) => class ic extends Transform$1 {
  constructor(s, o, fe, me, ye) {
    super(ye), this._rate = s, this._capacity = o, this._delimitedSuffix = fe, this._hashBitLength = me, this._options = ye, this._state = new r(), this._state.initialize(s, o), this._finalized = !1;
  }
  _transform(s, o, fe) {
    let me = null;
    try {
      this.update(s, o);
    } catch (ye) {
      me = ye;
    }
    fe(me);
  }
  _flush(s) {
    let o = null;
    try {
      this.push(this.digest());
    } catch (fe) {
      o = fe;
    }
    s(o);
  }
  update(s, o) {
    if (!Buffer.isBuffer(s) && typeof s != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Digest already called");
    return Buffer.isBuffer(s) || (s = Buffer.from(s, o)), this._state.absorb(s), this;
  }
  digest(s) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);
    let o = this._state.squeeze(this._hashBitLength / 8);
    return s !== void 0 && (o = o.toString(s)), this._resetState(), o;
  }
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  _clone() {
    const s = new ic(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
    return this._state.copy(s._state), s._finalized = this._finalized, s;
  }
};
const { Transform } = readableBrowser.exports;
var shake = (r) => class sc extends Transform {
  constructor(s, o, fe, me) {
    super(me), this._rate = s, this._capacity = o, this._delimitedSuffix = fe, this._options = me, this._state = new r(), this._state.initialize(s, o), this._finalized = !1;
  }
  _transform(s, o, fe) {
    let me = null;
    try {
      this.update(s, o);
    } catch (ye) {
      me = ye;
    }
    fe(me);
  }
  _flush() {
  }
  _read(s) {
    this.push(this.squeeze(s));
  }
  update(s, o) {
    if (!Buffer.isBuffer(s) && typeof s != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Squeeze already called");
    return Buffer.isBuffer(s) || (s = Buffer.from(s, o)), this._state.absorb(s), this;
  }
  squeeze(s, o) {
    this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));
    let fe = this._state.squeeze(s);
    return o !== void 0 && (fe = fe.toString(o)), fe;
  }
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  _clone() {
    const s = new sc(this._rate, this._capacity, this._delimitedSuffix, this._options);
    return this._state.copy(s._state), s._finalized = this._finalized, s;
  }
};
const createKeccak = keccak$1, createShake = shake;
var api = function(r) {
  const e = createKeccak(r), s = createShake(r);
  return function(o, fe) {
    switch (typeof o == "string" ? o.toLowerCase() : o) {
      case "keccak224":
        return new e(1152, 448, null, 224, fe);
      case "keccak256":
        return new e(1088, 512, null, 256, fe);
      case "keccak384":
        return new e(832, 768, null, 384, fe);
      case "keccak512":
        return new e(576, 1024, null, 512, fe);
      case "sha3-224":
        return new e(1152, 448, 6, 224, fe);
      case "sha3-256":
        return new e(1088, 512, 6, 256, fe);
      case "sha3-384":
        return new e(832, 768, 6, 384, fe);
      case "sha3-512":
        return new e(576, 1024, 6, 512, fe);
      case "shake128":
        return new s(1344, 256, 31, fe);
      case "shake256":
        return new s(1088, 512, 31, fe);
      default:
        throw new Error("Invald algorithm: " + o);
    }
  };
}, keccakStateUnroll = {};
const P1600_ROUND_CONSTANTS = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
keccakStateUnroll.p1600 = function(r) {
  for (let e = 0; e < 24; ++e) {
    const s = r[0] ^ r[10] ^ r[20] ^ r[30] ^ r[40], o = r[1] ^ r[11] ^ r[21] ^ r[31] ^ r[41], fe = r[2] ^ r[12] ^ r[22] ^ r[32] ^ r[42], me = r[3] ^ r[13] ^ r[23] ^ r[33] ^ r[43], ye = r[4] ^ r[14] ^ r[24] ^ r[34] ^ r[44], fr = r[5] ^ r[15] ^ r[25] ^ r[35] ^ r[45], Er = r[6] ^ r[16] ^ r[26] ^ r[36] ^ r[46], br = r[7] ^ r[17] ^ r[27] ^ r[37] ^ r[47], wr = r[8] ^ r[18] ^ r[28] ^ r[38] ^ r[48], kr = r[9] ^ r[19] ^ r[29] ^ r[39] ^ r[49];
    let Gr = wr ^ (fe << 1 | me >>> 31), Vr = kr ^ (me << 1 | fe >>> 31);
    const jr = r[0] ^ Gr, Kr = r[1] ^ Vr, bn = r[10] ^ Gr, Yr = r[11] ^ Vr, Zr = r[20] ^ Gr, ti = r[21] ^ Vr, On = r[30] ^ Gr, ni = r[31] ^ Vr, In = r[40] ^ Gr, Br = r[41] ^ Vr;
    Gr = s ^ (ye << 1 | fr >>> 31), Vr = o ^ (fr << 1 | ye >>> 31);
    const Hr = r[2] ^ Gr, Pn = r[3] ^ Vr, ei = r[12] ^ Gr, oi = r[13] ^ Vr, Nn = r[22] ^ Gr, En = r[23] ^ Vr, qr = r[32] ^ Gr, Jr = r[33] ^ Vr, ri = r[42] ^ Gr, Sn = r[43] ^ Vr;
    Gr = fe ^ (Er << 1 | br >>> 31), Vr = me ^ (br << 1 | Er >>> 31);
    const ai = r[4] ^ Gr, di = r[5] ^ Vr, ii = r[14] ^ Gr, fi = r[15] ^ Vr, Ei = r[24] ^ Gr, bi = r[25] ^ Vr, Si = r[34] ^ Gr, Ii = r[35] ^ Vr, yi = r[44] ^ Gr, ui = r[45] ^ Vr;
    Gr = ye ^ (wr << 1 | kr >>> 31), Vr = fr ^ (kr << 1 | wr >>> 31);
    const hi = r[6] ^ Gr, gi = r[7] ^ Vr, Qr = r[16] ^ Gr, wn = r[17] ^ Vr, ci = r[26] ^ Gr, vi = r[27] ^ Vr, Ni = r[36] ^ Gr, Fi = r[37] ^ Vr, Pi = r[46] ^ Gr, Li = r[47] ^ Vr;
    Gr = Er ^ (s << 1 | o >>> 31), Vr = br ^ (o << 1 | s >>> 31);
    const oo = r[8] ^ Gr, ao = r[9] ^ Vr, zi = r[18] ^ Gr, Ki = r[19] ^ Vr, Vi = r[28] ^ Gr, Yi = r[29] ^ Vr, eo = r[38] ^ Gr, Ui = r[39] ^ Vr, ji = r[48] ^ Gr, si = r[49] ^ Vr, Wr = jr, Xr = Kr, li = Yr << 4 | bn >>> 28, _i = bn << 4 | Yr >>> 28, $i = Zr << 3 | ti >>> 29, Ai = ti << 3 | Zr >>> 29, Di = ni << 9 | On >>> 23, Mi = On << 9 | ni >>> 23, to = In << 18 | Br >>> 14, so = Br << 18 | In >>> 14, no = Hr << 1 | Pn >>> 31, Po = Pn << 1 | Hr >>> 31, Uo = oi << 12 | ei >>> 20, jo = ei << 12 | oi >>> 20, Go = Nn << 10 | En >>> 22, fo = En << 10 | Nn >>> 22, co = Jr << 13 | qr >>> 19, _o = qr << 13 | Jr >>> 19, Eo = ri << 2 | Sn >>> 30, vo = Sn << 2 | ri >>> 30, mo = di << 30 | ai >>> 2, Io = ai << 30 | di >>> 2, yo = ii << 6 | fi >>> 26, bo = fi << 6 | ii >>> 26, $o = bi << 11 | Ei >>> 21, Co = Ei << 11 | bi >>> 21, So = Si << 15 | Ii >>> 17, wo = Ii << 15 | Si >>> 17, uo = ui << 29 | yi >>> 3, To = yi << 29 | ui >>> 3, Ao = hi << 28 | gi >>> 4, Yo = gi << 28 | hi >>> 4, Ro = wn << 23 | Qr >>> 9, Xo = Qr << 23 | wn >>> 9, Mo = ci << 25 | vi >>> 7, Jo = vi << 25 | ci >>> 7, Zo = Ni << 21 | Fi >>> 11, ea = Fi << 21 | Ni >>> 11, ta = Li << 24 | Pi >>> 8, ra = Pi << 24 | Li >>> 8, Vo = oo << 27 | ao >>> 5, na = ao << 27 | oo >>> 5, ia = zi << 20 | Ki >>> 12, sa = Ki << 20 | zi >>> 12, oa = Yi << 7 | Vi >>> 25, aa = Vi << 7 | Yi >>> 25, qo = eo << 8 | Ui >>> 24, ca = Ui << 8 | eo >>> 24, Ho = ji << 14 | si >>> 18, Fo = si << 14 | ji >>> 18;
    r[0] = Wr ^ ~Uo & $o, r[1] = Xr ^ ~jo & Co, r[10] = Ao ^ ~ia & $i, r[11] = Yo ^ ~sa & Ai, r[20] = no ^ ~yo & Mo, r[21] = Po ^ ~bo & Jo, r[30] = Vo ^ ~li & Go, r[31] = na ^ ~_i & fo, r[40] = mo ^ ~Ro & oa, r[41] = Io ^ ~Xo & aa, r[2] = Uo ^ ~$o & Zo, r[3] = jo ^ ~Co & ea, r[12] = ia ^ ~$i & co, r[13] = sa ^ ~Ai & _o, r[22] = yo ^ ~Mo & qo, r[23] = bo ^ ~Jo & ca, r[32] = li ^ ~Go & So, r[33] = _i ^ ~fo & wo, r[42] = Ro ^ ~oa & Di, r[43] = Xo ^ ~aa & Mi, r[4] = $o ^ ~Zo & Ho, r[5] = Co ^ ~ea & Fo, r[14] = $i ^ ~co & uo, r[15] = Ai ^ ~_o & To, r[24] = Mo ^ ~qo & to, r[25] = Jo ^ ~ca & so, r[34] = Go ^ ~So & ta, r[35] = fo ^ ~wo & ra, r[44] = oa ^ ~Di & Eo, r[45] = aa ^ ~Mi & vo, r[6] = Zo ^ ~Ho & Wr, r[7] = ea ^ ~Fo & Xr, r[16] = co ^ ~uo & Ao, r[17] = _o ^ ~To & Yo, r[26] = qo ^ ~to & no, r[27] = ca ^ ~so & Po, r[36] = So ^ ~ta & Vo, r[37] = wo ^ ~ra & na, r[46] = Di ^ ~Eo & mo, r[47] = Mi ^ ~vo & Io, r[8] = Ho ^ ~Wr & Uo, r[9] = Fo ^ ~Xr & jo, r[18] = uo ^ ~Ao & ia, r[19] = To ^ ~Yo & sa, r[28] = to ^ ~no & yo, r[29] = so ^ ~Po & bo, r[38] = ta ^ ~Vo & li, r[39] = ra ^ ~na & _i, r[48] = Eo ^ ~mo & Ro, r[49] = vo ^ ~Io & Xo, r[0] ^= P1600_ROUND_CONSTANTS[e * 2], r[1] ^= P1600_ROUND_CONSTANTS[e * 2 + 1];
  }
};
const keccakState = keccakStateUnroll;
function Keccak() {
  this.state = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], this.blockSize = null, this.count = 0, this.squeezing = !1;
}
Keccak.prototype.initialize = function(r, e) {
  for (let s = 0; s < 50; ++s)
    this.state[s] = 0;
  this.blockSize = r / 8, this.count = 0, this.squeezing = !1;
};
Keccak.prototype.absorb = function(r) {
  for (let e = 0; e < r.length; ++e)
    this.state[~~(this.count / 4)] ^= r[e] << 8 * (this.count % 4), this.count += 1, this.count === this.blockSize && (keccakState.p1600(this.state), this.count = 0);
};
Keccak.prototype.absorbLastFewBits = function(r) {
  this.state[~~(this.count / 4)] ^= r << 8 * (this.count % 4), (r & 128) !== 0 && this.count === this.blockSize - 1 && keccakState.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << 8 * ((this.blockSize - 1) % 4), keccakState.p1600(this.state), this.count = 0, this.squeezing = !0;
};
Keccak.prototype.squeeze = function(r) {
  this.squeezing || this.absorbLastFewBits(1);
  const e = Buffer.alloc(r);
  for (let s = 0; s < r; ++s)
    e[s] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 255, this.count += 1, this.count === this.blockSize && (keccakState.p1600(this.state), this.count = 0);
  return e;
};
Keccak.prototype.copy = function(r) {
  for (let e = 0; e < 50; ++e)
    r.state[e] = this.state[e];
  r.blockSize = this.blockSize, r.count = this.count, r.squeezing = this.squeezing;
};
var keccak = Keccak, js$1 = api(keccak), __importDefault$d = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(smartContract, "__esModule", { value: !0 });
smartContract.SmartContract = void 0;
const bignumber_js_1$a = __importDefault$d(require$$1$2), address_1$3 = address$2, compatibility_1 = compatibility, errors_1$b = errors$q, transaction_1$4 = transaction, utils_1$1 = utils$a, utils_2 = utils$b, codeMetadata_1 = codeMetadata, function_1 = _function, interaction_1 = interaction, nativeSerializer_1 = nativeSerializer, query_1 = query, transactionPayloadBuilders_1 = transactionPayloadBuilders, createKeccakHash = js$1;
class SmartContract {
  constructor(e = {}) {
    this.address = new address_1$3.Address(), this.methodsExplicit = {}, this.methods = {}, this.address = e.address || new address_1$3.Address(), this.abi = e.abi, this.abi && this.setupMethods();
  }
  setupMethods() {
    let e = this, s = this.getAbi();
    for (const o of s.getEndpoints()) {
      let fe = o.name;
      this.methodsExplicit[fe] = function(me) {
        let ye = new function_1.ContractFunction(fe);
        return new interaction_1.Interaction(e, ye, me || []);
      }, this.methods[fe] = function(me) {
        let ye = new function_1.ContractFunction(fe), fr = nativeSerializer_1.NativeSerializer.nativeToTypedValues(me || [], o);
        return new interaction_1.Interaction(e, ye, fr || []);
      };
    }
  }
  setAddress(e) {
    this.address = e;
  }
  getAddress() {
    return this.address;
  }
  getAbi() {
    return utils_1$1.guardValueIsSet("abi", this.abi), this.abi;
  }
  getEndpoint(e) {
    return this.getAbi().getEndpoint(e);
  }
  deploy({ deployer: e, code: s, codeMetadata: o, initArguments: fe, value: me, gasLimit: ye, gasPrice: fr, chainID: Er }) {
    compatibility_1.Compatibility.guardAddressIsSetAndNonZero(e, "'deployer' of SmartContract.deploy()", "pass the actual address to deploy()"), o = o || new codeMetadata_1.CodeMetadata(), fe = fe || [], me = me || 0;
    let br = new transactionPayloadBuilders_1.ContractDeployPayloadBuilder().setCode(s).setCodeMetadata(o).setInitArgs(fe).build();
    return new transaction_1$4.Transaction({
      receiver: address_1$3.Address.Zero(),
      sender: e,
      value: me,
      gasLimit: ye,
      gasPrice: fr,
      data: br,
      chainID: Er
    });
  }
  upgrade({ caller: e, code: s, codeMetadata: o, initArguments: fe, value: me, gasLimit: ye, gasPrice: fr, chainID: Er }) {
    compatibility_1.Compatibility.guardAddressIsSetAndNonZero(e, "'caller' of SmartContract.upgrade()", "pass the actual address to upgrade()"), this.ensureHasAddress(), o = o || new codeMetadata_1.CodeMetadata(), fe = fe || [], me = me || 0;
    let br = new transactionPayloadBuilders_1.ContractUpgradePayloadBuilder().setCode(s).setCodeMetadata(o).setInitArgs(fe).build();
    return new transaction_1$4.Transaction({
      sender: e,
      receiver: this.getAddress(),
      value: me,
      gasLimit: ye,
      gasPrice: fr,
      data: br,
      chainID: Er
    });
  }
  call({ func: e, args: s, value: o, gasLimit: fe, receiver: me, gasPrice: ye, chainID: fr, caller: Er }) {
    compatibility_1.Compatibility.guardAddressIsSetAndNonZero(Er, "'caller' of SmartContract.call()", "pass the actual address to call()"), this.ensureHasAddress(), s = s || [], o = o || 0;
    let br = new transactionPayloadBuilders_1.ContractCallPayloadBuilder().setFunction(e).setArgs(s).build();
    return new transaction_1$4.Transaction({
      sender: Er,
      receiver: me || this.getAddress(),
      value: o,
      gasLimit: fe,
      gasPrice: ye,
      data: br,
      chainID: fr
    });
  }
  createQuery({ func: e, args: s, value: o, caller: fe }) {
    return this.ensureHasAddress(), new query_1.Query({
      address: this.getAddress(),
      func: e,
      args: s,
      value: o,
      caller: fe
    });
  }
  ensureHasAddress() {
    if (!this.getAddress().bech32())
      throw new errors_1$b.ErrContractHasNoAddress();
  }
  static computeAddress(e, s) {
    let o = Buffer.alloc(8, 0), fe = new address_1$3.Address(e.bech32()).pubkey(), me = fe.slice(30), ye = Buffer.alloc(8);
    const fr = new bignumber_js_1$a.default(s.valueOf().toString(10)), Er = utils_2.bigIntToBuffer(fr);
    ye.write(Er.reverse().toString("hex"), "hex");
    let br = Buffer.concat([fe, ye]), wr = createKeccakHash("keccak256").update(br).digest(), kr = Buffer.from(transactionPayloadBuilders_1.ArwenVirtualMachine, "hex"), Gr = Buffer.concat([
      o,
      kr,
      wr.slice(10, 30),
      me
    ]);
    return new address_1$3.Address(Gr);
  }
}
smartContract.SmartContract = SmartContract;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(argSerializer, r), s(code$1, r), s(codec$1, r), s(codeMetadata, r), s(_function, r), s(interaction, r), s(interactionChecker, r), s(_interface, r), s(nativeSerializer, r), s(query, r), s(resultsParser, r), s(returnCode, r), s(smartContract, r), s(transactionPayloadBuilders, r), s(typesystem, r);
})(smartcontracts);
Object.defineProperty(relayedTransactionV2Builder, "__esModule", { value: !0 });
relayedTransactionV2Builder.RelayedTransactionV2Builder = void 0;
const errors_1$a = errors$q, smartcontracts_1 = smartcontracts, transaction_1$3 = transaction, transactionPayload_1$2 = transactionPayload;
class RelayedTransactionV2Builder {
  setInnerTransaction(e) {
    return this.innerTransaction = e, this;
  }
  setInnerTransactionGasLimit(e) {
    return this.innerTransactionGasLimit = e, this;
  }
  setNetworkConfig(e) {
    return this.netConfig = e, this;
  }
  setRelayerAddress(e) {
    return this.relayerAddress = e, this;
  }
  setRelayerNonce(e) {
    return this.relayerNonce = e, this;
  }
  build() {
    if (!this.innerTransaction || !this.innerTransactionGasLimit || !this.relayerAddress || !this.netConfig || !this.innerTransaction.getSignature())
      throw new errors_1$a.ErrInvalidRelayedV2BuilderArguments();
    if (this.innerTransaction.getGasLimit() != 0)
      throw new errors_1$a.ErrGasLimitShouldBe0ForInnerTransaction();
    const { argumentsString: e } = new smartcontracts_1.ArgSerializer().valuesToString([
      new smartcontracts_1.AddressValue(this.innerTransaction.getReceiver()),
      new smartcontracts_1.U64Value(this.innerTransaction.getNonce().valueOf()),
      new smartcontracts_1.BytesValue(this.innerTransaction.getData().valueOf()),
      new smartcontracts_1.BytesValue(this.innerTransaction.getSignature())
    ]), s = `relayedTxV2@${e}`, o = new transactionPayload_1$2.TransactionPayload(s);
    let fe = new transaction_1$3.Transaction({
      sender: this.relayerAddress,
      receiver: this.innerTransaction.getSender(),
      value: 0,
      gasLimit: this.innerTransactionGasLimit.valueOf() + this.netConfig.MinGasLimit + this.netConfig.GasPerDataByte * o.length(),
      data: o,
      chainID: this.netConfig.ChainID
    });
    return this.relayerNonce && fe.setNonce(this.relayerNonce), fe;
  }
}
relayedTransactionV2Builder.RelayedTransactionV2Builder = RelayedTransactionV2Builder;
var signableMessage = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.SignableMessage = r.MESSAGE_PREFIX = void 0;
  const e = address$2, s = signature, o = js$1;
  r.MESSAGE_PREFIX = `Elrond Signed Message:
`;
  class fe {
    constructor(ye) {
      this.message = Buffer.from([]), this.signature = Buffer.from([]), this.version = 1, this.signer = "ErdJS", this.address = new e.Address(), Object.assign(this, ye);
    }
    serializeForSigning() {
      const ye = Buffer.from(this.message.length.toString()), fr = Buffer.concat([ye, this.message]);
      let Er = Buffer.concat([Buffer.from(r.MESSAGE_PREFIX), fr]);
      return o("keccak256").update(Er).digest();
    }
    serializeForSigningRaw() {
      return Buffer.concat([this.getMessageSize(), this.message]);
    }
    getSignature() {
      return this.signature;
    }
    applySignature(ye) {
      this.signature = s.interpretSignatureAsBuffer(ye);
    }
    getMessageSize() {
      const ye = Buffer.alloc(4);
      return ye.writeUInt32BE(this.message.length, 0), ye;
    }
    toJSON() {
      return {
        address: this.address.bech32(),
        message: "0x" + this.message.toString("hex"),
        signature: "0x" + this.signature.toString("hex"),
        version: this.version,
        signer: this.signer
      };
    }
  }
  r.SignableMessage = fe;
})(signableMessage);
var tokenOperations = {}, tokenOperationsFactory = {}, codec = {}, __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding$1(e, r, s);
  return __setModuleDefault$1(e, r), e;
}, __importDefault$c = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(codec, "__esModule", { value: !0 });
codec.addressToHex = codec.bufferToHex = codec.utf8ToHex = codec.bigIntToHex = codec.bigIntToBuffer = codec.bufferToBigInt = codec.stringToBuffer = void 0;
const bignumber_js_1$9 = __importDefault$c(require$$1$2), address_1$2 = address$2, contractsCodecUtils = __importStar$1(utils$b), codecUtils = __importStar$1(utils_codec);
function stringToBuffer(r) {
  return Buffer.from(r);
}
codec.stringToBuffer = stringToBuffer;
function bufferToBigInt(r) {
  return r.length == 0 ? new bignumber_js_1$9.default(0) : contractsCodecUtils.bufferToBigInt(r);
}
codec.bufferToBigInt = bufferToBigInt;
function bigIntToBuffer(r) {
  return r == 0 ? Buffer.from([]) : contractsCodecUtils.bigIntToBuffer(r);
}
codec.bigIntToBuffer = bigIntToBuffer;
function bigIntToHex(r) {
  return r == 0 ? "" : contractsCodecUtils.getHexMagnitudeOfBigInt(r);
}
codec.bigIntToHex = bigIntToHex;
function utf8ToHex(r) {
  const e = Buffer.from(r).toString("hex");
  return codecUtils.zeroPadStringIfOddLength(e);
}
codec.utf8ToHex = utf8ToHex;
function bufferToHex(r) {
  const e = r.toString("hex");
  return codecUtils.zeroPadStringIfOddLength(e);
}
codec.bufferToHex = bufferToHex;
function addressToHex(r) {
  return address_1$2.Address.fromBech32(r.toString()).pubkey().toString("hex");
}
codec.addressToHex = addressToHex;
Object.defineProperty(tokenOperationsFactory, "__esModule", { value: !0 });
tokenOperationsFactory.TokenOperationsFactory = void 0;
const constants_1$5 = constants$c, logger_1$2 = logger$1, networkParams_1 = networkParams, transaction_1$2 = transaction, transactionPayload_1$1 = transactionPayload, codec_1$1 = codec;
class TokenOperationsFactory {
  constructor(e) {
    this.config = e, this.trueAsHex = codec_1$1.utf8ToHex("true"), this.falseAsHex = codec_1$1.utf8ToHex("false");
  }
  issueFungible(e) {
    this.notifyAboutUnsettingBurnRoleGlobally();
    const s = [
      "issue",
      codec_1$1.utf8ToHex(e.tokenName),
      codec_1$1.utf8ToHex(e.tokenTicker),
      codec_1$1.bigIntToHex(e.initialSupply),
      codec_1$1.bigIntToHex(e.numDecimals),
      codec_1$1.utf8ToHex("canFreeze"),
      e.canFreeze ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canWipe"),
      e.canWipe ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canPause"),
      e.canPause ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canChangeOwner"),
      e.canChangeOwner ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canUpgrade"),
      e.canUpgrade ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canAddSpecialRoles"),
      e.canAddSpecialRoles ? this.trueAsHex : this.falseAsHex
    ];
    return this.createTransaction({
      sender: e.issuer,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      value: this.config.issueCost,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitIssue,
      dataParts: s
    });
  }
  notifyAboutUnsettingBurnRoleGlobally() {
    logger_1$2.Logger.info(`
==========
IMPORTANT!
==========
You are about to issue (register) a new token. This will set the role "ESDTRoleBurnForAll" (globally).
Once the token is registered, you can unset this role by calling "unsetBurnRoleGlobally" (in a separate transaction).`);
  }
  issueSemiFungible(e) {
    this.notifyAboutUnsettingBurnRoleGlobally();
    const s = [
      "issueSemiFungible",
      codec_1$1.utf8ToHex(e.tokenName),
      codec_1$1.utf8ToHex(e.tokenTicker),
      codec_1$1.utf8ToHex("canFreeze"),
      e.canFreeze ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canWipe"),
      e.canWipe ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canPause"),
      e.canPause ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canTransferNFTCreateRole"),
      e.canTransferNFTCreateRole ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canChangeOwner"),
      e.canChangeOwner ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canUpgrade"),
      e.canUpgrade ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canAddSpecialRoles"),
      e.canAddSpecialRoles ? this.trueAsHex : this.falseAsHex
    ];
    return this.createTransaction({
      sender: e.issuer,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      value: this.config.issueCost,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitIssue,
      dataParts: s
    });
  }
  issueNonFungible(e) {
    this.notifyAboutUnsettingBurnRoleGlobally();
    const s = [
      "issueNonFungible",
      codec_1$1.utf8ToHex(e.tokenName),
      codec_1$1.utf8ToHex(e.tokenTicker),
      codec_1$1.utf8ToHex("canFreeze"),
      e.canFreeze ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canWipe"),
      e.canWipe ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canPause"),
      e.canPause ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canTransferNFTCreateRole"),
      e.canTransferNFTCreateRole ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canChangeOwner"),
      e.canChangeOwner ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canUpgrade"),
      e.canUpgrade ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canAddSpecialRoles"),
      e.canAddSpecialRoles ? this.trueAsHex : this.falseAsHex
    ];
    return this.createTransaction({
      sender: e.issuer,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      value: this.config.issueCost,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitIssue,
      dataParts: s
    });
  }
  registerMetaESDT(e) {
    this.notifyAboutUnsettingBurnRoleGlobally();
    const s = [
      "registerMetaESDT",
      codec_1$1.utf8ToHex(e.tokenName),
      codec_1$1.utf8ToHex(e.tokenTicker),
      codec_1$1.bigIntToHex(e.numDecimals),
      codec_1$1.utf8ToHex("canFreeze"),
      e.canFreeze ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canWipe"),
      e.canWipe ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canPause"),
      e.canPause ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canTransferNFTCreateRole"),
      e.canTransferNFTCreateRole ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canChangeOwner"),
      e.canChangeOwner ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canUpgrade"),
      e.canUpgrade ? this.trueAsHex : this.falseAsHex,
      codec_1$1.utf8ToHex("canAddSpecialRoles"),
      e.canAddSpecialRoles ? this.trueAsHex : this.falseAsHex
    ];
    return this.createTransaction({
      sender: e.issuer,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      value: this.config.issueCost,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitIssue,
      dataParts: s
    });
  }
  registerAndSetAllRoles(e) {
    this.notifyAboutUnsettingBurnRoleGlobally();
    const s = [
      "registerAndSetAllRoles",
      codec_1$1.utf8ToHex(e.tokenName),
      codec_1$1.utf8ToHex(e.tokenTicker),
      codec_1$1.utf8ToHex(e.tokenType),
      codec_1$1.bigIntToHex(e.numDecimals)
    ];
    return this.createTransaction({
      sender: e.issuer,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      value: this.config.issueCost,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitIssue,
      dataParts: s
    });
  }
  setBurnRoleGlobally(e) {
    const s = ["setBurnRoleGlobally", codec_1$1.utf8ToHex(e.tokenIdentifier)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitToggleBurnRoleGlobally,
      dataParts: s
    });
  }
  unsetBurnRoleGlobally(e) {
    const s = ["unsetBurnRoleGlobally", codec_1$1.utf8ToHex(e.tokenIdentifier)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitToggleBurnRoleGlobally,
      dataParts: s
    });
  }
  setSpecialRoleOnFungible(e) {
    const s = [
      "setSpecialRole",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.addressToHex(e.user),
      ...e.addRoleLocalMint ? [codec_1$1.utf8ToHex("ESDTRoleLocalMint")] : [],
      ...e.addRoleLocalBurn ? [codec_1$1.utf8ToHex("ESDTRoleLocalBurn")] : []
    ];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitSetSpecialRole,
      dataParts: s
    });
  }
  setSpecialRoleOnSemiFungible(e) {
    const s = [
      "setSpecialRole",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.addressToHex(e.user),
      ...e.addRoleNFTCreate ? [codec_1$1.utf8ToHex("ESDTRoleNFTCreate")] : [],
      ...e.addRoleNFTBurn ? [codec_1$1.utf8ToHex("ESDTRoleNFTBurn")] : [],
      ...e.addRoleNFTAddQuantity ? [codec_1$1.utf8ToHex("ESDTRoleNFTAddQuantity")] : [],
      ...e.addRoleESDTTransferRole ? [codec_1$1.utf8ToHex("ESDTTransferRole")] : []
    ];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitSetSpecialRole,
      dataParts: s
    });
  }
  setSpecialRoleOnMetaESDT(e) {
    return this.setSpecialRoleOnSemiFungible(e);
  }
  setSpecialRoleOnNonFungible(e) {
    const s = [
      "setSpecialRole",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.addressToHex(e.user),
      ...e.addRoleNFTCreate ? [codec_1$1.utf8ToHex("ESDTRoleNFTCreate")] : [],
      ...e.addRoleNFTBurn ? [codec_1$1.utf8ToHex("ESDTRoleNFTBurn")] : [],
      ...e.addRoleNFTUpdateAttributes ? [codec_1$1.utf8ToHex("ESDTRoleNFTUpdateAttributes")] : [],
      ...e.addRoleNFTAddURI ? [codec_1$1.utf8ToHex("ESDTRoleNFTAddURI")] : [],
      ...e.addRoleESDTTransferRole ? [codec_1$1.utf8ToHex("ESDTTransferRole")] : []
    ];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitSetSpecialRole,
      dataParts: s
    });
  }
  nftCreate(e) {
    const s = [
      "ESDTNFTCreate",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.bigIntToHex(e.initialQuantity),
      codec_1$1.utf8ToHex(e.name),
      codec_1$1.bigIntToHex(e.royalties),
      codec_1$1.utf8ToHex(e.hash),
      codec_1$1.bufferToHex(e.attributes),
      ...e.uris.map(codec_1$1.utf8ToHex)
    ], fe = (e.name + e.hash + e.attributes + e.uris.join("")).length * this.config.gasLimitStorePerByte.valueOf();
    return this.createTransaction({
      sender: e.creator,
      receiver: e.creator,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitESDTNFTCreate.valueOf() + fe.valueOf(),
      dataParts: s
    });
  }
  pause(e) {
    const s = ["pause", codec_1$1.utf8ToHex(e.tokenIdentifier)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitPausing,
      dataParts: s
    });
  }
  unpause(e) {
    const s = ["unPause", codec_1$1.utf8ToHex(e.tokenIdentifier)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitPausing,
      dataParts: s
    });
  }
  freeze(e) {
    const s = ["freeze", codec_1$1.utf8ToHex(e.tokenIdentifier), codec_1$1.addressToHex(e.user)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitFreezing,
      dataParts: s
    });
  }
  unfreeze(e) {
    const s = ["unFreeze", codec_1$1.utf8ToHex(e.tokenIdentifier), codec_1$1.addressToHex(e.user)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitFreezing,
      dataParts: s
    });
  }
  wipe(e) {
    const s = ["wipe", codec_1$1.utf8ToHex(e.tokenIdentifier), codec_1$1.addressToHex(e.user)];
    return this.createTransaction({
      sender: e.manager,
      receiver: this.config.esdtContractAddress,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitWiping,
      dataParts: s
    });
  }
  localMint(e) {
    const s = ["ESDTLocalMint", codec_1$1.utf8ToHex(e.tokenIdentifier), codec_1$1.bigIntToHex(e.supplyToMint)];
    return this.createTransaction({
      sender: e.manager,
      receiver: e.manager,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitESDTLocalMint,
      dataParts: s
    });
  }
  localBurn(e) {
    const s = ["ESDTLocalBurn", codec_1$1.utf8ToHex(e.tokenIdentifier), codec_1$1.bigIntToHex(e.supplyToBurn)];
    return this.createTransaction({
      sender: e.manager,
      receiver: e.manager,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitESDTLocalBurn,
      dataParts: s
    });
  }
  updateAttributes(e) {
    const s = [
      "ESDTNFTUpdateAttributes",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.bigIntToHex(e.tokenNonce),
      codec_1$1.bufferToHex(e.attributes)
    ];
    return this.createTransaction({
      sender: e.manager,
      receiver: e.manager,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitESDTNFTUpdateAttributes,
      dataParts: s
    });
  }
  addQuantity(e) {
    const s = [
      "ESDTNFTAddQuantity",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.bigIntToHex(e.tokenNonce),
      codec_1$1.bigIntToHex(e.quantityToAdd)
    ];
    return this.createTransaction({
      sender: e.manager,
      receiver: e.manager,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitESDTNFTAddQuantity,
      dataParts: s
    });
  }
  burnQuantity(e) {
    const s = [
      "ESDTNFTBurn",
      codec_1$1.utf8ToHex(e.tokenIdentifier),
      codec_1$1.bigIntToHex(e.tokenNonce),
      codec_1$1.bigIntToHex(e.quantityToBurn)
    ];
    return this.createTransaction({
      sender: e.manager,
      receiver: e.manager,
      nonce: e.transactionNonce,
      gasPrice: e.gasPrice,
      gasLimitHint: e.gasLimit,
      executionGasLimit: this.config.gasLimitESDTNFTBurn,
      dataParts: s
    });
  }
  createTransaction({ sender: e, receiver: s, nonce: o, value: fe, gasPrice: me, gasLimitHint: ye, executionGasLimit: fr, dataParts: Er }) {
    const br = this.buildTransactionPayload(Er), wr = ye || this.computeGasLimit(br, fr), kr = new networkParams_1.TransactionVersion(constants_1$5.TRANSACTION_VERSION_DEFAULT), Gr = new networkParams_1.TransactionOptions(constants_1$5.TRANSACTION_OPTIONS_DEFAULT);
    return new transaction_1$2.Transaction({
      chainID: this.config.chainID,
      sender: e,
      receiver: s,
      gasLimit: wr,
      gasPrice: me,
      nonce: o || 0,
      value: fe || 0,
      data: br,
      version: kr,
      options: Gr
    });
  }
  buildTransactionPayload(e) {
    const s = e.join(constants_1$5.ARGUMENTS_SEPARATOR);
    return new transactionPayload_1$1.TransactionPayload(s);
  }
  computeGasLimit(e, s) {
    return this.config.minGasLimit.valueOf() + this.config.gasLimitPerByte.valueOf() * e.length() + s.valueOf();
  }
}
tokenOperationsFactory.TokenOperationsFactory = TokenOperationsFactory;
var tokenOperationsFactoryConfig = {};
Object.defineProperty(tokenOperationsFactoryConfig, "__esModule", { value: !0 });
tokenOperationsFactoryConfig.TokenOperationsFactoryConfig = void 0;
const address_1$1 = address$2;
class TokenOperationsFactoryConfig {
  constructor(e) {
    this.minGasPrice = 1e9, this.minGasLimit = 5e4, this.gasLimitPerByte = 1500, this.gasLimitIssue = 6e7, this.gasLimitToggleBurnRoleGlobally = 6e7, this.gasLimitESDTLocalMint = 3e5, this.gasLimitESDTLocalBurn = 3e5, this.gasLimitSetSpecialRole = 6e7, this.gasLimitPausing = 6e7, this.gasLimitFreezing = 6e7, this.gasLimitWiping = 6e7, this.gasLimitESDTNFTCreate = 3e6, this.gasLimitESDTNFTUpdateAttributes = 1e6, this.gasLimitESDTNFTAddQuantity = 1e6, this.gasLimitESDTNFTBurn = 1e6, this.gasLimitStorePerByte = 5e4, this.issueCost = "50000000000000000", this.esdtContractAddress = address_1$1.Address.fromBech32("erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqzllls8a5w6u"), this.chainID = e;
  }
}
tokenOperationsFactoryConfig.TokenOperationsFactoryConfig = TokenOperationsFactoryConfig;
var tokenOperationsOutcomeParser = {};
Object.defineProperty(tokenOperationsOutcomeParser, "__esModule", { value: !0 });
tokenOperationsOutcomeParser.TokenOperationsOutcomeParser = void 0;
const address_1 = address$2, errors_1$9 = errors$q, codec_1 = codec;
class TokenOperationsOutcomeParser {
  parseIssueFungible(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "issue");
    return { tokenIdentifier: this.extractTokenIdentifier(s) };
  }
  parseIssueNonFungible(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "issueNonFungible");
    return { tokenIdentifier: this.extractTokenIdentifier(s) };
  }
  parseIssueSemiFungible(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "issueSemiFungible");
    return { tokenIdentifier: this.extractTokenIdentifier(s) };
  }
  parseRegisterMetaESDT(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "registerMetaESDT");
    return { tokenIdentifier: this.extractTokenIdentifier(s) };
  }
  parseRegisterAndSetAllRoles(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "registerAndSetAllRoles"), o = this.extractTokenIdentifier(s), me = this.findSingleEventByIdentifier(e, "ESDTSetRole").topics.slice(3).map((ye) => ye.valueOf().toString());
    return { tokenIdentifier: o, roles: me };
  }
  parseSetBurnRoleGlobally(e) {
    return this.ensureNoError(e), {};
  }
  parseUnsetBurnRoleGlobally(e) {
    return this.ensureNoError(e), {};
  }
  parseSetSpecialRole(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTSetRole"), o = s.address.toString(), fe = this.extractTokenIdentifier(s), me = s.topics.slice(3).map((ye) => ye.valueOf().toString());
    return { userAddress: o, tokenIdentifier: fe, roles: me };
  }
  parseNFTCreate(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTNFTCreate"), o = this.extractTokenIdentifier(s), fe = this.extractNonce(s), me = this.extractAmount(s);
    return { tokenIdentifier: o, nonce: fe, initialQuantity: me };
  }
  parseLocalMint(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTLocalMint"), o = s.address.toString(), fe = this.extractTokenIdentifier(s), me = this.extractNonce(s), ye = this.extractAmount(s);
    return { userAddress: o, tokenIdentifier: fe, nonce: me, mintedSupply: ye };
  }
  parseLocalBurn(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTLocalBurn"), o = s.address.toString(), fe = this.extractTokenIdentifier(s), me = this.extractNonce(s), ye = this.extractAmount(s);
    return { userAddress: o, tokenIdentifier: fe, nonce: me, burntSupply: ye };
  }
  parsePause(e) {
    return this.ensureNoError(e), this.findSingleEventByIdentifier(e, "ESDTPause"), {};
  }
  parseUnpause(e) {
    return this.ensureNoError(e), this.findSingleEventByIdentifier(e, "ESDTUnPause"), {};
  }
  parseFreeze(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTFreeze"), o = this.extractTokenIdentifier(s), fe = this.extractNonce(s), me = this.extractAmount(s);
    return { userAddress: this.extractAddress(s), tokenIdentifier: o, nonce: fe, balance: me };
  }
  parseUnfreeze(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTUnFreeze"), o = this.extractTokenIdentifier(s), fe = this.extractNonce(s), me = this.extractAmount(s);
    return { userAddress: this.extractAddress(s), tokenIdentifier: o, nonce: fe, balance: me };
  }
  parseWipe(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTWipe"), o = this.extractTokenIdentifier(s), fe = this.extractNonce(s), me = this.extractAmount(s);
    return { userAddress: this.extractAddress(s), tokenIdentifier: o, nonce: fe, balance: me };
  }
  parseUpdateAttributes(e) {
    var s;
    this.ensureNoError(e);
    const o = this.findSingleEventByIdentifier(e, "ESDTNFTUpdateAttributes"), fe = this.extractTokenIdentifier(o), me = this.extractNonce(o), ye = (s = o.topics[3]) === null || s === void 0 ? void 0 : s.valueOf();
    return { tokenIdentifier: fe, nonce: me, attributes: ye };
  }
  parseAddQuantity(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTNFTAddQuantity"), o = this.extractTokenIdentifier(s), fe = this.extractNonce(s), me = this.extractAmount(s);
    return { tokenIdentifier: o, nonce: fe, addedQuantity: me };
  }
  parseBurnQuantity(e) {
    this.ensureNoError(e);
    const s = this.findSingleEventByIdentifier(e, "ESDTNFTBurn"), o = this.extractTokenIdentifier(s), fe = this.extractNonce(s), me = this.extractAmount(s);
    return { tokenIdentifier: o, nonce: fe, burntQuantity: me };
  }
  ensureNoError(e) {
    var s;
    for (const o of e.logs.events)
      if (o.identifier == "signalError") {
        const fe = Buffer.from(o.data.substring(1), "hex").toString(), me = (s = o.topics[1]) === null || s === void 0 ? void 0 : s.valueOf().toString();
        throw new errors_1$9.ErrCannotParseTransactionOutcome(e.hash, `encountered signalError: ${me} (${fe})`);
      }
  }
  findSingleEventByIdentifier(e, s) {
    const o = this.gatherAllEvents(e).filter((fe) => fe.identifier == s);
    if (o.length == 0)
      throw new errors_1$9.ErrCannotParseTransactionOutcome(e.hash, `cannot find event of type ${s}`);
    if (o.length > 1)
      throw new errors_1$9.ErrCannotParseTransactionOutcome(e.hash, `more than one event of type ${s}`);
    return o[0];
  }
  gatherAllEvents(e) {
    const s = [];
    s.push(...e.logs.events);
    for (const o of e.contractResults.items)
      s.push(...o.logs.events);
    return s;
  }
  extractTokenIdentifier(e) {
    var s;
    return (s = e.topics[0]) === null || s === void 0 ? void 0 : s.valueOf().toString();
  }
  extractNonce(e) {
    var s;
    return codec_1.bufferToBigInt((s = e.topics[1]) === null || s === void 0 ? void 0 : s.valueOf()).toFixed(0);
  }
  extractAmount(e) {
    var s;
    return codec_1.bufferToBigInt((s = e.topics[2]) === null || s === void 0 ? void 0 : s.valueOf()).toFixed(0);
  }
  extractAddress(e) {
    var s;
    return address_1.Address.fromBuffer((s = e.topics[3]) === null || s === void 0 ? void 0 : s.valueOf()).toString();
  }
}
tokenOperationsOutcomeParser.TokenOperationsOutcomeParser = TokenOperationsOutcomeParser;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(tokenOperationsFactory, r), s(tokenOperationsFactoryConfig, r), s(tokenOperationsOutcomeParser, r);
})(tokenOperations);
var tokenTransfer = {}, __importDefault$b = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(tokenTransfer, "__esModule", { value: !0 });
tokenTransfer.TokenPayment = tokenTransfer.TokenTransfer = void 0;
const bignumber_js_1$8 = __importDefault$b(require$$1$2), errors_1$8 = errors$q, EGLDTokenIdentifier = "EGLD", EGLDNumDecimals = 18;
bignumber_js_1$8.default.set({ ROUNDING_MODE: 1 });
class TokenTransfer {
  constructor(e) {
    const s = new bignumber_js_1$8.default(e.amountAsBigInteger);
    if (!s.isInteger() || s.isNegative())
      throw new errors_1$8.ErrInvalidArgument(`bad amountAsBigInteger: ${e.amountAsBigInteger}`);
    this.tokenIdentifier = e.tokenIdentifier, this.nonce = e.nonce, this.amountAsBigInteger = s, this.numDecimals = e.numDecimals || 0;
  }
  static egldFromAmount(e) {
    const s = new bignumber_js_1$8.default(e).shiftedBy(EGLDNumDecimals).decimalPlaces(0);
    return this.egldFromBigInteger(s);
  }
  static egldFromBigInteger(e) {
    return new TokenTransfer({
      tokenIdentifier: EGLDTokenIdentifier,
      nonce: 0,
      amountAsBigInteger: e,
      numDecimals: EGLDNumDecimals
    });
  }
  static fungibleFromAmount(e, s, o) {
    const fe = new bignumber_js_1$8.default(s).shiftedBy(o).decimalPlaces(0);
    return this.fungibleFromBigInteger(e, fe, o);
  }
  static fungibleFromBigInteger(e, s, o = 0) {
    return new TokenTransfer({
      tokenIdentifier: e,
      nonce: 0,
      amountAsBigInteger: s,
      numDecimals: o
    });
  }
  static nonFungible(e, s) {
    return new TokenTransfer({
      tokenIdentifier: e,
      nonce: s,
      amountAsBigInteger: 1,
      numDecimals: 0
    });
  }
  static semiFungible(e, s, o) {
    return new TokenTransfer({
      tokenIdentifier: e,
      nonce: s,
      amountAsBigInteger: o,
      numDecimals: 0
    });
  }
  static metaEsdtFromAmount(e, s, o, fe) {
    const me = new bignumber_js_1$8.default(o).shiftedBy(fe).decimalPlaces(0);
    return this.metaEsdtFromBigInteger(e, s, me, fe);
  }
  static metaEsdtFromBigInteger(e, s, o, fe = 0) {
    return new TokenTransfer({
      tokenIdentifier: e,
      nonce: s,
      amountAsBigInteger: o,
      numDecimals: fe
    });
  }
  toString() {
    return this.amountAsBigInteger.toFixed(0);
  }
  valueOf() {
    return this.amountAsBigInteger;
  }
  toPrettyString() {
    return `${this.toAmount()} ${this.tokenIdentifier}`;
  }
  toAmount() {
    return this.amountAsBigInteger.shiftedBy(-this.numDecimals).toFixed(this.numDecimals);
  }
  isEgld() {
    return this.tokenIdentifier == EGLDTokenIdentifier;
  }
  isFungible() {
    return this.nonce == 0;
  }
}
tokenTransfer.TokenTransfer = TokenTransfer;
class TokenPayment extends TokenTransfer {
  constructor(e, s, o, fe) {
    super({
      tokenIdentifier: e,
      nonce: s,
      amountAsBigInteger: o,
      numDecimals: fe
    });
  }
}
tokenTransfer.TokenPayment = TokenPayment;
var transactionWatcher = {}, __awaiter$f = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
Object.defineProperty(transactionWatcher, "__esModule", { value: !0 });
transactionWatcher.TransactionWatcher = void 0;
const asyncTimer_1 = asyncTimer, errors_1$7 = errors$q, logger_1$1 = logger$1;
class TransactionWatcher {
  constructor(e, s = {}) {
    this.fetcher = new TransactionFetcherWithTracing(e), this.pollingIntervalMilliseconds = s.pollingIntervalMilliseconds || TransactionWatcher.DefaultPollingInterval, this.timeoutMilliseconds = s.timeoutMilliseconds || TransactionWatcher.DefaultTimeout, this.patienceMilliseconds = s.patienceMilliseconds || TransactionWatcher.DefaultPatience;
  }
  awaitPending(e) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const s = (me) => me.status.isPending(), o = () => __awaiter$f(this, void 0, void 0, function* () {
        return yield this.fetcher.getTransaction(e.getHash().hex());
      }), fe = () => new errors_1$7.ErrExpectedTransactionStatusNotReached();
      return this.awaitConditionally(s, o, fe);
    });
  }
  awaitCompleted(e) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const s = (me) => {
        if (me.isCompleted === void 0)
          throw new errors_1$7.ErrIsCompletedFieldIsMissingOnTransaction();
        return me.isCompleted;
      }, o = () => __awaiter$f(this, void 0, void 0, function* () {
        return yield this.fetcher.getTransaction(e.getHash().hex());
      }), fe = () => new errors_1$7.ErrExpectedTransactionStatusNotReached();
      return this.awaitConditionally(s, o, fe);
    });
  }
  awaitAllEvents(e, s) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const o = (ye) => {
        const fr = this.getAllTransactionEvents(ye).map((br) => br.identifier);
        return s.every((br) => fr.includes(br));
      }, fe = () => __awaiter$f(this, void 0, void 0, function* () {
        return yield this.fetcher.getTransaction(e.getHash().hex());
      }), me = () => new errors_1$7.ErrExpectedTransactionEventsNotFound();
      return this.awaitConditionally(o, fe, me);
    });
  }
  awaitAnyEvent(e, s) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const o = (ye) => {
        const fr = this.getAllTransactionEvents(ye).map((br) => br.identifier);
        return s.find((br) => fr.includes(br)) != null;
      }, fe = () => __awaiter$f(this, void 0, void 0, function* () {
        return yield this.fetcher.getTransaction(e.getHash().hex());
      }), me = () => new errors_1$7.ErrExpectedTransactionEventsNotFound();
      return this.awaitConditionally(o, fe, me);
    });
  }
  awaitOnCondition(e, s) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const o = () => __awaiter$f(this, void 0, void 0, function* () {
        return yield this.fetcher.getTransaction(e.getHash().hex());
      }), fe = () => new errors_1$7.ErrExpectedTransactionStatusNotReached();
      return this.awaitConditionally(s, o, fe);
    });
  }
  awaitConditionally(e, s, o) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const fe = new asyncTimer_1.AsyncTimer("watcher:periodic"), me = new asyncTimer_1.AsyncTimer("watcher:patience"), ye = new asyncTimer_1.AsyncTimer("watcher:timeout");
      let fr = !1, Er, br = !1;
      for (ye.start(this.timeoutMilliseconds).finally(() => {
        ye.stop(), fr = !0;
      }); !fr; ) {
        yield fe.start(this.pollingIntervalMilliseconds);
        try {
          if (Er = yield s(), br = e(Er), br || fr)
            break;
        } catch (wr) {
          if (logger_1$1.Logger.debug("TransactionWatcher.awaitConditionally(): cannot (yet) fetch data."), wr instanceof errors_1$7.ErrIsCompletedFieldIsMissingOnTransaction || !(wr instanceof errors_1$7.Err))
            throw wr;
        }
      }
      if (br && (yield me.start(this.patienceMilliseconds)), ye.isStopped() || ye.stop(), !Er || !br)
        throw o();
      return Er;
    });
  }
  getAllTransactionEvents(e) {
    const s = [...e.logs.events];
    for (const o of e.contractResults.items)
      s.push(...o.logs.events);
    return s;
  }
}
transactionWatcher.TransactionWatcher = TransactionWatcher;
TransactionWatcher.DefaultPollingInterval = 6e3;
TransactionWatcher.DefaultTimeout = TransactionWatcher.DefaultPollingInterval * 15;
TransactionWatcher.DefaultPatience = 0;
TransactionWatcher.NoopOnStatusReceived = (r) => {
};
class TransactionFetcherWithTracing {
  constructor(e) {
    this.fetcher = e;
  }
  getTransaction(e) {
    return __awaiter$f(this, void 0, void 0, function* () {
      return logger_1$1.Logger.debug(`transactionWatcher, getTransaction(${e})`), yield this.fetcher.getTransaction(e);
    });
  }
}
var transferTransactionsFactory = {};
Object.defineProperty(transferTransactionsFactory, "__esModule", { value: !0 });
transferTransactionsFactory.TransferTransactionsFactory = void 0;
const argSerializer_1 = argSerializer, typesystem_1 = typesystem, transaction_1$1 = transaction, transactionPayload_1 = transactionPayload;
class TransferTransactionsFactory {
  constructor(e) {
    this.gasEstimator = e;
  }
  createEGLDTransfer(e) {
    var s;
    const o = ((s = e.data) === null || s === void 0 ? void 0 : s.length()) || 0, fe = this.gasEstimator.forEGLDTransfer(o);
    return new transaction_1$1.Transaction({
      nonce: e.nonce,
      value: e.value,
      receiver: e.receiver,
      sender: e.sender,
      gasPrice: e.gasPrice,
      gasLimit: e.gasLimit || fe,
      data: e.data,
      chainID: e.chainID
    });
  }
  createESDTTransfer(e) {
    const { argumentsString: s } = new argSerializer_1.ArgSerializer().valuesToString([
      typesystem_1.BytesValue.fromUTF8(e.tokenTransfer.tokenIdentifier),
      new typesystem_1.BigUIntValue(e.tokenTransfer.valueOf())
    ]), o = `ESDTTransfer@${s}`, fe = new transactionPayload_1.TransactionPayload(o), me = fe.length() || 0, ye = this.gasEstimator.forESDTTransfer(me);
    return new transaction_1$1.Transaction({
      nonce: e.nonce,
      receiver: e.receiver,
      sender: e.sender,
      gasPrice: e.gasPrice,
      gasLimit: e.gasLimit || ye,
      data: fe,
      chainID: e.chainID
    });
  }
  createESDTNFTTransfer(e) {
    const { argumentsString: s } = new argSerializer_1.ArgSerializer().valuesToString([
      typesystem_1.BytesValue.fromUTF8(e.tokenTransfer.tokenIdentifier),
      new typesystem_1.U64Value(e.tokenTransfer.nonce),
      new typesystem_1.BigUIntValue(e.tokenTransfer.valueOf()),
      new typesystem_1.AddressValue(e.destination)
    ]), o = `ESDTNFTTransfer@${s}`, fe = new transactionPayload_1.TransactionPayload(o), me = fe.length() || 0, ye = this.gasEstimator.forESDTNFTTransfer(me);
    return new transaction_1$1.Transaction({
      nonce: e.nonce,
      receiver: e.sender,
      sender: e.sender,
      gasPrice: e.gasPrice,
      gasLimit: e.gasLimit || ye,
      data: fe,
      chainID: e.chainID
    });
  }
  createMultiESDTNFTTransfer(e) {
    const s = [
      new typesystem_1.AddressValue(e.destination),
      new typesystem_1.U16Value(e.tokenTransfers.length)
    ];
    for (const Er of e.tokenTransfers)
      s.push(typesystem_1.BytesValue.fromUTF8(Er.tokenIdentifier), new typesystem_1.U64Value(Er.nonce), new typesystem_1.BigUIntValue(Er.valueOf()));
    const { argumentsString: o } = new argSerializer_1.ArgSerializer().valuesToString(s), fe = `MultiESDTNFTTransfer@${o}`, me = new transactionPayload_1.TransactionPayload(fe), ye = me.length() || 0, fr = this.gasEstimator.forMultiESDTNFTTransfer(ye, e.tokenTransfers.length);
    return new transaction_1$1.Transaction({
      nonce: e.nonce,
      receiver: e.sender,
      sender: e.sender,
      gasPrice: e.gasPrice,
      gasLimit: e.gasLimit || fr,
      data: me,
      chainID: e.chainID
    });
  }
}
transferTransactionsFactory.TransferTransactionsFactory = TransferTransactionsFactory;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(account, r), s(address$2, r), s(asyncTimer, r), s(errors$q, r), s(gasEstimator, r), s(_interface$1, r), s(interfaceOfNetwork, r), s(logger$1, r), s(networkParams, r), s(relayedTransactionV1Builder, r), s(relayedTransactionV2Builder, r), s(signableMessage, r), s(smartcontracts, r), s(tokenOperations, r), s(tokenTransfer, r), s(transaction, r), s(transactionPayload, r), s(transactionWatcher, r), s(transferTransactionsFactory, r), s(utils$a, r);
})(out$4);
const emptyAccount = {
  balance: "...",
  address: "",
  nonce: 0,
  txCount: 0,
  scrCount: 0,
  claimableRewards: ZERO,
  isGuarded: !1
}, initialState$7 = {
  address: "",
  websocketEvent: null,
  accounts: { "": emptyAccount },
  ledgerAccount: null,
  publicKey: "",
  walletConnectAccount: null,
  isAccountLoading: !0,
  accountLoadingError: null,
  isGuarded: !1,
  activeGuardianAddress: null
}, useAccountStore = defineStore("erdjs-account", {
  state: () => ({ ...initialState$7 }),
  persist: !0,
  getters: {
    getAddress: (r) => r.address,
    getAccountNonce: (r) => r.accounts[r.address] ? r.accounts[r.address].nonce : 0,
    getAccountBalance: (r) => r.accounts[r.address] ? r.accounts[r.address].balance : "...",
    getAccount: (r) => r.accounts[r.address] ? r.accounts[r.address] : emptyAccount,
    getLedgerAccount: (r) => r.ledgerAccount,
    getWebsocketEvent: (r) => r.websocketEvent
  },
  actions: {
    setLogin(r) {
      const { address: e } = r;
      this.address = e, this.publicKey = new out$4.Address(e).hex();
    },
    setAddress(r) {
      const e = r;
      this.address = e, this.publicKey = new out$4.Address(e).hex();
    },
    setAccount(r) {
      var s, o;
      const e = this.address === r.address;
      this.accounts = {
        [this.address]: e ? r : emptyAccount
      }, this.isAccountLoading = !1, this.accountLoadingError = null, this.isGuarded = (s = r == null ? void 0 : r.isGuarded) != null ? s : !1, this.isGuarded && (this.activeGuardianAddress = (o = r == null ? void 0 : r.activeGuardianAddress) != null ? o : null);
    },
    setAccountNonce(r) {
      this.accounts[this.address].nonce = r;
    },
    setAccountShard(r) {
      this.shard = r;
    },
    setWebsocketEvent(r) {
      this.websocketEvent = {
        timestamp: Date.now(),
        message: r
      };
    },
    setLedgerAccount(r) {
      this.ledgerAccount = r;
    },
    updateLedgerAccount(r) {
      this.ledgerAccount != null && (this.ledgerAccount.index = r.index, this.ledgerAccount.address = r.address);
    },
    logout() {
      this.$reset();
    }
  }
}), initialState$6 = {
  txSubmittedModal: null,
  notificationModal: null
}, useNotificationsStore = defineStore("erdjs-notifications", {
  state: () => ({ ...initialState$6 }),
  persist: !1,
  getters: {
    getNotificationModal: (r) => r.notificationModal
  },
  actions: {
    addNotification(r) {
      this.notificationModal = r;
    }
  }
}), stringIsFloat = (r) => {
  if (isNaN(r) || String(r).includes("Infinity"))
    return !1;
  let [e, s] = r.split(".");
  if (s)
    for (; s.charAt(s.length - 1) === ZERO; )
      s = s.slice(0, -1);
  const o = s ? [e, s].join(".") : e, fe = new BigNumber$1(o);
  return fe.toString(10) === o && fe.comparedTo(0) >= 0;
}, stringIsInteger = (r, e = !0) => {
  const s = String(r);
  if (!s.match(/^[-]?\d+$/))
    return !1;
  const o = new BigNumber$1(s), fe = e ? 0 : -1;
  return o.toString(10) === s && o.comparedTo(0) >= fe;
};
function pipe(r) {
  return {
    if: function(e) {
      return e ? {
        then: (s) => s instanceof Function ? pipe(s(r)) : pipe(s)
      } : {
        then: () => pipe(r)
      };
    },
    then: (e) => e instanceof Function ? pipe(e(r)) : pipe(e),
    valueOf: function() {
      return r;
    }
  };
}
BigNumber$1.config({ ROUNDING_MODE: BigNumber$1.ROUND_FLOOR });
function formatAmount({
  input: r,
  decimals: e = DECIMALS,
  digits: s = DIGITS,
  showLastNonZeroDecimal: o = !0,
  showIsLessThanDecimalsLabel: fe = !1,
  addCommas: me = !1
}) {
  if (!stringIsInteger(r, !1))
    throw new Error("Invalid input");
  const ye = new BigNumber$1(r).isNegative();
  let fr = r;
  return ye && (fr = r.substring(1)), pipe(fr).then(
    () => out$4.TokenTransfer.fungibleFromBigInteger("", fr, e).amountAsBigInteger.shiftedBy(-e).toFixed(e)
  ).then((Er) => {
    const br = new BigNumber$1(Er);
    if (br.isZero())
      return ZERO;
    const wr = br.toString(10), [kr, Gr] = wr.split("."), Vr = new BigNumber$1(Gr || 0), jr = pipe(0).if(Boolean(Gr && o)).then(() => Math.max(Gr.length, s)).if(Vr.isZero() && !o).then(0).if(Boolean(Gr && !o)).then(() => Math.min(Gr.length, s)).valueOf(), Kr = Gr && s >= 1 && s <= Gr.length && Vr.isGreaterThan(0) && new BigNumber$1(Gr.substring(0, s)).isZero(), bn = br.toFormat(jr);
    return pipe(wr).if(me).then(bn).if(Boolean(Kr)).then((Zr) => {
      const ti = new BigNumber$1(kr).isZero(), [On, ni] = Zr.split("."), In = new Array(s - 1).fill(0), Br = [...In, 0].join(""), Hr = [...In, 1].join("");
      return ti ? fe ? `<${On}.${Hr}` : o ? `${On}.${ni}` : On : `${On}.${Br}`;
    }).if(Boolean(!Kr && Gr)).then((Zr) => {
      const [ti] = Zr.split(".");
      let On = Gr.substring(0, jr);
      if (o) {
        const ni = s - On.length;
        if (ni > 0) {
          const In = Array(ni).fill(0).join("");
          return On = `${On}${In}`, `${ti}.${On}`;
        }
        return Zr;
      }
      return On ? `${ti}.${On}` : ti;
    }).valueOf();
  }).if(ye).then((Er) => `-${Er}`).valueOf();
}
var out$3 = {}, proxyNetworkProvider = {};
function bind$2(r, e) {
  return function() {
    return r.apply(e, arguments);
  };
}
const { toString: toString$3 } = Object.prototype, { getPrototypeOf } = Object, kindOf = ((r) => (e) => {
  const s = toString$3.call(e);
  return r[s] || (r[s] = s.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (r) => (r = r.toLowerCase(), (e) => kindOf(e) === r), typeOfTest = (r) => (e) => typeof e === r, { isArray: isArray$7 } = Array, isUndefined$1 = typeOfTest("undefined");
function isBuffer$1(r) {
  return r !== null && !isUndefined$1(r) && r.constructor !== null && !isUndefined$1(r.constructor) && isFunction$2(r.constructor.isBuffer) && r.constructor.isBuffer(r);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(r) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && isArrayBuffer(r.buffer), e;
}
const isString$3 = typeOfTest("string"), isFunction$2 = typeOfTest("function"), isNumber$1 = typeOfTest("number"), isObject$3 = (r) => r !== null && typeof r == "object", isBoolean$1 = (r) => r === !0 || r === !1, isPlainObject = (r) => {
  if (kindOf(r) !== "object")
    return !1;
  const e = getPrototypeOf(r);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in r) && !(Symbol.iterator in r);
}, isDate$1 = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (r) => isObject$3(r) && isFunction$2(r.pipe), isFormData = (r) => {
  let e;
  return r && (typeof FormData == "function" && r instanceof FormData || isFunction$2(r.append) && ((e = kindOf(r)) === "formdata" || e === "object" && isFunction$2(r.toString) && r.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), trim$1 = (r) => r.trim ? r.trim() : r.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(r, e, { allOwnKeys: s = !1 } = {}) {
  if (r === null || typeof r > "u")
    return;
  let o, fe;
  if (typeof r != "object" && (r = [r]), isArray$7(r))
    for (o = 0, fe = r.length; o < fe; o++)
      e.call(null, r[o], o, r);
  else {
    const me = s ? Object.getOwnPropertyNames(r) : Object.keys(r), ye = me.length;
    let fr;
    for (o = 0; o < ye; o++)
      fr = me[o], e.call(null, r[fr], fr, r);
  }
}
function findKey(r, e) {
  e = e.toLowerCase();
  const s = Object.keys(r);
  let o = s.length, fe;
  for (; o-- > 0; )
    if (fe = s[o], e === fe.toLowerCase())
      return fe;
  return null;
}
const _global = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : globalThis)(), isContextDefined = (r) => !isUndefined$1(r) && r !== _global;
function merge$2() {
  const { caseless: r } = isContextDefined(this) && this || {}, e = {}, s = (o, fe) => {
    const me = r && findKey(e, fe) || fe;
    isPlainObject(e[me]) && isPlainObject(o) ? e[me] = merge$2(e[me], o) : isPlainObject(o) ? e[me] = merge$2({}, o) : isArray$7(o) ? e[me] = o.slice() : e[me] = o;
  };
  for (let o = 0, fe = arguments.length; o < fe; o++)
    arguments[o] && forEach(arguments[o], s);
  return e;
}
const extend = (r, e, s, { allOwnKeys: o } = {}) => (forEach(e, (fe, me) => {
  s && isFunction$2(fe) ? r[me] = bind$2(fe, s) : r[me] = fe;
}, { allOwnKeys: o }), r), stripBOM = (r) => (r.charCodeAt(0) === 65279 && (r = r.slice(1)), r), inherits = (r, e, s, o) => {
  r.prototype = Object.create(e.prototype, o), r.prototype.constructor = r, Object.defineProperty(r, "super", {
    value: e.prototype
  }), s && Object.assign(r.prototype, s);
}, toFlatObject = (r, e, s, o) => {
  let fe, me, ye;
  const fr = {};
  if (e = e || {}, r == null)
    return e;
  do {
    for (fe = Object.getOwnPropertyNames(r), me = fe.length; me-- > 0; )
      ye = fe[me], (!o || o(ye, r, e)) && !fr[ye] && (e[ye] = r[ye], fr[ye] = !0);
    r = s !== !1 && getPrototypeOf(r);
  } while (r && (!s || s(r, e)) && r !== Object.prototype);
  return e;
}, endsWith = (r, e, s) => {
  r = String(r), (s === void 0 || s > r.length) && (s = r.length), s -= e.length;
  const o = r.indexOf(e, s);
  return o !== -1 && o === s;
}, toArray = (r) => {
  if (!r)
    return null;
  if (isArray$7(r))
    return r;
  let e = r.length;
  if (!isNumber$1(e))
    return null;
  const s = new Array(e);
  for (; e-- > 0; )
    s[e] = r[e];
  return s;
}, isTypedArray = ((r) => (e) => r && e instanceof r)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (r, e) => {
  const o = (r && r[Symbol.iterator]).call(r);
  let fe;
  for (; (fe = o.next()) && !fe.done; ) {
    const me = fe.value;
    e.call(r, me[0], me[1]);
  }
}, matchAll = (r, e) => {
  let s;
  const o = [];
  for (; (s = r.exec(e)) !== null; )
    o.push(s);
  return o;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (r) => r.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(s, o, fe) {
    return o.toUpperCase() + fe;
  }
), hasOwnProperty$1 = (({ hasOwnProperty: r }) => (e, s) => r.call(e, s))(Object.prototype), isRegExp$2 = kindOfTest("RegExp"), reduceDescriptors = (r, e) => {
  const s = Object.getOwnPropertyDescriptors(r), o = {};
  forEach(s, (fe, me) => {
    let ye;
    (ye = e(fe, me, r)) !== !1 && (o[me] = ye || fe);
  }), Object.defineProperties(r, o);
}, freezeMethods = (r) => {
  reduceDescriptors(r, (e, s) => {
    if (isFunction$2(r) && ["arguments", "caller", "callee"].indexOf(s) !== -1)
      return !1;
    const o = r[s];
    if (!!isFunction$2(o)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + s + "'");
      });
    }
  });
}, toObjectSet = (r, e) => {
  const s = {}, o = (fe) => {
    fe.forEach((me) => {
      s[me] = !0;
    });
  };
  return isArray$7(r) ? o(r) : o(String(r).split(e)), s;
}, noop$2 = () => {
}, toFiniteNumber = (r, e) => (r = +r, Number.isFinite(r) ? r : e), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (r = 16, e = ALPHABET.ALPHA_DIGIT) => {
  let s = "";
  const { length: o } = e;
  for (; r--; )
    s += e[Math.random() * o | 0];
  return s;
};
function isSpecCompliantForm(r) {
  return !!(r && isFunction$2(r.append) && r[Symbol.toStringTag] === "FormData" && r[Symbol.iterator]);
}
const toJSONObject = (r) => {
  const e = new Array(10), s = (o, fe) => {
    if (isObject$3(o)) {
      if (e.indexOf(o) >= 0)
        return;
      if (!("toJSON" in o)) {
        e[fe] = o;
        const me = isArray$7(o) ? [] : {};
        return forEach(o, (ye, fr) => {
          const Er = s(ye, fe + 1);
          !isUndefined$1(Er) && (me[fr] = Er);
        }), e[fe] = void 0, me;
      }
    }
    return o;
  };
  return s(r, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (r) => r && (isObject$3(r) || isFunction$2(r)) && isFunction$2(r.then) && isFunction$2(r.catch), utils$9 = {
  isArray: isArray$7,
  isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData,
  isArrayBufferView,
  isString: isString$3,
  isNumber: isNumber$1,
  isBoolean: isBoolean$1,
  isObject: isObject$3,
  isPlainObject,
  isUndefined: isUndefined$1,
  isDate: isDate$1,
  isFile,
  isBlob,
  isRegExp: isRegExp$2,
  isFunction: isFunction$2,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge: merge$2,
  extend,
  trim: trim$1,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$1,
  hasOwnProp: hasOwnProperty$1,
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$2,
  toFiniteNumber,
  findKey,
  globalThis: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError$1(r, e, s, o, fe) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = r, this.name = "AxiosError", e && (this.code = e), s && (this.config = s), o && (this.request = o), fe && (this.response = fe);
}
utils$9.inherits(AxiosError$1, Error, {
  toJSON: function r() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: utils$9.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError$1.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((r) => {
  descriptors[r] = { value: r };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError$1.from = (r, e, s, o, fe, me) => {
  const ye = Object.create(prototype$1);
  return utils$9.toFlatObject(r, ye, function(Er) {
    return Er !== Error.prototype;
  }, (fr) => fr !== "isAxiosError"), AxiosError$1.call(ye, r.message, e, s, o, fe), ye.cause = r, ye.name = r.name, me && Object.assign(ye, me), ye;
};
const httpAdapter = null;
function isVisitable(r) {
  return utils$9.isPlainObject(r) || utils$9.isArray(r);
}
function removeBrackets(r) {
  return utils$9.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function renderKey(r, e, s) {
  return r ? r.concat(e).map(function(fe, me) {
    return fe = removeBrackets(fe), !s && me ? "[" + fe + "]" : fe;
  }).join(s ? "." : "") : e;
}
function isFlatArray(r) {
  return utils$9.isArray(r) && !r.some(isVisitable);
}
const predicates = utils$9.toFlatObject(utils$9, {}, null, function r(e) {
  return /^is[A-Z]/.test(e);
});
function toFormData$1(r, e, s) {
  if (!utils$9.isObject(r))
    throw new TypeError("target must be an object");
  e = e || new FormData(), s = utils$9.toFlatObject(s, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(Kr, bn) {
    return !utils$9.isUndefined(bn[Kr]);
  });
  const o = s.metaTokens, fe = s.visitor || wr, me = s.dots, ye = s.indexes, Er = (s.Blob || typeof Blob < "u" && Blob) && utils$9.isSpecCompliantForm(e);
  if (!utils$9.isFunction(fe))
    throw new TypeError("visitor must be a function");
  function br(jr) {
    if (jr === null)
      return "";
    if (utils$9.isDate(jr))
      return jr.toISOString();
    if (!Er && utils$9.isBlob(jr))
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    return utils$9.isArrayBuffer(jr) || utils$9.isTypedArray(jr) ? Er && typeof Blob == "function" ? new Blob([jr]) : Buffer.from(jr) : jr;
  }
  function wr(jr, Kr, bn) {
    let Yr = jr;
    if (jr && !bn && typeof jr == "object") {
      if (utils$9.endsWith(Kr, "{}"))
        Kr = o ? Kr : Kr.slice(0, -2), jr = JSON.stringify(jr);
      else if (utils$9.isArray(jr) && isFlatArray(jr) || (utils$9.isFileList(jr) || utils$9.endsWith(Kr, "[]")) && (Yr = utils$9.toArray(jr)))
        return Kr = removeBrackets(Kr), Yr.forEach(function(ti, On) {
          !(utils$9.isUndefined(ti) || ti === null) && e.append(
            ye === !0 ? renderKey([Kr], On, me) : ye === null ? Kr : Kr + "[]",
            br(ti)
          );
        }), !1;
    }
    return isVisitable(jr) ? !0 : (e.append(renderKey(bn, Kr, me), br(jr)), !1);
  }
  const kr = [], Gr = Object.assign(predicates, {
    defaultVisitor: wr,
    convertValue: br,
    isVisitable
  });
  function Vr(jr, Kr) {
    if (!utils$9.isUndefined(jr)) {
      if (kr.indexOf(jr) !== -1)
        throw Error("Circular reference detected in " + Kr.join("."));
      kr.push(jr), utils$9.forEach(jr, function(Yr, Zr) {
        (!(utils$9.isUndefined(Yr) || Yr === null) && fe.call(
          e,
          Yr,
          utils$9.isString(Zr) ? Zr.trim() : Zr,
          Kr,
          Gr
        )) === !0 && Vr(Yr, Kr ? Kr.concat(Zr) : [Zr]);
      }), kr.pop();
    }
  }
  if (!utils$9.isObject(r))
    throw new TypeError("data must be an object");
  return Vr(r), e;
}
function encode$8(r) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(r).replace(/[!'()~]|%20|%00/g, function(o) {
    return e[o];
  });
}
function AxiosURLSearchParams(r, e) {
  this._pairs = [], r && toFormData$1(r, this, e);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function r(e, s) {
  this._pairs.push([e, s]);
};
prototype.toString = function r(e) {
  const s = e ? function(o) {
    return e.call(this, o, encode$8);
  } : encode$8;
  return this._pairs.map(function(fe) {
    return s(fe[0]) + "=" + s(fe[1]);
  }, "").join("&");
};
function encode$7(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(r, e, s) {
  if (!e)
    return r;
  const o = s && s.encode || encode$7, fe = s && s.serialize;
  let me;
  if (fe ? me = fe(e, s) : me = utils$9.isURLSearchParams(e) ? e.toString() : new AxiosURLSearchParams(e, s).toString(o), me) {
    const ye = r.indexOf("#");
    ye !== -1 && (r = r.slice(0, ye)), r += (r.indexOf("?") === -1 ? "?" : "&") + me;
  }
  return r;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  use(e, s, o) {
    return this.handlers.push({
      fulfilled: e,
      rejected: s,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    utils$9.forEach(this.handlers, function(o) {
      o !== null && e(o);
    });
  }
}
const InterceptorManager$1 = InterceptorManager, transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", hasStandardBrowserEnv = ((r) => hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(r) < 0)(typeof navigator < "u" && navigator.product), hasStandardBrowserWebWorkerEnv = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), utils$8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils$8,
  ...platform$1
};
function toURLEncodedForm(r, e) {
  return toFormData$1(r, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(s, o, fe, me) {
      return platform.isNode && utils$9.isBuffer(s) ? (this.append(o, s.toString("base64")), !1) : me.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function parsePropPath(r) {
  return utils$9.matchAll(/\w+|\[(\w*)]/g, r).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function arrayToObject$1(r) {
  const e = {}, s = Object.keys(r);
  let o;
  const fe = s.length;
  let me;
  for (o = 0; o < fe; o++)
    me = s[o], e[me] = r[me];
  return e;
}
function formDataToJSON(r) {
  function e(s, o, fe, me) {
    let ye = s[me++];
    const fr = Number.isFinite(+ye), Er = me >= s.length;
    return ye = !ye && utils$9.isArray(fe) ? fe.length : ye, Er ? (utils$9.hasOwnProp(fe, ye) ? fe[ye] = [fe[ye], o] : fe[ye] = o, !fr) : ((!fe[ye] || !utils$9.isObject(fe[ye])) && (fe[ye] = []), e(s, o, fe[ye], me) && utils$9.isArray(fe[ye]) && (fe[ye] = arrayToObject$1(fe[ye])), !fr);
  }
  if (utils$9.isFormData(r) && utils$9.isFunction(r.entries)) {
    const s = {};
    return utils$9.forEachEntry(r, (o, fe) => {
      e(parsePropPath(o), fe, s, 0);
    }), s;
  }
  return null;
}
function stringifySafely(r, e, s) {
  if (utils$9.isString(r))
    try {
      return (e || JSON.parse)(r), utils$9.trim(r);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (s || JSON.stringify)(r);
}
const defaults$2 = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function r(e, s) {
    const o = s.getContentType() || "", fe = o.indexOf("application/json") > -1, me = utils$9.isObject(e);
    if (me && utils$9.isHTMLForm(e) && (e = new FormData(e)), utils$9.isFormData(e))
      return fe && fe ? JSON.stringify(formDataToJSON(e)) : e;
    if (utils$9.isArrayBuffer(e) || utils$9.isBuffer(e) || utils$9.isStream(e) || utils$9.isFile(e) || utils$9.isBlob(e))
      return e;
    if (utils$9.isArrayBufferView(e))
      return e.buffer;
    if (utils$9.isURLSearchParams(e))
      return s.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let fr;
    if (me) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(e, this.formSerializer).toString();
      if ((fr = utils$9.isFileList(e)) || o.indexOf("multipart/form-data") > -1) {
        const Er = this.env && this.env.FormData;
        return toFormData$1(
          fr ? { "files[]": e } : e,
          Er && new Er(),
          this.formSerializer
        );
      }
    }
    return me || fe ? (s.setContentType("application/json", !1), stringifySafely(e)) : e;
  }],
  transformResponse: [function r(e) {
    const s = this.transitional || defaults$2.transitional, o = s && s.forcedJSONParsing, fe = this.responseType === "json";
    if (e && utils$9.isString(e) && (o && !this.responseType || fe)) {
      const ye = !(s && s.silentJSONParsing) && fe;
      try {
        return JSON.parse(e);
      } catch (fr) {
        if (ye)
          throw fr.name === "SyntaxError" ? AxiosError$1.from(fr, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response) : fr;
      }
    }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function r(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$9.forEach(["delete", "get", "head", "post", "put", "patch"], (r) => {
  defaults$2.headers[r] = {};
});
const defaults$3 = defaults$2, ignoreDuplicateOf = utils$9.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (r) => {
  const e = {};
  let s, o, fe;
  return r && r.split(`
`).forEach(function(ye) {
    fe = ye.indexOf(":"), s = ye.substring(0, fe).trim().toLowerCase(), o = ye.substring(fe + 1).trim(), !(!s || e[s] && ignoreDuplicateOf[s]) && (s === "set-cookie" ? e[s] ? e[s].push(o) : e[s] = [o] : e[s] = e[s] ? e[s] + ", " + o : o);
  }), e;
}, $internals = Symbol("internals");
function normalizeHeader(r) {
  return r && String(r).trim().toLowerCase();
}
function normalizeValue(r) {
  return r === !1 || r == null ? r : utils$9.isArray(r) ? r.map(normalizeValue) : String(r);
}
function parseTokens(r) {
  const e = /* @__PURE__ */ Object.create(null), s = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = s.exec(r); )
    e[o[1]] = o[2];
  return e;
}
const isValidHeaderName = (r) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(r.trim());
function matchHeaderValue(r, e, s, o, fe) {
  if (utils$9.isFunction(o))
    return o.call(this, e, s);
  if (fe && (e = s), !!utils$9.isString(e)) {
    if (utils$9.isString(o))
      return e.indexOf(o) !== -1;
    if (utils$9.isRegExp(o))
      return o.test(e);
  }
}
function formatHeader(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, s, o) => s.toUpperCase() + o);
}
function buildAccessors(r, e) {
  const s = utils$9.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(r, o + s, {
      value: function(fe, me, ye) {
        return this[o].call(this, e, fe, me, ye);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders$1 {
  constructor(e) {
    e && this.set(e);
  }
  set(e, s, o) {
    const fe = this;
    function me(fr, Er, br) {
      const wr = normalizeHeader(Er);
      if (!wr)
        throw new Error("header name must be a non-empty string");
      const kr = utils$9.findKey(fe, wr);
      (!kr || fe[kr] === void 0 || br === !0 || br === void 0 && fe[kr] !== !1) && (fe[kr || Er] = normalizeValue(fr));
    }
    const ye = (fr, Er) => utils$9.forEach(fr, (br, wr) => me(br, wr, Er));
    return utils$9.isPlainObject(e) || e instanceof this.constructor ? ye(e, s) : utils$9.isString(e) && (e = e.trim()) && !isValidHeaderName(e) ? ye(parseHeaders(e), s) : e != null && me(s, e, o), this;
  }
  get(e, s) {
    if (e = normalizeHeader(e), e) {
      const o = utils$9.findKey(this, e);
      if (o) {
        const fe = this[o];
        if (!s)
          return fe;
        if (s === !0)
          return parseTokens(fe);
        if (utils$9.isFunction(s))
          return s.call(this, fe, o);
        if (utils$9.isRegExp(s))
          return s.exec(fe);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, s) {
    if (e = normalizeHeader(e), e) {
      const o = utils$9.findKey(this, e);
      return !!(o && this[o] !== void 0 && (!s || matchHeaderValue(this, this[o], o, s)));
    }
    return !1;
  }
  delete(e, s) {
    const o = this;
    let fe = !1;
    function me(ye) {
      if (ye = normalizeHeader(ye), ye) {
        const fr = utils$9.findKey(o, ye);
        fr && (!s || matchHeaderValue(o, o[fr], fr, s)) && (delete o[fr], fe = !0);
      }
    }
    return utils$9.isArray(e) ? e.forEach(me) : me(e), fe;
  }
  clear(e) {
    const s = Object.keys(this);
    let o = s.length, fe = !1;
    for (; o--; ) {
      const me = s[o];
      (!e || matchHeaderValue(this, this[me], me, e, !0)) && (delete this[me], fe = !0);
    }
    return fe;
  }
  normalize(e) {
    const s = this, o = {};
    return utils$9.forEach(this, (fe, me) => {
      const ye = utils$9.findKey(o, me);
      if (ye) {
        s[ye] = normalizeValue(fe), delete s[me];
        return;
      }
      const fr = e ? formatHeader(me) : String(me).trim();
      fr !== me && delete s[me], s[fr] = normalizeValue(fe), o[fr] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const s = /* @__PURE__ */ Object.create(null);
    return utils$9.forEach(this, (o, fe) => {
      o != null && o !== !1 && (s[fe] = e && utils$9.isArray(o) ? o.join(", ") : o);
    }), s;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, s]) => e + ": " + s).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...s) {
    const o = new this(e);
    return s.forEach((fe) => o.set(fe)), o;
  }
  static accessor(e) {
    const o = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, fe = this.prototype;
    function me(ye) {
      const fr = normalizeHeader(ye);
      o[fr] || (buildAccessors(fe, ye), o[fr] = !0);
    }
    return utils$9.isArray(e) ? e.forEach(me) : me(e), this;
  }
}
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$9.reduceDescriptors(AxiosHeaders$1.prototype, ({ value: r }, e) => {
  let s = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => r,
    set(o) {
      this[s] = o;
    }
  };
});
utils$9.freezeMethods(AxiosHeaders$1);
const AxiosHeaders$2 = AxiosHeaders$1;
function transformData(r, e) {
  const s = this || defaults$3, o = e || s, fe = AxiosHeaders$2.from(o.headers);
  let me = o.data;
  return utils$9.forEach(r, function(fr) {
    me = fr.call(s, me, fe.normalize(), e ? e.status : void 0);
  }), fe.normalize(), me;
}
function isCancel$1(r) {
  return !!(r && r.__CANCEL__);
}
function CanceledError$1(r, e, s) {
  AxiosError$1.call(this, r == null ? "canceled" : r, AxiosError$1.ERR_CANCELED, e, s), this.name = "CanceledError";
}
utils$9.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: !0
});
function settle(r, e, s) {
  const o = s.config.validateStatus;
  !s.status || !o || o(s.status) ? r(s) : e(new AxiosError$1(
    "Request failed with status code " + s.status,
    [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
    s.config,
    s.request,
    s
  ));
}
const cookies = platform.hasStandardBrowserEnv ? function r() {
  return {
    write: function(s, o, fe, me, ye, fr) {
      const Er = [];
      Er.push(s + "=" + encodeURIComponent(o)), utils$9.isNumber(fe) && Er.push("expires=" + new Date(fe).toGMTString()), utils$9.isString(me) && Er.push("path=" + me), utils$9.isString(ye) && Er.push("domain=" + ye), fr === !0 && Er.push("secure"), document.cookie = Er.join("; ");
    },
    read: function(s) {
      const o = document.cookie.match(new RegExp("(^|;\\s*)(" + s + ")=([^;]*)"));
      return o ? decodeURIComponent(o[3]) : null;
    },
    remove: function(s) {
      this.write(s, "", Date.now() - 864e5);
    }
  };
}() : function r() {
  return {
    write: function() {
    },
    read: function() {
      return null;
    },
    remove: function() {
    }
  };
}();
function isAbsoluteURL(r) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
}
function combineURLs(r, e) {
  return e ? r.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : r;
}
function buildFullPath(r, e) {
  return r && !isAbsoluteURL(e) ? combineURLs(r, e) : e;
}
const isURLSameOrigin = platform.hasStandardBrowserEnv ? function r() {
  const e = /(msie|trident)/i.test(navigator.userAgent), s = document.createElement("a");
  let o;
  function fe(me) {
    let ye = me;
    return e && (s.setAttribute("href", ye), ye = s.href), s.setAttribute("href", ye), {
      href: s.href,
      protocol: s.protocol ? s.protocol.replace(/:$/, "") : "",
      host: s.host,
      search: s.search ? s.search.replace(/^\?/, "") : "",
      hash: s.hash ? s.hash.replace(/^#/, "") : "",
      hostname: s.hostname,
      port: s.port,
      pathname: s.pathname.charAt(0) === "/" ? s.pathname : "/" + s.pathname
    };
  }
  return o = fe(window.location.href), function(ye) {
    const fr = utils$9.isString(ye) ? fe(ye) : ye;
    return fr.protocol === o.protocol && fr.host === o.host;
  };
}() : function r() {
  return function() {
    return !0;
  };
}();
function parseProtocol(r) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(r);
  return e && e[1] || "";
}
function speedometer(r, e) {
  r = r || 10;
  const s = new Array(r), o = new Array(r);
  let fe = 0, me = 0, ye;
  return e = e !== void 0 ? e : 1e3, function(Er) {
    const br = Date.now(), wr = o[me];
    ye || (ye = br), s[fe] = Er, o[fe] = br;
    let kr = me, Gr = 0;
    for (; kr !== fe; )
      Gr += s[kr++], kr = kr % r;
    if (fe = (fe + 1) % r, fe === me && (me = (me + 1) % r), br - ye < e)
      return;
    const Vr = wr && br - wr;
    return Vr ? Math.round(Gr * 1e3 / Vr) : void 0;
  };
}
function progressEventReducer(r, e) {
  let s = 0;
  const o = speedometer(50, 250);
  return (fe) => {
    const me = fe.loaded, ye = fe.lengthComputable ? fe.total : void 0, fr = me - s, Er = o(fr), br = me <= ye;
    s = me;
    const wr = {
      loaded: me,
      total: ye,
      progress: ye ? me / ye : void 0,
      bytes: fr,
      rate: Er || void 0,
      estimated: Er && ye && br ? (ye - me) / Er : void 0,
      event: fe
    };
    wr[e ? "download" : "upload"] = !0, r(wr);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(r) {
  return new Promise(function(s, o) {
    let fe = r.data;
    const me = AxiosHeaders$2.from(r.headers).normalize(), ye = r.responseType;
    let fr;
    function Er() {
      r.cancelToken && r.cancelToken.unsubscribe(fr), r.signal && r.signal.removeEventListener("abort", fr);
    }
    let br;
    if (utils$9.isFormData(fe)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
        me.setContentType(!1);
      else if ((br = me.getContentType()) !== !1) {
        const [jr, ...Kr] = br ? br.split(";").map((bn) => bn.trim()).filter(Boolean) : [];
        me.setContentType([jr || "multipart/form-data", ...Kr].join("; "));
      }
    }
    let wr = new XMLHttpRequest();
    if (r.auth) {
      const jr = r.auth.username || "", Kr = r.auth.password ? unescape(encodeURIComponent(r.auth.password)) : "";
      me.set("Authorization", "Basic " + btoa(jr + ":" + Kr));
    }
    const kr = buildFullPath(r.baseURL, r.url);
    wr.open(r.method.toUpperCase(), buildURL(kr, r.params, r.paramsSerializer), !0), wr.timeout = r.timeout;
    function Gr() {
      if (!wr)
        return;
      const jr = AxiosHeaders$2.from(
        "getAllResponseHeaders" in wr && wr.getAllResponseHeaders()
      ), bn = {
        data: !ye || ye === "text" || ye === "json" ? wr.responseText : wr.response,
        status: wr.status,
        statusText: wr.statusText,
        headers: jr,
        config: r,
        request: wr
      };
      settle(function(Zr) {
        s(Zr), Er();
      }, function(Zr) {
        o(Zr), Er();
      }, bn), wr = null;
    }
    if ("onloadend" in wr ? wr.onloadend = Gr : wr.onreadystatechange = function() {
      !wr || wr.readyState !== 4 || wr.status === 0 && !(wr.responseURL && wr.responseURL.indexOf("file:") === 0) || setTimeout(Gr);
    }, wr.onabort = function() {
      !wr || (o(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, r, wr)), wr = null);
    }, wr.onerror = function() {
      o(new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, r, wr)), wr = null;
    }, wr.ontimeout = function() {
      let Kr = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const bn = r.transitional || transitionalDefaults;
      r.timeoutErrorMessage && (Kr = r.timeoutErrorMessage), o(new AxiosError$1(
        Kr,
        bn.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        r,
        wr
      )), wr = null;
    }, platform.hasStandardBrowserEnv) {
      const jr = isURLSameOrigin(kr) && r.xsrfCookieName && cookies.read(r.xsrfCookieName);
      jr && me.set(r.xsrfHeaderName, jr);
    }
    fe === void 0 && me.setContentType(null), "setRequestHeader" in wr && utils$9.forEach(me.toJSON(), function(Kr, bn) {
      wr.setRequestHeader(bn, Kr);
    }), utils$9.isUndefined(r.withCredentials) || (wr.withCredentials = !!r.withCredentials), ye && ye !== "json" && (wr.responseType = r.responseType), typeof r.onDownloadProgress == "function" && wr.addEventListener("progress", progressEventReducer(r.onDownloadProgress, !0)), typeof r.onUploadProgress == "function" && wr.upload && wr.upload.addEventListener("progress", progressEventReducer(r.onUploadProgress)), (r.cancelToken || r.signal) && (fr = (jr) => {
      !wr || (o(!jr || jr.type ? new CanceledError$1(null, r, wr) : jr), wr.abort(), wr = null);
    }, r.cancelToken && r.cancelToken.subscribe(fr), r.signal && (r.signal.aborted ? fr() : r.signal.addEventListener("abort", fr)));
    const Vr = parseProtocol(kr);
    if (Vr && platform.protocols.indexOf(Vr) === -1) {
      o(new AxiosError$1("Unsupported protocol " + Vr + ":", AxiosError$1.ERR_BAD_REQUEST, r));
      return;
    }
    wr.send(fe || null);
  });
}, knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$9.forEach(knownAdapters, (r, e) => {
  if (r) {
    try {
      Object.defineProperty(r, "name", { value: e });
    } catch {
    }
    Object.defineProperty(r, "adapterName", { value: e });
  }
});
const renderReason = (r) => `- ${r}`, isResolvedHandle = (r) => utils$9.isFunction(r) || r === null || r === !1, adapters = {
  getAdapter: (r) => {
    r = utils$9.isArray(r) ? r : [r];
    const { length: e } = r;
    let s, o;
    const fe = {};
    for (let me = 0; me < e; me++) {
      s = r[me];
      let ye;
      if (o = s, !isResolvedHandle(s) && (o = knownAdapters[(ye = String(s)).toLowerCase()], o === void 0))
        throw new AxiosError$1(`Unknown adapter '${ye}'`);
      if (o)
        break;
      fe[ye || "#" + me] = o;
    }
    if (!o) {
      const me = Object.entries(fe).map(
        ([fr, Er]) => `adapter ${fr} ` + (Er === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let ye = e ? me.length > 1 ? `since :
` + me.map(renderReason).join(`
`) : " " + renderReason(me[0]) : "as no adapter specified";
      throw new AxiosError$1(
        "There is no suitable adapter to dispatch the request " + ye,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new CanceledError$1(null, r);
}
function dispatchRequest(r) {
  return throwIfCancellationRequested(r), r.headers = AxiosHeaders$2.from(r.headers), r.data = transformData.call(
    r,
    r.transformRequest
  ), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(r.adapter || defaults$3.adapter)(r).then(function(o) {
    return throwIfCancellationRequested(r), o.data = transformData.call(
      r,
      r.transformResponse,
      o
    ), o.headers = AxiosHeaders$2.from(o.headers), o;
  }, function(o) {
    return isCancel$1(o) || (throwIfCancellationRequested(r), o && o.response && (o.response.data = transformData.call(
      r,
      r.transformResponse,
      o.response
    ), o.response.headers = AxiosHeaders$2.from(o.response.headers))), Promise.reject(o);
  });
}
const headersToObject = (r) => r instanceof AxiosHeaders$2 ? r.toJSON() : r;
function mergeConfig$1(r, e) {
  e = e || {};
  const s = {};
  function o(br, wr, kr) {
    return utils$9.isPlainObject(br) && utils$9.isPlainObject(wr) ? utils$9.merge.call({ caseless: kr }, br, wr) : utils$9.isPlainObject(wr) ? utils$9.merge({}, wr) : utils$9.isArray(wr) ? wr.slice() : wr;
  }
  function fe(br, wr, kr) {
    if (utils$9.isUndefined(wr)) {
      if (!utils$9.isUndefined(br))
        return o(void 0, br, kr);
    } else
      return o(br, wr, kr);
  }
  function me(br, wr) {
    if (!utils$9.isUndefined(wr))
      return o(void 0, wr);
  }
  function ye(br, wr) {
    if (utils$9.isUndefined(wr)) {
      if (!utils$9.isUndefined(br))
        return o(void 0, br);
    } else
      return o(void 0, wr);
  }
  function fr(br, wr, kr) {
    if (kr in e)
      return o(br, wr);
    if (kr in r)
      return o(void 0, br);
  }
  const Er = {
    url: me,
    method: me,
    data: me,
    baseURL: ye,
    transformRequest: ye,
    transformResponse: ye,
    paramsSerializer: ye,
    timeout: ye,
    timeoutMessage: ye,
    withCredentials: ye,
    adapter: ye,
    responseType: ye,
    xsrfCookieName: ye,
    xsrfHeaderName: ye,
    onUploadProgress: ye,
    onDownloadProgress: ye,
    decompress: ye,
    maxContentLength: ye,
    maxBodyLength: ye,
    beforeRedirect: ye,
    transport: ye,
    httpAgent: ye,
    httpsAgent: ye,
    cancelToken: ye,
    socketPath: ye,
    responseEncoding: ye,
    validateStatus: fr,
    headers: (br, wr) => fe(headersToObject(br), headersToObject(wr), !0)
  };
  return utils$9.forEach(Object.keys(Object.assign({}, r, e)), function(wr) {
    const kr = Er[wr] || fe, Gr = kr(r[wr], e[wr], wr);
    utils$9.isUndefined(Gr) && kr !== fr || (s[wr] = Gr);
  }), s;
}
const VERSION$1 = "1.6.1", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((r, e) => {
  validators$1[r] = function(o) {
    return typeof o === r || "a" + (e < 1 ? "n " : " ") + r;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function r(e, s, o) {
  function fe(me, ye) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + me + "'" + ye + (o ? ". " + o : "");
  }
  return (me, ye, fr) => {
    if (e === !1)
      throw new AxiosError$1(
        fe(ye, " has been removed" + (s ? " in " + s : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    return s && !deprecatedWarnings[ye] && (deprecatedWarnings[ye] = !0, console.warn(
      fe(
        ye,
        " has been deprecated since v" + s + " and will be removed in the near future"
      )
    )), e ? e(me, ye, fr) : !0;
  };
};
function assertOptions(r, e, s) {
  if (typeof r != "object")
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(r);
  let fe = o.length;
  for (; fe-- > 0; ) {
    const me = o[fe], ye = e[me];
    if (ye) {
      const fr = r[me], Er = fr === void 0 || ye(fr, me, r);
      if (Er !== !0)
        throw new AxiosError$1("option " + me + " must be " + Er, AxiosError$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (s !== !0)
      throw new AxiosError$1("Unknown option " + me, AxiosError$1.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios$1 {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }
  request(e, s) {
    typeof e == "string" ? (s = s || {}, s.url = e) : s = e || {}, s = mergeConfig$1(this.defaults, s);
    const { transitional: o, paramsSerializer: fe, headers: me } = s;
    o !== void 0 && validator.assertOptions(o, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), fe != null && (utils$9.isFunction(fe) ? s.paramsSerializer = {
      serialize: fe
    } : validator.assertOptions(fe, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), s.method = (s.method || this.defaults.method || "get").toLowerCase();
    let ye = me && utils$9.merge(
      me.common,
      me[s.method]
    );
    me && utils$9.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (jr) => {
        delete me[jr];
      }
    ), s.headers = AxiosHeaders$2.concat(ye, me);
    const fr = [];
    let Er = !0;
    this.interceptors.request.forEach(function(Kr) {
      typeof Kr.runWhen == "function" && Kr.runWhen(s) === !1 || (Er = Er && Kr.synchronous, fr.unshift(Kr.fulfilled, Kr.rejected));
    });
    const br = [];
    this.interceptors.response.forEach(function(Kr) {
      br.push(Kr.fulfilled, Kr.rejected);
    });
    let wr, kr = 0, Gr;
    if (!Er) {
      const jr = [dispatchRequest.bind(this), void 0];
      for (jr.unshift.apply(jr, fr), jr.push.apply(jr, br), Gr = jr.length, wr = Promise.resolve(s); kr < Gr; )
        wr = wr.then(jr[kr++], jr[kr++]);
      return wr;
    }
    Gr = fr.length;
    let Vr = s;
    for (kr = 0; kr < Gr; ) {
      const jr = fr[kr++], Kr = fr[kr++];
      try {
        Vr = jr(Vr);
      } catch (bn) {
        Kr.call(this, bn);
        break;
      }
    }
    try {
      wr = dispatchRequest.call(this, Vr);
    } catch (jr) {
      return Promise.reject(jr);
    }
    for (kr = 0, Gr = br.length; kr < Gr; )
      wr = wr.then(br[kr++], br[kr++]);
    return wr;
  }
  getUri(e) {
    e = mergeConfig$1(this.defaults, e);
    const s = buildFullPath(e.baseURL, e.url);
    return buildURL(s, e.params, e.paramsSerializer);
  }
}
utils$9.forEach(["delete", "get", "head", "options"], function r(e) {
  Axios$1.prototype[e] = function(s, o) {
    return this.request(mergeConfig$1(o || {}, {
      method: e,
      url: s,
      data: (o || {}).data
    }));
  };
});
utils$9.forEach(["post", "put", "patch"], function r(e) {
  function s(o) {
    return function(me, ye, fr) {
      return this.request(mergeConfig$1(fr || {}, {
        method: e,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: me,
        data: ye
      }));
    };
  }
  Axios$1.prototype[e] = s(), Axios$1.prototype[e + "Form"] = s(!0);
});
const Axios$2 = Axios$1;
class CancelToken$1 {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let s;
    this.promise = new Promise(function(me) {
      s = me;
    });
    const o = this;
    this.promise.then((fe) => {
      if (!o._listeners)
        return;
      let me = o._listeners.length;
      for (; me-- > 0; )
        o._listeners[me](fe);
      o._listeners = null;
    }), this.promise.then = (fe) => {
      let me;
      const ye = new Promise((fr) => {
        o.subscribe(fr), me = fr;
      }).then(fe);
      return ye.cancel = function() {
        o.unsubscribe(me);
      }, ye;
    }, e(function(me, ye, fr) {
      o.reason || (o.reason = new CanceledError$1(me, ye, fr), s(o.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const s = this._listeners.indexOf(e);
    s !== -1 && this._listeners.splice(s, 1);
  }
  static source() {
    let e;
    return {
      token: new CancelToken$1(function(fe) {
        e = fe;
      }),
      cancel: e
    };
  }
}
const CancelToken$2 = CancelToken$1;
function spread$1(r) {
  return function(s) {
    return r.apply(null, s);
  };
}
function isAxiosError$1(r) {
  return utils$9.isObject(r) && r.isAxiosError === !0;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$1).forEach(([r, e]) => {
  HttpStatusCode$1[e] = r;
});
const HttpStatusCode$2 = HttpStatusCode$1;
function createInstance(r) {
  const e = new Axios$2(r), s = bind$2(Axios$2.prototype.request, e);
  return utils$9.extend(s, Axios$2.prototype, e, { allOwnKeys: !0 }), utils$9.extend(s, e, null, { allOwnKeys: !0 }), s.create = function(fe) {
    return createInstance(mergeConfig$1(r, fe));
  }, s;
}
const axios$1 = createInstance(defaults$3);
axios$1.Axios = Axios$2;
axios$1.CanceledError = CanceledError$1;
axios$1.CancelToken = CancelToken$2;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = VERSION$1;
axios$1.toFormData = toFormData$1;
axios$1.AxiosError = AxiosError$1;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function r(e) {
  return Promise.all(e);
};
axios$1.spread = spread$1;
axios$1.isAxiosError = isAxiosError$1;
axios$1.mergeConfig = mergeConfig$1;
axios$1.AxiosHeaders = AxiosHeaders$2;
axios$1.formToJSON = (r) => formDataToJSON(utils$9.isHTMLForm(r) ? new FormData(r) : r);
axios$1.getAdapter = adapters.getAdapter;
axios$1.HttpStatusCode = HttpStatusCode$2;
axios$1.default = axios$1;
const axios$2 = axios$1, {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios$2, axios = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: axios$2,
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
}, Symbol.toStringTag, { value: "Module" })), require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(axios);
var accounts = {}, primitives = {}, __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(r, e, s, o) {
  o === void 0 && (o = s), Object.defineProperty(r, o, { enumerable: !0, get: function() {
    return e[s];
  } });
} : function(r, e, s, o) {
  o === void 0 && (o = s), r[o] = e[s];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var e = {};
  if (r != null)
    for (var s in r)
      s !== "default" && Object.prototype.hasOwnProperty.call(r, s) && __createBinding(e, r, s);
  return __setModuleDefault(e, r), e;
};
Object.defineProperty(primitives, "__esModule", { value: !0 });
primitives.zeroPadStringIfOddLength = primitives.isPaddedHex = primitives.numberToPaddedHex = primitives.Nonce = primitives.Address = void 0;
const bech32 = __importStar(bech32$2), HRP = "erd";
class Address {
  constructor(e) {
    this.value = e;
  }
  static fromPubkey(e) {
    let s = bech32.toWords(e), o = bech32.encode(HRP, s);
    return new Address(o);
  }
  bech32() {
    return this.value;
  }
  toString() {
    return this.bech32();
  }
}
primitives.Address = Address;
class Nonce {
  constructor(e) {
    this.value = e;
  }
  valueOf() {
    return this.value;
  }
  hex() {
    return numberToPaddedHex(this.value);
  }
}
primitives.Nonce = Nonce;
function numberToPaddedHex(r) {
  let e = r.toString(16);
  return zeroPadStringIfOddLength(e);
}
primitives.numberToPaddedHex = numberToPaddedHex;
function isPaddedHex(r) {
  r = r || "";
  let e = Buffer.from(r, "hex").toString("hex");
  return r.toUpperCase() == e.toUpperCase();
}
primitives.isPaddedHex = isPaddedHex;
function zeroPadStringIfOddLength(r) {
  return r = r || "", r.length % 2 == 1 ? "0" + r : r;
}
primitives.zeroPadStringIfOddLength = zeroPadStringIfOddLength;
var __importDefault$a = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(accounts, "__esModule", { value: !0 });
accounts.GuardianData = accounts.AccountOnNetwork = void 0;
const bignumber_js_1$7 = __importDefault$a(require$$1$2), primitives_1$a = primitives;
class AccountOnNetwork {
  constructor(e) {
    this.address = new primitives_1$a.Address(""), this.nonce = 0, this.balance = new bignumber_js_1$7.default(0), this.code = "", this.userName = "", Object.assign(this, e);
  }
  static fromHttpResponse(e) {
    let s = new AccountOnNetwork();
    return s.address = new primitives_1$a.Address(e.address || ""), s.nonce = Number(e.nonce || 0), s.balance = new bignumber_js_1$7.default(e.balance || 0), s.code = e.code || "", s.userName = e.username || "", s;
  }
}
accounts.AccountOnNetwork = AccountOnNetwork;
class GuardianData {
  constructor(e) {
    this.guarded = !1, Object.assign(this, e);
  }
  static fromHttpResponse(e) {
    const s = new GuardianData();
    return s.guarded = e.guarded || !1, e.activeGuardian && (s.activeGuardian = Guardian.fromHttpResponse(e.activeGuardian)), e.pendingGuardian && (s.pendingGuardian = Guardian.fromHttpResponse(e.pendingGuardian)), s;
  }
  getCurrentGuardianAddress() {
    var e;
    if (!!this.guarded)
      return (e = this.activeGuardian) === null || e === void 0 ? void 0 : e.address;
  }
}
accounts.GuardianData = GuardianData;
class Guardian {
  constructor() {
    this.activationEpoch = 0, this.address = new primitives_1$a.Address(""), this.serviceUID = "";
  }
  static fromHttpResponse(e) {
    const s = new Guardian();
    return s.activationEpoch = Number(e.activationEpoch || 0), s.address = new primitives_1$a.Address(e.address || ""), s.serviceUID = e.serviceUID || "", s;
  }
}
var config$1 = {}, jsonBigint = { exports: {} }, stringify$3 = { exports: {} };
(function(r) {
  var e = require$$1$2, s = r.exports;
  (function() {
    var o = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, fe, me, ye = {
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    }, fr;
    function Er(wr) {
      return o.lastIndex = 0, o.test(wr) ? '"' + wr.replace(o, function(kr) {
        var Gr = ye[kr];
        return typeof Gr == "string" ? Gr : "\\u" + ("0000" + kr.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + wr + '"';
    }
    function br(wr, kr) {
      var Gr, Vr, jr, Kr, bn = fe, Yr, Zr = kr[wr], ti = Zr != null && (Zr instanceof e || e.isBigNumber(Zr));
      switch (Zr && typeof Zr == "object" && typeof Zr.toJSON == "function" && (Zr = Zr.toJSON(wr)), typeof fr == "function" && (Zr = fr.call(kr, wr, Zr)), typeof Zr) {
        case "string":
          return ti ? Zr : Er(Zr);
        case "number":
          return isFinite(Zr) ? String(Zr) : "null";
        case "boolean":
        case "null":
        case "bigint":
          return String(Zr);
        case "object":
          if (!Zr)
            return "null";
          if (fe += me, Yr = [], Object.prototype.toString.apply(Zr) === "[object Array]") {
            for (Kr = Zr.length, Gr = 0; Gr < Kr; Gr += 1)
              Yr[Gr] = br(Gr, Zr) || "null";
            return jr = Yr.length === 0 ? "[]" : fe ? `[
` + fe + Yr.join(`,
` + fe) + `
` + bn + "]" : "[" + Yr.join(",") + "]", fe = bn, jr;
          }
          if (fr && typeof fr == "object")
            for (Kr = fr.length, Gr = 0; Gr < Kr; Gr += 1)
              typeof fr[Gr] == "string" && (Vr = fr[Gr], jr = br(Vr, Zr), jr && Yr.push(Er(Vr) + (fe ? ": " : ":") + jr));
          else
            Object.keys(Zr).forEach(function(On) {
              var ni = br(On, Zr);
              ni && Yr.push(Er(On) + (fe ? ": " : ":") + ni);
            });
          return jr = Yr.length === 0 ? "{}" : fe ? `{
` + fe + Yr.join(`,
` + fe) + `
` + bn + "}" : "{" + Yr.join(",") + "}", fe = bn, jr;
      }
    }
    typeof s.stringify != "function" && (s.stringify = function(wr, kr, Gr) {
      var Vr;
      if (fe = "", me = "", typeof Gr == "number")
        for (Vr = 0; Vr < Gr; Vr += 1)
          me += " ";
      else
        typeof Gr == "string" && (me = Gr);
      if (fr = kr, kr && typeof kr != "function" && (typeof kr != "object" || typeof kr.length != "number"))
        throw new Error("JSON.stringify");
      return br("", { "": wr });
    });
  })();
})(stringify$3);
var BigNumber = null;
const suspectProtoRx$1 = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/, suspectConstructorRx$1 = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;
var json_parse$1 = function(r) {
  var e = {
    strict: !1,
    storeAsString: !1,
    alwaysParseAsBig: !1,
    useNativeBigInt: !1,
    protoAction: "error",
    constructorAction: "error"
  };
  if (r != null) {
    if (r.strict === !0 && (e.strict = !0), r.storeAsString === !0 && (e.storeAsString = !0), e.alwaysParseAsBig = r.alwaysParseAsBig === !0 ? r.alwaysParseAsBig : !1, e.useNativeBigInt = r.useNativeBigInt === !0 ? r.useNativeBigInt : !1, typeof r.constructorAction < "u")
      if (r.constructorAction === "error" || r.constructorAction === "ignore" || r.constructorAction === "preserve")
        e.constructorAction = r.constructorAction;
      else
        throw new Error(
          `Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${r.constructorAction}`
        );
    if (typeof r.protoAction < "u")
      if (r.protoAction === "error" || r.protoAction === "ignore" || r.protoAction === "preserve")
        e.protoAction = r.protoAction;
      else
        throw new Error(
          `Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${r.protoAction}`
        );
  }
  var s, o, fe = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, me, ye = function(Kr) {
    throw {
      name: "SyntaxError",
      message: Kr,
      at: s,
      text: me
    };
  }, fr = function(Kr) {
    return Kr && Kr !== o && ye("Expected '" + Kr + "' instead of '" + o + "'"), o = me.charAt(s), s += 1, o;
  }, Er = function() {
    var Kr, bn = "";
    for (o === "-" && (bn = "-", fr("-")); o >= "0" && o <= "9"; )
      bn += o, fr();
    if (o === ".")
      for (bn += "."; fr() && o >= "0" && o <= "9"; )
        bn += o;
    if (o === "e" || o === "E")
      for (bn += o, fr(), (o === "-" || o === "+") && (bn += o, fr()); o >= "0" && o <= "9"; )
        bn += o, fr();
    if (Kr = +bn, !isFinite(Kr))
      ye("Bad number");
    else
      return BigNumber == null && (BigNumber = require$$1$2), bn.length > 15 ? e.storeAsString ? bn : e.useNativeBigInt ? BigInt(bn) : new BigNumber(bn) : e.alwaysParseAsBig ? e.useNativeBigInt ? BigInt(Kr) : new BigNumber(Kr) : Kr;
  }, br = function() {
    var Kr, bn, Yr = "", Zr;
    if (o === '"')
      for (var ti = s; fr(); ) {
        if (o === '"')
          return s - 1 > ti && (Yr += me.substring(ti, s - 1)), fr(), Yr;
        if (o === "\\") {
          if (s - 1 > ti && (Yr += me.substring(ti, s - 1)), fr(), o === "u") {
            for (Zr = 0, bn = 0; bn < 4 && (Kr = parseInt(fr(), 16), !!isFinite(Kr)); bn += 1)
              Zr = Zr * 16 + Kr;
            Yr += String.fromCharCode(Zr);
          } else if (typeof fe[o] == "string")
            Yr += fe[o];
          else
            break;
          ti = s;
        }
      }
    ye("Bad string");
  }, wr = function() {
    for (; o && o <= " "; )
      fr();
  }, kr = function() {
    switch (o) {
      case "t":
        return fr("t"), fr("r"), fr("u"), fr("e"), !0;
      case "f":
        return fr("f"), fr("a"), fr("l"), fr("s"), fr("e"), !1;
      case "n":
        return fr("n"), fr("u"), fr("l"), fr("l"), null;
    }
    ye("Unexpected '" + o + "'");
  }, Gr, Vr = function() {
    var Kr = [];
    if (o === "[") {
      if (fr("["), wr(), o === "]")
        return fr("]"), Kr;
      for (; o; ) {
        if (Kr.push(Gr()), wr(), o === "]")
          return fr("]"), Kr;
        fr(","), wr();
      }
    }
    ye("Bad array");
  }, jr = function() {
    var Kr, bn = /* @__PURE__ */ Object.create(null);
    if (o === "{") {
      if (fr("{"), wr(), o === "}")
        return fr("}"), bn;
      for (; o; ) {
        if (Kr = br(), wr(), fr(":"), e.strict === !0 && Object.hasOwnProperty.call(bn, Kr) && ye('Duplicate key "' + Kr + '"'), suspectProtoRx$1.test(Kr) === !0 ? e.protoAction === "error" ? ye("Object contains forbidden prototype property") : e.protoAction === "ignore" ? Gr() : bn[Kr] = Gr() : suspectConstructorRx$1.test(Kr) === !0 ? e.constructorAction === "error" ? ye("Object contains forbidden constructor property") : e.constructorAction === "ignore" ? Gr() : bn[Kr] = Gr() : bn[Kr] = Gr(), wr(), o === "}")
          return fr("}"), bn;
        fr(","), wr();
      }
    }
    ye("Bad object");
  };
  return Gr = function() {
    switch (wr(), o) {
      case "{":
        return jr();
      case "[":
        return Vr();
      case '"':
        return br();
      case "-":
        return Er();
      default:
        return o >= "0" && o <= "9" ? Er() : kr();
    }
  }, function(Kr, bn) {
    var Yr;
    return me = Kr + "", s = 0, o = " ", Yr = Gr(), wr(), o && ye("Syntax error"), typeof bn == "function" ? function Zr(ti, On) {
      var ni, In = ti[On];
      return In && typeof In == "object" && Object.keys(In).forEach(function(Br) {
        ni = Zr(In, Br), ni !== void 0 ? In[Br] = ni : delete In[Br];
      }), bn.call(ti, On, In);
    }({ "": Yr }, "") : Yr;
  };
}, parse$h = json_parse$1, json_stringify = stringify$3.exports.stringify, json_parse = parse$h;
jsonBigint.exports = function(r) {
  return {
    parse: json_parse(r),
    stringify: json_stringify
  };
};
jsonBigint.exports.parse = json_parse();
jsonBigint.exports.stringify = json_stringify;
Object.defineProperty(config$1, "__esModule", { value: !0 });
config$1.defaultPagination = config$1.defaultAxiosConfig = void 0;
const JSONbig = jsonBigint.exports({ constructorAction: "ignore" });
config$1.defaultAxiosConfig = {
  timeout: 5e3,
  transformResponse: [
    function(r) {
      return JSONbig.parse(r);
    }
  ]
};
config$1.defaultPagination = {
  from: 0,
  size: 100
};
var constants$a = {}, __importDefault$9 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(constants$a, "__esModule", { value: !0 });
constants$a.EsdtContractAddress = constants$a.MaxUint64AsBigNumber = void 0;
const bignumber_js_1$6 = __importDefault$9(require$$1$2), primitives_1$9 = primitives;
constants$a.MaxUint64AsBigNumber = new bignumber_js_1$6.default("18446744073709551615");
constants$a.EsdtContractAddress = new primitives_1$9.Address("erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqzllls8a5w6u");
var contractQueryRequest = {};
Object.defineProperty(contractQueryRequest, "__esModule", { value: !0 });
contractQueryRequest.ContractQueryRequest = void 0;
class ContractQueryRequest {
  constructor(e) {
    this.query = e;
  }
  toHttpRequest() {
    var e;
    let s = {}, o = this.query;
    return s.scAddress = o.address.bech32(), s.caller = !((e = o.caller) === null || e === void 0) && e.bech32() ? o.caller.bech32() : void 0, s.funcName = o.func.toString(), s.value = o.value ? o.value.toString() : void 0, s.args = o.getEncodedArguments(), s;
  }
}
contractQueryRequest.ContractQueryRequest = ContractQueryRequest;
var contractQueryResponse = {}, __importDefault$8 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(contractQueryResponse, "__esModule", { value: !0 });
contractQueryResponse.ContractQueryResponse = void 0;
const bignumber_js_1$5 = __importDefault$8(require$$1$2), constants_1$4 = constants$a;
class ContractQueryResponse {
  constructor(e) {
    this.returnData = (e == null ? void 0 : e.returnData) || [], this.returnCode = (e == null ? void 0 : e.returnCode) || "", this.returnMessage = (e == null ? void 0 : e.returnMessage) || "", this.gasUsed = (e == null ? void 0 : e.gasUsed) || 0;
  }
  static fromHttpResponse(e) {
    let s = e.returnData || e.ReturnData, o = e.returnCode || e.ReturnCode, fe = e.returnMessage || e.ReturnMessage, me = new bignumber_js_1$5.default(e.gasRemaining || e.GasRemaining || 0), ye = constants_1$4.MaxUint64AsBigNumber.minus(me).toNumber();
    return new ContractQueryResponse({
      returnData: s,
      returnCode: o,
      returnMessage: fe,
      gasUsed: ye
    });
  }
  getReturnDataParts() {
    return this.returnData.map((e) => Buffer.from(e || "", "base64"));
  }
  toJSON() {
    return {
      returnData: this.returnData,
      returnCode: this.returnCode,
      returnMessage: this.returnMessage,
      gasUsed: this.gasUsed.valueOf()
    };
  }
}
contractQueryResponse.ContractQueryResponse = ContractQueryResponse;
var errors$4 = {};
Object.defineProperty(errors$4, "__esModule", { value: !0 });
errors$4.ErrContractQuery = errors$4.ErrNetworkProvider = errors$4.ErrUnexpectedCondition = errors$4.Err = void 0;
class Err$1 extends Error {
  constructor(e, s) {
    super(e), this.inner = void 0, this.inner = s;
  }
}
errors$4.Err = Err$1;
class ErrUnexpectedCondition extends Err$1 {
  constructor(e) {
    super(`Unexpected condition: [${e}]`);
  }
}
errors$4.ErrUnexpectedCondition = ErrUnexpectedCondition;
class ErrNetworkProvider extends Err$1 {
  constructor(e, s, o) {
    let fe = `Request error on url [${e}]: [${s}]`;
    super(fe, o);
  }
}
errors$4.ErrNetworkProvider = ErrNetworkProvider;
class ErrContractQuery extends Err$1 {
  constructor(e) {
    super(e.message.replace("executeQuery:", ""));
  }
}
errors$4.ErrContractQuery = ErrContractQuery;
var networkConfig = {}, __importDefault$7 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(networkConfig, "__esModule", { value: !0 });
networkConfig.NetworkConfig = void 0;
const bignumber_js_1$4 = __importDefault$7(require$$1$2);
class NetworkConfig {
  constructor() {
    this.ChainID = "T", this.GasPerDataByte = 1500, this.TopUpFactor = 0, this.RoundDuration = 0, this.RoundsPerEpoch = 0, this.TopUpRewardsGradientPoint = new bignumber_js_1$4.default(0), this.MinGasLimit = 5e4, this.MinGasPrice = 1e9, this.GasPriceModifier = 1, this.MinTransactionVersion = 1;
  }
  static fromHttpResponse(e) {
    let s = new NetworkConfig();
    return s.ChainID = String(e.erd_chain_id), s.GasPerDataByte = Number(e.erd_gas_per_data_byte), s.TopUpFactor = Number(e.erd_top_up_factor), s.RoundDuration = Number(e.erd_round_duration), s.RoundsPerEpoch = Number(e.erd_rounds_per_epoch), s.TopUpRewardsGradientPoint = new bignumber_js_1$4.default(e.erd_rewards_top_up_gradient_point), s.MinGasLimit = Number(e.erd_min_gas_limit), s.MinGasPrice = Number(e.erd_min_gas_price), s.MinTransactionVersion = Number(e.erd_min_transaction_version), s.GasPriceModifier = Number(e.erd_gas_price_modifier), s;
  }
}
networkConfig.NetworkConfig = NetworkConfig;
var networkStatus = {};
Object.defineProperty(networkStatus, "__esModule", { value: !0 });
networkStatus.NetworkStatus = void 0;
class NetworkStatus {
  constructor() {
    this.CurrentRound = 0, this.EpochNumber = 0, this.HighestFinalNonce = 0, this.Nonce = 0, this.NonceAtEpochStart = 0, this.NoncesPassedInCurrentEpoch = 0, this.RoundAtEpochStart = 0, this.RoundsPassedInCurrentEpoch = 0, this.RoundsPerEpoch = 0;
  }
  static fromHttpResponse(e) {
    let s = new NetworkStatus();
    return s.CurrentRound = Number(e.erd_current_round), s.EpochNumber = Number(e.erd_epoch_number), s.HighestFinalNonce = Number(e.erd_highest_final_nonce), s.Nonce = Number(e.erd_nonce), s.NonceAtEpochStart = Number(e.erd_nonce_at_epoch_start), s.NoncesPassedInCurrentEpoch = Number(e.erd_nonces_passed_in_current_epoch), s.RoundAtEpochStart = Number(e.erd_round_at_epoch_start), s.RoundsPassedInCurrentEpoch = Number(e.erd_rounds_passed_in_current_epoch), s.RoundsPerEpoch = Number(e.erd_rounds_per_epoch), s;
  }
}
networkStatus.NetworkStatus = NetworkStatus;
var tokenDefinitions = {}, __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(tokenDefinitions, "__esModule", { value: !0 });
tokenDefinitions.DefinitionOfTokenCollectionOnNetwork = tokenDefinitions.DefinitionOfFungibleTokenOnNetwork = void 0;
const bignumber_js_1$3 = __importDefault$6(require$$1$2), primitives_1$8 = primitives;
class DefinitionOfFungibleTokenOnNetwork {
  constructor() {
    this.identifier = "", this.name = "", this.ticker = "", this.owner = new primitives_1$8.Address(""), this.decimals = 0, this.supply = new bignumber_js_1$3.default(0), this.isPaused = !1, this.canUpgrade = !1, this.canMint = !1, this.canBurn = !1, this.canChangeOwner = !1, this.canPause = !1, this.canFreeze = !1, this.canWipe = !1, this.canAddSpecialRoles = !1, this.assets = {};
  }
  static fromApiHttpResponse(e) {
    let s = new DefinitionOfFungibleTokenOnNetwork();
    return s.identifier = e.identifier || "", s.name = e.name || "", s.ticker = e.ticker || "", s.owner = new primitives_1$8.Address(e.owner || ""), s.decimals = e.decimals || 0, s.supply = new bignumber_js_1$3.default(e.supply || "0"), s.isPaused = e.isPaused || !1, s.canUpgrade = e.canUpgrade || !1, s.canMint = e.canMint || !1, s.canBurn = e.canBurn || !1, s.canChangeOwner = e.canChangeOwner || !1, s.canPause = e.canPause || !1, s.canFreeze = e.canFreeze || !1, s.canWipe = e.canWipe || !1, s.assets = e.assets || {}, s;
  }
  static fromResponseOfGetTokenProperties(e, s) {
    let o = new DefinitionOfFungibleTokenOnNetwork(), [fe, me, ye, fr, ...Er] = s, br = parseTokenProperties(Er);
    return o.identifier = e, o.name = fe.toString(), o.ticker = e, o.owner = primitives_1$8.Address.fromPubkey(ye), o.decimals = br.NumDecimals.toNumber(), o.supply = new bignumber_js_1$3.default(fr.toString()).shiftedBy(-o.decimals), o.isPaused = br.IsPaused, o.canUpgrade = br.CanUpgrade, o.canMint = br.CanMint, o.canBurn = br.CanBurn, o.canChangeOwner = br.CanChangeOwner, o.canPause = br.CanPause, o.canFreeze = br.CanFreeze, o.canWipe = br.CanWipe, o;
  }
}
tokenDefinitions.DefinitionOfFungibleTokenOnNetwork = DefinitionOfFungibleTokenOnNetwork;
class DefinitionOfTokenCollectionOnNetwork {
  constructor() {
    this.collection = "", this.type = "", this.name = "", this.ticker = "", this.owner = new primitives_1$8.Address(""), this.decimals = 0, this.canPause = !1, this.canFreeze = !1, this.canWipe = !1, this.canUpgrade = !1, this.canChangeOwner = !1, this.canAddSpecialRoles = !1, this.canTransferNftCreateRole = !1, this.canCreateMultiShard = !1;
  }
  static fromApiHttpResponse(e) {
    let s = new DefinitionOfTokenCollectionOnNetwork();
    return s.collection = e.collection || "", s.type = e.type || "", s.name = e.name || "", s.ticker = e.ticker || "", s.owner = new primitives_1$8.Address(e.owner || ""), s.decimals = e.decimals || 0, s.canPause = e.canPause || !1, s.canFreeze = e.canFreeze || !1, s.canWipe = e.canWipe || !1, s.canUpgrade = e.canUpgrade || !1, s.canAddSpecialRoles = e.canAddSpecialRoles || !1, s.canTransferNftCreateRole = e.canTransferNftCreateRole || !1, s;
  }
  static fromResponseOfGetTokenProperties(e, s) {
    var o;
    let fe = new DefinitionOfTokenCollectionOnNetwork(), [me, ye, fr, Er, br, ...wr] = s, kr = parseTokenProperties(wr);
    return fe.collection = e, fe.type = ye.toString(), fe.name = me.toString(), fe.ticker = e, fe.owner = primitives_1$8.Address.fromPubkey(fr), fe.decimals = (o = kr.NumDecimals.toNumber()) !== null && o !== void 0 ? o : 0, fe.canPause = kr.CanPause || !1, fe.canFreeze = kr.CanFreeze || !1, fe.canWipe = kr.CanWipe || !1, fe.canUpgrade = kr.CanUpgrade || !1, fe.canChangeOwner = kr.CanChangeOwner || !1, fe.canAddSpecialRoles = kr.CanAddSpecialRoles || !1, fe.canTransferNftCreateRole = kr.CanTransferNFTCreateRole || !1, fe.canCreateMultiShard = kr.CanCreateMultiShard || !1, fe;
  }
}
tokenDefinitions.DefinitionOfTokenCollectionOnNetwork = DefinitionOfTokenCollectionOnNetwork;
function parseTokenProperties(r) {
  let e = {};
  for (let s of r) {
    let [o, fe] = s.toString().split("-");
    e[o] = parseValueOfTokenProperty(fe);
  }
  return e;
}
function parseValueOfTokenProperty(r) {
  switch (r) {
    case "true":
      return !0;
    case "false":
      return !1;
    default:
      return new bignumber_js_1$3.default(r);
  }
}
var tokens = {};
Object.defineProperty(tokens, "__esModule", { value: !0 });
tokens.NonFungibleTokenOfAccountOnNetwork = tokens.FungibleTokenOfAccountOnNetwork = void 0;
const bignumber_js_1$2 = require$$1$2, primitives_1$7 = primitives;
class FungibleTokenOfAccountOnNetwork {
  constructor() {
    this.identifier = "", this.balance = new bignumber_js_1$2.BigNumber(0), this.rawResponse = {};
  }
  static fromHttpResponse(e) {
    let s = new FungibleTokenOfAccountOnNetwork();
    return s.identifier = e.tokenIdentifier || e.identifier || "", s.balance = new bignumber_js_1$2.BigNumber(e.balance || 0), s.rawResponse = e, s;
  }
}
tokens.FungibleTokenOfAccountOnNetwork = FungibleTokenOfAccountOnNetwork;
class NonFungibleTokenOfAccountOnNetwork {
  constructor(e) {
    this.identifier = "", this.collection = "", this.timestamp = 0, this.attributes = Buffer.from([]), this.nonce = 0, this.type = "", this.name = "", this.creator = new primitives_1$7.Address(""), this.supply = new bignumber_js_1$2.BigNumber(0), this.decimals = 0, this.royalties = new bignumber_js_1$2.BigNumber(0), this.assets = [], this.balance = new bignumber_js_1$2.BigNumber(0), Object.assign(this, e);
  }
  static fromProxyHttpResponse(e) {
    let s = NonFungibleTokenOfAccountOnNetwork.fromHttpResponse(e);
    return s.identifier = e.tokenIdentifier || "", s.collection = NonFungibleTokenOfAccountOnNetwork.parseCollectionFromIdentifier(s.identifier), s.royalties = new bignumber_js_1$2.BigNumber(e.royalties || 0).div(100), s;
  }
  static fromProxyHttpResponseByNonce(e) {
    let s = NonFungibleTokenOfAccountOnNetwork.fromHttpResponse(e), o = new primitives_1$7.Nonce(s.nonce).hex();
    return s.identifier = `${e.tokenIdentifier}-${o}`, s.collection = e.tokenIdentifier || "", s.royalties = new bignumber_js_1$2.BigNumber(e.royalties || 0).div(100), s;
  }
  static fromApiHttpResponse(e) {
    let s = NonFungibleTokenOfAccountOnNetwork.fromHttpResponse(e);
    return s.identifier = e.identifier || "", s.collection = e.collection || "", s;
  }
  static fromHttpResponse(e) {
    let s = new NonFungibleTokenOfAccountOnNetwork();
    return s.timestamp = Number(e.timestamp || 0), s.attributes = Buffer.from(e.attributes || "", "base64"), s.nonce = e.nonce || 0, s.type = e.type || "", s.name = e.name || "", s.creator = new primitives_1$7.Address(e.creator || ""), s.decimals = Number(e.decimals || 0), s.supply = new bignumber_js_1$2.BigNumber(e.balance || 1), s.royalties = new bignumber_js_1$2.BigNumber(e.royalties || 0), s.assets = e.assets || [], s.balance = new bignumber_js_1$2.BigNumber(e.balance || 1), s;
  }
  static parseCollectionFromIdentifier(e) {
    return e.split("-").slice(0, 2).join("-");
  }
}
tokens.NonFungibleTokenOfAccountOnNetwork = NonFungibleTokenOfAccountOnNetwork;
var transactions = {}, transactionStatus = {};
Object.defineProperty(transactionStatus, "__esModule", { value: !0 });
transactionStatus.TransactionStatus = void 0;
class TransactionStatus {
  constructor(e) {
    this.status = (e || "").toLowerCase();
  }
  static createUnknown() {
    return new TransactionStatus("unknown");
  }
  isPending() {
    return this.status == "received" || this.status == "pending";
  }
  isExecuted() {
    return this.isSuccessful() || this.isFailed() || this.isInvalid();
  }
  isSuccessful() {
    return this.status == "executed" || this.status == "success" || this.status == "successful";
  }
  isFailed() {
    return this.status == "fail" || this.status == "failed" || this.status == "unsuccessful" || this.isInvalid();
  }
  isInvalid() {
    return this.status == "invalid";
  }
  toString() {
    return this.status;
  }
  valueOf() {
    return this.status;
  }
  equals(e) {
    return e ? this.status == e.status : !1;
  }
}
transactionStatus.TransactionStatus = TransactionStatus;
var contractResults = {}, transactionLogs = {}, transactionEvents = {};
Object.defineProperty(transactionEvents, "__esModule", { value: !0 });
transactionEvents.TransactionEventTopic = transactionEvents.TransactionEventData = transactionEvents.TransactionEvent = void 0;
const primitives_1$6 = primitives;
class TransactionEvent {
  constructor(e) {
    this.address = new primitives_1$6.Address(""), this.identifier = "", this.topics = [], this.data = "", this.dataPayload = new TransactionEventData(Buffer.from("", "utf8")), this.additionalData = [], Object.assign(this, e);
  }
  static fromHttpResponse(e) {
    let s = new TransactionEvent();
    return s.address = new primitives_1$6.Address(e.address), s.identifier = e.identifier || "", s.topics = (e.topics || []).map((o) => new TransactionEventTopic(o)), s.dataPayload = TransactionEventData.fromBase64(e.data), s.additionalData = (e.additionalData || []).map(TransactionEventData.fromBase64), s.data = s.dataPayload.toString(), s;
  }
  findFirstOrNoneTopic(e) {
    return this.topics.filter((s) => e(s))[0];
  }
  getLastTopic() {
    return this.topics[this.topics.length - 1];
  }
}
transactionEvents.TransactionEvent = TransactionEvent;
class TransactionEventData {
  constructor(e) {
    this.raw = e;
  }
  static fromBase64(e) {
    return new TransactionEventData(Buffer.from(e || "", "base64"));
  }
  toString() {
    return this.raw.toString("utf8");
  }
  hex() {
    return this.raw.toString("hex");
  }
  valueOf() {
    return this.raw;
  }
}
transactionEvents.TransactionEventData = TransactionEventData;
class TransactionEventTopic {
  constructor(e) {
    this.raw = Buffer.from(e || "", "base64");
  }
  toString() {
    return this.raw.toString("utf8");
  }
  hex() {
    return this.raw.toString("hex");
  }
  valueOf() {
    return this.raw;
  }
}
transactionEvents.TransactionEventTopic = TransactionEventTopic;
Object.defineProperty(transactionLogs, "__esModule", { value: !0 });
transactionLogs.TransactionLogs = void 0;
const errors_1$6 = errors$4, primitives_1$5 = primitives, transactionEvents_1 = transactionEvents;
class TransactionLogs {
  constructor(e) {
    this.address = new primitives_1$5.Address(""), this.events = [], Object.assign(this, e);
  }
  static fromHttpResponse(e) {
    let s = new TransactionLogs();
    return s.address = new primitives_1$5.Address(e.address), s.events = (e.events || []).map((o) => transactionEvents_1.TransactionEvent.fromHttpResponse(o)), s;
  }
  findSingleOrNoneEvent(e, s) {
    let o = this.findEvents(e, s);
    if (o.length > 1)
      throw new errors_1$6.ErrUnexpectedCondition(`more than one event of type ${e}`);
    return o[0];
  }
  findFirstOrNoneEvent(e, s) {
    return this.findEvents(e, s)[0];
  }
  findEvents(e, s) {
    let o = this.events.filter((fe) => fe.identifier == e);
    return s && (o = o.filter((fe) => s(fe))), o;
  }
}
transactionLogs.TransactionLogs = TransactionLogs;
Object.defineProperty(contractResults, "__esModule", { value: !0 });
contractResults.ContractResultItem = contractResults.ContractResults = void 0;
const transactionLogs_1$1 = transactionLogs, primitives_1$4 = primitives;
class ContractResults {
  constructor(e) {
    this.items = e, this.items.sort(function(s, o) {
      return s.nonce.valueOf() - o.nonce.valueOf();
    });
  }
  static fromProxyHttpResponse(e) {
    let s = e.map((o) => ContractResultItem.fromProxyHttpResponse(o));
    return new ContractResults(s);
  }
  static fromApiHttpResponse(e) {
    let s = e.map((o) => ContractResultItem.fromApiHttpResponse(o));
    return new ContractResults(s);
  }
}
contractResults.ContractResults = ContractResults;
class ContractResultItem {
  constructor(e) {
    this.hash = "", this.nonce = 0, this.value = "", this.receiver = new primitives_1$4.Address(""), this.sender = new primitives_1$4.Address(""), this.data = "", this.previousHash = "", this.originalHash = "", this.gasLimit = 0, this.gasPrice = 0, this.callType = 0, this.returnMessage = "", this.logs = new transactionLogs_1$1.TransactionLogs(), Object.assign(this, e);
  }
  static fromProxyHttpResponse(e) {
    return ContractResultItem.fromHttpResponse(e);
  }
  static fromApiHttpResponse(e) {
    let s = ContractResultItem.fromHttpResponse(e);
    return s.data = Buffer.from(s.data, "base64").toString(), s.callType = Number(s.callType), s;
  }
  static fromHttpResponse(e) {
    let s = new ContractResultItem();
    return s.hash = e.hash, s.nonce = Number(e.nonce || 0), s.value = (e.value || 0).toString(), s.receiver = new primitives_1$4.Address(e.receiver), s.sender = new primitives_1$4.Address(e.sender), s.previousHash = e.prevTxHash, s.originalHash = e.originalTxHash, s.gasLimit = Number(e.gasLimit || 0), s.gasPrice = Number(e.gasPrice || 0), s.data = e.data || "", s.callType = e.callType, s.returnMessage = e.returnMessage, s.logs = transactionLogs_1$1.TransactionLogs.fromHttpResponse(e.logs || {}), s;
  }
}
contractResults.ContractResultItem = ContractResultItem;
var transactionReceipt = {};
Object.defineProperty(transactionReceipt, "__esModule", { value: !0 });
transactionReceipt.TransactionReceipt = void 0;
const primitives_1$3 = primitives;
class TransactionReceipt {
  constructor() {
    this.value = "", this.sender = new primitives_1$3.Address(""), this.data = "", this.hash = "";
  }
  static fromHttpResponse(e) {
    let s = new TransactionReceipt();
    return s.value = (e.value || 0).toString(), s.sender = new primitives_1$3.Address(e.sender), s.data = e.data, s.hash = e.txHash, s;
  }
}
transactionReceipt.TransactionReceipt = TransactionReceipt;
Object.defineProperty(transactions, "__esModule", { value: !0 });
transactions.TransactionOnNetwork = void 0;
const transactionStatus_1$2 = transactionStatus, contractResults_1 = contractResults, primitives_1$2 = primitives, transactionLogs_1 = transactionLogs, transactionReceipt_1 = transactionReceipt;
class TransactionOnNetwork {
  constructor(e) {
    this.hash = "", this.type = "", this.nonce = 0, this.round = 0, this.epoch = 0, this.value = "", this.receiver = new primitives_1$2.Address(""), this.sender = new primitives_1$2.Address(""), this.gasLimit = 0, this.gasPrice = 0, this.data = Buffer.from([]), this.signature = "", this.status = transactionStatus_1$2.TransactionStatus.createUnknown(), this.timestamp = 0, this.blockNonce = 0, this.hyperblockNonce = 0, this.hyperblockHash = "", this.receipt = new transactionReceipt_1.TransactionReceipt(), this.contractResults = new contractResults_1.ContractResults([]), this.logs = new transactionLogs_1.TransactionLogs(), Object.assign(this, e);
  }
  static fromProxyHttpResponse(e, s, o) {
    let fe = TransactionOnNetwork.fromHttpResponse(e, s);
    return fe.contractResults = contractResults_1.ContractResults.fromProxyHttpResponse(s.smartContractResults || []), o && (fe.status = o, fe.isCompleted = fe.status.isSuccessful() || fe.status.isFailed()), fe;
  }
  static fromApiHttpResponse(e, s) {
    let o = TransactionOnNetwork.fromHttpResponse(e, s);
    return o.contractResults = contractResults_1.ContractResults.fromApiHttpResponse(s.results || []), o.isCompleted = !o.status.isPending(), o;
  }
  static fromHttpResponse(e, s) {
    let o = new TransactionOnNetwork();
    return o.hash = e, o.type = s.type || "", o.nonce = s.nonce || 0, o.round = s.round, o.epoch = s.epoch || 0, o.value = (s.value || 0).toString(), o.sender = new primitives_1$2.Address(s.sender), o.receiver = new primitives_1$2.Address(s.receiver), o.gasPrice = s.gasPrice || 0, o.gasLimit = s.gasLimit || 0, o.data = Buffer.from(s.data || "", "base64"), o.status = new transactionStatus_1$2.TransactionStatus(s.status), o.timestamp = s.timestamp || 0, o.blockNonce = s.blockNonce || 0, o.hyperblockNonce = s.hyperblockNonce || 0, o.hyperblockHash = s.hyperblockHash || "", o.receipt = transactionReceipt_1.TransactionReceipt.fromHttpResponse(s.receipt || {}), o.logs = transactionLogs_1.TransactionLogs.fromHttpResponse(s.logs || {}), o;
  }
  getDateTime() {
    return new Date(this.timestamp * 1e3);
  }
}
transactions.TransactionOnNetwork = TransactionOnNetwork;
var __awaiter$e = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
}, __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(proxyNetworkProvider, "__esModule", { value: !0 });
proxyNetworkProvider.ProxyNetworkProvider = void 0;
const axios_1$1 = __importDefault$5(require$$0$3), accounts_1$1 = accounts, config_1$1 = config$1, constants_1$3 = constants$a, contractQueryRequest_1$1 = contractQueryRequest, contractQueryResponse_1$1 = contractQueryResponse, errors_1$5 = errors$4, networkConfig_1 = networkConfig, networkStatus_1 = networkStatus, tokenDefinitions_1$1 = tokenDefinitions, tokens_1$1 = tokens, transactions_1$1 = transactions, transactionStatus_1$1 = transactionStatus;
class ProxyNetworkProvider {
  constructor(e, s) {
    this.url = e, this.config = Object.assign(Object.assign({}, config_1$1.defaultAxiosConfig), s);
  }
  getNetworkConfig() {
    return __awaiter$e(this, void 0, void 0, function* () {
      let e = yield this.doGetGeneric("network/config");
      return networkConfig_1.NetworkConfig.fromHttpResponse(e.config);
    });
  }
  getNetworkStatus() {
    return __awaiter$e(this, void 0, void 0, function* () {
      let e = yield this.doGetGeneric("network/status/4294967295");
      return networkStatus_1.NetworkStatus.fromHttpResponse(e.status);
    });
  }
  getNetworkStakeStatistics() {
    return __awaiter$e(this, void 0, void 0, function* () {
      throw new Error("Method not implemented.");
    });
  }
  getNetworkGeneralStatistics() {
    return __awaiter$e(this, void 0, void 0, function* () {
      throw new Error("Method not implemented.");
    });
  }
  getAccount(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`address/${e.bech32()}`);
      return accounts_1$1.AccountOnNetwork.fromHttpResponse(s.account);
    });
  }
  getGuardianData(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      const s = yield this.doGetGeneric(`address/${e.bech32()}/guardian-data`);
      return accounts_1$1.GuardianData.fromHttpResponse(s.guardianData);
    });
  }
  getFungibleTokensOfAccount(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let o = `address/${e.bech32()}/esdt`, fe = yield this.doGetGeneric(o), fr = Object.values(fe.esdts).filter((Er) => !Er.nonce).map((Er) => tokens_1$1.FungibleTokenOfAccountOnNetwork.fromHttpResponse(Er));
      return fr.sort((Er, br) => Er.identifier.localeCompare(br.identifier)), fr;
    });
  }
  getNonFungibleTokensOfAccount(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let o = `address/${e.bech32()}/esdt`, fe = yield this.doGetGeneric(o), fr = Object.values(fe.esdts).filter((Er) => Er.nonce >= 0).map((Er) => tokens_1$1.NonFungibleTokenOfAccountOnNetwork.fromProxyHttpResponse(Er));
      return fr.sort((Er, br) => Er.identifier.localeCompare(br.identifier)), fr;
    });
  }
  getFungibleTokenOfAccount(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let o = yield this.doGetGeneric(`address/${e.bech32()}/esdt/${s}`);
      return tokens_1$1.FungibleTokenOfAccountOnNetwork.fromHttpResponse(o.tokenData);
    });
  }
  getNonFungibleTokenOfAccount(e, s, o) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let fe = yield this.doGetGeneric(`address/${e.bech32()}/nft/${s}/nonce/${o.valueOf()}`);
      return tokens_1$1.NonFungibleTokenOfAccountOnNetwork.fromProxyHttpResponseByNonce(fe.tokenData);
    });
  }
  getTransaction(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let o;
      s === !0 && (o = this.getTransactionStatus(e));
      let fe = this.buildUrlWithQueryParameters(`transaction/${e}`, { withResults: "true" }), me = yield this.doGetGeneric(fe);
      if (o) {
        const ye = yield o;
        return transactions_1$1.TransactionOnNetwork.fromProxyHttpResponse(e, me.transaction, ye);
      }
      return transactions_1$1.TransactionOnNetwork.fromProxyHttpResponse(e, me.transaction);
    });
  }
  getTransactionStatus(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`transaction/${e}/process-status`);
      return new transactionStatus_1$1.TransactionStatus(s.status);
    });
  }
  sendTransaction(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      return (yield this.doPostGeneric("transaction/send", e.toSendable())).txHash;
    });
  }
  sendTransactions(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      const s = e.map((me) => me.toSendable()), o = yield this.doPostGeneric("transaction/send-multiple", s), fe = Array(e.length).fill(null);
      for (let me = 0; me < e.length; me++)
        fe[me] = o.txsHashes[me.toString()] || null;
      return fe;
    });
  }
  simulateTransaction(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      return yield this.doPostGeneric("transaction/simulate", e.toSendable());
    });
  }
  queryContract(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      try {
        let s = new contractQueryRequest_1$1.ContractQueryRequest(e).toHttpRequest(), o = yield this.doPostGeneric("vm-values/query", s);
        return contractQueryResponse_1$1.ContractQueryResponse.fromHttpResponse(o.data);
      } catch (s) {
        throw new errors_1$5.ErrContractQuery(s);
      }
    });
  }
  getDefinitionOfFungibleToken(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let s = yield this.getTokenProperties(e);
      return tokenDefinitions_1$1.DefinitionOfFungibleTokenOnNetwork.fromResponseOfGetTokenProperties(e, s);
    });
  }
  getTokenProperties(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let s = Buffer.from(e).toString("hex");
      return (yield this.queryContract({
        address: constants_1$3.EsdtContractAddress,
        func: "getTokenProperties",
        getEncodedArguments: () => [s]
      })).getReturnDataParts();
    });
  }
  getDefinitionOfTokenCollection(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let s = yield this.getTokenProperties(e);
      return tokenDefinitions_1$1.DefinitionOfTokenCollectionOnNetwork.fromResponseOfGetTokenProperties(e, s);
    });
  }
  getNonFungibleToken(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      throw new Error("Method not implemented.");
    });
  }
  doGetGeneric(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      return yield this.doGet(e);
    });
  }
  doPostGeneric(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      return yield this.doPost(e, s);
    });
  }
  doGet(e) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let s = `${this.url}/${e}`;
      try {
        return (yield axios_1$1.default.get(s, this.config)).data.data;
      } catch (o) {
        this.handleApiError(o, e);
      }
    });
  }
  doPost(e, s) {
    return __awaiter$e(this, void 0, void 0, function* () {
      let o = `${this.url}/${e}`;
      try {
        return (yield axios_1$1.default.post(o, s, Object.assign(Object.assign({}, this.config), { headers: Object.assign({ "Content-Type": "application/json" }, this.config.headers) }))).data.data;
      } catch (fe) {
        this.handleApiError(fe, e);
      }
    });
  }
  buildUrlWithQueryParameters(e, s) {
    let o = new URLSearchParams();
    for (let [fe, me] of Object.entries(s))
      me && o.append(fe, me);
    return `${e}?${o.toString()}`;
  }
  handleApiError(e, s) {
    if (!e.response)
      throw new errors_1$5.ErrNetworkProvider(s, e.toString(), e);
    const o = e.response.data, fe = o.message || o.error || JSON.stringify(o);
    throw new errors_1$5.ErrNetworkProvider(s, fe, e);
  }
}
proxyNetworkProvider.ProxyNetworkProvider = ProxyNetworkProvider;
var apiNetworkProvider = {}, networkGeneralStatistics = {};
Object.defineProperty(networkGeneralStatistics, "__esModule", { value: !0 });
networkGeneralStatistics.NetworkGeneralStatistics = void 0;
class NetworkGeneralStatistics {
  constructor() {
    this.Shards = 0, this.Blocks = 0, this.Accounts = 0, this.Transactions = 0, this.RefreshRate = 0, this.Epoch = 0, this.RoundsPassed = 0, this.RoundsPerEpoch = 0;
  }
  static fromHttpResponse(e) {
    let s = new NetworkGeneralStatistics();
    return s.Shards = Number(e.shards), s.Blocks = Number(e.blocks), s.Accounts = Number(e.accounts), s.Transactions = Number(e.transactions), s.RefreshRate = Number(e.refreshRate), s.Epoch = Number(e.epoch), s.RoundsPassed = Number(e.roundsPassed), s.RoundsPerEpoch = Number(e.roundsPerEpoch), s;
  }
}
networkGeneralStatistics.NetworkGeneralStatistics = NetworkGeneralStatistics;
var networkStake = {}, __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(networkStake, "__esModule", { value: !0 });
networkStake.NetworkStake = void 0;
const bignumber_js_1$1 = __importDefault$4(require$$1$2);
class NetworkStake {
  constructor() {
    this.TotalValidators = 0, this.ActiveValidators = 0, this.QueueSize = 0, this.TotalStaked = new bignumber_js_1$1.default(0);
  }
  static fromHttpResponse(e) {
    let s = new NetworkStake();
    return s.TotalValidators = Number(e.totalValidators), s.ActiveValidators = Number(e.activeValidators), s.QueueSize = Number(e.queueSize), s.TotalStaked = new bignumber_js_1$1.default(e.totalStaked), s;
  }
}
networkStake.NetworkStake = NetworkStake;
var pairs = {}, __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(pairs, "__esModule", { value: !0 });
pairs.PairOnNetwork = void 0;
const primitives_1$1 = primitives, bignumber_js_1 = __importDefault$3(require$$1$2);
class PairOnNetwork {
  constructor(e) {
    this.address = new primitives_1$1.Address(""), this.id = "", this.symbol = "", this.name = "", this.price = new bignumber_js_1.default(0), this.baseId = "", this.basePrice = new bignumber_js_1.default(0), this.baseSymbol = "", this.baseName = "", this.quoteId = "", this.quotePrice = new bignumber_js_1.default(0), this.quoteSymbol = "", this.quoteName = "", this.totalValue = new bignumber_js_1.default(0), this.volume24h = new bignumber_js_1.default(0), this.state = "", this.type = "", this.rawResponse = {}, Object.assign(this, e);
  }
  static fromApiHttpResponse(e) {
    let s = new PairOnNetwork();
    return s.address = new primitives_1$1.Address(e.address || ""), s.id = e.id || "", s.symbol = e.symbol || "", s.name = e.name || "", s.price = new bignumber_js_1.default(e.price || 0), s.baseId = e.baseId || "", s.basePrice = new bignumber_js_1.default(e.basePrice || 0), s.baseSymbol = e.baseSymbol || "", s.baseName = e.baseName || "", s.quoteId = e.quoteId || "", s.quotePrice = new bignumber_js_1.default(e.quotePrice || 0), s.quoteSymbol = e.quoteSymbol || "", s.quoteName = e.quoteName || "", s.totalValue = new bignumber_js_1.default(e.totalValue || 0), s.volume24h = new bignumber_js_1.default(e.volume24h || 0), s.state = e.state || "", s.type = e.type || "", s.rawResponse = e, s;
  }
}
pairs.PairOnNetwork = PairOnNetwork;
var __awaiter$d = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
}, __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(apiNetworkProvider, "__esModule", { value: !0 });
apiNetworkProvider.ApiNetworkProvider = void 0;
const axios_1 = __importDefault$2(require$$0$3), accounts_1 = accounts, config_1 = config$1, contractQueryRequest_1 = contractQueryRequest, contractQueryResponse_1 = contractQueryResponse, errors_1$4 = errors$4, networkGeneralStatistics_1 = networkGeneralStatistics, networkStake_1 = networkStake, pairs_1 = pairs, primitives_1 = primitives, proxyNetworkProvider_1 = proxyNetworkProvider, tokenDefinitions_1 = tokenDefinitions, tokens_1 = tokens, transactions_1 = transactions, transactionStatus_1 = transactionStatus;
class ApiNetworkProvider {
  constructor(e, s) {
    this.url = e, this.config = Object.assign(Object.assign({}, config_1.defaultAxiosConfig), s), this.backingProxyNetworkProvider = new proxyNetworkProvider_1.ProxyNetworkProvider(e, s);
  }
  getNetworkConfig() {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.backingProxyNetworkProvider.getNetworkConfig();
    });
  }
  getNetworkStatus() {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.backingProxyNetworkProvider.getNetworkStatus();
    });
  }
  getNetworkStakeStatistics() {
    return __awaiter$d(this, void 0, void 0, function* () {
      let e = yield this.doGetGeneric("stake");
      return networkStake_1.NetworkStake.fromHttpResponse(e);
    });
  }
  getNetworkGeneralStatistics() {
    return __awaiter$d(this, void 0, void 0, function* () {
      let e = yield this.doGetGeneric("stats");
      return networkGeneralStatistics_1.NetworkGeneralStatistics.fromHttpResponse(e);
    });
  }
  getAccount(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`accounts/${e.bech32()}`);
      return accounts_1.AccountOnNetwork.fromHttpResponse(s);
    });
  }
  getGuardianData(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.backingProxyNetworkProvider.getGuardianData(e);
    });
  }
  getFungibleTokensOfAccount(e, s) {
    return __awaiter$d(this, void 0, void 0, function* () {
      s = s || config_1.defaultPagination;
      let o = `accounts/${e.bech32()}/tokens?${this.buildPaginationParams(s)}`, me = (yield this.doGetGeneric(o)).map((ye) => tokens_1.FungibleTokenOfAccountOnNetwork.fromHttpResponse(ye));
      return me.sort((ye, fr) => ye.identifier.localeCompare(fr.identifier)), me;
    });
  }
  getNonFungibleTokensOfAccount(e, s) {
    return __awaiter$d(this, void 0, void 0, function* () {
      s = s || config_1.defaultPagination;
      let o = `accounts/${e.bech32()}/nfts?${this.buildPaginationParams(s)}`, me = (yield this.doGetGeneric(o)).map((ye) => tokens_1.NonFungibleTokenOfAccountOnNetwork.fromApiHttpResponse(ye));
      return me.sort((ye, fr) => ye.identifier.localeCompare(fr.identifier)), me;
    });
  }
  getFungibleTokenOfAccount(e, s) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let o = yield this.doGetGeneric(`accounts/${e.bech32()}/tokens/${s}`);
      return tokens_1.FungibleTokenOfAccountOnNetwork.fromHttpResponse(o);
    });
  }
  getNonFungibleTokenOfAccount(e, s, o) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let fe = new primitives_1.Nonce(o).hex(), me = yield this.doGetGeneric(`accounts/${e.bech32()}/nfts/${s}-${fe}`);
      return tokens_1.NonFungibleTokenOfAccountOnNetwork.fromApiHttpResponse(me);
    });
  }
  getMexPairs(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = "mex/pairs";
      return e && (s = `${s}?from=${e.from}&size=${e.size}`), (yield this.doGetGeneric(s)).map((fe) => pairs_1.PairOnNetwork.fromApiHttpResponse(fe));
    });
  }
  getTransaction(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`transactions/${e}`);
      return transactions_1.TransactionOnNetwork.fromApiHttpResponse(e, s);
    });
  }
  getTransactionStatus(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`transactions/${e}?fields=status`);
      return new transactionStatus_1.TransactionStatus(s.status);
    });
  }
  sendTransaction(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      return (yield this.doPostGeneric("transactions", e.toSendable())).txHash;
    });
  }
  sendTransactions(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.backingProxyNetworkProvider.sendTransactions(e);
    });
  }
  simulateTransaction(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.backingProxyNetworkProvider.simulateTransaction(e);
    });
  }
  queryContract(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      try {
        let s = new contractQueryRequest_1.ContractQueryRequest(e).toHttpRequest(), o = yield this.doPostGeneric("query", s);
        return contractQueryResponse_1.ContractQueryResponse.fromHttpResponse(o);
      } catch (s) {
        throw new errors_1$4.ErrContractQuery(s);
      }
    });
  }
  getDefinitionOfFungibleToken(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`tokens/${e}`);
      return tokenDefinitions_1.DefinitionOfFungibleTokenOnNetwork.fromApiHttpResponse(s);
    });
  }
  getDefinitionOfTokenCollection(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = yield this.doGetGeneric(`collections/${e}`);
      return tokenDefinitions_1.DefinitionOfTokenCollectionOnNetwork.fromApiHttpResponse(s);
    });
  }
  getNonFungibleToken(e, s) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let o = new primitives_1.Nonce(s).hex(), fe = yield this.doGetGeneric(`nfts/${e}-${o}`);
      return tokens_1.NonFungibleTokenOfAccountOnNetwork.fromApiHttpResponse(fe);
    });
  }
  doGetGeneric(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.doGet(e);
    });
  }
  doPostGeneric(e, s) {
    return __awaiter$d(this, void 0, void 0, function* () {
      return yield this.doPost(e, s);
    });
  }
  buildPaginationParams(e) {
    return `from=${e.from}&size=${e.size}`;
  }
  doGet(e) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let s = `${this.url}/${e}`;
      try {
        return (yield axios_1.default.get(s, this.config)).data;
      } catch (o) {
        this.handleApiError(o, e);
      }
    });
  }
  doPost(e, s) {
    return __awaiter$d(this, void 0, void 0, function* () {
      let o = `${this.url}/${e}`;
      try {
        return (yield axios_1.default.post(o, s, Object.assign(Object.assign({}, this.config), { headers: Object.assign({ "Content-Type": "application/json" }, this.config.headers) }))).data;
      } catch (fe) {
        this.handleApiError(fe, e);
      }
    });
  }
  handleApiError(e, s) {
    if (!e.response)
      throw new errors_1$4.ErrNetworkProvider(s, e.toString(), e);
    const o = e.response.data, fe = o.message || o.error || JSON.stringify(o);
    throw new errors_1$4.ErrNetworkProvider(s, fe, e);
  }
}
apiNetworkProvider.ApiNetworkProvider = ApiNetworkProvider;
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.NetworkStatus = r.NetworkStake = r.NetworkGeneralStatistics = r.NetworkConfig = r.DefinitionOfTokenCollectionOnNetwork = r.DefinitionOfFungibleTokenOnNetwork = r.NonFungibleTokenOfAccountOnNetwork = r.FungibleTokenOfAccountOnNetwork = r.ContractResultItem = r.ContractResults = r.ContractQueryResponse = r.TransactionStatus = r.TransactionReceipt = r.TransactionLogs = r.TransactionEventTopic = r.TransactionEvent = r.TransactionOnNetwork = r.AccountOnNetwork = r.ApiNetworkProvider = r.ProxyNetworkProvider = void 0;
  var e = proxyNetworkProvider;
  Object.defineProperty(r, "ProxyNetworkProvider", { enumerable: !0, get: function() {
    return e.ProxyNetworkProvider;
  } });
  var s = apiNetworkProvider;
  Object.defineProperty(r, "ApiNetworkProvider", { enumerable: !0, get: function() {
    return s.ApiNetworkProvider;
  } });
  var o = accounts;
  Object.defineProperty(r, "AccountOnNetwork", { enumerable: !0, get: function() {
    return o.AccountOnNetwork;
  } });
  var fe = transactions;
  Object.defineProperty(r, "TransactionOnNetwork", { enumerable: !0, get: function() {
    return fe.TransactionOnNetwork;
  } });
  var me = transactionEvents;
  Object.defineProperty(r, "TransactionEvent", { enumerable: !0, get: function() {
    return me.TransactionEvent;
  } }), Object.defineProperty(r, "TransactionEventTopic", { enumerable: !0, get: function() {
    return me.TransactionEventTopic;
  } });
  var ye = transactionLogs;
  Object.defineProperty(r, "TransactionLogs", { enumerable: !0, get: function() {
    return ye.TransactionLogs;
  } });
  var fr = transactionReceipt;
  Object.defineProperty(r, "TransactionReceipt", { enumerable: !0, get: function() {
    return fr.TransactionReceipt;
  } });
  var Er = transactionStatus;
  Object.defineProperty(r, "TransactionStatus", { enumerable: !0, get: function() {
    return Er.TransactionStatus;
  } });
  var br = contractQueryResponse;
  Object.defineProperty(r, "ContractQueryResponse", { enumerable: !0, get: function() {
    return br.ContractQueryResponse;
  } });
  var wr = contractResults;
  Object.defineProperty(r, "ContractResults", { enumerable: !0, get: function() {
    return wr.ContractResults;
  } }), Object.defineProperty(r, "ContractResultItem", { enumerable: !0, get: function() {
    return wr.ContractResultItem;
  } });
  var kr = tokens;
  Object.defineProperty(r, "FungibleTokenOfAccountOnNetwork", { enumerable: !0, get: function() {
    return kr.FungibleTokenOfAccountOnNetwork;
  } }), Object.defineProperty(r, "NonFungibleTokenOfAccountOnNetwork", { enumerable: !0, get: function() {
    return kr.NonFungibleTokenOfAccountOnNetwork;
  } });
  var Gr = tokenDefinitions;
  Object.defineProperty(r, "DefinitionOfFungibleTokenOnNetwork", { enumerable: !0, get: function() {
    return Gr.DefinitionOfFungibleTokenOnNetwork;
  } }), Object.defineProperty(r, "DefinitionOfTokenCollectionOnNetwork", { enumerable: !0, get: function() {
    return Gr.DefinitionOfTokenCollectionOnNetwork;
  } });
  var Vr = networkConfig;
  Object.defineProperty(r, "NetworkConfig", { enumerable: !0, get: function() {
    return Vr.NetworkConfig;
  } });
  var jr = networkGeneralStatistics;
  Object.defineProperty(r, "NetworkGeneralStatistics", { enumerable: !0, get: function() {
    return jr.NetworkGeneralStatistics;
  } });
  var Kr = networkStake;
  Object.defineProperty(r, "NetworkStake", { enumerable: !0, get: function() {
    return Kr.NetworkStake;
  } });
  var bn = networkStatus;
  Object.defineProperty(r, "NetworkStatus", { enumerable: !0, get: function() {
    return bn.NetworkStatus;
  } });
})(out$3);
const placeholderData = {
  from: "erd12dnfhej64s6c56ka369gkyj3hwv5ms0y5rxgsk2k7hkd2vuk7rvqxkalsa",
  to: "erd12dnfhej64s6c56ka369gkyj3hwv5ms0y5rxgsk2k7hkd2vuk7rvqxkalsa"
};
function calculateFeeLimit({
  minGasLimit: r = String(GAS_LIMIT),
  gasLimit: e,
  gasPrice: s,
  data: o,
  gasPerDataByte: fe,
  gasPriceModifier: me,
  defaultGasPrice: ye = String(GAS_PRICE),
  chainId: fr
}) {
  const Er = o || "", br = stringIsInteger(e) ? e : r, wr = stringIsFloat(s) ? s : ye, kr = new out$4.Transaction({
    nonce: 0,
    value: out$4.TokenPayment.egldFromAmount("0"),
    receiver: new out$4.Address(placeholderData.to),
    sender: new out$4.Address(placeholderData.to),
    gasPrice: parseInt(wr),
    gasLimit: parseInt(br),
    data: new out$4.TransactionPayload(Er.trim()),
    chainID: fr,
    version: new out$4.TransactionVersion(1)
  }), Gr = new out$3.NetworkConfig();
  Gr.MinGasLimit = parseInt(r), Gr.GasPerDataByte = parseInt(fe), Gr.GasPriceModifier = parseFloat(me);
  try {
    return kr.computeFee(Gr).toString(10);
  } catch {
    return ZERO;
  }
}
function calcTotalFee(r, e) {
  let s = new BigNumber$1(0);
  return r.forEach((o) => {
    const fe = calculateFeeLimit({
      gasPerDataByte: String(GAS_PER_DATA_BYTE),
      gasPriceModifier: String(GAS_PRICE_MODIFIER),
      minGasLimit: String(e),
      gasLimit: o.getGasLimit().valueOf().toString(),
      gasPrice: o.getGasPrice().valueOf().toString(),
      data: o.getData().toString(),
      chainId: o.getChainID().valueOf()
    });
    s = s.plus(new BigNumber$1(fe));
  }), s;
}
const pendingBatchTransactionsStates = [
  TransactionBatchStatusesEnum.sent
], successBatchTransactionsStates = [
  TransactionBatchStatusesEnum.success
], failBatchTransactionsStates = [
  TransactionBatchStatusesEnum.fail,
  TransactionBatchStatusesEnum.cancelled,
  TransactionBatchStatusesEnum.timedOut
], timedOutBatchTransactionsStates = [
  TransactionBatchStatusesEnum.timedOut
], pendingServerTransactionsStatuses = [
  TransactionServerStatusesEnum.pending
], successServerTransactionsStates = [
  TransactionServerStatusesEnum.success
], failServerTransactionsStates = [
  TransactionServerStatusesEnum.fail,
  TransactionServerStatusesEnum.invalid
];
function getIsTransactionPending(r) {
  return r != null && (isBatchTransactionPending(r) || isServerTransactionPending(r));
}
function getIsTransactionSuccessful(r) {
  return r != null && (isBatchTransactionSuccessful(r) || isServerTransactionSuccessful(r));
}
function getIsTransactionFailed(r) {
  return r != null && (isBatchTransactionFailed(r) || isServerTransactionFailed(r));
}
function getIsTransactionTimedOut(r) {
  return r != null && isBatchTransactionTimedOut(r);
}
function isBatchTransactionPending(r) {
  return r != null && pendingBatchTransactionsStates.includes(r);
}
function isBatchTransactionSuccessful(r) {
  return r != null && successBatchTransactionsStates.includes(r);
}
function isBatchTransactionFailed(r) {
  return r != null && failBatchTransactionsStates.includes(r);
}
function isBatchTransactionTimedOut(r) {
  return r != null && timedOutBatchTransactionsStates.includes(r);
}
function isServerTransactionPending(r) {
  return r != null && pendingServerTransactionsStatuses.includes(r);
}
function isServerTransactionSuccessful(r) {
  return r != null && successServerTransactionsStates.includes(r);
}
function isServerTransactionFailed(r) {
  return r != null && failServerTransactionsStates.includes(r);
}
function isStringBase64(r) {
  try {
    return Buffer.from(r, "base64").toString() === atob(r);
  } catch {
    return !1;
  }
}
function decodeBase64(r) {
  return atob(r);
}
const getDataPayloadForTransaction = (r) => {
  const e = r != null ? r : "";
  return isStringBase64(e) ? out$4.TransactionPayload.fromEncoded(e) : new out$4.TransactionPayload(e);
};
function newTransaction(r) {
  var s, o, fe;
  const e = new out$4.Transaction({
    value: r.value.valueOf(),
    data: getDataPayloadForTransaction(r.data),
    nonce: r.nonce.valueOf(),
    receiver: new out$4.Address(r.receiver),
    ...r.receiverUsername ? { receiverUsername: r.receiverUsername } : {},
    sender: new out$4.Address(r.sender),
    ...r.senderUsername ? { senderUsername: r.senderUsername } : {},
    gasLimit: (s = r.gasLimit.valueOf()) != null ? s : GAS_LIMIT,
    gasPrice: (o = r.gasPrice.valueOf()) != null ? o : GAS_PRICE,
    chainID: r.chainID.valueOf(),
    version: new out$4.TransactionVersion((fe = r.version) != null ? fe : VERSION$2),
    ...r.options ? { options: new out$4.TransactionOptions(r.options) } : {},
    ...r.guardian ? { guardian: new out$4.Address(r.guardian) } : {}
  });
  return r.guardianSignature && e.applyGuardianSignature(
    Buffer.from(r.guardianSignature, "hex")
  ), r.signature && e.applySignature(Buffer.from(r.signature, "hex")), e;
}
const initialState$5 = {
  signedTransactions: {},
  transactionsToSign: null,
  signTransactionsError: null,
  signTransactionsCancelMessage: null,
  customTransactionInformationForSessionId: {}
}, defaultCustomInformation = {
  signWithoutSending: !1,
  sessionInformation: null,
  redirectAfterSign: !1
}, selectTxByStatus = (r, e) => Object.entries(e).reduce((s, [o, fe]) => (r(fe.status) && (s[o] = fe), s), {}), useTransactionsStore = defineStore("erdjs-transactions", {
  state: () => ({ ...initialState$5 }),
  persist: !0,
  getters: {
    getTransactionsToSign: (r) => {
      var e;
      return (r == null ? void 0 : r.transactionsToSign) == null ? null : {
        ...r.transactionsToSign,
        transactions: ((e = r == null ? void 0 : r.transactionsToSign) == null ? void 0 : e.transactions.map(
          (s) => newTransaction(s)
        )) || []
      };
    },
    getSignedTransactions: (r) => r.signedTransactions,
    getPendingSignedTransactions: (r) => selectTxByStatus(getIsTransactionPending, r == null ? void 0 : r.signedTransactions),
    getFailedTransactions: (r) => selectTxByStatus(getIsTransactionFailed, r.signedTransactions),
    getSuccessfulTransactions: (r) => selectTxByStatus(getIsTransactionSuccessful, r.signedTransactions),
    getTimedOutTransactions: (r) => selectTxByStatus(getIsTransactionTimedOut, r.signedTransactions),
    getSignTransactionsError: (r) => r.signTransactionsError,
    getSignTransactionsCancelMessage: (r) => r.signTransactionsCancelMessage,
    getTransaction: (r) => (e) => {
      var s;
      return e != null ? ((s = r.signedTransactions) == null ? void 0 : s[e]) || {} : {};
    },
    getTransactionStatus: (r) => (e) => {
      var s, o;
      return e != null && ((s = r.signedTransactions) == null ? void 0 : s[e]) ? ((o = r.signedTransactions) == null ? void 0 : o[e].status) || {} : {};
    }
  },
  actions: {
    moveTransactionsToSignedState(r) {
      var fr, Er;
      const {
        sessionId: e,
        transactions: s,
        errorMessage: o,
        status: fe,
        redirectRoute: me
      } = r, ye = ((fr = this.customTransactionInformationForSessionId) == null ? void 0 : fr[e]) || defaultCustomInformation;
      this.signedTransactions[e] = {
        transactions: s,
        status: fe,
        errorMessage: o,
        redirectRoute: me,
        customTransactionInformation: ye
      }, ((Er = this == null ? void 0 : this.transactionsToSign) == null ? void 0 : Er.sessionId) === e && (this.transactionsToSign = initialState$5.transactionsToSign);
    },
    clearSignedTransaction(r) {
      delete this.signedTransactions[r];
    },
    clearTransactionToSign() {
      this != null && this.transactionsToSign && (this.transactionsToSign = null);
    },
    updateSignedTransaction(r) {
      const { sessionId: e, status: s, errorMessage: o, transactions: fe } = r;
      this.signedTransactions[e] != null && (this.signedTransactions[e].status = s, o != null && (this.signedTransactions[e].errorMessage = o), fe != null && (this.signedTransactions[e].transactions = fe));
    },
    updateSignedTransactions(r) {
      const { sessionId: e, status: s, errorMessage: o, transactions: fe } = r;
      this.signedTransactions[e] != null && (this.signedTransactions[e].status = s, o != null && (this.signedTransactions[e].errorMessage = o), fe != null && (this.signedTransactions[e].transactions = fe));
    },
    updateSignedTransactionStatus(r) {
      var ye, fr, Er, br, wr, kr;
      const {
        sessionId: e,
        status: s,
        errorMessage: o,
        transactionHash: fe
      } = r, me = (fr = (ye = this.signedTransactions) == null ? void 0 : ye[e]) == null ? void 0 : fr.transactions;
      if (me != null) {
        this.signedTransactions[e].transactions = me.map(
          (jr) => jr.hash === fe ? {
            ...jr,
            status: s,
            errorMessage: o
          } : jr
        );
        const Gr = (br = (Er = this.signedTransactions[e]) == null ? void 0 : Er.transactions) == null ? void 0 : br.every((jr) => getIsTransactionSuccessful(jr.status)), Vr = (kr = (wr = this.signedTransactions[e]) == null ? void 0 : wr.transactions) == null ? void 0 : kr.every(
          (jr) => getIsTransactionFailed(jr.status)
        );
        Gr && (this.signedTransactions[e].status = TransactionBatchStatusesEnum.success), Vr && (this.signedTransactions[e].status = TransactionBatchStatusesEnum.fail);
      }
    },
    setTransactionsToSign(r) {
      this.transactionsToSign = r;
      const { sessionId: e, customTransactionInformation: s } = r;
      this.customTransactionInformationForSessionId[e] = s, this.signTransactionsError = null;
    },
    clearAllTransactionsToSign() {
      this.transactionsToSign = initialState$5.transactionsToSign, this.signTransactionsError = null;
    },
    clearAllSignedTransactions() {
      this.transactionsToSign = initialState$5.transactionsToSign, this.signTransactionsError = null;
    },
    setSignTransactionsError(r) {
      this.signTransactionsError = r;
    },
    setSignTransactionsCancelMessage(r) {
      this.signTransactionsCancelMessage = r;
    }
  }
}), defaultTransactionErrorMessage = "Transaction failed", defaultTransactionSuccessMessage = "Transaction successful", defaultTransactionProcessingMessage = "Processing transaction", defaultTransactionSubmittedMessage = "Transaction submitted", defaultTransactionInfo = {
  errorMessage: defaultTransactionErrorMessage,
  successMessage: defaultTransactionSuccessMessage,
  processingMessage: defaultTransactionProcessingMessage
}, initialState$4 = {
  0: defaultTransactionInfo
}, useTransactionsInfoStore = defineStore("erdjs-transactions-info", {
  state: () => ({ ...initialState$4 }),
  persist: !1,
  getters: {
    getTransactionDisplayInfo: (r) => (e) => e != null && (r == null ? void 0 : r[e]) || defaultTransactionInfo
  },
  actions: {
    setTransactionsDisplayInfo(r) {
      const { sessionId: e, transactionsDisplayInfo: s } = r;
      e != null && (this[e] = {
        errorMessage: (s == null ? void 0 : s.errorMessage) || defaultTransactionErrorMessage,
        successMessage: (s == null ? void 0 : s.successMessage) || defaultTransactionSuccessMessage,
        processingMessage: (s == null ? void 0 : s.processingMessage) || defaultTransactionProcessingMessage,
        submittedMessage: (s == null ? void 0 : s.submittedMessage) || defaultTransactionSubmittedMessage,
        transactionDuration: s == null ? void 0 : s.transactionDuration
      });
    },
    clearTransactionsInfoForSessionId(r) {
      r != null && delete this[r];
    },
    clearTransactionsInfo() {
      this.$reset();
    }
  }
}), ACCOUNTS_ENDPOINT = "accounts", TRANSACTIONS_ENDPOINT = "transactions", TOKENS_ENDPOINT = "tokens", BLOCKS_ENDPOINT = "blocks", NODES_ENDPOINT = "nodes", IDENTITIES_ENDPOINT = "identities", COLLECTIONS_ENDPOINT = "collections", NFTS_ENDPOINT = "nfts", PROVIDERS_ENDPOINT = "providers", SC_RESULTS_ENDPOINT = "sc-results", CONTRACTS_ENDPOINT = "contracts", LOGS_ENDPOINT = "logs", CODE_ENDPOINT = "code", LOCKED_ACCOUNTS_ENDPOINT = "locked-accounts", ROLES_ENDPOINT = "roles", getCleanApiAddress = (r) => {
  const e = r != null ? r : useDappStore().getApiAddress;
  return e.endsWith("/") ? e.slice(0, -1) : e;
};
var out$2 = {}, extensionProvider = {}, errors$3 = {};
Object.defineProperty(errors$3, "__esModule", { value: !0 });
errors$3.ErrAccountNotConnected = errors$3.ErrCannotSignSingleTransaction = errors$3.Err = void 0;
class Err extends Error {
  constructor(e, s) {
    super(e), this.inner = void 0, this.inner = s;
  }
}
errors$3.Err = Err;
class ErrCannotSignSingleTransaction extends Err {
  constructor() {
    super("Cannot sign single transaction.");
  }
}
errors$3.ErrCannotSignSingleTransaction = ErrCannotSignSingleTransaction;
class ErrAccountNotConnected extends Err {
  constructor() {
    super("Account is not connected.");
  }
}
errors$3.ErrAccountNotConnected = ErrAccountNotConnected;
var operation$1 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Operation = void 0, function(e) {
    e.Connect = "connect", e.Logout = "logout", e.SignTransactions = "signTransactions", e.SignMessage = "signMessage", e.CancelAction = "cancelAction";
  }(r.Operation || (r.Operation = {}));
})(operation$1);
var __awaiter$c = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
Object.defineProperty(extensionProvider, "__esModule", { value: !0 });
extensionProvider.ExtensionProvider = void 0;
const transaction_1 = transaction, errors_1$3 = errors$3, operation_1$2 = operation$1;
class ExtensionProvider {
  constructor() {
    if (this.account = { address: "" }, this.initialized = !1, ExtensionProvider._instance)
      throw new Error("Error: Instantiation failed: Use ExtensionProvider.getInstance() instead of new.");
    ExtensionProvider._instance = this;
  }
  static getInstance() {
    return ExtensionProvider._instance;
  }
  setAddress(e) {
    return this.account.address = e, ExtensionProvider._instance;
  }
  init() {
    return __awaiter$c(this, void 0, void 0, function* () {
      return window && window.elrondWallet && (this.initialized = !0), this.initialized;
    });
  }
  login(e = {}) {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (!this.initialized)
        throw new Error("Extension provider is not initialised, call init() first");
      const { token: s } = e, o = s || "";
      return yield this.startBgrMsgChannel(operation_1$2.Operation.Connect, o), this.account.address;
    });
  }
  logout() {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (!this.initialized)
        throw new Error("Extension provider is not initialised, call init() first");
      try {
        yield this.startBgrMsgChannel(operation_1$2.Operation.Logout, this.account.address), this.disconnect();
      } catch (e) {
        console.warn("Extension origin url is already cleared!", e);
      }
      return !0;
    });
  }
  disconnect() {
    this.account = { address: "" };
  }
  getAddress() {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (!this.initialized)
        throw new Error("Extension provider is not initialised, call init() first");
      return this.account ? this.account.address : "";
    });
  }
  isInitialized() {
    return this.initialized;
  }
  isConnected() {
    return __awaiter$c(this, void 0, void 0, function* () {
      return Boolean(this.account.address);
    });
  }
  signTransaction(e) {
    return __awaiter$c(this, void 0, void 0, function* () {
      this.ensureConnected();
      const s = yield this.signTransactions([e]);
      if (s.length != 1)
        throw new errors_1$3.ErrCannotSignSingleTransaction();
      return s[0];
    });
  }
  ensureConnected() {
    if (!this.account.address)
      throw new errors_1$3.ErrAccountNotConnected();
  }
  signTransactions(e) {
    return __awaiter$c(this, void 0, void 0, function* () {
      this.ensureConnected();
      const s = yield this.startBgrMsgChannel(operation_1$2.Operation.SignTransactions, {
        from: this.account.address,
        transactions: e.map((o) => o.toPlainObject())
      });
      try {
        return s.map((fe) => transaction_1.Transaction.fromPlainObject(fe));
      } catch (o) {
        throw new Error(`Transaction canceled: ${o.message}.`);
      }
    });
  }
  signMessage(e) {
    return __awaiter$c(this, void 0, void 0, function* () {
      this.ensureConnected();
      const s = {
        account: this.account.address,
        message: e.message.toString()
      }, fe = (yield this.startBgrMsgChannel(operation_1$2.Operation.SignMessage, s)).signature, me = Buffer.from(fe, "hex");
      return e.applySignature(me), e;
    });
  }
  cancelAction() {
    return this.startBgrMsgChannel(operation_1$2.Operation.CancelAction, {});
  }
  startBgrMsgChannel(e, s) {
    return new Promise((o) => {
      window.postMessage({
        target: "erdw-inpage",
        type: e,
        data: s
      }, window.origin);
      const fe = (me) => {
        me.isTrusted && me.data.target === "erdw-contentScript" && (me.data.type === "connectResponse" ? (me.data.data && Boolean(me.data.data.address) && (this.account = me.data.data), window.removeEventListener("message", fe), o(me.data.data)) : (window.removeEventListener("message", fe), o(me.data.data)));
      };
      window.addEventListener("message", fe, !1);
    });
  }
}
extensionProvider.ExtensionProvider = ExtensionProvider;
ExtensionProvider._instance = new ExtensionProvider();
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(extensionProvider, r);
})(out$2);
var out$1 = {};
globalThis.Buffer || (globalThis.Buffer = requireBuffer().Buffer);
var hwProvider = {};
const createCustomErrorClass$1 = (r) => {
  class e extends Error {
    constructor(o, fe, me) {
      if (super(o || r, me), Object.setPrototypeOf(this, e.prototype), this.name = r, fe)
        for (const ye in fe)
          this[ye] = fe[ye];
      if (me && isObject$2(me) && "cause" in me && !("cause" in this)) {
        const ye = me.cause;
        this.cause = ye, "stack" in ye && (this.stack = this.stack + `
CAUSE: ` + ye.stack);
      }
    }
  }
  return e;
};
function isObject$2(r) {
  return typeof r == "object";
}
const LockedDeviceError$1 = createCustomErrorClass$1("LockedDeviceError"), DisconnectedDevice$1 = createCustomErrorClass$1("DisconnectedDevice"), TransportOpenUserCancelled$1 = createCustomErrorClass$1("TransportOpenUserCancelled"), TransportRaceCondition$1 = createCustomErrorClass$1("TransportRaceCondition");
var HwTransportErrorType$1;
(function(r) {
  r.Unknown = "Unknown", r.LocationServicesDisabled = "LocationServicesDisabled", r.LocationServicesUnauthorized = "LocationServicesUnauthorized", r.BluetoothScanStartFailed = "BluetoothScanStartFailed";
})(HwTransportErrorType$1 || (HwTransportErrorType$1 = {}));
class TransportError$2 extends Error {
  constructor(e, s) {
    const o = "TransportError";
    super(e || o), this.name = o, this.message = e, this.stack = new Error(e).stack, this.id = s;
  }
}
const StatusCodes$1 = {
  ACCESS_CONDITION_NOT_FULFILLED: 38916,
  ALGORITHM_NOT_SUPPORTED: 38020,
  CLA_NOT_SUPPORTED: 28160,
  CODE_BLOCKED: 38976,
  CODE_NOT_INITIALIZED: 38914,
  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 27009,
  CONDITIONS_OF_USE_NOT_SATISFIED: 27013,
  CONTRADICTION_INVALIDATION: 38928,
  CONTRADICTION_SECRET_CODE_STATUS: 38920,
  CUSTOM_IMAGE_BOOTLOADER: 26159,
  CUSTOM_IMAGE_EMPTY: 26158,
  FILE_ALREADY_EXISTS: 27273,
  FILE_NOT_FOUND: 37892,
  GP_AUTH_FAILED: 25344,
  HALTED: 28586,
  INCONSISTENT_FILE: 37896,
  INCORRECT_DATA: 27264,
  INCORRECT_LENGTH: 26368,
  INCORRECT_P1_P2: 27392,
  INS_NOT_SUPPORTED: 27904,
  DEVICE_NOT_ONBOARDED: 27911,
  DEVICE_NOT_ONBOARDED_2: 26129,
  INVALID_KCV: 38021,
  INVALID_OFFSET: 37890,
  LICENSING: 28482,
  LOCKED_DEVICE: 21781,
  MAX_VALUE_REACHED: 38992,
  MEMORY_PROBLEM: 37440,
  MISSING_CRITICAL_PARAMETER: 26624,
  NO_EF_SELECTED: 37888,
  NOT_ENOUGH_MEMORY_SPACE: 27268,
  OK: 36864,
  PIN_REMAINING_ATTEMPTS: 25536,
  REFERENCED_DATA_NOT_FOUND: 27272,
  SECURITY_STATUS_NOT_SATISFIED: 27010,
  TECHNICAL_PROBLEM: 28416,
  UNKNOWN_APDU: 27906,
  USER_REFUSED_ON_DEVICE: 21761,
  NOT_ENOUGH_SPACE: 20738
};
function getAltStatusMessage$1(r) {
  switch (r) {
    case 26368:
      return "Incorrect length";
    case 26624:
      return "Missing critical parameter";
    case 27010:
      return "Security not satisfied (dongle locked or have invalid access rights)";
    case 27013:
      return "Condition of use not satisfied (denied by the user?)";
    case 27264:
      return "Invalid data received";
    case 27392:
      return "Invalid parameter received";
    case 21781:
      return "Locked device";
  }
  if (28416 <= r && r <= 28671)
    return "Internal error, please report";
}
function TransportStatusError$1(r) {
  const e = Object.keys(StatusCodes$1).find((me) => StatusCodes$1[me] === r) || "UNKNOWN_ERROR", s = getAltStatusMessage$1(r) || e, o = r.toString(16), fe = `Ledger device: ${s} (0x${o})`;
  if (r === StatusCodes$1.LOCKED_DEVICE)
    throw new LockedDeviceError$1(fe);
  this.name = "TransportStatusError", this.message = fe, this.stack = new Error(fe).stack, this.statusCode = r, this.statusText = e;
}
TransportStatusError$1.prototype = new Error();
var __awaiter$b = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
class Transport$2 {
  constructor() {
    this.exchangeTimeout = 3e4, this.unresponsiveTimeout = 15e3, this.deviceModel = null, this._events = new events.exports(), this.send = (e, s, o, fe, me = Buffer.alloc(0), ye = [StatusCodes$1.OK]) => __awaiter$b(this, void 0, void 0, function* () {
      if (me.length >= 256)
        throw new TransportError$2("data.length exceed 256 bytes limit. Got: " + me.length, "DataLengthTooBig");
      const fr = yield this.exchange(Buffer.concat([Buffer.from([e, s, o, fe]), Buffer.from([me.length]), me])), Er = fr.readUInt16BE(fr.length - 2);
      if (!ye.some((br) => br === Er))
        throw new TransportStatusError$1(Er);
      return fr;
    }), this.exchangeAtomicImpl = (e) => __awaiter$b(this, void 0, void 0, function* () {
      if (this.exchangeBusyPromise)
        throw new TransportRaceCondition$1("An action was already pending on the Ledger device. Please deny or reconnect.");
      let s;
      const o = new Promise((ye) => {
        s = ye;
      });
      this.exchangeBusyPromise = o;
      let fe = !1;
      const me = setTimeout(() => {
        fe = !0, this.emit("unresponsive");
      }, this.unresponsiveTimeout);
      try {
        const ye = yield e();
        return fe && this.emit("responsive"), ye;
      } finally {
        clearTimeout(me), s && s(), this.exchangeBusyPromise = null;
      }
    }), this._appAPIlock = null;
  }
  exchange(e) {
    throw new Error("exchange not implemented");
  }
  exchangeBulk(e, s) {
    let o = !1;
    const fe = () => {
      o = !0;
    };
    return (() => __awaiter$b(this, void 0, void 0, function* () {
      if (!o)
        for (const ye of e) {
          const fr = yield this.exchange(ye);
          if (o)
            return;
          const Er = fr.readUInt16BE(fr.length - 2);
          if (Er !== StatusCodes$1.OK)
            throw new TransportStatusError$1(Er);
          s.next(fr);
        }
    }))().then(() => !o && s.complete(), (ye) => !o && s.error(ye)), { unsubscribe: fe };
  }
  setScrambleKey(e) {
  }
  close() {
    return Promise.resolve();
  }
  on(e, s) {
    this._events.on(e, s);
  }
  off(e, s) {
    this._events.removeListener(e, s);
  }
  emit(e, ...s) {
    this._events.emit(e, ...s);
  }
  setDebugMode() {
    console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
  }
  setExchangeTimeout(e) {
    this.exchangeTimeout = e;
  }
  setExchangeUnresponsiveTimeout(e) {
    this.unresponsiveTimeout = e;
  }
  static create(e = 3e3, s) {
    return new Promise((o, fe) => {
      let me = !1;
      const ye = this.listen({
        next: (Er) => {
          me = !0, ye && ye.unsubscribe(), fr && clearTimeout(fr), this.open(Er.descriptor, e).then(o, fe);
        },
        error: (Er) => {
          fr && clearTimeout(fr), fe(Er);
        },
        complete: () => {
          fr && clearTimeout(fr), me || fe(new TransportError$2(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
        }
      }), fr = s ? setTimeout(() => {
        ye.unsubscribe(), fe(new TransportError$2(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
      }, s) : null;
    });
  }
  decorateAppAPIMethods(e, s, o) {
    for (const fe of s)
      e[fe] = this.decorateAppAPIMethod(fe, e[fe], e, o);
  }
  decorateAppAPIMethod(e, s, o, fe) {
    return (...me) => __awaiter$b(this, void 0, void 0, function* () {
      const { _appAPIlock: ye } = this;
      if (ye)
        return Promise.reject(new TransportError$2("Ledger Device is busy (lock " + ye + ")", "TransportLocked"));
      try {
        return this._appAPIlock = e, this.setScrambleKey(fe), yield s.apply(o, me);
      } finally {
        this._appAPIlock = null;
      }
    });
  }
}
Transport$2.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
Transport$2.ErrorMessage_NoDeviceFound = "No Ledger device found";
var re$7 = { exports: {} };
const SEMVER_SPEC_VERSION$1 = "2.0.0", MAX_LENGTH$3 = 256, MAX_SAFE_INTEGER$3 = Number.MAX_SAFE_INTEGER || 9007199254740991, MAX_SAFE_COMPONENT_LENGTH$1 = 16, MAX_SAFE_BUILD_LENGTH$1 = MAX_LENGTH$3 - 6, RELEASE_TYPES$1 = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$9 = {
  MAX_LENGTH: MAX_LENGTH$3,
  MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH$1,
  MAX_SAFE_BUILD_LENGTH: MAX_SAFE_BUILD_LENGTH$1,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$3,
  RELEASE_TYPES: RELEASE_TYPES$1,
  SEMVER_SPEC_VERSION: SEMVER_SPEC_VERSION$1,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$3 = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...r) => console.error("SEMVER", ...r) : () => {
};
var debug_1$1 = debug$3;
(function(r, e) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: s,
    MAX_SAFE_BUILD_LENGTH: o,
    MAX_LENGTH: fe
  } = constants$9, me = debug_1$1;
  e = r.exports = {};
  const ye = e.re = [], fr = e.safeRe = [], Er = e.src = [], br = e.t = {};
  let wr = 0;
  const kr = "[a-zA-Z0-9-]", Gr = [
    ["\\s", 1],
    ["\\d", fe],
    [kr, o]
  ], Vr = (Kr) => {
    for (const [bn, Yr] of Gr)
      Kr = Kr.split(`${bn}*`).join(`${bn}{0,${Yr}}`).split(`${bn}+`).join(`${bn}{1,${Yr}}`);
    return Kr;
  }, jr = (Kr, bn, Yr) => {
    const Zr = Vr(bn), ti = wr++;
    me(Kr, ti, bn), br[Kr] = ti, Er[ti] = bn, ye[ti] = new RegExp(bn, Yr ? "g" : void 0), fr[ti] = new RegExp(Zr, Yr ? "g" : void 0);
  };
  jr("NUMERICIDENTIFIER", "0|[1-9]\\d*"), jr("NUMERICIDENTIFIERLOOSE", "\\d+"), jr("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${kr}*`), jr("MAINVERSION", `(${Er[br.NUMERICIDENTIFIER]})\\.(${Er[br.NUMERICIDENTIFIER]})\\.(${Er[br.NUMERICIDENTIFIER]})`), jr("MAINVERSIONLOOSE", `(${Er[br.NUMERICIDENTIFIERLOOSE]})\\.(${Er[br.NUMERICIDENTIFIERLOOSE]})\\.(${Er[br.NUMERICIDENTIFIERLOOSE]})`), jr("PRERELEASEIDENTIFIER", `(?:${Er[br.NUMERICIDENTIFIER]}|${Er[br.NONNUMERICIDENTIFIER]})`), jr("PRERELEASEIDENTIFIERLOOSE", `(?:${Er[br.NUMERICIDENTIFIERLOOSE]}|${Er[br.NONNUMERICIDENTIFIER]})`), jr("PRERELEASE", `(?:-(${Er[br.PRERELEASEIDENTIFIER]}(?:\\.${Er[br.PRERELEASEIDENTIFIER]})*))`), jr("PRERELEASELOOSE", `(?:-?(${Er[br.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${Er[br.PRERELEASEIDENTIFIERLOOSE]})*))`), jr("BUILDIDENTIFIER", `${kr}+`), jr("BUILD", `(?:\\+(${Er[br.BUILDIDENTIFIER]}(?:\\.${Er[br.BUILDIDENTIFIER]})*))`), jr("FULLPLAIN", `v?${Er[br.MAINVERSION]}${Er[br.PRERELEASE]}?${Er[br.BUILD]}?`), jr("FULL", `^${Er[br.FULLPLAIN]}$`), jr("LOOSEPLAIN", `[v=\\s]*${Er[br.MAINVERSIONLOOSE]}${Er[br.PRERELEASELOOSE]}?${Er[br.BUILD]}?`), jr("LOOSE", `^${Er[br.LOOSEPLAIN]}$`), jr("GTLT", "((?:<|>)?=?)"), jr("XRANGEIDENTIFIERLOOSE", `${Er[br.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), jr("XRANGEIDENTIFIER", `${Er[br.NUMERICIDENTIFIER]}|x|X|\\*`), jr("XRANGEPLAIN", `[v=\\s]*(${Er[br.XRANGEIDENTIFIER]})(?:\\.(${Er[br.XRANGEIDENTIFIER]})(?:\\.(${Er[br.XRANGEIDENTIFIER]})(?:${Er[br.PRERELEASE]})?${Er[br.BUILD]}?)?)?`), jr("XRANGEPLAINLOOSE", `[v=\\s]*(${Er[br.XRANGEIDENTIFIERLOOSE]})(?:\\.(${Er[br.XRANGEIDENTIFIERLOOSE]})(?:\\.(${Er[br.XRANGEIDENTIFIERLOOSE]})(?:${Er[br.PRERELEASELOOSE]})?${Er[br.BUILD]}?)?)?`), jr("XRANGE", `^${Er[br.GTLT]}\\s*${Er[br.XRANGEPLAIN]}$`), jr("XRANGELOOSE", `^${Er[br.GTLT]}\\s*${Er[br.XRANGEPLAINLOOSE]}$`), jr("COERCE", `(^|[^\\d])(\\d{1,${s}})(?:\\.(\\d{1,${s}}))?(?:\\.(\\d{1,${s}}))?(?:$|[^\\d])`), jr("COERCERTL", Er[br.COERCE], !0), jr("LONETILDE", "(?:~>?)"), jr("TILDETRIM", `(\\s*)${Er[br.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", jr("TILDE", `^${Er[br.LONETILDE]}${Er[br.XRANGEPLAIN]}$`), jr("TILDELOOSE", `^${Er[br.LONETILDE]}${Er[br.XRANGEPLAINLOOSE]}$`), jr("LONECARET", "(?:\\^)"), jr("CARETTRIM", `(\\s*)${Er[br.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", jr("CARET", `^${Er[br.LONECARET]}${Er[br.XRANGEPLAIN]}$`), jr("CARETLOOSE", `^${Er[br.LONECARET]}${Er[br.XRANGEPLAINLOOSE]}$`), jr("COMPARATORLOOSE", `^${Er[br.GTLT]}\\s*(${Er[br.LOOSEPLAIN]})$|^$`), jr("COMPARATOR", `^${Er[br.GTLT]}\\s*(${Er[br.FULLPLAIN]})$|^$`), jr("COMPARATORTRIM", `(\\s*)${Er[br.GTLT]}\\s*(${Er[br.LOOSEPLAIN]}|${Er[br.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", jr("HYPHENRANGE", `^\\s*(${Er[br.XRANGEPLAIN]})\\s+-\\s+(${Er[br.XRANGEPLAIN]})\\s*$`), jr("HYPHENRANGELOOSE", `^\\s*(${Er[br.XRANGEPLAINLOOSE]})\\s+-\\s+(${Er[br.XRANGEPLAINLOOSE]})\\s*$`), jr("STAR", "(<|>)?=?\\s*\\*"), jr("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), jr("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$7, re$7.exports);
const looseOption$1 = Object.freeze({ loose: !0 }), emptyOpts$1 = Object.freeze({}), parseOptions$3 = (r) => r ? typeof r != "object" ? looseOption$1 : r : emptyOpts$1;
var parseOptions_1$1 = parseOptions$3;
const numeric$2 = /^[0-9]+$/, compareIdentifiers$3 = (r, e) => {
  const s = numeric$2.test(r), o = numeric$2.test(e);
  return s && o && (r = +r, e = +e), r === e ? 0 : s && !o ? -1 : o && !s ? 1 : r < e ? -1 : 1;
}, rcompareIdentifiers$1 = (r, e) => compareIdentifiers$3(e, r);
var identifiers$3 = {
  compareIdentifiers: compareIdentifiers$3,
  rcompareIdentifiers: rcompareIdentifiers$1
};
const debug$2 = debug_1$1, { MAX_LENGTH: MAX_LENGTH$2, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$2 } = constants$9, { safeRe: re$6, t: t$3 } = re$7.exports, parseOptions$2 = parseOptions_1$1, { compareIdentifiers: compareIdentifiers$2 } = identifiers$3;
class SemVer$r {
  constructor(e, s) {
    if (s = parseOptions$2(s), e instanceof SemVer$r) {
      if (e.loose === !!s.loose && e.includePrerelease === !!s.includePrerelease)
        return e;
      e = e.version;
    } else if (typeof e != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof e}".`);
    if (e.length > MAX_LENGTH$2)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH$2} characters`
      );
    debug$2("SemVer", e, s), this.options = s, this.loose = !!s.loose, this.includePrerelease = !!s.includePrerelease;
    const o = e.trim().match(s.loose ? re$6[t$3.LOOSE] : re$6[t$3.FULL]);
    if (!o)
      throw new TypeError(`Invalid Version: ${e}`);
    if (this.raw = e, this.major = +o[1], this.minor = +o[2], this.patch = +o[3], this.major > MAX_SAFE_INTEGER$2 || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER$2 || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER$2 || this.patch < 0)
      throw new TypeError("Invalid patch version");
    o[4] ? this.prerelease = o[4].split(".").map((fe) => {
      if (/^[0-9]+$/.test(fe)) {
        const me = +fe;
        if (me >= 0 && me < MAX_SAFE_INTEGER$2)
          return me;
      }
      return fe;
    }) : this.prerelease = [], this.build = o[5] ? o[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(e) {
    if (debug$2("SemVer.compare", this.version, this.options, e), !(e instanceof SemVer$r)) {
      if (typeof e == "string" && e === this.version)
        return 0;
      e = new SemVer$r(e, this.options);
    }
    return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
  }
  compareMain(e) {
    return e instanceof SemVer$r || (e = new SemVer$r(e, this.options)), compareIdentifiers$2(this.major, e.major) || compareIdentifiers$2(this.minor, e.minor) || compareIdentifiers$2(this.patch, e.patch);
  }
  comparePre(e) {
    if (e instanceof SemVer$r || (e = new SemVer$r(e, this.options)), this.prerelease.length && !e.prerelease.length)
      return -1;
    if (!this.prerelease.length && e.prerelease.length)
      return 1;
    if (!this.prerelease.length && !e.prerelease.length)
      return 0;
    let s = 0;
    do {
      const o = this.prerelease[s], fe = e.prerelease[s];
      if (debug$2("prerelease compare", s, o, fe), o === void 0 && fe === void 0)
        return 0;
      if (fe === void 0)
        return 1;
      if (o === void 0)
        return -1;
      if (o === fe)
        continue;
      return compareIdentifiers$2(o, fe);
    } while (++s);
  }
  compareBuild(e) {
    e instanceof SemVer$r || (e = new SemVer$r(e, this.options));
    let s = 0;
    do {
      const o = this.build[s], fe = e.build[s];
      if (debug$2("prerelease compare", s, o, fe), o === void 0 && fe === void 0)
        return 0;
      if (fe === void 0)
        return 1;
      if (o === void 0)
        return -1;
      if (o === fe)
        continue;
      return compareIdentifiers$2(o, fe);
    } while (++s);
  }
  inc(e, s, o) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", s, o);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", s, o);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", s, o), this.inc("pre", s, o);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", s, o), this.inc("pre", s, o);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const fe = Number(o) ? 1 : 0;
        if (!s && o === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [fe];
        else {
          let me = this.prerelease.length;
          for (; --me >= 0; )
            typeof this.prerelease[me] == "number" && (this.prerelease[me]++, me = -2);
          if (me === -1) {
            if (s === this.prerelease.join(".") && o === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(fe);
          }
        }
        if (s) {
          let me = [s, fe];
          o === !1 && (me = [s]), compareIdentifiers$2(this.prerelease[0], s) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = me) : this.prerelease = me;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${e}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
}
var semver$3 = SemVer$r;
const SemVer$q = semver$3, parse$g = (r, e, s = !1) => {
  if (r instanceof SemVer$q)
    return r;
  try {
    return new SemVer$q(r, e);
  } catch (o) {
    if (!s)
      return null;
    throw o;
  }
};
var parse_1$1 = parse$g;
const parse$f = parse_1$1, valid$5 = (r, e) => {
  const s = parse$f(r, e);
  return s ? s.version : null;
};
var valid_1$1 = valid$5;
const parse$e = parse_1$1, clean$3 = (r, e) => {
  const s = parse$e(r.trim().replace(/^[=v]+/, ""), e);
  return s ? s.version : null;
};
var clean_1$1 = clean$3;
const SemVer$p = semver$3, inc$3 = (r, e, s, o, fe) => {
  typeof s == "string" && (fe = o, o = s, s = void 0);
  try {
    return new SemVer$p(
      r instanceof SemVer$p ? r.version : r,
      s
    ).inc(e, o, fe).version;
  } catch {
    return null;
  }
};
var inc_1$1 = inc$3;
const parse$d = parse_1$1, diff$3 = (r, e) => {
  const s = parse$d(r, null, !0), o = parse$d(e, null, !0), fe = s.compare(o);
  if (fe === 0)
    return null;
  const me = fe > 0, ye = me ? s : o, fr = me ? o : s, Er = !!ye.prerelease.length;
  if (!!fr.prerelease.length && !Er)
    return !fr.patch && !fr.minor ? "major" : ye.patch ? "patch" : ye.minor ? "minor" : "major";
  const wr = Er ? "pre" : "";
  return s.major !== o.major ? wr + "major" : s.minor !== o.minor ? wr + "minor" : s.patch !== o.patch ? wr + "patch" : "prerelease";
};
var diff_1$1 = diff$3;
const SemVer$o = semver$3, major$3 = (r, e) => new SemVer$o(r, e).major;
var major_1$1 = major$3;
const SemVer$n = semver$3, minor$3 = (r, e) => new SemVer$n(r, e).minor;
var minor_1$1 = minor$3;
const SemVer$m = semver$3, patch$3 = (r, e) => new SemVer$m(r, e).patch;
var patch_1$1 = patch$3;
const parse$c = parse_1$1, prerelease$3 = (r, e) => {
  const s = parse$c(r, e);
  return s && s.prerelease.length ? s.prerelease : null;
};
var prerelease_1$1 = prerelease$3;
const SemVer$l = semver$3, compare$o = (r, e, s) => new SemVer$l(r, s).compare(new SemVer$l(e, s));
var compare_1$1 = compare$o;
const compare$n = compare_1$1, rcompare$3 = (r, e, s) => compare$n(e, r, s);
var rcompare_1$1 = rcompare$3;
const compare$m = compare_1$1, compareLoose$3 = (r, e) => compare$m(r, e, !0);
var compareLoose_1$1 = compareLoose$3;
const SemVer$k = semver$3, compareBuild$7 = (r, e, s) => {
  const o = new SemVer$k(r, s), fe = new SemVer$k(e, s);
  return o.compare(fe) || o.compareBuild(fe);
};
var compareBuild_1$1 = compareBuild$7;
const compareBuild$6 = compareBuild_1$1, sort$3 = (r, e) => r.sort((s, o) => compareBuild$6(s, o, e));
var sort_1$1 = sort$3;
const compareBuild$5 = compareBuild_1$1, rsort$3 = (r, e) => r.sort((s, o) => compareBuild$5(o, s, e));
var rsort_1$1 = rsort$3;
const compare$l = compare_1$1, gt$b = (r, e, s) => compare$l(r, e, s) > 0;
var gt_1$1 = gt$b;
const compare$k = compare_1$1, lt$9 = (r, e, s) => compare$k(r, e, s) < 0;
var lt_1$1 = lt$9;
const compare$j = compare_1$1, eq$5 = (r, e, s) => compare$j(r, e, s) === 0;
var eq_1$1 = eq$5;
const compare$i = compare_1$1, neq$5 = (r, e, s) => compare$i(r, e, s) !== 0;
var neq_1$1 = neq$5;
const compare$h = compare_1$1, gte$7 = (r, e, s) => compare$h(r, e, s) >= 0;
var gte_1$1 = gte$7;
const compare$g = compare_1$1, lte$7 = (r, e, s) => compare$g(r, e, s) <= 0;
var lte_1$1 = lte$7;
const eq$4 = eq_1$1, neq$4 = neq_1$1, gt$a = gt_1$1, gte$6 = gte_1$1, lt$8 = lt_1$1, lte$6 = lte_1$1, cmp$3 = (r, e, s, o) => {
  switch (e) {
    case "===":
      return typeof r == "object" && (r = r.version), typeof s == "object" && (s = s.version), r === s;
    case "!==":
      return typeof r == "object" && (r = r.version), typeof s == "object" && (s = s.version), r !== s;
    case "":
    case "=":
    case "==":
      return eq$4(r, s, o);
    case "!=":
      return neq$4(r, s, o);
    case ">":
      return gt$a(r, s, o);
    case ">=":
      return gte$6(r, s, o);
    case "<":
      return lt$8(r, s, o);
    case "<=":
      return lte$6(r, s, o);
    default:
      throw new TypeError(`Invalid operator: ${e}`);
  }
};
var cmp_1$1 = cmp$3;
const SemVer$j = semver$3, parse$b = parse_1$1, { safeRe: re$5, t: t$2 } = re$7.exports, coerce$4 = (r, e) => {
  if (r instanceof SemVer$j)
    return r;
  if (typeof r == "number" && (r = String(r)), typeof r != "string")
    return null;
  e = e || {};
  let s = null;
  if (!e.rtl)
    s = r.match(re$5[t$2.COERCE]);
  else {
    let o;
    for (; (o = re$5[t$2.COERCERTL].exec(r)) && (!s || s.index + s[0].length !== r.length); )
      (!s || o.index + o[0].length !== s.index + s[0].length) && (s = o), re$5[t$2.COERCERTL].lastIndex = o.index + o[1].length + o[2].length;
    re$5[t$2.COERCERTL].lastIndex = -1;
  }
  return s === null ? null : parse$b(`${s[2]}.${s[3] || "0"}.${s[4] || "0"}`, e);
};
var coerce_1$1 = coerce$4, iterator$1, hasRequiredIterator;
function requireIterator() {
  return hasRequiredIterator || (hasRequiredIterator = 1, iterator$1 = function(r) {
    r.prototype[Symbol.iterator] = function* () {
      for (let e = this.head; e; e = e.next)
        yield e.value;
    };
  }), iterator$1;
}
var yallist = Yallist$1;
Yallist$1.Node = Node;
Yallist$1.create = Yallist$1;
function Yallist$1(r) {
  var e = this;
  if (e instanceof Yallist$1 || (e = new Yallist$1()), e.tail = null, e.head = null, e.length = 0, r && typeof r.forEach == "function")
    r.forEach(function(fe) {
      e.push(fe);
    });
  else if (arguments.length > 0)
    for (var s = 0, o = arguments.length; s < o; s++)
      e.push(arguments[s]);
  return e;
}
Yallist$1.prototype.removeNode = function(r) {
  if (r.list !== this)
    throw new Error("removing node which does not belong to this list");
  var e = r.next, s = r.prev;
  return e && (e.prev = s), s && (s.next = e), r === this.head && (this.head = e), r === this.tail && (this.tail = s), r.list.length--, r.next = null, r.prev = null, r.list = null, e;
};
Yallist$1.prototype.unshiftNode = function(r) {
  if (r !== this.head) {
    r.list && r.list.removeNode(r);
    var e = this.head;
    r.list = this, r.next = e, e && (e.prev = r), this.head = r, this.tail || (this.tail = r), this.length++;
  }
};
Yallist$1.prototype.pushNode = function(r) {
  if (r !== this.tail) {
    r.list && r.list.removeNode(r);
    var e = this.tail;
    r.list = this, r.prev = e, e && (e.next = r), this.tail = r, this.head || (this.head = r), this.length++;
  }
};
Yallist$1.prototype.push = function() {
  for (var r = 0, e = arguments.length; r < e; r++)
    push$1(this, arguments[r]);
  return this.length;
};
Yallist$1.prototype.unshift = function() {
  for (var r = 0, e = arguments.length; r < e; r++)
    unshift(this, arguments[r]);
  return this.length;
};
Yallist$1.prototype.pop = function() {
  if (!!this.tail) {
    var r = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, r;
  }
};
Yallist$1.prototype.shift = function() {
  if (!!this.head) {
    var r = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, r;
  }
};
Yallist$1.prototype.forEach = function(r, e) {
  e = e || this;
  for (var s = this.head, o = 0; s !== null; o++)
    r.call(e, s.value, o, this), s = s.next;
};
Yallist$1.prototype.forEachReverse = function(r, e) {
  e = e || this;
  for (var s = this.tail, o = this.length - 1; s !== null; o--)
    r.call(e, s.value, o, this), s = s.prev;
};
Yallist$1.prototype.get = function(r) {
  for (var e = 0, s = this.head; s !== null && e < r; e++)
    s = s.next;
  if (e === r && s !== null)
    return s.value;
};
Yallist$1.prototype.getReverse = function(r) {
  for (var e = 0, s = this.tail; s !== null && e < r; e++)
    s = s.prev;
  if (e === r && s !== null)
    return s.value;
};
Yallist$1.prototype.map = function(r, e) {
  e = e || this;
  for (var s = new Yallist$1(), o = this.head; o !== null; )
    s.push(r.call(e, o.value, this)), o = o.next;
  return s;
};
Yallist$1.prototype.mapReverse = function(r, e) {
  e = e || this;
  for (var s = new Yallist$1(), o = this.tail; o !== null; )
    s.push(r.call(e, o.value, this)), o = o.prev;
  return s;
};
Yallist$1.prototype.reduce = function(r, e) {
  var s, o = this.head;
  if (arguments.length > 1)
    s = e;
  else if (this.head)
    o = this.head.next, s = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var fe = 0; o !== null; fe++)
    s = r(s, o.value, fe), o = o.next;
  return s;
};
Yallist$1.prototype.reduceReverse = function(r, e) {
  var s, o = this.tail;
  if (arguments.length > 1)
    s = e;
  else if (this.tail)
    o = this.tail.prev, s = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var fe = this.length - 1; o !== null; fe--)
    s = r(s, o.value, fe), o = o.prev;
  return s;
};
Yallist$1.prototype.toArray = function() {
  for (var r = new Array(this.length), e = 0, s = this.head; s !== null; e++)
    r[e] = s.value, s = s.next;
  return r;
};
Yallist$1.prototype.toArrayReverse = function() {
  for (var r = new Array(this.length), e = 0, s = this.tail; s !== null; e++)
    r[e] = s.value, s = s.prev;
  return r;
};
Yallist$1.prototype.slice = function(r, e) {
  e = e || this.length, e < 0 && (e += this.length), r = r || 0, r < 0 && (r += this.length);
  var s = new Yallist$1();
  if (e < r || e < 0)
    return s;
  r < 0 && (r = 0), e > this.length && (e = this.length);
  for (var o = 0, fe = this.head; fe !== null && o < r; o++)
    fe = fe.next;
  for (; fe !== null && o < e; o++, fe = fe.next)
    s.push(fe.value);
  return s;
};
Yallist$1.prototype.sliceReverse = function(r, e) {
  e = e || this.length, e < 0 && (e += this.length), r = r || 0, r < 0 && (r += this.length);
  var s = new Yallist$1();
  if (e < r || e < 0)
    return s;
  r < 0 && (r = 0), e > this.length && (e = this.length);
  for (var o = this.length, fe = this.tail; fe !== null && o > e; o--)
    fe = fe.prev;
  for (; fe !== null && o > r; o--, fe = fe.prev)
    s.push(fe.value);
  return s;
};
Yallist$1.prototype.splice = function(r, e, ...s) {
  r > this.length && (r = this.length - 1), r < 0 && (r = this.length + r);
  for (var o = 0, fe = this.head; fe !== null && o < r; o++)
    fe = fe.next;
  for (var me = [], o = 0; fe && o < e; o++)
    me.push(fe.value), fe = this.removeNode(fe);
  fe === null && (fe = this.tail), fe !== this.head && fe !== this.tail && (fe = fe.prev);
  for (var o = 0; o < s.length; o++)
    fe = insert(this, fe, s[o]);
  return me;
};
Yallist$1.prototype.reverse = function() {
  for (var r = this.head, e = this.tail, s = r; s !== null; s = s.prev) {
    var o = s.prev;
    s.prev = s.next, s.next = o;
  }
  return this.head = e, this.tail = r, this;
};
function insert(r, e, s) {
  var o = e === r.head ? new Node(s, null, e, r) : new Node(s, e, e.next, r);
  return o.next === null && (r.tail = o), o.prev === null && (r.head = o), r.length++, o;
}
function push$1(r, e) {
  r.tail = new Node(e, r.tail, null, r), r.head || (r.head = r.tail), r.length++;
}
function unshift(r, e) {
  r.head = new Node(e, null, r.head, r), r.tail || (r.tail = r.head), r.length++;
}
function Node(r, e, s, o) {
  if (!(this instanceof Node))
    return new Node(r, e, s, o);
  this.list = o, this.value = r, e ? (e.next = this, this.prev = e) : this.prev = null, s ? (s.prev = this, this.next = s) : this.next = null;
}
try {
  requireIterator()(Yallist$1);
} catch (r) {
}
const Yallist = yallist, MAX = Symbol("max"), LENGTH = Symbol("length"), LENGTH_CALCULATOR = Symbol("lengthCalculator"), ALLOW_STALE = Symbol("allowStale"), MAX_AGE = Symbol("maxAge"), DISPOSE = Symbol("dispose"), NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet"), LRU_LIST = Symbol("lruList"), CACHE = Symbol("cache"), UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet"), naiveLength = () => 1;
class LRUCache {
  constructor(e) {
    if (typeof e == "number" && (e = { max: e }), e || (e = {}), e.max && (typeof e.max != "number" || e.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[MAX] = e.max || 1 / 0;
    const s = e.length || naiveLength;
    if (this[LENGTH_CALCULATOR] = typeof s != "function" ? naiveLength : s, this[ALLOW_STALE] = e.stale || !1, e.maxAge && typeof e.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[MAX_AGE] = e.maxAge || 0, this[DISPOSE] = e.dispose, this[NO_DISPOSE_ON_SET] = e.noDisposeOnSet || !1, this[UPDATE_AGE_ON_GET] = e.updateAgeOnGet || !1, this.reset();
  }
  set max(e) {
    if (typeof e != "number" || e < 0)
      throw new TypeError("max must be a non-negative number");
    this[MAX] = e || 1 / 0, trim(this);
  }
  get max() {
    return this[MAX];
  }
  set allowStale(e) {
    this[ALLOW_STALE] = !!e;
  }
  get allowStale() {
    return this[ALLOW_STALE];
  }
  set maxAge(e) {
    if (typeof e != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[MAX_AGE] = e, trim(this);
  }
  get maxAge() {
    return this[MAX_AGE];
  }
  set lengthCalculator(e) {
    typeof e != "function" && (e = naiveLength), e !== this[LENGTH_CALCULATOR] && (this[LENGTH_CALCULATOR] = e, this[LENGTH] = 0, this[LRU_LIST].forEach((s) => {
      s.length = this[LENGTH_CALCULATOR](s.value, s.key), this[LENGTH] += s.length;
    })), trim(this);
  }
  get lengthCalculator() {
    return this[LENGTH_CALCULATOR];
  }
  get length() {
    return this[LENGTH];
  }
  get itemCount() {
    return this[LRU_LIST].length;
  }
  rforEach(e, s) {
    s = s || this;
    for (let o = this[LRU_LIST].tail; o !== null; ) {
      const fe = o.prev;
      forEachStep(this, e, o, s), o = fe;
    }
  }
  forEach(e, s) {
    s = s || this;
    for (let o = this[LRU_LIST].head; o !== null; ) {
      const fe = o.next;
      forEachStep(this, e, o, s), o = fe;
    }
  }
  keys() {
    return this[LRU_LIST].toArray().map((e) => e.key);
  }
  values() {
    return this[LRU_LIST].toArray().map((e) => e.value);
  }
  reset() {
    this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length && this[LRU_LIST].forEach((e) => this[DISPOSE](e.key, e.value)), this[CACHE] = /* @__PURE__ */ new Map(), this[LRU_LIST] = new Yallist(), this[LENGTH] = 0;
  }
  dump() {
    return this[LRU_LIST].map((e) => isStale(this, e) ? !1 : {
      k: e.key,
      v: e.value,
      e: e.now + (e.maxAge || 0)
    }).toArray().filter((e) => e);
  }
  dumpLru() {
    return this[LRU_LIST];
  }
  set(e, s, o) {
    if (o = o || this[MAX_AGE], o && typeof o != "number")
      throw new TypeError("maxAge must be a number");
    const fe = o ? Date.now() : 0, me = this[LENGTH_CALCULATOR](s, e);
    if (this[CACHE].has(e)) {
      if (me > this[MAX])
        return del$1(this, this[CACHE].get(e)), !1;
      const Er = this[CACHE].get(e).value;
      return this[DISPOSE] && (this[NO_DISPOSE_ON_SET] || this[DISPOSE](e, Er.value)), Er.now = fe, Er.maxAge = o, Er.value = s, this[LENGTH] += me - Er.length, Er.length = me, this.get(e), trim(this), !0;
    }
    const ye = new Entry(e, s, me, fe, o);
    return ye.length > this[MAX] ? (this[DISPOSE] && this[DISPOSE](e, s), !1) : (this[LENGTH] += ye.length, this[LRU_LIST].unshift(ye), this[CACHE].set(e, this[LRU_LIST].head), trim(this), !0);
  }
  has(e) {
    if (!this[CACHE].has(e))
      return !1;
    const s = this[CACHE].get(e).value;
    return !isStale(this, s);
  }
  get(e) {
    return get$1(this, e, !0);
  }
  peek(e) {
    return get$1(this, e, !1);
  }
  pop() {
    const e = this[LRU_LIST].tail;
    return e ? (del$1(this, e), e.value) : null;
  }
  del(e) {
    del$1(this, this[CACHE].get(e));
  }
  load(e) {
    this.reset();
    const s = Date.now();
    for (let o = e.length - 1; o >= 0; o--) {
      const fe = e[o], me = fe.e || 0;
      if (me === 0)
        this.set(fe.k, fe.v);
      else {
        const ye = me - s;
        ye > 0 && this.set(fe.k, fe.v, ye);
      }
    }
  }
  prune() {
    this[CACHE].forEach((e, s) => get$1(this, s, !1));
  }
}
const get$1 = (r, e, s) => {
  const o = r[CACHE].get(e);
  if (o) {
    const fe = o.value;
    if (isStale(r, fe)) {
      if (del$1(r, o), !r[ALLOW_STALE])
        return;
    } else
      s && (r[UPDATE_AGE_ON_GET] && (o.value.now = Date.now()), r[LRU_LIST].unshiftNode(o));
    return fe.value;
  }
}, isStale = (r, e) => {
  if (!e || !e.maxAge && !r[MAX_AGE])
    return !1;
  const s = Date.now() - e.now;
  return e.maxAge ? s > e.maxAge : r[MAX_AGE] && s > r[MAX_AGE];
}, trim = (r) => {
  if (r[LENGTH] > r[MAX])
    for (let e = r[LRU_LIST].tail; r[LENGTH] > r[MAX] && e !== null; ) {
      const s = e.prev;
      del$1(r, e), e = s;
    }
}, del$1 = (r, e) => {
  if (e) {
    const s = e.value;
    r[DISPOSE] && r[DISPOSE](s.key, s.value), r[LENGTH] -= s.length, r[CACHE].delete(s.key), r[LRU_LIST].removeNode(e);
  }
};
class Entry {
  constructor(e, s, o, fe, me) {
    this.key = e, this.value = s, this.length = o, this.now = fe, this.maxAge = me || 0;
  }
}
const forEachStep = (r, e, s, o) => {
  let fe = s.value;
  isStale(r, fe) && (del$1(r, s), r[ALLOW_STALE] || (fe = void 0)), fe && e.call(o, fe.value, fe.key, r);
};
var lruCache = LRUCache, range$1, hasRequiredRange$1;
function requireRange$1() {
  if (hasRequiredRange$1)
    return range$1;
  hasRequiredRange$1 = 1;
  class r {
    constructor(qr, Jr) {
      if (Jr = o(Jr), qr instanceof r)
        return qr.loose === !!Jr.loose && qr.includePrerelease === !!Jr.includePrerelease ? qr : new r(qr.raw, Jr);
      if (qr instanceof fe)
        return this.raw = qr.value, this.set = [[qr]], this.format(), this;
      if (this.options = Jr, this.loose = !!Jr.loose, this.includePrerelease = !!Jr.includePrerelease, this.raw = qr.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((ri) => this.parseRange(ri.trim())).filter((ri) => ri.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const ri = this.set[0];
        if (this.set = this.set.filter((Sn) => !jr(Sn[0])), this.set.length === 0)
          this.set = [ri];
        else if (this.set.length > 1) {
          for (const Sn of this.set)
            if (Sn.length === 1 && Kr(Sn[0])) {
              this.set = [Sn];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((qr) => qr.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(qr) {
      const ri = ((this.options.includePrerelease && Gr) | (this.options.loose && Vr)) + ":" + qr, Sn = s.get(ri);
      if (Sn)
        return Sn;
      const ai = this.options.loose, di = ai ? fr[Er.HYPHENRANGELOOSE] : fr[Er.HYPHENRANGE];
      qr = qr.replace(di, oi(this.options.includePrerelease)), me("hyphen replace", qr), qr = qr.replace(fr[Er.COMPARATORTRIM], br), me("comparator trim", qr), qr = qr.replace(fr[Er.TILDETRIM], wr), me("tilde trim", qr), qr = qr.replace(fr[Er.CARETTRIM], kr), me("caret trim", qr);
      let ii = qr.split(" ").map((Si) => Yr(Si, this.options)).join(" ").split(/\s+/).map((Si) => ei(Si, this.options));
      ai && (ii = ii.filter((Si) => (me("loose invalid filter", Si, this.options), !!Si.match(fr[Er.COMPARATORLOOSE])))), me("range list", ii);
      const fi = /* @__PURE__ */ new Map(), Ei = ii.map((Si) => new fe(Si, this.options));
      for (const Si of Ei) {
        if (jr(Si))
          return [Si];
        fi.set(Si.value, Si);
      }
      fi.size > 1 && fi.has("") && fi.delete("");
      const bi = [...fi.values()];
      return s.set(ri, bi), bi;
    }
    intersects(qr, Jr) {
      if (!(qr instanceof r))
        throw new TypeError("a Range is required");
      return this.set.some((ri) => bn(ri, Jr) && qr.set.some((Sn) => bn(Sn, Jr) && ri.every((ai) => Sn.every((di) => ai.intersects(di, Jr)))));
    }
    test(qr) {
      if (!qr)
        return !1;
      if (typeof qr == "string")
        try {
          qr = new ye(qr, this.options);
        } catch {
          return !1;
        }
      for (let Jr = 0; Jr < this.set.length; Jr++)
        if (Nn(this.set[Jr], qr, this.options))
          return !0;
      return !1;
    }
  }
  range$1 = r;
  const e = lruCache, s = new e({ max: 1e3 }), o = parseOptions_1$1, fe = requireComparator$1(), me = debug_1$1, ye = semver$3, {
    safeRe: fr,
    t: Er,
    comparatorTrimReplace: br,
    tildeTrimReplace: wr,
    caretTrimReplace: kr
  } = re$7.exports, { FLAG_INCLUDE_PRERELEASE: Gr, FLAG_LOOSE: Vr } = constants$9, jr = (En) => En.value === "<0.0.0-0", Kr = (En) => En.value === "", bn = (En, qr) => {
    let Jr = !0;
    const ri = En.slice();
    let Sn = ri.pop();
    for (; Jr && ri.length; )
      Jr = ri.every((ai) => Sn.intersects(ai, qr)), Sn = ri.pop();
    return Jr;
  }, Yr = (En, qr) => (me("comp", En, qr), En = ni(En, qr), me("caret", En), En = ti(En, qr), me("tildes", En), En = Br(En, qr), me("xrange", En), En = Pn(En, qr), me("stars", En), En), Zr = (En) => !En || En.toLowerCase() === "x" || En === "*", ti = (En, qr) => En.trim().split(/\s+/).map((Jr) => On(Jr, qr)).join(" "), On = (En, qr) => {
    const Jr = qr.loose ? fr[Er.TILDELOOSE] : fr[Er.TILDE];
    return En.replace(Jr, (ri, Sn, ai, di, ii) => {
      me("tilde", En, ri, Sn, ai, di, ii);
      let fi;
      return Zr(Sn) ? fi = "" : Zr(ai) ? fi = `>=${Sn}.0.0 <${+Sn + 1}.0.0-0` : Zr(di) ? fi = `>=${Sn}.${ai}.0 <${Sn}.${+ai + 1}.0-0` : ii ? (me("replaceTilde pr", ii), fi = `>=${Sn}.${ai}.${di}-${ii} <${Sn}.${+ai + 1}.0-0`) : fi = `>=${Sn}.${ai}.${di} <${Sn}.${+ai + 1}.0-0`, me("tilde return", fi), fi;
    });
  }, ni = (En, qr) => En.trim().split(/\s+/).map((Jr) => In(Jr, qr)).join(" "), In = (En, qr) => {
    me("caret", En, qr);
    const Jr = qr.loose ? fr[Er.CARETLOOSE] : fr[Er.CARET], ri = qr.includePrerelease ? "-0" : "";
    return En.replace(Jr, (Sn, ai, di, ii, fi) => {
      me("caret", En, Sn, ai, di, ii, fi);
      let Ei;
      return Zr(ai) ? Ei = "" : Zr(di) ? Ei = `>=${ai}.0.0${ri} <${+ai + 1}.0.0-0` : Zr(ii) ? ai === "0" ? Ei = `>=${ai}.${di}.0${ri} <${ai}.${+di + 1}.0-0` : Ei = `>=${ai}.${di}.0${ri} <${+ai + 1}.0.0-0` : fi ? (me("replaceCaret pr", fi), ai === "0" ? di === "0" ? Ei = `>=${ai}.${di}.${ii}-${fi} <${ai}.${di}.${+ii + 1}-0` : Ei = `>=${ai}.${di}.${ii}-${fi} <${ai}.${+di + 1}.0-0` : Ei = `>=${ai}.${di}.${ii}-${fi} <${+ai + 1}.0.0-0`) : (me("no pr"), ai === "0" ? di === "0" ? Ei = `>=${ai}.${di}.${ii}${ri} <${ai}.${di}.${+ii + 1}-0` : Ei = `>=${ai}.${di}.${ii}${ri} <${ai}.${+di + 1}.0-0` : Ei = `>=${ai}.${di}.${ii} <${+ai + 1}.0.0-0`), me("caret return", Ei), Ei;
    });
  }, Br = (En, qr) => (me("replaceXRanges", En, qr), En.split(/\s+/).map((Jr) => Hr(Jr, qr)).join(" ")), Hr = (En, qr) => {
    En = En.trim();
    const Jr = qr.loose ? fr[Er.XRANGELOOSE] : fr[Er.XRANGE];
    return En.replace(Jr, (ri, Sn, ai, di, ii, fi) => {
      me("xRange", En, ri, Sn, ai, di, ii, fi);
      const Ei = Zr(ai), bi = Ei || Zr(di), Si = bi || Zr(ii), Ii = Si;
      return Sn === "=" && Ii && (Sn = ""), fi = qr.includePrerelease ? "-0" : "", Ei ? Sn === ">" || Sn === "<" ? ri = "<0.0.0-0" : ri = "*" : Sn && Ii ? (bi && (di = 0), ii = 0, Sn === ">" ? (Sn = ">=", bi ? (ai = +ai + 1, di = 0, ii = 0) : (di = +di + 1, ii = 0)) : Sn === "<=" && (Sn = "<", bi ? ai = +ai + 1 : di = +di + 1), Sn === "<" && (fi = "-0"), ri = `${Sn + ai}.${di}.${ii}${fi}`) : bi ? ri = `>=${ai}.0.0${fi} <${+ai + 1}.0.0-0` : Si && (ri = `>=${ai}.${di}.0${fi} <${ai}.${+di + 1}.0-0`), me("xRange return", ri), ri;
    });
  }, Pn = (En, qr) => (me("replaceStars", En, qr), En.trim().replace(fr[Er.STAR], "")), ei = (En, qr) => (me("replaceGTE0", En, qr), En.trim().replace(fr[qr.includePrerelease ? Er.GTE0PRE : Er.GTE0], "")), oi = (En) => (qr, Jr, ri, Sn, ai, di, ii, fi, Ei, bi, Si, Ii, yi) => (Zr(ri) ? Jr = "" : Zr(Sn) ? Jr = `>=${ri}.0.0${En ? "-0" : ""}` : Zr(ai) ? Jr = `>=${ri}.${Sn}.0${En ? "-0" : ""}` : di ? Jr = `>=${Jr}` : Jr = `>=${Jr}${En ? "-0" : ""}`, Zr(Ei) ? fi = "" : Zr(bi) ? fi = `<${+Ei + 1}.0.0-0` : Zr(Si) ? fi = `<${Ei}.${+bi + 1}.0-0` : Ii ? fi = `<=${Ei}.${bi}.${Si}-${Ii}` : En ? fi = `<${Ei}.${bi}.${+Si + 1}-0` : fi = `<=${fi}`, `${Jr} ${fi}`.trim()), Nn = (En, qr, Jr) => {
    for (let ri = 0; ri < En.length; ri++)
      if (!En[ri].test(qr))
        return !1;
    if (qr.prerelease.length && !Jr.includePrerelease) {
      for (let ri = 0; ri < En.length; ri++)
        if (me(En[ri].semver), En[ri].semver !== fe.ANY && En[ri].semver.prerelease.length > 0) {
          const Sn = En[ri].semver;
          if (Sn.major === qr.major && Sn.minor === qr.minor && Sn.patch === qr.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range$1;
}
var comparator$1, hasRequiredComparator$1;
function requireComparator$1() {
  if (hasRequiredComparator$1)
    return comparator$1;
  hasRequiredComparator$1 = 1;
  const r = Symbol("SemVer ANY");
  class e {
    static get ANY() {
      return r;
    }
    constructor(wr, kr) {
      if (kr = s(kr), wr instanceof e) {
        if (wr.loose === !!kr.loose)
          return wr;
        wr = wr.value;
      }
      wr = wr.trim().split(/\s+/).join(" "), ye("comparator", wr, kr), this.options = kr, this.loose = !!kr.loose, this.parse(wr), this.semver === r ? this.value = "" : this.value = this.operator + this.semver.version, ye("comp", this);
    }
    parse(wr) {
      const kr = this.options.loose ? o[fe.COMPARATORLOOSE] : o[fe.COMPARATOR], Gr = wr.match(kr);
      if (!Gr)
        throw new TypeError(`Invalid comparator: ${wr}`);
      this.operator = Gr[1] !== void 0 ? Gr[1] : "", this.operator === "=" && (this.operator = ""), Gr[2] ? this.semver = new fr(Gr[2], this.options.loose) : this.semver = r;
    }
    toString() {
      return this.value;
    }
    test(wr) {
      if (ye("Comparator.test", wr, this.options.loose), this.semver === r || wr === r)
        return !0;
      if (typeof wr == "string")
        try {
          wr = new fr(wr, this.options);
        } catch {
          return !1;
        }
      return me(wr, this.operator, this.semver, this.options);
    }
    intersects(wr, kr) {
      if (!(wr instanceof e))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new Er(wr.value, kr).test(this.value) : wr.operator === "" ? wr.value === "" ? !0 : new Er(this.value, kr).test(wr.semver) : (kr = s(kr), kr.includePrerelease && (this.value === "<0.0.0-0" || wr.value === "<0.0.0-0") || !kr.includePrerelease && (this.value.startsWith("<0.0.0") || wr.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && wr.operator.startsWith(">") || this.operator.startsWith("<") && wr.operator.startsWith("<") || this.semver.version === wr.semver.version && this.operator.includes("=") && wr.operator.includes("=") || me(this.semver, "<", wr.semver, kr) && this.operator.startsWith(">") && wr.operator.startsWith("<") || me(this.semver, ">", wr.semver, kr) && this.operator.startsWith("<") && wr.operator.startsWith(">")));
    }
  }
  comparator$1 = e;
  const s = parseOptions_1$1, { safeRe: o, t: fe } = re$7.exports, me = cmp_1$1, ye = debug_1$1, fr = semver$3, Er = requireRange$1();
  return comparator$1;
}
const Range$j = requireRange$1(), satisfies$9 = (r, e, s) => {
  try {
    e = new Range$j(e, s);
  } catch {
    return !1;
  }
  return e.test(r);
};
var satisfies_1$1 = satisfies$9;
const Range$i = requireRange$1(), toComparators$3 = (r, e) => new Range$i(r, e).set.map((s) => s.map((o) => o.value).join(" ").trim().split(" "));
var toComparators_1$1 = toComparators$3;
const SemVer$i = semver$3, Range$h = requireRange$1(), maxSatisfying$3 = (r, e, s) => {
  let o = null, fe = null, me = null;
  try {
    me = new Range$h(e, s);
  } catch {
    return null;
  }
  return r.forEach((ye) => {
    me.test(ye) && (!o || fe.compare(ye) === -1) && (o = ye, fe = new SemVer$i(o, s));
  }), o;
};
var maxSatisfying_1$1 = maxSatisfying$3;
const SemVer$h = semver$3, Range$g = requireRange$1(), minSatisfying$3 = (r, e, s) => {
  let o = null, fe = null, me = null;
  try {
    me = new Range$g(e, s);
  } catch {
    return null;
  }
  return r.forEach((ye) => {
    me.test(ye) && (!o || fe.compare(ye) === 1) && (o = ye, fe = new SemVer$h(o, s));
  }), o;
};
var minSatisfying_1$1 = minSatisfying$3;
const SemVer$g = semver$3, Range$f = requireRange$1(), gt$9 = gt_1$1, minVersion$3 = (r, e) => {
  r = new Range$f(r, e);
  let s = new SemVer$g("0.0.0");
  if (r.test(s) || (s = new SemVer$g("0.0.0-0"), r.test(s)))
    return s;
  s = null;
  for (let o = 0; o < r.set.length; ++o) {
    const fe = r.set[o];
    let me = null;
    fe.forEach((ye) => {
      const fr = new SemVer$g(ye.semver.version);
      switch (ye.operator) {
        case ">":
          fr.prerelease.length === 0 ? fr.patch++ : fr.prerelease.push(0), fr.raw = fr.format();
        case "":
        case ">=":
          (!me || gt$9(fr, me)) && (me = fr);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${ye.operator}`);
      }
    }), me && (!s || gt$9(s, me)) && (s = me);
  }
  return s && r.test(s) ? s : null;
};
var minVersion_1$1 = minVersion$3;
const Range$e = requireRange$1(), validRange$3 = (r, e) => {
  try {
    return new Range$e(r, e).range || "*";
  } catch {
    return null;
  }
};
var valid$4 = validRange$3;
const SemVer$f = semver$3, Comparator$5 = requireComparator$1(), { ANY: ANY$3 } = Comparator$5, Range$d = requireRange$1(), satisfies$8 = satisfies_1$1, gt$8 = gt_1$1, lt$7 = lt_1$1, lte$5 = lte_1$1, gte$5 = gte_1$1, outside$7 = (r, e, s, o) => {
  r = new SemVer$f(r, o), e = new Range$d(e, o);
  let fe, me, ye, fr, Er;
  switch (s) {
    case ">":
      fe = gt$8, me = lte$5, ye = lt$7, fr = ">", Er = ">=";
      break;
    case "<":
      fe = lt$7, me = gte$5, ye = gt$8, fr = "<", Er = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$8(r, e, o))
    return !1;
  for (let br = 0; br < e.set.length; ++br) {
    const wr = e.set[br];
    let kr = null, Gr = null;
    if (wr.forEach((Vr) => {
      Vr.semver === ANY$3 && (Vr = new Comparator$5(">=0.0.0")), kr = kr || Vr, Gr = Gr || Vr, fe(Vr.semver, kr.semver, o) ? kr = Vr : ye(Vr.semver, Gr.semver, o) && (Gr = Vr);
    }), kr.operator === fr || kr.operator === Er || (!Gr.operator || Gr.operator === fr) && me(r, Gr.semver))
      return !1;
    if (Gr.operator === Er && ye(r, Gr.semver))
      return !1;
  }
  return !0;
};
var outside_1$1 = outside$7;
const outside$6 = outside_1$1, gtr$3 = (r, e, s) => outside$6(r, e, ">", s);
var gtr_1$1 = gtr$3;
const outside$5 = outside_1$1, ltr$3 = (r, e, s) => outside$5(r, e, "<", s);
var ltr_1$1 = ltr$3;
const Range$c = requireRange$1(), intersects$3 = (r, e, s) => (r = new Range$c(r, s), e = new Range$c(e, s), r.intersects(e, s));
var intersects_1$1 = intersects$3;
const satisfies$7 = satisfies_1$1, compare$f = compare_1$1;
var simplify$1 = (r, e, s) => {
  const o = [];
  let fe = null, me = null;
  const ye = r.sort((wr, kr) => compare$f(wr, kr, s));
  for (const wr of ye)
    satisfies$7(wr, e, s) ? (me = wr, fe || (fe = wr)) : (me && o.push([fe, me]), me = null, fe = null);
  fe && o.push([fe, null]);
  const fr = [];
  for (const [wr, kr] of o)
    wr === kr ? fr.push(wr) : !kr && wr === ye[0] ? fr.push("*") : kr ? wr === ye[0] ? fr.push(`<=${kr}`) : fr.push(`${wr} - ${kr}`) : fr.push(`>=${wr}`);
  const Er = fr.join(" || "), br = typeof e.raw == "string" ? e.raw : String(e);
  return Er.length < br.length ? Er : e;
};
const Range$b = requireRange$1(), Comparator$4 = requireComparator$1(), { ANY: ANY$2 } = Comparator$4, satisfies$6 = satisfies_1$1, compare$e = compare_1$1, subset$3 = (r, e, s = {}) => {
  if (r === e)
    return !0;
  r = new Range$b(r, s), e = new Range$b(e, s);
  let o = !1;
  e:
    for (const fe of r.set) {
      for (const me of e.set) {
        const ye = simpleSubset$1(fe, me, s);
        if (o = o || ye !== null, ye)
          continue e;
      }
      if (o)
        return !1;
    }
  return !0;
}, minimumVersionWithPreRelease$1 = [new Comparator$4(">=0.0.0-0")], minimumVersion$1 = [new Comparator$4(">=0.0.0")], simpleSubset$1 = (r, e, s) => {
  if (r === e)
    return !0;
  if (r.length === 1 && r[0].semver === ANY$2) {
    if (e.length === 1 && e[0].semver === ANY$2)
      return !0;
    s.includePrerelease ? r = minimumVersionWithPreRelease$1 : r = minimumVersion$1;
  }
  if (e.length === 1 && e[0].semver === ANY$2) {
    if (s.includePrerelease)
      return !0;
    e = minimumVersion$1;
  }
  const o = /* @__PURE__ */ new Set();
  let fe, me;
  for (const Vr of r)
    Vr.operator === ">" || Vr.operator === ">=" ? fe = higherGT$1(fe, Vr, s) : Vr.operator === "<" || Vr.operator === "<=" ? me = lowerLT$1(me, Vr, s) : o.add(Vr.semver);
  if (o.size > 1)
    return null;
  let ye;
  if (fe && me) {
    if (ye = compare$e(fe.semver, me.semver, s), ye > 0)
      return null;
    if (ye === 0 && (fe.operator !== ">=" || me.operator !== "<="))
      return null;
  }
  for (const Vr of o) {
    if (fe && !satisfies$6(Vr, String(fe), s) || me && !satisfies$6(Vr, String(me), s))
      return null;
    for (const jr of e)
      if (!satisfies$6(Vr, String(jr), s))
        return !1;
    return !0;
  }
  let fr, Er, br, wr, kr = me && !s.includePrerelease && me.semver.prerelease.length ? me.semver : !1, Gr = fe && !s.includePrerelease && fe.semver.prerelease.length ? fe.semver : !1;
  kr && kr.prerelease.length === 1 && me.operator === "<" && kr.prerelease[0] === 0 && (kr = !1);
  for (const Vr of e) {
    if (wr = wr || Vr.operator === ">" || Vr.operator === ">=", br = br || Vr.operator === "<" || Vr.operator === "<=", fe) {
      if (Gr && Vr.semver.prerelease && Vr.semver.prerelease.length && Vr.semver.major === Gr.major && Vr.semver.minor === Gr.minor && Vr.semver.patch === Gr.patch && (Gr = !1), Vr.operator === ">" || Vr.operator === ">=") {
        if (fr = higherGT$1(fe, Vr, s), fr === Vr && fr !== fe)
          return !1;
      } else if (fe.operator === ">=" && !satisfies$6(fe.semver, String(Vr), s))
        return !1;
    }
    if (me) {
      if (kr && Vr.semver.prerelease && Vr.semver.prerelease.length && Vr.semver.major === kr.major && Vr.semver.minor === kr.minor && Vr.semver.patch === kr.patch && (kr = !1), Vr.operator === "<" || Vr.operator === "<=") {
        if (Er = lowerLT$1(me, Vr, s), Er === Vr && Er !== me)
          return !1;
      } else if (me.operator === "<=" && !satisfies$6(me.semver, String(Vr), s))
        return !1;
    }
    if (!Vr.operator && (me || fe) && ye !== 0)
      return !1;
  }
  return !(fe && br && !me && ye !== 0 || me && wr && !fe && ye !== 0 || Gr || kr);
}, higherGT$1 = (r, e, s) => {
  if (!r)
    return e;
  const o = compare$e(r.semver, e.semver, s);
  return o > 0 ? r : o < 0 || e.operator === ">" && r.operator === ">=" ? e : r;
}, lowerLT$1 = (r, e, s) => {
  if (!r)
    return e;
  const o = compare$e(r.semver, e.semver, s);
  return o < 0 ? r : o > 0 || e.operator === "<" && r.operator === "<=" ? e : r;
};
var subset_1$1 = subset$3;
const internalRe$1 = re$7.exports, constants$8 = constants$9, SemVer$e = semver$3, identifiers$2 = identifiers$3, parse$a = parse_1$1, valid$3 = valid_1$1, clean$2 = clean_1$1, inc$2 = inc_1$1, diff$2 = diff_1$1, major$2 = major_1$1, minor$2 = minor_1$1, patch$2 = patch_1$1, prerelease$2 = prerelease_1$1, compare$d = compare_1$1, rcompare$2 = rcompare_1$1, compareLoose$2 = compareLoose_1$1, compareBuild$4 = compareBuild_1$1, sort$2 = sort_1$1, rsort$2 = rsort_1$1, gt$7 = gt_1$1, lt$6 = lt_1$1, eq$3 = eq_1$1, neq$3 = neq_1$1, gte$4 = gte_1$1, lte$4 = lte_1$1, cmp$2 = cmp_1$1, coerce$3 = coerce_1$1, Comparator$3 = requireComparator$1(), Range$a = requireRange$1(), satisfies$5 = satisfies_1$1, toComparators$2 = toComparators_1$1, maxSatisfying$2 = maxSatisfying_1$1, minSatisfying$2 = minSatisfying_1$1, minVersion$2 = minVersion_1$1, validRange$2 = valid$4, outside$4 = outside_1$1, gtr$2 = gtr_1$1, ltr$2 = ltr_1$1, intersects$2 = intersects_1$1, simplifyRange$1 = simplify$1, subset$2 = subset_1$1;
var semver$2 = {
  parse: parse$a,
  valid: valid$3,
  clean: clean$2,
  inc: inc$2,
  diff: diff$2,
  major: major$2,
  minor: minor$2,
  patch: patch$2,
  prerelease: prerelease$2,
  compare: compare$d,
  rcompare: rcompare$2,
  compareLoose: compareLoose$2,
  compareBuild: compareBuild$4,
  sort: sort$2,
  rsort: rsort$2,
  gt: gt$7,
  lt: lt$6,
  eq: eq$3,
  neq: neq$3,
  gte: gte$4,
  lte: lte$4,
  cmp: cmp$2,
  coerce: coerce$3,
  Comparator: Comparator$3,
  Range: Range$a,
  satisfies: satisfies$5,
  toComparators: toComparators$2,
  maxSatisfying: maxSatisfying$2,
  minSatisfying: minSatisfying$2,
  minVersion: minVersion$2,
  validRange: validRange$2,
  outside: outside$4,
  gtr: gtr$2,
  ltr: ltr$2,
  intersects: intersects$2,
  simplifyRange: simplifyRange$1,
  subset: subset$2,
  SemVer: SemVer$e,
  re: internalRe$1.re,
  src: internalRe$1.src,
  tokens: internalRe$1.t,
  SEMVER_SPEC_VERSION: constants$8.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants$8.RELEASE_TYPES,
  compareIdentifiers: identifiers$2.compareIdentifiers,
  rcompareIdentifiers: identifiers$2.rcompareIdentifiers
}, DeviceModelId$1;
(function(r) {
  r.blue = "blue", r.nanoS = "nanoS", r.nanoSP = "nanoSP", r.nanoX = "nanoX", r.stax = "stax";
})(DeviceModelId$1 || (DeviceModelId$1 = {}));
const devices$1 = {
  [DeviceModelId$1.blue]: {
    id: DeviceModelId$1.blue,
    productName: "Ledger\xA0Blue",
    productIdMM: 0,
    legacyUsbProductId: 0,
    usbOnly: !0,
    memorySize: 480 * 1024,
    masks: [822083584, 822149120],
    getBlockSize: (r) => 4 * 1024
  },
  [DeviceModelId$1.nanoS]: {
    id: DeviceModelId$1.nanoS,
    productName: "Ledger\xA0Nano\xA0S",
    productIdMM: 16,
    legacyUsbProductId: 1,
    usbOnly: !0,
    memorySize: 320 * 1024,
    masks: [823132160],
    getBlockSize: (r) => {
      var e;
      return semver$2.lt((e = semver$2.coerce(r)) !== null && e !== void 0 ? e : "", "2.0.0") ? 4 * 1024 : 2 * 1024;
    }
  },
  [DeviceModelId$1.nanoSP]: {
    id: DeviceModelId$1.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 80,
    legacyUsbProductId: 5,
    usbOnly: !0,
    memorySize: 1536 * 1024,
    masks: [856686592],
    getBlockSize: (r) => 32
  },
  [DeviceModelId$1.nanoX]: {
    id: DeviceModelId$1.nanoX,
    productName: "Ledger\xA0Nano\xA0X",
    productIdMM: 64,
    legacyUsbProductId: 4,
    usbOnly: !1,
    memorySize: 2 * 1024 * 1024,
    masks: [855638016],
    getBlockSize: (r) => 4 * 1024,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId$1.stax]: {
    id: DeviceModelId$1.stax,
    productName: "Ledger\xA0Stax",
    productIdMM: 96,
    legacyUsbProductId: 6,
    usbOnly: !1,
    memorySize: 1536 * 1024,
    masks: [857735168],
    getBlockSize: (r) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
      }
    ]
  }
};
DeviceModelId$1.blue, DeviceModelId$1.nanoS, DeviceModelId$1.nanoSP, DeviceModelId$1.nanoX, DeviceModelId$1.stax;
Object.values(devices$1);
const bluetoothServices$1 = [], serviceUuidToInfos$1 = {};
for (const r in devices$1) {
  const e = devices$1[r], { bluetoothSpec: s } = e;
  if (s)
    for (let o = 0; o < s.length; o++) {
      const fe = s[o];
      bluetoothServices$1.push(fe.serviceUuid), serviceUuidToInfos$1[fe.serviceUuid] = serviceUuidToInfos$1[fe.serviceUuid.replace(/-/g, "")] = Object.assign({ deviceModel: e }, fe);
    }
}
const getBluetoothServiceUuids = () => bluetoothServices$1, getInfosForServiceUuid = (r) => serviceUuidToInfos$1[r.toLowerCase()];
var tslib = { exports: {} };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(r) {
  var e, s, o, fe, me, ye, fr, Er, br, wr, kr, Gr, Vr, jr, Kr, bn, Yr, Zr, ti, On, ni, In, Br;
  (function(Hr) {
    var Pn = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof this == "object" ? this : {};
    Hr(ei(Pn, ei(r.exports)));
    function ei(oi, Nn) {
      return oi !== Pn && (typeof Object.create == "function" ? Object.defineProperty(oi, "__esModule", { value: !0 }) : oi.__esModule = !0), function(En, qr) {
        return oi[En] = Nn ? Nn(En, qr) : qr;
      };
    }
  })(function(Hr) {
    var Pn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ei, oi) {
      ei.__proto__ = oi;
    } || function(ei, oi) {
      for (var Nn in oi)
        oi.hasOwnProperty(Nn) && (ei[Nn] = oi[Nn]);
    };
    e = function(ei, oi) {
      Pn(ei, oi);
      function Nn() {
        this.constructor = ei;
      }
      ei.prototype = oi === null ? Object.create(oi) : (Nn.prototype = oi.prototype, new Nn());
    }, s = Object.assign || function(ei) {
      for (var oi, Nn = 1, En = arguments.length; Nn < En; Nn++) {
        oi = arguments[Nn];
        for (var qr in oi)
          Object.prototype.hasOwnProperty.call(oi, qr) && (ei[qr] = oi[qr]);
      }
      return ei;
    }, o = function(ei, oi) {
      var Nn = {};
      for (var En in ei)
        Object.prototype.hasOwnProperty.call(ei, En) && oi.indexOf(En) < 0 && (Nn[En] = ei[En]);
      if (ei != null && typeof Object.getOwnPropertySymbols == "function")
        for (var qr = 0, En = Object.getOwnPropertySymbols(ei); qr < En.length; qr++)
          oi.indexOf(En[qr]) < 0 && Object.prototype.propertyIsEnumerable.call(ei, En[qr]) && (Nn[En[qr]] = ei[En[qr]]);
      return Nn;
    }, fe = function(ei, oi, Nn, En) {
      var qr = arguments.length, Jr = qr < 3 ? oi : En === null ? En = Object.getOwnPropertyDescriptor(oi, Nn) : En, ri;
      if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
        Jr = Reflect.decorate(ei, oi, Nn, En);
      else
        for (var Sn = ei.length - 1; Sn >= 0; Sn--)
          (ri = ei[Sn]) && (Jr = (qr < 3 ? ri(Jr) : qr > 3 ? ri(oi, Nn, Jr) : ri(oi, Nn)) || Jr);
      return qr > 3 && Jr && Object.defineProperty(oi, Nn, Jr), Jr;
    }, me = function(ei, oi) {
      return function(Nn, En) {
        oi(Nn, En, ei);
      };
    }, ye = function(ei, oi) {
      if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
        return Reflect.metadata(ei, oi);
    }, fr = function(ei, oi, Nn, En) {
      function qr(Jr) {
        return Jr instanceof Nn ? Jr : new Nn(function(ri) {
          ri(Jr);
        });
      }
      return new (Nn || (Nn = Promise))(function(Jr, ri) {
        function Sn(ii) {
          try {
            di(En.next(ii));
          } catch (fi) {
            ri(fi);
          }
        }
        function ai(ii) {
          try {
            di(En.throw(ii));
          } catch (fi) {
            ri(fi);
          }
        }
        function di(ii) {
          ii.done ? Jr(ii.value) : qr(ii.value).then(Sn, ai);
        }
        di((En = En.apply(ei, oi || [])).next());
      });
    }, Er = function(ei, oi) {
      var Nn = { label: 0, sent: function() {
        if (Jr[0] & 1)
          throw Jr[1];
        return Jr[1];
      }, trys: [], ops: [] }, En, qr, Jr, ri;
      return ri = { next: Sn(0), throw: Sn(1), return: Sn(2) }, typeof Symbol == "function" && (ri[Symbol.iterator] = function() {
        return this;
      }), ri;
      function Sn(di) {
        return function(ii) {
          return ai([di, ii]);
        };
      }
      function ai(di) {
        if (En)
          throw new TypeError("Generator is already executing.");
        for (; Nn; )
          try {
            if (En = 1, qr && (Jr = di[0] & 2 ? qr.return : di[0] ? qr.throw || ((Jr = qr.return) && Jr.call(qr), 0) : qr.next) && !(Jr = Jr.call(qr, di[1])).done)
              return Jr;
            switch (qr = 0, Jr && (di = [di[0] & 2, Jr.value]), di[0]) {
              case 0:
              case 1:
                Jr = di;
                break;
              case 4:
                return Nn.label++, { value: di[1], done: !1 };
              case 5:
                Nn.label++, qr = di[1], di = [0];
                continue;
              case 7:
                di = Nn.ops.pop(), Nn.trys.pop();
                continue;
              default:
                if (Jr = Nn.trys, !(Jr = Jr.length > 0 && Jr[Jr.length - 1]) && (di[0] === 6 || di[0] === 2)) {
                  Nn = 0;
                  continue;
                }
                if (di[0] === 3 && (!Jr || di[1] > Jr[0] && di[1] < Jr[3])) {
                  Nn.label = di[1];
                  break;
                }
                if (di[0] === 6 && Nn.label < Jr[1]) {
                  Nn.label = Jr[1], Jr = di;
                  break;
                }
                if (Jr && Nn.label < Jr[2]) {
                  Nn.label = Jr[2], Nn.ops.push(di);
                  break;
                }
                Jr[2] && Nn.ops.pop(), Nn.trys.pop();
                continue;
            }
            di = oi.call(ei, Nn);
          } catch (ii) {
            di = [6, ii], qr = 0;
          } finally {
            En = Jr = 0;
          }
        if (di[0] & 5)
          throw di[1];
        return { value: di[0] ? di[1] : void 0, done: !0 };
      }
    }, Br = function(ei, oi, Nn, En) {
      En === void 0 && (En = Nn), ei[En] = oi[Nn];
    }, br = function(ei, oi) {
      for (var Nn in ei)
        Nn !== "default" && !oi.hasOwnProperty(Nn) && (oi[Nn] = ei[Nn]);
    }, wr = function(ei) {
      var oi = typeof Symbol == "function" && Symbol.iterator, Nn = oi && ei[oi], En = 0;
      if (Nn)
        return Nn.call(ei);
      if (ei && typeof ei.length == "number")
        return {
          next: function() {
            return ei && En >= ei.length && (ei = void 0), { value: ei && ei[En++], done: !ei };
          }
        };
      throw new TypeError(oi ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, kr = function(ei, oi) {
      var Nn = typeof Symbol == "function" && ei[Symbol.iterator];
      if (!Nn)
        return ei;
      var En = Nn.call(ei), qr, Jr = [], ri;
      try {
        for (; (oi === void 0 || oi-- > 0) && !(qr = En.next()).done; )
          Jr.push(qr.value);
      } catch (Sn) {
        ri = { error: Sn };
      } finally {
        try {
          qr && !qr.done && (Nn = En.return) && Nn.call(En);
        } finally {
          if (ri)
            throw ri.error;
        }
      }
      return Jr;
    }, Gr = function() {
      for (var ei = [], oi = 0; oi < arguments.length; oi++)
        ei = ei.concat(kr(arguments[oi]));
      return ei;
    }, Vr = function() {
      for (var ei = 0, oi = 0, Nn = arguments.length; oi < Nn; oi++)
        ei += arguments[oi].length;
      for (var En = Array(ei), qr = 0, oi = 0; oi < Nn; oi++)
        for (var Jr = arguments[oi], ri = 0, Sn = Jr.length; ri < Sn; ri++, qr++)
          En[qr] = Jr[ri];
      return En;
    }, jr = function(ei) {
      return this instanceof jr ? (this.v = ei, this) : new jr(ei);
    }, Kr = function(ei, oi, Nn) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var En = Nn.apply(ei, oi || []), qr, Jr = [];
      return qr = {}, ri("next"), ri("throw"), ri("return"), qr[Symbol.asyncIterator] = function() {
        return this;
      }, qr;
      function ri(Ei) {
        En[Ei] && (qr[Ei] = function(bi) {
          return new Promise(function(Si, Ii) {
            Jr.push([Ei, bi, Si, Ii]) > 1 || Sn(Ei, bi);
          });
        });
      }
      function Sn(Ei, bi) {
        try {
          ai(En[Ei](bi));
        } catch (Si) {
          fi(Jr[0][3], Si);
        }
      }
      function ai(Ei) {
        Ei.value instanceof jr ? Promise.resolve(Ei.value.v).then(di, ii) : fi(Jr[0][2], Ei);
      }
      function di(Ei) {
        Sn("next", Ei);
      }
      function ii(Ei) {
        Sn("throw", Ei);
      }
      function fi(Ei, bi) {
        Ei(bi), Jr.shift(), Jr.length && Sn(Jr[0][0], Jr[0][1]);
      }
    }, bn = function(ei) {
      var oi, Nn;
      return oi = {}, En("next"), En("throw", function(qr) {
        throw qr;
      }), En("return"), oi[Symbol.iterator] = function() {
        return this;
      }, oi;
      function En(qr, Jr) {
        oi[qr] = ei[qr] ? function(ri) {
          return (Nn = !Nn) ? { value: jr(ei[qr](ri)), done: qr === "return" } : Jr ? Jr(ri) : ri;
        } : Jr;
      }
    }, Yr = function(ei) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var oi = ei[Symbol.asyncIterator], Nn;
      return oi ? oi.call(ei) : (ei = typeof wr == "function" ? wr(ei) : ei[Symbol.iterator](), Nn = {}, En("next"), En("throw"), En("return"), Nn[Symbol.asyncIterator] = function() {
        return this;
      }, Nn);
      function En(Jr) {
        Nn[Jr] = ei[Jr] && function(ri) {
          return new Promise(function(Sn, ai) {
            ri = ei[Jr](ri), qr(Sn, ai, ri.done, ri.value);
          });
        };
      }
      function qr(Jr, ri, Sn, ai) {
        Promise.resolve(ai).then(function(di) {
          Jr({ value: di, done: Sn });
        }, ri);
      }
    }, Zr = function(ei, oi) {
      return Object.defineProperty ? Object.defineProperty(ei, "raw", { value: oi }) : ei.raw = oi, ei;
    }, ti = function(ei) {
      if (ei && ei.__esModule)
        return ei;
      var oi = {};
      if (ei != null)
        for (var Nn in ei)
          Object.hasOwnProperty.call(ei, Nn) && (oi[Nn] = ei[Nn]);
      return oi.default = ei, oi;
    }, On = function(ei) {
      return ei && ei.__esModule ? ei : { default: ei };
    }, ni = function(ei, oi) {
      if (!oi.has(ei))
        throw new TypeError("attempted to get private field on non-instance");
      return oi.get(ei);
    }, In = function(ei, oi, Nn) {
      if (!oi.has(ei))
        throw new TypeError("attempted to set private field on non-instance");
      return oi.set(ei, Nn), Nn;
    }, Hr("__extends", e), Hr("__assign", s), Hr("__rest", o), Hr("__decorate", fe), Hr("__param", me), Hr("__metadata", ye), Hr("__awaiter", fr), Hr("__generator", Er), Hr("__exportStar", br), Hr("__createBinding", Br), Hr("__values", wr), Hr("__read", kr), Hr("__spread", Gr), Hr("__spreadArrays", Vr), Hr("__await", jr), Hr("__asyncGenerator", Kr), Hr("__asyncDelegator", bn), Hr("__asyncValues", Yr), Hr("__makeTemplateObject", Zr), Hr("__importStar", ti), Hr("__importDefault", On), Hr("__classPrivateFieldGet", ni), Hr("__classPrivateFieldSet", In);
  });
})(tslib);
function isFunction$1(r) {
  return typeof r == "function";
}
var _enable_super_gross_mode_that_will_cause_bad_things = !1, config = {
  Promise: void 0,
  set useDeprecatedSynchronousErrorHandling(r) {
    if (r) {
      var e = /* @__PURE__ */ new Error();
      "" + e.stack;
    }
    _enable_super_gross_mode_that_will_cause_bad_things = r;
  },
  get useDeprecatedSynchronousErrorHandling() {
    return _enable_super_gross_mode_that_will_cause_bad_things;
  }
};
function hostReportError(r) {
  setTimeout(function() {
    throw r;
  }, 0);
}
var empty$2 = {
  closed: !0,
  next: function(r) {
  },
  error: function(r) {
    if (config.useDeprecatedSynchronousErrorHandling)
      throw r;
    hostReportError(r);
  },
  complete: function() {
  }
}, isArray$6 = /* @__PURE__ */ function() {
  return Array.isArray || function(r) {
    return r && typeof r.length == "number";
  };
}();
function isObject$1(r) {
  return r !== null && typeof r == "object";
}
var UnsubscriptionErrorImpl = /* @__PURE__ */ function() {
  function r(e) {
    return Error.call(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(s, o) {
      return o + 1 + ") " + s.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e, this;
  }
  return r.prototype = /* @__PURE__ */ Object.create(Error.prototype), r;
}(), UnsubscriptionError = UnsubscriptionErrorImpl, Subscription = /* @__PURE__ */ function() {
  function r(e) {
    this.closed = !1, this._parentOrParents = null, this._subscriptions = null, e && (this._ctorUnsubscribe = !0, this._unsubscribe = e);
  }
  return r.prototype.unsubscribe = function() {
    var e;
    if (!this.closed) {
      var s = this, o = s._parentOrParents, fe = s._ctorUnsubscribe, me = s._unsubscribe, ye = s._subscriptions;
      if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, o instanceof r)
        o.remove(this);
      else if (o !== null)
        for (var fr = 0; fr < o.length; ++fr) {
          var Er = o[fr];
          Er.remove(this);
        }
      if (isFunction$1(me)) {
        fe && (this._unsubscribe = void 0);
        try {
          me.call(this);
        } catch (kr) {
          e = kr instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(kr.errors) : [kr];
        }
      }
      if (isArray$6(ye))
        for (var fr = -1, br = ye.length; ++fr < br; ) {
          var wr = ye[fr];
          if (isObject$1(wr))
            try {
              wr.unsubscribe();
            } catch (Gr) {
              e = e || [], Gr instanceof UnsubscriptionError ? e = e.concat(flattenUnsubscriptionErrors(Gr.errors)) : e.push(Gr);
            }
        }
      if (e)
        throw new UnsubscriptionError(e);
    }
  }, r.prototype.add = function(e) {
    var s = e;
    if (!e)
      return r.EMPTY;
    switch (typeof e) {
      case "function":
        s = new r(e);
      case "object":
        if (s === this || s.closed || typeof s.unsubscribe != "function")
          return s;
        if (this.closed)
          return s.unsubscribe(), s;
        if (!(s instanceof r)) {
          var o = s;
          s = new r(), s._subscriptions = [o];
        }
        break;
      default:
        throw new Error("unrecognized teardown " + e + " added to Subscription.");
    }
    var fe = s._parentOrParents;
    if (fe === null)
      s._parentOrParents = this;
    else if (fe instanceof r) {
      if (fe === this)
        return s;
      s._parentOrParents = [fe, this];
    } else if (fe.indexOf(this) === -1)
      fe.push(this);
    else
      return s;
    var me = this._subscriptions;
    return me === null ? this._subscriptions = [s] : me.push(s), s;
  }, r.prototype.remove = function(e) {
    var s = this._subscriptions;
    if (s) {
      var o = s.indexOf(e);
      o !== -1 && s.splice(o, 1);
    }
  }, r.EMPTY = function(e) {
    return e.closed = !0, e;
  }(new r()), r;
}();
function flattenUnsubscriptionErrors(r) {
  return r.reduce(function(e, s) {
    return e.concat(s instanceof UnsubscriptionError ? s.errors : s);
  }, []);
}
var rxSubscriber = /* @__PURE__ */ function() {
  return typeof Symbol == "function" ? /* @__PURE__ */ Symbol("rxSubscriber") : "@@rxSubscriber_" + /* @__PURE__ */ Math.random();
}(), Subscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o, fe) {
    var me = r.call(this) || this;
    switch (me.syncErrorValue = null, me.syncErrorThrown = !1, me.syncErrorThrowable = !1, me.isStopped = !1, arguments.length) {
      case 0:
        me.destination = empty$2;
        break;
      case 1:
        if (!s) {
          me.destination = empty$2;
          break;
        }
        if (typeof s == "object") {
          s instanceof e ? (me.syncErrorThrowable = s.syncErrorThrowable, me.destination = s, s.add(me)) : (me.syncErrorThrowable = !0, me.destination = new SafeSubscriber(me, s));
          break;
        }
      default:
        me.syncErrorThrowable = !0, me.destination = new SafeSubscriber(me, s, o, fe);
        break;
    }
    return me;
  }
  return e.prototype[rxSubscriber] = function() {
    return this;
  }, e.create = function(s, o, fe) {
    var me = new e(s, o, fe);
    return me.syncErrorThrowable = !1, me;
  }, e.prototype.next = function(s) {
    this.isStopped || this._next(s);
  }, e.prototype.error = function(s) {
    this.isStopped || (this.isStopped = !0, this._error(s));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this));
  }, e.prototype._next = function(s) {
    this.destination.next(s);
  }, e.prototype._error = function(s) {
    this.destination.error(s), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.destination.complete(), this.unsubscribe();
  }, e.prototype._unsubscribeAndRecycle = function() {
    var s = this._parentOrParents;
    return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = s, this;
  }, e;
}(Subscription), SafeSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o, fe, me) {
    var ye = r.call(this) || this;
    ye._parentSubscriber = s;
    var fr, Er = ye;
    return isFunction$1(o) ? fr = o : o && (fr = o.next, fe = o.error, me = o.complete, o !== empty$2 && (Er = Object.create(o), isFunction$1(Er.unsubscribe) && ye.add(Er.unsubscribe.bind(Er)), Er.unsubscribe = ye.unsubscribe.bind(ye))), ye._context = Er, ye._next = fr, ye._error = fe, ye._complete = me, ye;
  }
  return e.prototype.next = function(s) {
    if (!this.isStopped && this._next) {
      var o = this._parentSubscriber;
      !config.useDeprecatedSynchronousErrorHandling || !o.syncErrorThrowable ? this.__tryOrUnsub(this._next, s) : this.__tryOrSetError(o, this._next, s) && this.unsubscribe();
    }
  }, e.prototype.error = function(s) {
    if (!this.isStopped) {
      var o = this._parentSubscriber, fe = config.useDeprecatedSynchronousErrorHandling;
      if (this._error)
        !fe || !o.syncErrorThrowable ? (this.__tryOrUnsub(this._error, s), this.unsubscribe()) : (this.__tryOrSetError(o, this._error, s), this.unsubscribe());
      else if (o.syncErrorThrowable)
        fe ? (o.syncErrorValue = s, o.syncErrorThrown = !0) : hostReportError(s), this.unsubscribe();
      else {
        if (this.unsubscribe(), fe)
          throw s;
        hostReportError(s);
      }
    }
  }, e.prototype.complete = function() {
    var s = this;
    if (!this.isStopped) {
      var o = this._parentSubscriber;
      if (this._complete) {
        var fe = function() {
          return s._complete.call(s._context);
        };
        !config.useDeprecatedSynchronousErrorHandling || !o.syncErrorThrowable ? (this.__tryOrUnsub(fe), this.unsubscribe()) : (this.__tryOrSetError(o, fe), this.unsubscribe());
      } else
        this.unsubscribe();
    }
  }, e.prototype.__tryOrUnsub = function(s, o) {
    try {
      s.call(this._context, o);
    } catch (fe) {
      if (this.unsubscribe(), config.useDeprecatedSynchronousErrorHandling)
        throw fe;
      hostReportError(fe);
    }
  }, e.prototype.__tryOrSetError = function(s, o, fe) {
    if (!config.useDeprecatedSynchronousErrorHandling)
      throw new Error("bad call");
    try {
      o.call(this._context, fe);
    } catch (me) {
      return config.useDeprecatedSynchronousErrorHandling ? (s.syncErrorValue = me, s.syncErrorThrown = !0, !0) : (hostReportError(me), !0);
    }
    return !1;
  }, e.prototype._unsubscribe = function() {
    var s = this._parentSubscriber;
    this._context = null, this._parentSubscriber = null, s.unsubscribe();
  }, e;
}(Subscriber);
function canReportError(r) {
  for (; r; ) {
    var e = r, s = e.closed, o = e.destination, fe = e.isStopped;
    if (s || fe)
      return !1;
    o && o instanceof Subscriber ? r = o : r = null;
  }
  return !0;
}
function toSubscriber(r, e, s) {
  if (r) {
    if (r instanceof Subscriber)
      return r;
    if (r[rxSubscriber])
      return r[rxSubscriber]();
  }
  return !r && !e && !s ? new Subscriber(empty$2) : new Subscriber(r, e, s);
}
var observable = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function identity$3(r) {
  return r;
}
function pipeFromArray(r) {
  return r.length === 0 ? identity$3 : r.length === 1 ? r[0] : function(s) {
    return r.reduce(function(o, fe) {
      return fe(o);
    }, s);
  };
}
var Observable = /* @__PURE__ */ function() {
  function r(e) {
    this._isScalar = !1, e && (this._subscribe = e);
  }
  return r.prototype.lift = function(e) {
    var s = new r();
    return s.source = this, s.operator = e, s;
  }, r.prototype.subscribe = function(e, s, o) {
    var fe = this.operator, me = toSubscriber(e, s, o);
    if (fe ? me.add(fe.call(me, this.source)) : me.add(this.source || config.useDeprecatedSynchronousErrorHandling && !me.syncErrorThrowable ? this._subscribe(me) : this._trySubscribe(me)), config.useDeprecatedSynchronousErrorHandling && me.syncErrorThrowable && (me.syncErrorThrowable = !1, me.syncErrorThrown))
      throw me.syncErrorValue;
    return me;
  }, r.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (s) {
      config.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = s), canReportError(e) ? e.error(s) : console.warn(s);
    }
  }, r.prototype.forEach = function(e, s) {
    var o = this;
    return s = getPromiseCtor(s), new s(function(fe, me) {
      var ye;
      ye = o.subscribe(function(fr) {
        try {
          e(fr);
        } catch (Er) {
          me(Er), ye && ye.unsubscribe();
        }
      }, me, fe);
    });
  }, r.prototype._subscribe = function(e) {
    var s = this.source;
    return s && s.subscribe(e);
  }, r.prototype[observable] = function() {
    return this;
  }, r.prototype.pipe = function() {
    for (var e = [], s = 0; s < arguments.length; s++)
      e[s] = arguments[s];
    return e.length === 0 ? this : pipeFromArray(e)(this);
  }, r.prototype.toPromise = function(e) {
    var s = this;
    return e = getPromiseCtor(e), new e(function(o, fe) {
      var me;
      s.subscribe(function(ye) {
        return me = ye;
      }, function(ye) {
        return fe(ye);
      }, function() {
        return o(me);
      });
    });
  }, r.create = function(e) {
    return new r(e);
  }, r;
}();
function getPromiseCtor(r) {
  if (r || (r = config.Promise || Promise), !r)
    throw new Error("no Promise impl found");
  return r;
}
var ObjectUnsubscribedErrorImpl = /* @__PURE__ */ function() {
  function r() {
    return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
  }
  return r.prototype = /* @__PURE__ */ Object.create(Error.prototype), r;
}(), ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl, SubjectSubscription = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this) || this;
    return fe.subject = s, fe.subscriber = o, fe.closed = !1, fe;
  }
  return e.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.closed = !0;
      var s = this.subject, o = s.observers;
      if (this.subject = null, !(!o || o.length === 0 || s.isStopped || s.closed)) {
        var fe = o.indexOf(this.subscriber);
        fe !== -1 && o.splice(fe, 1);
      }
    }
  }, e;
}(Subscription), SubjectSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s) {
    var o = r.call(this, s) || this;
    return o.destination = s, o;
  }
  return e;
}(Subscriber), Subject = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e() {
    var s = r.call(this) || this;
    return s.observers = [], s.closed = !1, s.isStopped = !1, s.hasError = !1, s.thrownError = null, s;
  }
  return e.prototype[rxSubscriber] = function() {
    return new SubjectSubscriber(this);
  }, e.prototype.lift = function(s) {
    var o = new AnonymousSubject(this, this);
    return o.operator = s, o;
  }, e.prototype.next = function(s) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    if (!this.isStopped)
      for (var o = this.observers, fe = o.length, me = o.slice(), ye = 0; ye < fe; ye++)
        me[ye].next(s);
  }, e.prototype.error = function(s) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    this.hasError = !0, this.thrownError = s, this.isStopped = !0;
    for (var o = this.observers, fe = o.length, me = o.slice(), ye = 0; ye < fe; ye++)
      me[ye].error(s);
    this.observers.length = 0;
  }, e.prototype.complete = function() {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    this.isStopped = !0;
    for (var s = this.observers, o = s.length, fe = s.slice(), me = 0; me < o; me++)
      fe[me].complete();
    this.observers.length = 0;
  }, e.prototype.unsubscribe = function() {
    this.isStopped = !0, this.closed = !0, this.observers = null;
  }, e.prototype._trySubscribe = function(s) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    return r.prototype._trySubscribe.call(this, s);
  }, e.prototype._subscribe = function(s) {
    if (this.closed)
      throw new ObjectUnsubscribedError();
    return this.hasError ? (s.error(this.thrownError), Subscription.EMPTY) : this.isStopped ? (s.complete(), Subscription.EMPTY) : (this.observers.push(s), new SubjectSubscription(this, s));
  }, e.prototype.asObservable = function() {
    var s = new Observable();
    return s.source = this, s;
  }, e.create = function(s, o) {
    return new AnonymousSubject(s, o);
  }, e;
}(Observable), AnonymousSubject = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this) || this;
    return fe.destination = s, fe.source = o, fe;
  }
  return e.prototype.next = function(s) {
    var o = this.destination;
    o && o.next && o.next(s);
  }, e.prototype.error = function(s) {
    var o = this.destination;
    o && o.error && this.destination.error(s);
  }, e.prototype.complete = function() {
    var s = this.destination;
    s && s.complete && this.destination.complete();
  }, e.prototype._subscribe = function(s) {
    var o = this.source;
    return o ? this.source.subscribe(s) : Subscription.EMPTY;
  }, e;
}(Subject);
function refCount() {
  return function(e) {
    return e.lift(new RefCountOperator(e));
  };
}
var RefCountOperator = /* @__PURE__ */ function() {
  function r(e) {
    this.connectable = e;
  }
  return r.prototype.call = function(e, s) {
    var o = this.connectable;
    o._refCount++;
    var fe = new RefCountSubscriber(e, o), me = s.subscribe(fe);
    return fe.closed || (fe.connection = o.connect()), me;
  }, r;
}(), RefCountSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this, s) || this;
    return fe.connectable = o, fe;
  }
  return e.prototype._unsubscribe = function() {
    var s = this.connectable;
    if (!s) {
      this.connection = null;
      return;
    }
    this.connectable = null;
    var o = s._refCount;
    if (o <= 0) {
      this.connection = null;
      return;
    }
    if (s._refCount = o - 1, o > 1) {
      this.connection = null;
      return;
    }
    var fe = this.connection, me = s._connection;
    this.connection = null, me && (!fe || me === fe) && me.unsubscribe();
  }, e;
}(Subscriber), ConnectableObservable = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this) || this;
    return fe.source = s, fe.subjectFactory = o, fe._refCount = 0, fe._isComplete = !1, fe;
  }
  return e.prototype._subscribe = function(s) {
    return this.getSubject().subscribe(s);
  }, e.prototype.getSubject = function() {
    var s = this._subject;
    return (!s || s.isStopped) && (this._subject = this.subjectFactory()), this._subject;
  }, e.prototype.connect = function() {
    var s = this._connection;
    return s || (this._isComplete = !1, s = this._connection = new Subscription(), s.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this))), s.closed && (this._connection = null, s = Subscription.EMPTY)), s;
  }, e.prototype.refCount = function() {
    return refCount()(this);
  }, e;
}(Observable), connectableObservableDescriptor = /* @__PURE__ */ function() {
  var r = ConnectableObservable.prototype;
  return {
    operator: { value: null },
    _refCount: { value: 0, writable: !0 },
    _subject: { value: null, writable: !0 },
    _connection: { value: null, writable: !0 },
    _subscribe: { value: r._subscribe },
    _isComplete: { value: r._isComplete, writable: !0 },
    getSubject: { value: r.getSubject },
    connect: { value: r.connect },
    refCount: { value: r.refCount }
  };
}(), ConnectableSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this, s) || this;
    return fe.connectable = o, fe;
  }
  return e.prototype._error = function(s) {
    this._unsubscribe(), r.prototype._error.call(this, s);
  }, e.prototype._complete = function() {
    this.connectable._isComplete = !0, this._unsubscribe(), r.prototype._complete.call(this);
  }, e.prototype._unsubscribe = function() {
    var s = this.connectable;
    if (s) {
      this.connectable = null;
      var o = s._connection;
      s._refCount = 0, s._subject = null, s._connection = null, o && o.unsubscribe();
    }
  }, e;
}(SubjectSubscriber), EMPTY = /* @__PURE__ */ new Observable(function(r) {
  return r.complete();
});
function empty$1(r) {
  return r ? emptyScheduled(r) : EMPTY;
}
function emptyScheduled(r) {
  return new Observable(function(e) {
    return r.schedule(function() {
      return e.complete();
    });
  });
}
function isScheduler(r) {
  return r && typeof r.schedule == "function";
}
var subscribeToArray = function(r) {
  return function(e) {
    for (var s = 0, o = r.length; s < o && !e.closed; s++)
      e.next(r[s]);
    e.complete();
  };
};
function scheduleArray(r, e) {
  return new Observable(function(s) {
    var o = new Subscription(), fe = 0;
    return o.add(e.schedule(function() {
      if (fe === r.length) {
        s.complete();
        return;
      }
      s.next(r[fe++]), s.closed || o.add(this.schedule());
    })), o;
  });
}
function fromArray(r, e) {
  return e ? scheduleArray(r, e) : new Observable(subscribeToArray(r));
}
function noop$1() {
}
var ArgumentOutOfRangeErrorImpl = /* @__PURE__ */ function() {
  function r() {
    return Error.call(this), this.message = "argument out of range", this.name = "ArgumentOutOfRangeError", this;
  }
  return r.prototype = /* @__PURE__ */ Object.create(Error.prototype), r;
}(), ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl, EmptyErrorImpl = /* @__PURE__ */ function() {
  function r() {
    return Error.call(this), this.message = "no elements in sequence", this.name = "EmptyError", this;
  }
  return r.prototype = /* @__PURE__ */ Object.create(Error.prototype), r;
}(), EmptyError = EmptyErrorImpl;
function map$1(r, e) {
  return function(o) {
    if (typeof r != "function")
      throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
    return o.lift(new MapOperator(r, e));
  };
}
var MapOperator = /* @__PURE__ */ function() {
  function r(e, s) {
    this.project = e, this.thisArg = s;
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new MapSubscriber(e, this.project, this.thisArg));
  }, r;
}(), MapSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o, fe) {
    var me = r.call(this, s) || this;
    return me.project = o, me.count = 0, me.thisArg = fe || me, me;
  }
  return e.prototype._next = function(s) {
    var o;
    try {
      o = this.project.call(this.thisArg, s, this.count++);
    } catch (fe) {
      this.destination.error(fe);
      return;
    }
    this.destination.next(o);
  }, e;
}(Subscriber), subscribeToPromise = function(r) {
  return function(e) {
    return r.then(function(s) {
      e.closed || (e.next(s), e.complete());
    }, function(s) {
      return e.error(s);
    }).then(null, hostReportError), e;
  };
};
function getSymbolIterator() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var iterator = /* @__PURE__ */ getSymbolIterator(), subscribeToIterable = function(r) {
  return function(e) {
    var s = r[iterator]();
    do {
      var o = void 0;
      try {
        o = s.next();
      } catch (fe) {
        return e.error(fe), e;
      }
      if (o.done) {
        e.complete();
        break;
      }
      if (e.next(o.value), e.closed)
        break;
    } while (!0);
    return typeof s.return == "function" && e.add(function() {
      s.return && s.return();
    }), e;
  };
}, subscribeToObservable = function(r) {
  return function(e) {
    var s = r[observable]();
    if (typeof s.subscribe != "function")
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    return s.subscribe(e);
  };
}, isArrayLike = function(r) {
  return r && typeof r.length == "number" && typeof r != "function";
};
function isPromise(r) {
  return !!r && typeof r.subscribe != "function" && typeof r.then == "function";
}
var subscribeTo = function(r) {
  if (!!r && typeof r[observable] == "function")
    return subscribeToObservable(r);
  if (isArrayLike(r))
    return subscribeToArray(r);
  if (isPromise(r))
    return subscribeToPromise(r);
  if (!!r && typeof r[iterator] == "function")
    return subscribeToIterable(r);
  var e = isObject$1(r) ? "an invalid object" : "'" + r + "'", s = "You provided " + e + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
  throw new TypeError(s);
};
function scheduleObservable(r, e) {
  return new Observable(function(s) {
    var o = new Subscription();
    return o.add(e.schedule(function() {
      var fe = r[observable]();
      o.add(fe.subscribe({
        next: function(me) {
          o.add(e.schedule(function() {
            return s.next(me);
          }));
        },
        error: function(me) {
          o.add(e.schedule(function() {
            return s.error(me);
          }));
        },
        complete: function() {
          o.add(e.schedule(function() {
            return s.complete();
          }));
        }
      }));
    })), o;
  });
}
function schedulePromise(r, e) {
  return new Observable(function(s) {
    var o = new Subscription();
    return o.add(e.schedule(function() {
      return r.then(function(fe) {
        o.add(e.schedule(function() {
          s.next(fe), o.add(e.schedule(function() {
            return s.complete();
          }));
        }));
      }, function(fe) {
        o.add(e.schedule(function() {
          return s.error(fe);
        }));
      });
    })), o;
  });
}
function scheduleIterable(r, e) {
  if (!r)
    throw new Error("Iterable cannot be null");
  return new Observable(function(s) {
    var o = new Subscription(), fe;
    return o.add(function() {
      fe && typeof fe.return == "function" && fe.return();
    }), o.add(e.schedule(function() {
      fe = r[iterator](), o.add(e.schedule(function() {
        if (!s.closed) {
          var me, ye;
          try {
            var fr = fe.next();
            me = fr.value, ye = fr.done;
          } catch (Er) {
            s.error(Er);
            return;
          }
          ye ? s.complete() : (s.next(me), this.schedule());
        }
      }));
    })), o;
  });
}
function isInteropObservable(r) {
  return r && typeof r[observable] == "function";
}
function isIterable(r) {
  return r && typeof r[iterator] == "function";
}
function scheduled(r, e) {
  if (r != null) {
    if (isInteropObservable(r))
      return scheduleObservable(r, e);
    if (isPromise(r))
      return schedulePromise(r, e);
    if (isArrayLike(r))
      return scheduleArray(r, e);
    if (isIterable(r) || typeof r == "string")
      return scheduleIterable(r, e);
  }
  throw new TypeError((r !== null && typeof r || r) + " is not observable");
}
function from$2(r, e) {
  return e ? scheduled(r, e) : r instanceof Observable ? r : new Observable(subscribeTo(r));
}
var SimpleInnerSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s) {
    var o = r.call(this) || this;
    return o.parent = s, o;
  }
  return e.prototype._next = function(s) {
    this.parent.notifyNext(s);
  }, e.prototype._error = function(s) {
    this.parent.notifyError(s), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.parent.notifyComplete(), this.unsubscribe();
  }, e;
}(Subscriber), SimpleOuterSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return e.prototype.notifyNext = function(s) {
    this.destination.next(s);
  }, e.prototype.notifyError = function(s) {
    this.destination.error(s);
  }, e.prototype.notifyComplete = function() {
    this.destination.complete();
  }, e;
}(Subscriber);
function innerSubscribe(r, e) {
  if (!e.closed) {
    if (r instanceof Observable)
      return r.subscribe(e);
    var s;
    try {
      s = subscribeTo(r)(e);
    } catch (o) {
      e.error(o);
    }
    return s;
  }
}
function mergeMap(r, e, s) {
  return s === void 0 && (s = Number.POSITIVE_INFINITY), typeof e == "function" ? function(o) {
    return o.pipe(mergeMap(function(fe, me) {
      return from$2(r(fe, me)).pipe(map$1(function(ye, fr) {
        return e(fe, ye, me, fr);
      }));
    }, s));
  } : (typeof e == "number" && (s = e), function(o) {
    return o.lift(new MergeMapOperator(r, s));
  });
}
var MergeMapOperator = /* @__PURE__ */ function() {
  function r(e, s) {
    s === void 0 && (s = Number.POSITIVE_INFINITY), this.project = e, this.concurrent = s;
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new MergeMapSubscriber(e, this.project, this.concurrent));
  }, r;
}(), MergeMapSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o, fe) {
    fe === void 0 && (fe = Number.POSITIVE_INFINITY);
    var me = r.call(this, s) || this;
    return me.project = o, me.concurrent = fe, me.hasCompleted = !1, me.buffer = [], me.active = 0, me.index = 0, me;
  }
  return e.prototype._next = function(s) {
    this.active < this.concurrent ? this._tryNext(s) : this.buffer.push(s);
  }, e.prototype._tryNext = function(s) {
    var o, fe = this.index++;
    try {
      o = this.project(s, fe);
    } catch (me) {
      this.destination.error(me);
      return;
    }
    this.active++, this._innerSub(o);
  }, e.prototype._innerSub = function(s) {
    var o = new SimpleInnerSubscriber(this), fe = this.destination;
    fe.add(o);
    var me = innerSubscribe(s, o);
    me !== o && fe.add(me);
  }, e.prototype._complete = function() {
    this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && this.destination.complete(), this.unsubscribe();
  }, e.prototype.notifyNext = function(s) {
    this.destination.next(s);
  }, e.prototype.notifyComplete = function() {
    var s = this.buffer;
    this.active--, s.length > 0 ? this._next(s.shift()) : this.active === 0 && this.hasCompleted && this.destination.complete();
  }, e;
}(SimpleOuterSubscriber);
function mergeAll(r) {
  return r === void 0 && (r = Number.POSITIVE_INFINITY), mergeMap(identity$3, r);
}
function defer(r) {
  return new Observable(function(e) {
    var s;
    try {
      s = r();
    } catch (fe) {
      e.error(fe);
      return;
    }
    var o = s ? from$2(s) : empty$1();
    return o.subscribe(e);
  });
}
function merge$1() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var s = Number.POSITIVE_INFINITY, o = null, fe = r[r.length - 1];
  return isScheduler(fe) ? (o = r.pop(), r.length > 1 && typeof r[r.length - 1] == "number" && (s = r.pop())) : typeof fe == "number" && (s = r.pop()), o === null && r.length === 1 && r[0] instanceof Observable ? r[0] : mergeAll(s)(fromArray(r, o));
}
function filter(r, e) {
  return function(o) {
    return o.lift(new FilterOperator(r, e));
  };
}
var FilterOperator = /* @__PURE__ */ function() {
  function r(e, s) {
    this.predicate = e, this.thisArg = s;
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new FilterSubscriber(e, this.predicate, this.thisArg));
  }, r;
}(), FilterSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o, fe) {
    var me = r.call(this, s) || this;
    return me.predicate = o, me.thisArg = fe, me.count = 0, me;
  }
  return e.prototype._next = function(s) {
    var o;
    try {
      o = this.predicate.call(this.thisArg, s, this.count++);
    } catch (fe) {
      this.destination.error(fe);
      return;
    }
    o && this.destination.next(s);
  }, e;
}(Subscriber), id = 0, subscribers = [], log = function(r, e, s) {
  var o = {
    type: r,
    id: String(++id),
    date: new Date()
  };
  e && (o.message = e), s && (o.data = s), dispatch(o);
}, listen = function(r) {
  return subscribers.push(r), function() {
    var e = subscribers.indexOf(r);
    e !== -1 && (subscribers[e] = subscribers[subscribers.length - 1], subscribers.pop());
  };
};
function dispatch(r) {
  for (var e = 0; e < subscribers.length; e++)
    try {
      subscribers[e](r);
    } catch (s) {
      console.error(s);
    }
}
typeof window < "u" && (window.__ledgerLogsListen = listen);
var __awaiter$a = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
const TagId$1 = 5;
function chunkBuffer(r, e) {
  const s = [];
  for (let o = 0, fe = e(0); o < r.length; o += fe, fe = e(o))
    s.push(r.slice(o, o + fe));
  return s;
}
const sendAPDU = (r, e, s) => {
  const o = chunkBuffer(e, (fe) => s - (fe === 0 ? 5 : 3)).map((fe, me) => {
    const ye = Buffer.alloc(me === 0 ? 5 : 3);
    return ye.writeUInt8(TagId$1, 0), ye.writeUInt16BE(me, 1), me === 0 && ye.writeUInt16BE(e.length, 3), Buffer.concat([ye, fe]);
  });
  return new Observable((fe) => {
    let me = !1;
    function ye() {
      return __awaiter$a(this, void 0, void 0, function* () {
        for (const Er of o) {
          if (me)
            return;
          yield r(Er);
        }
      });
    }
    return ye().then(() => {
      me = !0, fe.complete();
    }, (Er) => {
      me = !0, log("ble-error", "sendAPDU failure " + String(Er)), fe.error(Er);
    }), () => {
      me || (log("ble-verbose", "sendAPDU interruption"), me = !0);
    };
  });
}, TagId = 5, receiveAPDU = (r) => Observable.create((e) => {
  let s = 0, o = 0, fe = Buffer.alloc(0);
  const me = r.subscribe({
    complete: () => {
      e.error(new DisconnectedDevice$1()), me.unsubscribe();
    },
    error: (ye) => {
      log("ble-error", "in receiveAPDU " + String(ye)), e.error(ye), me.unsubscribe();
    },
    next: (ye) => {
      const fr = ye.readUInt8(0), Er = ye.readUInt16BE(1);
      let br = ye.slice(3);
      if (fr !== TagId) {
        e.error(new TransportError$2("Invalid tag " + fr.toString(16), "InvalidTag"));
        return;
      }
      if (s !== Er) {
        e.error(new TransportError$2("BLE: Invalid sequence number. discontinued chunk. Received " + Er + " but expected " + s, "InvalidSequence"));
        return;
      }
      if (Er === 0 && (o = br.readUInt16BE(0), br = br.slice(2)), s++, fe = Buffer.concat([fe, br]), fe.length > o) {
        e.error(new TransportError$2("BLE: received too much data. discontinued chunk. Received " + fe.length + " but expected " + o, "BLETooMuchData"));
        return;
      }
      fe.length === o && (e.next(fe), e.complete(), me.unsubscribe());
    }
  });
  return () => {
    me.unsubscribe();
  };
});
function defaultIfEmpty(r) {
  return r === void 0 && (r = null), function(e) {
    return e.lift(new DefaultIfEmptyOperator(r));
  };
}
var DefaultIfEmptyOperator = /* @__PURE__ */ function() {
  function r(e) {
    this.defaultValue = e;
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new DefaultIfEmptySubscriber(e, this.defaultValue));
  }, r;
}(), DefaultIfEmptySubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this, s) || this;
    return fe.defaultValue = o, fe.isEmpty = !0, fe;
  }
  return e.prototype._next = function(s) {
    this.isEmpty = !1, this.destination.next(s);
  }, e.prototype._complete = function() {
    this.isEmpty && this.destination.next(this.defaultValue), this.destination.complete();
  }, e;
}(Subscriber);
function throwIfEmpty(r) {
  return r === void 0 && (r = defaultErrorFactory), function(e) {
    return e.lift(new ThrowIfEmptyOperator(r));
  };
}
var ThrowIfEmptyOperator = /* @__PURE__ */ function() {
  function r(e) {
    this.errorFactory = e;
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new ThrowIfEmptySubscriber(e, this.errorFactory));
  }, r;
}(), ThrowIfEmptySubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this, s) || this;
    return fe.errorFactory = o, fe.hasValue = !1, fe;
  }
  return e.prototype._next = function(s) {
    this.hasValue = !0, this.destination.next(s);
  }, e.prototype._complete = function() {
    if (this.hasValue)
      return this.destination.complete();
    var s = void 0;
    try {
      s = this.errorFactory();
    } catch (o) {
      s = o;
    }
    this.destination.error(s);
  }, e;
}(Subscriber);
function defaultErrorFactory() {
  return new EmptyError();
}
function take(r) {
  return function(e) {
    return r === 0 ? empty$1() : e.lift(new TakeOperator(r));
  };
}
var TakeOperator = /* @__PURE__ */ function() {
  function r(e) {
    if (this.total = e, this.total < 0)
      throw new ArgumentOutOfRangeError();
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new TakeSubscriber(e, this.total));
  }, r;
}(), TakeSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o) {
    var fe = r.call(this, s) || this;
    return fe.total = o, fe.count = 0, fe;
  }
  return e.prototype._next = function(s) {
    var o = this.total, fe = ++this.count;
    fe <= o && (this.destination.next(s), fe === o && (this.destination.complete(), this.unsubscribe()));
  }, e;
}(Subscriber);
function first(r, e) {
  var s = arguments.length >= 2;
  return function(o) {
    return o.pipe(r ? filter(function(fe, me) {
      return r(fe, me, o);
    }) : identity$3, take(1), s ? defaultIfEmpty(e) : throwIfEmpty(function() {
      return new EmptyError();
    }));
  };
}
function ignoreElements() {
  return function(e) {
    return e.lift(new IgnoreElementsOperator());
  };
}
var IgnoreElementsOperator = /* @__PURE__ */ function() {
  function r() {
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new IgnoreElementsSubscriber(e));
  }, r;
}(), IgnoreElementsSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return e.prototype._next = function(s) {
  }, e;
}(Subscriber);
function multicast(r, e) {
  return function(o) {
    var fe;
    if (typeof r == "function" ? fe = r : fe = function() {
      return r;
    }, typeof e == "function")
      return o.lift(new MulticastOperator(fe, e));
    var me = Object.create(o, connectableObservableDescriptor);
    return me.source = o, me.subjectFactory = fe, me;
  };
}
var MulticastOperator = /* @__PURE__ */ function() {
  function r(e, s) {
    this.subjectFactory = e, this.selector = s;
  }
  return r.prototype.call = function(e, s) {
    var o = this.selector, fe = this.subjectFactory(), me = o(fe).subscribe(e);
    return me.add(s.subscribe(fe)), me;
  }, r;
}();
function shareSubjectFactory() {
  return new Subject();
}
function share() {
  return function(r) {
    return refCount()(multicast(shareSubjectFactory)(r));
  };
}
function tap(r, e, s) {
  return function(fe) {
    return fe.lift(new DoOperator(r, e, s));
  };
}
var DoOperator = /* @__PURE__ */ function() {
  function r(e, s, o) {
    this.nextOrObserver = e, this.error = s, this.complete = o;
  }
  return r.prototype.call = function(e, s) {
    return s.subscribe(new TapSubscriber(e, this.nextOrObserver, this.error, this.complete));
  }, r;
}(), TapSubscriber = /* @__PURE__ */ function(r) {
  tslib.exports.__extends(e, r);
  function e(s, o, fe, me) {
    var ye = r.call(this, s) || this;
    return ye._tapNext = noop$1, ye._tapError = noop$1, ye._tapComplete = noop$1, ye._tapError = fe || noop$1, ye._tapComplete = me || noop$1, isFunction$1(o) ? (ye._context = ye, ye._tapNext = o) : o && (ye._context = o, ye._tapNext = o.next || noop$1, ye._tapError = o.error || noop$1, ye._tapComplete = o.complete || noop$1), ye;
  }
  return e.prototype._next = function(s) {
    try {
      this._tapNext.call(this._context, s);
    } catch (o) {
      this.destination.error(o);
      return;
    }
    this.destination.next(s);
  }, e.prototype._error = function(s) {
    try {
      this._tapError.call(this._context, s);
    } catch (o) {
      this.destination.error(o);
      return;
    }
    this.destination.error(s);
  }, e.prototype._complete = function() {
    try {
      this._tapComplete.call(this._context);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    return this.destination.complete();
  }, e;
}(Subscriber);
const monitorCharacteristic = (r) => Observable.create((e) => {
  log("ble-verbose", "start monitor " + r.uuid);
  function s(o) {
    const fe = o.target;
    fe.value && e.next(Buffer.from(fe.value.buffer));
  }
  return r.startNotifications().then(() => {
    r.addEventListener("characteristicvaluechanged", s);
  }), () => {
    log("ble-verbose", "end monitor " + r.uuid), r.stopNotifications();
  };
});
var __awaiter$9 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
const requiresBluetooth = () => {
  const { bluetooth: r } = navigator;
  if (typeof r > "u")
    throw new Error("web bluetooth not supported");
  return r;
}, availability = () => Observable.create((r) => {
  const e = requiresBluetooth(), s = (fe) => {
    r.next(fe.value);
  };
  e.addEventListener("availabilitychanged", s);
  let o = !1;
  return e.getAvailability().then((fe) => {
    o || r.next(fe);
  }), () => {
    o = !0, e.removeEventListener("availabilitychanged", s);
  };
}), transportsCache = {}, requestDeviceParam = () => ({
  filters: getBluetoothServiceUuids().map((r) => ({
    services: [r]
  }))
}), retrieveService = (r) => __awaiter$9(void 0, void 0, void 0, function* () {
  if (!r.gatt)
    throw new Error("bluetooth gatt not found");
  const [e] = yield r.gatt.getPrimaryServices();
  if (!e)
    throw new Error("bluetooth service not found");
  const s = getInfosForServiceUuid(e.uuid);
  if (!s)
    throw new Error("bluetooth service infos not found");
  return [e, s];
});
function open(r, e) {
  return __awaiter$9(this, void 0, void 0, function* () {
    let s;
    if (typeof r == "string") {
      if (transportsCache[r])
        return log("ble-verbose", "Transport in cache, using that."), transportsCache[r];
      s = yield requiresBluetooth().requestDevice(requestDeviceParam());
    } else
      s = r;
    s.gatt.connected || (log("ble-verbose", "not connected. connecting..."), yield s.gatt.connect());
    const [o, fe] = yield retrieveService(s), { deviceModel: me, writeUuid: ye, notifyUuid: fr } = fe, [Er, br] = yield Promise.all([
      o.getCharacteristic(ye),
      o.getCharacteristic(fr)
    ]), wr = monitorCharacteristic(br).pipe(tap((Kr) => {
      log("ble-frame", "<= " + Kr.toString("hex"));
    }), share()), kr = wr.subscribe(), Gr = new BluetoothTransport(s, Er, wr, me);
    if (!s.gatt.connected)
      throw new DisconnectedDevice$1();
    transportsCache[Gr.id] = Gr;
    const Vr = (Kr) => {
      console.log("onDisconnect!", Kr), delete transportsCache[Gr.id], Gr.notYetDisconnected = !1, kr.unsubscribe(), s.removeEventListener("gattserverdisconnected", Vr), log("ble-verbose", `BleTransport(${Gr.id}) disconnected`), Gr.emit("disconnect", Kr);
    };
    s.addEventListener("gattserverdisconnected", Vr);
    const jr = Date.now();
    try {
      yield Gr.inferMTU();
    } finally {
      Date.now() - jr < 1e3 && (e = !1), e && (yield s.gatt.disconnect(), yield new Promise((bn) => setTimeout(bn, 4e3)));
    }
    return e ? open(s, !1) : Gr;
  });
}
class BluetoothTransport extends Transport$2 {
  static listen(e) {
    log("ble-verbose", "listen...");
    let s;
    requiresBluetooth().requestDevice(requestDeviceParam()).then((me) => {
      s || (e.next({
        type: "add",
        descriptor: me
      }), e.complete());
    }, (me) => {
      e.error(new TransportOpenUserCancelled$1(me.message));
    });
    function fe() {
      s = !0;
    }
    return {
      unsubscribe: fe
    };
  }
  static open(e) {
    return __awaiter$9(this, void 0, void 0, function* () {
      return open(e, !0);
    });
  }
  constructor(e, s, o, fe) {
    super(), this.mtuSize = 20, this.notYetDisconnected = !0, this.write = (me) => __awaiter$9(this, void 0, void 0, function* () {
      log("ble-frame", "=> " + me.toString("hex")), yield this.writeCharacteristic.writeValue(me);
    }), this.id = e.id, this.device = e, this.writeCharacteristic = s, this.notifyObservable = o, this.deviceModel = fe, log("ble-verbose", `BleTransport(${String(this.id)}) new instance`);
  }
  inferMTU() {
    return __awaiter$9(this, void 0, void 0, function* () {
      let e = 23;
      if (yield this.exchangeAtomicImpl(() => __awaiter$9(this, void 0, void 0, function* () {
        try {
          e = (yield merge$1(this.notifyObservable.pipe(first((s) => s.readUInt8(0) === 8), map$1((s) => s.readUInt8(5))), defer(() => from$2(this.write(Buffer.from([8, 0, 0, 0, 0])))).pipe(ignoreElements())).toPromise()) + 3;
        } catch (s) {
          throw log("ble-error", "inferMTU got " + String(s)), this.device.gatt.disconnect(), s;
        }
      })), e > 23) {
        const s = e - 3;
        log("ble-verbose", `BleTransport(${String(this.id)}) mtu set to ${String(s)}`), this.mtuSize = s;
      }
      return this.mtuSize;
    });
  }
  exchange(e) {
    return __awaiter$9(this, void 0, void 0, function* () {
      return yield this.exchangeAtomicImpl(() => __awaiter$9(this, void 0, void 0, function* () {
        try {
          const o = e.toString("hex");
          log("apdu", `=> ${o}`);
          const fe = yield merge$1(this.notifyObservable.pipe(receiveAPDU), sendAPDU(this.write, e, this.mtuSize)).toPromise(), me = fe.toString("hex");
          return log("apdu", `<= ${me}`), fe;
        } catch (o) {
          throw log("ble-error", "exchange got " + String(o)), this.notYetDisconnected && this.device.gatt.disconnect(), o;
        }
      }));
    });
  }
  setScrambleKey() {
  }
  close() {
    return __awaiter$9(this, void 0, void 0, function* () {
      this.exchangeBusyPromise && (yield this.exchangeBusyPromise);
    });
  }
}
BluetoothTransport.isSupported = () => Promise.resolve().then(requiresBluetooth).then(() => !0, () => !1);
BluetoothTransport.observeAvailability = (r) => availability().subscribe(r);
BluetoothTransport.list = () => Promise.resolve([]);
BluetoothTransport.disconnect = (r) => __awaiter$9(void 0, void 0, void 0, function* () {
  log("ble-verbose", `user disconnect(${r})`);
  const e = transportsCache[r];
  e && e.device.gatt.disconnect();
});
const TransportWebBLE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: BluetoothTransport
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(TransportWebBLE), createCustomErrorClass = (r) => {
  class e extends Error {
    constructor(o, fe, me) {
      if (super(o || r, me), Object.setPrototypeOf(this, e.prototype), this.name = r, fe)
        for (const ye in fe)
          this[ye] = fe[ye];
      if (me && isObject(me) && "cause" in me && !("cause" in this)) {
        const ye = me.cause;
        this.cause = ye, "stack" in ye && (this.stack = this.stack + `
CAUSE: ` + ye.stack);
      }
    }
  }
  return e;
};
function isObject(r) {
  return typeof r == "object";
}
const LockedDeviceError = createCustomErrorClass("LockedDeviceError"), DisconnectedDevice = createCustomErrorClass("DisconnectedDevice"), DisconnectedDeviceDuringOperation = createCustomErrorClass("DisconnectedDeviceDuringOperation"), TransportOpenUserCancelled = createCustomErrorClass("TransportOpenUserCancelled"), TransportInterfaceNotAvailable = createCustomErrorClass("TransportInterfaceNotAvailable"), TransportRaceCondition = createCustomErrorClass("TransportRaceCondition"), TransportWebUSBGestureRequired = createCustomErrorClass("TransportWebUSBGestureRequired");
var HwTransportErrorType;
(function(r) {
  r.Unknown = "Unknown", r.LocationServicesDisabled = "LocationServicesDisabled", r.LocationServicesUnauthorized = "LocationServicesUnauthorized", r.BluetoothScanStartFailed = "BluetoothScanStartFailed";
})(HwTransportErrorType || (HwTransportErrorType = {}));
class TransportError$1 extends Error {
  constructor(e, s) {
    const o = "TransportError";
    super(e || o), this.name = o, this.message = e, this.stack = new Error().stack, this.id = s;
  }
}
const StatusCodes = {
  ACCESS_CONDITION_NOT_FULFILLED: 38916,
  ALGORITHM_NOT_SUPPORTED: 38020,
  CLA_NOT_SUPPORTED: 28160,
  CODE_BLOCKED: 38976,
  CODE_NOT_INITIALIZED: 38914,
  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 27009,
  CONDITIONS_OF_USE_NOT_SATISFIED: 27013,
  CONTRADICTION_INVALIDATION: 38928,
  CONTRADICTION_SECRET_CODE_STATUS: 38920,
  CUSTOM_IMAGE_BOOTLOADER: 26159,
  CUSTOM_IMAGE_EMPTY: 26158,
  FILE_ALREADY_EXISTS: 27273,
  FILE_NOT_FOUND: 37892,
  GP_AUTH_FAILED: 25344,
  HALTED: 28586,
  INCONSISTENT_FILE: 37896,
  INCORRECT_DATA: 27264,
  INCORRECT_LENGTH: 26368,
  INCORRECT_P1_P2: 27392,
  INS_NOT_SUPPORTED: 27904,
  DEVICE_NOT_ONBOARDED: 27911,
  DEVICE_NOT_ONBOARDED_2: 26129,
  INVALID_KCV: 38021,
  INVALID_OFFSET: 37890,
  LICENSING: 28482,
  LOCKED_DEVICE: 21781,
  MAX_VALUE_REACHED: 38992,
  MEMORY_PROBLEM: 37440,
  MISSING_CRITICAL_PARAMETER: 26624,
  NO_EF_SELECTED: 37888,
  NOT_ENOUGH_MEMORY_SPACE: 27268,
  OK: 36864,
  PIN_REMAINING_ATTEMPTS: 25536,
  REFERENCED_DATA_NOT_FOUND: 27272,
  SECURITY_STATUS_NOT_SATISFIED: 27010,
  TECHNICAL_PROBLEM: 28416,
  UNKNOWN_APDU: 27906,
  USER_REFUSED_ON_DEVICE: 21761,
  NOT_ENOUGH_SPACE: 20738
};
function getAltStatusMessage(r) {
  switch (r) {
    case 26368:
      return "Incorrect length";
    case 26624:
      return "Missing critical parameter";
    case 27010:
      return "Security not satisfied (dongle locked or have invalid access rights)";
    case 27013:
      return "Condition of use not satisfied (denied by the user?)";
    case 27264:
      return "Invalid data received";
    case 27392:
      return "Invalid parameter received";
    case 21781:
      return "Locked device";
  }
  if (28416 <= r && r <= 28671)
    return "Internal error, please report";
}
function TransportStatusError(r) {
  const e = Object.keys(StatusCodes).find((me) => StatusCodes[me] === r) || "UNKNOWN_ERROR", s = getAltStatusMessage(r) || e, o = r.toString(16), fe = `Ledger device: ${s} (0x${o})`;
  if (r === StatusCodes.LOCKED_DEVICE)
    throw new LockedDeviceError(fe);
  this.name = "TransportStatusError", this.message = fe, this.stack = new Error().stack, this.statusCode = r, this.statusText = e;
}
TransportStatusError.prototype = new Error();
var __awaiter$8 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
class Transport$1 {
  constructor() {
    this.exchangeTimeout = 3e4, this.unresponsiveTimeout = 15e3, this.deviceModel = null, this._events = new events.exports(), this.send = (e, s, o, fe, me = Buffer.alloc(0), ye = [StatusCodes.OK]) => __awaiter$8(this, void 0, void 0, function* () {
      if (me.length >= 256)
        throw new TransportError$1("data.length exceed 256 bytes limit. Got: " + me.length, "DataLengthTooBig");
      const fr = yield this.exchange(Buffer.concat([
        Buffer.from([e, s, o, fe]),
        Buffer.from([me.length]),
        me
      ])), Er = fr.readUInt16BE(fr.length - 2);
      if (!ye.some((br) => br === Er))
        throw new TransportStatusError(Er);
      return fr;
    }), this.exchangeAtomicImpl = (e) => __awaiter$8(this, void 0, void 0, function* () {
      if (this.exchangeBusyPromise)
        throw new TransportRaceCondition("An action was already pending on the Ledger device. Please deny or reconnect.");
      let s;
      const o = new Promise((ye) => {
        s = ye;
      });
      this.exchangeBusyPromise = o;
      let fe = !1;
      const me = setTimeout(() => {
        fe = !0, this.emit("unresponsive");
      }, this.unresponsiveTimeout);
      try {
        const ye = yield e();
        return fe && this.emit("responsive"), ye;
      } finally {
        clearTimeout(me), s && s(), this.exchangeBusyPromise = null;
      }
    }), this._appAPIlock = null;
  }
  exchange(e) {
    throw new Error("exchange not implemented");
  }
  exchangeBulk(e, s) {
    let o = !1;
    const fe = () => {
      o = !0;
    };
    return (() => __awaiter$8(this, void 0, void 0, function* () {
      if (!o)
        for (const ye of e) {
          const fr = yield this.exchange(ye);
          if (o)
            return;
          const Er = fr.readUInt16BE(fr.length - 2);
          if (Er !== StatusCodes.OK)
            throw new TransportStatusError(Er);
          s.next(fr);
        }
    }))().then(() => !o && s.complete(), (ye) => !o && s.error(ye)), { unsubscribe: fe };
  }
  setScrambleKey(e) {
  }
  close() {
    return Promise.resolve();
  }
  on(e, s) {
    this._events.on(e, s);
  }
  off(e, s) {
    this._events.removeListener(e, s);
  }
  emit(e, ...s) {
    this._events.emit(e, ...s);
  }
  setDebugMode() {
    console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
  }
  setExchangeTimeout(e) {
    this.exchangeTimeout = e;
  }
  setExchangeUnresponsiveTimeout(e) {
    this.unresponsiveTimeout = e;
  }
  static create(e = 3e3, s) {
    return new Promise((o, fe) => {
      let me = !1;
      const ye = this.listen({
        next: (Er) => {
          me = !0, ye && ye.unsubscribe(), fr && clearTimeout(fr), this.open(Er.descriptor, e).then(o, fe);
        },
        error: (Er) => {
          fr && clearTimeout(fr), fe(Er);
        },
        complete: () => {
          fr && clearTimeout(fr), me || fe(new TransportError$1(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
        }
      }), fr = s ? setTimeout(() => {
        ye.unsubscribe(), fe(new TransportError$1(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
      }, s) : null;
    });
  }
  decorateAppAPIMethods(e, s, o) {
    for (const fe of s)
      e[fe] = this.decorateAppAPIMethod(fe, e[fe], e, o);
  }
  decorateAppAPIMethod(e, s, o, fe) {
    return (...me) => __awaiter$8(this, void 0, void 0, function* () {
      const { _appAPIlock: ye } = this;
      if (ye)
        return Promise.reject(new TransportError$1("Ledger Device is busy (lock " + ye + ")", "TransportLocked"));
      try {
        return this._appAPIlock = e, this.setScrambleKey(fe), yield s.apply(o, me);
      } finally {
        this._appAPIlock = null;
      }
    });
  }
}
Transport$1.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
Transport$1.ErrorMessage_NoDeviceFound = "No Ledger device found";
const Tag = 5;
function asUInt16BE(r) {
  const e = Buffer.alloc(2);
  return e.writeUInt16BE(r, 0), e;
}
const initialAcc = {
  data: Buffer.alloc(0),
  dataLength: 0,
  sequence: 0
}, createHIDframing = (r, e) => ({
  makeBlocks(s) {
    let o = Buffer.concat([asUInt16BE(s.length), s]);
    const fe = e - 5, me = Math.ceil(o.length / fe);
    o = Buffer.concat([
      o,
      Buffer.alloc(me * fe - o.length + 1).fill(0)
    ]);
    const ye = [];
    for (let fr = 0; fr < me; fr++) {
      const Er = Buffer.alloc(5);
      Er.writeUInt16BE(r, 0), Er.writeUInt8(Tag, 2), Er.writeUInt16BE(fr, 3);
      const br = o.slice(fr * fe, (fr + 1) * fe);
      ye.push(Buffer.concat([Er, br]));
    }
    return ye;
  },
  reduceResponse(s, o) {
    let { data: fe, dataLength: me, sequence: ye } = s || initialAcc;
    if (o.readUInt16BE(0) !== r)
      throw new TransportError$1("Invalid channel", "InvalidChannel");
    if (o.readUInt8(2) !== Tag)
      throw new TransportError$1("Invalid tag", "InvalidTag");
    if (o.readUInt16BE(3) !== ye)
      throw new TransportError$1("Invalid sequence", "InvalidSequence");
    s || (me = o.readUInt16BE(5)), ye++;
    const fr = o.slice(s ? 5 : 7);
    return fe = Buffer.concat([fe, fr]), fe.length > me && (fe = fe.slice(0, me)), {
      data: fe,
      dataLength: me,
      sequence: ye
    };
  },
  getReducedResult(s) {
    if (s && s.dataLength === s.data.length)
      return s.data;
  }
});
var re$4 = { exports: {} };
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || 9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6, RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$7 = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$1 = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...r) => console.error("SEMVER", ...r) : () => {
};
var debug_1 = debug$1;
(function(r, e) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: s,
    MAX_SAFE_BUILD_LENGTH: o,
    MAX_LENGTH: fe
  } = constants$7, me = debug_1;
  e = r.exports = {};
  const ye = e.re = [], fr = e.safeRe = [], Er = e.src = [], br = e.t = {};
  let wr = 0;
  const kr = "[a-zA-Z0-9-]", Gr = [
    ["\\s", 1],
    ["\\d", fe],
    [kr, o]
  ], Vr = (Kr) => {
    for (const [bn, Yr] of Gr)
      Kr = Kr.split(`${bn}*`).join(`${bn}{0,${Yr}}`).split(`${bn}+`).join(`${bn}{1,${Yr}}`);
    return Kr;
  }, jr = (Kr, bn, Yr) => {
    const Zr = Vr(bn), ti = wr++;
    me(Kr, ti, bn), br[Kr] = ti, Er[ti] = bn, ye[ti] = new RegExp(bn, Yr ? "g" : void 0), fr[ti] = new RegExp(Zr, Yr ? "g" : void 0);
  };
  jr("NUMERICIDENTIFIER", "0|[1-9]\\d*"), jr("NUMERICIDENTIFIERLOOSE", "\\d+"), jr("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${kr}*`), jr("MAINVERSION", `(${Er[br.NUMERICIDENTIFIER]})\\.(${Er[br.NUMERICIDENTIFIER]})\\.(${Er[br.NUMERICIDENTIFIER]})`), jr("MAINVERSIONLOOSE", `(${Er[br.NUMERICIDENTIFIERLOOSE]})\\.(${Er[br.NUMERICIDENTIFIERLOOSE]})\\.(${Er[br.NUMERICIDENTIFIERLOOSE]})`), jr("PRERELEASEIDENTIFIER", `(?:${Er[br.NUMERICIDENTIFIER]}|${Er[br.NONNUMERICIDENTIFIER]})`), jr("PRERELEASEIDENTIFIERLOOSE", `(?:${Er[br.NUMERICIDENTIFIERLOOSE]}|${Er[br.NONNUMERICIDENTIFIER]})`), jr("PRERELEASE", `(?:-(${Er[br.PRERELEASEIDENTIFIER]}(?:\\.${Er[br.PRERELEASEIDENTIFIER]})*))`), jr("PRERELEASELOOSE", `(?:-?(${Er[br.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${Er[br.PRERELEASEIDENTIFIERLOOSE]})*))`), jr("BUILDIDENTIFIER", `${kr}+`), jr("BUILD", `(?:\\+(${Er[br.BUILDIDENTIFIER]}(?:\\.${Er[br.BUILDIDENTIFIER]})*))`), jr("FULLPLAIN", `v?${Er[br.MAINVERSION]}${Er[br.PRERELEASE]}?${Er[br.BUILD]}?`), jr("FULL", `^${Er[br.FULLPLAIN]}$`), jr("LOOSEPLAIN", `[v=\\s]*${Er[br.MAINVERSIONLOOSE]}${Er[br.PRERELEASELOOSE]}?${Er[br.BUILD]}?`), jr("LOOSE", `^${Er[br.LOOSEPLAIN]}$`), jr("GTLT", "((?:<|>)?=?)"), jr("XRANGEIDENTIFIERLOOSE", `${Er[br.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), jr("XRANGEIDENTIFIER", `${Er[br.NUMERICIDENTIFIER]}|x|X|\\*`), jr("XRANGEPLAIN", `[v=\\s]*(${Er[br.XRANGEIDENTIFIER]})(?:\\.(${Er[br.XRANGEIDENTIFIER]})(?:\\.(${Er[br.XRANGEIDENTIFIER]})(?:${Er[br.PRERELEASE]})?${Er[br.BUILD]}?)?)?`), jr("XRANGEPLAINLOOSE", `[v=\\s]*(${Er[br.XRANGEIDENTIFIERLOOSE]})(?:\\.(${Er[br.XRANGEIDENTIFIERLOOSE]})(?:\\.(${Er[br.XRANGEIDENTIFIERLOOSE]})(?:${Er[br.PRERELEASELOOSE]})?${Er[br.BUILD]}?)?)?`), jr("XRANGE", `^${Er[br.GTLT]}\\s*${Er[br.XRANGEPLAIN]}$`), jr("XRANGELOOSE", `^${Er[br.GTLT]}\\s*${Er[br.XRANGEPLAINLOOSE]}$`), jr("COERCE", `(^|[^\\d])(\\d{1,${s}})(?:\\.(\\d{1,${s}}))?(?:\\.(\\d{1,${s}}))?(?:$|[^\\d])`), jr("COERCERTL", Er[br.COERCE], !0), jr("LONETILDE", "(?:~>?)"), jr("TILDETRIM", `(\\s*)${Er[br.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", jr("TILDE", `^${Er[br.LONETILDE]}${Er[br.XRANGEPLAIN]}$`), jr("TILDELOOSE", `^${Er[br.LONETILDE]}${Er[br.XRANGEPLAINLOOSE]}$`), jr("LONECARET", "(?:\\^)"), jr("CARETTRIM", `(\\s*)${Er[br.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", jr("CARET", `^${Er[br.LONECARET]}${Er[br.XRANGEPLAIN]}$`), jr("CARETLOOSE", `^${Er[br.LONECARET]}${Er[br.XRANGEPLAINLOOSE]}$`), jr("COMPARATORLOOSE", `^${Er[br.GTLT]}\\s*(${Er[br.LOOSEPLAIN]})$|^$`), jr("COMPARATOR", `^${Er[br.GTLT]}\\s*(${Er[br.FULLPLAIN]})$|^$`), jr("COMPARATORTRIM", `(\\s*)${Er[br.GTLT]}\\s*(${Er[br.LOOSEPLAIN]}|${Er[br.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", jr("HYPHENRANGE", `^\\s*(${Er[br.XRANGEPLAIN]})\\s+-\\s+(${Er[br.XRANGEPLAIN]})\\s*$`), jr("HYPHENRANGELOOSE", `^\\s*(${Er[br.XRANGEPLAINLOOSE]})\\s+-\\s+(${Er[br.XRANGEPLAINLOOSE]})\\s*$`), jr("STAR", "(<|>)?=?\\s*\\*"), jr("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), jr("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$4, re$4.exports);
const looseOption = Object.freeze({ loose: !0 }), emptyOpts = Object.freeze({}), parseOptions$1 = (r) => r ? typeof r != "object" ? looseOption : r : emptyOpts;
var parseOptions_1 = parseOptions$1;
const numeric$1 = /^[0-9]+$/, compareIdentifiers$1 = (r, e) => {
  const s = numeric$1.test(r), o = numeric$1.test(e);
  return s && o && (r = +r, e = +e), r === e ? 0 : s && !o ? -1 : o && !s ? 1 : r < e ? -1 : 1;
}, rcompareIdentifiers = (r, e) => compareIdentifiers$1(e, r);
var identifiers$1 = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER } = constants$7, { safeRe: re$3, t: t$1 } = re$4.exports, parseOptions = parseOptions_1, { compareIdentifiers } = identifiers$1;
class SemVer$d {
  constructor(e, s) {
    if (s = parseOptions(s), e instanceof SemVer$d) {
      if (e.loose === !!s.loose && e.includePrerelease === !!s.includePrerelease)
        return e;
      e = e.version;
    } else if (typeof e != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof e}".`);
    if (e.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", e, s), this.options = s, this.loose = !!s.loose, this.includePrerelease = !!s.includePrerelease;
    const o = e.trim().match(s.loose ? re$3[t$1.LOOSE] : re$3[t$1.FULL]);
    if (!o)
      throw new TypeError(`Invalid Version: ${e}`);
    if (this.raw = e, this.major = +o[1], this.minor = +o[2], this.patch = +o[3], this.major > MAX_SAFE_INTEGER || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
      throw new TypeError("Invalid patch version");
    o[4] ? this.prerelease = o[4].split(".").map((fe) => {
      if (/^[0-9]+$/.test(fe)) {
        const me = +fe;
        if (me >= 0 && me < MAX_SAFE_INTEGER)
          return me;
      }
      return fe;
    }) : this.prerelease = [], this.build = o[5] ? o[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(e) {
    if (debug("SemVer.compare", this.version, this.options, e), !(e instanceof SemVer$d)) {
      if (typeof e == "string" && e === this.version)
        return 0;
      e = new SemVer$d(e, this.options);
    }
    return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
  }
  compareMain(e) {
    return e instanceof SemVer$d || (e = new SemVer$d(e, this.options)), compareIdentifiers(this.major, e.major) || compareIdentifiers(this.minor, e.minor) || compareIdentifiers(this.patch, e.patch);
  }
  comparePre(e) {
    if (e instanceof SemVer$d || (e = new SemVer$d(e, this.options)), this.prerelease.length && !e.prerelease.length)
      return -1;
    if (!this.prerelease.length && e.prerelease.length)
      return 1;
    if (!this.prerelease.length && !e.prerelease.length)
      return 0;
    let s = 0;
    do {
      const o = this.prerelease[s], fe = e.prerelease[s];
      if (debug("prerelease compare", s, o, fe), o === void 0 && fe === void 0)
        return 0;
      if (fe === void 0)
        return 1;
      if (o === void 0)
        return -1;
      if (o === fe)
        continue;
      return compareIdentifiers(o, fe);
    } while (++s);
  }
  compareBuild(e) {
    e instanceof SemVer$d || (e = new SemVer$d(e, this.options));
    let s = 0;
    do {
      const o = this.build[s], fe = e.build[s];
      if (debug("prerelease compare", s, o, fe), o === void 0 && fe === void 0)
        return 0;
      if (fe === void 0)
        return 1;
      if (o === void 0)
        return -1;
      if (o === fe)
        continue;
      return compareIdentifiers(o, fe);
    } while (++s);
  }
  inc(e, s, o) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", s, o);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", s, o);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", s, o), this.inc("pre", s, o);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", s, o), this.inc("pre", s, o);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const fe = Number(o) ? 1 : 0;
        if (!s && o === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [fe];
        else {
          let me = this.prerelease.length;
          for (; --me >= 0; )
            typeof this.prerelease[me] == "number" && (this.prerelease[me]++, me = -2);
          if (me === -1) {
            if (s === this.prerelease.join(".") && o === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(fe);
          }
        }
        if (s) {
          let me = [s, fe];
          o === !1 && (me = [s]), compareIdentifiers(this.prerelease[0], s) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = me) : this.prerelease = me;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${e}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
}
var semver$1 = SemVer$d;
const SemVer$c = semver$1, parse$9 = (r, e, s = !1) => {
  if (r instanceof SemVer$c)
    return r;
  try {
    return new SemVer$c(r, e);
  } catch (o) {
    if (!s)
      return null;
    throw o;
  }
};
var parse_1 = parse$9;
const parse$8 = parse_1, valid$2 = (r, e) => {
  const s = parse$8(r, e);
  return s ? s.version : null;
};
var valid_1 = valid$2;
const parse$7 = parse_1, clean$1 = (r, e) => {
  const s = parse$7(r.trim().replace(/^[=v]+/, ""), e);
  return s ? s.version : null;
};
var clean_1 = clean$1;
const SemVer$b = semver$1, inc$1 = (r, e, s, o, fe) => {
  typeof s == "string" && (fe = o, o = s, s = void 0);
  try {
    return new SemVer$b(
      r instanceof SemVer$b ? r.version : r,
      s
    ).inc(e, o, fe).version;
  } catch {
    return null;
  }
};
var inc_1 = inc$1;
const parse$6 = parse_1, diff$1 = (r, e) => {
  const s = parse$6(r, null, !0), o = parse$6(e, null, !0), fe = s.compare(o);
  if (fe === 0)
    return null;
  const me = fe > 0, ye = me ? s : o, fr = me ? o : s, Er = !!ye.prerelease.length;
  if (!!fr.prerelease.length && !Er)
    return !fr.patch && !fr.minor ? "major" : ye.patch ? "patch" : ye.minor ? "minor" : "major";
  const wr = Er ? "pre" : "";
  return s.major !== o.major ? wr + "major" : s.minor !== o.minor ? wr + "minor" : s.patch !== o.patch ? wr + "patch" : "prerelease";
};
var diff_1 = diff$1;
const SemVer$a = semver$1, major$1 = (r, e) => new SemVer$a(r, e).major;
var major_1 = major$1;
const SemVer$9 = semver$1, minor$1 = (r, e) => new SemVer$9(r, e).minor;
var minor_1 = minor$1;
const SemVer$8 = semver$1, patch$1 = (r, e) => new SemVer$8(r, e).patch;
var patch_1 = patch$1;
const parse$5 = parse_1, prerelease$1 = (r, e) => {
  const s = parse$5(r, e);
  return s && s.prerelease.length ? s.prerelease : null;
};
var prerelease_1 = prerelease$1;
const SemVer$7 = semver$1, compare$c = (r, e, s) => new SemVer$7(r, s).compare(new SemVer$7(e, s));
var compare_1 = compare$c;
const compare$b = compare_1, rcompare$1 = (r, e, s) => compare$b(e, r, s);
var rcompare_1 = rcompare$1;
const compare$a = compare_1, compareLoose$1 = (r, e) => compare$a(r, e, !0);
var compareLoose_1 = compareLoose$1;
const SemVer$6 = semver$1, compareBuild$3 = (r, e, s) => {
  const o = new SemVer$6(r, s), fe = new SemVer$6(e, s);
  return o.compare(fe) || o.compareBuild(fe);
};
var compareBuild_1 = compareBuild$3;
const compareBuild$2 = compareBuild_1, sort$1 = (r, e) => r.sort((s, o) => compareBuild$2(s, o, e));
var sort_1 = sort$1;
const compareBuild$1 = compareBuild_1, rsort$1 = (r, e) => r.sort((s, o) => compareBuild$1(o, s, e));
var rsort_1 = rsort$1;
const compare$9 = compare_1, gt$6 = (r, e, s) => compare$9(r, e, s) > 0;
var gt_1 = gt$6;
const compare$8 = compare_1, lt$5 = (r, e, s) => compare$8(r, e, s) < 0;
var lt_1 = lt$5;
const compare$7 = compare_1, eq$2 = (r, e, s) => compare$7(r, e, s) === 0;
var eq_1 = eq$2;
const compare$6 = compare_1, neq$2 = (r, e, s) => compare$6(r, e, s) !== 0;
var neq_1 = neq$2;
const compare$5 = compare_1, gte$3 = (r, e, s) => compare$5(r, e, s) >= 0;
var gte_1 = gte$3;
const compare$4 = compare_1, lte$3 = (r, e, s) => compare$4(r, e, s) <= 0;
var lte_1 = lte$3;
const eq$1 = eq_1, neq$1 = neq_1, gt$5 = gt_1, gte$2 = gte_1, lt$4 = lt_1, lte$2 = lte_1, cmp$1 = (r, e, s, o) => {
  switch (e) {
    case "===":
      return typeof r == "object" && (r = r.version), typeof s == "object" && (s = s.version), r === s;
    case "!==":
      return typeof r == "object" && (r = r.version), typeof s == "object" && (s = s.version), r !== s;
    case "":
    case "=":
    case "==":
      return eq$1(r, s, o);
    case "!=":
      return neq$1(r, s, o);
    case ">":
      return gt$5(r, s, o);
    case ">=":
      return gte$2(r, s, o);
    case "<":
      return lt$4(r, s, o);
    case "<=":
      return lte$2(r, s, o);
    default:
      throw new TypeError(`Invalid operator: ${e}`);
  }
};
var cmp_1 = cmp$1;
const SemVer$5 = semver$1, parse$4 = parse_1, { safeRe: re$2, t } = re$4.exports, coerce$2 = (r, e) => {
  if (r instanceof SemVer$5)
    return r;
  if (typeof r == "number" && (r = String(r)), typeof r != "string")
    return null;
  e = e || {};
  let s = null;
  if (!e.rtl)
    s = r.match(re$2[t.COERCE]);
  else {
    let o;
    for (; (o = re$2[t.COERCERTL].exec(r)) && (!s || s.index + s[0].length !== r.length); )
      (!s || o.index + o[0].length !== s.index + s[0].length) && (s = o), re$2[t.COERCERTL].lastIndex = o.index + o[1].length + o[2].length;
    re$2[t.COERCERTL].lastIndex = -1;
  }
  return s === null ? null : parse$4(`${s[2]}.${s[3] || "0"}.${s[4] || "0"}`, e);
};
var coerce_1 = coerce$2, range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange)
    return range;
  hasRequiredRange = 1;
  class r {
    constructor(qr, Jr) {
      if (Jr = o(Jr), qr instanceof r)
        return qr.loose === !!Jr.loose && qr.includePrerelease === !!Jr.includePrerelease ? qr : new r(qr.raw, Jr);
      if (qr instanceof fe)
        return this.raw = qr.value, this.set = [[qr]], this.format(), this;
      if (this.options = Jr, this.loose = !!Jr.loose, this.includePrerelease = !!Jr.includePrerelease, this.raw = qr.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((ri) => this.parseRange(ri.trim())).filter((ri) => ri.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const ri = this.set[0];
        if (this.set = this.set.filter((Sn) => !jr(Sn[0])), this.set.length === 0)
          this.set = [ri];
        else if (this.set.length > 1) {
          for (const Sn of this.set)
            if (Sn.length === 1 && Kr(Sn[0])) {
              this.set = [Sn];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((qr) => qr.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(qr) {
      const ri = ((this.options.includePrerelease && Gr) | (this.options.loose && Vr)) + ":" + qr, Sn = s.get(ri);
      if (Sn)
        return Sn;
      const ai = this.options.loose, di = ai ? fr[Er.HYPHENRANGELOOSE] : fr[Er.HYPHENRANGE];
      qr = qr.replace(di, oi(this.options.includePrerelease)), me("hyphen replace", qr), qr = qr.replace(fr[Er.COMPARATORTRIM], br), me("comparator trim", qr), qr = qr.replace(fr[Er.TILDETRIM], wr), me("tilde trim", qr), qr = qr.replace(fr[Er.CARETTRIM], kr), me("caret trim", qr);
      let ii = qr.split(" ").map((Si) => Yr(Si, this.options)).join(" ").split(/\s+/).map((Si) => ei(Si, this.options));
      ai && (ii = ii.filter((Si) => (me("loose invalid filter", Si, this.options), !!Si.match(fr[Er.COMPARATORLOOSE])))), me("range list", ii);
      const fi = /* @__PURE__ */ new Map(), Ei = ii.map((Si) => new fe(Si, this.options));
      for (const Si of Ei) {
        if (jr(Si))
          return [Si];
        fi.set(Si.value, Si);
      }
      fi.size > 1 && fi.has("") && fi.delete("");
      const bi = [...fi.values()];
      return s.set(ri, bi), bi;
    }
    intersects(qr, Jr) {
      if (!(qr instanceof r))
        throw new TypeError("a Range is required");
      return this.set.some((ri) => bn(ri, Jr) && qr.set.some((Sn) => bn(Sn, Jr) && ri.every((ai) => Sn.every((di) => ai.intersects(di, Jr)))));
    }
    test(qr) {
      if (!qr)
        return !1;
      if (typeof qr == "string")
        try {
          qr = new ye(qr, this.options);
        } catch {
          return !1;
        }
      for (let Jr = 0; Jr < this.set.length; Jr++)
        if (Nn(this.set[Jr], qr, this.options))
          return !0;
      return !1;
    }
  }
  range = r;
  const e = lruCache, s = new e({ max: 1e3 }), o = parseOptions_1, fe = requireComparator(), me = debug_1, ye = semver$1, {
    safeRe: fr,
    t: Er,
    comparatorTrimReplace: br,
    tildeTrimReplace: wr,
    caretTrimReplace: kr
  } = re$4.exports, { FLAG_INCLUDE_PRERELEASE: Gr, FLAG_LOOSE: Vr } = constants$7, jr = (En) => En.value === "<0.0.0-0", Kr = (En) => En.value === "", bn = (En, qr) => {
    let Jr = !0;
    const ri = En.slice();
    let Sn = ri.pop();
    for (; Jr && ri.length; )
      Jr = ri.every((ai) => Sn.intersects(ai, qr)), Sn = ri.pop();
    return Jr;
  }, Yr = (En, qr) => (me("comp", En, qr), En = ni(En, qr), me("caret", En), En = ti(En, qr), me("tildes", En), En = Br(En, qr), me("xrange", En), En = Pn(En, qr), me("stars", En), En), Zr = (En) => !En || En.toLowerCase() === "x" || En === "*", ti = (En, qr) => En.trim().split(/\s+/).map((Jr) => On(Jr, qr)).join(" "), On = (En, qr) => {
    const Jr = qr.loose ? fr[Er.TILDELOOSE] : fr[Er.TILDE];
    return En.replace(Jr, (ri, Sn, ai, di, ii) => {
      me("tilde", En, ri, Sn, ai, di, ii);
      let fi;
      return Zr(Sn) ? fi = "" : Zr(ai) ? fi = `>=${Sn}.0.0 <${+Sn + 1}.0.0-0` : Zr(di) ? fi = `>=${Sn}.${ai}.0 <${Sn}.${+ai + 1}.0-0` : ii ? (me("replaceTilde pr", ii), fi = `>=${Sn}.${ai}.${di}-${ii} <${Sn}.${+ai + 1}.0-0`) : fi = `>=${Sn}.${ai}.${di} <${Sn}.${+ai + 1}.0-0`, me("tilde return", fi), fi;
    });
  }, ni = (En, qr) => En.trim().split(/\s+/).map((Jr) => In(Jr, qr)).join(" "), In = (En, qr) => {
    me("caret", En, qr);
    const Jr = qr.loose ? fr[Er.CARETLOOSE] : fr[Er.CARET], ri = qr.includePrerelease ? "-0" : "";
    return En.replace(Jr, (Sn, ai, di, ii, fi) => {
      me("caret", En, Sn, ai, di, ii, fi);
      let Ei;
      return Zr(ai) ? Ei = "" : Zr(di) ? Ei = `>=${ai}.0.0${ri} <${+ai + 1}.0.0-0` : Zr(ii) ? ai === "0" ? Ei = `>=${ai}.${di}.0${ri} <${ai}.${+di + 1}.0-0` : Ei = `>=${ai}.${di}.0${ri} <${+ai + 1}.0.0-0` : fi ? (me("replaceCaret pr", fi), ai === "0" ? di === "0" ? Ei = `>=${ai}.${di}.${ii}-${fi} <${ai}.${di}.${+ii + 1}-0` : Ei = `>=${ai}.${di}.${ii}-${fi} <${ai}.${+di + 1}.0-0` : Ei = `>=${ai}.${di}.${ii}-${fi} <${+ai + 1}.0.0-0`) : (me("no pr"), ai === "0" ? di === "0" ? Ei = `>=${ai}.${di}.${ii}${ri} <${ai}.${di}.${+ii + 1}-0` : Ei = `>=${ai}.${di}.${ii}${ri} <${ai}.${+di + 1}.0-0` : Ei = `>=${ai}.${di}.${ii} <${+ai + 1}.0.0-0`), me("caret return", Ei), Ei;
    });
  }, Br = (En, qr) => (me("replaceXRanges", En, qr), En.split(/\s+/).map((Jr) => Hr(Jr, qr)).join(" ")), Hr = (En, qr) => {
    En = En.trim();
    const Jr = qr.loose ? fr[Er.XRANGELOOSE] : fr[Er.XRANGE];
    return En.replace(Jr, (ri, Sn, ai, di, ii, fi) => {
      me("xRange", En, ri, Sn, ai, di, ii, fi);
      const Ei = Zr(ai), bi = Ei || Zr(di), Si = bi || Zr(ii), Ii = Si;
      return Sn === "=" && Ii && (Sn = ""), fi = qr.includePrerelease ? "-0" : "", Ei ? Sn === ">" || Sn === "<" ? ri = "<0.0.0-0" : ri = "*" : Sn && Ii ? (bi && (di = 0), ii = 0, Sn === ">" ? (Sn = ">=", bi ? (ai = +ai + 1, di = 0, ii = 0) : (di = +di + 1, ii = 0)) : Sn === "<=" && (Sn = "<", bi ? ai = +ai + 1 : di = +di + 1), Sn === "<" && (fi = "-0"), ri = `${Sn + ai}.${di}.${ii}${fi}`) : bi ? ri = `>=${ai}.0.0${fi} <${+ai + 1}.0.0-0` : Si && (ri = `>=${ai}.${di}.0${fi} <${ai}.${+di + 1}.0-0`), me("xRange return", ri), ri;
    });
  }, Pn = (En, qr) => (me("replaceStars", En, qr), En.trim().replace(fr[Er.STAR], "")), ei = (En, qr) => (me("replaceGTE0", En, qr), En.trim().replace(fr[qr.includePrerelease ? Er.GTE0PRE : Er.GTE0], "")), oi = (En) => (qr, Jr, ri, Sn, ai, di, ii, fi, Ei, bi, Si, Ii, yi) => (Zr(ri) ? Jr = "" : Zr(Sn) ? Jr = `>=${ri}.0.0${En ? "-0" : ""}` : Zr(ai) ? Jr = `>=${ri}.${Sn}.0${En ? "-0" : ""}` : di ? Jr = `>=${Jr}` : Jr = `>=${Jr}${En ? "-0" : ""}`, Zr(Ei) ? fi = "" : Zr(bi) ? fi = `<${+Ei + 1}.0.0-0` : Zr(Si) ? fi = `<${Ei}.${+bi + 1}.0-0` : Ii ? fi = `<=${Ei}.${bi}.${Si}-${Ii}` : En ? fi = `<${Ei}.${bi}.${+Si + 1}-0` : fi = `<=${fi}`, `${Jr} ${fi}`.trim()), Nn = (En, qr, Jr) => {
    for (let ri = 0; ri < En.length; ri++)
      if (!En[ri].test(qr))
        return !1;
    if (qr.prerelease.length && !Jr.includePrerelease) {
      for (let ri = 0; ri < En.length; ri++)
        if (me(En[ri].semver), En[ri].semver !== fe.ANY && En[ri].semver.prerelease.length > 0) {
          const Sn = En[ri].semver;
          if (Sn.major === qr.major && Sn.minor === qr.minor && Sn.patch === qr.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator)
    return comparator;
  hasRequiredComparator = 1;
  const r = Symbol("SemVer ANY");
  class e {
    static get ANY() {
      return r;
    }
    constructor(wr, kr) {
      if (kr = s(kr), wr instanceof e) {
        if (wr.loose === !!kr.loose)
          return wr;
        wr = wr.value;
      }
      wr = wr.trim().split(/\s+/).join(" "), ye("comparator", wr, kr), this.options = kr, this.loose = !!kr.loose, this.parse(wr), this.semver === r ? this.value = "" : this.value = this.operator + this.semver.version, ye("comp", this);
    }
    parse(wr) {
      const kr = this.options.loose ? o[fe.COMPARATORLOOSE] : o[fe.COMPARATOR], Gr = wr.match(kr);
      if (!Gr)
        throw new TypeError(`Invalid comparator: ${wr}`);
      this.operator = Gr[1] !== void 0 ? Gr[1] : "", this.operator === "=" && (this.operator = ""), Gr[2] ? this.semver = new fr(Gr[2], this.options.loose) : this.semver = r;
    }
    toString() {
      return this.value;
    }
    test(wr) {
      if (ye("Comparator.test", wr, this.options.loose), this.semver === r || wr === r)
        return !0;
      if (typeof wr == "string")
        try {
          wr = new fr(wr, this.options);
        } catch {
          return !1;
        }
      return me(wr, this.operator, this.semver, this.options);
    }
    intersects(wr, kr) {
      if (!(wr instanceof e))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new Er(wr.value, kr).test(this.value) : wr.operator === "" ? wr.value === "" ? !0 : new Er(this.value, kr).test(wr.semver) : (kr = s(kr), kr.includePrerelease && (this.value === "<0.0.0-0" || wr.value === "<0.0.0-0") || !kr.includePrerelease && (this.value.startsWith("<0.0.0") || wr.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && wr.operator.startsWith(">") || this.operator.startsWith("<") && wr.operator.startsWith("<") || this.semver.version === wr.semver.version && this.operator.includes("=") && wr.operator.includes("=") || me(this.semver, "<", wr.semver, kr) && this.operator.startsWith(">") && wr.operator.startsWith("<") || me(this.semver, ">", wr.semver, kr) && this.operator.startsWith("<") && wr.operator.startsWith(">")));
    }
  }
  comparator = e;
  const s = parseOptions_1, { safeRe: o, t: fe } = re$4.exports, me = cmp_1, ye = debug_1, fr = semver$1, Er = requireRange();
  return comparator;
}
const Range$9 = requireRange(), satisfies$4 = (r, e, s) => {
  try {
    e = new Range$9(e, s);
  } catch {
    return !1;
  }
  return e.test(r);
};
var satisfies_1 = satisfies$4;
const Range$8 = requireRange(), toComparators$1 = (r, e) => new Range$8(r, e).set.map((s) => s.map((o) => o.value).join(" ").trim().split(" "));
var toComparators_1 = toComparators$1;
const SemVer$4 = semver$1, Range$7 = requireRange(), maxSatisfying$1 = (r, e, s) => {
  let o = null, fe = null, me = null;
  try {
    me = new Range$7(e, s);
  } catch {
    return null;
  }
  return r.forEach((ye) => {
    me.test(ye) && (!o || fe.compare(ye) === -1) && (o = ye, fe = new SemVer$4(o, s));
  }), o;
};
var maxSatisfying_1 = maxSatisfying$1;
const SemVer$3 = semver$1, Range$6 = requireRange(), minSatisfying$1 = (r, e, s) => {
  let o = null, fe = null, me = null;
  try {
    me = new Range$6(e, s);
  } catch {
    return null;
  }
  return r.forEach((ye) => {
    me.test(ye) && (!o || fe.compare(ye) === 1) && (o = ye, fe = new SemVer$3(o, s));
  }), o;
};
var minSatisfying_1 = minSatisfying$1;
const SemVer$2 = semver$1, Range$5 = requireRange(), gt$4 = gt_1, minVersion$1 = (r, e) => {
  r = new Range$5(r, e);
  let s = new SemVer$2("0.0.0");
  if (r.test(s) || (s = new SemVer$2("0.0.0-0"), r.test(s)))
    return s;
  s = null;
  for (let o = 0; o < r.set.length; ++o) {
    const fe = r.set[o];
    let me = null;
    fe.forEach((ye) => {
      const fr = new SemVer$2(ye.semver.version);
      switch (ye.operator) {
        case ">":
          fr.prerelease.length === 0 ? fr.patch++ : fr.prerelease.push(0), fr.raw = fr.format();
        case "":
        case ">=":
          (!me || gt$4(fr, me)) && (me = fr);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${ye.operator}`);
      }
    }), me && (!s || gt$4(s, me)) && (s = me);
  }
  return s && r.test(s) ? s : null;
};
var minVersion_1 = minVersion$1;
const Range$4 = requireRange(), validRange$1 = (r, e) => {
  try {
    return new Range$4(r, e).range || "*";
  } catch {
    return null;
  }
};
var valid$1 = validRange$1;
const SemVer$1 = semver$1, Comparator$2 = requireComparator(), { ANY: ANY$1 } = Comparator$2, Range$3 = requireRange(), satisfies$3 = satisfies_1, gt$3 = gt_1, lt$3 = lt_1, lte$1 = lte_1, gte$1 = gte_1, outside$3 = (r, e, s, o) => {
  r = new SemVer$1(r, o), e = new Range$3(e, o);
  let fe, me, ye, fr, Er;
  switch (s) {
    case ">":
      fe = gt$3, me = lte$1, ye = lt$3, fr = ">", Er = ">=";
      break;
    case "<":
      fe = lt$3, me = gte$1, ye = gt$3, fr = "<", Er = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$3(r, e, o))
    return !1;
  for (let br = 0; br < e.set.length; ++br) {
    const wr = e.set[br];
    let kr = null, Gr = null;
    if (wr.forEach((Vr) => {
      Vr.semver === ANY$1 && (Vr = new Comparator$2(">=0.0.0")), kr = kr || Vr, Gr = Gr || Vr, fe(Vr.semver, kr.semver, o) ? kr = Vr : ye(Vr.semver, Gr.semver, o) && (Gr = Vr);
    }), kr.operator === fr || kr.operator === Er || (!Gr.operator || Gr.operator === fr) && me(r, Gr.semver))
      return !1;
    if (Gr.operator === Er && ye(r, Gr.semver))
      return !1;
  }
  return !0;
};
var outside_1 = outside$3;
const outside$2 = outside_1, gtr$1 = (r, e, s) => outside$2(r, e, ">", s);
var gtr_1 = gtr$1;
const outside$1 = outside_1, ltr$1 = (r, e, s) => outside$1(r, e, "<", s);
var ltr_1 = ltr$1;
const Range$2 = requireRange(), intersects$1 = (r, e, s) => (r = new Range$2(r, s), e = new Range$2(e, s), r.intersects(e, s));
var intersects_1 = intersects$1;
const satisfies$2 = satisfies_1, compare$3 = compare_1;
var simplify = (r, e, s) => {
  const o = [];
  let fe = null, me = null;
  const ye = r.sort((wr, kr) => compare$3(wr, kr, s));
  for (const wr of ye)
    satisfies$2(wr, e, s) ? (me = wr, fe || (fe = wr)) : (me && o.push([fe, me]), me = null, fe = null);
  fe && o.push([fe, null]);
  const fr = [];
  for (const [wr, kr] of o)
    wr === kr ? fr.push(wr) : !kr && wr === ye[0] ? fr.push("*") : kr ? wr === ye[0] ? fr.push(`<=${kr}`) : fr.push(`${wr} - ${kr}`) : fr.push(`>=${wr}`);
  const Er = fr.join(" || "), br = typeof e.raw == "string" ? e.raw : String(e);
  return Er.length < br.length ? Er : e;
};
const Range$1 = requireRange(), Comparator$1 = requireComparator(), { ANY } = Comparator$1, satisfies$1 = satisfies_1, compare$2 = compare_1, subset$1 = (r, e, s = {}) => {
  if (r === e)
    return !0;
  r = new Range$1(r, s), e = new Range$1(e, s);
  let o = !1;
  e:
    for (const fe of r.set) {
      for (const me of e.set) {
        const ye = simpleSubset(fe, me, s);
        if (o = o || ye !== null, ye)
          continue e;
      }
      if (o)
        return !1;
    }
  return !0;
}, minimumVersionWithPreRelease = [new Comparator$1(">=0.0.0-0")], minimumVersion = [new Comparator$1(">=0.0.0")], simpleSubset = (r, e, s) => {
  if (r === e)
    return !0;
  if (r.length === 1 && r[0].semver === ANY) {
    if (e.length === 1 && e[0].semver === ANY)
      return !0;
    s.includePrerelease ? r = minimumVersionWithPreRelease : r = minimumVersion;
  }
  if (e.length === 1 && e[0].semver === ANY) {
    if (s.includePrerelease)
      return !0;
    e = minimumVersion;
  }
  const o = /* @__PURE__ */ new Set();
  let fe, me;
  for (const Vr of r)
    Vr.operator === ">" || Vr.operator === ">=" ? fe = higherGT(fe, Vr, s) : Vr.operator === "<" || Vr.operator === "<=" ? me = lowerLT(me, Vr, s) : o.add(Vr.semver);
  if (o.size > 1)
    return null;
  let ye;
  if (fe && me) {
    if (ye = compare$2(fe.semver, me.semver, s), ye > 0)
      return null;
    if (ye === 0 && (fe.operator !== ">=" || me.operator !== "<="))
      return null;
  }
  for (const Vr of o) {
    if (fe && !satisfies$1(Vr, String(fe), s) || me && !satisfies$1(Vr, String(me), s))
      return null;
    for (const jr of e)
      if (!satisfies$1(Vr, String(jr), s))
        return !1;
    return !0;
  }
  let fr, Er, br, wr, kr = me && !s.includePrerelease && me.semver.prerelease.length ? me.semver : !1, Gr = fe && !s.includePrerelease && fe.semver.prerelease.length ? fe.semver : !1;
  kr && kr.prerelease.length === 1 && me.operator === "<" && kr.prerelease[0] === 0 && (kr = !1);
  for (const Vr of e) {
    if (wr = wr || Vr.operator === ">" || Vr.operator === ">=", br = br || Vr.operator === "<" || Vr.operator === "<=", fe) {
      if (Gr && Vr.semver.prerelease && Vr.semver.prerelease.length && Vr.semver.major === Gr.major && Vr.semver.minor === Gr.minor && Vr.semver.patch === Gr.patch && (Gr = !1), Vr.operator === ">" || Vr.operator === ">=") {
        if (fr = higherGT(fe, Vr, s), fr === Vr && fr !== fe)
          return !1;
      } else if (fe.operator === ">=" && !satisfies$1(fe.semver, String(Vr), s))
        return !1;
    }
    if (me) {
      if (kr && Vr.semver.prerelease && Vr.semver.prerelease.length && Vr.semver.major === kr.major && Vr.semver.minor === kr.minor && Vr.semver.patch === kr.patch && (kr = !1), Vr.operator === "<" || Vr.operator === "<=") {
        if (Er = lowerLT(me, Vr, s), Er === Vr && Er !== me)
          return !1;
      } else if (me.operator === "<=" && !satisfies$1(me.semver, String(Vr), s))
        return !1;
    }
    if (!Vr.operator && (me || fe) && ye !== 0)
      return !1;
  }
  return !(fe && br && !me && ye !== 0 || me && wr && !fe && ye !== 0 || Gr || kr);
}, higherGT = (r, e, s) => {
  if (!r)
    return e;
  const o = compare$2(r.semver, e.semver, s);
  return o > 0 ? r : o < 0 || e.operator === ">" && r.operator === ">=" ? e : r;
}, lowerLT = (r, e, s) => {
  if (!r)
    return e;
  const o = compare$2(r.semver, e.semver, s);
  return o < 0 ? r : o > 0 || e.operator === "<" && r.operator === "<=" ? e : r;
};
var subset_1 = subset$1;
const internalRe = re$4.exports, constants$6 = constants$7, SemVer = semver$1, identifiers = identifiers$1, parse$3 = parse_1, valid = valid_1, clean = clean_1, inc = inc_1, diff = diff_1, major = major_1, minor = minor_1, patch = patch_1, prerelease = prerelease_1, compare$1 = compare_1, rcompare = rcompare_1, compareLoose = compareLoose_1, compareBuild = compareBuild_1, sort = sort_1, rsort = rsort_1, gt$2 = gt_1, lt$2 = lt_1, eq = eq_1, neq = neq_1, gte = gte_1, lte = lte_1, cmp = cmp_1, coerce$1 = coerce_1, Comparator = requireComparator(), Range = requireRange(), satisfies = satisfies_1, toComparators = toComparators_1, maxSatisfying = maxSatisfying_1, minSatisfying = minSatisfying_1, minVersion = minVersion_1, validRange = valid$1, outside = outside_1, gtr = gtr_1, ltr = ltr_1, intersects = intersects_1, simplifyRange = simplify, subset = subset_1;
var semver = {
  parse: parse$3,
  valid,
  clean,
  inc,
  diff,
  major,
  minor,
  patch,
  prerelease,
  compare: compare$1,
  rcompare,
  compareLoose,
  compareBuild,
  sort,
  rsort,
  gt: gt$2,
  lt: lt$2,
  eq,
  neq,
  gte,
  lte,
  cmp,
  coerce: coerce$1,
  Comparator,
  Range,
  satisfies,
  toComparators,
  maxSatisfying,
  minSatisfying,
  minVersion,
  validRange,
  outside,
  gtr,
  ltr,
  intersects,
  simplifyRange,
  subset,
  SemVer,
  re: internalRe.re,
  src: internalRe.src,
  tokens: internalRe.t,
  SEMVER_SPEC_VERSION: constants$6.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants$6.RELEASE_TYPES,
  compareIdentifiers: identifiers.compareIdentifiers,
  rcompareIdentifiers: identifiers.rcompareIdentifiers
}, DeviceModelId;
(function(r) {
  r.blue = "blue", r.nanoS = "nanoS", r.nanoSP = "nanoSP", r.nanoX = "nanoX", r.stax = "stax";
})(DeviceModelId || (DeviceModelId = {}));
const devices = {
  [DeviceModelId.blue]: {
    id: DeviceModelId.blue,
    productName: "Ledger\xA0Blue",
    productIdMM: 0,
    legacyUsbProductId: 0,
    usbOnly: !0,
    memorySize: 480 * 1024,
    masks: [822083584, 822149120],
    getBlockSize: (r) => 4 * 1024
  },
  [DeviceModelId.nanoS]: {
    id: DeviceModelId.nanoS,
    productName: "Ledger\xA0Nano\xA0S",
    productIdMM: 16,
    legacyUsbProductId: 1,
    usbOnly: !0,
    memorySize: 320 * 1024,
    masks: [823132160],
    getBlockSize: (r) => {
      var e;
      return semver.lt((e = semver.coerce(r)) !== null && e !== void 0 ? e : "", "2.0.0") ? 4 * 1024 : 2 * 1024;
    }
  },
  [DeviceModelId.nanoSP]: {
    id: DeviceModelId.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 80,
    legacyUsbProductId: 5,
    usbOnly: !0,
    memorySize: 1536 * 1024,
    masks: [856686592],
    getBlockSize: (r) => 32
  },
  [DeviceModelId.nanoX]: {
    id: DeviceModelId.nanoX,
    productName: "Ledger\xA0Nano\xA0X",
    productIdMM: 64,
    legacyUsbProductId: 4,
    usbOnly: !1,
    memorySize: 2 * 1024 * 1024,
    masks: [855638016],
    getBlockSize: (r) => 4 * 1024,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.stax]: {
    id: DeviceModelId.stax,
    productName: "Ledger\xA0Stax",
    productIdMM: 96,
    legacyUsbProductId: 6,
    usbOnly: !1,
    memorySize: 1536 * 1024,
    masks: [857735168],
    getBlockSize: (r) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
      }
    ]
  }
};
DeviceModelId.blue, DeviceModelId.nanoS, DeviceModelId.nanoSP, DeviceModelId.nanoX, DeviceModelId.stax;
const devicesList = Object.values(devices), ledgerUSBVendorId = 11415, identifyUSBProductId = (r) => {
  const e = devicesList.find((fe) => fe.legacyUsbProductId === r);
  if (e)
    return e;
  const s = r >> 8;
  return devicesList.find((fe) => fe.productIdMM === s);
}, bluetoothServices = [], serviceUuidToInfos = {};
for (const r in devices) {
  const e = devices[r], { bluetoothSpec: s } = e;
  if (s)
    for (let o = 0; o < s.length; o++) {
      const fe = s[o];
      bluetoothServices.push(fe.serviceUuid), serviceUuidToInfos[fe.serviceUuid] = serviceUuidToInfos[fe.serviceUuid.replace(/-/g, "")] = Object.assign({ deviceModel: e }, fe);
    }
}
var __awaiter$7 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
const ledgerDevices$1 = [
  {
    vendorId: ledgerUSBVendorId
  }
], isSupported$1 = () => Promise.resolve(!!(window.navigator && window.navigator.hid)), getHID = () => {
  const { hid: r } = navigator;
  if (!r)
    throw new TransportError$1("navigator.hid is not supported", "HIDNotSupported");
  return r;
};
function requestLedgerDevices() {
  return __awaiter$7(this, void 0, void 0, function* () {
    const r = yield getHID().requestDevice({
      filters: ledgerDevices$1
    });
    return Array.isArray(r) ? r : [r];
  });
}
function getLedgerDevices$1() {
  return __awaiter$7(this, void 0, void 0, function* () {
    return (yield getHID().getDevices()).filter((e) => e.vendorId === ledgerUSBVendorId);
  });
}
function getFirstLedgerDevice$1() {
  return __awaiter$7(this, void 0, void 0, function* () {
    const r = yield getLedgerDevices$1();
    return r.length > 0 ? r[0] : (yield requestLedgerDevices())[0];
  });
}
class TransportWebHID extends Transport$1 {
  constructor(e) {
    super(), this.channel = Math.floor(Math.random() * 65535), this.packetSize = 64, this.inputs = [], this.read = () => this.inputs.length ? Promise.resolve(this.inputs.shift()) : new Promise((s) => {
      this.inputCallback = s;
    }), this.onInputReport = (s) => {
      const o = Buffer.from(s.data.buffer);
      this.inputCallback ? (this.inputCallback(o), this.inputCallback = null) : this.inputs.push(o);
    }, this._disconnectEmitted = !1, this._emitDisconnect = (s) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", s));
    }, this.exchange = (s) => __awaiter$7(this, void 0, void 0, function* () {
      return yield this.exchangeAtomicImpl(() => __awaiter$7(this, void 0, void 0, function* () {
        const { channel: fe, packetSize: me } = this;
        log("apdu", "=> " + s.toString("hex"));
        const ye = createHIDframing(fe, me), fr = ye.makeBlocks(s);
        for (let wr = 0; wr < fr.length; wr++)
          yield this.device.sendReport(0, fr[wr]);
        let Er, br;
        for (; !(Er = ye.getReducedResult(br)); ) {
          const wr = yield this.read();
          br = ye.reduceResponse(br, wr);
        }
        return log("apdu", "<= " + Er.toString("hex")), Er;
      })).catch((fe) => {
        throw fe && fe.message && fe.message.includes("write") ? (this._emitDisconnect(fe), new DisconnectedDeviceDuringOperation(fe.message)) : fe;
      });
    }), this.device = e, this.deviceModel = typeof e.productId == "number" ? identifyUSBProductId(e.productId) : void 0, e.addEventListener("inputreport", this.onInputReport);
  }
  static request() {
    return __awaiter$7(this, void 0, void 0, function* () {
      const [e] = yield requestLedgerDevices();
      return TransportWebHID.open(e);
    });
  }
  static openConnected() {
    return __awaiter$7(this, void 0, void 0, function* () {
      const e = yield getLedgerDevices$1();
      return e.length === 0 ? null : TransportWebHID.open(e[0]);
    });
  }
  static open(e) {
    return __awaiter$7(this, void 0, void 0, function* () {
      yield e.open();
      const s = new TransportWebHID(e), o = (fe) => {
        e === fe.device && (getHID().removeEventListener("disconnect", o), s._emitDisconnect(new DisconnectedDevice()));
      };
      return getHID().addEventListener("disconnect", o), s;
    });
  }
  close() {
    return __awaiter$7(this, void 0, void 0, function* () {
      yield this.exchangeBusyPromise, this.device.removeEventListener("inputreport", this.onInputReport), yield this.device.close();
    });
  }
  setScrambleKey() {
  }
}
TransportWebHID.isSupported = isSupported$1;
TransportWebHID.list = getLedgerDevices$1;
TransportWebHID.listen = (r) => {
  let e = !1;
  getFirstLedgerDevice$1().then((o) => {
    if (!o)
      r.error(new TransportOpenUserCancelled("Access denied to use Ledger device"));
    else if (!e) {
      const fe = typeof o.productId == "number" ? identifyUSBProductId(o.productId) : void 0;
      r.next({
        type: "add",
        descriptor: o,
        deviceModel: fe
      }), r.complete();
    }
  }, (o) => {
    r.error(new TransportOpenUserCancelled(o.message));
  });
  function s() {
    e = !0;
  }
  return {
    unsubscribe: s
  };
};
const TransportWebHID$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TransportWebHID
}, Symbol.toStringTag, { value: "Module" })), require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(TransportWebHID$1);
var __awaiter$6 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
const ledgerDevices = [
  {
    vendorId: ledgerUSBVendorId
  }
];
function requestLedgerDevice() {
  return __awaiter$6(this, void 0, void 0, function* () {
    return yield navigator.usb.requestDevice({
      filters: ledgerDevices
    });
  });
}
function getLedgerDevices() {
  return __awaiter$6(this, void 0, void 0, function* () {
    return (yield navigator.usb.getDevices()).filter((e) => e.vendorId === ledgerUSBVendorId);
  });
}
function getFirstLedgerDevice() {
  return __awaiter$6(this, void 0, void 0, function* () {
    const r = yield getLedgerDevices();
    return r.length > 0 ? r[0] : requestLedgerDevice();
  });
}
const isSupported = () => Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices == "function");
var __awaiter$5 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
const configurationValue = 1, endpointNumber = 3;
class TransportWebUSB extends Transport$1 {
  constructor(e, s) {
    super(), this.channel = Math.floor(Math.random() * 65535), this.packetSize = 64, this._disconnectEmitted = !1, this._emitDisconnect = (o) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", o));
    }, this.device = e, this.interfaceNumber = s, this.deviceModel = identifyUSBProductId(e.productId);
  }
  static request() {
    return __awaiter$5(this, void 0, void 0, function* () {
      const e = yield requestLedgerDevice();
      return TransportWebUSB.open(e);
    });
  }
  static openConnected() {
    return __awaiter$5(this, void 0, void 0, function* () {
      const e = yield getLedgerDevices();
      return e.length === 0 ? null : TransportWebUSB.open(e[0]);
    });
  }
  static open(e) {
    return __awaiter$5(this, void 0, void 0, function* () {
      yield e.open(), e.configuration === null && (yield e.selectConfiguration(configurationValue)), yield gracefullyResetDevice(e);
      const s = e.configurations[0].interfaces.find(({ alternates: ye }) => ye.some((fr) => fr.interfaceClass === 255));
      if (!s)
        throw new TransportInterfaceNotAvailable("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
      const o = s.interfaceNumber;
      try {
        yield e.claimInterface(o);
      } catch (ye) {
        throw yield e.close(), new TransportInterfaceNotAvailable(ye.message);
      }
      const fe = new TransportWebUSB(e, o), me = (ye) => {
        e === ye.device && (navigator.usb.removeEventListener("disconnect", me), fe._emitDisconnect(new DisconnectedDevice()));
      };
      return navigator.usb.addEventListener("disconnect", me), fe;
    });
  }
  close() {
    return __awaiter$5(this, void 0, void 0, function* () {
      yield this.exchangeBusyPromise, yield this.device.releaseInterface(this.interfaceNumber), yield gracefullyResetDevice(this.device), yield this.device.close();
    });
  }
  exchange(e) {
    return __awaiter$5(this, void 0, void 0, function* () {
      return yield this.exchangeAtomicImpl(() => __awaiter$5(this, void 0, void 0, function* () {
        const { channel: o, packetSize: fe } = this;
        log("apdu", "=> " + e.toString("hex"));
        const me = createHIDframing(o, fe), ye = me.makeBlocks(e);
        for (let br = 0; br < ye.length; br++)
          yield this.device.transferOut(endpointNumber, ye[br]);
        let fr, Er;
        for (; !(fr = me.getReducedResult(Er)); ) {
          const br = yield this.device.transferIn(endpointNumber, fe), wr = Buffer.from(br.data.buffer);
          Er = me.reduceResponse(Er, wr);
        }
        return log("apdu", "<= " + fr.toString("hex")), fr;
      })).catch((o) => {
        throw o && o.message && o.message.includes("disconnected") ? (this._emitDisconnect(o), new DisconnectedDeviceDuringOperation(o.message)) : o;
      });
    });
  }
  setScrambleKey() {
  }
}
TransportWebUSB.isSupported = isSupported;
TransportWebUSB.list = getLedgerDevices;
TransportWebUSB.listen = (r) => {
  let e = !1;
  getFirstLedgerDevice().then((o) => {
    if (!e) {
      const fe = identifyUSBProductId(o.productId);
      r.next({
        type: "add",
        descriptor: o,
        deviceModel: fe
      }), r.complete();
    }
  }, (o) => {
    window.DOMException && o instanceof window.DOMException && o.code === 18 ? r.error(new TransportWebUSBGestureRequired(o.message)) : r.error(new TransportOpenUserCancelled(o.message));
  });
  function s() {
    e = !0;
  }
  return {
    unsubscribe: s
  };
};
function gracefullyResetDevice(r) {
  return __awaiter$5(this, void 0, void 0, function* () {
    try {
      yield r.reset();
    } catch (e) {
      console.warn(e);
    }
  });
}
const TransportWebUSB$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TransportWebUSB
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(TransportWebUSB$1);
var constants$5 = {};
Object.defineProperty(constants$5, "__esModule", { value: !0 });
constants$5.TRANSACTION_OPTIONS_TX_GUARDED = constants$5.TRANSACTION_OPTIONS_TX_HASH_SIGN = constants$5.TRANSACTION_VERSION_WITH_OPTIONS = constants$5.LEDGER_TX_GUARDIAN_MIN_VERSION = constants$5.LEDGER_TX_HASH_SIGN_MIN_VERSION = void 0;
constants$5.LEDGER_TX_HASH_SIGN_MIN_VERSION = "1.0.11";
constants$5.LEDGER_TX_GUARDIAN_MIN_VERSION = "1.0.22";
constants$5.TRANSACTION_VERSION_WITH_OPTIONS = 2;
constants$5.TRANSACTION_OPTIONS_TX_HASH_SIGN = 1;
constants$5.TRANSACTION_OPTIONS_TX_GUARDED = 2;
var errors$2 = {};
Object.defineProperty(errors$2, "__esModule", { value: !0 });
errors$2.ErrNotInitialized = void 0;
class ErrNotInitialized extends Error {
  constructor() {
    super("HWApp not initialised, call init() first");
  }
}
errors$2.ErrNotInitialized = ErrNotInitialized;
var ledgerApp = {}, __awaiter$4 = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
Object.defineProperty(ledgerApp, "__esModule", { value: !0 });
const CLA = 237, SIGN_RAW_TX_INS = 4, SIGN_HASH_TX_INS = 7, SIGN_MESSAGE_INS = 6, PROVIDE_ESDT_INFO_INS = 8, GET_ADDRESS_AUTH_TOKEN_INS = 9, ACTIVE_SIGNERS = [
  SIGN_RAW_TX_INS,
  SIGN_HASH_TX_INS,
  SIGN_MESSAGE_INS,
  GET_ADDRESS_AUTH_TOKEN_INS
];
class LedgerApp {
  constructor(e, s = "eGLD") {
    this.transport = e, e.decorateAppAPIMethods(this, [
      "getAddress",
      "setAddress",
      "signTransaction",
      "signMessage",
      "getAppConfiguration",
      "getAddressAndSignAuthToken",
      "provideESDTInfo"
    ], s);
  }
  getAddress(e, s, o) {
    return __awaiter$4(this, void 0, void 0, function* () {
      const me = o ? 1 : 0, ye = 0, fr = Buffer.alloc(8);
      fr.writeInt32BE(e, 0), fr.writeUInt32BE(s, 4);
      const Er = yield this.transport.send(CLA, 3, me, ye, fr), br = Er[0];
      return { address: Buffer.from(Er.subarray(1, 1 + br)).toString("ascii") };
    });
  }
  setAddress(e, s, o) {
    return __awaiter$4(this, void 0, void 0, function* () {
      const me = o ? 1 : 0, ye = 0, fr = Buffer.alloc(8);
      return fr.writeInt32BE(e, 0), fr.writeUInt32BE(s, 4), yield this.transport.send(CLA, 5, me, ye, fr);
    });
  }
  signTransaction(e, s) {
    return __awaiter$4(this, void 0, void 0, function* () {
      return s ? this.sign(e, SIGN_HASH_TX_INS) : this.sign(e, SIGN_RAW_TX_INS);
    });
  }
  signMessage(e) {
    return __awaiter$4(this, void 0, void 0, function* () {
      return this.sign(e, SIGN_MESSAGE_INS);
    });
  }
  getAddressAndSignAuthToken(e, s, o) {
    return __awaiter$4(this, void 0, void 0, function* () {
      const fe = Buffer.alloc(12);
      fe.writeInt32BE(e, 0), fe.writeUInt32BE(s, 4), fe.writeUInt32BE(o.length, 8);
      let me = [fe, o], fr = (yield this.sign(Buffer.concat(me), GET_ADDRESS_AUTH_TOKEN_INS)).split("|");
      return {
        address: fr[0],
        signature: fr[1]
      };
    });
  }
  getAppConfiguration() {
    return __awaiter$4(this, void 0, void 0, function* () {
      const e = yield this.transport.send(237, 2, 0, 0);
      let s = 0, o = 0;
      return e.length === 14 && (s = this.getIntValueFromBytes(e.slice(6, 10)), o = this.getIntValueFromBytes(e.slice(10, 14))), {
        contractData: e[0],
        accountIndex: s,
        addressIndex: o,
        version: `${e[3]}.${e[4]}.${e[5]}`
      };
    });
  }
  getIntValueFromBytes(e) {
    return e[e.length - 1] | e[e.length - 2] << 8 | e[e.length - 3] << 16 | e[e.length - 4] << 24;
  }
  sign(e, s) {
    return __awaiter$4(this, void 0, void 0, function* () {
      if (!ACTIVE_SIGNERS.includes(s))
        throw new Error(`invalid sign instruction called: ${s}`);
      const o = [];
      let fe = 0;
      for (; fe !== e.length; ) {
        const ye = fe === 0, fr = 150, br = fe + fr < e.length ? fr : e.length - fe, wr = {
          cla: CLA,
          ins: s,
          p1: ye ? 0 : 128,
          p2: 0,
          data: Buffer.alloc(br)
        };
        e.copy(wr.data, 0, fe, fe + br), o.push(wr), fe += br;
      }
      let me = Buffer.alloc(0);
      for (let ye of o)
        me = yield this.transport.send(ye.cla, ye.ins, ye.p1, ye.p2, ye.data);
      if (GET_ADDRESS_AUTH_TOKEN_INS === s)
        return this.handleAuthTokenResponse(me);
      if (me.length !== 67 || me[0] !== 64)
        throw new Error("invalid signature received from ledger device");
      return me.slice(1, me.length - 2).toString("hex");
    });
  }
  handleAuthTokenResponse(e) {
    return __awaiter$4(this, void 0, void 0, function* () {
      if (e.length !== 129 && e[0] !== 126)
        throw new Error("invalid address and token signature received from ledger device");
      const s = e.slice(1, 63).toString("ascii"), o = e.slice(63, e.length - 2).toString("hex");
      return s + "|" + o;
    });
  }
  serializeESDTInfo(e, s, o, fe, me) {
    const ye = Buffer.from([e.length]), fr = Buffer.from(e), Er = Buffer.from([s.length]), br = Buffer.from(s), wr = Buffer.from([o]), kr = Buffer.from([fe.length]), Gr = Buffer.from(fe), Vr = Buffer.from(me, "hex");
    let jr = [
      ye,
      fr,
      Er,
      br,
      wr,
      kr,
      Gr,
      Vr
    ];
    return Buffer.concat(jr);
  }
  provideESDTInfo(e, s, o, fe, me) {
    return __awaiter$4(this, void 0, void 0, function* () {
      const ye = this.serializeESDTInfo(e, s, o, fe, me);
      return yield this.transport.send(CLA, PROVIDE_ESDT_INFO_INS, 0, 0, ye);
    });
  }
}
ledgerApp.default = LedgerApp;
var transportType_enum = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.TransportType = void 0, function(e) {
    e.USB = "USB", e.BLE = "BLE", e.HID = "HID";
  }(r.TransportType || (r.TransportType = {}));
})(transportType_enum);
var versioning = {};
Object.defineProperty(versioning, "__esModule", { value: !0 });
versioning.compareVersions = void 0;
function compareVersions(r, e) {
  let s, o;
  const fe = /(\.0+)+$/, me = r.replace(fe, "").split("."), ye = e.replace(fe, "").split("."), fr = Math.min(me.length, ye.length);
  for (s = 0; s < fr; s++)
    if (o = parseInt(me[s], 10) - parseInt(ye[s], 10), o != 0)
      return o < 0 ? -1 : 1;
  return me.length - ye.length;
}
versioning.compareVersions = compareVersions;
var __awaiter$3 = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
}, __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(hwProvider, "__esModule", { value: !0 });
hwProvider.HWProvider = void 0;
const hw_transport_web_ble_1 = __importDefault$1(require$$0$2), hw_transport_webhid_1 = __importDefault$1(require$$1$1), hw_transport_webusb_1 = __importDefault$1(require$$2$1), sdk_core_1$1 = out$4, constants_1$2 = constants$5, errors_1$2 = errors$2, ledgerApp_1 = __importDefault$1(ledgerApp), transport_type_enum_1 = transportType_enum, versioning_1 = versioning;
class HWProvider {
  constructor(e) {
    this._hwApp = e, this._addressIndex = 0;
  }
  get addressIndex() {
    return this._addressIndex;
  }
  get hwApp() {
    return this._hwApp;
  }
  get transportType() {
    return this._transportType;
  }
  init(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (this.isInitialized())
        return !0;
      try {
        const { transport: s, transportType: o } = yield this.getTransport(e);
        return this._transportType = o, this._transport = s, this._hwApp = new ledgerApp_1.default(this._transport), this.isInitialized();
      } catch (s) {
        return console.error("Provider initialization error", s), !1;
      }
    });
  }
  getTransport(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (this._transport && this._transportType)
        return {
          transport: this._transport,
          transportType: this._transportType
        };
      if (!(yield this.isLedgerTransportSupported()))
        throw new Error("Ledger is not supported");
      if (e) {
        const fe = yield this.getTransportByType(e);
        if (!fe)
          throw new Error(`Failed to initialize provider type ${e}`);
        return {
          transport: fe,
          transportType: e
        };
      }
      let o = yield this.getUSBTransport();
      if (o)
        return {
          transport: o,
          transportType: transport_type_enum_1.TransportType.USB
        };
      if (o = yield this.getBLETransport(), o)
        return {
          transport: o,
          transportType: transport_type_enum_1.TransportType.BLE
        };
      if (o = yield this.getHIDTransport(), o)
        return {
          transport: o,
          transportType: transport_type_enum_1.TransportType.HID
        };
      throw new Error("Failed to initialize provider");
    });
  }
  getTransportByType(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      switch (e) {
        case transport_type_enum_1.TransportType.USB:
          return this.getUSBTransport();
        case transport_type_enum_1.TransportType.BLE:
          return this.getBLETransport();
        case transport_type_enum_1.TransportType.HID:
          return this.getHIDTransport();
        default:
          throw new Error("Transport type not supported");
      }
    });
  }
  getUSBTransport() {
    return __awaiter$3(this, void 0, void 0, function* () {
      try {
        if (yield this.isWebUSBSupported())
          return console.log("Web USB Transport selected"), yield hw_transport_webusb_1.default.create();
      } catch (e) {
        console.error("Failed to create USB transport:", e);
      }
      return null;
    });
  }
  getBLETransport() {
    return __awaiter$3(this, void 0, void 0, function* () {
      try {
        if (yield this.isBLESupported())
          return console.log("Web BLE Transport selected"), yield hw_transport_web_ble_1.default.create();
      } catch (e) {
        console.error("Failed to create BLE transport:", e);
      }
      return null;
    });
  }
  getHIDTransport() {
    return __awaiter$3(this, void 0, void 0, function* () {
      try {
        if (yield this.isWebHIDSupported())
          return console.log("Web HID Transport selected"), yield hw_transport_webhid_1.default.create();
      } catch (e) {
        console.error("Failed to create HID transport:", e);
      }
      return null;
    });
  }
  isLedgerTransportSupported() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return (yield this.isBLESupported()) || (yield this.isWebUSBSupported()) || (yield this.isWebHIDSupported());
    });
  }
  isBLESupported() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield hw_transport_web_ble_1.default.isSupported();
    });
  }
  isWebUSBSupported() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield hw_transport_webusb_1.default.isSupported();
    });
  }
  isWebHIDSupported() {
    return __awaiter$3(this, void 0, void 0, function* () {
      return yield hw_transport_webhid_1.default.isSupported();
    });
  }
  isInitialized() {
    return Boolean(this.hwApp && this._transport && this._transportType);
  }
  isConnected() {
    return new Promise((e) => this.isInitialized() ? this._transportType === transport_type_enum_1.TransportType.USB ? e(this._transport.device.opened) : this._transportType === transport_type_enum_1.TransportType.BLE ? e(this._transport.device.gatt.connected) : e(!0) : e(!1));
  }
  login(e = { addressIndex: 0 }) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      yield this.setAddressIndex(e.addressIndex);
      const { address: s } = yield this.hwApp.getAddress(0, e.addressIndex, !0);
      return s;
    });
  }
  setAddressIndex(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      this._addressIndex = e, yield this.hwApp.setAddress(0, e);
    });
  }
  getAccounts(e = 0, s = 10) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      const o = [], fe = e * s;
      for (let me = fe; me < fe + s; me++) {
        const { address: ye } = yield this.hwApp.getAddress(0, me);
        o.push(ye);
      }
      return o;
    });
  }
  logout() {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      return !0;
    });
  }
  getAddress() {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      const { address: e } = yield this.hwApp.getAddress(0, this._addressIndex);
      return e;
    });
  }
  signTransaction(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      e = this.cloneTransaction(e);
      const s = yield this.getAppFeatures(), o = s.appVersion, fe = s.mustUseVersionWithOptions, me = s.mustSignUsingHash, ye = s.canUseGuardian, fr = e.getOptions().valueOf();
      if (fr & constants_1$2.TRANSACTION_OPTIONS_TX_GUARDED && !ye)
        throw new Error(`MultiversX App v${o} does not support guarded transactions.`);
      fe && (e.setVersion(constants_1$2.TRANSACTION_VERSION_WITH_OPTIONS), console.info("Transaction version: ", e.getVersion().valueOf())), me && (e.setOptions(fr | constants_1$2.TRANSACTION_OPTIONS_TX_HASH_SIGN), console.info("Transaction options: ", e.getOptions().valueOf()));
      const br = e.serializeForSigning(), wr = Buffer.from(br), kr = yield this.hwApp.signTransaction(wr, me);
      return e.applySignature(Buffer.from(kr, "hex")), e;
    });
  }
  cloneTransaction(e) {
    return sdk_core_1$1.Transaction.fromPlainObject(e.toPlainObject());
  }
  signTransactions(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      const s = [];
      for (const o of e) {
        const fe = yield this.signTransaction(o);
        s.push(fe);
      }
      return s;
    });
  }
  signMessage(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      e = this.cloneMessage(e);
      let s = e.serializeForSigningRaw(), o = Buffer.from(s);
      const fe = yield this.hwApp.signMessage(o);
      return e.applySignature(Buffer.from(fe, "hex")), e;
    });
  }
  cloneMessage(e) {
    return new sdk_core_1$1.SignableMessage({
      message: e.message,
      address: e.address,
      signer: e.signer,
      version: e.version
    });
  }
  tokenLogin(e) {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      let s = e.addressIndex || 0;
      yield this.setAddressIndex(s);
      const { signature: o, address: fe } = yield this.hwApp.getAddressAndSignAuthToken(0, s, e.token);
      return {
        signature: Buffer.from(o, "hex"),
        address: fe
      };
    });
  }
  getAppFeatures() {
    return __awaiter$3(this, void 0, void 0, function* () {
      if (!this.hwApp)
        throw new errors_1$2.ErrNotInitialized();
      const s = (yield this.hwApp.getAppConfiguration()).version, o = versioning_1.compareVersions(s, constants_1$2.LEDGER_TX_HASH_SIGN_MIN_VERSION) >= 0, fe = versioning_1.compareVersions(s, constants_1$2.LEDGER_TX_GUARDIAN_MIN_VERSION) >= 0;
      return {
        appVersion: s,
        mustUseVersionWithOptions: o,
        mustSignUsingHash: o,
        canUseGuardian: fe
      };
    });
  }
}
hwProvider.HWProvider = HWProvider;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(hwProvider, r);
})(out$1);
var walletConnectV2Provider = {};
const suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function jsonParseTransform(r, e) {
  if (r === "__proto__" || r === "constructor" && e && typeof e == "object" && "prototype" in e) {
    warnKeyDropped(r);
    return;
  }
  return e;
}
function warnKeyDropped(r) {
  console.warn(`[destr] Dropping "${r}" key to prevent prototype pollution.`);
}
function destr(r, e = {}) {
  if (typeof r != "string")
    return r;
  const s = r.trim();
  if (r[0] === '"' && r.at(-1) === '"' && !r.includes("\\"))
    return s.slice(1, -1);
  if (s.length <= 9) {
    const o = s.toLowerCase();
    if (o === "true")
      return !0;
    if (o === "false")
      return !1;
    if (o === "undefined")
      return;
    if (o === "null")
      return null;
    if (o === "nan")
      return Number.NaN;
    if (o === "infinity")
      return Number.POSITIVE_INFINITY;
    if (o === "-infinity")
      return Number.NEGATIVE_INFINITY;
  }
  if (!JsonSigRx.test(r)) {
    if (e.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return r;
  }
  try {
    if (suspectProtoRx.test(r) || suspectConstructorRx.test(r)) {
      if (e.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(r, jsonParseTransform);
    }
    return JSON.parse(r);
  } catch (o) {
    if (e.strict)
      throw o;
    return r;
  }
}
function wrapToPromise(r) {
  return !r || typeof r.then != "function" ? Promise.resolve(r) : r;
}
function asyncCall(r, ...e) {
  try {
    return wrapToPromise(r(...e));
  } catch (s) {
    return Promise.reject(s);
  }
}
function isPrimitive(r) {
  const e = typeof r;
  return r === null || e !== "object" && e !== "function";
}
function isPureObject(r) {
  const e = Object.getPrototypeOf(r);
  return !e || e.isPrototypeOf(Object);
}
function stringify$2(r) {
  if (isPrimitive(r))
    return String(r);
  if (isPureObject(r) || Array.isArray(r))
    return JSON.stringify(r);
  if (typeof r.toJSON == "function")
    return stringify$2(r.toJSON());
  throw new Error("[unstorage] Cannot stringify value!");
}
function checkBufferSupport() {
  if (typeof Buffer === void 0)
    throw new TypeError("[unstorage] Buffer is not supported!");
}
const BASE64_PREFIX = "base64:";
function serializeRaw(r) {
  if (typeof r == "string")
    return r;
  checkBufferSupport();
  const e = Buffer.from(r).toString("base64");
  return BASE64_PREFIX + e;
}
function deserializeRaw(r) {
  return typeof r != "string" || !r.startsWith(BASE64_PREFIX) ? r : (checkBufferSupport(), Buffer.from(r.slice(BASE64_PREFIX.length), "base64"));
}
function normalizeKey(r) {
  return r ? r.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "") : "";
}
function joinKeys(...r) {
  return normalizeKey(r.join(":"));
}
function normalizeBaseKey(r) {
  return r = normalizeKey(r), r ? r + ":" : "";
}
function defineDriver(r) {
  return r;
}
const DRIVER_NAME = "memory", memory = () => {
  const r = /* @__PURE__ */ new Map();
  return {
    name: DRIVER_NAME,
    options: {},
    hasItem(e) {
      return r.has(e);
    },
    getItem(e) {
      var s;
      return (s = r.get(e)) != null ? s : null;
    },
    getItemRaw(e) {
      var s;
      return (s = r.get(e)) != null ? s : null;
    },
    setItem(e, s) {
      r.set(e, s);
    },
    setItemRaw(e, s) {
      r.set(e, s);
    },
    removeItem(e) {
      r.delete(e);
    },
    getKeys() {
      return Array.from(r.keys());
    },
    clear() {
      r.clear();
    },
    dispose() {
      r.clear();
    }
  };
};
function createStorage(r = {}) {
  const e = {
    mounts: { "": r.driver || memory() },
    mountpoints: [""],
    watching: !1,
    watchListeners: [],
    unwatch: {}
  }, s = (br) => {
    for (const wr of e.mountpoints)
      if (br.startsWith(wr))
        return {
          base: wr,
          relativeKey: br.slice(wr.length),
          driver: e.mounts[wr]
        };
    return {
      base: "",
      relativeKey: br,
      driver: e.mounts[""]
    };
  }, o = (br, wr) => e.mountpoints.filter(
    (kr) => kr.startsWith(br) || wr && br.startsWith(kr)
  ).map((kr) => ({
    relativeBase: br.length > kr.length ? br.slice(kr.length) : void 0,
    mountpoint: kr,
    driver: e.mounts[kr]
  })), fe = (br, wr) => {
    if (!!e.watching) {
      wr = normalizeKey(wr);
      for (const kr of e.watchListeners)
        kr(br, wr);
    }
  }, me = async () => {
    if (!e.watching) {
      e.watching = !0;
      for (const br in e.mounts)
        e.unwatch[br] = await watch$2(
          e.mounts[br],
          fe,
          br
        );
    }
  }, ye = async () => {
    if (!!e.watching) {
      for (const br in e.unwatch)
        await e.unwatch[br]();
      e.unwatch = {}, e.watching = !1;
    }
  }, fr = (br, wr, kr) => {
    const Gr = /* @__PURE__ */ new Map(), Vr = (jr) => {
      let Kr = Gr.get(jr.base);
      return Kr || (Kr = {
        driver: jr.driver,
        base: jr.base,
        items: []
      }, Gr.set(jr.base, Kr)), Kr;
    };
    for (const jr of br) {
      const Kr = typeof jr == "string", bn = normalizeKey(Kr ? jr : jr.key), Yr = Kr ? void 0 : jr.value, Zr = Kr || !jr.options ? wr : { ...wr, ...jr.options }, ti = s(bn);
      Vr(ti).items.push({
        key: bn,
        value: Yr,
        relativeKey: ti.relativeKey,
        options: Zr
      });
    }
    return Promise.all([...Gr.values()].map((jr) => kr(jr))).then(
      (jr) => jr.flat()
    );
  }, Er = {
    hasItem(br, wr = {}) {
      br = normalizeKey(br);
      const { relativeKey: kr, driver: Gr } = s(br);
      return asyncCall(Gr.hasItem, kr, wr);
    },
    getItem(br, wr = {}) {
      br = normalizeKey(br);
      const { relativeKey: kr, driver: Gr } = s(br);
      return asyncCall(Gr.getItem, kr, wr).then(
        (Vr) => destr(Vr)
      );
    },
    getItems(br, wr) {
      return fr(br, wr, (kr) => kr.driver.getItems ? asyncCall(
        kr.driver.getItems,
        kr.items.map((Gr) => ({
          key: Gr.relativeKey,
          options: Gr.options
        })),
        wr
      ).then(
        (Gr) => Gr.map((Vr) => ({
          key: joinKeys(kr.base, Vr.key),
          value: destr(Vr.value)
        }))
      ) : Promise.all(
        kr.items.map((Gr) => asyncCall(
          kr.driver.getItem,
          Gr.relativeKey,
          Gr.options
        ).then((Vr) => ({
          key: Gr.key,
          value: destr(Vr)
        })))
      ));
    },
    getItemRaw(br, wr = {}) {
      br = normalizeKey(br);
      const { relativeKey: kr, driver: Gr } = s(br);
      return Gr.getItemRaw ? asyncCall(Gr.getItemRaw, kr, wr) : asyncCall(Gr.getItem, kr, wr).then(
        (Vr) => deserializeRaw(Vr)
      );
    },
    async setItem(br, wr, kr = {}) {
      if (wr === void 0)
        return Er.removeItem(br);
      br = normalizeKey(br);
      const { relativeKey: Gr, driver: Vr } = s(br);
      !Vr.setItem || (await asyncCall(Vr.setItem, Gr, stringify$2(wr), kr), Vr.watch || fe("update", br));
    },
    async setItems(br, wr) {
      await fr(br, wr, async (kr) => {
        kr.driver.setItems && await asyncCall(
          kr.driver.setItems,
          kr.items.map((Gr) => ({
            key: Gr.relativeKey,
            value: stringify$2(Gr.value),
            options: Gr.options
          })),
          wr
        ), kr.driver.setItem && await Promise.all(
          kr.items.map((Gr) => asyncCall(
            kr.driver.setItem,
            Gr.relativeKey,
            stringify$2(Gr.value),
            Gr.options
          ))
        );
      });
    },
    async setItemRaw(br, wr, kr = {}) {
      if (wr === void 0)
        return Er.removeItem(br, kr);
      br = normalizeKey(br);
      const { relativeKey: Gr, driver: Vr } = s(br);
      if (Vr.setItemRaw)
        await asyncCall(Vr.setItemRaw, Gr, wr, kr);
      else if (Vr.setItem)
        await asyncCall(Vr.setItem, Gr, serializeRaw(wr), kr);
      else
        return;
      Vr.watch || fe("update", br);
    },
    async removeItem(br, wr = {}) {
      typeof wr == "boolean" && (wr = { removeMeta: wr }), br = normalizeKey(br);
      const { relativeKey: kr, driver: Gr } = s(br);
      !Gr.removeItem || (await asyncCall(Gr.removeItem, kr, wr), (wr.removeMeta || wr.removeMata) && await asyncCall(Gr.removeItem, kr + "$", wr), Gr.watch || fe("remove", br));
    },
    async getMeta(br, wr = {}) {
      typeof wr == "boolean" && (wr = { nativeOnly: wr }), br = normalizeKey(br);
      const { relativeKey: kr, driver: Gr } = s(br), Vr = /* @__PURE__ */ Object.create(null);
      if (Gr.getMeta && Object.assign(Vr, await asyncCall(Gr.getMeta, kr, wr)), !wr.nativeOnly) {
        const jr = await asyncCall(
          Gr.getItem,
          kr + "$",
          wr
        ).then((Kr) => destr(Kr));
        jr && typeof jr == "object" && (typeof jr.atime == "string" && (jr.atime = new Date(jr.atime)), typeof jr.mtime == "string" && (jr.mtime = new Date(jr.mtime)), Object.assign(Vr, jr));
      }
      return Vr;
    },
    setMeta(br, wr, kr = {}) {
      return this.setItem(br + "$", wr, kr);
    },
    removeMeta(br, wr = {}) {
      return this.removeItem(br + "$", wr);
    },
    async getKeys(br, wr = {}) {
      br = normalizeBaseKey(br);
      const kr = o(br, !0);
      let Gr = [];
      const Vr = [];
      for (const jr of kr) {
        const bn = (await asyncCall(
          jr.driver.getKeys,
          jr.relativeBase,
          wr
        )).map((Yr) => jr.mountpoint + normalizeKey(Yr)).filter((Yr) => !Gr.some((Zr) => Yr.startsWith(Zr)));
        Vr.push(...bn), Gr = [
          jr.mountpoint,
          ...Gr.filter((Yr) => !Yr.startsWith(jr.mountpoint))
        ];
      }
      return br ? Vr.filter((jr) => jr.startsWith(br) && !jr.endsWith("$")) : Vr.filter((jr) => !jr.endsWith("$"));
    },
    async clear(br, wr = {}) {
      br = normalizeBaseKey(br), await Promise.all(
        o(br, !1).map(async (kr) => {
          if (kr.driver.clear)
            return asyncCall(kr.driver.clear, kr.relativeBase, wr);
          if (kr.driver.removeItem) {
            const Gr = await kr.driver.getKeys(kr.relativeBase || "", wr);
            return Promise.all(
              Gr.map((Vr) => kr.driver.removeItem(Vr, wr))
            );
          }
        })
      );
    },
    async dispose() {
      await Promise.all(
        Object.values(e.mounts).map((br) => dispose(br))
      );
    },
    async watch(br) {
      return await me(), e.watchListeners.push(br), async () => {
        e.watchListeners = e.watchListeners.filter(
          (wr) => wr !== br
        ), e.watchListeners.length === 0 && await ye();
      };
    },
    async unwatch() {
      e.watchListeners = [], await ye();
    },
    mount(br, wr) {
      if (br = normalizeBaseKey(br), br && e.mounts[br])
        throw new Error(`already mounted at ${br}`);
      return br && (e.mountpoints.push(br), e.mountpoints.sort((kr, Gr) => Gr.length - kr.length)), e.mounts[br] = wr, e.watching && Promise.resolve(watch$2(wr, fe, br)).then((kr) => {
        e.unwatch[br] = kr;
      }).catch(console.error), Er;
    },
    async unmount(br, wr = !0) {
      br = normalizeBaseKey(br), !(!br || !e.mounts[br]) && (e.watching && br in e.unwatch && (e.unwatch[br](), delete e.unwatch[br]), wr && await dispose(e.mounts[br]), e.mountpoints = e.mountpoints.filter((kr) => kr !== br), delete e.mounts[br]);
    },
    getMount(br = "") {
      br = normalizeKey(br) + ":";
      const wr = s(br);
      return {
        driver: wr.driver,
        base: wr.base
      };
    },
    getMounts(br = "", wr = {}) {
      return br = normalizeKey(br), o(br, wr.parents).map((Gr) => ({
        driver: Gr.driver,
        base: Gr.mountpoint
      }));
    }
  };
  return Er;
}
function watch$2(r, e, s) {
  return r.watch ? r.watch((o, fe) => e(o, s + fe)) : () => {
  };
}
async function dispose(r) {
  typeof r.dispose == "function" && await asyncCall(r.dispose);
}
function promisifyRequest(r) {
  return new Promise((e, s) => {
    r.oncomplete = r.onsuccess = () => e(r.result), r.onabort = r.onerror = () => s(r.error);
  });
}
function createStore(r, e) {
  const s = indexedDB.open(r);
  s.onupgradeneeded = () => s.result.createObjectStore(e);
  const o = promisifyRequest(s);
  return (fe, me) => o.then((ye) => me(ye.transaction(e, fe).objectStore(e)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
  return defaultGetStoreFunc || (defaultGetStoreFunc = createStore("keyval-store", "keyval")), defaultGetStoreFunc;
}
function get(r, e = defaultGetStore()) {
  return e("readonly", (s) => promisifyRequest(s.get(r)));
}
function set(r, e, s = defaultGetStore()) {
  return s("readwrite", (o) => (o.put(e, r), promisifyRequest(o.transaction)));
}
function del(r, e = defaultGetStore()) {
  return e("readwrite", (s) => (s.delete(r), promisifyRequest(s.transaction)));
}
function clear(r = defaultGetStore()) {
  return r("readwrite", (e) => (e.clear(), promisifyRequest(e.transaction)));
}
function eachCursor(r, e) {
  return r.openCursor().onsuccess = function() {
    !this.result || (e(this.result), this.result.continue());
  }, promisifyRequest(r.transaction);
}
function keys(r = defaultGetStore()) {
  return r("readonly", (e) => {
    if (e.getAllKeys)
      return promisifyRequest(e.getAllKeys());
    const s = [];
    return eachCursor(e, (o) => s.push(o.key)).then(() => s);
  });
}
const JSONStringify = (r) => JSON.stringify(r, (e, s) => typeof s == "bigint" ? s.toString() + "n" : s), JSONParse = (r) => {
  const e = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g, s = r.replace(e, '$1"$2n"$3');
  return JSON.parse(s, (o, fe) => typeof fe == "string" && fe.match(/^\d+n$/) ? BigInt(fe.substring(0, fe.length - 1)) : fe);
};
function safeJsonParse(r) {
  if (typeof r != "string")
    throw new Error(`Cannot safe json parse value of type ${typeof r}`);
  try {
    return JSONParse(r);
  } catch {
    return r;
  }
}
function safeJsonStringify(r) {
  return typeof r == "string" ? r : JSONStringify(r) || "";
}
const x$1 = "idb-keyval";
var z$1 = (r = {}) => {
  const e = r.base && r.base.length > 0 ? `${r.base}:` : "", s = (fe) => e + fe;
  let o;
  return r.dbName && r.storeName && (o = createStore(r.dbName, r.storeName)), { name: x$1, options: r, async hasItem(fe) {
    return !(typeof await get(s(fe), o) > "u");
  }, async getItem(fe) {
    var me;
    return (me = await get(s(fe), o)) != null ? me : null;
  }, setItem(fe, me) {
    return set(s(fe), me, o);
  }, removeItem(fe) {
    return del(s(fe), o);
  }, getKeys() {
    return keys(o);
  }, clear() {
    return clear(o);
  } };
};
const D$2 = "WALLET_CONNECT_V2_INDEXED_DB", E$1 = "keyvaluestorage";
class _$1 {
  constructor() {
    this.indexedDb = createStorage({ driver: z$1({ dbName: D$2, storeName: E$1 }) });
  }
  async getKeys() {
    return this.indexedDb.getKeys();
  }
  async getEntries() {
    return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((e) => [e.key, e.value]);
  }
  async getItem(e) {
    const s = await this.indexedDb.getItem(e);
    if (s !== null)
      return s;
  }
  async setItem(e, s) {
    await this.indexedDb.setItem(e, safeJsonStringify(s));
  }
  async removeItem(e) {
    await this.indexedDb.removeItem(e);
  }
}
var l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {}, c = { exports: {} };
(function() {
  let r;
  function e() {
  }
  r = e, r.prototype.getItem = function(s) {
    return this.hasOwnProperty(s) ? String(this[s]) : null;
  }, r.prototype.setItem = function(s, o) {
    this[s] = String(o);
  }, r.prototype.removeItem = function(s) {
    delete this[s];
  }, r.prototype.clear = function() {
    const s = this;
    Object.keys(s).forEach(function(o) {
      s[o] = void 0, delete s[o];
    });
  }, r.prototype.key = function(s) {
    return s = s || 0, Object.keys(this)[s];
  }, r.prototype.__defineGetter__("length", function() {
    return Object.keys(this).length;
  }), typeof l < "u" && l.localStorage ? c.exports = l.localStorage : typeof window < "u" && window.localStorage ? c.exports = window.localStorage : c.exports = new e();
})();
function k$1(r) {
  var e;
  return [r[0], safeJsonParse((e = r[1]) != null ? e : "")];
}
class K$1 {
  constructor() {
    this.localStorage = c.exports;
  }
  async getKeys() {
    return Object.keys(this.localStorage);
  }
  async getEntries() {
    return Object.entries(this.localStorage).map(k$1);
  }
  async getItem(e) {
    const s = this.localStorage.getItem(e);
    if (s !== null)
      return safeJsonParse(s);
  }
  async setItem(e, s) {
    this.localStorage.setItem(e, safeJsonStringify(s));
  }
  async removeItem(e) {
    this.localStorage.removeItem(e);
  }
}
const N$1 = "wc_storage_version", y$1 = 1, O$2 = async (r, e, s) => {
  const o = N$1, fe = await e.getItem(o);
  if (fe && fe >= y$1) {
    s(e);
    return;
  }
  const me = await r.getKeys();
  if (!me.length) {
    s(e);
    return;
  }
  const ye = [];
  for (; me.length; ) {
    const fr = me.shift();
    if (!fr)
      continue;
    const Er = fr.toLowerCase();
    if (Er.includes("wc@") || Er.includes("walletconnect") || Er.includes("wc_") || Er.includes("wallet_connect")) {
      const br = await r.getItem(fr);
      await e.setItem(fr, br), ye.push(fr);
    }
  }
  await e.setItem(o, y$1), s(e), j$1(r, ye);
}, j$1 = async (r, e) => {
  e.length && e.forEach(async (s) => {
    await r.removeItem(s);
  });
};
class h$3 {
  constructor() {
    this.initialized = !1, this.setInitialized = (s) => {
      this.storage = s, this.initialized = !0;
    };
    const e = new K$1();
    this.storage = e;
    try {
      const s = new _$1();
      O$2(e, s, this.setInitialized);
    } catch {
      this.initialized = !0;
    }
  }
  async getKeys() {
    return await this.initialize(), this.storage.getKeys();
  }
  async getEntries() {
    return await this.initialize(), this.storage.getEntries();
  }
  async getItem(e) {
    return await this.initialize(), this.storage.getItem(e);
  }
  async setItem(e, s) {
    return await this.initialize(), this.storage.setItem(e, s);
  }
  async removeItem(e) {
    return await this.initialize(), this.storage.removeItem(e);
  }
  async initialize() {
    this.initialized || await new Promise((e) => {
      const s = setInterval(() => {
        this.initialized && (clearInterval(s), e());
      }, 20);
    });
  }
}
var cjs$5 = {}, heartbeat$2 = {}, cjs$4 = {}, utils$7 = {}, delay = {}, hasRequiredDelay;
function requireDelay() {
  if (hasRequiredDelay)
    return delay;
  hasRequiredDelay = 1, Object.defineProperty(delay, "__esModule", { value: !0 }), delay.delay = void 0;
  function r(e) {
    return new Promise((s) => {
      setTimeout(() => {
        s(!0);
      }, e);
    });
  }
  return delay.delay = r, delay;
}
var convert = {}, constants$4 = {}, misc = {}, hasRequiredMisc;
function requireMisc() {
  return hasRequiredMisc || (hasRequiredMisc = 1, Object.defineProperty(misc, "__esModule", { value: !0 }), misc.ONE_THOUSAND = misc.ONE_HUNDRED = void 0, misc.ONE_HUNDRED = 100, misc.ONE_THOUSAND = 1e3), misc;
}
var time = {}, hasRequiredTime;
function requireTime() {
  return hasRequiredTime || (hasRequiredTime = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.ONE_YEAR = r.FOUR_WEEKS = r.THREE_WEEKS = r.TWO_WEEKS = r.ONE_WEEK = r.THIRTY_DAYS = r.SEVEN_DAYS = r.FIVE_DAYS = r.THREE_DAYS = r.ONE_DAY = r.TWENTY_FOUR_HOURS = r.TWELVE_HOURS = r.SIX_HOURS = r.THREE_HOURS = r.ONE_HOUR = r.SIXTY_MINUTES = r.THIRTY_MINUTES = r.TEN_MINUTES = r.FIVE_MINUTES = r.ONE_MINUTE = r.SIXTY_SECONDS = r.THIRTY_SECONDS = r.TEN_SECONDS = r.FIVE_SECONDS = r.ONE_SECOND = void 0, r.ONE_SECOND = 1, r.FIVE_SECONDS = 5, r.TEN_SECONDS = 10, r.THIRTY_SECONDS = 30, r.SIXTY_SECONDS = 60, r.ONE_MINUTE = r.SIXTY_SECONDS, r.FIVE_MINUTES = r.ONE_MINUTE * 5, r.TEN_MINUTES = r.ONE_MINUTE * 10, r.THIRTY_MINUTES = r.ONE_MINUTE * 30, r.SIXTY_MINUTES = r.ONE_MINUTE * 60, r.ONE_HOUR = r.SIXTY_MINUTES, r.THREE_HOURS = r.ONE_HOUR * 3, r.SIX_HOURS = r.ONE_HOUR * 6, r.TWELVE_HOURS = r.ONE_HOUR * 12, r.TWENTY_FOUR_HOURS = r.ONE_HOUR * 24, r.ONE_DAY = r.TWENTY_FOUR_HOURS, r.THREE_DAYS = r.ONE_DAY * 3, r.FIVE_DAYS = r.ONE_DAY * 5, r.SEVEN_DAYS = r.ONE_DAY * 7, r.THIRTY_DAYS = r.ONE_DAY * 30, r.ONE_WEEK = r.SEVEN_DAYS, r.TWO_WEEKS = r.ONE_WEEK * 2, r.THREE_WEEKS = r.ONE_WEEK * 3, r.FOUR_WEEKS = r.ONE_WEEK * 4, r.ONE_YEAR = r.ONE_DAY * 365;
  }(time)), time;
}
var hasRequiredConstants$2;
function requireConstants$2() {
  return hasRequiredConstants$2 || (hasRequiredConstants$2 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 });
    const e = tslib.exports;
    e.__exportStar(requireMisc(), r), e.__exportStar(requireTime(), r);
  }(constants$4)), constants$4;
}
var hasRequiredConvert;
function requireConvert() {
  if (hasRequiredConvert)
    return convert;
  hasRequiredConvert = 1, Object.defineProperty(convert, "__esModule", { value: !0 }), convert.fromMiliseconds = convert.toMiliseconds = void 0;
  const r = requireConstants$2();
  function e(o) {
    return o * r.ONE_THOUSAND;
  }
  convert.toMiliseconds = e;
  function s(o) {
    return Math.floor(o / r.ONE_THOUSAND);
  }
  return convert.fromMiliseconds = s, convert;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  return hasRequiredUtils$1 || (hasRequiredUtils$1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 });
    const e = tslib.exports;
    e.__exportStar(requireDelay(), r), e.__exportStar(requireConvert(), r);
  }(utils$7)), utils$7;
}
var watch$1 = {}, hasRequiredWatch$1;
function requireWatch$1() {
  if (hasRequiredWatch$1)
    return watch$1;
  hasRequiredWatch$1 = 1, Object.defineProperty(watch$1, "__esModule", { value: !0 }), watch$1.Watch = void 0;
  class r {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(s) {
      if (this.timestamps.has(s))
        throw new Error(`Watch already started for label: ${s}`);
      this.timestamps.set(s, { started: Date.now() });
    }
    stop(s) {
      const o = this.get(s);
      if (typeof o.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${s}`);
      const fe = Date.now() - o.started;
      this.timestamps.set(s, { started: o.started, elapsed: fe });
    }
    get(s) {
      const o = this.timestamps.get(s);
      if (typeof o > "u")
        throw new Error(`No timestamp found for label: ${s}`);
      return o;
    }
    elapsed(s) {
      const o = this.get(s);
      return o.elapsed || Date.now() - o.started;
    }
  }
  return watch$1.Watch = r, watch$1.default = r, watch$1;
}
var types$1 = {}, watch = {}, hasRequiredWatch;
function requireWatch() {
  if (hasRequiredWatch)
    return watch;
  hasRequiredWatch = 1, Object.defineProperty(watch, "__esModule", { value: !0 }), watch.IWatch = void 0;
  class r {
  }
  return watch.IWatch = r, watch;
}
var hasRequiredTypes$1;
function requireTypes$1() {
  return hasRequiredTypes$1 || (hasRequiredTypes$1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), tslib.exports.__exportStar(requireWatch(), r);
  }(types$1)), types$1;
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  const e = tslib.exports;
  e.__exportStar(requireUtils$1(), r), e.__exportStar(requireWatch$1(), r), e.__exportStar(requireTypes$1(), r), e.__exportStar(requireConstants$2(), r);
})(cjs$4);
var types = {}, heartbeat$1 = {};
class IEvents$1 {
}
const esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IEvents: IEvents$1
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(esm);
var hasRequiredHeartbeat$2;
function requireHeartbeat$2() {
  if (hasRequiredHeartbeat$2)
    return heartbeat$1;
  hasRequiredHeartbeat$2 = 1, Object.defineProperty(heartbeat$1, "__esModule", { value: !0 }), heartbeat$1.IHeartBeat = void 0;
  const r = require$$0$1;
  class e extends r.IEvents {
    constructor(o) {
      super();
    }
  }
  return heartbeat$1.IHeartBeat = e, heartbeat$1;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), tslib.exports.__exportStar(requireHeartbeat$2(), r);
  }(types)), types;
}
var constants$3 = {}, heartbeat = {}, hasRequiredHeartbeat$1;
function requireHeartbeat$1() {
  if (hasRequiredHeartbeat$1)
    return heartbeat;
  hasRequiredHeartbeat$1 = 1, Object.defineProperty(heartbeat, "__esModule", { value: !0 }), heartbeat.HEARTBEAT_EVENTS = heartbeat.HEARTBEAT_INTERVAL = void 0;
  const r = cjs$4;
  return heartbeat.HEARTBEAT_INTERVAL = r.FIVE_SECONDS, heartbeat.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
  }, heartbeat;
}
var hasRequiredConstants$1;
function requireConstants$1() {
  return hasRequiredConstants$1 || (hasRequiredConstants$1 = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), tslib.exports.__exportStar(requireHeartbeat$1(), r);
  }(constants$3)), constants$3;
}
var hasRequiredHeartbeat;
function requireHeartbeat() {
  if (hasRequiredHeartbeat)
    return heartbeat$2;
  hasRequiredHeartbeat = 1, Object.defineProperty(heartbeat$2, "__esModule", { value: !0 }), heartbeat$2.HeartBeat = void 0;
  const r = tslib.exports, e = events.exports, s = cjs$4, o = requireTypes(), fe = requireConstants$1();
  class me extends o.IHeartBeat {
    constructor(fr) {
      super(fr), this.events = new e.EventEmitter(), this.interval = fe.HEARTBEAT_INTERVAL, this.interval = (fr == null ? void 0 : fr.interval) || fe.HEARTBEAT_INTERVAL;
    }
    static init(fr) {
      return r.__awaiter(this, void 0, void 0, function* () {
        const Er = new me(fr);
        return yield Er.init(), Er;
      });
    }
    init() {
      return r.__awaiter(this, void 0, void 0, function* () {
        yield this.initialize();
      });
    }
    stop() {
      clearInterval(this.intervalRef);
    }
    on(fr, Er) {
      this.events.on(fr, Er);
    }
    once(fr, Er) {
      this.events.once(fr, Er);
    }
    off(fr, Er) {
      this.events.off(fr, Er);
    }
    removeListener(fr, Er) {
      this.events.removeListener(fr, Er);
    }
    initialize() {
      return r.__awaiter(this, void 0, void 0, function* () {
        this.intervalRef = setInterval(() => this.pulse(), s.toMiliseconds(this.interval));
      });
    }
    pulse() {
      this.events.emit(fe.HEARTBEAT_EVENTS.pulse);
    }
  }
  return heartbeat$2.HeartBeat = me, heartbeat$2;
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  const e = tslib.exports;
  e.__exportStar(requireHeartbeat(), r), e.__exportStar(requireTypes(), r), e.__exportStar(requireConstants$1(), r);
})(cjs$5);
var cjs$3 = {}, quickFormatUnescaped, hasRequiredQuickFormatUnescaped;
function requireQuickFormatUnescaped() {
  if (hasRequiredQuickFormatUnescaped)
    return quickFormatUnescaped;
  hasRequiredQuickFormatUnescaped = 1;
  function r(s) {
    try {
      return JSON.stringify(s);
    } catch {
      return '"[Circular]"';
    }
  }
  quickFormatUnescaped = e;
  function e(s, o, fe) {
    var me = fe && fe.stringify || r, ye = 1;
    if (typeof s == "object" && s !== null) {
      var fr = o.length + ye;
      if (fr === 1)
        return s;
      var Er = new Array(fr);
      Er[0] = me(s);
      for (var br = 1; br < fr; br++)
        Er[br] = me(o[br]);
      return Er.join(" ");
    }
    if (typeof s != "string")
      return s;
    var wr = o.length;
    if (wr === 0)
      return s;
    for (var kr = "", Gr = 1 - ye, Vr = -1, jr = s && s.length || 0, Kr = 0; Kr < jr; ) {
      if (s.charCodeAt(Kr) === 37 && Kr + 1 < jr) {
        switch (Vr = Vr > -1 ? Vr : 0, s.charCodeAt(Kr + 1)) {
          case 100:
          case 102:
            if (Gr >= wr || o[Gr] == null)
              break;
            Vr < Kr && (kr += s.slice(Vr, Kr)), kr += Number(o[Gr]), Vr = Kr + 2, Kr++;
            break;
          case 105:
            if (Gr >= wr || o[Gr] == null)
              break;
            Vr < Kr && (kr += s.slice(Vr, Kr)), kr += Math.floor(Number(o[Gr])), Vr = Kr + 2, Kr++;
            break;
          case 79:
          case 111:
          case 106:
            if (Gr >= wr || o[Gr] === void 0)
              break;
            Vr < Kr && (kr += s.slice(Vr, Kr));
            var bn = typeof o[Gr];
            if (bn === "string") {
              kr += "'" + o[Gr] + "'", Vr = Kr + 2, Kr++;
              break;
            }
            if (bn === "function") {
              kr += o[Gr].name || "<anonymous>", Vr = Kr + 2, Kr++;
              break;
            }
            kr += me(o[Gr]), Vr = Kr + 2, Kr++;
            break;
          case 115:
            if (Gr >= wr)
              break;
            Vr < Kr && (kr += s.slice(Vr, Kr)), kr += String(o[Gr]), Vr = Kr + 2, Kr++;
            break;
          case 37:
            Vr < Kr && (kr += s.slice(Vr, Kr)), kr += "%", Vr = Kr + 2, Kr++, Gr--;
            break;
        }
        ++Gr;
      }
      ++Kr;
    }
    return Vr === -1 ? s : (Vr < jr && (kr += s.slice(Vr)), kr);
  }
  return quickFormatUnescaped;
}
var browser$3, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser$3;
  hasRequiredBrowser = 1;
  const r = requireQuickFormatUnescaped();
  browser$3 = fe;
  const e = ni().console || {}, s = {
    mapHttpRequest: jr,
    mapHttpResponse: jr,
    wrapRequestSerializer: Kr,
    wrapResponseSerializer: Kr,
    wrapErrorSerializer: Kr,
    req: jr,
    res: jr,
    err: Gr
  };
  function o(In, Br) {
    return Array.isArray(In) ? In.filter(function(Pn) {
      return Pn !== "!stdSerializers.err";
    }) : In === !0 ? Object.keys(Br) : !1;
  }
  function fe(In) {
    In = In || {}, In.browser = In.browser || {};
    const Br = In.browser.transmit;
    if (Br && typeof Br.send != "function")
      throw Error("pino: transmit option must have a send function");
    const Hr = In.browser.write || e;
    In.browser.write && (In.browser.asObject = !0);
    const Pn = In.serializers || {}, ei = o(In.browser.serialize, Pn);
    let oi = In.browser.serialize;
    Array.isArray(In.browser.serialize) && In.browser.serialize.indexOf("!stdSerializers.err") > -1 && (oi = !1);
    const Nn = ["error", "fatal", "warn", "info", "debug", "trace"];
    typeof Hr == "function" && (Hr.error = Hr.fatal = Hr.warn = Hr.info = Hr.debug = Hr.trace = Hr), In.enabled === !1 && (In.level = "silent");
    const En = In.level || "info", qr = Object.create(Hr);
    qr.log || (qr.log = bn), Object.defineProperty(qr, "levelVal", {
      get: ri
    }), Object.defineProperty(qr, "level", {
      get: Sn,
      set: ai
    });
    const Jr = {
      transmit: Br,
      serialize: ei,
      asObject: In.browser.asObject,
      levels: Nn,
      timestamp: Vr(In)
    };
    qr.levels = fe.levels, qr.level = En, qr.setMaxListeners = qr.getMaxListeners = qr.emit = qr.addListener = qr.on = qr.prependListener = qr.once = qr.prependOnceListener = qr.removeListener = qr.removeAllListeners = qr.listeners = qr.listenerCount = qr.eventNames = qr.write = qr.flush = bn, qr.serializers = Pn, qr._serialize = ei, qr._stdErrSerialize = oi, qr.child = di, Br && (qr._logEvent = kr());
    function ri() {
      return this.level === "silent" ? 1 / 0 : this.levels.values[this.level];
    }
    function Sn() {
      return this._level;
    }
    function ai(ii) {
      if (ii !== "silent" && !this.levels.values[ii])
        throw Error("unknown level " + ii);
      this._level = ii, me(Jr, qr, "error", "log"), me(Jr, qr, "fatal", "error"), me(Jr, qr, "warn", "error"), me(Jr, qr, "info", "log"), me(Jr, qr, "debug", "log"), me(Jr, qr, "trace", "log");
    }
    function di(ii, fi) {
      if (!ii)
        throw new Error("missing bindings for child Pino");
      fi = fi || {}, ei && ii.serializers && (fi.serializers = ii.serializers);
      const Ei = fi.serializers;
      if (ei && Ei) {
        var bi = Object.assign({}, Pn, Ei), Si = In.browser.serialize === !0 ? Object.keys(bi) : ei;
        delete ii.serializers, Er([ii], Si, bi, this._stdErrSerialize);
      }
      function Ii(yi) {
        this._childLevel = (yi._childLevel | 0) + 1, this.error = br(yi, ii, "error"), this.fatal = br(yi, ii, "fatal"), this.warn = br(yi, ii, "warn"), this.info = br(yi, ii, "info"), this.debug = br(yi, ii, "debug"), this.trace = br(yi, ii, "trace"), bi && (this.serializers = bi, this._serialize = Si), Br && (this._logEvent = kr(
          [].concat(yi._logEvent.bindings, ii)
        ));
      }
      return Ii.prototype = this, new Ii(this);
    }
    return qr;
  }
  fe.levels = {
    values: {
      fatal: 60,
      error: 50,
      warn: 40,
      info: 30,
      debug: 20,
      trace: 10
    },
    labels: {
      10: "trace",
      20: "debug",
      30: "info",
      40: "warn",
      50: "error",
      60: "fatal"
    }
  }, fe.stdSerializers = s, fe.stdTimeFunctions = Object.assign({}, { nullTime: Yr, epochTime: Zr, unixTime: ti, isoTime: On });
  function me(In, Br, Hr, Pn) {
    const ei = Object.getPrototypeOf(Br);
    Br[Hr] = Br.levelVal > Br.levels.values[Hr] ? bn : ei[Hr] ? ei[Hr] : e[Hr] || e[Pn] || bn, ye(In, Br, Hr);
  }
  function ye(In, Br, Hr) {
    !In.transmit && Br[Hr] === bn || (Br[Hr] = function(Pn) {
      return function() {
        const oi = In.timestamp(), Nn = new Array(arguments.length), En = Object.getPrototypeOf && Object.getPrototypeOf(this) === e ? e : this;
        for (var qr = 0; qr < Nn.length; qr++)
          Nn[qr] = arguments[qr];
        if (In.serialize && !In.asObject && Er(Nn, this._serialize, this.serializers, this._stdErrSerialize), In.asObject ? Pn.call(En, fr(this, Hr, Nn, oi)) : Pn.apply(En, Nn), In.transmit) {
          const Jr = In.transmit.level || Br.level, ri = fe.levels.values[Jr], Sn = fe.levels.values[Hr];
          if (Sn < ri)
            return;
          wr(this, {
            ts: oi,
            methodLevel: Hr,
            methodValue: Sn,
            transmitLevel: Jr,
            transmitValue: fe.levels.values[In.transmit.level || Br.level],
            send: In.transmit.send,
            val: Br.levelVal
          }, Nn);
        }
      };
    }(Br[Hr]));
  }
  function fr(In, Br, Hr, Pn) {
    In._serialize && Er(Hr, In._serialize, In.serializers, In._stdErrSerialize);
    const ei = Hr.slice();
    let oi = ei[0];
    const Nn = {};
    Pn && (Nn.time = Pn), Nn.level = fe.levels.values[Br];
    let En = (In._childLevel | 0) + 1;
    if (En < 1 && (En = 1), oi !== null && typeof oi == "object") {
      for (; En-- && typeof ei[0] == "object"; )
        Object.assign(Nn, ei.shift());
      oi = ei.length ? r(ei.shift(), ei) : void 0;
    } else
      typeof oi == "string" && (oi = r(ei.shift(), ei));
    return oi !== void 0 && (Nn.msg = oi), Nn;
  }
  function Er(In, Br, Hr, Pn) {
    for (const ei in In)
      if (Pn && In[ei] instanceof Error)
        In[ei] = fe.stdSerializers.err(In[ei]);
      else if (typeof In[ei] == "object" && !Array.isArray(In[ei]))
        for (const oi in In[ei])
          Br && Br.indexOf(oi) > -1 && oi in Hr && (In[ei][oi] = Hr[oi](In[ei][oi]));
  }
  function br(In, Br, Hr) {
    return function() {
      const Pn = new Array(1 + arguments.length);
      Pn[0] = Br;
      for (var ei = 1; ei < Pn.length; ei++)
        Pn[ei] = arguments[ei - 1];
      return In[Hr].apply(this, Pn);
    };
  }
  function wr(In, Br, Hr) {
    const Pn = Br.send, ei = Br.ts, oi = Br.methodLevel, Nn = Br.methodValue, En = Br.val, qr = In._logEvent.bindings;
    Er(
      Hr,
      In._serialize || Object.keys(In.serializers),
      In.serializers,
      In._stdErrSerialize === void 0 ? !0 : In._stdErrSerialize
    ), In._logEvent.ts = ei, In._logEvent.messages = Hr.filter(function(Jr) {
      return qr.indexOf(Jr) === -1;
    }), In._logEvent.level.label = oi, In._logEvent.level.value = Nn, Pn(oi, In._logEvent, En), In._logEvent = kr(qr);
  }
  function kr(In) {
    return {
      ts: 0,
      messages: [],
      bindings: In || [],
      level: { label: "", value: 0 }
    };
  }
  function Gr(In) {
    const Br = {
      type: In.constructor.name,
      msg: In.message,
      stack: In.stack
    };
    for (const Hr in In)
      Br[Hr] === void 0 && (Br[Hr] = In[Hr]);
    return Br;
  }
  function Vr(In) {
    return typeof In.timestamp == "function" ? In.timestamp : In.timestamp === !1 ? Yr : Zr;
  }
  function jr() {
    return {};
  }
  function Kr(In) {
    return In;
  }
  function bn() {
  }
  function Yr() {
    return !1;
  }
  function Zr() {
    return Date.now();
  }
  function ti() {
    return Math.round(Date.now() / 1e3);
  }
  function On() {
    return new Date(Date.now()).toISOString();
  }
  function ni() {
    function In(Br) {
      return typeof Br < "u" && Br;
    }
    try {
      return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
        get: function() {
          return delete Object.prototype.globalThis, this.globalThis = this;
        },
        configurable: !0
      }), globalThis;
    } catch {
      return In(self) || In(window) || In(this) || {};
    }
  }
  return browser$3;
}
var constants$2 = {}, hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, Object.defineProperty(constants$2, "__esModule", { value: !0 }), constants$2.PINO_CUSTOM_CONTEXT_KEY = constants$2.PINO_LOGGER_DEFAULTS = void 0, constants$2.PINO_LOGGER_DEFAULTS = {
    level: "info"
  }, constants$2.PINO_CUSTOM_CONTEXT_KEY = "custom_context"), constants$2;
}
var utils$6 = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils$6;
  hasRequiredUtils = 1, Object.defineProperty(utils$6, "__esModule", { value: !0 }), utils$6.generateChildLogger = utils$6.formatChildLoggerContext = utils$6.getLoggerContext = utils$6.setBrowserLoggerContext = utils$6.getBrowserLoggerContext = utils$6.getDefaultLoggerOptions = void 0;
  const r = requireConstants();
  function e(fr) {
    return Object.assign(Object.assign({}, fr), { level: (fr == null ? void 0 : fr.level) || r.PINO_LOGGER_DEFAULTS.level });
  }
  utils$6.getDefaultLoggerOptions = e;
  function s(fr, Er = r.PINO_CUSTOM_CONTEXT_KEY) {
    return fr[Er] || "";
  }
  utils$6.getBrowserLoggerContext = s;
  function o(fr, Er, br = r.PINO_CUSTOM_CONTEXT_KEY) {
    return fr[br] = Er, fr;
  }
  utils$6.setBrowserLoggerContext = o;
  function fe(fr, Er = r.PINO_CUSTOM_CONTEXT_KEY) {
    let br = "";
    return typeof fr.bindings > "u" ? br = s(fr, Er) : br = fr.bindings().context || "", br;
  }
  utils$6.getLoggerContext = fe;
  function me(fr, Er, br = r.PINO_CUSTOM_CONTEXT_KEY) {
    const wr = fe(fr, br);
    return wr.trim() ? `${wr}/${Er}` : Er;
  }
  utils$6.formatChildLoggerContext = me;
  function ye(fr, Er, br = r.PINO_CUSTOM_CONTEXT_KEY) {
    const wr = me(fr, Er, br), kr = fr.child({ context: wr });
    return o(kr, wr, br);
  }
  return utils$6.generateChildLogger = ye, utils$6;
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.pino = void 0;
  const e = tslib.exports, s = e.__importDefault(requireBrowser());
  Object.defineProperty(r, "pino", { enumerable: !0, get: function() {
    return s.default;
  } }), e.__exportStar(requireConstants(), r), e.__exportStar(requireUtils(), r);
})(cjs$3);
class n extends IEvents$1 {
  constructor(e) {
    super(), this.opts = e, this.protocol = "wc", this.version = 2;
  }
}
class h$2 extends IEvents$1 {
  constructor(e, s) {
    super(), this.core = e, this.logger = s, this.records = /* @__PURE__ */ new Map();
  }
}
class a$1 {
  constructor(e, s) {
    this.logger = e, this.core = s;
  }
}
class u extends IEvents$1 {
  constructor(e, s) {
    super(), this.relayer = e, this.logger = s;
  }
}
class g$2 extends IEvents$1 {
  constructor(e) {
    super();
  }
}
class p$1 {
  constructor(e, s, o, fe) {
    this.core = e, this.logger = s, this.name = o;
  }
}
class d extends IEvents$1 {
  constructor(e, s) {
    super(), this.relayer = e, this.logger = s;
  }
}
class E extends IEvents$1 {
  constructor(e, s) {
    super(), this.core = e, this.logger = s;
  }
}
class y {
  constructor(e, s) {
    this.projectId = e, this.logger = s;
  }
}
class v$1 {
  constructor(e, s) {
    this.projectId = e, this.logger = s;
  }
}
class b$2 {
  constructor(e) {
    this.opts = e, this.protocol = "wc", this.version = 2;
  }
}
class w$3 {
  constructor(e) {
    this.client = e;
  }
}
var ed25519 = {}, random = {}, system = {}, browser$2 = {};
Object.defineProperty(browser$2, "__esModule", { value: !0 });
browser$2.BrowserRandomSource = void 0;
const QUOTA = 65536;
class BrowserRandomSource {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const e = typeof self < "u" ? self.crypto || self.msCrypto : null;
    e && e.getRandomValues !== void 0 && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const s = new Uint8Array(e);
    for (let o = 0; o < s.length; o += QUOTA)
      this._crypto.getRandomValues(s.subarray(o, o + Math.min(s.length - o, QUOTA)));
    return s;
  }
}
browser$2.BrowserRandomSource = BrowserRandomSource;
var node = {}, wipe$1 = {};
Object.defineProperty(wipe$1, "__esModule", { value: !0 });
function wipe(r) {
  for (var e = 0; e < r.length; e++)
    r[e] = 0;
  return r;
}
wipe$1.wipe = wipe;
Object.defineProperty(node, "__esModule", { value: !0 });
node.NodeRandomSource = void 0;
const wipe_1$3 = wipe$1;
class NodeRandomSource {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof commonjsRequire < "u") {
      const e = require$$0$4;
      e && e.randomBytes && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let s = this._crypto.randomBytes(e);
    if (s.length !== e)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const o = new Uint8Array(e);
    for (let fe = 0; fe < o.length; fe++)
      o[fe] = s[fe];
    return (0, wipe_1$3.wipe)(s), o;
  }
}
node.NodeRandomSource = NodeRandomSource;
Object.defineProperty(system, "__esModule", { value: !0 });
system.SystemRandomSource = void 0;
const browser_1 = browser$2, node_1 = node;
class SystemRandomSource {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new browser_1.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new node_1.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(e);
  }
}
system.SystemRandomSource = SystemRandomSource;
var binary = {}, int = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  function e(fr, Er) {
    var br = fr >>> 16 & 65535, wr = fr & 65535, kr = Er >>> 16 & 65535, Gr = Er & 65535;
    return wr * Gr + (br * Gr + wr * kr << 16 >>> 0) | 0;
  }
  r.mul = Math.imul || e;
  function s(fr, Er) {
    return fr + Er | 0;
  }
  r.add = s;
  function o(fr, Er) {
    return fr - Er | 0;
  }
  r.sub = o;
  function fe(fr, Er) {
    return fr << Er | fr >>> 32 - Er;
  }
  r.rotl = fe;
  function me(fr, Er) {
    return fr << 32 - Er | fr >>> Er;
  }
  r.rotr = me;
  function ye(fr) {
    return typeof fr == "number" && isFinite(fr) && Math.floor(fr) === fr;
  }
  r.isInteger = Number.isInteger || ye, r.MAX_SAFE_INTEGER = 9007199254740991, r.isSafeInteger = function(fr) {
    return r.isInteger(fr) && fr >= -r.MAX_SAFE_INTEGER && fr <= r.MAX_SAFE_INTEGER;
  };
})(int);
Object.defineProperty(binary, "__esModule", { value: !0 });
var int_1 = int;
function readInt16BE(r, e) {
  return e === void 0 && (e = 0), (r[e + 0] << 8 | r[e + 1]) << 16 >> 16;
}
binary.readInt16BE = readInt16BE;
function readUint16BE(r, e) {
  return e === void 0 && (e = 0), (r[e + 0] << 8 | r[e + 1]) >>> 0;
}
binary.readUint16BE = readUint16BE;
function readInt16LE(r, e) {
  return e === void 0 && (e = 0), (r[e + 1] << 8 | r[e]) << 16 >> 16;
}
binary.readInt16LE = readInt16LE;
function readUint16LE(r, e) {
  return e === void 0 && (e = 0), (r[e + 1] << 8 | r[e]) >>> 0;
}
binary.readUint16LE = readUint16LE;
function writeUint16BE(r, e, s) {
  return e === void 0 && (e = new Uint8Array(2)), s === void 0 && (s = 0), e[s + 0] = r >>> 8, e[s + 1] = r >>> 0, e;
}
binary.writeUint16BE = writeUint16BE;
binary.writeInt16BE = writeUint16BE;
function writeUint16LE(r, e, s) {
  return e === void 0 && (e = new Uint8Array(2)), s === void 0 && (s = 0), e[s + 0] = r >>> 0, e[s + 1] = r >>> 8, e;
}
binary.writeUint16LE = writeUint16LE;
binary.writeInt16LE = writeUint16LE;
function readInt32BE(r, e) {
  return e === void 0 && (e = 0), r[e] << 24 | r[e + 1] << 16 | r[e + 2] << 8 | r[e + 3];
}
binary.readInt32BE = readInt32BE;
function readUint32BE(r, e) {
  return e === void 0 && (e = 0), (r[e] << 24 | r[e + 1] << 16 | r[e + 2] << 8 | r[e + 3]) >>> 0;
}
binary.readUint32BE = readUint32BE;
function readInt32LE(r, e) {
  return e === void 0 && (e = 0), r[e + 3] << 24 | r[e + 2] << 16 | r[e + 1] << 8 | r[e];
}
binary.readInt32LE = readInt32LE;
function readUint32LE(r, e) {
  return e === void 0 && (e = 0), (r[e + 3] << 24 | r[e + 2] << 16 | r[e + 1] << 8 | r[e]) >>> 0;
}
binary.readUint32LE = readUint32LE;
function writeUint32BE(r, e, s) {
  return e === void 0 && (e = new Uint8Array(4)), s === void 0 && (s = 0), e[s + 0] = r >>> 24, e[s + 1] = r >>> 16, e[s + 2] = r >>> 8, e[s + 3] = r >>> 0, e;
}
binary.writeUint32BE = writeUint32BE;
binary.writeInt32BE = writeUint32BE;
function writeUint32LE(r, e, s) {
  return e === void 0 && (e = new Uint8Array(4)), s === void 0 && (s = 0), e[s + 0] = r >>> 0, e[s + 1] = r >>> 8, e[s + 2] = r >>> 16, e[s + 3] = r >>> 24, e;
}
binary.writeUint32LE = writeUint32LE;
binary.writeInt32LE = writeUint32LE;
function readInt64BE(r, e) {
  e === void 0 && (e = 0);
  var s = readInt32BE(r, e), o = readInt32BE(r, e + 4);
  return s * 4294967296 + o - (o >> 31) * 4294967296;
}
binary.readInt64BE = readInt64BE;
function readUint64BE(r, e) {
  e === void 0 && (e = 0);
  var s = readUint32BE(r, e), o = readUint32BE(r, e + 4);
  return s * 4294967296 + o;
}
binary.readUint64BE = readUint64BE;
function readInt64LE(r, e) {
  e === void 0 && (e = 0);
  var s = readInt32LE(r, e), o = readInt32LE(r, e + 4);
  return o * 4294967296 + s - (s >> 31) * 4294967296;
}
binary.readInt64LE = readInt64LE;
function readUint64LE(r, e) {
  e === void 0 && (e = 0);
  var s = readUint32LE(r, e), o = readUint32LE(r, e + 4);
  return o * 4294967296 + s;
}
binary.readUint64LE = readUint64LE;
function writeUint64BE(r, e, s) {
  return e === void 0 && (e = new Uint8Array(8)), s === void 0 && (s = 0), writeUint32BE(r / 4294967296 >>> 0, e, s), writeUint32BE(r >>> 0, e, s + 4), e;
}
binary.writeUint64BE = writeUint64BE;
binary.writeInt64BE = writeUint64BE;
function writeUint64LE(r, e, s) {
  return e === void 0 && (e = new Uint8Array(8)), s === void 0 && (s = 0), writeUint32LE(r >>> 0, e, s), writeUint32LE(r / 4294967296 >>> 0, e, s + 4), e;
}
binary.writeUint64LE = writeUint64LE;
binary.writeInt64LE = writeUint64LE;
function readUintBE(r, e, s) {
  if (s === void 0 && (s = 0), r % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (r / 8 > e.length - s)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var o = 0, fe = 1, me = r / 8 + s - 1; me >= s; me--)
    o += e[me] * fe, fe *= 256;
  return o;
}
binary.readUintBE = readUintBE;
function readUintLE(r, e, s) {
  if (s === void 0 && (s = 0), r % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (r / 8 > e.length - s)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var o = 0, fe = 1, me = s; me < s + r / 8; me++)
    o += e[me] * fe, fe *= 256;
  return o;
}
binary.readUintLE = readUintLE;
function writeUintBE(r, e, s, o) {
  if (s === void 0 && (s = new Uint8Array(r / 8)), o === void 0 && (o = 0), r % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!int_1.isSafeInteger(e))
    throw new Error("writeUintBE value must be an integer");
  for (var fe = 1, me = r / 8 + o - 1; me >= o; me--)
    s[me] = e / fe & 255, fe *= 256;
  return s;
}
binary.writeUintBE = writeUintBE;
function writeUintLE(r, e, s, o) {
  if (s === void 0 && (s = new Uint8Array(r / 8)), o === void 0 && (o = 0), r % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!int_1.isSafeInteger(e))
    throw new Error("writeUintLE value must be an integer");
  for (var fe = 1, me = o; me < o + r / 8; me++)
    s[me] = e / fe & 255, fe *= 256;
  return s;
}
binary.writeUintLE = writeUintLE;
function readFloat32BE(r, e) {
  e === void 0 && (e = 0);
  var s = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return s.getFloat32(e);
}
binary.readFloat32BE = readFloat32BE;
function readFloat32LE(r, e) {
  e === void 0 && (e = 0);
  var s = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return s.getFloat32(e, !0);
}
binary.readFloat32LE = readFloat32LE;
function readFloat64BE(r, e) {
  e === void 0 && (e = 0);
  var s = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return s.getFloat64(e);
}
binary.readFloat64BE = readFloat64BE;
function readFloat64LE(r, e) {
  e === void 0 && (e = 0);
  var s = new DataView(r.buffer, r.byteOffset, r.byteLength);
  return s.getFloat64(e, !0);
}
binary.readFloat64LE = readFloat64LE;
function writeFloat32BE(r, e, s) {
  e === void 0 && (e = new Uint8Array(4)), s === void 0 && (s = 0);
  var o = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return o.setFloat32(s, r), e;
}
binary.writeFloat32BE = writeFloat32BE;
function writeFloat32LE(r, e, s) {
  e === void 0 && (e = new Uint8Array(4)), s === void 0 && (s = 0);
  var o = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return o.setFloat32(s, r, !0), e;
}
binary.writeFloat32LE = writeFloat32LE;
function writeFloat64BE(r, e, s) {
  e === void 0 && (e = new Uint8Array(8)), s === void 0 && (s = 0);
  var o = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return o.setFloat64(s, r), e;
}
binary.writeFloat64BE = writeFloat64BE;
function writeFloat64LE(r, e, s) {
  e === void 0 && (e = new Uint8Array(8)), s === void 0 && (s = 0);
  var o = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return o.setFloat64(s, r, !0), e;
}
binary.writeFloat64LE = writeFloat64LE;
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.randomStringForEntropy = r.randomString = r.randomUint32 = r.randomBytes = r.defaultRandomSource = void 0;
  const e = system, s = binary, o = wipe$1;
  r.defaultRandomSource = new e.SystemRandomSource();
  function fe(br, wr = r.defaultRandomSource) {
    return wr.randomBytes(br);
  }
  r.randomBytes = fe;
  function me(br = r.defaultRandomSource) {
    const wr = fe(4, br), kr = (0, s.readUint32LE)(wr);
    return (0, o.wipe)(wr), kr;
  }
  r.randomUint32 = me;
  const ye = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function fr(br, wr = ye, kr = r.defaultRandomSource) {
    if (wr.length < 2)
      throw new Error("randomString charset is too short");
    if (wr.length > 256)
      throw new Error("randomString charset is too long");
    let Gr = "";
    const Vr = wr.length, jr = 256 - 256 % Vr;
    for (; br > 0; ) {
      const Kr = fe(Math.ceil(br * 256 / jr), kr);
      for (let bn = 0; bn < Kr.length && br > 0; bn++) {
        const Yr = Kr[bn];
        Yr < jr && (Gr += wr.charAt(Yr % Vr), br--);
      }
      (0, o.wipe)(Kr);
    }
    return Gr;
  }
  r.randomString = fr;
  function Er(br, wr = ye, kr = r.defaultRandomSource) {
    const Gr = Math.ceil(br / (Math.log(wr.length) / Math.LN2));
    return fr(Gr, wr, kr);
  }
  r.randomStringForEntropy = Er;
})(random);
var sha512$1 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  var e = binary, s = wipe$1;
  r.DIGEST_LENGTH = 64, r.BLOCK_SIZE = 128;
  var o = function() {
    function fr() {
      this.digestLength = r.DIGEST_LENGTH, this.blockSize = r.BLOCK_SIZE, this._stateHi = new Int32Array(8), this._stateLo = new Int32Array(8), this._tempHi = new Int32Array(16), this._tempLo = new Int32Array(16), this._buffer = new Uint8Array(256), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
    }
    return fr.prototype._initState = function() {
      this._stateHi[0] = 1779033703, this._stateHi[1] = 3144134277, this._stateHi[2] = 1013904242, this._stateHi[3] = 2773480762, this._stateHi[4] = 1359893119, this._stateHi[5] = 2600822924, this._stateHi[6] = 528734635, this._stateHi[7] = 1541459225, this._stateLo[0] = 4089235720, this._stateLo[1] = 2227873595, this._stateLo[2] = 4271175723, this._stateLo[3] = 1595750129, this._stateLo[4] = 2917565137, this._stateLo[5] = 725511199, this._stateLo[6] = 4215389547, this._stateLo[7] = 327033209;
    }, fr.prototype.reset = function() {
      return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
    }, fr.prototype.clean = function() {
      s.wipe(this._buffer), s.wipe(this._tempHi), s.wipe(this._tempLo), this.reset();
    }, fr.prototype.update = function(Er, br) {
      if (br === void 0 && (br = Er.length), this._finished)
        throw new Error("SHA512: can't update because hash was finished.");
      var wr = 0;
      if (this._bytesHashed += br, this._bufferLength > 0) {
        for (; this._bufferLength < r.BLOCK_SIZE && br > 0; )
          this._buffer[this._bufferLength++] = Er[wr++], br--;
        this._bufferLength === this.blockSize && (me(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize), this._bufferLength = 0);
      }
      for (br >= this.blockSize && (wr = me(this._tempHi, this._tempLo, this._stateHi, this._stateLo, Er, wr, br), br %= this.blockSize); br > 0; )
        this._buffer[this._bufferLength++] = Er[wr++], br--;
      return this;
    }, fr.prototype.finish = function(Er) {
      if (!this._finished) {
        var br = this._bytesHashed, wr = this._bufferLength, kr = br / 536870912 | 0, Gr = br << 3, Vr = br % 128 < 112 ? 128 : 256;
        this._buffer[wr] = 128;
        for (var jr = wr + 1; jr < Vr - 8; jr++)
          this._buffer[jr] = 0;
        e.writeUint32BE(kr, this._buffer, Vr - 8), e.writeUint32BE(Gr, this._buffer, Vr - 4), me(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, Vr), this._finished = !0;
      }
      for (var jr = 0; jr < this.digestLength / 8; jr++)
        e.writeUint32BE(this._stateHi[jr], Er, jr * 8), e.writeUint32BE(this._stateLo[jr], Er, jr * 8 + 4);
      return this;
    }, fr.prototype.digest = function() {
      var Er = new Uint8Array(this.digestLength);
      return this.finish(Er), Er;
    }, fr.prototype.saveState = function() {
      if (this._finished)
        throw new Error("SHA256: cannot save finished state");
      return {
        stateHi: new Int32Array(this._stateHi),
        stateLo: new Int32Array(this._stateLo),
        buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
        bufferLength: this._bufferLength,
        bytesHashed: this._bytesHashed
      };
    }, fr.prototype.restoreState = function(Er) {
      return this._stateHi.set(Er.stateHi), this._stateLo.set(Er.stateLo), this._bufferLength = Er.bufferLength, Er.buffer && this._buffer.set(Er.buffer), this._bytesHashed = Er.bytesHashed, this._finished = !1, this;
    }, fr.prototype.cleanSavedState = function(Er) {
      s.wipe(Er.stateHi), s.wipe(Er.stateLo), Er.buffer && s.wipe(Er.buffer), Er.bufferLength = 0, Er.bytesHashed = 0;
    }, fr;
  }();
  r.SHA512 = o;
  var fe = new Int32Array([
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ]);
  function me(fr, Er, br, wr, kr, Gr, Vr) {
    for (var jr = br[0], Kr = br[1], bn = br[2], Yr = br[3], Zr = br[4], ti = br[5], On = br[6], ni = br[7], In = wr[0], Br = wr[1], Hr = wr[2], Pn = wr[3], ei = wr[4], oi = wr[5], Nn = wr[6], En = wr[7], qr, Jr, ri, Sn, ai, di, ii, fi; Vr >= 128; ) {
      for (var Ei = 0; Ei < 16; Ei++) {
        var bi = 8 * Ei + Gr;
        fr[Ei] = e.readUint32BE(kr, bi), Er[Ei] = e.readUint32BE(kr, bi + 4);
      }
      for (var Ei = 0; Ei < 80; Ei++) {
        var Si = jr, Ii = Kr, yi = bn, ui = Yr, hi = Zr, gi = ti, Qr = On, wn = ni, ci = In, vi = Br, Ni = Hr, Fi = Pn, Pi = ei, Li = oi, oo = Nn, ao = En;
        if (qr = ni, Jr = En, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = (Zr >>> 14 | ei << 32 - 14) ^ (Zr >>> 18 | ei << 32 - 18) ^ (ei >>> 41 - 32 | Zr << 32 - (41 - 32)), Jr = (ei >>> 14 | Zr << 32 - 14) ^ (ei >>> 18 | Zr << 32 - 18) ^ (Zr >>> 41 - 32 | ei << 32 - (41 - 32)), ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, qr = Zr & ti ^ ~Zr & On, Jr = ei & oi ^ ~ei & Nn, ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, qr = fe[Ei * 2], Jr = fe[Ei * 2 + 1], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, qr = fr[Ei % 16], Jr = Er[Ei % 16], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, ri = ii & 65535 | fi << 16, Sn = ai & 65535 | di << 16, qr = ri, Jr = Sn, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = (jr >>> 28 | In << 32 - 28) ^ (In >>> 34 - 32 | jr << 32 - (34 - 32)) ^ (In >>> 39 - 32 | jr << 32 - (39 - 32)), Jr = (In >>> 28 | jr << 32 - 28) ^ (jr >>> 34 - 32 | In << 32 - (34 - 32)) ^ (jr >>> 39 - 32 | In << 32 - (39 - 32)), ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, qr = jr & Kr ^ jr & bn ^ Kr & bn, Jr = In & Br ^ In & Hr ^ Br & Hr, ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, wn = ii & 65535 | fi << 16, ao = ai & 65535 | di << 16, qr = ui, Jr = Fi, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = ri, Jr = Sn, ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, ui = ii & 65535 | fi << 16, Fi = ai & 65535 | di << 16, Kr = Si, bn = Ii, Yr = yi, Zr = ui, ti = hi, On = gi, ni = Qr, jr = wn, Br = ci, Hr = vi, Pn = Ni, ei = Fi, oi = Pi, Nn = Li, En = oo, In = ao, Ei % 16 === 15)
          for (var bi = 0; bi < 16; bi++)
            qr = fr[bi], Jr = Er[bi], ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = fr[(bi + 9) % 16], Jr = Er[(bi + 9) % 16], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, ri = fr[(bi + 1) % 16], Sn = Er[(bi + 1) % 16], qr = (ri >>> 1 | Sn << 32 - 1) ^ (ri >>> 8 | Sn << 32 - 8) ^ ri >>> 7, Jr = (Sn >>> 1 | ri << 32 - 1) ^ (Sn >>> 8 | ri << 32 - 8) ^ (Sn >>> 7 | ri << 32 - 7), ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, ri = fr[(bi + 14) % 16], Sn = Er[(bi + 14) % 16], qr = (ri >>> 19 | Sn << 32 - 19) ^ (Sn >>> 61 - 32 | ri << 32 - (61 - 32)) ^ ri >>> 6, Jr = (Sn >>> 19 | ri << 32 - 19) ^ (ri >>> 61 - 32 | Sn << 32 - (61 - 32)) ^ (Sn >>> 6 | ri << 32 - 6), ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, fr[bi] = ii & 65535 | fi << 16, Er[bi] = ai & 65535 | di << 16;
      }
      qr = jr, Jr = In, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[0], Jr = wr[0], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[0] = jr = ii & 65535 | fi << 16, wr[0] = In = ai & 65535 | di << 16, qr = Kr, Jr = Br, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[1], Jr = wr[1], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[1] = Kr = ii & 65535 | fi << 16, wr[1] = Br = ai & 65535 | di << 16, qr = bn, Jr = Hr, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[2], Jr = wr[2], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[2] = bn = ii & 65535 | fi << 16, wr[2] = Hr = ai & 65535 | di << 16, qr = Yr, Jr = Pn, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[3], Jr = wr[3], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[3] = Yr = ii & 65535 | fi << 16, wr[3] = Pn = ai & 65535 | di << 16, qr = Zr, Jr = ei, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[4], Jr = wr[4], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[4] = Zr = ii & 65535 | fi << 16, wr[4] = ei = ai & 65535 | di << 16, qr = ti, Jr = oi, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[5], Jr = wr[5], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[5] = ti = ii & 65535 | fi << 16, wr[5] = oi = ai & 65535 | di << 16, qr = On, Jr = Nn, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[6], Jr = wr[6], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[6] = On = ii & 65535 | fi << 16, wr[6] = Nn = ai & 65535 | di << 16, qr = ni, Jr = En, ai = Jr & 65535, di = Jr >>> 16, ii = qr & 65535, fi = qr >>> 16, qr = br[7], Jr = wr[7], ai += Jr & 65535, di += Jr >>> 16, ii += qr & 65535, fi += qr >>> 16, di += ai >>> 16, ii += di >>> 16, fi += ii >>> 16, br[7] = ni = ii & 65535 | fi << 16, wr[7] = En = ai & 65535 | di << 16, Gr += 128, Vr -= 128;
    }
    return Gr;
  }
  function ye(fr) {
    var Er = new o();
    Er.update(fr);
    var br = Er.digest();
    return Er.clean(), br;
  }
  r.hash = ye;
})(sha512$1);
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.convertSecretKeyToX25519 = r.convertPublicKeyToX25519 = r.verify = r.sign = r.extractPublicKeyFromSecretKey = r.generateKeyPair = r.generateKeyPairFromSeed = r.SEED_LENGTH = r.SECRET_KEY_LENGTH = r.PUBLIC_KEY_LENGTH = r.SIGNATURE_LENGTH = void 0;
  const e = random, s = sha512$1, o = wipe$1;
  r.SIGNATURE_LENGTH = 64, r.PUBLIC_KEY_LENGTH = 32, r.SECRET_KEY_LENGTH = 64, r.SEED_LENGTH = 32;
  function fe(ui) {
    const hi = new Float64Array(16);
    if (ui)
      for (let gi = 0; gi < ui.length; gi++)
        hi[gi] = ui[gi];
    return hi;
  }
  const me = new Uint8Array(32);
  me[0] = 9;
  const ye = fe(), fr = fe([1]), Er = fe([
    30883,
    4953,
    19914,
    30187,
    55467,
    16705,
    2637,
    112,
    59544,
    30585,
    16505,
    36039,
    65139,
    11119,
    27886,
    20995
  ]), br = fe([
    61785,
    9906,
    39828,
    60374,
    45398,
    33411,
    5274,
    224,
    53552,
    61171,
    33010,
    6542,
    64743,
    22239,
    55772,
    9222
  ]), wr = fe([
    54554,
    36645,
    11616,
    51542,
    42930,
    38181,
    51040,
    26924,
    56412,
    64982,
    57905,
    49316,
    21502,
    52590,
    14035,
    8553
  ]), kr = fe([
    26200,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214
  ]), Gr = fe([
    41136,
    18958,
    6951,
    50414,
    58488,
    44335,
    6150,
    12099,
    55207,
    15867,
    153,
    11085,
    57099,
    20417,
    9344,
    11139
  ]);
  function Vr(ui, hi) {
    for (let gi = 0; gi < 16; gi++)
      ui[gi] = hi[gi] | 0;
  }
  function jr(ui) {
    let hi = 1;
    for (let gi = 0; gi < 16; gi++) {
      let Qr = ui[gi] + hi + 65535;
      hi = Math.floor(Qr / 65536), ui[gi] = Qr - hi * 65536;
    }
    ui[0] += hi - 1 + 37 * (hi - 1);
  }
  function Kr(ui, hi, gi) {
    const Qr = ~(gi - 1);
    for (let wn = 0; wn < 16; wn++) {
      const ci = Qr & (ui[wn] ^ hi[wn]);
      ui[wn] ^= ci, hi[wn] ^= ci;
    }
  }
  function bn(ui, hi) {
    const gi = fe(), Qr = fe();
    for (let wn = 0; wn < 16; wn++)
      Qr[wn] = hi[wn];
    jr(Qr), jr(Qr), jr(Qr);
    for (let wn = 0; wn < 2; wn++) {
      gi[0] = Qr[0] - 65517;
      for (let vi = 1; vi < 15; vi++)
        gi[vi] = Qr[vi] - 65535 - (gi[vi - 1] >> 16 & 1), gi[vi - 1] &= 65535;
      gi[15] = Qr[15] - 32767 - (gi[14] >> 16 & 1);
      const ci = gi[15] >> 16 & 1;
      gi[14] &= 65535, Kr(Qr, gi, 1 - ci);
    }
    for (let wn = 0; wn < 16; wn++)
      ui[2 * wn] = Qr[wn] & 255, ui[2 * wn + 1] = Qr[wn] >> 8;
  }
  function Yr(ui, hi) {
    let gi = 0;
    for (let Qr = 0; Qr < 32; Qr++)
      gi |= ui[Qr] ^ hi[Qr];
    return (1 & gi - 1 >>> 8) - 1;
  }
  function Zr(ui, hi) {
    const gi = new Uint8Array(32), Qr = new Uint8Array(32);
    return bn(gi, ui), bn(Qr, hi), Yr(gi, Qr);
  }
  function ti(ui) {
    const hi = new Uint8Array(32);
    return bn(hi, ui), hi[0] & 1;
  }
  function On(ui, hi) {
    for (let gi = 0; gi < 16; gi++)
      ui[gi] = hi[2 * gi] + (hi[2 * gi + 1] << 8);
    ui[15] &= 32767;
  }
  function ni(ui, hi, gi) {
    for (let Qr = 0; Qr < 16; Qr++)
      ui[Qr] = hi[Qr] + gi[Qr];
  }
  function In(ui, hi, gi) {
    for (let Qr = 0; Qr < 16; Qr++)
      ui[Qr] = hi[Qr] - gi[Qr];
  }
  function Br(ui, hi, gi) {
    let Qr, wn, ci = 0, vi = 0, Ni = 0, Fi = 0, Pi = 0, Li = 0, oo = 0, ao = 0, zi = 0, Ki = 0, Vi = 0, Yi = 0, eo = 0, Ui = 0, ji = 0, si = 0, Wr = 0, Xr = 0, li = 0, _i = 0, $i = 0, Ai = 0, Di = 0, Mi = 0, to = 0, so = 0, no = 0, Po = 0, Uo = 0, jo = 0, Go = 0, fo = gi[0], co = gi[1], _o = gi[2], Eo = gi[3], vo = gi[4], mo = gi[5], Io = gi[6], yo = gi[7], bo = gi[8], $o = gi[9], Co = gi[10], So = gi[11], wo = gi[12], uo = gi[13], To = gi[14], Ao = gi[15];
    Qr = hi[0], ci += Qr * fo, vi += Qr * co, Ni += Qr * _o, Fi += Qr * Eo, Pi += Qr * vo, Li += Qr * mo, oo += Qr * Io, ao += Qr * yo, zi += Qr * bo, Ki += Qr * $o, Vi += Qr * Co, Yi += Qr * So, eo += Qr * wo, Ui += Qr * uo, ji += Qr * To, si += Qr * Ao, Qr = hi[1], vi += Qr * fo, Ni += Qr * co, Fi += Qr * _o, Pi += Qr * Eo, Li += Qr * vo, oo += Qr * mo, ao += Qr * Io, zi += Qr * yo, Ki += Qr * bo, Vi += Qr * $o, Yi += Qr * Co, eo += Qr * So, Ui += Qr * wo, ji += Qr * uo, si += Qr * To, Wr += Qr * Ao, Qr = hi[2], Ni += Qr * fo, Fi += Qr * co, Pi += Qr * _o, Li += Qr * Eo, oo += Qr * vo, ao += Qr * mo, zi += Qr * Io, Ki += Qr * yo, Vi += Qr * bo, Yi += Qr * $o, eo += Qr * Co, Ui += Qr * So, ji += Qr * wo, si += Qr * uo, Wr += Qr * To, Xr += Qr * Ao, Qr = hi[3], Fi += Qr * fo, Pi += Qr * co, Li += Qr * _o, oo += Qr * Eo, ao += Qr * vo, zi += Qr * mo, Ki += Qr * Io, Vi += Qr * yo, Yi += Qr * bo, eo += Qr * $o, Ui += Qr * Co, ji += Qr * So, si += Qr * wo, Wr += Qr * uo, Xr += Qr * To, li += Qr * Ao, Qr = hi[4], Pi += Qr * fo, Li += Qr * co, oo += Qr * _o, ao += Qr * Eo, zi += Qr * vo, Ki += Qr * mo, Vi += Qr * Io, Yi += Qr * yo, eo += Qr * bo, Ui += Qr * $o, ji += Qr * Co, si += Qr * So, Wr += Qr * wo, Xr += Qr * uo, li += Qr * To, _i += Qr * Ao, Qr = hi[5], Li += Qr * fo, oo += Qr * co, ao += Qr * _o, zi += Qr * Eo, Ki += Qr * vo, Vi += Qr * mo, Yi += Qr * Io, eo += Qr * yo, Ui += Qr * bo, ji += Qr * $o, si += Qr * Co, Wr += Qr * So, Xr += Qr * wo, li += Qr * uo, _i += Qr * To, $i += Qr * Ao, Qr = hi[6], oo += Qr * fo, ao += Qr * co, zi += Qr * _o, Ki += Qr * Eo, Vi += Qr * vo, Yi += Qr * mo, eo += Qr * Io, Ui += Qr * yo, ji += Qr * bo, si += Qr * $o, Wr += Qr * Co, Xr += Qr * So, li += Qr * wo, _i += Qr * uo, $i += Qr * To, Ai += Qr * Ao, Qr = hi[7], ao += Qr * fo, zi += Qr * co, Ki += Qr * _o, Vi += Qr * Eo, Yi += Qr * vo, eo += Qr * mo, Ui += Qr * Io, ji += Qr * yo, si += Qr * bo, Wr += Qr * $o, Xr += Qr * Co, li += Qr * So, _i += Qr * wo, $i += Qr * uo, Ai += Qr * To, Di += Qr * Ao, Qr = hi[8], zi += Qr * fo, Ki += Qr * co, Vi += Qr * _o, Yi += Qr * Eo, eo += Qr * vo, Ui += Qr * mo, ji += Qr * Io, si += Qr * yo, Wr += Qr * bo, Xr += Qr * $o, li += Qr * Co, _i += Qr * So, $i += Qr * wo, Ai += Qr * uo, Di += Qr * To, Mi += Qr * Ao, Qr = hi[9], Ki += Qr * fo, Vi += Qr * co, Yi += Qr * _o, eo += Qr * Eo, Ui += Qr * vo, ji += Qr * mo, si += Qr * Io, Wr += Qr * yo, Xr += Qr * bo, li += Qr * $o, _i += Qr * Co, $i += Qr * So, Ai += Qr * wo, Di += Qr * uo, Mi += Qr * To, to += Qr * Ao, Qr = hi[10], Vi += Qr * fo, Yi += Qr * co, eo += Qr * _o, Ui += Qr * Eo, ji += Qr * vo, si += Qr * mo, Wr += Qr * Io, Xr += Qr * yo, li += Qr * bo, _i += Qr * $o, $i += Qr * Co, Ai += Qr * So, Di += Qr * wo, Mi += Qr * uo, to += Qr * To, so += Qr * Ao, Qr = hi[11], Yi += Qr * fo, eo += Qr * co, Ui += Qr * _o, ji += Qr * Eo, si += Qr * vo, Wr += Qr * mo, Xr += Qr * Io, li += Qr * yo, _i += Qr * bo, $i += Qr * $o, Ai += Qr * Co, Di += Qr * So, Mi += Qr * wo, to += Qr * uo, so += Qr * To, no += Qr * Ao, Qr = hi[12], eo += Qr * fo, Ui += Qr * co, ji += Qr * _o, si += Qr * Eo, Wr += Qr * vo, Xr += Qr * mo, li += Qr * Io, _i += Qr * yo, $i += Qr * bo, Ai += Qr * $o, Di += Qr * Co, Mi += Qr * So, to += Qr * wo, so += Qr * uo, no += Qr * To, Po += Qr * Ao, Qr = hi[13], Ui += Qr * fo, ji += Qr * co, si += Qr * _o, Wr += Qr * Eo, Xr += Qr * vo, li += Qr * mo, _i += Qr * Io, $i += Qr * yo, Ai += Qr * bo, Di += Qr * $o, Mi += Qr * Co, to += Qr * So, so += Qr * wo, no += Qr * uo, Po += Qr * To, Uo += Qr * Ao, Qr = hi[14], ji += Qr * fo, si += Qr * co, Wr += Qr * _o, Xr += Qr * Eo, li += Qr * vo, _i += Qr * mo, $i += Qr * Io, Ai += Qr * yo, Di += Qr * bo, Mi += Qr * $o, to += Qr * Co, so += Qr * So, no += Qr * wo, Po += Qr * uo, Uo += Qr * To, jo += Qr * Ao, Qr = hi[15], si += Qr * fo, Wr += Qr * co, Xr += Qr * _o, li += Qr * Eo, _i += Qr * vo, $i += Qr * mo, Ai += Qr * Io, Di += Qr * yo, Mi += Qr * bo, to += Qr * $o, so += Qr * Co, no += Qr * So, Po += Qr * wo, Uo += Qr * uo, jo += Qr * To, Go += Qr * Ao, ci += 38 * Wr, vi += 38 * Xr, Ni += 38 * li, Fi += 38 * _i, Pi += 38 * $i, Li += 38 * Ai, oo += 38 * Di, ao += 38 * Mi, zi += 38 * to, Ki += 38 * so, Vi += 38 * no, Yi += 38 * Po, eo += 38 * Uo, Ui += 38 * jo, ji += 38 * Go, wn = 1, Qr = ci + wn + 65535, wn = Math.floor(Qr / 65536), ci = Qr - wn * 65536, Qr = vi + wn + 65535, wn = Math.floor(Qr / 65536), vi = Qr - wn * 65536, Qr = Ni + wn + 65535, wn = Math.floor(Qr / 65536), Ni = Qr - wn * 65536, Qr = Fi + wn + 65535, wn = Math.floor(Qr / 65536), Fi = Qr - wn * 65536, Qr = Pi + wn + 65535, wn = Math.floor(Qr / 65536), Pi = Qr - wn * 65536, Qr = Li + wn + 65535, wn = Math.floor(Qr / 65536), Li = Qr - wn * 65536, Qr = oo + wn + 65535, wn = Math.floor(Qr / 65536), oo = Qr - wn * 65536, Qr = ao + wn + 65535, wn = Math.floor(Qr / 65536), ao = Qr - wn * 65536, Qr = zi + wn + 65535, wn = Math.floor(Qr / 65536), zi = Qr - wn * 65536, Qr = Ki + wn + 65535, wn = Math.floor(Qr / 65536), Ki = Qr - wn * 65536, Qr = Vi + wn + 65535, wn = Math.floor(Qr / 65536), Vi = Qr - wn * 65536, Qr = Yi + wn + 65535, wn = Math.floor(Qr / 65536), Yi = Qr - wn * 65536, Qr = eo + wn + 65535, wn = Math.floor(Qr / 65536), eo = Qr - wn * 65536, Qr = Ui + wn + 65535, wn = Math.floor(Qr / 65536), Ui = Qr - wn * 65536, Qr = ji + wn + 65535, wn = Math.floor(Qr / 65536), ji = Qr - wn * 65536, Qr = si + wn + 65535, wn = Math.floor(Qr / 65536), si = Qr - wn * 65536, ci += wn - 1 + 37 * (wn - 1), wn = 1, Qr = ci + wn + 65535, wn = Math.floor(Qr / 65536), ci = Qr - wn * 65536, Qr = vi + wn + 65535, wn = Math.floor(Qr / 65536), vi = Qr - wn * 65536, Qr = Ni + wn + 65535, wn = Math.floor(Qr / 65536), Ni = Qr - wn * 65536, Qr = Fi + wn + 65535, wn = Math.floor(Qr / 65536), Fi = Qr - wn * 65536, Qr = Pi + wn + 65535, wn = Math.floor(Qr / 65536), Pi = Qr - wn * 65536, Qr = Li + wn + 65535, wn = Math.floor(Qr / 65536), Li = Qr - wn * 65536, Qr = oo + wn + 65535, wn = Math.floor(Qr / 65536), oo = Qr - wn * 65536, Qr = ao + wn + 65535, wn = Math.floor(Qr / 65536), ao = Qr - wn * 65536, Qr = zi + wn + 65535, wn = Math.floor(Qr / 65536), zi = Qr - wn * 65536, Qr = Ki + wn + 65535, wn = Math.floor(Qr / 65536), Ki = Qr - wn * 65536, Qr = Vi + wn + 65535, wn = Math.floor(Qr / 65536), Vi = Qr - wn * 65536, Qr = Yi + wn + 65535, wn = Math.floor(Qr / 65536), Yi = Qr - wn * 65536, Qr = eo + wn + 65535, wn = Math.floor(Qr / 65536), eo = Qr - wn * 65536, Qr = Ui + wn + 65535, wn = Math.floor(Qr / 65536), Ui = Qr - wn * 65536, Qr = ji + wn + 65535, wn = Math.floor(Qr / 65536), ji = Qr - wn * 65536, Qr = si + wn + 65535, wn = Math.floor(Qr / 65536), si = Qr - wn * 65536, ci += wn - 1 + 37 * (wn - 1), ui[0] = ci, ui[1] = vi, ui[2] = Ni, ui[3] = Fi, ui[4] = Pi, ui[5] = Li, ui[6] = oo, ui[7] = ao, ui[8] = zi, ui[9] = Ki, ui[10] = Vi, ui[11] = Yi, ui[12] = eo, ui[13] = Ui, ui[14] = ji, ui[15] = si;
  }
  function Hr(ui, hi) {
    Br(ui, hi, hi);
  }
  function Pn(ui, hi) {
    const gi = fe();
    let Qr;
    for (Qr = 0; Qr < 16; Qr++)
      gi[Qr] = hi[Qr];
    for (Qr = 253; Qr >= 0; Qr--)
      Hr(gi, gi), Qr !== 2 && Qr !== 4 && Br(gi, gi, hi);
    for (Qr = 0; Qr < 16; Qr++)
      ui[Qr] = gi[Qr];
  }
  function ei(ui, hi) {
    const gi = fe();
    let Qr;
    for (Qr = 0; Qr < 16; Qr++)
      gi[Qr] = hi[Qr];
    for (Qr = 250; Qr >= 0; Qr--)
      Hr(gi, gi), Qr !== 1 && Br(gi, gi, hi);
    for (Qr = 0; Qr < 16; Qr++)
      ui[Qr] = gi[Qr];
  }
  function oi(ui, hi) {
    const gi = fe(), Qr = fe(), wn = fe(), ci = fe(), vi = fe(), Ni = fe(), Fi = fe(), Pi = fe(), Li = fe();
    In(gi, ui[1], ui[0]), In(Li, hi[1], hi[0]), Br(gi, gi, Li), ni(Qr, ui[0], ui[1]), ni(Li, hi[0], hi[1]), Br(Qr, Qr, Li), Br(wn, ui[3], hi[3]), Br(wn, wn, br), Br(ci, ui[2], hi[2]), ni(ci, ci, ci), In(vi, Qr, gi), In(Ni, ci, wn), ni(Fi, ci, wn), ni(Pi, Qr, gi), Br(ui[0], vi, Ni), Br(ui[1], Pi, Fi), Br(ui[2], Fi, Ni), Br(ui[3], vi, Pi);
  }
  function Nn(ui, hi, gi) {
    for (let Qr = 0; Qr < 4; Qr++)
      Kr(ui[Qr], hi[Qr], gi);
  }
  function En(ui, hi) {
    const gi = fe(), Qr = fe(), wn = fe();
    Pn(wn, hi[2]), Br(gi, hi[0], wn), Br(Qr, hi[1], wn), bn(ui, Qr), ui[31] ^= ti(gi) << 7;
  }
  function qr(ui, hi, gi) {
    Vr(ui[0], ye), Vr(ui[1], fr), Vr(ui[2], fr), Vr(ui[3], ye);
    for (let Qr = 255; Qr >= 0; --Qr) {
      const wn = gi[Qr / 8 | 0] >> (Qr & 7) & 1;
      Nn(ui, hi, wn), oi(hi, ui), oi(ui, ui), Nn(ui, hi, wn);
    }
  }
  function Jr(ui, hi) {
    const gi = [fe(), fe(), fe(), fe()];
    Vr(gi[0], wr), Vr(gi[1], kr), Vr(gi[2], fr), Br(gi[3], wr, kr), qr(ui, gi, hi);
  }
  function ri(ui) {
    if (ui.length !== r.SEED_LENGTH)
      throw new Error(`ed25519: seed must be ${r.SEED_LENGTH} bytes`);
    const hi = (0, s.hash)(ui);
    hi[0] &= 248, hi[31] &= 127, hi[31] |= 64;
    const gi = new Uint8Array(32), Qr = [fe(), fe(), fe(), fe()];
    Jr(Qr, hi), En(gi, Qr);
    const wn = new Uint8Array(64);
    return wn.set(ui), wn.set(gi, 32), {
      publicKey: gi,
      secretKey: wn
    };
  }
  r.generateKeyPairFromSeed = ri;
  function Sn(ui) {
    const hi = (0, e.randomBytes)(32, ui), gi = ri(hi);
    return (0, o.wipe)(hi), gi;
  }
  r.generateKeyPair = Sn;
  function ai(ui) {
    if (ui.length !== r.SECRET_KEY_LENGTH)
      throw new Error(`ed25519: secret key must be ${r.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(ui.subarray(32));
  }
  r.extractPublicKeyFromSecretKey = ai;
  const di = new Float64Array([
    237,
    211,
    245,
    92,
    26,
    99,
    18,
    88,
    214,
    156,
    247,
    162,
    222,
    249,
    222,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    16
  ]);
  function ii(ui, hi) {
    let gi, Qr, wn, ci;
    for (Qr = 63; Qr >= 32; --Qr) {
      for (gi = 0, wn = Qr - 32, ci = Qr - 12; wn < ci; ++wn)
        hi[wn] += gi - 16 * hi[Qr] * di[wn - (Qr - 32)], gi = Math.floor((hi[wn] + 128) / 256), hi[wn] -= gi * 256;
      hi[wn] += gi, hi[Qr] = 0;
    }
    for (gi = 0, wn = 0; wn < 32; wn++)
      hi[wn] += gi - (hi[31] >> 4) * di[wn], gi = hi[wn] >> 8, hi[wn] &= 255;
    for (wn = 0; wn < 32; wn++)
      hi[wn] -= gi * di[wn];
    for (Qr = 0; Qr < 32; Qr++)
      hi[Qr + 1] += hi[Qr] >> 8, ui[Qr] = hi[Qr] & 255;
  }
  function fi(ui) {
    const hi = new Float64Array(64);
    for (let gi = 0; gi < 64; gi++)
      hi[gi] = ui[gi];
    for (let gi = 0; gi < 64; gi++)
      ui[gi] = 0;
    ii(ui, hi);
  }
  function Ei(ui, hi) {
    const gi = new Float64Array(64), Qr = [fe(), fe(), fe(), fe()], wn = (0, s.hash)(ui.subarray(0, 32));
    wn[0] &= 248, wn[31] &= 127, wn[31] |= 64;
    const ci = new Uint8Array(64);
    ci.set(wn.subarray(32), 32);
    const vi = new s.SHA512();
    vi.update(ci.subarray(32)), vi.update(hi);
    const Ni = vi.digest();
    vi.clean(), fi(Ni), Jr(Qr, Ni), En(ci, Qr), vi.reset(), vi.update(ci.subarray(0, 32)), vi.update(ui.subarray(32)), vi.update(hi);
    const Fi = vi.digest();
    fi(Fi);
    for (let Pi = 0; Pi < 32; Pi++)
      gi[Pi] = Ni[Pi];
    for (let Pi = 0; Pi < 32; Pi++)
      for (let Li = 0; Li < 32; Li++)
        gi[Pi + Li] += Fi[Pi] * wn[Li];
    return ii(ci.subarray(32), gi), ci;
  }
  r.sign = Ei;
  function bi(ui, hi) {
    const gi = fe(), Qr = fe(), wn = fe(), ci = fe(), vi = fe(), Ni = fe(), Fi = fe();
    return Vr(ui[2], fr), On(ui[1], hi), Hr(wn, ui[1]), Br(ci, wn, Er), In(wn, wn, ui[2]), ni(ci, ui[2], ci), Hr(vi, ci), Hr(Ni, vi), Br(Fi, Ni, vi), Br(gi, Fi, wn), Br(gi, gi, ci), ei(gi, gi), Br(gi, gi, wn), Br(gi, gi, ci), Br(gi, gi, ci), Br(ui[0], gi, ci), Hr(Qr, ui[0]), Br(Qr, Qr, ci), Zr(Qr, wn) && Br(ui[0], ui[0], Gr), Hr(Qr, ui[0]), Br(Qr, Qr, ci), Zr(Qr, wn) ? -1 : (ti(ui[0]) === hi[31] >> 7 && In(ui[0], ye, ui[0]), Br(ui[3], ui[0], ui[1]), 0);
  }
  function Si(ui, hi, gi) {
    const Qr = new Uint8Array(32), wn = [fe(), fe(), fe(), fe()], ci = [fe(), fe(), fe(), fe()];
    if (gi.length !== r.SIGNATURE_LENGTH)
      throw new Error(`ed25519: signature must be ${r.SIGNATURE_LENGTH} bytes`);
    if (bi(ci, ui))
      return !1;
    const vi = new s.SHA512();
    vi.update(gi.subarray(0, 32)), vi.update(ui), vi.update(hi);
    const Ni = vi.digest();
    return fi(Ni), qr(wn, ci, Ni), Jr(ci, gi.subarray(32)), oi(wn, ci), En(Qr, wn), !Yr(gi, Qr);
  }
  r.verify = Si;
  function Ii(ui) {
    let hi = [fe(), fe(), fe(), fe()];
    if (bi(hi, ui))
      throw new Error("Ed25519: invalid public key");
    let gi = fe(), Qr = fe(), wn = hi[1];
    ni(gi, fr, wn), In(Qr, fr, wn), Pn(Qr, Qr), Br(gi, gi, Qr);
    let ci = new Uint8Array(32);
    return bn(ci, gi), ci;
  }
  r.convertPublicKeyToX25519 = Ii;
  function yi(ui) {
    const hi = (0, s.hash)(ui.subarray(0, 32));
    hi[0] &= 248, hi[31] &= 127, hi[31] |= 64;
    const gi = new Uint8Array(hi.subarray(0, 32));
    return (0, o.wipe)(hi), gi;
  }
  r.convertSecretKeyToX25519 = yi;
})(ed25519);
const JWT_IRIDIUM_ALG = "EdDSA", JWT_IRIDIUM_TYP = "JWT", JWT_DELIMITER = ".", JWT_ENCODING = "base64url", JSON_ENCODING = "utf8", DATA_ENCODING = "utf8", DID_DELIMITER = ":", DID_PREFIX = "did", DID_METHOD = "key", MULTICODEC_ED25519_ENCODING = "base58btc", MULTICODEC_ED25519_BASE = "z", MULTICODEC_ED25519_HEADER = "K36", KEY_PAIR_SEED_LENGTH = 32;
function asUint8Array(r) {
  return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}
function allocUnsafe(r = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? asUint8Array(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}
function concat(r, e) {
  e || (e = r.reduce((fe, me) => fe + me.length, 0));
  const s = allocUnsafe(e);
  let o = 0;
  for (const fe of r)
    s.set(fe, o), o += fe.length;
  return asUint8Array(s);
}
function base(r, e) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var s = new Uint8Array(256), o = 0; o < s.length; o++)
    s[o] = 255;
  for (var fe = 0; fe < r.length; fe++) {
    var me = r.charAt(fe), ye = me.charCodeAt(0);
    if (s[ye] !== 255)
      throw new TypeError(me + " is ambiguous");
    s[ye] = fe;
  }
  var fr = r.length, Er = r.charAt(0), br = Math.log(fr) / Math.log(256), wr = Math.log(256) / Math.log(fr);
  function kr(jr) {
    if (jr instanceof Uint8Array || (ArrayBuffer.isView(jr) ? jr = new Uint8Array(jr.buffer, jr.byteOffset, jr.byteLength) : Array.isArray(jr) && (jr = Uint8Array.from(jr))), !(jr instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (jr.length === 0)
      return "";
    for (var Kr = 0, bn = 0, Yr = 0, Zr = jr.length; Yr !== Zr && jr[Yr] === 0; )
      Yr++, Kr++;
    for (var ti = (Zr - Yr) * wr + 1 >>> 0, On = new Uint8Array(ti); Yr !== Zr; ) {
      for (var ni = jr[Yr], In = 0, Br = ti - 1; (ni !== 0 || In < bn) && Br !== -1; Br--, In++)
        ni += 256 * On[Br] >>> 0, On[Br] = ni % fr >>> 0, ni = ni / fr >>> 0;
      if (ni !== 0)
        throw new Error("Non-zero carry");
      bn = In, Yr++;
    }
    for (var Hr = ti - bn; Hr !== ti && On[Hr] === 0; )
      Hr++;
    for (var Pn = Er.repeat(Kr); Hr < ti; ++Hr)
      Pn += r.charAt(On[Hr]);
    return Pn;
  }
  function Gr(jr) {
    if (typeof jr != "string")
      throw new TypeError("Expected String");
    if (jr.length === 0)
      return new Uint8Array();
    var Kr = 0;
    if (jr[Kr] !== " ") {
      for (var bn = 0, Yr = 0; jr[Kr] === Er; )
        bn++, Kr++;
      for (var Zr = (jr.length - Kr) * br + 1 >>> 0, ti = new Uint8Array(Zr); jr[Kr]; ) {
        var On = s[jr.charCodeAt(Kr)];
        if (On === 255)
          return;
        for (var ni = 0, In = Zr - 1; (On !== 0 || ni < Yr) && In !== -1; In--, ni++)
          On += fr * ti[In] >>> 0, ti[In] = On % 256 >>> 0, On = On / 256 >>> 0;
        if (On !== 0)
          throw new Error("Non-zero carry");
        Yr = ni, Kr++;
      }
      if (jr[Kr] !== " ") {
        for (var Br = Zr - Yr; Br !== Zr && ti[Br] === 0; )
          Br++;
        for (var Hr = new Uint8Array(bn + (Zr - Br)), Pn = bn; Br !== Zr; )
          Hr[Pn++] = ti[Br++];
        return Hr;
      }
    }
  }
  function Vr(jr) {
    var Kr = Gr(jr);
    if (Kr)
      return Kr;
    throw new Error(`Non-${e} character`);
  }
  return {
    encode: kr,
    decodeUnsafe: Gr,
    decode: Vr
  };
}
var src$1 = base, _brrp__multiformats_scope_baseX = src$1;
const coerce = (r) => {
  if (r instanceof Uint8Array && r.constructor.name === "Uint8Array")
    return r;
  if (r instanceof ArrayBuffer)
    return new Uint8Array(r);
  if (ArrayBuffer.isView(r))
    return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  throw new Error("Unknown type, must be binary type");
}, fromString$1 = (r) => new TextEncoder().encode(r), toString$2 = (r) => new TextDecoder().decode(r);
class Encoder$1 {
  constructor(e, s, o) {
    this.name = e, this.prefix = s, this.baseEncode = o;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Decoder$1 {
  constructor(e, s, o) {
    if (this.name = e, this.prefix = s, s.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = s.codePointAt(0), this.baseDecode = o;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return or$1(this, e);
  }
}
class ComposedDecoder {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return or$1(this, e);
  }
  decode(e) {
    const s = e[0], o = this.decoders[s];
    if (o)
      return o.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const or$1 = (r, e) => new ComposedDecoder({
  ...r.decoders || { [r.prefix]: r },
  ...e.decoders || { [e.prefix]: e }
});
class Codec {
  constructor(e, s, o, fe) {
    this.name = e, this.prefix = s, this.baseEncode = o, this.baseDecode = fe, this.encoder = new Encoder$1(e, s, o), this.decoder = new Decoder$1(e, s, fe);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const from$1 = ({ name: r, prefix: e, encode: s, decode: o }) => new Codec(r, e, s, o), baseX = ({ prefix: r, name: e, alphabet: s }) => {
  const { encode: o, decode: fe } = _brrp__multiformats_scope_baseX(s, e);
  return from$1({
    prefix: r,
    name: e,
    encode: o,
    decode: (me) => coerce(fe(me))
  });
}, decode$6 = (r, e, s, o) => {
  const fe = {};
  for (let wr = 0; wr < e.length; ++wr)
    fe[e[wr]] = wr;
  let me = r.length;
  for (; r[me - 1] === "="; )
    --me;
  const ye = new Uint8Array(me * s / 8 | 0);
  let fr = 0, Er = 0, br = 0;
  for (let wr = 0; wr < me; ++wr) {
    const kr = fe[r[wr]];
    if (kr === void 0)
      throw new SyntaxError(`Non-${o} character`);
    Er = Er << s | kr, fr += s, fr >= 8 && (fr -= 8, ye[br++] = 255 & Er >> fr);
  }
  if (fr >= s || 255 & Er << 8 - fr)
    throw new SyntaxError("Unexpected end of data");
  return ye;
}, encode$6 = (r, e, s) => {
  const o = e[e.length - 1] === "=", fe = (1 << s) - 1;
  let me = "", ye = 0, fr = 0;
  for (let Er = 0; Er < r.length; ++Er)
    for (fr = fr << 8 | r[Er], ye += 8; ye > s; )
      ye -= s, me += e[fe & fr >> ye];
  if (ye && (me += e[fe & fr << s - ye]), o)
    for (; me.length * s & 7; )
      me += "=";
  return me;
}, rfc4648 = ({ name: r, prefix: e, bitsPerChar: s, alphabet: o }) => from$1({
  prefix: e,
  name: r,
  encode(fe) {
    return encode$6(fe, o, s);
  },
  decode(fe) {
    return decode$6(fe, o, s, r);
  }
}), identity$2 = from$1({
  prefix: "\0",
  name: "identity",
  encode: (r) => toString$2(r),
  decode: (r) => fromString$1(r)
}), identityBase = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity: identity$2
}, Symbol.toStringTag, { value: "Module" })), base2 = rfc4648({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
}), base2$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base2
}, Symbol.toStringTag, { value: "Module" })), base8 = rfc4648({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
}), base8$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base8
}, Symbol.toStringTag, { value: "Module" })), base10 = baseX({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
}), base10$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base10
}, Symbol.toStringTag, { value: "Module" })), base16 = rfc4648({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}), base16upper = rfc4648({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
}), base16$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base16,
  base16upper
}, Symbol.toStringTag, { value: "Module" })), base32 = rfc4648({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}), base32upper = rfc4648({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}), base32pad = rfc4648({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}), base32padupper = rfc4648({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}), base32hex = rfc4648({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}), base32hexupper = rfc4648({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}), base32hexpad = rfc4648({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}), base32hexpadupper = rfc4648({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}), base32z = rfc4648({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
}), base32$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base32,
  base32upper,
  base32pad,
  base32padupper,
  base32hex,
  base32hexupper,
  base32hexpad,
  base32hexpadupper,
  base32z
}, Symbol.toStringTag, { value: "Module" })), base36 = baseX({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), base36upper = baseX({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), base36$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base36,
  base36upper
}, Symbol.toStringTag, { value: "Module" })), base58btc = baseX({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), base58flickr = baseX({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), base58 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base58btc,
  base58flickr
}, Symbol.toStringTag, { value: "Module" })), base64 = rfc4648({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}), base64pad = rfc4648({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}), base64url = rfc4648({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}), base64urlpad = rfc4648({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
}), base64$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64,
  base64pad,
  base64url,
  base64urlpad
}, Symbol.toStringTag, { value: "Module" })), alphabet$1 = Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"), alphabetBytesToChars = alphabet$1.reduce((r, e, s) => (r[s] = e, r), []), alphabetCharsToBytes = alphabet$1.reduce((r, e, s) => (r[e.codePointAt(0)] = s, r), []);
function encode$5(r) {
  return r.reduce((e, s) => (e += alphabetBytesToChars[s], e), "");
}
function decode$5(r) {
  const e = [];
  for (const s of r) {
    const o = alphabetCharsToBytes[s.codePointAt(0)];
    if (o === void 0)
      throw new Error(`Non-base256emoji character: ${s}`);
    e.push(o);
  }
  return new Uint8Array(e);
}
const base256emoji = from$1({
  prefix: "\u{1F680}",
  name: "base256emoji",
  encode: encode$5,
  decode: decode$5
}), base256emoji$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base256emoji
}, Symbol.toStringTag, { value: "Module" }));
var encode_1 = encode$4, MSB = 128, REST = 127, MSBALL = ~REST, INT = Math.pow(2, 31);
function encode$4(r, e, s) {
  e = e || [], s = s || 0;
  for (var o = s; r >= INT; )
    e[s++] = r & 255 | MSB, r /= 128;
  for (; r & MSBALL; )
    e[s++] = r & 255 | MSB, r >>>= 7;
  return e[s] = r | 0, encode$4.bytes = s - o + 1, e;
}
var decode$4 = read, MSB$1 = 128, REST$1 = 127;
function read(r, o) {
  var s = 0, o = o || 0, fe = 0, me = o, ye, fr = r.length;
  do {
    if (me >= fr)
      throw read.bytes = 0, new RangeError("Could not decode varint");
    ye = r[me++], s += fe < 28 ? (ye & REST$1) << fe : (ye & REST$1) * Math.pow(2, fe), fe += 7;
  } while (ye >= MSB$1);
  return read.bytes = me - o, s;
}
var N1 = Math.pow(2, 7), N2 = Math.pow(2, 14), N3 = Math.pow(2, 21), N4 = Math.pow(2, 28), N5 = Math.pow(2, 35), N6 = Math.pow(2, 42), N7 = Math.pow(2, 49), N8 = Math.pow(2, 56), N9 = Math.pow(2, 63), length$1 = function(r) {
  return r < N1 ? 1 : r < N2 ? 2 : r < N3 ? 3 : r < N4 ? 4 : r < N5 ? 5 : r < N6 ? 6 : r < N7 ? 7 : r < N8 ? 8 : r < N9 ? 9 : 10;
}, varint = {
  encode: encode_1,
  decode: decode$4,
  encodingLength: length$1
}, _brrp_varint = varint;
const encodeTo = (r, e, s = 0) => (_brrp_varint.encode(r, e, s), e), encodingLength = (r) => _brrp_varint.encodingLength(r), create = (r, e) => {
  const s = e.byteLength, o = encodingLength(r), fe = o + encodingLength(s), me = new Uint8Array(fe + s);
  return encodeTo(r, me, 0), encodeTo(s, me, o), me.set(e, fe), new Digest(r, s, e, me);
};
class Digest {
  constructor(e, s, o, fe) {
    this.code = e, this.size = s, this.digest = o, this.bytes = fe;
  }
}
const from = ({ name: r, code: e, encode: s }) => new Hasher(r, e, s);
class Hasher {
  constructor(e, s, o) {
    this.name = e, this.code = s, this.encode = o;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const s = this.encode(e);
      return s instanceof Uint8Array ? create(this.code, s) : s.then((o) => create(this.code, o));
    } else
      throw Error("Unknown type, must be binary type");
  }
}
const sha = (r) => async (e) => new Uint8Array(await crypto.subtle.digest(r, e)), sha256$1 = from({
  name: "sha2-256",
  code: 18,
  encode: sha("SHA-256")
}), sha512 = from({
  name: "sha2-512",
  code: 19,
  encode: sha("SHA-512")
}), sha2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sha256: sha256$1,
  sha512
}, Symbol.toStringTag, { value: "Module" })), code = 0, name = "identity", encode$3 = coerce, digest = (r) => create(code, encode$3(r)), identity = {
  code,
  name,
  encode: encode$3,
  digest
}, identity$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity
}, Symbol.toStringTag, { value: "Module" }));
new TextEncoder();
new TextDecoder();
const bases = {
  ...identityBase,
  ...base2$1,
  ...base8$1,
  ...base10$1,
  ...base16$1,
  ...base32$1,
  ...base36$1,
  ...base58,
  ...base64$1,
  ...base256emoji$1
};
({
  ...sha2,
  ...identity$1
});
function createCodec(r, e, s, o) {
  return {
    name: r,
    prefix: e,
    encoder: {
      name: r,
      prefix: e,
      encode: s
    },
    decoder: { decode: o }
  };
}
const string = createCodec("utf8", "u", (r) => "u" + new TextDecoder("utf8").decode(r), (r) => new TextEncoder().encode(r.substring(1))), ascii = createCodec("ascii", "a", (r) => {
  let e = "a";
  for (let s = 0; s < r.length; s++)
    e += String.fromCharCode(r[s]);
  return e;
}, (r) => {
  r = r.substring(1);
  const e = allocUnsafe(r.length);
  for (let s = 0; s < r.length; s++)
    e[s] = r.charCodeAt(s);
  return e;
}), BASES = {
  utf8: string,
  "utf-8": string,
  hex: bases.base16,
  latin1: ascii,
  ascii,
  binary: ascii,
  ...bases
};
function toString$1(r, e = "utf8") {
  const s = BASES[e];
  if (!s)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(r.buffer, r.byteOffset, r.byteLength).toString("utf8") : s.encoder.encode(r).substring(1);
}
function fromString(r, e = "utf8") {
  const s = BASES[e];
  if (!s)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? asUint8Array(globalThis.Buffer.from(r, "utf-8")) : s.decoder.decode(`${s.prefix}${r}`);
}
function encodeJSON(r) {
  return toString$1(fromString(safeJsonStringify(r), JSON_ENCODING), JWT_ENCODING);
}
function encodeIss(r) {
  const e = fromString(MULTICODEC_ED25519_HEADER, MULTICODEC_ED25519_ENCODING), s = MULTICODEC_ED25519_BASE + toString$1(concat([e, r]), MULTICODEC_ED25519_ENCODING);
  return [DID_PREFIX, DID_METHOD, s].join(DID_DELIMITER);
}
function encodeSig(r) {
  return toString$1(r, JWT_ENCODING);
}
function encodeData(r) {
  return fromString([encodeJSON(r.header), encodeJSON(r.payload)].join(JWT_DELIMITER), DATA_ENCODING);
}
function encodeJWT(r) {
  return [
    encodeJSON(r.header),
    encodeJSON(r.payload),
    encodeSig(r.signature)
  ].join(JWT_DELIMITER);
}
function generateKeyPair(r = random.randomBytes(KEY_PAIR_SEED_LENGTH)) {
  return ed25519.generateKeyPairFromSeed(r);
}
async function signJWT(r, e, s, o, fe = cjs$4.fromMiliseconds(Date.now())) {
  const me = { alg: JWT_IRIDIUM_ALG, typ: JWT_IRIDIUM_TYP }, ye = encodeIss(o.publicKey), fr = fe + s, Er = { iss: ye, sub: r, aud: e, iat: fe, exp: fr }, br = encodeData({ header: me, payload: Er }), wr = ed25519.sign(o.secretKey, br);
  return encodeJWT({ header: me, payload: Er, signature: wr });
}
var chacha20poly1305 = {}, chacha = {};
Object.defineProperty(chacha, "__esModule", { value: !0 });
var binary_1 = binary, wipe_1$2 = wipe$1, ROUNDS = 20;
function core(r, e, s) {
  for (var o = 1634760805, fe = 857760878, me = 2036477234, ye = 1797285236, fr = s[3] << 24 | s[2] << 16 | s[1] << 8 | s[0], Er = s[7] << 24 | s[6] << 16 | s[5] << 8 | s[4], br = s[11] << 24 | s[10] << 16 | s[9] << 8 | s[8], wr = s[15] << 24 | s[14] << 16 | s[13] << 8 | s[12], kr = s[19] << 24 | s[18] << 16 | s[17] << 8 | s[16], Gr = s[23] << 24 | s[22] << 16 | s[21] << 8 | s[20], Vr = s[27] << 24 | s[26] << 16 | s[25] << 8 | s[24], jr = s[31] << 24 | s[30] << 16 | s[29] << 8 | s[28], Kr = e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0], bn = e[7] << 24 | e[6] << 16 | e[5] << 8 | e[4], Yr = e[11] << 24 | e[10] << 16 | e[9] << 8 | e[8], Zr = e[15] << 24 | e[14] << 16 | e[13] << 8 | e[12], ti = o, On = fe, ni = me, In = ye, Br = fr, Hr = Er, Pn = br, ei = wr, oi = kr, Nn = Gr, En = Vr, qr = jr, Jr = Kr, ri = bn, Sn = Yr, ai = Zr, di = 0; di < ROUNDS; di += 2)
    ti = ti + Br | 0, Jr ^= ti, Jr = Jr >>> 32 - 16 | Jr << 16, oi = oi + Jr | 0, Br ^= oi, Br = Br >>> 32 - 12 | Br << 12, On = On + Hr | 0, ri ^= On, ri = ri >>> 32 - 16 | ri << 16, Nn = Nn + ri | 0, Hr ^= Nn, Hr = Hr >>> 32 - 12 | Hr << 12, ni = ni + Pn | 0, Sn ^= ni, Sn = Sn >>> 32 - 16 | Sn << 16, En = En + Sn | 0, Pn ^= En, Pn = Pn >>> 32 - 12 | Pn << 12, In = In + ei | 0, ai ^= In, ai = ai >>> 32 - 16 | ai << 16, qr = qr + ai | 0, ei ^= qr, ei = ei >>> 32 - 12 | ei << 12, ni = ni + Pn | 0, Sn ^= ni, Sn = Sn >>> 32 - 8 | Sn << 8, En = En + Sn | 0, Pn ^= En, Pn = Pn >>> 32 - 7 | Pn << 7, In = In + ei | 0, ai ^= In, ai = ai >>> 32 - 8 | ai << 8, qr = qr + ai | 0, ei ^= qr, ei = ei >>> 32 - 7 | ei << 7, On = On + Hr | 0, ri ^= On, ri = ri >>> 32 - 8 | ri << 8, Nn = Nn + ri | 0, Hr ^= Nn, Hr = Hr >>> 32 - 7 | Hr << 7, ti = ti + Br | 0, Jr ^= ti, Jr = Jr >>> 32 - 8 | Jr << 8, oi = oi + Jr | 0, Br ^= oi, Br = Br >>> 32 - 7 | Br << 7, ti = ti + Hr | 0, ai ^= ti, ai = ai >>> 32 - 16 | ai << 16, En = En + ai | 0, Hr ^= En, Hr = Hr >>> 32 - 12 | Hr << 12, On = On + Pn | 0, Jr ^= On, Jr = Jr >>> 32 - 16 | Jr << 16, qr = qr + Jr | 0, Pn ^= qr, Pn = Pn >>> 32 - 12 | Pn << 12, ni = ni + ei | 0, ri ^= ni, ri = ri >>> 32 - 16 | ri << 16, oi = oi + ri | 0, ei ^= oi, ei = ei >>> 32 - 12 | ei << 12, In = In + Br | 0, Sn ^= In, Sn = Sn >>> 32 - 16 | Sn << 16, Nn = Nn + Sn | 0, Br ^= Nn, Br = Br >>> 32 - 12 | Br << 12, ni = ni + ei | 0, ri ^= ni, ri = ri >>> 32 - 8 | ri << 8, oi = oi + ri | 0, ei ^= oi, ei = ei >>> 32 - 7 | ei << 7, In = In + Br | 0, Sn ^= In, Sn = Sn >>> 32 - 8 | Sn << 8, Nn = Nn + Sn | 0, Br ^= Nn, Br = Br >>> 32 - 7 | Br << 7, On = On + Pn | 0, Jr ^= On, Jr = Jr >>> 32 - 8 | Jr << 8, qr = qr + Jr | 0, Pn ^= qr, Pn = Pn >>> 32 - 7 | Pn << 7, ti = ti + Hr | 0, ai ^= ti, ai = ai >>> 32 - 8 | ai << 8, En = En + ai | 0, Hr ^= En, Hr = Hr >>> 32 - 7 | Hr << 7;
  binary_1.writeUint32LE(ti + o | 0, r, 0), binary_1.writeUint32LE(On + fe | 0, r, 4), binary_1.writeUint32LE(ni + me | 0, r, 8), binary_1.writeUint32LE(In + ye | 0, r, 12), binary_1.writeUint32LE(Br + fr | 0, r, 16), binary_1.writeUint32LE(Hr + Er | 0, r, 20), binary_1.writeUint32LE(Pn + br | 0, r, 24), binary_1.writeUint32LE(ei + wr | 0, r, 28), binary_1.writeUint32LE(oi + kr | 0, r, 32), binary_1.writeUint32LE(Nn + Gr | 0, r, 36), binary_1.writeUint32LE(En + Vr | 0, r, 40), binary_1.writeUint32LE(qr + jr | 0, r, 44), binary_1.writeUint32LE(Jr + Kr | 0, r, 48), binary_1.writeUint32LE(ri + bn | 0, r, 52), binary_1.writeUint32LE(Sn + Yr | 0, r, 56), binary_1.writeUint32LE(ai + Zr | 0, r, 60);
}
function streamXOR(r, e, s, o, fe) {
  if (fe === void 0 && (fe = 0), r.length !== 32)
    throw new Error("ChaCha: key size must be 32 bytes");
  if (o.length < s.length)
    throw new Error("ChaCha: destination is shorter than source");
  var me, ye;
  if (fe === 0) {
    if (e.length !== 8 && e.length !== 12)
      throw new Error("ChaCha nonce must be 8 or 12 bytes");
    me = new Uint8Array(16), ye = me.length - e.length, me.set(e, ye);
  } else {
    if (e.length !== 16)
      throw new Error("ChaCha nonce with counter must be 16 bytes");
    me = e, ye = fe;
  }
  for (var fr = new Uint8Array(64), Er = 0; Er < s.length; Er += 64) {
    core(fr, me, r);
    for (var br = Er; br < Er + 64 && br < s.length; br++)
      o[br] = s[br] ^ fr[br - Er];
    incrementCounter(me, 0, ye);
  }
  return wipe_1$2.wipe(fr), fe === 0 && wipe_1$2.wipe(me), o;
}
chacha.streamXOR = streamXOR;
function stream(r, e, s, o) {
  return o === void 0 && (o = 0), wipe_1$2.wipe(s), streamXOR(r, e, s, s, o);
}
chacha.stream = stream;
function incrementCounter(r, e, s) {
  for (var o = 1; s--; )
    o = o + (r[e] & 255) | 0, r[e] = o & 255, o >>>= 8, e++;
  if (o > 0)
    throw new Error("ChaCha: counter overflow");
}
var poly1305 = {}, constantTime = {};
Object.defineProperty(constantTime, "__esModule", { value: !0 });
function select(r, e, s) {
  return ~(r - 1) & e | r - 1 & s;
}
constantTime.select = select;
function lessOrEqual(r, e) {
  return (r | 0) - (e | 0) - 1 >>> 31 & 1;
}
constantTime.lessOrEqual = lessOrEqual;
function compare(r, e) {
  if (r.length !== e.length)
    return 0;
  for (var s = 0, o = 0; o < r.length; o++)
    s |= r[o] ^ e[o];
  return 1 & s - 1 >>> 8;
}
constantTime.compare = compare;
function equal(r, e) {
  return r.length === 0 || e.length === 0 ? !1 : compare(r, e) !== 0;
}
constantTime.equal = equal;
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  var e = constantTime, s = wipe$1;
  r.DIGEST_LENGTH = 16;
  var o = function() {
    function ye(fr) {
      this.digestLength = r.DIGEST_LENGTH, this._buffer = new Uint8Array(16), this._r = new Uint16Array(10), this._h = new Uint16Array(10), this._pad = new Uint16Array(8), this._leftover = 0, this._fin = 0, this._finished = !1;
      var Er = fr[0] | fr[1] << 8;
      this._r[0] = Er & 8191;
      var br = fr[2] | fr[3] << 8;
      this._r[1] = (Er >>> 13 | br << 3) & 8191;
      var wr = fr[4] | fr[5] << 8;
      this._r[2] = (br >>> 10 | wr << 6) & 7939;
      var kr = fr[6] | fr[7] << 8;
      this._r[3] = (wr >>> 7 | kr << 9) & 8191;
      var Gr = fr[8] | fr[9] << 8;
      this._r[4] = (kr >>> 4 | Gr << 12) & 255, this._r[5] = Gr >>> 1 & 8190;
      var Vr = fr[10] | fr[11] << 8;
      this._r[6] = (Gr >>> 14 | Vr << 2) & 8191;
      var jr = fr[12] | fr[13] << 8;
      this._r[7] = (Vr >>> 11 | jr << 5) & 8065;
      var Kr = fr[14] | fr[15] << 8;
      this._r[8] = (jr >>> 8 | Kr << 8) & 8191, this._r[9] = Kr >>> 5 & 127, this._pad[0] = fr[16] | fr[17] << 8, this._pad[1] = fr[18] | fr[19] << 8, this._pad[2] = fr[20] | fr[21] << 8, this._pad[3] = fr[22] | fr[23] << 8, this._pad[4] = fr[24] | fr[25] << 8, this._pad[5] = fr[26] | fr[27] << 8, this._pad[6] = fr[28] | fr[29] << 8, this._pad[7] = fr[30] | fr[31] << 8;
    }
    return ye.prototype._blocks = function(fr, Er, br) {
      for (var wr = this._fin ? 0 : 2048, kr = this._h[0], Gr = this._h[1], Vr = this._h[2], jr = this._h[3], Kr = this._h[4], bn = this._h[5], Yr = this._h[6], Zr = this._h[7], ti = this._h[8], On = this._h[9], ni = this._r[0], In = this._r[1], Br = this._r[2], Hr = this._r[3], Pn = this._r[4], ei = this._r[5], oi = this._r[6], Nn = this._r[7], En = this._r[8], qr = this._r[9]; br >= 16; ) {
        var Jr = fr[Er + 0] | fr[Er + 1] << 8;
        kr += Jr & 8191;
        var ri = fr[Er + 2] | fr[Er + 3] << 8;
        Gr += (Jr >>> 13 | ri << 3) & 8191;
        var Sn = fr[Er + 4] | fr[Er + 5] << 8;
        Vr += (ri >>> 10 | Sn << 6) & 8191;
        var ai = fr[Er + 6] | fr[Er + 7] << 8;
        jr += (Sn >>> 7 | ai << 9) & 8191;
        var di = fr[Er + 8] | fr[Er + 9] << 8;
        Kr += (ai >>> 4 | di << 12) & 8191, bn += di >>> 1 & 8191;
        var ii = fr[Er + 10] | fr[Er + 11] << 8;
        Yr += (di >>> 14 | ii << 2) & 8191;
        var fi = fr[Er + 12] | fr[Er + 13] << 8;
        Zr += (ii >>> 11 | fi << 5) & 8191;
        var Ei = fr[Er + 14] | fr[Er + 15] << 8;
        ti += (fi >>> 8 | Ei << 8) & 8191, On += Ei >>> 5 | wr;
        var bi = 0, Si = bi;
        Si += kr * ni, Si += Gr * (5 * qr), Si += Vr * (5 * En), Si += jr * (5 * Nn), Si += Kr * (5 * oi), bi = Si >>> 13, Si &= 8191, Si += bn * (5 * ei), Si += Yr * (5 * Pn), Si += Zr * (5 * Hr), Si += ti * (5 * Br), Si += On * (5 * In), bi += Si >>> 13, Si &= 8191;
        var Ii = bi;
        Ii += kr * In, Ii += Gr * ni, Ii += Vr * (5 * qr), Ii += jr * (5 * En), Ii += Kr * (5 * Nn), bi = Ii >>> 13, Ii &= 8191, Ii += bn * (5 * oi), Ii += Yr * (5 * ei), Ii += Zr * (5 * Pn), Ii += ti * (5 * Hr), Ii += On * (5 * Br), bi += Ii >>> 13, Ii &= 8191;
        var yi = bi;
        yi += kr * Br, yi += Gr * In, yi += Vr * ni, yi += jr * (5 * qr), yi += Kr * (5 * En), bi = yi >>> 13, yi &= 8191, yi += bn * (5 * Nn), yi += Yr * (5 * oi), yi += Zr * (5 * ei), yi += ti * (5 * Pn), yi += On * (5 * Hr), bi += yi >>> 13, yi &= 8191;
        var ui = bi;
        ui += kr * Hr, ui += Gr * Br, ui += Vr * In, ui += jr * ni, ui += Kr * (5 * qr), bi = ui >>> 13, ui &= 8191, ui += bn * (5 * En), ui += Yr * (5 * Nn), ui += Zr * (5 * oi), ui += ti * (5 * ei), ui += On * (5 * Pn), bi += ui >>> 13, ui &= 8191;
        var hi = bi;
        hi += kr * Pn, hi += Gr * Hr, hi += Vr * Br, hi += jr * In, hi += Kr * ni, bi = hi >>> 13, hi &= 8191, hi += bn * (5 * qr), hi += Yr * (5 * En), hi += Zr * (5 * Nn), hi += ti * (5 * oi), hi += On * (5 * ei), bi += hi >>> 13, hi &= 8191;
        var gi = bi;
        gi += kr * ei, gi += Gr * Pn, gi += Vr * Hr, gi += jr * Br, gi += Kr * In, bi = gi >>> 13, gi &= 8191, gi += bn * ni, gi += Yr * (5 * qr), gi += Zr * (5 * En), gi += ti * (5 * Nn), gi += On * (5 * oi), bi += gi >>> 13, gi &= 8191;
        var Qr = bi;
        Qr += kr * oi, Qr += Gr * ei, Qr += Vr * Pn, Qr += jr * Hr, Qr += Kr * Br, bi = Qr >>> 13, Qr &= 8191, Qr += bn * In, Qr += Yr * ni, Qr += Zr * (5 * qr), Qr += ti * (5 * En), Qr += On * (5 * Nn), bi += Qr >>> 13, Qr &= 8191;
        var wn = bi;
        wn += kr * Nn, wn += Gr * oi, wn += Vr * ei, wn += jr * Pn, wn += Kr * Hr, bi = wn >>> 13, wn &= 8191, wn += bn * Br, wn += Yr * In, wn += Zr * ni, wn += ti * (5 * qr), wn += On * (5 * En), bi += wn >>> 13, wn &= 8191;
        var ci = bi;
        ci += kr * En, ci += Gr * Nn, ci += Vr * oi, ci += jr * ei, ci += Kr * Pn, bi = ci >>> 13, ci &= 8191, ci += bn * Hr, ci += Yr * Br, ci += Zr * In, ci += ti * ni, ci += On * (5 * qr), bi += ci >>> 13, ci &= 8191;
        var vi = bi;
        vi += kr * qr, vi += Gr * En, vi += Vr * Nn, vi += jr * oi, vi += Kr * ei, bi = vi >>> 13, vi &= 8191, vi += bn * Pn, vi += Yr * Hr, vi += Zr * Br, vi += ti * In, vi += On * ni, bi += vi >>> 13, vi &= 8191, bi = (bi << 2) + bi | 0, bi = bi + Si | 0, Si = bi & 8191, bi = bi >>> 13, Ii += bi, kr = Si, Gr = Ii, Vr = yi, jr = ui, Kr = hi, bn = gi, Yr = Qr, Zr = wn, ti = ci, On = vi, Er += 16, br -= 16;
      }
      this._h[0] = kr, this._h[1] = Gr, this._h[2] = Vr, this._h[3] = jr, this._h[4] = Kr, this._h[5] = bn, this._h[6] = Yr, this._h[7] = Zr, this._h[8] = ti, this._h[9] = On;
    }, ye.prototype.finish = function(fr, Er) {
      Er === void 0 && (Er = 0);
      var br = new Uint16Array(10), wr, kr, Gr, Vr;
      if (this._leftover) {
        for (Vr = this._leftover, this._buffer[Vr++] = 1; Vr < 16; Vr++)
          this._buffer[Vr] = 0;
        this._fin = 1, this._blocks(this._buffer, 0, 16);
      }
      for (wr = this._h[1] >>> 13, this._h[1] &= 8191, Vr = 2; Vr < 10; Vr++)
        this._h[Vr] += wr, wr = this._h[Vr] >>> 13, this._h[Vr] &= 8191;
      for (this._h[0] += wr * 5, wr = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += wr, wr = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += wr, br[0] = this._h[0] + 5, wr = br[0] >>> 13, br[0] &= 8191, Vr = 1; Vr < 10; Vr++)
        br[Vr] = this._h[Vr] + wr, wr = br[Vr] >>> 13, br[Vr] &= 8191;
      for (br[9] -= 1 << 13, kr = (wr ^ 1) - 1, Vr = 0; Vr < 10; Vr++)
        br[Vr] &= kr;
      for (kr = ~kr, Vr = 0; Vr < 10; Vr++)
        this._h[Vr] = this._h[Vr] & kr | br[Vr];
      for (this._h[0] = (this._h[0] | this._h[1] << 13) & 65535, this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 65535, this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 65535, this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 65535, this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 65535, this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 65535, this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 65535, this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 65535, Gr = this._h[0] + this._pad[0], this._h[0] = Gr & 65535, Vr = 1; Vr < 8; Vr++)
        Gr = (this._h[Vr] + this._pad[Vr] | 0) + (Gr >>> 16) | 0, this._h[Vr] = Gr & 65535;
      return fr[Er + 0] = this._h[0] >>> 0, fr[Er + 1] = this._h[0] >>> 8, fr[Er + 2] = this._h[1] >>> 0, fr[Er + 3] = this._h[1] >>> 8, fr[Er + 4] = this._h[2] >>> 0, fr[Er + 5] = this._h[2] >>> 8, fr[Er + 6] = this._h[3] >>> 0, fr[Er + 7] = this._h[3] >>> 8, fr[Er + 8] = this._h[4] >>> 0, fr[Er + 9] = this._h[4] >>> 8, fr[Er + 10] = this._h[5] >>> 0, fr[Er + 11] = this._h[5] >>> 8, fr[Er + 12] = this._h[6] >>> 0, fr[Er + 13] = this._h[6] >>> 8, fr[Er + 14] = this._h[7] >>> 0, fr[Er + 15] = this._h[7] >>> 8, this._finished = !0, this;
    }, ye.prototype.update = function(fr) {
      var Er = 0, br = fr.length, wr;
      if (this._leftover) {
        wr = 16 - this._leftover, wr > br && (wr = br);
        for (var kr = 0; kr < wr; kr++)
          this._buffer[this._leftover + kr] = fr[Er + kr];
        if (br -= wr, Er += wr, this._leftover += wr, this._leftover < 16)
          return this;
        this._blocks(this._buffer, 0, 16), this._leftover = 0;
      }
      if (br >= 16 && (wr = br - br % 16, this._blocks(fr, Er, wr), Er += wr, br -= wr), br) {
        for (var kr = 0; kr < br; kr++)
          this._buffer[this._leftover + kr] = fr[Er + kr];
        this._leftover += br;
      }
      return this;
    }, ye.prototype.digest = function() {
      if (this._finished)
        throw new Error("Poly1305 was finished");
      var fr = new Uint8Array(16);
      return this.finish(fr), fr;
    }, ye.prototype.clean = function() {
      return s.wipe(this._buffer), s.wipe(this._r), s.wipe(this._h), s.wipe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
    }, ye;
  }();
  r.Poly1305 = o;
  function fe(ye, fr) {
    var Er = new o(ye);
    Er.update(fr);
    var br = Er.digest();
    return Er.clean(), br;
  }
  r.oneTimeAuth = fe;
  function me(ye, fr) {
    return ye.length !== r.DIGEST_LENGTH || fr.length !== r.DIGEST_LENGTH ? !1 : e.equal(ye, fr);
  }
  r.equal = me;
})(poly1305);
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  var e = chacha, s = poly1305, o = wipe$1, fe = binary, me = constantTime;
  r.KEY_LENGTH = 32, r.NONCE_LENGTH = 12, r.TAG_LENGTH = 16;
  var ye = new Uint8Array(16), fr = function() {
    function Er(br) {
      if (this.nonceLength = r.NONCE_LENGTH, this.tagLength = r.TAG_LENGTH, br.length !== r.KEY_LENGTH)
        throw new Error("ChaCha20Poly1305 needs 32-byte key");
      this._key = new Uint8Array(br);
    }
    return Er.prototype.seal = function(br, wr, kr, Gr) {
      if (br.length > 16)
        throw new Error("ChaCha20Poly1305: incorrect nonce length");
      var Vr = new Uint8Array(16);
      Vr.set(br, Vr.length - br.length);
      var jr = new Uint8Array(32);
      e.stream(this._key, Vr, jr, 4);
      var Kr = wr.length + this.tagLength, bn;
      if (Gr) {
        if (Gr.length !== Kr)
          throw new Error("ChaCha20Poly1305: incorrect destination length");
        bn = Gr;
      } else
        bn = new Uint8Array(Kr);
      return e.streamXOR(this._key, Vr, wr, bn, 4), this._authenticate(bn.subarray(bn.length - this.tagLength, bn.length), jr, bn.subarray(0, bn.length - this.tagLength), kr), o.wipe(Vr), bn;
    }, Er.prototype.open = function(br, wr, kr, Gr) {
      if (br.length > 16)
        throw new Error("ChaCha20Poly1305: incorrect nonce length");
      if (wr.length < this.tagLength)
        return null;
      var Vr = new Uint8Array(16);
      Vr.set(br, Vr.length - br.length);
      var jr = new Uint8Array(32);
      e.stream(this._key, Vr, jr, 4);
      var Kr = new Uint8Array(this.tagLength);
      if (this._authenticate(Kr, jr, wr.subarray(0, wr.length - this.tagLength), kr), !me.equal(Kr, wr.subarray(wr.length - this.tagLength, wr.length)))
        return null;
      var bn = wr.length - this.tagLength, Yr;
      if (Gr) {
        if (Gr.length !== bn)
          throw new Error("ChaCha20Poly1305: incorrect destination length");
        Yr = Gr;
      } else
        Yr = new Uint8Array(bn);
      return e.streamXOR(this._key, Vr, wr.subarray(0, wr.length - this.tagLength), Yr, 4), o.wipe(Vr), Yr;
    }, Er.prototype.clean = function() {
      return o.wipe(this._key), this;
    }, Er.prototype._authenticate = function(br, wr, kr, Gr) {
      var Vr = new s.Poly1305(wr);
      Gr && (Vr.update(Gr), Gr.length % 16 > 0 && Vr.update(ye.subarray(Gr.length % 16))), Vr.update(kr), kr.length % 16 > 0 && Vr.update(ye.subarray(kr.length % 16));
      var jr = new Uint8Array(8);
      Gr && fe.writeUint64LE(Gr.length, jr), Vr.update(jr), fe.writeUint64LE(kr.length, jr), Vr.update(jr);
      for (var Kr = Vr.digest(), bn = 0; bn < Kr.length; bn++)
        br[bn] = Kr[bn];
      Vr.clean(), o.wipe(Kr), o.wipe(jr);
    }, Er;
  }();
  r.ChaCha20Poly1305 = fr;
})(chacha20poly1305);
var hkdf = {}, hmac$1 = {}, hash = {};
Object.defineProperty(hash, "__esModule", { value: !0 });
function isSerializableHash(r) {
  return typeof r.saveState < "u" && typeof r.restoreState < "u" && typeof r.cleanSavedState < "u";
}
hash.isSerializableHash = isSerializableHash;
Object.defineProperty(hmac$1, "__esModule", { value: !0 });
var hash_1 = hash, constant_time_1 = constantTime, wipe_1$1 = wipe$1, HMAC = function() {
  function r(e, s) {
    this._finished = !1, this._inner = new e(), this._outer = new e(), this.blockSize = this._outer.blockSize, this.digestLength = this._outer.digestLength;
    var o = new Uint8Array(this.blockSize);
    s.length > this.blockSize ? this._inner.update(s).finish(o).clean() : o.set(s);
    for (var fe = 0; fe < o.length; fe++)
      o[fe] ^= 54;
    this._inner.update(o);
    for (var fe = 0; fe < o.length; fe++)
      o[fe] ^= 106;
    this._outer.update(o), hash_1.isSerializableHash(this._inner) && hash_1.isSerializableHash(this._outer) && (this._innerKeyedState = this._inner.saveState(), this._outerKeyedState = this._outer.saveState()), wipe_1$1.wipe(o);
  }
  return r.prototype.reset = function() {
    if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer))
      throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
    return this._inner.restoreState(this._innerKeyedState), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
  }, r.prototype.clean = function() {
    hash_1.isSerializableHash(this._inner) && this._inner.cleanSavedState(this._innerKeyedState), hash_1.isSerializableHash(this._outer) && this._outer.cleanSavedState(this._outerKeyedState), this._inner.clean(), this._outer.clean();
  }, r.prototype.update = function(e) {
    return this._inner.update(e), this;
  }, r.prototype.finish = function(e) {
    return this._finished ? (this._outer.finish(e), this) : (this._inner.finish(e), this._outer.update(e.subarray(0, this.digestLength)).finish(e), this._finished = !0, this);
  }, r.prototype.digest = function() {
    var e = new Uint8Array(this.digestLength);
    return this.finish(e), e;
  }, r.prototype.saveState = function() {
    if (!hash_1.isSerializableHash(this._inner))
      throw new Error("hmac: can't saveState() because hash doesn't implement it");
    return this._inner.saveState();
  }, r.prototype.restoreState = function(e) {
    if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer))
      throw new Error("hmac: can't restoreState() because hash doesn't implement it");
    return this._inner.restoreState(e), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
  }, r.prototype.cleanSavedState = function(e) {
    if (!hash_1.isSerializableHash(this._inner))
      throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
    this._inner.cleanSavedState(e);
  }, r;
}();
hmac$1.HMAC = HMAC;
function hmac(r, e, s) {
  var o = new HMAC(r, e);
  o.update(s);
  var fe = o.digest();
  return o.clean(), fe;
}
hmac$1.hmac = hmac;
hmac$1.equal = constant_time_1.equal;
Object.defineProperty(hkdf, "__esModule", { value: !0 });
var hmac_1 = hmac$1, wipe_1 = wipe$1, HKDF = function() {
  function r(e, s, o, fe) {
    o === void 0 && (o = new Uint8Array(0)), this._counter = new Uint8Array(1), this._hash = e, this._info = fe;
    var me = hmac_1.hmac(this._hash, o, s);
    this._hmac = new hmac_1.HMAC(e, me), this._buffer = new Uint8Array(this._hmac.digestLength), this._bufpos = this._buffer.length;
  }
  return r.prototype._fillBuffer = function() {
    this._counter[0]++;
    var e = this._counter[0];
    if (e === 0)
      throw new Error("hkdf: cannot expand more");
    this._hmac.reset(), e > 1 && this._hmac.update(this._buffer), this._info && this._hmac.update(this._info), this._hmac.update(this._counter), this._hmac.finish(this._buffer), this._bufpos = 0;
  }, r.prototype.expand = function(e) {
    for (var s = new Uint8Array(e), o = 0; o < s.length; o++)
      this._bufpos === this._buffer.length && this._fillBuffer(), s[o] = this._buffer[this._bufpos++];
    return s;
  }, r.prototype.clean = function() {
    this._hmac.clean(), wipe_1.wipe(this._buffer), wipe_1.wipe(this._counter), this._bufpos = 0;
  }, r;
}(), HKDF_1 = hkdf.HKDF = HKDF, sha256 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  var e = binary, s = wipe$1;
  r.DIGEST_LENGTH = 32, r.BLOCK_SIZE = 64;
  var o = function() {
    function fr() {
      this.digestLength = r.DIGEST_LENGTH, this.blockSize = r.BLOCK_SIZE, this._state = new Int32Array(8), this._temp = new Int32Array(64), this._buffer = new Uint8Array(128), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
    }
    return fr.prototype._initState = function() {
      this._state[0] = 1779033703, this._state[1] = 3144134277, this._state[2] = 1013904242, this._state[3] = 2773480762, this._state[4] = 1359893119, this._state[5] = 2600822924, this._state[6] = 528734635, this._state[7] = 1541459225;
    }, fr.prototype.reset = function() {
      return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
    }, fr.prototype.clean = function() {
      s.wipe(this._buffer), s.wipe(this._temp), this.reset();
    }, fr.prototype.update = function(Er, br) {
      if (br === void 0 && (br = Er.length), this._finished)
        throw new Error("SHA256: can't update because hash was finished.");
      var wr = 0;
      if (this._bytesHashed += br, this._bufferLength > 0) {
        for (; this._bufferLength < this.blockSize && br > 0; )
          this._buffer[this._bufferLength++] = Er[wr++], br--;
        this._bufferLength === this.blockSize && (me(this._temp, this._state, this._buffer, 0, this.blockSize), this._bufferLength = 0);
      }
      for (br >= this.blockSize && (wr = me(this._temp, this._state, Er, wr, br), br %= this.blockSize); br > 0; )
        this._buffer[this._bufferLength++] = Er[wr++], br--;
      return this;
    }, fr.prototype.finish = function(Er) {
      if (!this._finished) {
        var br = this._bytesHashed, wr = this._bufferLength, kr = br / 536870912 | 0, Gr = br << 3, Vr = br % 64 < 56 ? 64 : 128;
        this._buffer[wr] = 128;
        for (var jr = wr + 1; jr < Vr - 8; jr++)
          this._buffer[jr] = 0;
        e.writeUint32BE(kr, this._buffer, Vr - 8), e.writeUint32BE(Gr, this._buffer, Vr - 4), me(this._temp, this._state, this._buffer, 0, Vr), this._finished = !0;
      }
      for (var jr = 0; jr < this.digestLength / 4; jr++)
        e.writeUint32BE(this._state[jr], Er, jr * 4);
      return this;
    }, fr.prototype.digest = function() {
      var Er = new Uint8Array(this.digestLength);
      return this.finish(Er), Er;
    }, fr.prototype.saveState = function() {
      if (this._finished)
        throw new Error("SHA256: cannot save finished state");
      return {
        state: new Int32Array(this._state),
        buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
        bufferLength: this._bufferLength,
        bytesHashed: this._bytesHashed
      };
    }, fr.prototype.restoreState = function(Er) {
      return this._state.set(Er.state), this._bufferLength = Er.bufferLength, Er.buffer && this._buffer.set(Er.buffer), this._bytesHashed = Er.bytesHashed, this._finished = !1, this;
    }, fr.prototype.cleanSavedState = function(Er) {
      s.wipe(Er.state), Er.buffer && s.wipe(Er.buffer), Er.bufferLength = 0, Er.bytesHashed = 0;
    }, fr;
  }();
  r.SHA256 = o;
  var fe = new Int32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  function me(fr, Er, br, wr, kr) {
    for (; kr >= 64; ) {
      for (var Gr = Er[0], Vr = Er[1], jr = Er[2], Kr = Er[3], bn = Er[4], Yr = Er[5], Zr = Er[6], ti = Er[7], On = 0; On < 16; On++) {
        var ni = wr + On * 4;
        fr[On] = e.readUint32BE(br, ni);
      }
      for (var On = 16; On < 64; On++) {
        var In = fr[On - 2], Br = (In >>> 17 | In << 32 - 17) ^ (In >>> 19 | In << 32 - 19) ^ In >>> 10;
        In = fr[On - 15];
        var Hr = (In >>> 7 | In << 32 - 7) ^ (In >>> 18 | In << 32 - 18) ^ In >>> 3;
        fr[On] = (Br + fr[On - 7] | 0) + (Hr + fr[On - 16] | 0);
      }
      for (var On = 0; On < 64; On++) {
        var Br = (((bn >>> 6 | bn << 26) ^ (bn >>> 11 | bn << 21) ^ (bn >>> 25 | bn << 7)) + (bn & Yr ^ ~bn & Zr) | 0) + (ti + (fe[On] + fr[On] | 0) | 0) | 0, Hr = ((Gr >>> 2 | Gr << 32 - 2) ^ (Gr >>> 13 | Gr << 32 - 13) ^ (Gr >>> 22 | Gr << 32 - 22)) + (Gr & Vr ^ Gr & jr ^ Vr & jr) | 0;
        ti = Zr, Zr = Yr, Yr = bn, bn = Kr + Br | 0, Kr = jr, jr = Vr, Vr = Gr, Gr = Br + Hr | 0;
      }
      Er[0] += Gr, Er[1] += Vr, Er[2] += jr, Er[3] += Kr, Er[4] += bn, Er[5] += Yr, Er[6] += Zr, Er[7] += ti, wr += 64, kr -= 64;
    }
    return wr;
  }
  function ye(fr) {
    var Er = new o();
    Er.update(fr);
    var br = Er.digest();
    return Er.clean(), br;
  }
  r.hash = ye;
})(sha256);
var x25519 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.sharedKey = r.generateKeyPair = r.generateKeyPairFromSeed = r.scalarMultBase = r.scalarMult = r.SHARED_KEY_LENGTH = r.SECRET_KEY_LENGTH = r.PUBLIC_KEY_LENGTH = void 0;
  const e = random, s = wipe$1;
  r.PUBLIC_KEY_LENGTH = 32, r.SECRET_KEY_LENGTH = 32, r.SHARED_KEY_LENGTH = 32;
  function o(On) {
    const ni = new Float64Array(16);
    if (On)
      for (let In = 0; In < On.length; In++)
        ni[In] = On[In];
    return ni;
  }
  const fe = new Uint8Array(32);
  fe[0] = 9;
  const me = o([56129, 1]);
  function ye(On) {
    let ni = 1;
    for (let In = 0; In < 16; In++) {
      let Br = On[In] + ni + 65535;
      ni = Math.floor(Br / 65536), On[In] = Br - ni * 65536;
    }
    On[0] += ni - 1 + 37 * (ni - 1);
  }
  function fr(On, ni, In) {
    const Br = ~(In - 1);
    for (let Hr = 0; Hr < 16; Hr++) {
      const Pn = Br & (On[Hr] ^ ni[Hr]);
      On[Hr] ^= Pn, ni[Hr] ^= Pn;
    }
  }
  function Er(On, ni) {
    const In = o(), Br = o();
    for (let Hr = 0; Hr < 16; Hr++)
      Br[Hr] = ni[Hr];
    ye(Br), ye(Br), ye(Br);
    for (let Hr = 0; Hr < 2; Hr++) {
      In[0] = Br[0] - 65517;
      for (let ei = 1; ei < 15; ei++)
        In[ei] = Br[ei] - 65535 - (In[ei - 1] >> 16 & 1), In[ei - 1] &= 65535;
      In[15] = Br[15] - 32767 - (In[14] >> 16 & 1);
      const Pn = In[15] >> 16 & 1;
      In[14] &= 65535, fr(Br, In, 1 - Pn);
    }
    for (let Hr = 0; Hr < 16; Hr++)
      On[2 * Hr] = Br[Hr] & 255, On[2 * Hr + 1] = Br[Hr] >> 8;
  }
  function br(On, ni) {
    for (let In = 0; In < 16; In++)
      On[In] = ni[2 * In] + (ni[2 * In + 1] << 8);
    On[15] &= 32767;
  }
  function wr(On, ni, In) {
    for (let Br = 0; Br < 16; Br++)
      On[Br] = ni[Br] + In[Br];
  }
  function kr(On, ni, In) {
    for (let Br = 0; Br < 16; Br++)
      On[Br] = ni[Br] - In[Br];
  }
  function Gr(On, ni, In) {
    let Br, Hr, Pn = 0, ei = 0, oi = 0, Nn = 0, En = 0, qr = 0, Jr = 0, ri = 0, Sn = 0, ai = 0, di = 0, ii = 0, fi = 0, Ei = 0, bi = 0, Si = 0, Ii = 0, yi = 0, ui = 0, hi = 0, gi = 0, Qr = 0, wn = 0, ci = 0, vi = 0, Ni = 0, Fi = 0, Pi = 0, Li = 0, oo = 0, ao = 0, zi = In[0], Ki = In[1], Vi = In[2], Yi = In[3], eo = In[4], Ui = In[5], ji = In[6], si = In[7], Wr = In[8], Xr = In[9], li = In[10], _i = In[11], $i = In[12], Ai = In[13], Di = In[14], Mi = In[15];
    Br = ni[0], Pn += Br * zi, ei += Br * Ki, oi += Br * Vi, Nn += Br * Yi, En += Br * eo, qr += Br * Ui, Jr += Br * ji, ri += Br * si, Sn += Br * Wr, ai += Br * Xr, di += Br * li, ii += Br * _i, fi += Br * $i, Ei += Br * Ai, bi += Br * Di, Si += Br * Mi, Br = ni[1], ei += Br * zi, oi += Br * Ki, Nn += Br * Vi, En += Br * Yi, qr += Br * eo, Jr += Br * Ui, ri += Br * ji, Sn += Br * si, ai += Br * Wr, di += Br * Xr, ii += Br * li, fi += Br * _i, Ei += Br * $i, bi += Br * Ai, Si += Br * Di, Ii += Br * Mi, Br = ni[2], oi += Br * zi, Nn += Br * Ki, En += Br * Vi, qr += Br * Yi, Jr += Br * eo, ri += Br * Ui, Sn += Br * ji, ai += Br * si, di += Br * Wr, ii += Br * Xr, fi += Br * li, Ei += Br * _i, bi += Br * $i, Si += Br * Ai, Ii += Br * Di, yi += Br * Mi, Br = ni[3], Nn += Br * zi, En += Br * Ki, qr += Br * Vi, Jr += Br * Yi, ri += Br * eo, Sn += Br * Ui, ai += Br * ji, di += Br * si, ii += Br * Wr, fi += Br * Xr, Ei += Br * li, bi += Br * _i, Si += Br * $i, Ii += Br * Ai, yi += Br * Di, ui += Br * Mi, Br = ni[4], En += Br * zi, qr += Br * Ki, Jr += Br * Vi, ri += Br * Yi, Sn += Br * eo, ai += Br * Ui, di += Br * ji, ii += Br * si, fi += Br * Wr, Ei += Br * Xr, bi += Br * li, Si += Br * _i, Ii += Br * $i, yi += Br * Ai, ui += Br * Di, hi += Br * Mi, Br = ni[5], qr += Br * zi, Jr += Br * Ki, ri += Br * Vi, Sn += Br * Yi, ai += Br * eo, di += Br * Ui, ii += Br * ji, fi += Br * si, Ei += Br * Wr, bi += Br * Xr, Si += Br * li, Ii += Br * _i, yi += Br * $i, ui += Br * Ai, hi += Br * Di, gi += Br * Mi, Br = ni[6], Jr += Br * zi, ri += Br * Ki, Sn += Br * Vi, ai += Br * Yi, di += Br * eo, ii += Br * Ui, fi += Br * ji, Ei += Br * si, bi += Br * Wr, Si += Br * Xr, Ii += Br * li, yi += Br * _i, ui += Br * $i, hi += Br * Ai, gi += Br * Di, Qr += Br * Mi, Br = ni[7], ri += Br * zi, Sn += Br * Ki, ai += Br * Vi, di += Br * Yi, ii += Br * eo, fi += Br * Ui, Ei += Br * ji, bi += Br * si, Si += Br * Wr, Ii += Br * Xr, yi += Br * li, ui += Br * _i, hi += Br * $i, gi += Br * Ai, Qr += Br * Di, wn += Br * Mi, Br = ni[8], Sn += Br * zi, ai += Br * Ki, di += Br * Vi, ii += Br * Yi, fi += Br * eo, Ei += Br * Ui, bi += Br * ji, Si += Br * si, Ii += Br * Wr, yi += Br * Xr, ui += Br * li, hi += Br * _i, gi += Br * $i, Qr += Br * Ai, wn += Br * Di, ci += Br * Mi, Br = ni[9], ai += Br * zi, di += Br * Ki, ii += Br * Vi, fi += Br * Yi, Ei += Br * eo, bi += Br * Ui, Si += Br * ji, Ii += Br * si, yi += Br * Wr, ui += Br * Xr, hi += Br * li, gi += Br * _i, Qr += Br * $i, wn += Br * Ai, ci += Br * Di, vi += Br * Mi, Br = ni[10], di += Br * zi, ii += Br * Ki, fi += Br * Vi, Ei += Br * Yi, bi += Br * eo, Si += Br * Ui, Ii += Br * ji, yi += Br * si, ui += Br * Wr, hi += Br * Xr, gi += Br * li, Qr += Br * _i, wn += Br * $i, ci += Br * Ai, vi += Br * Di, Ni += Br * Mi, Br = ni[11], ii += Br * zi, fi += Br * Ki, Ei += Br * Vi, bi += Br * Yi, Si += Br * eo, Ii += Br * Ui, yi += Br * ji, ui += Br * si, hi += Br * Wr, gi += Br * Xr, Qr += Br * li, wn += Br * _i, ci += Br * $i, vi += Br * Ai, Ni += Br * Di, Fi += Br * Mi, Br = ni[12], fi += Br * zi, Ei += Br * Ki, bi += Br * Vi, Si += Br * Yi, Ii += Br * eo, yi += Br * Ui, ui += Br * ji, hi += Br * si, gi += Br * Wr, Qr += Br * Xr, wn += Br * li, ci += Br * _i, vi += Br * $i, Ni += Br * Ai, Fi += Br * Di, Pi += Br * Mi, Br = ni[13], Ei += Br * zi, bi += Br * Ki, Si += Br * Vi, Ii += Br * Yi, yi += Br * eo, ui += Br * Ui, hi += Br * ji, gi += Br * si, Qr += Br * Wr, wn += Br * Xr, ci += Br * li, vi += Br * _i, Ni += Br * $i, Fi += Br * Ai, Pi += Br * Di, Li += Br * Mi, Br = ni[14], bi += Br * zi, Si += Br * Ki, Ii += Br * Vi, yi += Br * Yi, ui += Br * eo, hi += Br * Ui, gi += Br * ji, Qr += Br * si, wn += Br * Wr, ci += Br * Xr, vi += Br * li, Ni += Br * _i, Fi += Br * $i, Pi += Br * Ai, Li += Br * Di, oo += Br * Mi, Br = ni[15], Si += Br * zi, Ii += Br * Ki, yi += Br * Vi, ui += Br * Yi, hi += Br * eo, gi += Br * Ui, Qr += Br * ji, wn += Br * si, ci += Br * Wr, vi += Br * Xr, Ni += Br * li, Fi += Br * _i, Pi += Br * $i, Li += Br * Ai, oo += Br * Di, ao += Br * Mi, Pn += 38 * Ii, ei += 38 * yi, oi += 38 * ui, Nn += 38 * hi, En += 38 * gi, qr += 38 * Qr, Jr += 38 * wn, ri += 38 * ci, Sn += 38 * vi, ai += 38 * Ni, di += 38 * Fi, ii += 38 * Pi, fi += 38 * Li, Ei += 38 * oo, bi += 38 * ao, Hr = 1, Br = Pn + Hr + 65535, Hr = Math.floor(Br / 65536), Pn = Br - Hr * 65536, Br = ei + Hr + 65535, Hr = Math.floor(Br / 65536), ei = Br - Hr * 65536, Br = oi + Hr + 65535, Hr = Math.floor(Br / 65536), oi = Br - Hr * 65536, Br = Nn + Hr + 65535, Hr = Math.floor(Br / 65536), Nn = Br - Hr * 65536, Br = En + Hr + 65535, Hr = Math.floor(Br / 65536), En = Br - Hr * 65536, Br = qr + Hr + 65535, Hr = Math.floor(Br / 65536), qr = Br - Hr * 65536, Br = Jr + Hr + 65535, Hr = Math.floor(Br / 65536), Jr = Br - Hr * 65536, Br = ri + Hr + 65535, Hr = Math.floor(Br / 65536), ri = Br - Hr * 65536, Br = Sn + Hr + 65535, Hr = Math.floor(Br / 65536), Sn = Br - Hr * 65536, Br = ai + Hr + 65535, Hr = Math.floor(Br / 65536), ai = Br - Hr * 65536, Br = di + Hr + 65535, Hr = Math.floor(Br / 65536), di = Br - Hr * 65536, Br = ii + Hr + 65535, Hr = Math.floor(Br / 65536), ii = Br - Hr * 65536, Br = fi + Hr + 65535, Hr = Math.floor(Br / 65536), fi = Br - Hr * 65536, Br = Ei + Hr + 65535, Hr = Math.floor(Br / 65536), Ei = Br - Hr * 65536, Br = bi + Hr + 65535, Hr = Math.floor(Br / 65536), bi = Br - Hr * 65536, Br = Si + Hr + 65535, Hr = Math.floor(Br / 65536), Si = Br - Hr * 65536, Pn += Hr - 1 + 37 * (Hr - 1), Hr = 1, Br = Pn + Hr + 65535, Hr = Math.floor(Br / 65536), Pn = Br - Hr * 65536, Br = ei + Hr + 65535, Hr = Math.floor(Br / 65536), ei = Br - Hr * 65536, Br = oi + Hr + 65535, Hr = Math.floor(Br / 65536), oi = Br - Hr * 65536, Br = Nn + Hr + 65535, Hr = Math.floor(Br / 65536), Nn = Br - Hr * 65536, Br = En + Hr + 65535, Hr = Math.floor(Br / 65536), En = Br - Hr * 65536, Br = qr + Hr + 65535, Hr = Math.floor(Br / 65536), qr = Br - Hr * 65536, Br = Jr + Hr + 65535, Hr = Math.floor(Br / 65536), Jr = Br - Hr * 65536, Br = ri + Hr + 65535, Hr = Math.floor(Br / 65536), ri = Br - Hr * 65536, Br = Sn + Hr + 65535, Hr = Math.floor(Br / 65536), Sn = Br - Hr * 65536, Br = ai + Hr + 65535, Hr = Math.floor(Br / 65536), ai = Br - Hr * 65536, Br = di + Hr + 65535, Hr = Math.floor(Br / 65536), di = Br - Hr * 65536, Br = ii + Hr + 65535, Hr = Math.floor(Br / 65536), ii = Br - Hr * 65536, Br = fi + Hr + 65535, Hr = Math.floor(Br / 65536), fi = Br - Hr * 65536, Br = Ei + Hr + 65535, Hr = Math.floor(Br / 65536), Ei = Br - Hr * 65536, Br = bi + Hr + 65535, Hr = Math.floor(Br / 65536), bi = Br - Hr * 65536, Br = Si + Hr + 65535, Hr = Math.floor(Br / 65536), Si = Br - Hr * 65536, Pn += Hr - 1 + 37 * (Hr - 1), On[0] = Pn, On[1] = ei, On[2] = oi, On[3] = Nn, On[4] = En, On[5] = qr, On[6] = Jr, On[7] = ri, On[8] = Sn, On[9] = ai, On[10] = di, On[11] = ii, On[12] = fi, On[13] = Ei, On[14] = bi, On[15] = Si;
  }
  function Vr(On, ni) {
    Gr(On, ni, ni);
  }
  function jr(On, ni) {
    const In = o();
    for (let Br = 0; Br < 16; Br++)
      In[Br] = ni[Br];
    for (let Br = 253; Br >= 0; Br--)
      Vr(In, In), Br !== 2 && Br !== 4 && Gr(In, In, ni);
    for (let Br = 0; Br < 16; Br++)
      On[Br] = In[Br];
  }
  function Kr(On, ni) {
    const In = new Uint8Array(32), Br = new Float64Array(80), Hr = o(), Pn = o(), ei = o(), oi = o(), Nn = o(), En = o();
    for (let Sn = 0; Sn < 31; Sn++)
      In[Sn] = On[Sn];
    In[31] = On[31] & 127 | 64, In[0] &= 248, br(Br, ni);
    for (let Sn = 0; Sn < 16; Sn++)
      Pn[Sn] = Br[Sn];
    Hr[0] = oi[0] = 1;
    for (let Sn = 254; Sn >= 0; --Sn) {
      const ai = In[Sn >>> 3] >>> (Sn & 7) & 1;
      fr(Hr, Pn, ai), fr(ei, oi, ai), wr(Nn, Hr, ei), kr(Hr, Hr, ei), wr(ei, Pn, oi), kr(Pn, Pn, oi), Vr(oi, Nn), Vr(En, Hr), Gr(Hr, ei, Hr), Gr(ei, Pn, Nn), wr(Nn, Hr, ei), kr(Hr, Hr, ei), Vr(Pn, Hr), kr(ei, oi, En), Gr(Hr, ei, me), wr(Hr, Hr, oi), Gr(ei, ei, Hr), Gr(Hr, oi, En), Gr(oi, Pn, Br), Vr(Pn, Nn), fr(Hr, Pn, ai), fr(ei, oi, ai);
    }
    for (let Sn = 0; Sn < 16; Sn++)
      Br[Sn + 16] = Hr[Sn], Br[Sn + 32] = ei[Sn], Br[Sn + 48] = Pn[Sn], Br[Sn + 64] = oi[Sn];
    const qr = Br.subarray(32), Jr = Br.subarray(16);
    jr(qr, qr), Gr(Jr, Jr, qr);
    const ri = new Uint8Array(32);
    return Er(ri, Jr), ri;
  }
  r.scalarMult = Kr;
  function bn(On) {
    return Kr(On, fe);
  }
  r.scalarMultBase = bn;
  function Yr(On) {
    if (On.length !== r.SECRET_KEY_LENGTH)
      throw new Error(`x25519: seed must be ${r.SECRET_KEY_LENGTH} bytes`);
    const ni = new Uint8Array(On);
    return {
      publicKey: bn(ni),
      secretKey: ni
    };
  }
  r.generateKeyPairFromSeed = Yr;
  function Zr(On) {
    const ni = (0, e.randomBytes)(32, On), In = Yr(ni);
    return (0, s.wipe)(ni), In;
  }
  r.generateKeyPair = Zr;
  function ti(On, ni, In = !1) {
    if (On.length !== r.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect secret key length");
    if (ni.length !== r.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect public key length");
    const Br = Kr(On, ni);
    if (In) {
      let Hr = 0;
      for (let Pn = 0; Pn < Br.length; Pn++)
        Hr |= Br[Pn];
      if (Hr === 0)
        throw new Error("X25519: invalid shared key");
    }
    return Br;
  }
  r.sharedKey = ti;
})(x25519);
var __spreadArray = globalThis && globalThis.__spreadArray || function(r, e, s) {
  if (s || arguments.length === 2)
    for (var o = 0, fe = e.length, me; o < fe; o++)
      (me || !(o in e)) && (me || (me = Array.prototype.slice.call(e, 0, o)), me[o] = e[o]);
  return r.concat(me || Array.prototype.slice.call(e));
}, BrowserInfo = function() {
  function r(e, s, o) {
    this.name = e, this.version = s, this.os = o, this.type = "browser";
  }
  return r;
}(), NodeInfo = function() {
  function r(e) {
    this.version = e, this.type = "node", this.name = "node", this.os = process.platform;
  }
  return r;
}(), SearchBotDeviceInfo = function() {
  function r(e, s, o, fe) {
    this.name = e, this.version = s, this.os = o, this.bot = fe, this.type = "bot-device";
  }
  return r;
}(), BotInfo = function() {
  function r() {
    this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
  }
  return r;
}(), ReactNativeInfo = function() {
  function r() {
    this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
  }
  return r;
}(), SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, REQUIRED_VERSION_PARTS = 3, userAgentRules = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", SEARCHBOX_UA_REGEX]
], operatingSystemRules = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function detect(r) {
  return r ? parseUserAgent(r) : typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new ReactNativeInfo() : typeof navigator < "u" ? parseUserAgent(navigator.userAgent) : getNodeVersion();
}
function matchUserAgent(r) {
  return r !== "" && userAgentRules.reduce(function(e, s) {
    var o = s[0], fe = s[1];
    if (e)
      return e;
    var me = fe.exec(r);
    return !!me && [o, me];
  }, !1);
}
function parseUserAgent(r) {
  var e = matchUserAgent(r);
  if (!e)
    return null;
  var s = e[0], o = e[1];
  if (s === "searchbot")
    return new BotInfo();
  var fe = o[1] && o[1].split(".").join("_").split("_").slice(0, 3);
  fe ? fe.length < REQUIRED_VERSION_PARTS && (fe = __spreadArray(__spreadArray([], fe, !0), createVersionParts(REQUIRED_VERSION_PARTS - fe.length), !0)) : fe = [];
  var me = fe.join("."), ye = detectOS(r), fr = SEARCHBOT_OS_REGEX.exec(r);
  return fr && fr[1] ? new SearchBotDeviceInfo(s, me, ye, fr[1]) : new BrowserInfo(s, me, ye);
}
function detectOS(r) {
  for (var e = 0, s = operatingSystemRules.length; e < s; e++) {
    var o = operatingSystemRules[e], fe = o[0], me = o[1], ye = me.exec(r);
    if (ye)
      return fe;
  }
  return null;
}
function getNodeVersion() {
  var r = typeof process < "u" && process.version;
  return r ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(r) {
  for (var e = [], s = 0; s < r; s++)
    e.push("0");
  return e;
}
var cjs$2 = {};
Object.defineProperty(cjs$2, "__esModule", { value: !0 });
cjs$2.getLocalStorage = cjs$2.getLocalStorageOrThrow = cjs$2.getCrypto = cjs$2.getCryptoOrThrow = getLocation_1 = cjs$2.getLocation = cjs$2.getLocationOrThrow = getNavigator_1 = cjs$2.getNavigator = cjs$2.getNavigatorOrThrow = getDocument_1 = cjs$2.getDocument = cjs$2.getDocumentOrThrow = cjs$2.getFromWindowOrThrow = cjs$2.getFromWindow = void 0;
function getFromWindow(r) {
  let e;
  return typeof window < "u" && typeof window[r] < "u" && (e = window[r]), e;
}
cjs$2.getFromWindow = getFromWindow;
function getFromWindowOrThrow(r) {
  const e = getFromWindow(r);
  if (!e)
    throw new Error(`${r} is not defined in Window`);
  return e;
}
cjs$2.getFromWindowOrThrow = getFromWindowOrThrow;
function getDocumentOrThrow() {
  return getFromWindowOrThrow("document");
}
cjs$2.getDocumentOrThrow = getDocumentOrThrow;
function getDocument() {
  return getFromWindow("document");
}
var getDocument_1 = cjs$2.getDocument = getDocument;
function getNavigatorOrThrow() {
  return getFromWindowOrThrow("navigator");
}
cjs$2.getNavigatorOrThrow = getNavigatorOrThrow;
function getNavigator() {
  return getFromWindow("navigator");
}
var getNavigator_1 = cjs$2.getNavigator = getNavigator;
function getLocationOrThrow() {
  return getFromWindowOrThrow("location");
}
cjs$2.getLocationOrThrow = getLocationOrThrow;
function getLocation() {
  return getFromWindow("location");
}
var getLocation_1 = cjs$2.getLocation = getLocation;
function getCryptoOrThrow() {
  return getFromWindowOrThrow("crypto");
}
cjs$2.getCryptoOrThrow = getCryptoOrThrow;
function getCrypto() {
  return getFromWindow("crypto");
}
cjs$2.getCrypto = getCrypto;
function getLocalStorageOrThrow() {
  return getFromWindowOrThrow("localStorage");
}
cjs$2.getLocalStorageOrThrow = getLocalStorageOrThrow;
function getLocalStorage() {
  return getFromWindow("localStorage");
}
cjs$2.getLocalStorage = getLocalStorage;
var cjs$1 = {};
Object.defineProperty(cjs$1, "__esModule", { value: !0 });
var getWindowMetadata_1 = cjs$1.getWindowMetadata = void 0;
const window_getters_1 = cjs$2;
function getWindowMetadata() {
  let r, e;
  try {
    r = window_getters_1.getDocumentOrThrow(), e = window_getters_1.getLocationOrThrow();
  } catch {
    return null;
  }
  function s() {
    const kr = r.getElementsByTagName("link"), Gr = [];
    for (let Vr = 0; Vr < kr.length; Vr++) {
      const jr = kr[Vr], Kr = jr.getAttribute("rel");
      if (Kr && Kr.toLowerCase().indexOf("icon") > -1) {
        const bn = jr.getAttribute("href");
        if (bn)
          if (bn.toLowerCase().indexOf("https:") === -1 && bn.toLowerCase().indexOf("http:") === -1 && bn.indexOf("//") !== 0) {
            let Yr = e.protocol + "//" + e.host;
            if (bn.indexOf("/") === 0)
              Yr += bn;
            else {
              const Zr = e.pathname.split("/");
              Zr.pop();
              const ti = Zr.join("/");
              Yr += ti + "/" + bn;
            }
            Gr.push(Yr);
          } else if (bn.indexOf("//") === 0) {
            const Yr = e.protocol + bn;
            Gr.push(Yr);
          } else
            Gr.push(bn);
      }
    }
    return Gr;
  }
  function o(...kr) {
    const Gr = r.getElementsByTagName("meta");
    for (let Vr = 0; Vr < Gr.length; Vr++) {
      const jr = Gr[Vr], Kr = ["itemprop", "property", "name"].map((bn) => jr.getAttribute(bn)).filter((bn) => bn ? kr.includes(bn) : !1);
      if (Kr.length && Kr) {
        const bn = jr.getAttribute("content");
        if (bn)
          return bn;
      }
    }
    return "";
  }
  function fe() {
    let kr = o("name", "og:site_name", "og:title", "twitter:title");
    return kr || (kr = r.title), kr;
  }
  function me() {
    return o("description", "og:description", "twitter:description", "keywords");
  }
  const ye = fe(), fr = me(), Er = e.origin, br = s();
  return {
    description: fr,
    url: Er,
    icons: br,
    name: ye
  };
}
getWindowMetadata_1 = cjs$1.getWindowMetadata = getWindowMetadata;
var queryString = {}, strictUriEncode = (r) => encodeURIComponent(r).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), token = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(r, e) {
  try {
    return [decodeURIComponent(r.join(""))];
  } catch {
  }
  if (r.length === 1)
    return r;
  e = e || 1;
  var s = r.slice(0, e), o = r.slice(e);
  return Array.prototype.concat.call([], decodeComponents(s), decodeComponents(o));
}
function decode$3(r) {
  try {
    return decodeURIComponent(r);
  } catch {
    for (var e = r.match(singleMatcher) || [], s = 1; s < e.length; s++)
      r = decodeComponents(e, s).join(""), e = r.match(singleMatcher) || [];
    return r;
  }
}
function customDecodeURIComponent(r) {
  for (var e = {
    "%FE%FF": "\uFFFD\uFFFD",
    "%FF%FE": "\uFFFD\uFFFD"
  }, s = multiMatcher.exec(r); s; ) {
    try {
      e[s[0]] = decodeURIComponent(s[0]);
    } catch {
      var o = decode$3(s[0]);
      o !== s[0] && (e[s[0]] = o);
    }
    s = multiMatcher.exec(r);
  }
  e["%C2"] = "\uFFFD";
  for (var fe = Object.keys(e), me = 0; me < fe.length; me++) {
    var ye = fe[me];
    r = r.replace(new RegExp(ye, "g"), e[ye]);
  }
  return r;
}
var decodeUriComponent = function(r) {
  if (typeof r != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof r + "`");
  try {
    return r = r.replace(/\+/g, " "), decodeURIComponent(r);
  } catch {
    return customDecodeURIComponent(r);
  }
}, splitOnFirst = (r, e) => {
  if (!(typeof r == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "")
    return [r];
  const s = r.indexOf(e);
  return s === -1 ? [r] : [
    r.slice(0, s),
    r.slice(s + e.length)
  ];
}, filterObj = function(r, e) {
  for (var s = {}, o = Object.keys(r), fe = Array.isArray(e), me = 0; me < o.length; me++) {
    var ye = o[me], fr = r[ye];
    (fe ? e.indexOf(ye) !== -1 : e(ye, fr, r)) && (s[ye] = fr);
  }
  return s;
};
(function(r) {
  const e = strictUriEncode, s = decodeUriComponent, o = splitOnFirst, fe = filterObj, me = (Zr) => Zr == null, ye = Symbol("encodeFragmentIdentifier");
  function fr(Zr) {
    switch (Zr.arrayFormat) {
      case "index":
        return (ti) => (On, ni) => {
          const In = On.length;
          return ni === void 0 || Zr.skipNull && ni === null || Zr.skipEmptyString && ni === "" ? On : ni === null ? [...On, [wr(ti, Zr), "[", In, "]"].join("")] : [
            ...On,
            [wr(ti, Zr), "[", wr(In, Zr), "]=", wr(ni, Zr)].join("")
          ];
        };
      case "bracket":
        return (ti) => (On, ni) => ni === void 0 || Zr.skipNull && ni === null || Zr.skipEmptyString && ni === "" ? On : ni === null ? [...On, [wr(ti, Zr), "[]"].join("")] : [...On, [wr(ti, Zr), "[]=", wr(ni, Zr)].join("")];
      case "colon-list-separator":
        return (ti) => (On, ni) => ni === void 0 || Zr.skipNull && ni === null || Zr.skipEmptyString && ni === "" ? On : ni === null ? [...On, [wr(ti, Zr), ":list="].join("")] : [...On, [wr(ti, Zr), ":list=", wr(ni, Zr)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const ti = Zr.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (On) => (ni, In) => In === void 0 || Zr.skipNull && In === null || Zr.skipEmptyString && In === "" ? ni : (In = In === null ? "" : In, ni.length === 0 ? [[wr(On, Zr), ti, wr(In, Zr)].join("")] : [[ni, wr(In, Zr)].join(Zr.arrayFormatSeparator)]);
      }
      default:
        return (ti) => (On, ni) => ni === void 0 || Zr.skipNull && ni === null || Zr.skipEmptyString && ni === "" ? On : ni === null ? [...On, wr(ti, Zr)] : [...On, [wr(ti, Zr), "=", wr(ni, Zr)].join("")];
    }
  }
  function Er(Zr) {
    let ti;
    switch (Zr.arrayFormat) {
      case "index":
        return (On, ni, In) => {
          if (ti = /\[(\d*)\]$/.exec(On), On = On.replace(/\[\d*\]$/, ""), !ti) {
            In[On] = ni;
            return;
          }
          In[On] === void 0 && (In[On] = {}), In[On][ti[1]] = ni;
        };
      case "bracket":
        return (On, ni, In) => {
          if (ti = /(\[\])$/.exec(On), On = On.replace(/\[\]$/, ""), !ti) {
            In[On] = ni;
            return;
          }
          if (In[On] === void 0) {
            In[On] = [ni];
            return;
          }
          In[On] = [].concat(In[On], ni);
        };
      case "colon-list-separator":
        return (On, ni, In) => {
          if (ti = /(:list)$/.exec(On), On = On.replace(/:list$/, ""), !ti) {
            In[On] = ni;
            return;
          }
          if (In[On] === void 0) {
            In[On] = [ni];
            return;
          }
          In[On] = [].concat(In[On], ni);
        };
      case "comma":
      case "separator":
        return (On, ni, In) => {
          const Br = typeof ni == "string" && ni.includes(Zr.arrayFormatSeparator), Hr = typeof ni == "string" && !Br && kr(ni, Zr).includes(Zr.arrayFormatSeparator);
          ni = Hr ? kr(ni, Zr) : ni;
          const Pn = Br || Hr ? ni.split(Zr.arrayFormatSeparator).map((ei) => kr(ei, Zr)) : ni === null ? ni : kr(ni, Zr);
          In[On] = Pn;
        };
      case "bracket-separator":
        return (On, ni, In) => {
          const Br = /(\[\])$/.test(On);
          if (On = On.replace(/\[\]$/, ""), !Br) {
            In[On] = ni && kr(ni, Zr);
            return;
          }
          const Hr = ni === null ? [] : ni.split(Zr.arrayFormatSeparator).map((Pn) => kr(Pn, Zr));
          if (In[On] === void 0) {
            In[On] = Hr;
            return;
          }
          In[On] = [].concat(In[On], Hr);
        };
      default:
        return (On, ni, In) => {
          if (In[On] === void 0) {
            In[On] = ni;
            return;
          }
          In[On] = [].concat(In[On], ni);
        };
    }
  }
  function br(Zr) {
    if (typeof Zr != "string" || Zr.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function wr(Zr, ti) {
    return ti.encode ? ti.strict ? e(Zr) : encodeURIComponent(Zr) : Zr;
  }
  function kr(Zr, ti) {
    return ti.decode ? s(Zr) : Zr;
  }
  function Gr(Zr) {
    return Array.isArray(Zr) ? Zr.sort() : typeof Zr == "object" ? Gr(Object.keys(Zr)).sort((ti, On) => Number(ti) - Number(On)).map((ti) => Zr[ti]) : Zr;
  }
  function Vr(Zr) {
    const ti = Zr.indexOf("#");
    return ti !== -1 && (Zr = Zr.slice(0, ti)), Zr;
  }
  function jr(Zr) {
    let ti = "";
    const On = Zr.indexOf("#");
    return On !== -1 && (ti = Zr.slice(On)), ti;
  }
  function Kr(Zr) {
    Zr = Vr(Zr);
    const ti = Zr.indexOf("?");
    return ti === -1 ? "" : Zr.slice(ti + 1);
  }
  function bn(Zr, ti) {
    return ti.parseNumbers && !Number.isNaN(Number(Zr)) && typeof Zr == "string" && Zr.trim() !== "" ? Zr = Number(Zr) : ti.parseBooleans && Zr !== null && (Zr.toLowerCase() === "true" || Zr.toLowerCase() === "false") && (Zr = Zr.toLowerCase() === "true"), Zr;
  }
  function Yr(Zr, ti) {
    ti = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, ti), br(ti.arrayFormatSeparator);
    const On = Er(ti), ni = /* @__PURE__ */ Object.create(null);
    if (typeof Zr != "string" || (Zr = Zr.trim().replace(/^[?#&]/, ""), !Zr))
      return ni;
    for (const In of Zr.split("&")) {
      if (In === "")
        continue;
      let [Br, Hr] = o(ti.decode ? In.replace(/\+/g, " ") : In, "=");
      Hr = Hr === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(ti.arrayFormat) ? Hr : kr(Hr, ti), On(kr(Br, ti), Hr, ni);
    }
    for (const In of Object.keys(ni)) {
      const Br = ni[In];
      if (typeof Br == "object" && Br !== null)
        for (const Hr of Object.keys(Br))
          Br[Hr] = bn(Br[Hr], ti);
      else
        ni[In] = bn(Br, ti);
    }
    return ti.sort === !1 ? ni : (ti.sort === !0 ? Object.keys(ni).sort() : Object.keys(ni).sort(ti.sort)).reduce((In, Br) => {
      const Hr = ni[Br];
      return Boolean(Hr) && typeof Hr == "object" && !Array.isArray(Hr) ? In[Br] = Gr(Hr) : In[Br] = Hr, In;
    }, /* @__PURE__ */ Object.create(null));
  }
  r.extract = Kr, r.parse = Yr, r.stringify = (Zr, ti) => {
    if (!Zr)
      return "";
    ti = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, ti), br(ti.arrayFormatSeparator);
    const On = (Hr) => ti.skipNull && me(Zr[Hr]) || ti.skipEmptyString && Zr[Hr] === "", ni = fr(ti), In = {};
    for (const Hr of Object.keys(Zr))
      On(Hr) || (In[Hr] = Zr[Hr]);
    const Br = Object.keys(In);
    return ti.sort !== !1 && Br.sort(ti.sort), Br.map((Hr) => {
      const Pn = Zr[Hr];
      return Pn === void 0 ? "" : Pn === null ? wr(Hr, ti) : Array.isArray(Pn) ? Pn.length === 0 && ti.arrayFormat === "bracket-separator" ? wr(Hr, ti) + "[]" : Pn.reduce(ni(Hr), []).join("&") : wr(Hr, ti) + "=" + wr(Pn, ti);
    }).filter((Hr) => Hr.length > 0).join("&");
  }, r.parseUrl = (Zr, ti) => {
    ti = Object.assign({
      decode: !0
    }, ti);
    const [On, ni] = o(Zr, "#");
    return Object.assign(
      {
        url: On.split("?")[0] || "",
        query: Yr(Kr(Zr), ti)
      },
      ti && ti.parseFragmentIdentifier && ni ? { fragmentIdentifier: kr(ni, ti) } : {}
    );
  }, r.stringifyUrl = (Zr, ti) => {
    ti = Object.assign({
      encode: !0,
      strict: !0,
      [ye]: !0
    }, ti);
    const On = Vr(Zr.url).split("?")[0] || "", ni = r.extract(Zr.url), In = r.parse(ni, { sort: !1 }), Br = Object.assign(In, Zr.query);
    let Hr = r.stringify(Br, ti);
    Hr && (Hr = `?${Hr}`);
    let Pn = jr(Zr.url);
    return Zr.fragmentIdentifier && (Pn = `#${ti[ye] ? wr(Zr.fragmentIdentifier, ti) : Zr.fragmentIdentifier}`), `${On}${Hr}${Pn}`;
  }, r.pick = (Zr, ti, On) => {
    On = Object.assign({
      parseFragmentIdentifier: !0,
      [ye]: !1
    }, On);
    const { url: ni, query: In, fragmentIdentifier: Br } = r.parseUrl(Zr, On);
    return r.stringifyUrl({
      url: ni,
      query: fe(In, ti),
      fragmentIdentifier: Br
    }, On);
  }, r.exclude = (Zr, ti, On) => {
    const ni = Array.isArray(ti) ? (In) => !ti.includes(In) : (In, Br) => !ti(In, Br);
    return r.pick(Zr, ni, On);
  };
})(queryString);
const RELAY_JSONRPC = {
  waku: {
    publish: "waku_publish",
    batchPublish: "waku_batchPublish",
    subscribe: "waku_subscribe",
    batchSubscribe: "waku_batchSubscribe",
    subscription: "waku_subscription",
    unsubscribe: "waku_unsubscribe",
    batchUnsubscribe: "waku_batchUnsubscribe"
  },
  irn: {
    publish: "irn_publish",
    batchPublish: "irn_batchPublish",
    subscribe: "irn_subscribe",
    batchSubscribe: "irn_batchSubscribe",
    subscription: "irn_subscription",
    unsubscribe: "irn_unsubscribe",
    batchUnsubscribe: "irn_batchUnsubscribe"
  },
  iridium: {
    publish: "iridium_publish",
    batchPublish: "iridium_batchPublish",
    subscribe: "iridium_subscribe",
    batchSubscribe: "iridium_batchSubscribe",
    subscription: "iridium_subscription",
    unsubscribe: "iridium_unsubscribe",
    batchUnsubscribe: "iridium_batchUnsubscribe"
  }
}, K = ":";
function ve(r) {
  const [e, s] = r.split(K);
  return { namespace: e, reference: s };
}
function Ee(r) {
  const { namespace: e, reference: s } = r;
  return [e, s].join(K);
}
function z(r) {
  const [e, s, o] = r.split(K);
  return { namespace: e, reference: s, address: o };
}
function be(r) {
  const { namespace: e, reference: s, address: o } = r;
  return [e, s, o].join(K);
}
function Y(r, e) {
  const s = [];
  return r.forEach((o) => {
    const fe = e(o);
    s.includes(fe) || s.push(fe);
  }), s;
}
function Ne$1(r) {
  const { address: e } = z(r);
  return e;
}
function Oe(r) {
  const { namespace: e, reference: s } = z(r);
  return Ee({ namespace: e, reference: s });
}
function Tn(r, e) {
  const { namespace: s, reference: o } = ve(e);
  return be({ namespace: s, reference: o, address: r });
}
function An(r) {
  return Y(r, Ne$1);
}
function Se(r) {
  return Y(r, Oe);
}
function Un(r, e = []) {
  const s = [];
  return Object.keys(r).forEach((o) => {
    if (e.length && !e.includes(o))
      return;
    const fe = r[o];
    s.push(...fe.accounts);
  }), s;
}
function _n(r, e = []) {
  const s = [];
  return Object.keys(r).forEach((o) => {
    if (e.length && !e.includes(o))
      return;
    const fe = r[o];
    s.push(...Se(fe.accounts));
  }), s;
}
function Cn(r, e = []) {
  const s = [];
  return Object.keys(r).forEach((o) => {
    if (e.length && !e.includes(o))
      return;
    const fe = r[o];
    s.push(...L(o, fe));
  }), s;
}
function L(r, e) {
  return r.includes(":") ? [r] : e.chains || [];
}
const x = (r) => r == null ? void 0 : r.split(":"), we = (r) => {
  const e = r && x(r);
  if (e)
    return e[3];
}, jn = (r) => {
  const e = r && x(r);
  if (e)
    return e[2] + ":" + e[3];
}, Ie = (r) => {
  const e = r && x(r);
  if (e)
    return e.pop();
}, $n = (r, e) => {
  const s = `${r.domain} wants you to sign in with your Ethereum account:`, o = Ie(e), fe = r.statement, me = `URI: ${r.aud}`, ye = `Version: ${r.version}`, fr = `Chain ID: ${we(e)}`, Er = `Nonce: ${r.nonce}`, br = `Issued At: ${r.iat}`, wr = r.resources && r.resources.length > 0 ? `Resources:
${r.resources.map((kr) => `- ${kr}`).join(`
`)}` : void 0;
  return [s, o, "", fe, "", me, ye, fr, Er, br, wr].filter((kr) => kr != null).join(`
`);
}, J = "base10", p = "base16", F$2 = "base64pad", H$1 = "utf8", Q$2 = 0, _ = 1, Dn = 0, Pe = 1, Z$1 = 12, X$1 = 32;
function kn() {
  const r = x25519.generateKeyPair();
  return { privateKey: toString$1(r.secretKey, p), publicKey: toString$1(r.publicKey, p) };
}
function Vn() {
  const r = random.randomBytes(X$1);
  return toString$1(r, p);
}
function Mn(r, e) {
  const s = x25519.sharedKey(fromString(r, p), fromString(e, p), !0), o = new HKDF_1(sha256.SHA256, s).expand(X$1);
  return toString$1(o, p);
}
function Kn(r) {
  const e = sha256.hash(fromString(r, p));
  return toString$1(e, p);
}
function Ln(r) {
  const e = sha256.hash(fromString(r, H$1));
  return toString$1(e, p);
}
function Re(r) {
  return fromString(`${r}`, J);
}
function $$1(r) {
  return Number(toString$1(r, J));
}
function xn(r) {
  const e = Re(typeof r.type < "u" ? r.type : Q$2);
  if ($$1(e) === _ && typeof r.senderPublicKey > "u")
    throw new Error("Missing sender public key for type 1 envelope");
  const s = typeof r.senderPublicKey < "u" ? fromString(r.senderPublicKey, p) : void 0, o = typeof r.iv < "u" ? fromString(r.iv, p) : random.randomBytes(Z$1), fe = new chacha20poly1305.ChaCha20Poly1305(fromString(r.symKey, p)).seal(o, fromString(r.message, H$1));
  return Te({ type: e, sealed: fe, iv: o, senderPublicKey: s });
}
function Fn(r) {
  const e = new chacha20poly1305.ChaCha20Poly1305(fromString(r.symKey, p)), { sealed: s, iv: o } = ee$1(r.encoded), fe = e.open(o, s);
  if (fe === null)
    throw new Error("Failed to decrypt");
  return toString$1(fe, H$1);
}
function Te(r) {
  if ($$1(r.type) === _) {
    if (typeof r.senderPublicKey > "u")
      throw new Error("Missing sender public key for type 1 envelope");
    return toString$1(concat([r.type, r.senderPublicKey, r.iv, r.sealed]), F$2);
  }
  return toString$1(concat([r.type, r.iv, r.sealed]), F$2);
}
function ee$1(r) {
  const e = fromString(r, F$2), s = e.slice(Dn, Pe), o = Pe;
  if ($$1(s) === _) {
    const fr = o + X$1, Er = fr + Z$1, br = e.slice(o, fr), wr = e.slice(fr, Er), kr = e.slice(Er);
    return { type: s, sealed: kr, iv: wr, senderPublicKey: br };
  }
  const fe = o + Z$1, me = e.slice(o, fe), ye = e.slice(fe);
  return { type: s, sealed: ye, iv: me };
}
function Hn(r, e) {
  const s = ee$1(r);
  return Ae({ type: $$1(s.type), senderPublicKey: typeof s.senderPublicKey < "u" ? toString$1(s.senderPublicKey, p) : void 0, receiverPublicKey: e == null ? void 0 : e.receiverPublicKey });
}
function Ae(r) {
  const e = (r == null ? void 0 : r.type) || Q$2;
  if (e === _) {
    if (typeof (r == null ? void 0 : r.senderPublicKey) > "u")
      throw new Error("missing sender public key");
    if (typeof (r == null ? void 0 : r.receiverPublicKey) > "u")
      throw new Error("missing receiver public key");
  }
  return { type: e, senderPublicKey: r == null ? void 0 : r.senderPublicKey, receiverPublicKey: r == null ? void 0 : r.receiverPublicKey };
}
function qn(r) {
  return r.type === _ && typeof r.senderPublicKey == "string" && typeof r.receiverPublicKey == "string";
}
var Bn = Object.defineProperty, Ue$1 = Object.getOwnPropertySymbols, Gn = Object.prototype.hasOwnProperty, Wn = Object.prototype.propertyIsEnumerable, _e = (r, e, s) => e in r ? Bn(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, Ce = (r, e) => {
  for (var s in e || (e = {}))
    Gn.call(e, s) && _e(r, s, e[s]);
  if (Ue$1)
    for (var s of Ue$1(e))
      Wn.call(e, s) && _e(r, s, e[s]);
  return r;
};
const je$1 = "ReactNative", m = { reactNative: "react-native", node: "node", browser: "browser", unknown: "unknown" }, q = " ", zn = ":", $e$1 = "/", ne$1 = 2, Yn = 1e3, De$1 = "js";
function te$1() {
  return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function C() {
  return !getDocument_1() && !!getNavigator_1() && navigator.product === je$1;
}
function D$1() {
  return !te$1() && !!getNavigator_1() && !!getDocument_1();
}
function T() {
  return C() ? m.reactNative : te$1() ? m.node : D$1() ? m.browser : m.unknown;
}
function Jn() {
  var r;
  try {
    return C() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Application) < "u" ? (r = globalThis.Application) == null ? void 0 : r.applicationId : void 0;
  } catch {
    return;
  }
}
function ke$1(r, e) {
  let s = queryString.parse(r);
  return s = Ce(Ce({}, s), e), r = queryString.stringify(s), r;
}
function Qn() {
  return getWindowMetadata_1() || { name: "", description: "", url: "", icons: [""] };
}
function Zn(r, e) {
  var s;
  const o = T(), fe = { protocol: r, version: e, env: o };
  return o === "browser" && (fe.host = ((s = getLocation_1()) == null ? void 0 : s.host) || "unknown"), fe;
}
function Ve$1() {
  if (T() === m.reactNative && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u") {
    const { OS: s, Version: o } = globalThis.Platform;
    return [s, o].join("-");
  }
  const r = detect();
  if (r === null)
    return "unknown";
  const e = r.os ? r.os.replace(" ", "").toLowerCase() : "unknown";
  return r.type === "browser" ? [e, r.name, r.version].join("-") : [e, r.version].join("-");
}
function Me$1() {
  var r;
  const e = T();
  return e === m.browser ? [e, ((r = getLocation_1()) == null ? void 0 : r.host) || "unknown"].join(":") : e;
}
function Ke$1(r, e, s) {
  const o = Ve$1(), fe = Me$1();
  return [[r, e].join("-"), [De$1, s].join("-"), o, fe].join("/");
}
function Xn({ protocol: r, version: e, relayUrl: s, sdkVersion: o, auth: fe, projectId: me, useOnCloseEvent: ye, bundleId: fr }) {
  const Er = s.split("?"), br = Ke$1(r, e, o), wr = { auth: fe, ua: br, projectId: me, useOnCloseEvent: ye || void 0, origin: fr || void 0 }, kr = ke$1(Er[1] || "", wr);
  return Er[0] + "?" + kr;
}
function et$1(r) {
  let e = (r.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
  const s = typeof e < "u" ? r.split("://")[1] : r;
  return e = e === "wss" ? "https" : "http", [e, s].join("://");
}
function nt$1(r, e, s) {
  if (!r[e] || typeof r[e] !== s)
    throw new Error(`Missing or invalid "${e}" param`);
}
function Le$1(r, e = ne$1) {
  return xe(r.split($e$1), e);
}
function tt$1(r) {
  return Le$1(r).join(q);
}
function O$1(r, e) {
  return r.filter((s) => e.includes(s)).length === r.length;
}
function xe(r, e = ne$1) {
  return r.slice(Math.max(r.length - e, 0));
}
function rt$1(r) {
  return Object.fromEntries(r.entries());
}
function ot$1(r) {
  return new Map(Object.entries(r));
}
function st$1(r, e) {
  const s = {};
  return Object.keys(r).forEach((o) => {
    s[o] = e(r[o]);
  }), s;
}
const it$1 = (r) => r;
function Fe$1(r) {
  return r.trim().replace(/^\w/, (e) => e.toUpperCase());
}
function ct$1(r) {
  return r.split(q).map((e) => Fe$1(e)).join(q);
}
function at$1(r = cjs$4.FIVE_MINUTES, e) {
  const s = cjs$4.toMiliseconds(r || cjs$4.FIVE_MINUTES);
  let o, fe, me;
  return { resolve: (ye) => {
    me && o && (clearTimeout(me), o(ye));
  }, reject: (ye) => {
    me && fe && (clearTimeout(me), fe(ye));
  }, done: () => new Promise((ye, fr) => {
    me = setTimeout(() => {
      fr(new Error(e));
    }, s), o = ye, fe = fr;
  }) };
}
function ut$1(r, e, s) {
  return new Promise(async (o, fe) => {
    const me = setTimeout(() => fe(new Error(s)), e);
    try {
      const ye = await r;
      o(ye);
    } catch (ye) {
      fe(ye);
    }
    clearTimeout(me);
  });
}
function re$1(r, e) {
  if (typeof e == "string" && e.startsWith(`${r}:`))
    return e;
  if (r.toLowerCase() === "topic") {
    if (typeof e != "string")
      throw new Error('Value must be "string" for expirer target type: topic');
    return `topic:${e}`;
  } else if (r.toLowerCase() === "id") {
    if (typeof e != "number")
      throw new Error('Value must be "number" for expirer target type: id');
    return `id:${e}`;
  }
  throw new Error(`Unknown expirer target type: ${r}`);
}
function lt$1(r) {
  return re$1("topic", r);
}
function dt$1(r) {
  return re$1("id", r);
}
function ft$1(r) {
  const [e, s] = r.split(":"), o = { id: void 0, topic: void 0 };
  if (e === "topic" && typeof s == "string")
    o.topic = s;
  else if (e === "id" && Number.isInteger(Number(s)))
    o.id = Number(s);
  else
    throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${s}`);
  return o;
}
function pt$1(r, e) {
  return cjs$4.fromMiliseconds((e || Date.now()) + cjs$4.toMiliseconds(r));
}
function mt$1(r) {
  return Date.now() >= cjs$4.toMiliseconds(r);
}
function yt$1(r, e) {
  return `${r}${e ? `:${e}` : ""}`;
}
function S$1(r = [], e = []) {
  return [.../* @__PURE__ */ new Set([...r, ...e])];
}
async function ht$1({ id: r, topic: e, wcDeepLink: s }) {
  try {
    if (!s)
      return;
    const o = typeof s == "string" ? JSON.parse(s) : s;
    let fe = o == null ? void 0 : o.href;
    if (typeof fe != "string")
      return;
    fe.endsWith("/") && (fe = fe.slice(0, -1));
    const me = `${fe}/wc?requestId=${r}&sessionTopic=${e}`, ye = T();
    ye === m.browser ? me.startsWith("https://") ? window.open(me, "_blank", "noreferrer noopener") : window.open(me, "_self", "noreferrer noopener") : ye === m.reactNative && typeof (globalThis == null ? void 0 : globalThis.Linking) < "u" && await globalThis.Linking.openURL(me);
  } catch (o) {
    console.error(o);
  }
}
async function gt$1(r, e) {
  try {
    return await r.getItem(e) || (D$1() ? localStorage.getItem(e) : void 0);
  } catch (s) {
    console.error(s);
  }
}
const He$1 = "irn";
function vt$1(r) {
  return (r == null ? void 0 : r.relay) || { protocol: He$1 };
}
function Et$1(r) {
  const e = RELAY_JSONRPC[r];
  if (typeof e > "u")
    throw new Error(`Relay Protocol not supported: ${r}`);
  return e;
}
var bt$1 = Object.defineProperty, qe$1 = Object.getOwnPropertySymbols, Nt$1 = Object.prototype.hasOwnProperty, Ot$1 = Object.prototype.propertyIsEnumerable, Be$1 = (r, e, s) => e in r ? bt$1(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, St$1 = (r, e) => {
  for (var s in e || (e = {}))
    Nt$1.call(e, s) && Be$1(r, s, e[s]);
  if (qe$1)
    for (var s of qe$1(e))
      Ot$1.call(e, s) && Be$1(r, s, e[s]);
  return r;
};
function Ge$1(r, e = "-") {
  const s = {}, o = "relay" + e;
  return Object.keys(r).forEach((fe) => {
    if (fe.startsWith(o)) {
      const me = fe.replace(o, ""), ye = r[fe];
      s[me] = ye;
    }
  }), s;
}
function wt$1(r) {
  r = r.includes("wc://") ? r.replace("wc://", "") : r, r = r.includes("wc:") ? r.replace("wc:", "") : r;
  const e = r.indexOf(":"), s = r.indexOf("?") !== -1 ? r.indexOf("?") : void 0, o = r.substring(0, e), fe = r.substring(e + 1, s).split("@"), me = typeof s < "u" ? r.substring(s) : "", ye = queryString.parse(me);
  return { protocol: o, topic: We$1(fe[0]), version: parseInt(fe[1], 10), symKey: ye.symKey, relay: Ge$1(ye) };
}
function We$1(r) {
  return r.startsWith("//") ? r.substring(2) : r;
}
function ze(r, e = "-") {
  const s = "relay", o = {};
  return Object.keys(r).forEach((fe) => {
    const me = s + e + fe;
    r[fe] && (o[me] = r[fe]);
  }), o;
}
function It$1(r) {
  return `${r.protocol}:${r.topic}@${r.version}?` + queryString.stringify(St$1({ symKey: r.symKey }, ze(r.relay)));
}
var Pt$1 = Object.defineProperty, Rt$1 = Object.defineProperties, Tt$1 = Object.getOwnPropertyDescriptors, Ye$1 = Object.getOwnPropertySymbols, At$1 = Object.prototype.hasOwnProperty, Ut$1 = Object.prototype.propertyIsEnumerable, Je$1 = (r, e, s) => e in r ? Pt$1(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, _t$1 = (r, e) => {
  for (var s in e || (e = {}))
    At$1.call(e, s) && Je$1(r, s, e[s]);
  if (Ye$1)
    for (var s of Ye$1(e))
      Ut$1.call(e, s) && Je$1(r, s, e[s]);
  return r;
}, Ct$1 = (r, e) => Rt$1(r, Tt$1(e));
function A$1(r) {
  const e = [];
  return r.forEach((s) => {
    const [o, fe] = s.split(":");
    e.push(`${o}:${fe}`);
  }), e;
}
function Qe$1(r) {
  const e = [];
  return Object.values(r).forEach((s) => {
    e.push(...A$1(s.accounts));
  }), e;
}
function Ze$1(r, e) {
  const s = [];
  return Object.values(r).forEach((o) => {
    A$1(o.accounts).includes(e) && s.push(...o.methods);
  }), s;
}
function Xe$1(r, e) {
  const s = [];
  return Object.values(r).forEach((o) => {
    A$1(o.accounts).includes(e) && s.push(...o.events);
  }), s;
}
function jt$1(r, e) {
  const s = ln(r, e);
  if (s)
    throw new Error(s.message);
  const o = {};
  for (const [fe, me] of Object.entries(r))
    o[fe] = { methods: me.methods, events: me.events, chains: me.accounts.map((ye) => `${ye.split(":")[0]}:${ye.split(":")[1]}`) };
  return o;
}
function $t$1(r) {
  const { proposal: { requiredNamespaces: e, optionalNamespaces: s = {} }, supportedNamespaces: o } = r, fe = se(e), me = se(s), ye = {};
  Object.keys(o).forEach((br) => {
    const wr = o[br].chains, kr = o[br].methods, Gr = o[br].events, Vr = o[br].accounts;
    wr.forEach((jr) => {
      if (!Vr.some((Kr) => Kr.includes(jr)))
        throw new Error(`No accounts provided for chain ${jr} in namespace ${br}`);
    }), ye[br] = { chains: wr, methods: kr, events: Gr, accounts: Vr };
  });
  const fr = fn(e, ye, "approve()");
  if (fr)
    throw new Error(fr.message);
  const Er = {};
  return !Object.keys(e).length && !Object.keys(s).length ? ye : (Object.keys(fe).forEach((br) => {
    const wr = o[br].chains.filter((jr) => {
      var Kr, bn;
      return (bn = (Kr = fe[br]) == null ? void 0 : Kr.chains) == null ? void 0 : bn.includes(jr);
    }), kr = o[br].methods.filter((jr) => {
      var Kr, bn;
      return (bn = (Kr = fe[br]) == null ? void 0 : Kr.methods) == null ? void 0 : bn.includes(jr);
    }), Gr = o[br].events.filter((jr) => {
      var Kr, bn;
      return (bn = (Kr = fe[br]) == null ? void 0 : Kr.events) == null ? void 0 : bn.includes(jr);
    }), Vr = wr.map((jr) => o[br].accounts.filter((Kr) => Kr.includes(`${jr}:`))).flat();
    Er[br] = { chains: wr, methods: kr, events: Gr, accounts: Vr };
  }), Object.keys(me).forEach((br) => {
    var wr, kr, Gr, Vr, jr, Kr;
    if (!o[br])
      return;
    const bn = (kr = (wr = me[br]) == null ? void 0 : wr.chains) == null ? void 0 : kr.filter((On) => o[br].chains.includes(On)), Yr = o[br].methods.filter((On) => {
      var ni, In;
      return (In = (ni = me[br]) == null ? void 0 : ni.methods) == null ? void 0 : In.includes(On);
    }), Zr = o[br].events.filter((On) => {
      var ni, In;
      return (In = (ni = me[br]) == null ? void 0 : ni.events) == null ? void 0 : In.includes(On);
    }), ti = bn == null ? void 0 : bn.map((On) => o[br].accounts.filter((ni) => ni.includes(`${On}:`))).flat();
    Er[br] = { chains: S$1((Gr = Er[br]) == null ? void 0 : Gr.chains, bn), methods: S$1((Vr = Er[br]) == null ? void 0 : Vr.methods, Yr), events: S$1((jr = Er[br]) == null ? void 0 : jr.events, Zr), accounts: S$1((Kr = Er[br]) == null ? void 0 : Kr.accounts, ti) };
  }), Er);
}
function oe$1(r) {
  return r.includes(":");
}
function en(r) {
  return oe$1(r) ? r.split(":")[0] : r;
}
function se(r) {
  var e, s, o;
  const fe = {};
  if (!B$1(r))
    return fe;
  for (const [me, ye] of Object.entries(r)) {
    const fr = oe$1(me) ? [me] : ye.chains, Er = ye.methods || [], br = ye.events || [], wr = en(me);
    fe[wr] = Ct$1(_t$1({}, fe[wr]), { chains: S$1(fr, (e = fe[wr]) == null ? void 0 : e.chains), methods: S$1(Er, (s = fe[wr]) == null ? void 0 : s.methods), events: S$1(br, (o = fe[wr]) == null ? void 0 : o.events) });
  }
  return fe;
}
const nn = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } }, tn = { NOT_INITIALIZED: { message: "Not initialized.", code: 1 }, NO_MATCHING_KEY: { message: "No matching key.", code: 2 }, RESTORE_WILL_OVERRIDE: { message: "Restore will override.", code: 3 }, RESUBSCRIBED: { message: "Resubscribed.", code: 4 }, MISSING_OR_INVALID: { message: "Missing or invalid.", code: 5 }, EXPIRED: { message: "Expired.", code: 6 }, UNKNOWN_TYPE: { message: "Unknown type.", code: 7 }, MISMATCHED_TOPIC: { message: "Mismatched topic.", code: 8 }, NON_CONFORMING_NAMESPACES: { message: "Non conforming namespaces.", code: 9 } };
function N(r, e) {
  const { message: s, code: o } = tn[r];
  return { message: e ? `${s} ${e}` : s, code: o };
}
function U$1(r, e) {
  const { message: s, code: o } = nn[r];
  return { message: e ? `${s} ${e}` : s, code: o };
}
function k(r, e) {
  return Array.isArray(r) ? typeof e < "u" && r.length ? r.every(e) : !0 : !1;
}
function B$1(r) {
  return Object.getPrototypeOf(r) === Object.prototype && Object.keys(r).length;
}
function w$2(r) {
  return typeof r > "u";
}
function h$1(r, e) {
  return e && w$2(r) ? !0 : typeof r == "string" && !!r.trim().length;
}
function G$1(r, e) {
  return e && w$2(r) ? !0 : typeof r == "number" && !isNaN(r);
}
function Dt$1(r, e) {
  const { requiredNamespaces: s } = e, o = Object.keys(r.namespaces), fe = Object.keys(s);
  let me = !0;
  return O$1(fe, o) ? (o.forEach((ye) => {
    const { accounts: fr, methods: Er, events: br } = r.namespaces[ye], wr = A$1(fr), kr = s[ye];
    (!O$1(L(ye, kr), wr) || !O$1(kr.methods, Er) || !O$1(kr.events, br)) && (me = !1);
  }), me) : !1;
}
function V$2(r) {
  return h$1(r, !1) && r.includes(":") ? r.split(":").length === 2 : !1;
}
function rn(r) {
  if (h$1(r, !1) && r.includes(":")) {
    const e = r.split(":");
    if (e.length === 3) {
      const s = e[0] + ":" + e[1];
      return !!e[2] && V$2(s);
    }
  }
  return !1;
}
function kt$1(r) {
  if (h$1(r, !1))
    try {
      return typeof new URL(r) < "u";
    } catch {
      return !1;
    }
  return !1;
}
function Vt$1(r) {
  var e;
  return (e = r == null ? void 0 : r.proposer) == null ? void 0 : e.publicKey;
}
function Mt$1(r) {
  return r == null ? void 0 : r.topic;
}
function Kt$1(r, e) {
  let s = null;
  return h$1(r == null ? void 0 : r.publicKey, !1) || (s = N("MISSING_OR_INVALID", `${e} controller public key should be a string`)), s;
}
function ie(r) {
  let e = !0;
  return k(r) ? r.length && (e = r.every((s) => h$1(s, !1))) : e = !1, e;
}
function on$1(r, e, s) {
  let o = null;
  return k(e) && e.length ? e.forEach((fe) => {
    o || V$2(fe) || (o = U$1("UNSUPPORTED_CHAINS", `${s}, chain ${fe} should be a string and conform to "namespace:chainId" format`));
  }) : V$2(r) || (o = U$1("UNSUPPORTED_CHAINS", `${s}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), o;
}
function sn(r, e, s) {
  let o = null;
  return Object.entries(r).forEach(([fe, me]) => {
    if (o)
      return;
    const ye = on$1(fe, L(fe, me), `${e} ${s}`);
    ye && (o = ye);
  }), o;
}
function cn(r, e) {
  let s = null;
  return k(r) ? r.forEach((o) => {
    s || rn(o) || (s = U$1("UNSUPPORTED_ACCOUNTS", `${e}, account ${o} should be a string and conform to "namespace:chainId:address" format`));
  }) : s = U$1("UNSUPPORTED_ACCOUNTS", `${e}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), s;
}
function an(r, e) {
  let s = null;
  return Object.values(r).forEach((o) => {
    if (s)
      return;
    const fe = cn(o == null ? void 0 : o.accounts, `${e} namespace`);
    fe && (s = fe);
  }), s;
}
function un(r, e) {
  let s = null;
  return ie(r == null ? void 0 : r.methods) ? ie(r == null ? void 0 : r.events) || (s = U$1("UNSUPPORTED_EVENTS", `${e}, events should be an array of strings or empty array for no events`)) : s = U$1("UNSUPPORTED_METHODS", `${e}, methods should be an array of strings or empty array for no methods`), s;
}
function ce$2(r, e) {
  let s = null;
  return Object.values(r).forEach((o) => {
    if (s)
      return;
    const fe = un(o, `${e}, namespace`);
    fe && (s = fe);
  }), s;
}
function Lt$1(r, e, s) {
  let o = null;
  if (r && B$1(r)) {
    const fe = ce$2(r, e);
    fe && (o = fe);
    const me = sn(r, e, s);
    me && (o = me);
  } else
    o = N("MISSING_OR_INVALID", `${e}, ${s} should be an object with data`);
  return o;
}
function ln(r, e) {
  let s = null;
  if (r && B$1(r)) {
    const o = ce$2(r, e);
    o && (s = o);
    const fe = an(r, e);
    fe && (s = fe);
  } else
    s = N("MISSING_OR_INVALID", `${e}, namespaces should be an object with data`);
  return s;
}
function dn(r) {
  return h$1(r.protocol, !0);
}
function xt$1(r, e) {
  let s = !1;
  return e && !r ? s = !0 : r && k(r) && r.length && r.forEach((o) => {
    s = dn(o);
  }), s;
}
function Ft$1(r) {
  return typeof r == "number";
}
function Ht$1(r) {
  return typeof r < "u" && typeof r !== null;
}
function qt$1(r) {
  return !(!r || typeof r != "object" || !r.code || !G$1(r.code, !1) || !r.message || !h$1(r.message, !1));
}
function Bt$1(r) {
  return !(w$2(r) || !h$1(r.method, !1));
}
function Gt$1(r) {
  return !(w$2(r) || w$2(r.result) && w$2(r.error) || !G$1(r.id, !1) || !h$1(r.jsonrpc, !1));
}
function Wt(r) {
  return !(w$2(r) || !h$1(r.name, !1));
}
function zt$1(r, e) {
  return !(!V$2(e) || !Qe$1(r).includes(e));
}
function Yt$1(r, e, s) {
  return h$1(s, !1) ? Ze$1(r, e).includes(s) : !1;
}
function Jt$1(r, e, s) {
  return h$1(s, !1) ? Xe$1(r, e).includes(s) : !1;
}
function fn(r, e, s) {
  let o = null;
  const fe = Qt(r), me = Zt(e), ye = Object.keys(fe), fr = Object.keys(me), Er = pn(Object.keys(r)), br = pn(Object.keys(e)), wr = Er.filter((kr) => !br.includes(kr));
  return wr.length && (o = N("NON_CONFORMING_NAMESPACES", `${s} namespaces keys don't satisfy requiredNamespaces.
      Required: ${wr.toString()}
      Received: ${Object.keys(e).toString()}`)), O$1(ye, fr) || (o = N("NON_CONFORMING_NAMESPACES", `${s} namespaces chains don't satisfy required namespaces.
      Required: ${ye.toString()}
      Approved: ${fr.toString()}`)), Object.keys(e).forEach((kr) => {
    if (!kr.includes(":") || o)
      return;
    const Gr = A$1(e[kr].accounts);
    Gr.includes(kr) || (o = N("NON_CONFORMING_NAMESPACES", `${s} namespaces accounts don't satisfy namespace accounts for ${kr}
        Required: ${kr}
        Approved: ${Gr.toString()}`));
  }), ye.forEach((kr) => {
    o || (O$1(fe[kr].methods, me[kr].methods) ? O$1(fe[kr].events, me[kr].events) || (o = N("NON_CONFORMING_NAMESPACES", `${s} namespaces events don't satisfy namespace events for ${kr}`)) : o = N("NON_CONFORMING_NAMESPACES", `${s} namespaces methods don't satisfy namespace methods for ${kr}`));
  }), o;
}
function Qt(r) {
  const e = {};
  return Object.keys(r).forEach((s) => {
    var o;
    s.includes(":") ? e[s] = r[s] : (o = r[s].chains) == null || o.forEach((fe) => {
      e[fe] = { methods: r[s].methods, events: r[s].events };
    });
  }), e;
}
function pn(r) {
  return [...new Set(r.map((e) => e.includes(":") ? e.split(":")[0] : e))];
}
function Zt(r) {
  const e = {};
  return Object.keys(r).forEach((s) => {
    if (s.includes(":"))
      e[s] = r[s];
    else {
      const o = A$1(r[s].accounts);
      o == null || o.forEach((fe) => {
        e[fe] = { accounts: r[s].accounts.filter((me) => me.includes(`${fe}:`)), methods: r[s].methods, events: r[s].events };
      });
    }
  }), e;
}
function Xt(r, e) {
  return G$1(r, !1) && r <= e.max && r >= e.min;
}
function er$1() {
  const r = T();
  return new Promise((e) => {
    switch (r) {
      case m.browser:
        e(mn());
        break;
      case m.reactNative:
        e(yn());
        break;
      case m.node:
        e(hn());
        break;
      default:
        e(!0);
    }
  });
}
function mn() {
  return D$1() && (navigator == null ? void 0 : navigator.onLine);
}
async function yn() {
  if (C() && typeof globalThis < "u" && globalThis != null && globalThis.NetInfo) {
    const r = await (globalThis == null ? void 0 : globalThis.NetInfo.fetch());
    return r == null ? void 0 : r.isConnected;
  }
  return !0;
}
function hn() {
  return !0;
}
function nr$1(r) {
  switch (T()) {
    case m.browser:
      gn(r);
      break;
    case m.reactNative:
      vn(r);
      break;
    case m.node:
      break;
  }
}
function gn(r) {
  !C() && D$1() && (window.addEventListener("online", () => r(!0)), window.addEventListener("offline", () => r(!1)));
}
function vn(r) {
  C() && typeof globalThis < "u" && globalThis != null && globalThis.NetInfo && (globalThis == null || globalThis.NetInfo.addEventListener((e) => r(e == null ? void 0 : e.isConnected)));
}
const ae$1 = {};
class tr$1 {
  static get(e) {
    return ae$1[e];
  }
  static set(e, s) {
    ae$1[e] = s;
  }
  static delete(e) {
    delete ae$1[e];
  }
}
const index_es$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BASE10: J,
  BASE16: p,
  BASE64: F$2,
  COLON: zn,
  DEFAULT_DEPTH: ne$1,
  EMPTY_SPACE: q,
  ENV_MAP: m,
  INTERNAL_ERRORS: tn,
  MemoryStore: tr$1,
  ONE_THOUSAND: Yn,
  REACT_NATIVE_PRODUCT: je$1,
  RELAYER_DEFAULT_PROTOCOL: He$1,
  SDK_ERRORS: nn,
  SDK_TYPE: De$1,
  SLASH: $e$1,
  TYPE_0: Q$2,
  TYPE_1: _,
  UTF8: H$1,
  appendToQueryString: ke$1,
  assertType: nt$1,
  buildApprovedNamespaces: $t$1,
  calcExpiry: pt$1,
  capitalize: ct$1,
  capitalizeWord: Fe$1,
  createDelayedPromise: at$1,
  createExpiringPromise: ut$1,
  decodeTypeByte: $$1,
  decrypt: Fn,
  deriveSymKey: Mn,
  deserialize: ee$1,
  encodeTypeByte: Re,
  encrypt: xn,
  engineEvent: yt$1,
  enumify: it$1,
  formatAccountId: be,
  formatAccountWithChain: Tn,
  formatChainId: Ee,
  formatExpirerTarget: re$1,
  formatIdTarget: dt$1,
  formatMessage: $n,
  formatMessageContext: tt$1,
  formatRelayParams: ze,
  formatRelayRpcUrl: Xn,
  formatTopicTarget: lt$1,
  formatUA: Ke$1,
  formatUri: It$1,
  generateKeyPair: kn,
  generateRandomBytes32: Vn,
  getAccountsChains: A$1,
  getAccountsFromNamespaces: Un,
  getAddressFromAccount: Ne$1,
  getAddressesFromAccounts: An,
  getAppMetadata: Qn,
  getBrowserOnlineStatus: mn,
  getBundleId: Jn,
  getChainFromAccount: Oe,
  getChainsFromAccounts: Se,
  getChainsFromNamespace: L,
  getChainsFromNamespaces: _n,
  getChainsFromRequiredNamespaces: Cn,
  getDeepLink: gt$1,
  getDidAddress: Ie,
  getDidAddressSegments: x,
  getDidChainId: we,
  getEnvironment: T,
  getHttpUrl: et$1,
  getInternalError: N,
  getJavascriptID: Me$1,
  getJavascriptOS: Ve$1,
  getLastItems: xe,
  getNamespacedDidChainId: jn,
  getNamespacesChains: Qe$1,
  getNamespacesEventsForChainId: Xe$1,
  getNamespacesMethodsForChainId: Ze$1,
  getNodeOnlineStatus: hn,
  getReactNativeOnlineStatus: yn,
  getRelayClientMetadata: Zn,
  getRelayProtocolApi: Et$1,
  getRelayProtocolName: vt$1,
  getRequiredNamespacesFromNamespaces: jt$1,
  getSdkError: U$1,
  getUniqueValues: Y,
  handleDeeplinkRedirect: ht$1,
  hasOverlap: O$1,
  hashKey: Kn,
  hashMessage: Ln,
  isBrowser: D$1,
  isCaipNamespace: oe$1,
  isConformingNamespaces: fn,
  isExpired: mt$1,
  isNode: te$1,
  isOnline: er$1,
  isProposalStruct: Vt$1,
  isReactNative: C,
  isSessionCompatible: Dt$1,
  isSessionStruct: Mt$1,
  isTypeOneEnvelope: qn,
  isUndefined: w$2,
  isValidAccountId: rn,
  isValidAccounts: cn,
  isValidActions: un,
  isValidArray: k,
  isValidChainId: V$2,
  isValidChains: on$1,
  isValidController: Kt$1,
  isValidErrorReason: qt$1,
  isValidEvent: Wt,
  isValidId: Ft$1,
  isValidNamespaceAccounts: an,
  isValidNamespaceActions: ce$2,
  isValidNamespaceChains: sn,
  isValidNamespaceMethodsOrEvents: ie,
  isValidNamespaces: ln,
  isValidNamespacesChainId: zt$1,
  isValidNamespacesEvent: Jt$1,
  isValidNamespacesRequest: Yt$1,
  isValidNumber: G$1,
  isValidObject: B$1,
  isValidParams: Ht$1,
  isValidRelay: dn,
  isValidRelays: xt$1,
  isValidRequest: Bt$1,
  isValidRequestExpiry: Xt,
  isValidRequiredNamespaces: Lt$1,
  isValidResponse: Gt$1,
  isValidString: h$1,
  isValidUrl: kt$1,
  mapEntries: st$1,
  mapToObj: rt$1,
  mergeArrays: S$1,
  normalizeNamespaces: se,
  objToMap: ot$1,
  parseAccountId: z,
  parseChainId: ve,
  parseContextNames: Le$1,
  parseExpirerTarget: ft$1,
  parseNamespaceKey: en,
  parseRelayParams: Ge$1,
  parseTopic: We$1,
  parseUri: wt$1,
  serialize: Te,
  subscribeToBrowserNetworkChange: gn,
  subscribeToNetworkChange: nr$1,
  subscribeToReactNativeNetworkChange: vn,
  validateDecoding: Hn,
  validateEncoding: Ae
}, Symbol.toStringTag, { value: "Module" })), PARSE_ERROR = "PARSE_ERROR", INVALID_REQUEST = "INVALID_REQUEST", METHOD_NOT_FOUND = "METHOD_NOT_FOUND", INVALID_PARAMS = "INVALID_PARAMS", INTERNAL_ERROR = "INTERNAL_ERROR", SERVER_ERROR = "SERVER_ERROR", RESERVED_ERROR_CODES = [-32700, -32600, -32601, -32602, -32603], STANDARD_ERROR_MAP = {
  [PARSE_ERROR]: { code: -32700, message: "Parse error" },
  [INVALID_REQUEST]: { code: -32600, message: "Invalid Request" },
  [METHOD_NOT_FOUND]: { code: -32601, message: "Method not found" },
  [INVALID_PARAMS]: { code: -32602, message: "Invalid params" },
  [INTERNAL_ERROR]: { code: -32603, message: "Internal error" },
  [SERVER_ERROR]: { code: -32e3, message: "Server error" }
}, DEFAULT_ERROR = SERVER_ERROR;
function isReservedErrorCode(r) {
  return RESERVED_ERROR_CODES.includes(r);
}
function getError(r) {
  return Object.keys(STANDARD_ERROR_MAP).includes(r) ? STANDARD_ERROR_MAP[r] : STANDARD_ERROR_MAP[DEFAULT_ERROR];
}
function getErrorByCode(r) {
  const e = Object.values(STANDARD_ERROR_MAP).find((s) => s.code === r);
  return e || STANDARD_ERROR_MAP[DEFAULT_ERROR];
}
function parseConnectionError(r, e, s) {
  return r.message.includes("getaddrinfo ENOTFOUND") || r.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${s} RPC url at ${e}`) : r;
}
var cjs = {}, crypto$1 = {}, hasRequiredCrypto;
function requireCrypto() {
  if (hasRequiredCrypto)
    return crypto$1;
  hasRequiredCrypto = 1, Object.defineProperty(crypto$1, "__esModule", { value: !0 }), crypto$1.isBrowserCryptoAvailable = crypto$1.getSubtleCrypto = crypto$1.getBrowerCrypto = void 0;
  function r() {
    return (globalThis == null ? void 0 : globalThis.crypto) || (globalThis == null ? void 0 : globalThis.msCrypto) || {};
  }
  crypto$1.getBrowerCrypto = r;
  function e() {
    const o = r();
    return o.subtle || o.webkitSubtle;
  }
  crypto$1.getSubtleCrypto = e;
  function s() {
    return !!r() && !!e();
  }
  return crypto$1.isBrowserCryptoAvailable = s, crypto$1;
}
var env = {}, hasRequiredEnv;
function requireEnv() {
  if (hasRequiredEnv)
    return env;
  hasRequiredEnv = 1, Object.defineProperty(env, "__esModule", { value: !0 }), env.isBrowser = env.isNode = env.isReactNative = void 0;
  function r() {
    return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative";
  }
  env.isReactNative = r;
  function e() {
    return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
  }
  env.isNode = e;
  function s() {
    return !r() && !e();
  }
  return env.isBrowser = s, env;
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  const e = tslib.exports;
  e.__exportStar(requireCrypto(), r), e.__exportStar(requireEnv(), r);
})(cjs);
function payloadId(r = 3) {
  const e = Date.now() * Math.pow(10, r), s = Math.floor(Math.random() * Math.pow(10, r));
  return e + s;
}
function getBigIntRpcId(r = 6) {
  return BigInt(payloadId(r));
}
function formatJsonRpcRequest(r, e, s) {
  return {
    id: s || payloadId(),
    jsonrpc: "2.0",
    method: r,
    params: e
  };
}
function formatJsonRpcResult(r, e) {
  return {
    id: r,
    jsonrpc: "2.0",
    result: e
  };
}
function formatJsonRpcError(r, e, s) {
  return {
    id: r,
    jsonrpc: "2.0",
    error: formatErrorMessage(e, s)
  };
}
function formatErrorMessage(r, e) {
  return typeof r > "u" ? getError(INTERNAL_ERROR) : (typeof r == "string" && (r = Object.assign(Object.assign({}, getError(SERVER_ERROR)), { message: r })), typeof e < "u" && (r.data = e), isReservedErrorCode(r.code) && (r = getErrorByCode(r.code)), r);
}
class IEvents {
}
class IBaseJsonRpcProvider extends IEvents {
  constructor() {
    super();
  }
}
class IJsonRpcProvider extends IBaseJsonRpcProvider {
  constructor(e) {
    super();
  }
}
const WS_REGEX = "^wss?:";
function getUrlProtocol(r) {
  const e = r.match(new RegExp(/^\w+:/, "gi"));
  if (!(!e || !e.length))
    return e[0];
}
function matchRegexProtocol(r, e) {
  const s = getUrlProtocol(r);
  return typeof s > "u" ? !1 : new RegExp(e).test(s);
}
function isWsUrl(r) {
  return matchRegexProtocol(r, WS_REGEX);
}
function isLocalhostUrl(r) {
  return new RegExp("wss?://localhost(:d{2,5})?").test(r);
}
function isJsonRpcPayload(r) {
  return typeof r == "object" && "id" in r && "jsonrpc" in r && r.jsonrpc === "2.0";
}
function isJsonRpcRequest(r) {
  return isJsonRpcPayload(r) && "method" in r;
}
function isJsonRpcResponse(r) {
  return isJsonRpcPayload(r) && (isJsonRpcResult(r) || isJsonRpcError(r));
}
function isJsonRpcResult(r) {
  return "result" in r;
}
function isJsonRpcError(r) {
  return "error" in r;
}
class JsonRpcProvider extends IJsonRpcProvider {
  constructor(e) {
    super(e), this.events = new events.exports.EventEmitter(), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(e), this.connection.connected && this.registerEventListeners();
  }
  async connect(e = this.connection) {
    await this.open(e);
  }
  async disconnect() {
    await this.close();
  }
  on(e, s) {
    this.events.on(e, s);
  }
  once(e, s) {
    this.events.once(e, s);
  }
  off(e, s) {
    this.events.off(e, s);
  }
  removeListener(e, s) {
    this.events.removeListener(e, s);
  }
  async request(e, s) {
    return this.requestStrict(formatJsonRpcRequest(e.method, e.params || [], e.id || getBigIntRpcId().toString()), s);
  }
  async requestStrict(e, s) {
    return new Promise(async (o, fe) => {
      if (!this.connection.connected)
        try {
          await this.open();
        } catch (me) {
          fe(me);
        }
      this.events.on(`${e.id}`, (me) => {
        isJsonRpcError(me) ? fe(me.error) : o(me.result);
      });
      try {
        await this.connection.send(e, s);
      } catch (me) {
        fe(me);
      }
    });
  }
  setConnection(e = this.connection) {
    return e;
  }
  onPayload(e) {
    this.events.emit("payload", e), isJsonRpcResponse(e) ? this.events.emit(`${e.id}`, e) : this.events.emit("message", {
      type: e.method,
      data: e.params
    });
  }
  onClose(e) {
    e && e.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${e.code} ${e.reason ? `(${e.reason})` : ""}`)), this.events.emit("disconnect");
  }
  async open(e = this.connection) {
    this.connection === e && this.connection.connected || (this.connection.connected && this.close(), typeof e == "string" && (await this.connection.open(e), e = this.connection), this.connection = this.setConnection(e), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
  }
  async close() {
    await this.connection.close();
  }
  registerEventListeners() {
    this.hasRegisteredEventListeners || (this.connection.on("payload", (e) => this.onPayload(e)), this.connection.on("close", (e) => this.onClose(e)), this.connection.on("error", (e) => this.events.emit("error", e)), this.connection.on("register_error", (e) => this.onClose()), this.hasRegisteredEventListeners = !0);
  }
}
const w$1 = () => typeof WebSocket < "u" ? WebSocket : typeof globalThis < "u" && typeof globalThis.WebSocket < "u" ? globalThis.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : require("ws"), b$1 = () => typeof WebSocket < "u" || typeof globalThis < "u" && typeof globalThis.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", a = (r) => r.split("?")[0], h = 10, S = w$1();
class f {
  constructor(e) {
    if (this.url = e, this.events = new events.exports.EventEmitter(), this.registering = !1, !isWsUrl(e))
      throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    this.url = e;
  }
  get connected() {
    return typeof this.socket < "u";
  }
  get connecting() {
    return this.registering;
  }
  on(e, s) {
    this.events.on(e, s);
  }
  once(e, s) {
    this.events.once(e, s);
  }
  off(e, s) {
    this.events.off(e, s);
  }
  removeListener(e, s) {
    this.events.removeListener(e, s);
  }
  async open(e = this.url) {
    await this.register(e);
  }
  async close() {
    return new Promise((e, s) => {
      if (typeof this.socket > "u") {
        s(new Error("Connection already closed"));
        return;
      }
      this.socket.onclose = (o) => {
        this.onClose(o), e();
      }, this.socket.close();
    });
  }
  async send(e) {
    typeof this.socket > "u" && (this.socket = await this.register());
    try {
      this.socket.send(safeJsonStringify(e));
    } catch (s) {
      this.onError(e.id, s);
    }
  }
  register(e = this.url) {
    if (!isWsUrl(e))
      throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    if (this.registering) {
      const s = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= s || this.events.listenerCount("open") >= s) && this.events.setMaxListeners(s + 1), new Promise((o, fe) => {
        this.events.once("register_error", (me) => {
          this.resetMaxListeners(), fe(me);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.socket > "u")
            return fe(new Error("WebSocket connection is missing or invalid"));
          o(this.socket);
        });
      });
    }
    return this.url = e, this.registering = !0, new Promise((s, o) => {
      const fe = new URLSearchParams(e).get("origin"), me = cjs.isReactNative() ? { headers: { origin: fe } } : { rejectUnauthorized: !isLocalhostUrl(e) }, ye = new S(e, [], me);
      b$1() ? ye.onerror = (fr) => {
        const Er = fr;
        o(this.emitError(Er.error));
      } : ye.on("error", (fr) => {
        o(this.emitError(fr));
      }), ye.onopen = () => {
        this.onOpen(ye), s(ye);
      };
    });
  }
  onOpen(e) {
    e.onmessage = (s) => this.onPayload(s), e.onclose = (s) => this.onClose(s), this.socket = e, this.registering = !1, this.events.emit("open");
  }
  onClose(e) {
    this.socket = void 0, this.registering = !1, this.events.emit("close", e);
  }
  onPayload(e) {
    if (typeof e.data > "u")
      return;
    const s = typeof e.data == "string" ? safeJsonParse(e.data) : e.data;
    this.events.emit("payload", s);
  }
  onError(e, s) {
    const o = this.parseError(s), fe = o.message || o.toString(), me = formatJsonRpcError(e, fe);
    this.events.emit("payload", me);
  }
  parseError(e, s = this.url) {
    return parseConnectionError(e, a(s), "WS");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > h && this.events.setMaxListeners(h);
  }
  emitError(e) {
    const s = this.parseError(new Error((e == null ? void 0 : e.message) || `WebSocket connection failed for host: ${a(this.url)}`));
    return this.events.emit("register_error", s), s;
  }
}
var lodash_isequal = { exports: {} };
(function(r, e) {
  var s = 200, o = "__lodash_hash_undefined__", fe = 1, me = 2, ye = 9007199254740991, fr = "[object Arguments]", Er = "[object Array]", br = "[object AsyncFunction]", wr = "[object Boolean]", kr = "[object Date]", Gr = "[object Error]", Vr = "[object Function]", jr = "[object GeneratorFunction]", Kr = "[object Map]", bn = "[object Number]", Yr = "[object Null]", Zr = "[object Object]", ti = "[object Promise]", On = "[object Proxy]", ni = "[object RegExp]", In = "[object Set]", Br = "[object String]", Hr = "[object Symbol]", Pn = "[object Undefined]", ei = "[object WeakMap]", oi = "[object ArrayBuffer]", Nn = "[object DataView]", En = "[object Float32Array]", qr = "[object Float64Array]", Jr = "[object Int8Array]", ri = "[object Int16Array]", Sn = "[object Int32Array]", ai = "[object Uint8Array]", di = "[object Uint8ClampedArray]", ii = "[object Uint16Array]", fi = "[object Uint32Array]", Ei = /[\\^$.*+?()[\]{}|]/g, bi = /^\[object .+?Constructor\]$/, Si = /^(?:0|[1-9]\d*)$/, Ii = {};
  Ii[En] = Ii[qr] = Ii[Jr] = Ii[ri] = Ii[Sn] = Ii[ai] = Ii[di] = Ii[ii] = Ii[fi] = !0, Ii[fr] = Ii[Er] = Ii[oi] = Ii[wr] = Ii[Nn] = Ii[kr] = Ii[Gr] = Ii[Vr] = Ii[Kr] = Ii[bn] = Ii[Zr] = Ii[ni] = Ii[In] = Ii[Br] = Ii[ei] = !1;
  var yi = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis, ui = typeof self == "object" && self && self.Object === Object && self, hi = yi || ui || Function("return this")(), gi = e && !e.nodeType && e, Qr = gi && !0 && r && !r.nodeType && r, wn = Qr && Qr.exports === gi, ci = wn && yi.process, vi = function() {
    try {
      return ci && ci.binding && ci.binding("util");
    } catch {
    }
  }(), Ni = vi && vi.isTypedArray;
  function Fi(pi, wi) {
    for (var Oi = -1, Bi = pi == null ? 0 : pi.length, ho = 0, ro = []; ++Oi < Bi; ) {
      var No = pi[Oi];
      wi(No, Oi, pi) && (ro[ho++] = No);
    }
    return ro;
  }
  function Pi(pi, wi) {
    for (var Oi = -1, Bi = wi.length, ho = pi.length; ++Oi < Bi; )
      pi[ho + Oi] = wi[Oi];
    return pi;
  }
  function Li(pi, wi) {
    for (var Oi = -1, Bi = pi == null ? 0 : pi.length; ++Oi < Bi; )
      if (wi(pi[Oi], Oi, pi))
        return !0;
    return !1;
  }
  function oo(pi, wi) {
    for (var Oi = -1, Bi = Array(pi); ++Oi < pi; )
      Bi[Oi] = wi(Oi);
    return Bi;
  }
  function ao(pi) {
    return function(wi) {
      return pi(wi);
    };
  }
  function zi(pi, wi) {
    return pi.has(wi);
  }
  function Ki(pi, wi) {
    return pi == null ? void 0 : pi[wi];
  }
  function Vi(pi) {
    var wi = -1, Oi = Array(pi.size);
    return pi.forEach(function(Bi, ho) {
      Oi[++wi] = [ho, Bi];
    }), Oi;
  }
  function Yi(pi, wi) {
    return function(Oi) {
      return pi(wi(Oi));
    };
  }
  function eo(pi) {
    var wi = -1, Oi = Array(pi.size);
    return pi.forEach(function(Bi) {
      Oi[++wi] = Bi;
    }), Oi;
  }
  var Ui = Array.prototype, ji = Function.prototype, si = Object.prototype, Wr = hi["__core-js_shared__"], Xr = ji.toString, li = si.hasOwnProperty, _i = function() {
    var pi = /[^.]+$/.exec(Wr && Wr.keys && Wr.keys.IE_PROTO || "");
    return pi ? "Symbol(src)_1." + pi : "";
  }(), $i = si.toString, Ai = RegExp(
    "^" + Xr.call(li).replace(Ei, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Di = wn ? hi.Buffer : void 0, Mi = hi.Symbol, to = hi.Uint8Array, so = si.propertyIsEnumerable, no = Ui.splice, Po = Mi ? Mi.toStringTag : void 0, Uo = Object.getOwnPropertySymbols, jo = Di ? Di.isBuffer : void 0, Go = Yi(Object.keys, Object), fo = Wo(hi, "DataView"), co = Wo(hi, "Map"), _o = Wo(hi, "Promise"), Eo = Wo(hi, "Set"), vo = Wo(hi, "WeakMap"), mo = Wo(Object, "create"), Io = zo(fo), yo = zo(co), bo = zo(_o), $o = zo(Eo), Co = zo(vo), So = Mi ? Mi.prototype : void 0, wo = So ? So.valueOf : void 0;
  function uo(pi) {
    var wi = -1, Oi = pi == null ? 0 : pi.length;
    for (this.clear(); ++wi < Oi; ) {
      var Bi = pi[wi];
      this.set(Bi[0], Bi[1]);
    }
  }
  function To() {
    this.__data__ = mo ? mo(null) : {}, this.size = 0;
  }
  function Ao(pi) {
    var wi = this.has(pi) && delete this.__data__[pi];
    return this.size -= wi ? 1 : 0, wi;
  }
  function Yo(pi) {
    var wi = this.__data__;
    if (mo) {
      var Oi = wi[pi];
      return Oi === o ? void 0 : Oi;
    }
    return li.call(wi, pi) ? wi[pi] : void 0;
  }
  function Ro(pi) {
    var wi = this.__data__;
    return mo ? wi[pi] !== void 0 : li.call(wi, pi);
  }
  function Xo(pi, wi) {
    var Oi = this.__data__;
    return this.size += this.has(pi) ? 0 : 1, Oi[pi] = mo && wi === void 0 ? o : wi, this;
  }
  uo.prototype.clear = To, uo.prototype.delete = Ao, uo.prototype.get = Yo, uo.prototype.has = Ro, uo.prototype.set = Xo;
  function Mo(pi) {
    var wi = -1, Oi = pi == null ? 0 : pi.length;
    for (this.clear(); ++wi < Oi; ) {
      var Bi = pi[wi];
      this.set(Bi[0], Bi[1]);
    }
  }
  function Jo() {
    this.__data__ = [], this.size = 0;
  }
  function Zo(pi) {
    var wi = this.__data__, Oi = ua(wi, pi);
    if (Oi < 0)
      return !1;
    var Bi = wi.length - 1;
    return Oi == Bi ? wi.pop() : no.call(wi, Oi, 1), --this.size, !0;
  }
  function ea(pi) {
    var wi = this.__data__, Oi = ua(wi, pi);
    return Oi < 0 ? void 0 : wi[Oi][1];
  }
  function ta(pi) {
    return ua(this.__data__, pi) > -1;
  }
  function ra(pi, wi) {
    var Oi = this.__data__, Bi = ua(Oi, pi);
    return Bi < 0 ? (++this.size, Oi.push([pi, wi])) : Oi[Bi][1] = wi, this;
  }
  Mo.prototype.clear = Jo, Mo.prototype.delete = Zo, Mo.prototype.get = ea, Mo.prototype.has = ta, Mo.prototype.set = ra;
  function Vo(pi) {
    var wi = -1, Oi = pi == null ? 0 : pi.length;
    for (this.clear(); ++wi < Oi; ) {
      var Bi = pi[wi];
      this.set(Bi[0], Bi[1]);
    }
  }
  function na() {
    this.size = 0, this.__data__ = {
      hash: new uo(),
      map: new (co || Mo)(),
      string: new uo()
    };
  }
  function ia(pi) {
    var wi = fa(this, pi).delete(pi);
    return this.size -= wi ? 1 : 0, wi;
  }
  function sa(pi) {
    return fa(this, pi).get(pi);
  }
  function oa(pi) {
    return fa(this, pi).has(pi);
  }
  function aa(pi, wi) {
    var Oi = fa(this, pi), Bi = Oi.size;
    return Oi.set(pi, wi), this.size += Oi.size == Bi ? 0 : 1, this;
  }
  Vo.prototype.clear = na, Vo.prototype.delete = ia, Vo.prototype.get = sa, Vo.prototype.has = oa, Vo.prototype.set = aa;
  function qo(pi) {
    var wi = -1, Oi = pi == null ? 0 : pi.length;
    for (this.__data__ = new Vo(); ++wi < Oi; )
      this.add(pi[wi]);
  }
  function ca(pi) {
    return this.__data__.set(pi, o), this;
  }
  function Ho(pi) {
    return this.__data__.has(pi);
  }
  qo.prototype.add = qo.prototype.push = ca, qo.prototype.has = Ho;
  function Fo(pi) {
    var wi = this.__data__ = new Mo(pi);
    this.size = wi.size;
  }
  function Aa() {
    this.__data__ = new Mo(), this.size = 0;
  }
  function Ia(pi) {
    var wi = this.__data__, Oi = wi.delete(pi);
    return this.size = wi.size, Oi;
  }
  function Ca(pi) {
    return this.__data__.get(pi);
  }
  function Na(pi) {
    return this.__data__.has(pi);
  }
  function Oa(pi, wi) {
    var Oi = this.__data__;
    if (Oi instanceof Mo) {
      var Bi = Oi.__data__;
      if (!co || Bi.length < s - 1)
        return Bi.push([pi, wi]), this.size = ++Oi.size, this;
      Oi = this.__data__ = new Vo(Bi);
    }
    return Oi.set(pi, wi), this.size = Oi.size, this;
  }
  Fo.prototype.clear = Aa, Fo.prototype.delete = Ia, Fo.prototype.get = Ca, Fo.prototype.has = Na, Fo.prototype.set = Oa;
  function Ra(pi, wi) {
    var Oi = ha(pi), Bi = !Oi && xa(pi), ho = !Oi && !Bi && ba(pi), ro = !Oi && !Bi && !ho && pa(pi), No = Oi || Bi || ho || ro, Do = No ? oo(pi.length, String) : [], Lo = Do.length;
    for (var Rn in pi)
      (wi || li.call(pi, Rn)) && !(No && (Rn == "length" || ho && (Rn == "offset" || Rn == "parent") || ro && (Rn == "buffer" || Rn == "byteLength" || Rn == "byteOffset") || Sa(Rn, Lo))) && Do.push(Rn);
    return Do;
  }
  function ua(pi, wi) {
    for (var Oi = pi.length; Oi--; )
      if (Ta(pi[Oi][0], wi))
        return Oi;
    return -1;
  }
  function ja(pi, wi, Oi) {
    var Bi = wi(pi);
    return ha(pi) ? Bi : Pi(Bi, Oi(pi));
  }
  function la(pi) {
    return pi == null ? pi === void 0 ? Pn : Yr : Po && Po in Object(pi) ? va(pi) : Da(pi);
  }
  function ga(pi) {
    return Ko(pi) && la(pi) == fr;
  }
  function ma(pi, wi, Oi, Bi, ho) {
    return pi === wi ? !0 : pi == null || wi == null || !Ko(pi) && !Ko(wi) ? pi !== pi && wi !== wi : ya(pi, wi, Oi, Bi, ma, ho);
  }
  function ya(pi, wi, Oi, Bi, ho, ro) {
    var No = ha(pi), Do = ha(wi), Lo = No ? Er : ko(pi), Rn = Do ? Er : ko(wi);
    Lo = Lo == fr ? Zr : Lo, Rn = Rn == fr ? Zr : Rn;
    var mi = Lo == Zr, Ti = Rn == Zr, Ci = Lo == Rn;
    if (Ci && ba(pi)) {
      if (!ba(wi))
        return !1;
      No = !0, mi = !1;
    }
    if (Ci && !mi)
      return ro || (ro = new Fo()), No || pa(pi) ? $a(pi, wi, Oi, Bi, ho, ro) : Ha(pi, wi, Lo, Oi, Bi, ho, ro);
    if (!(Oi & fe)) {
      var Ri = mi && li.call(pi, "__wrapped__"), ki = Ti && li.call(wi, "__wrapped__");
      if (Ri || ki) {
        var xi = Ri ? pi.value() : pi, qi = ki ? wi.value() : wi;
        return ro || (ro = new Fo()), ho(xi, qi, Oi, Bi, ro);
      }
    }
    return Ci ? (ro || (ro = new Fo()), qa(pi, wi, Oi, Bi, ho, ro)) : !1;
  }
  function wa(pi) {
    if (!Fa(pi) || za(pi))
      return !1;
    var wi = Ba(pi) ? Ai : bi;
    return wi.test(zo(pi));
  }
  function Ea(pi) {
    return Ko(pi) && Ma(pi.length) && !!Ii[la(pi)];
  }
  function Ga(pi) {
    if (!Ka(pi))
      return Go(pi);
    var wi = [];
    for (var Oi in Object(pi))
      li.call(pi, Oi) && Oi != "constructor" && wi.push(Oi);
    return wi;
  }
  function $a(pi, wi, Oi, Bi, ho, ro) {
    var No = Oi & fe, Do = pi.length, Lo = wi.length;
    if (Do != Lo && !(No && Lo > Do))
      return !1;
    var Rn = ro.get(pi);
    if (Rn && ro.get(wi))
      return Rn == wi;
    var mi = -1, Ti = !0, Ci = Oi & me ? new qo() : void 0;
    for (ro.set(pi, wi), ro.set(wi, pi); ++mi < Do; ) {
      var Ri = pi[mi], ki = wi[mi];
      if (Bi)
        var xi = No ? Bi(ki, Ri, mi, wi, pi, ro) : Bi(Ri, ki, mi, pi, wi, ro);
      if (xi !== void 0) {
        if (xi)
          continue;
        Ti = !1;
        break;
      }
      if (Ci) {
        if (!Li(wi, function(qi, io) {
          if (!zi(Ci, io) && (Ri === qi || ho(Ri, qi, Oi, Bi, ro)))
            return Ci.push(io);
        })) {
          Ti = !1;
          break;
        }
      } else if (!(Ri === ki || ho(Ri, ki, Oi, Bi, ro))) {
        Ti = !1;
        break;
      }
    }
    return ro.delete(pi), ro.delete(wi), Ti;
  }
  function Ha(pi, wi, Oi, Bi, ho, ro, No) {
    switch (Oi) {
      case Nn:
        if (pi.byteLength != wi.byteLength || pi.byteOffset != wi.byteOffset)
          return !1;
        pi = pi.buffer, wi = wi.buffer;
      case oi:
        return !(pi.byteLength != wi.byteLength || !ro(new to(pi), new to(wi)));
      case wr:
      case kr:
      case bn:
        return Ta(+pi, +wi);
      case Gr:
        return pi.name == wi.name && pi.message == wi.message;
      case ni:
      case Br:
        return pi == wi + "";
      case Kr:
        var Do = Vi;
      case In:
        var Lo = Bi & fe;
        if (Do || (Do = eo), pi.size != wi.size && !Lo)
          return !1;
        var Rn = No.get(pi);
        if (Rn)
          return Rn == wi;
        Bi |= me, No.set(pi, wi);
        var mi = $a(Do(pi), Do(wi), Bi, ho, ro, No);
        return No.delete(pi), mi;
      case Hr:
        if (wo)
          return wo.call(pi) == wo.call(wi);
    }
    return !1;
  }
  function qa(pi, wi, Oi, Bi, ho, ro) {
    var No = Oi & fe, Do = da(pi), Lo = Do.length, Rn = da(wi), mi = Rn.length;
    if (Lo != mi && !No)
      return !1;
    for (var Ti = Lo; Ti--; ) {
      var Ci = Do[Ti];
      if (!(No ? Ci in wi : li.call(wi, Ci)))
        return !1;
    }
    var Ri = ro.get(pi);
    if (Ri && ro.get(wi))
      return Ri == wi;
    var ki = !0;
    ro.set(pi, wi), ro.set(wi, pi);
    for (var xi = No; ++Ti < Lo; ) {
      Ci = Do[Ti];
      var qi = pi[Ci], io = wi[Ci];
      if (Bi)
        var lo = No ? Bi(io, qi, Ci, wi, pi, ro) : Bi(qi, io, Ci, pi, wi, ro);
      if (!(lo === void 0 ? qi === io || ho(qi, io, Oi, Bi, ro) : lo)) {
        ki = !1;
        break;
      }
      xi || (xi = Ci == "constructor");
    }
    if (ki && !xi) {
      var po = pi.constructor, go = wi.constructor;
      po != go && "constructor" in pi && "constructor" in wi && !(typeof po == "function" && po instanceof po && typeof go == "function" && go instanceof go) && (ki = !1);
    }
    return ro.delete(pi), ro.delete(wi), ki;
  }
  function da(pi) {
    return ja(pi, Ya, Wa);
  }
  function fa(pi, wi) {
    var Oi = pi.__data__;
    return Pa(wi) ? Oi[typeof wi == "string" ? "string" : "hash"] : Oi.map;
  }
  function Wo(pi, wi) {
    var Oi = Ki(pi, wi);
    return wa(Oi) ? Oi : void 0;
  }
  function va(pi) {
    var wi = li.call(pi, Po), Oi = pi[Po];
    try {
      pi[Po] = void 0;
      var Bi = !0;
    } catch {
    }
    var ho = $i.call(pi);
    return Bi && (wi ? pi[Po] = Oi : delete pi[Po]), ho;
  }
  var Wa = Uo ? function(pi) {
    return pi == null ? [] : (pi = Object(pi), Fi(Uo(pi), function(wi) {
      return so.call(pi, wi);
    }));
  } : Qo, ko = la;
  (fo && ko(new fo(new ArrayBuffer(1))) != Nn || co && ko(new co()) != Kr || _o && ko(_o.resolve()) != ti || Eo && ko(new Eo()) != In || vo && ko(new vo()) != ei) && (ko = function(pi) {
    var wi = la(pi), Oi = wi == Zr ? pi.constructor : void 0, Bi = Oi ? zo(Oi) : "";
    if (Bi)
      switch (Bi) {
        case Io:
          return Nn;
        case yo:
          return Kr;
        case bo:
          return ti;
        case $o:
          return In;
        case Co:
          return ei;
      }
    return wi;
  });
  function Sa(pi, wi) {
    return wi = wi == null ? ye : wi, !!wi && (typeof pi == "number" || Si.test(pi)) && pi > -1 && pi % 1 == 0 && pi < wi;
  }
  function Pa(pi) {
    var wi = typeof pi;
    return wi == "string" || wi == "number" || wi == "symbol" || wi == "boolean" ? pi !== "__proto__" : pi === null;
  }
  function za(pi) {
    return !!_i && _i in pi;
  }
  function Ka(pi) {
    var wi = pi && pi.constructor, Oi = typeof wi == "function" && wi.prototype || si;
    return pi === Oi;
  }
  function Da(pi) {
    return $i.call(pi);
  }
  function zo(pi) {
    if (pi != null) {
      try {
        return Xr.call(pi);
      } catch {
      }
      try {
        return pi + "";
      } catch {
      }
    }
    return "";
  }
  function Ta(pi, wi) {
    return pi === wi || pi !== pi && wi !== wi;
  }
  var xa = ga(function() {
    return arguments;
  }()) ? ga : function(pi) {
    return Ko(pi) && li.call(pi, "callee") && !so.call(pi, "callee");
  }, ha = Array.isArray;
  function Qa(pi) {
    return pi != null && Ma(pi.length) && !Ba(pi);
  }
  var ba = jo || ka;
  function La(pi, wi) {
    return ma(pi, wi);
  }
  function Ba(pi) {
    if (!Fa(pi))
      return !1;
    var wi = la(pi);
    return wi == Vr || wi == jr || wi == br || wi == On;
  }
  function Ma(pi) {
    return typeof pi == "number" && pi > -1 && pi % 1 == 0 && pi <= ye;
  }
  function Fa(pi) {
    var wi = typeof pi;
    return pi != null && (wi == "object" || wi == "function");
  }
  function Ko(pi) {
    return pi != null && typeof pi == "object";
  }
  var pa = Ni ? ao(Ni) : Ea;
  function Ya(pi) {
    return Qa(pi) ? Ra(pi) : Ga(pi);
  }
  function Qo() {
    return [];
  }
  function ka() {
    return !1;
  }
  r.exports = La;
})(lodash_isequal, lodash_isequal.exports);
const Gi = lodash_isequal.exports;
function unfetch_module(r, e) {
  return e = e || {}, new Promise(function(s, o) {
    var fe = new XMLHttpRequest(), me = [], ye = [], fr = {}, Er = function() {
      return { ok: (fe.status / 100 | 0) == 2, statusText: fe.statusText, status: fe.status, url: fe.responseURL, text: function() {
        return Promise.resolve(fe.responseText);
      }, json: function() {
        return Promise.resolve(fe.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([fe.response]));
      }, clone: Er, headers: { keys: function() {
        return me;
      }, entries: function() {
        return ye;
      }, get: function(wr) {
        return fr[wr.toLowerCase()];
      }, has: function(wr) {
        return wr.toLowerCase() in fr;
      } } };
    };
    for (var br in fe.open(e.method || "get", r, !0), fe.onload = function() {
      fe.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(wr, kr, Gr) {
        me.push(kr = kr.toLowerCase()), ye.push([kr, Gr]), fr[kr] = fr[kr] ? fr[kr] + "," + Gr : Gr;
      }), s(Er());
    }, fe.onerror = o, fe.withCredentials = e.credentials == "include", e.headers)
      fe.setRequestHeader(br, e.headers[br]);
    fe.send(e.body || null);
  });
}
const unfetch_module$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: unfetch_module
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(unfetch_module$1);
var browser$1 = self.fetch || (self.fetch = require$$0.default || require$$0);
function Hi(r, e) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var s = new Uint8Array(256), o = 0; o < s.length; o++)
    s[o] = 255;
  for (var fe = 0; fe < r.length; fe++) {
    var me = r.charAt(fe), ye = me.charCodeAt(0);
    if (s[ye] !== 255)
      throw new TypeError(me + " is ambiguous");
    s[ye] = fe;
  }
  var fr = r.length, Er = r.charAt(0), br = Math.log(fr) / Math.log(256), wr = Math.log(256) / Math.log(fr);
  function kr(jr) {
    if (jr instanceof Uint8Array || (ArrayBuffer.isView(jr) ? jr = new Uint8Array(jr.buffer, jr.byteOffset, jr.byteLength) : Array.isArray(jr) && (jr = Uint8Array.from(jr))), !(jr instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (jr.length === 0)
      return "";
    for (var Kr = 0, bn = 0, Yr = 0, Zr = jr.length; Yr !== Zr && jr[Yr] === 0; )
      Yr++, Kr++;
    for (var ti = (Zr - Yr) * wr + 1 >>> 0, On = new Uint8Array(ti); Yr !== Zr; ) {
      for (var ni = jr[Yr], In = 0, Br = ti - 1; (ni !== 0 || In < bn) && Br !== -1; Br--, In++)
        ni += 256 * On[Br] >>> 0, On[Br] = ni % fr >>> 0, ni = ni / fr >>> 0;
      if (ni !== 0)
        throw new Error("Non-zero carry");
      bn = In, Yr++;
    }
    for (var Hr = ti - bn; Hr !== ti && On[Hr] === 0; )
      Hr++;
    for (var Pn = Er.repeat(Kr); Hr < ti; ++Hr)
      Pn += r.charAt(On[Hr]);
    return Pn;
  }
  function Gr(jr) {
    if (typeof jr != "string")
      throw new TypeError("Expected String");
    if (jr.length === 0)
      return new Uint8Array();
    var Kr = 0;
    if (jr[Kr] !== " ") {
      for (var bn = 0, Yr = 0; jr[Kr] === Er; )
        bn++, Kr++;
      for (var Zr = (jr.length - Kr) * br + 1 >>> 0, ti = new Uint8Array(Zr); jr[Kr]; ) {
        var On = s[jr.charCodeAt(Kr)];
        if (On === 255)
          return;
        for (var ni = 0, In = Zr - 1; (On !== 0 || ni < Yr) && In !== -1; In--, ni++)
          On += fr * ti[In] >>> 0, ti[In] = On % 256 >>> 0, On = On / 256 >>> 0;
        if (On !== 0)
          throw new Error("Non-zero carry");
        Yr = ni, Kr++;
      }
      if (jr[Kr] !== " ") {
        for (var Br = Zr - Yr; Br !== Zr && ti[Br] === 0; )
          Br++;
        for (var Hr = new Uint8Array(bn + (Zr - Br)), Pn = bn; Br !== Zr; )
          Hr[Pn++] = ti[Br++];
        return Hr;
      }
    }
  }
  function Vr(jr) {
    var Kr = Gr(jr);
    if (Kr)
      return Kr;
    throw new Error(`Non-${e} character`);
  }
  return { encode: kr, decodeUnsafe: Gr, decode: Vr };
}
var Ji = Hi, Xi = Ji;
const Ne = (r) => {
  if (r instanceof Uint8Array && r.constructor.name === "Uint8Array")
    return r;
  if (r instanceof ArrayBuffer)
    return new Uint8Array(r);
  if (ArrayBuffer.isView(r))
    return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  throw new Error("Unknown type, must be binary type");
}, Wi = (r) => new TextEncoder().encode(r), Qi = (r) => new TextDecoder().decode(r);
class Zi {
  constructor(e, s, o) {
    this.name = e, this.prefix = s, this.baseEncode = o;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class es {
  constructor(e, s, o) {
    if (this.name = e, this.prefix = s, s.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = s.codePointAt(0), this.baseDecode = o;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return Ue(this, e);
  }
}
class ts$1 {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return Ue(this, e);
  }
  decode(e) {
    const s = e[0], o = this.decoders[s];
    if (o)
      return o.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const Ue = (r, e) => new ts$1({ ...r.decoders || { [r.prefix]: r }, ...e.decoders || { [e.prefix]: e } });
class is$1 {
  constructor(e, s, o, fe) {
    this.name = e, this.prefix = s, this.baseEncode = o, this.baseDecode = fe, this.encoder = new Zi(e, s, o), this.decoder = new es(e, s, fe);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const W$1 = ({ name: r, prefix: e, encode: s, decode: o }) => new is$1(r, e, s, o), B = ({ prefix: r, name: e, alphabet: s }) => {
  const { encode: o, decode: fe } = Xi(s, e);
  return W$1({ prefix: r, name: e, encode: o, decode: (me) => Ne(fe(me)) });
}, ss$1 = (r, e, s, o) => {
  const fe = {};
  for (let wr = 0; wr < e.length; ++wr)
    fe[e[wr]] = wr;
  let me = r.length;
  for (; r[me - 1] === "="; )
    --me;
  const ye = new Uint8Array(me * s / 8 | 0);
  let fr = 0, Er = 0, br = 0;
  for (let wr = 0; wr < me; ++wr) {
    const kr = fe[r[wr]];
    if (kr === void 0)
      throw new SyntaxError(`Non-${o} character`);
    Er = Er << s | kr, fr += s, fr >= 8 && (fr -= 8, ye[br++] = 255 & Er >> fr);
  }
  if (fr >= s || 255 & Er << 8 - fr)
    throw new SyntaxError("Unexpected end of data");
  return ye;
}, rs$1 = (r, e, s) => {
  const o = e[e.length - 1] === "=", fe = (1 << s) - 1;
  let me = "", ye = 0, fr = 0;
  for (let Er = 0; Er < r.length; ++Er)
    for (fr = fr << 8 | r[Er], ye += 8; ye > s; )
      ye -= s, me += e[fe & fr >> ye];
  if (ye && (me += e[fe & fr << s - ye]), o)
    for (; me.length * s & 7; )
      me += "=";
  return me;
}, g$1 = ({ name: r, prefix: e, bitsPerChar: s, alphabet: o }) => W$1({ prefix: e, name: r, encode(fe) {
  return rs$1(fe, o, s);
}, decode(fe) {
  return ss$1(fe, o, s, r);
} }), ns$1 = W$1({ prefix: "\0", name: "identity", encode: (r) => Qi(r), decode: (r) => Wi(r) });
var os$1 = Object.freeze({ __proto__: null, identity: ns$1 });
const as$1 = g$1({ prefix: "0", name: "base2", alphabet: "01", bitsPerChar: 1 });
var hs$1 = Object.freeze({ __proto__: null, base2: as$1 });
const cs$1 = g$1({ prefix: "7", name: "base8", alphabet: "01234567", bitsPerChar: 3 });
var us$1 = Object.freeze({ __proto__: null, base8: cs$1 });
const ls$1 = B({ prefix: "9", name: "base10", alphabet: "0123456789" });
var ds$1 = Object.freeze({ __proto__: null, base10: ls$1 });
const gs$1 = g$1({ prefix: "f", name: "base16", alphabet: "0123456789abcdef", bitsPerChar: 4 }), ps$1 = g$1({ prefix: "F", name: "base16upper", alphabet: "0123456789ABCDEF", bitsPerChar: 4 });
var Ds = Object.freeze({ __proto__: null, base16: gs$1, base16upper: ps$1 });
const ys = g$1({ prefix: "b", name: "base32", alphabet: "abcdefghijklmnopqrstuvwxyz234567", bitsPerChar: 5 }), ms$1 = g$1({ prefix: "B", name: "base32upper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", bitsPerChar: 5 }), bs = g$1({ prefix: "c", name: "base32pad", alphabet: "abcdefghijklmnopqrstuvwxyz234567=", bitsPerChar: 5 }), fs = g$1({ prefix: "C", name: "base32padupper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=", bitsPerChar: 5 }), Es = g$1({ prefix: "v", name: "base32hex", alphabet: "0123456789abcdefghijklmnopqrstuv", bitsPerChar: 5 }), ws$1 = g$1({ prefix: "V", name: "base32hexupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV", bitsPerChar: 5 }), vs = g$1({ prefix: "t", name: "base32hexpad", alphabet: "0123456789abcdefghijklmnopqrstuv=", bitsPerChar: 5 }), Is = g$1({ prefix: "T", name: "base32hexpadupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=", bitsPerChar: 5 }), Cs = g$1({ prefix: "h", name: "base32z", alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769", bitsPerChar: 5 });
var Rs = Object.freeze({ __proto__: null, base32: ys, base32upper: ms$1, base32pad: bs, base32padupper: fs, base32hex: Es, base32hexupper: ws$1, base32hexpad: vs, base32hexpadupper: Is, base32z: Cs });
const _s = B({ prefix: "k", name: "base36", alphabet: "0123456789abcdefghijklmnopqrstuvwxyz" }), Ss = B({ prefix: "K", name: "base36upper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ" });
var Ts = Object.freeze({ __proto__: null, base36: _s, base36upper: Ss });
const Ps = B({ name: "base58btc", prefix: "z", alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz" }), xs = B({ name: "base58flickr", prefix: "Z", alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ" });
var Os = Object.freeze({ __proto__: null, base58btc: Ps, base58flickr: xs });
const As = g$1({ prefix: "m", name: "base64", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bitsPerChar: 6 }), zs = g$1({ prefix: "M", name: "base64pad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", bitsPerChar: 6 }), Ns = g$1({ prefix: "u", name: "base64url", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", bitsPerChar: 6 }), Us = g$1({ prefix: "U", name: "base64urlpad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=", bitsPerChar: 6 });
var Ls = Object.freeze({ __proto__: null, base64: As, base64pad: zs, base64url: Ns, base64urlpad: Us });
const Le = Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"), Fs = Le.reduce((r, e, s) => (r[s] = e, r), []), $s = Le.reduce((r, e, s) => (r[e.codePointAt(0)] = s, r), []);
function Ms(r) {
  return r.reduce((e, s) => (e += Fs[s], e), "");
}
function ks(r) {
  const e = [];
  for (const s of r) {
    const o = $s[s.codePointAt(0)];
    if (o === void 0)
      throw new Error(`Non-base256emoji character: ${s}`);
    e.push(o);
  }
  return new Uint8Array(e);
}
const Ks = W$1({ prefix: "\u{1F680}", name: "base256emoji", encode: Ms, decode: ks });
var Bs = Object.freeze({ __proto__: null, base256emoji: Ks }), Vs = $e, Fe = 128, js = 127, qs = ~js, Gs = Math.pow(2, 31);
function $e(r, e, s) {
  e = e || [], s = s || 0;
  for (var o = s; r >= Gs; )
    e[s++] = r & 255 | Fe, r /= 128;
  for (; r & qs; )
    e[s++] = r & 255 | Fe, r >>>= 7;
  return e[s] = r | 0, $e.bytes = s - o + 1, e;
}
var Ys = he$1, Hs = 128, Me = 127;
function he$1(r, o) {
  var s = 0, o = o || 0, fe = 0, me = o, ye, fr = r.length;
  do {
    if (me >= fr)
      throw he$1.bytes = 0, new RangeError("Could not decode varint");
    ye = r[me++], s += fe < 28 ? (ye & Me) << fe : (ye & Me) * Math.pow(2, fe), fe += 7;
  } while (ye >= Hs);
  return he$1.bytes = me - o, s;
}
var Js = Math.pow(2, 7), Xs = Math.pow(2, 14), Ws = Math.pow(2, 21), Qs = Math.pow(2, 28), Zs = Math.pow(2, 35), er = Math.pow(2, 42), tr = Math.pow(2, 49), ir = Math.pow(2, 56), sr = Math.pow(2, 63), rr = function(r) {
  return r < Js ? 1 : r < Xs ? 2 : r < Ws ? 3 : r < Qs ? 4 : r < Zs ? 5 : r < er ? 6 : r < tr ? 7 : r < ir ? 8 : r < sr ? 9 : 10;
}, nr = { encode: Vs, decode: Ys, encodingLength: rr }, ke = nr;
const Ke = (r, e, s = 0) => (ke.encode(r, e, s), e), Be = (r) => ke.encodingLength(r), ce$1 = (r, e) => {
  const s = e.byteLength, o = Be(r), fe = o + Be(s), me = new Uint8Array(fe + s);
  return Ke(r, me, 0), Ke(s, me, o), me.set(e, fe), new or(r, s, e, me);
};
class or {
  constructor(e, s, o, fe) {
    this.code = e, this.size = s, this.digest = o, this.bytes = fe;
  }
}
const Ve = ({ name: r, code: e, encode: s }) => new ar(r, e, s);
class ar {
  constructor(e, s, o) {
    this.name = e, this.code = s, this.encode = o;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const s = this.encode(e);
      return s instanceof Uint8Array ? ce$1(this.code, s) : s.then((o) => ce$1(this.code, o));
    } else
      throw Error("Unknown type, must be binary type");
  }
}
const je = (r) => async (e) => new Uint8Array(await crypto.subtle.digest(r, e)), hr = Ve({ name: "sha2-256", code: 18, encode: je("SHA-256") }), cr = Ve({ name: "sha2-512", code: 19, encode: je("SHA-512") });
var ur = Object.freeze({ __proto__: null, sha256: hr, sha512: cr });
const qe = 0, lr = "identity", Ge = Ne, dr = (r) => ce$1(qe, Ge(r)), gr = { code: qe, name: lr, encode: Ge, digest: dr };
var pr = Object.freeze({ __proto__: null, identity: gr });
new TextEncoder(), new TextDecoder();
const Ye = { ...os$1, ...hs$1, ...us$1, ...ds$1, ...Ds, ...Rs, ...Ts, ...Os, ...Ls, ...Bs };
({ ...ur, ...pr });
function He(r) {
  return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}
function Dr(r = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? He(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}
function Je(r, e, s, o) {
  return { name: r, prefix: e, encoder: { name: r, prefix: e, encode: s }, decoder: { decode: o } };
}
const Xe = Je("utf8", "u", (r) => "u" + new TextDecoder("utf8").decode(r), (r) => new TextEncoder().encode(r.substring(1))), ue$1 = Je("ascii", "a", (r) => {
  let e = "a";
  for (let s = 0; s < r.length; s++)
    e += String.fromCharCode(r[s]);
  return e;
}, (r) => {
  r = r.substring(1);
  const e = Dr(r.length);
  for (let s = 0; s < r.length; s++)
    e[s] = r.charCodeAt(s);
  return e;
}), yr = { utf8: Xe, "utf-8": Xe, hex: Ye.base16, latin1: ue$1, ascii: ue$1, binary: ue$1, ...Ye };
function mr(r, e = "utf8") {
  const s = yr[e];
  if (!s)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? He(globalThis.Buffer.from(r, "utf-8")) : s.decoder.decode(`${s.prefix}${r}`);
}
const le$1 = "wc", We = 2, Q$1 = "core", O = `${le$1}@2:${Q$1}:`, Qe = { name: Q$1, logger: "error" }, Ze = { database: ":memory:" }, et = "crypto", de$1 = "client_ed25519_seed", tt = cjs$4.ONE_DAY, it = "keychain", st = "0.3", rt = "messages", nt = "0.3", ot = cjs$4.SIX_HOURS, at = "publisher", ht = "irn", ct = "error", ge = "wss://relay.walletconnect.com", pe$1 = "wss://relay.walletconnect.org", ut = "relayer", D = { message: "relayer_message", message_ack: "relayer_message_ack", connect: "relayer_connect", disconnect: "relayer_disconnect", error: "relayer_error", connection_stalled: "relayer_connection_stalled", transport_closed: "relayer_transport_closed", publish: "relayer_publish" }, lt = "_subscription", P = { payload: "payload", connect: "connect", disconnect: "disconnect", error: "error" }, dt = cjs$4.ONE_SECOND, gt = "2.11.0", pt = 1e4, Dt = "0.3", yt = "WALLETCONNECT_CLIENT_ID", w = { created: "subscription_created", deleted: "subscription_deleted", expired: "subscription_expired", disabled: "subscription_disabled", sync: "subscription_sync", resubscribed: "subscription_resubscribed" }, mt = "subscription", bt = "0.3", ft = cjs$4.FIVE_SECONDS * 1e3, Et = "pairing", wt = "0.3", F$1 = { wc_pairingDelete: { req: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1e3 }, res: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1001 } }, wc_pairingPing: { req: { ttl: cjs$4.THIRTY_SECONDS, prompt: !1, tag: 1002 }, res: { ttl: cjs$4.THIRTY_SECONDS, prompt: !1, tag: 1003 } }, unregistered_method: { req: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 0 }, res: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 0 } } }, V$1 = { create: "pairing_create", expire: "pairing_expire", delete: "pairing_delete", ping: "pairing_ping" }, R = { created: "history_created", updated: "history_updated", deleted: "history_deleted", sync: "history_sync" }, vt = "history", It = "0.3", Ct = "expirer", v = { created: "expirer_created", deleted: "expirer_deleted", expired: "expirer_expired", sync: "expirer_sync" }, Rt = "0.3", Z = "verify-api", $ = "https://verify.walletconnect.com", ee = "https://verify.walletconnect.org", _t = [$, ee], St = "echo", Tt = "https://echo.walletconnect.com";
class Pt {
  constructor(e, s) {
    this.core = e, this.logger = s, this.keychain = /* @__PURE__ */ new Map(), this.name = it, this.version = st, this.initialized = !1, this.storagePrefix = O, this.init = async () => {
      if (!this.initialized) {
        const o = await this.getKeyChain();
        typeof o < "u" && (this.keychain = o), this.initialized = !0;
      }
    }, this.has = (o) => (this.isInitialized(), this.keychain.has(o)), this.set = async (o, fe) => {
      this.isInitialized(), this.keychain.set(o, fe), await this.persist();
    }, this.get = (o) => {
      this.isInitialized();
      const fe = this.keychain.get(o);
      if (typeof fe > "u") {
        const { message: me } = N("NO_MATCHING_KEY", `${this.name}: ${o}`);
        throw new Error(me);
      }
      return fe;
    }, this.del = async (o) => {
      this.isInitialized(), this.keychain.delete(o), await this.persist();
    }, this.core = e, this.logger = cjs$3.generateChildLogger(s, this.name);
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setKeyChain(e) {
    await this.core.storage.setItem(this.storageKey, rt$1(e));
  }
  async getKeyChain() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? ot$1(e) : void 0;
  }
  async persist() {
    await this.setKeyChain(this.keychain);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class xt {
  constructor(e, s, o) {
    this.core = e, this.logger = s, this.name = et, this.initialized = !1, this.init = async () => {
      this.initialized || (await this.keychain.init(), this.initialized = !0);
    }, this.hasKeys = (fe) => (this.isInitialized(), this.keychain.has(fe)), this.getClientId = async () => {
      this.isInitialized();
      const fe = await this.getClientSeed(), me = generateKeyPair(fe);
      return encodeIss(me.publicKey);
    }, this.generateKeyPair = () => {
      this.isInitialized();
      const fe = kn();
      return this.setPrivateKey(fe.publicKey, fe.privateKey);
    }, this.signJWT = async (fe) => {
      this.isInitialized();
      const me = await this.getClientSeed(), ye = generateKeyPair(me), fr = Vn();
      return await signJWT(fr, fe, tt, ye);
    }, this.generateSharedKey = (fe, me, ye) => {
      this.isInitialized();
      const fr = this.getPrivateKey(fe), Er = Mn(fr, me);
      return this.setSymKey(Er, ye);
    }, this.setSymKey = async (fe, me) => {
      this.isInitialized();
      const ye = me || Kn(fe);
      return await this.keychain.set(ye, fe), ye;
    }, this.deleteKeyPair = async (fe) => {
      this.isInitialized(), await this.keychain.del(fe);
    }, this.deleteSymKey = async (fe) => {
      this.isInitialized(), await this.keychain.del(fe);
    }, this.encode = async (fe, me, ye) => {
      this.isInitialized();
      const fr = Ae(ye), Er = safeJsonStringify(me);
      if (qn(fr)) {
        const Gr = fr.senderPublicKey, Vr = fr.receiverPublicKey;
        fe = await this.generateSharedKey(Gr, Vr);
      }
      const br = this.getSymKey(fe), { type: wr, senderPublicKey: kr } = fr;
      return xn({ type: wr, symKey: br, message: Er, senderPublicKey: kr });
    }, this.decode = async (fe, me, ye) => {
      this.isInitialized();
      const fr = Hn(me, ye);
      if (qn(fr)) {
        const Er = fr.receiverPublicKey, br = fr.senderPublicKey;
        fe = await this.generateSharedKey(Er, br);
      }
      try {
        const Er = this.getSymKey(fe), br = Fn({ symKey: Er, encoded: me });
        return safeJsonParse(br);
      } catch (Er) {
        this.logger.error(`Failed to decode message from topic: '${fe}', clientId: '${await this.getClientId()}'`), this.logger.error(Er);
      }
    }, this.getPayloadType = (fe) => {
      const me = ee$1(fe);
      return $$1(me.type);
    }, this.getPayloadSenderPublicKey = (fe) => {
      const me = ee$1(fe);
      return me.senderPublicKey ? toString$1(me.senderPublicKey, p) : void 0;
    }, this.core = e, this.logger = cjs$3.generateChildLogger(s, this.name), this.keychain = o || new Pt(this.core, this.logger);
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  async setPrivateKey(e, s) {
    return await this.keychain.set(e, s), e;
  }
  getPrivateKey(e) {
    return this.keychain.get(e);
  }
  async getClientSeed() {
    let e = "";
    try {
      e = this.keychain.get(de$1);
    } catch {
      e = Vn(), await this.keychain.set(de$1, e);
    }
    return mr(e, "base16");
  }
  getSymKey(e) {
    return this.keychain.get(e);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class Ot extends a$1 {
  constructor(e, s) {
    super(e, s), this.logger = e, this.core = s, this.messages = /* @__PURE__ */ new Map(), this.name = rt, this.version = nt, this.initialized = !1, this.storagePrefix = O, this.init = async () => {
      if (!this.initialized) {
        this.logger.trace("Initialized");
        try {
          const o = await this.getRelayerMessages();
          typeof o < "u" && (this.messages = o), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", size: this.messages.size });
        } catch (o) {
          this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(o);
        } finally {
          this.initialized = !0;
        }
      }
    }, this.set = async (o, fe) => {
      this.isInitialized();
      const me = Ln(fe);
      let ye = this.messages.get(o);
      return typeof ye > "u" && (ye = {}), typeof ye[me] < "u" || (ye[me] = fe, this.messages.set(o, ye), await this.persist()), me;
    }, this.get = (o) => {
      this.isInitialized();
      let fe = this.messages.get(o);
      return typeof fe > "u" && (fe = {}), fe;
    }, this.has = (o, fe) => {
      this.isInitialized();
      const me = this.get(o), ye = Ln(fe);
      return typeof me[ye] < "u";
    }, this.del = async (o) => {
      this.isInitialized(), this.messages.delete(o), await this.persist();
    }, this.logger = cjs$3.generateChildLogger(e, this.name), this.core = s;
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setRelayerMessages(e) {
    await this.core.storage.setItem(this.storageKey, rt$1(e));
  }
  async getRelayerMessages() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? ot$1(e) : void 0;
  }
  async persist() {
    await this.setRelayerMessages(this.messages);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class vr extends u {
  constructor(e, s) {
    super(e, s), this.relayer = e, this.logger = s, this.events = new events.exports.EventEmitter(), this.name = at, this.queue = /* @__PURE__ */ new Map(), this.publishTimeout = cjs$4.toMiliseconds(cjs$4.TEN_SECONDS), this.needsTransportRestart = !1, this.publish = async (o, fe, me) => {
      var ye;
      this.logger.debug("Publishing Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: o, message: fe, opts: me } });
      try {
        const fr = (me == null ? void 0 : me.ttl) || ot, Er = vt$1(me), br = (me == null ? void 0 : me.prompt) || !1, wr = (me == null ? void 0 : me.tag) || 0, kr = (me == null ? void 0 : me.id) || getBigIntRpcId().toString(), Gr = { topic: o, message: fe, opts: { ttl: fr, relay: Er, prompt: br, tag: wr, id: kr } }, Vr = setTimeout(() => this.queue.set(kr, Gr), this.publishTimeout);
        try {
          await await ut$1(this.rpcPublish(o, fe, fr, Er, br, wr, kr), this.publishTimeout, "Failed to publish payload, please try again."), this.removeRequestFromQueue(kr), this.relayer.events.emit(D.publish, Gr);
        } catch (jr) {
          if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (ye = me == null ? void 0 : me.internal) != null && ye.throwOnFailedPublish)
            throw this.removeRequestFromQueue(kr), jr;
          return;
        } finally {
          clearTimeout(Vr);
        }
        this.logger.debug("Successfully Published Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: o, message: fe, opts: me } });
      } catch (fr) {
        throw this.logger.debug("Failed to Publish Payload"), this.logger.error(fr), fr;
      }
    }, this.on = (o, fe) => {
      this.events.on(o, fe);
    }, this.once = (o, fe) => {
      this.events.once(o, fe);
    }, this.off = (o, fe) => {
      this.events.off(o, fe);
    }, this.removeListener = (o, fe) => {
      this.events.removeListener(o, fe);
    }, this.relayer = e, this.logger = cjs$3.generateChildLogger(s, this.name), this.registerEventListeners();
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  rpcPublish(e, s, o, fe, me, ye, fr) {
    var Er, br, wr, kr;
    const Gr = { method: Et$1(fe.protocol).publish, params: { topic: e, message: s, ttl: o, prompt: me, tag: ye }, id: fr };
    return w$2((Er = Gr.params) == null ? void 0 : Er.prompt) && ((br = Gr.params) == null || delete br.prompt), w$2((wr = Gr.params) == null ? void 0 : wr.tag) && ((kr = Gr.params) == null || delete kr.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "message", direction: "outgoing", request: Gr }), this.relayer.request(Gr);
  }
  removeRequestFromQueue(e) {
    this.queue.delete(e);
  }
  checkQueue() {
    this.queue.forEach(async (e) => {
      const { topic: s, message: o, opts: fe } = e;
      await this.publish(s, o, fe);
    });
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(cjs$5.HEARTBEAT_EVENTS.pulse, () => {
      if (this.needsTransportRestart) {
        this.needsTransportRestart = !1, this.relayer.events.emit(D.connection_stalled);
        return;
      }
      this.checkQueue();
    }), this.relayer.on(D.message_ack, (e) => {
      this.removeRequestFromQueue(e.id.toString());
    });
  }
}
class Ir {
  constructor() {
    this.map = /* @__PURE__ */ new Map(), this.set = (e, s) => {
      const o = this.get(e);
      this.exists(e, s) || this.map.set(e, [...o, s]);
    }, this.get = (e) => this.map.get(e) || [], this.exists = (e, s) => this.get(e).includes(s), this.delete = (e, s) => {
      if (typeof s > "u") {
        this.map.delete(e);
        return;
      }
      if (!this.map.has(e))
        return;
      const o = this.get(e);
      if (!this.exists(e, s))
        return;
      const fe = o.filter((me) => me !== s);
      if (!fe.length) {
        this.map.delete(e);
        return;
      }
      this.map.set(e, fe);
    }, this.clear = () => {
      this.map.clear();
    };
  }
  get topics() {
    return Array.from(this.map.keys());
  }
}
var Cr = Object.defineProperty, Rr = Object.defineProperties, _r = Object.getOwnPropertyDescriptors, At = Object.getOwnPropertySymbols, Sr = Object.prototype.hasOwnProperty, Tr = Object.prototype.propertyIsEnumerable, zt = (r, e, s) => e in r ? Cr(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, j = (r, e) => {
  for (var s in e || (e = {}))
    Sr.call(e, s) && zt(r, s, e[s]);
  if (At)
    for (var s of At(e))
      Tr.call(e, s) && zt(r, s, e[s]);
  return r;
}, De = (r, e) => Rr(r, _r(e));
class Nt extends d {
  constructor(e, s) {
    super(e, s), this.relayer = e, this.logger = s, this.subscriptions = /* @__PURE__ */ new Map(), this.topicMap = new Ir(), this.events = new events.exports.EventEmitter(), this.name = mt, this.version = bt, this.pending = /* @__PURE__ */ new Map(), this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = O, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
    }, this.subscribe = async (o, fe) => {
      await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: o, opts: fe } });
      try {
        const me = vt$1(fe), ye = { topic: o, relay: me };
        this.pending.set(o, ye);
        const fr = await this.rpcSubscribe(o, me);
        return this.onSubscribe(fr, ye), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: o, opts: fe } }), fr;
      } catch (me) {
        throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(me), me;
      }
    }, this.unsubscribe = async (o, fe) => {
      await this.restartToComplete(), this.isInitialized(), typeof (fe == null ? void 0 : fe.id) < "u" ? await this.unsubscribeById(o, fe.id, fe) : await this.unsubscribeByTopic(o, fe);
    }, this.isSubscribed = async (o) => this.topics.includes(o) ? !0 : await new Promise((fe, me) => {
      const ye = new cjs$4.Watch();
      ye.start(this.pendingSubscriptionWatchLabel);
      const fr = setInterval(() => {
        !this.pending.has(o) && this.topics.includes(o) && (clearInterval(fr), ye.stop(this.pendingSubscriptionWatchLabel), fe(!0)), ye.elapsed(this.pendingSubscriptionWatchLabel) >= ft && (clearInterval(fr), ye.stop(this.pendingSubscriptionWatchLabel), me(new Error("Subscription resolution timeout")));
      }, this.pollingInterval);
    }).catch(() => !1), this.on = (o, fe) => {
      this.events.on(o, fe);
    }, this.once = (o, fe) => {
      this.events.once(o, fe);
    }, this.off = (o, fe) => {
      this.events.off(o, fe);
    }, this.removeListener = (o, fe) => {
      this.events.removeListener(o, fe);
    }, this.restart = async () => {
      this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
    }, this.relayer = e, this.logger = cjs$3.generateChildLogger(s, this.name), this.clientId = "";
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.subscriptions.size;
  }
  get ids() {
    return Array.from(this.subscriptions.keys());
  }
  get values() {
    return Array.from(this.subscriptions.values());
  }
  get topics() {
    return this.topicMap.topics;
  }
  hasSubscription(e, s) {
    let o = !1;
    try {
      o = this.getSubscription(e).topic === s;
    } catch {
    }
    return o;
  }
  onEnable() {
    this.cached = [], this.initialized = !0;
  }
  onDisable() {
    this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
  }
  async unsubscribeByTopic(e, s) {
    const o = this.topicMap.get(e);
    await Promise.all(o.map(async (fe) => await this.unsubscribeById(e, fe, s)));
  }
  async unsubscribeById(e, s, o) {
    this.logger.debug("Unsubscribing Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: s, opts: o } });
    try {
      const fe = vt$1(o);
      await this.rpcUnsubscribe(e, s, fe);
      const me = U$1("USER_DISCONNECTED", `${this.name}, ${e}`);
      await this.onUnsubscribe(e, s, me), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: s, opts: o } });
    } catch (fe) {
      throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(fe), fe;
    }
  }
  async rpcSubscribe(e, s) {
    const o = { method: Et$1(s.protocol).subscribe, params: { topic: e } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: o });
    try {
      await await ut$1(this.relayer.request(o), this.subscribeTimeout);
    } catch {
      this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(D.connection_stalled);
    }
    return Ln(e + this.clientId);
  }
  async rpcBatchSubscribe(e) {
    if (!e.length)
      return;
    const s = e[0].relay, o = { method: Et$1(s.protocol).batchSubscribe, params: { topics: e.map((fe) => fe.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: o });
    try {
      return await await ut$1(this.relayer.request(o), this.subscribeTimeout);
    } catch {
      this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit(D.connection_stalled);
    }
  }
  rpcUnsubscribe(e, s, o) {
    const fe = { method: Et$1(o.protocol).unsubscribe, params: { topic: e, id: s } };
    return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: fe }), this.relayer.request(fe);
  }
  onSubscribe(e, s) {
    this.setSubscription(e, De(j({}, s), { id: e })), this.pending.delete(s.topic);
  }
  onBatchSubscribe(e) {
    e.length && e.forEach((s) => {
      this.setSubscription(s.id, j({}, s)), this.pending.delete(s.topic);
    });
  }
  async onUnsubscribe(e, s, o) {
    this.events.removeAllListeners(s), this.hasSubscription(s, e) && this.deleteSubscription(s, o), await this.relayer.messages.del(e);
  }
  async setRelayerSubscriptions(e) {
    await this.relayer.core.storage.setItem(this.storageKey, e);
  }
  async getRelayerSubscriptions() {
    return await this.relayer.core.storage.getItem(this.storageKey);
  }
  setSubscription(e, s) {
    this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({ type: "method", method: "setSubscription", id: e, subscription: s }), this.addSubscription(e, s));
  }
  addSubscription(e, s) {
    this.subscriptions.set(e, j({}, s)), this.topicMap.set(s.topic, e), this.events.emit(w.created, s);
  }
  getSubscription(e) {
    this.logger.debug("Getting subscription"), this.logger.trace({ type: "method", method: "getSubscription", id: e });
    const s = this.subscriptions.get(e);
    if (!s) {
      const { message: o } = N("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(o);
    }
    return s;
  }
  deleteSubscription(e, s) {
    this.logger.debug("Deleting subscription"), this.logger.trace({ type: "method", method: "deleteSubscription", id: e, reason: s });
    const o = this.getSubscription(e);
    this.subscriptions.delete(e), this.topicMap.delete(o.topic, e), this.events.emit(w.deleted, De(j({}, o), { reason: s }));
  }
  async persist() {
    await this.setRelayerSubscriptions(this.values), this.events.emit(w.sync);
  }
  async reset() {
    if (this.cached.length) {
      const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
      for (let s = 0; s < e; s++) {
        const o = this.cached.splice(0, this.batchSubscribeTopicsLimit);
        await this.batchSubscribe(o);
      }
    }
    this.events.emit(w.resubscribed);
  }
  async restore() {
    try {
      const e = await this.getRelayerSubscriptions();
      if (typeof e > "u" || !e.length)
        return;
      if (this.subscriptions.size) {
        const { message: s } = N("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(s), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(s);
      }
      this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({ type: "method", method: "restore", subscriptions: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
    }
  }
  async batchSubscribe(e) {
    if (!e.length)
      return;
    const s = await this.rpcBatchSubscribe(e);
    k(s) && this.onBatchSubscribe(s.map((o, fe) => De(j({}, e[fe]), { id: o })));
  }
  async onConnect() {
    this.restartInProgress || (await this.restart(), this.onEnable());
  }
  onDisconnect() {
    this.onDisable();
  }
  async checkPending() {
    if (!this.initialized || this.relayer.transportExplicitlyClosed)
      return;
    const e = [];
    this.pending.forEach((s) => {
      e.push(s);
    }), await this.batchSubscribe(e);
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(cjs$5.HEARTBEAT_EVENTS.pulse, async () => {
      await this.checkPending();
    }), this.relayer.on(D.connect, async () => {
      await this.onConnect();
    }), this.relayer.on(D.disconnect, () => {
      this.onDisconnect();
    }), this.events.on(w.created, async (e) => {
      const s = w.created;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, data: e }), await this.persist();
    }), this.events.on(w.deleted, async (e) => {
      const s = w.deleted;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, data: e }), await this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async restartToComplete() {
    this.restartInProgress && await new Promise((e) => {
      const s = setInterval(() => {
        this.restartInProgress || (clearInterval(s), e());
      }, this.pollingInterval);
    });
  }
}
var Pr = Object.defineProperty, Ut = Object.getOwnPropertySymbols, xr = Object.prototype.hasOwnProperty, Or = Object.prototype.propertyIsEnumerable, Lt = (r, e, s) => e in r ? Pr(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, Ar = (r, e) => {
  for (var s in e || (e = {}))
    xr.call(e, s) && Lt(r, s, e[s]);
  if (Ut)
    for (var s of Ut(e))
      Or.call(e, s) && Lt(r, s, e[s]);
  return r;
};
class Ft extends g$2 {
  constructor(e) {
    super(e), this.protocol = "wc", this.version = 2, this.events = new events.exports.EventEmitter(), this.name = ut, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = ["socket hang up", "socket stalled"], this.hasExperiencedNetworkDisruption = !1, this.request = async (s) => {
      this.logger.debug("Publishing Request Payload");
      try {
        return await this.toEstablishConnection(), await this.provider.request(s);
      } catch (o) {
        throw this.logger.debug("Failed to Publish Request"), this.logger.error(o), o;
      }
    }, this.onPayloadHandler = (s) => {
      this.onProviderPayload(s);
    }, this.onConnectHandler = () => {
      this.events.emit(D.connect);
    }, this.onDisconnectHandler = () => {
      this.onProviderDisconnect();
    }, this.onProviderErrorHandler = (s) => {
      this.logger.error(s), this.events.emit(D.error, s), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
    }, this.registerProviderListeners = () => {
      this.provider.on(P.payload, this.onPayloadHandler), this.provider.on(P.connect, this.onConnectHandler), this.provider.on(P.disconnect, this.onDisconnectHandler), this.provider.on(P.error, this.onProviderErrorHandler);
    }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? cjs$3.generateChildLogger(e.logger, this.name) : cjs$3.pino(cjs$3.getDefaultLoggerOptions({ level: e.logger || ct })), this.messages = new Ot(this.logger, e.core), this.subscriber = new Nt(this, this.logger), this.publisher = new vr(this, this.logger), this.relayUrl = (e == null ? void 0 : e.relayUrl) || ge, this.projectId = e.projectId, this.bundleId = Jn(), this.provider = {};
  }
  async init() {
    this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([this.messages.init(), this.subscriber.init()]);
    try {
      await this.transportOpen();
    } catch {
      this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${pe$1}...`), await this.restartTransport(pe$1);
    }
    this.initialized = !0, setTimeout(async () => {
      this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
    }, pt);
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get connected() {
    return this.provider.connection.connected;
  }
  get connecting() {
    return this.provider.connection.connecting;
  }
  async publish(e, s, o) {
    this.isInitialized(), await this.publisher.publish(e, s, o), await this.recordMessageEvent({ topic: e, message: s, publishedAt: Date.now() });
  }
  async subscribe(e, s) {
    var o;
    this.isInitialized();
    let fe = ((o = this.subscriber.topicMap.get(e)) == null ? void 0 : o[0]) || "";
    if (fe)
      return fe;
    let me;
    const ye = (fr) => {
      fr.topic === e && (this.subscriber.off(w.created, ye), me());
    };
    return await Promise.all([new Promise((fr) => {
      me = fr, this.subscriber.on(w.created, ye);
    }), new Promise(async (fr) => {
      fe = await this.subscriber.subscribe(e, s), fr();
    })]), fe;
  }
  async unsubscribe(e, s) {
    this.isInitialized(), await this.subscriber.unsubscribe(e, s);
  }
  on(e, s) {
    this.events.on(e, s);
  }
  once(e, s) {
    this.events.once(e, s);
  }
  off(e, s) {
    this.events.off(e, s);
  }
  removeListener(e, s) {
    this.events.removeListener(e, s);
  }
  async transportClose() {
    this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await ut$1(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(() => this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
  }
  async transportOpen(e) {
    if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
      e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
      try {
        await Promise.all([new Promise((s) => {
          if (!this.initialized)
            return s();
          this.subscriber.once(w.resubscribed, () => {
            s();
          });
        }), new Promise(async (s, o) => {
          try {
            await ut$1(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
          } catch (fe) {
            o(fe);
            return;
          }
          s();
        })]);
      } catch (s) {
        this.logger.error(s);
        const o = s;
        if (!this.isConnectionStalled(o.message))
          throw s;
        this.provider.events.emit(P.disconnect);
      } finally {
        this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
      }
    }
  }
  async restartTransport(e) {
    await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
  }
  async confirmOnlineStateOrThrow() {
    if (!await er$1())
      throw new Error("No internet connection detected. Please restart your network and try again.");
  }
  isConnectionStalled(e) {
    return this.staleConnectionErrors.some((s) => e.includes(s));
  }
  async createProvider() {
    this.provider.connection && this.unregisterProviderListeners();
    const e = await this.core.crypto.signJWT(this.relayUrl);
    this.provider = new JsonRpcProvider(new f(Xn({ sdkVersion: gt, protocol: this.protocol, version: this.version, relayUrl: this.relayUrl, projectId: this.projectId, auth: e, useOnCloseEvent: !0, bundleId: this.bundleId }))), this.registerProviderListeners();
  }
  async recordMessageEvent(e) {
    const { topic: s, message: o } = e;
    await this.messages.set(s, o);
  }
  async shouldIgnoreMessageEvent(e) {
    const { topic: s, message: o } = e;
    if (!o || o.length === 0)
      return this.logger.debug(`Ignoring invalid/empty message: ${o}`), !0;
    if (!await this.subscriber.isSubscribed(s))
      return this.logger.debug(`Ignoring message for non-subscribed topic ${s}`), !0;
    const fe = this.messages.has(s, o);
    return fe && this.logger.debug(`Ignoring duplicate message: ${o}`), fe;
  }
  async onProviderPayload(e) {
    if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({ type: "payload", direction: "incoming", payload: e }), isJsonRpcRequest(e)) {
      if (!e.method.endsWith(lt))
        return;
      const s = e.params, { topic: o, message: fe, publishedAt: me } = s.data, ye = { topic: o, message: fe, publishedAt: me };
      this.logger.debug("Emitting Relayer Payload"), this.logger.trace(Ar({ type: "event", event: s.id }, ye)), this.events.emit(s.id, ye), await this.acknowledgePayload(e), await this.onMessageEvent(ye);
    } else
      isJsonRpcResponse(e) && this.events.emit(D.message_ack, e);
  }
  async onMessageEvent(e) {
    await this.shouldIgnoreMessageEvent(e) || (this.events.emit(D.message, e), await this.recordMessageEvent(e));
  }
  async acknowledgePayload(e) {
    const s = formatJsonRpcResult(e.id, !0);
    await this.provider.connection.send(s);
  }
  unregisterProviderListeners() {
    this.provider.off(P.payload, this.onPayloadHandler), this.provider.off(P.connect, this.onConnectHandler), this.provider.off(P.disconnect, this.onDisconnectHandler), this.provider.off(P.error, this.onProviderErrorHandler);
  }
  async registerEventListeners() {
    this.events.on(D.connection_stalled, () => {
      this.restartTransport().catch((s) => this.logger.error(s));
    });
    let e = await er$1();
    nr$1(async (s) => {
      this.initialized && e !== s && (e = s, s ? await this.restartTransport().catch((o) => this.logger.error(o)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((o) => this.logger.error(o))));
    });
  }
  onProviderDisconnect() {
    this.events.emit(D.disconnect), this.attemptToReconnect();
  }
  attemptToReconnect() {
    this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async () => {
      await this.restartTransport().catch((e) => this.logger.error(e));
    }, cjs$4.toMiliseconds(dt)));
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async toEstablishConnection() {
    if (await this.confirmOnlineStateOrThrow(), !this.connected) {
      if (this.connectionAttemptInProgress)
        return await new Promise((e) => {
          const s = setInterval(() => {
            this.connected && (clearInterval(s), e());
          }, this.connectionStatusPollingInterval);
        });
      await this.restartTransport();
    }
  }
}
var zr = Object.defineProperty, $t = Object.getOwnPropertySymbols, Nr = Object.prototype.hasOwnProperty, Ur = Object.prototype.propertyIsEnumerable, Mt = (r, e, s) => e in r ? zr(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, kt = (r, e) => {
  for (var s in e || (e = {}))
    Nr.call(e, s) && Mt(r, s, e[s]);
  if ($t)
    for (var s of $t(e))
      Ur.call(e, s) && Mt(r, s, e[s]);
  return r;
};
class Kt extends p$1 {
  constructor(e, s, o, fe = O, me = void 0) {
    super(e, s, o, fe), this.core = e, this.logger = s, this.name = o, this.map = /* @__PURE__ */ new Map(), this.version = Dt, this.cached = [], this.initialized = !1, this.storagePrefix = O, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((ye) => {
        this.getKey && ye !== null && !w$2(ye) ? this.map.set(this.getKey(ye), ye) : Vt$1(ye) ? this.map.set(ye.id, ye) : Mt$1(ye) && this.map.set(ye.topic, ye);
      }), this.cached = [], this.initialized = !0);
    }, this.set = async (ye, fr) => {
      this.isInitialized(), this.map.has(ye) ? await this.update(ye, fr) : (this.logger.debug("Setting value"), this.logger.trace({ type: "method", method: "set", key: ye, value: fr }), this.map.set(ye, fr), await this.persist());
    }, this.get = (ye) => (this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({ type: "method", method: "get", key: ye }), this.getData(ye)), this.getAll = (ye) => (this.isInitialized(), ye ? this.values.filter((fr) => Object.keys(ye).every((Er) => Gi(fr[Er], ye[Er]))) : this.values), this.update = async (ye, fr) => {
      this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({ type: "method", method: "update", key: ye, update: fr });
      const Er = kt(kt({}, this.getData(ye)), fr);
      this.map.set(ye, Er), await this.persist();
    }, this.delete = async (ye, fr) => {
      this.isInitialized(), this.map.has(ye) && (this.logger.debug("Deleting value"), this.logger.trace({ type: "method", method: "delete", key: ye, reason: fr }), this.map.delete(ye), await this.persist());
    }, this.logger = cjs$3.generateChildLogger(s, this.name), this.storagePrefix = fe, this.getKey = me;
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.map.size;
  }
  get keys() {
    return Array.from(this.map.keys());
  }
  get values() {
    return Array.from(this.map.values());
  }
  async setDataStore(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getDataStore() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getData(e) {
    const s = this.map.get(e);
    if (!s) {
      const { message: o } = N("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(o), new Error(o);
    }
    return s;
  }
  async persist() {
    await this.setDataStore(this.values);
  }
  async restore() {
    try {
      const e = await this.getDataStore();
      if (typeof e > "u" || !e.length)
        return;
      if (this.map.size) {
        const { message: s } = N("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(s), new Error(s);
      }
      this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({ type: "method", method: "restore", value: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class Bt {
  constructor(e, s) {
    this.core = e, this.logger = s, this.name = Et, this.version = wt, this.events = new events.exports(), this.initialized = !1, this.storagePrefix = O, this.ignoredPayloadTypes = [_], this.registeredMethods = [], this.init = async () => {
      this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
    }, this.register = ({ methods: o }) => {
      this.isInitialized(), this.registeredMethods = [.../* @__PURE__ */ new Set([...this.registeredMethods, ...o])];
    }, this.create = async () => {
      this.isInitialized();
      const o = Vn(), fe = await this.core.crypto.setSymKey(o), me = pt$1(cjs$4.FIVE_MINUTES), ye = { protocol: ht }, fr = { topic: fe, expiry: me, relay: ye, active: !1 }, Er = It$1({ protocol: this.core.protocol, version: this.core.version, topic: fe, symKey: o, relay: ye });
      return await this.pairings.set(fe, fr), await this.core.relayer.subscribe(fe), this.core.expirer.set(fe, me), { topic: fe, uri: Er };
    }, this.pair = async (o) => {
      this.isInitialized(), this.isValidPair(o);
      const { topic: fe, symKey: me, relay: ye } = wt$1(o.uri);
      let fr;
      if (this.pairings.keys.includes(fe) && (fr = this.pairings.get(fe), fr.active))
        throw new Error(`Pairing already exists: ${fe}. Please try again with a new connection URI.`);
      const Er = pt$1(cjs$4.FIVE_MINUTES), br = { topic: fe, relay: ye, expiry: Er, active: !1 };
      return await this.pairings.set(fe, br), this.core.expirer.set(fe, Er), o.activatePairing && await this.activate({ topic: fe }), this.events.emit(V$1.create, br), this.core.crypto.keychain.has(fe) || (await this.core.crypto.setSymKey(me, fe), await this.core.relayer.subscribe(fe, { relay: ye })), br;
    }, this.activate = async ({ topic: o }) => {
      this.isInitialized();
      const fe = pt$1(cjs$4.THIRTY_DAYS);
      await this.pairings.update(o, { active: !0, expiry: fe }), this.core.expirer.set(o, fe);
    }, this.ping = async (o) => {
      this.isInitialized(), await this.isValidPing(o);
      const { topic: fe } = o;
      if (this.pairings.keys.includes(fe)) {
        const me = await this.sendRequest(fe, "wc_pairingPing", {}), { done: ye, resolve: fr, reject: Er } = at$1();
        this.events.once(yt$1("pairing_ping", me), ({ error: br }) => {
          br ? Er(br) : fr();
        }), await ye();
      }
    }, this.updateExpiry = async ({ topic: o, expiry: fe }) => {
      this.isInitialized(), await this.pairings.update(o, { expiry: fe });
    }, this.updateMetadata = async ({ topic: o, metadata: fe }) => {
      this.isInitialized(), await this.pairings.update(o, { peerMetadata: fe });
    }, this.getPairings = () => (this.isInitialized(), this.pairings.values), this.disconnect = async (o) => {
      this.isInitialized(), await this.isValidDisconnect(o);
      const { topic: fe } = o;
      this.pairings.keys.includes(fe) && (await this.sendRequest(fe, "wc_pairingDelete", U$1("USER_DISCONNECTED")), await this.deletePairing(fe));
    }, this.sendRequest = async (o, fe, me) => {
      const ye = formatJsonRpcRequest(fe, me), fr = await this.core.crypto.encode(o, ye), Er = F$1[fe].req;
      return this.core.history.set(o, ye), this.core.relayer.publish(o, fr, Er), ye.id;
    }, this.sendResult = async (o, fe, me) => {
      const ye = formatJsonRpcResult(o, me), fr = await this.core.crypto.encode(fe, ye), Er = await this.core.history.get(fe, o), br = F$1[Er.request.method].res;
      await this.core.relayer.publish(fe, fr, br), await this.core.history.resolve(ye);
    }, this.sendError = async (o, fe, me) => {
      const ye = formatJsonRpcError(o, me), fr = await this.core.crypto.encode(fe, ye), Er = await this.core.history.get(fe, o), br = F$1[Er.request.method] ? F$1[Er.request.method].res : F$1.unregistered_method.res;
      await this.core.relayer.publish(fe, fr, br), await this.core.history.resolve(ye);
    }, this.deletePairing = async (o, fe) => {
      await this.core.relayer.unsubscribe(o), await Promise.all([this.pairings.delete(o, U$1("USER_DISCONNECTED")), this.core.crypto.deleteSymKey(o), fe ? Promise.resolve() : this.core.expirer.del(o)]);
    }, this.cleanup = async () => {
      const o = this.pairings.getAll().filter((fe) => mt$1(fe.expiry));
      await Promise.all(o.map((fe) => this.deletePairing(fe.topic)));
    }, this.onRelayEventRequest = (o) => {
      const { topic: fe, payload: me } = o;
      switch (me.method) {
        case "wc_pairingPing":
          return this.onPairingPingRequest(fe, me);
        case "wc_pairingDelete":
          return this.onPairingDeleteRequest(fe, me);
        default:
          return this.onUnknownRpcMethodRequest(fe, me);
      }
    }, this.onRelayEventResponse = async (o) => {
      const { topic: fe, payload: me } = o, ye = (await this.core.history.get(fe, me.id)).request.method;
      switch (ye) {
        case "wc_pairingPing":
          return this.onPairingPingResponse(fe, me);
        default:
          return this.onUnknownRpcMethodResponse(ye);
      }
    }, this.onPairingPingRequest = async (o, fe) => {
      const { id: me } = fe;
      try {
        this.isValidPing({ topic: o }), await this.sendResult(me, o, !0), this.events.emit(V$1.ping, { id: me, topic: o });
      } catch (ye) {
        await this.sendError(me, o, ye), this.logger.error(ye);
      }
    }, this.onPairingPingResponse = (o, fe) => {
      const { id: me } = fe;
      setTimeout(() => {
        isJsonRpcResult(fe) ? this.events.emit(yt$1("pairing_ping", me), {}) : isJsonRpcError(fe) && this.events.emit(yt$1("pairing_ping", me), { error: fe.error });
      }, 500);
    }, this.onPairingDeleteRequest = async (o, fe) => {
      const { id: me } = fe;
      try {
        this.isValidDisconnect({ topic: o }), await this.deletePairing(o), this.events.emit(V$1.delete, { id: me, topic: o });
      } catch (ye) {
        await this.sendError(me, o, ye), this.logger.error(ye);
      }
    }, this.onUnknownRpcMethodRequest = async (o, fe) => {
      const { id: me, method: ye } = fe;
      try {
        if (this.registeredMethods.includes(ye))
          return;
        const fr = U$1("WC_METHOD_UNSUPPORTED", ye);
        await this.sendError(me, o, fr), this.logger.error(fr);
      } catch (fr) {
        await this.sendError(me, o, fr), this.logger.error(fr);
      }
    }, this.onUnknownRpcMethodResponse = (o) => {
      this.registeredMethods.includes(o) || this.logger.error(U$1("WC_METHOD_UNSUPPORTED", o));
    }, this.isValidPair = (o) => {
      var fe;
      if (!Ht$1(o)) {
        const { message: ye } = N("MISSING_OR_INVALID", `pair() params: ${o}`);
        throw new Error(ye);
      }
      if (!kt$1(o.uri)) {
        const { message: ye } = N("MISSING_OR_INVALID", `pair() uri: ${o.uri}`);
        throw new Error(ye);
      }
      const me = wt$1(o.uri);
      if (!((fe = me == null ? void 0 : me.relay) != null && fe.protocol)) {
        const { message: ye } = N("MISSING_OR_INVALID", "pair() uri#relay-protocol");
        throw new Error(ye);
      }
      if (!(me != null && me.symKey)) {
        const { message: ye } = N("MISSING_OR_INVALID", "pair() uri#symKey");
        throw new Error(ye);
      }
    }, this.isValidPing = async (o) => {
      if (!Ht$1(o)) {
        const { message: me } = N("MISSING_OR_INVALID", `ping() params: ${o}`);
        throw new Error(me);
      }
      const { topic: fe } = o;
      await this.isValidPairingTopic(fe);
    }, this.isValidDisconnect = async (o) => {
      if (!Ht$1(o)) {
        const { message: me } = N("MISSING_OR_INVALID", `disconnect() params: ${o}`);
        throw new Error(me);
      }
      const { topic: fe } = o;
      await this.isValidPairingTopic(fe);
    }, this.isValidPairingTopic = async (o) => {
      if (!h$1(o, !1)) {
        const { message: fe } = N("MISSING_OR_INVALID", `pairing topic should be a string: ${o}`);
        throw new Error(fe);
      }
      if (!this.pairings.keys.includes(o)) {
        const { message: fe } = N("NO_MATCHING_KEY", `pairing topic doesn't exist: ${o}`);
        throw new Error(fe);
      }
      if (mt$1(this.pairings.get(o).expiry)) {
        await this.deletePairing(o);
        const { message: fe } = N("EXPIRED", `pairing topic: ${o}`);
        throw new Error(fe);
      }
    }, this.core = e, this.logger = cjs$3.generateChildLogger(s, this.name), this.pairings = new Kt(this.core, this.logger, this.name, this.storagePrefix);
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  registerRelayerEvents() {
    this.core.relayer.on(D.message, async (e) => {
      const { topic: s, message: o } = e;
      if (!this.pairings.keys.includes(s) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(o)))
        return;
      const fe = await this.core.crypto.decode(s, o);
      try {
        isJsonRpcRequest(fe) ? (this.core.history.set(s, fe), this.onRelayEventRequest({ topic: s, payload: fe })) : isJsonRpcResponse(fe) && (await this.core.history.resolve(fe), await this.onRelayEventResponse({ topic: s, payload: fe }), this.core.history.delete(s, fe.id));
      } catch (me) {
        this.logger.error(me);
      }
    });
  }
  registerExpirerEvents() {
    this.core.expirer.on(v.expired, async (e) => {
      const { topic: s } = ft$1(e.target);
      s && this.pairings.keys.includes(s) && (await this.deletePairing(s, !0), this.events.emit(V$1.expire, { topic: s }));
    });
  }
}
class Vt extends h$2 {
  constructor(e, s) {
    super(e, s), this.core = e, this.logger = s, this.records = /* @__PURE__ */ new Map(), this.events = new events.exports.EventEmitter(), this.name = vt, this.version = It, this.cached = [], this.initialized = !1, this.storagePrefix = O, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o) => this.records.set(o.id, o)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }, this.set = (o, fe, me) => {
      if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({ type: "method", method: "set", topic: o, request: fe, chainId: me }), this.records.has(fe.id))
        return;
      const ye = { id: fe.id, topic: o, request: { method: fe.method, params: fe.params || null }, chainId: me, expiry: pt$1(cjs$4.THIRTY_DAYS) };
      this.records.set(ye.id, ye), this.events.emit(R.created, ye);
    }, this.resolve = async (o) => {
      if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({ type: "method", method: "update", response: o }), !this.records.has(o.id))
        return;
      const fe = await this.getRecord(o.id);
      typeof fe.response > "u" && (fe.response = isJsonRpcError(o) ? { error: o.error } : { result: o.result }, this.records.set(fe.id, fe), this.events.emit(R.updated, fe));
    }, this.get = async (o, fe) => (this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({ type: "method", method: "get", topic: o, id: fe }), await this.getRecord(fe)), this.delete = (o, fe) => {
      this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({ type: "method", method: "delete", id: fe }), this.values.forEach((me) => {
        if (me.topic === o) {
          if (typeof fe < "u" && me.id !== fe)
            return;
          this.records.delete(me.id), this.events.emit(R.deleted, me);
        }
      });
    }, this.exists = async (o, fe) => (this.isInitialized(), this.records.has(fe) ? (await this.getRecord(fe)).topic === o : !1), this.on = (o, fe) => {
      this.events.on(o, fe);
    }, this.once = (o, fe) => {
      this.events.once(o, fe);
    }, this.off = (o, fe) => {
      this.events.off(o, fe);
    }, this.removeListener = (o, fe) => {
      this.events.removeListener(o, fe);
    }, this.logger = cjs$3.generateChildLogger(s, this.name);
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get size() {
    return this.records.size;
  }
  get keys() {
    return Array.from(this.records.keys());
  }
  get values() {
    return Array.from(this.records.values());
  }
  get pending() {
    const e = [];
    return this.values.forEach((s) => {
      if (typeof s.response < "u")
        return;
      const o = { topic: s.topic, request: formatJsonRpcRequest(s.request.method, s.request.params, s.id), chainId: s.chainId };
      return e.push(o);
    }), e;
  }
  async setJsonRpcRecords(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getJsonRpcRecords() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getRecord(e) {
    this.isInitialized();
    const s = this.records.get(e);
    if (!s) {
      const { message: o } = N("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(o);
    }
    return s;
  }
  async persist() {
    await this.setJsonRpcRecords(this.values), this.events.emit(R.sync);
  }
  async restore() {
    try {
      const e = await this.getJsonRpcRecords();
      if (typeof e > "u" || !e.length)
        return;
      if (this.records.size) {
        const { message: s } = N("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(s), new Error(s);
      }
      this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", records: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
    }
  }
  registerEventListeners() {
    this.events.on(R.created, (e) => {
      const s = R.created;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, record: e }), this.persist();
    }), this.events.on(R.updated, (e) => {
      const s = R.updated;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, record: e }), this.persist();
    }), this.events.on(R.deleted, (e) => {
      const s = R.deleted;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, record: e }), this.persist();
    }), this.core.heartbeat.on(cjs$5.HEARTBEAT_EVENTS.pulse, () => {
      this.cleanup();
    });
  }
  cleanup() {
    try {
      this.records.forEach((e) => {
        cjs$4.toMiliseconds(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
      });
    } catch (e) {
      this.logger.warn(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class jt extends E {
  constructor(e, s) {
    super(e, s), this.core = e, this.logger = s, this.expirations = /* @__PURE__ */ new Map(), this.events = new events.exports.EventEmitter(), this.name = Ct, this.version = Rt, this.cached = [], this.initialized = !1, this.storagePrefix = O, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o) => this.expirations.set(o.target, o)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }, this.has = (o) => {
      try {
        const fe = this.formatTarget(o);
        return typeof this.getExpiration(fe) < "u";
      } catch {
        return !1;
      }
    }, this.set = (o, fe) => {
      this.isInitialized();
      const me = this.formatTarget(o), ye = { target: me, expiry: fe };
      this.expirations.set(me, ye), this.checkExpiry(me, ye), this.events.emit(v.created, { target: me, expiration: ye });
    }, this.get = (o) => {
      this.isInitialized();
      const fe = this.formatTarget(o);
      return this.getExpiration(fe);
    }, this.del = (o) => {
      if (this.isInitialized(), this.has(o)) {
        const fe = this.formatTarget(o), me = this.getExpiration(fe);
        this.expirations.delete(fe), this.events.emit(v.deleted, { target: fe, expiration: me });
      }
    }, this.on = (o, fe) => {
      this.events.on(o, fe);
    }, this.once = (o, fe) => {
      this.events.once(o, fe);
    }, this.off = (o, fe) => {
      this.events.off(o, fe);
    }, this.removeListener = (o, fe) => {
      this.events.removeListener(o, fe);
    }, this.logger = cjs$3.generateChildLogger(s, this.name);
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.expirations.size;
  }
  get keys() {
    return Array.from(this.expirations.keys());
  }
  get values() {
    return Array.from(this.expirations.values());
  }
  formatTarget(e) {
    if (typeof e == "string")
      return lt$1(e);
    if (typeof e == "number")
      return dt$1(e);
    const { message: s } = N("UNKNOWN_TYPE", `Target type: ${typeof e}`);
    throw new Error(s);
  }
  async setExpirations(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getExpirations() {
    return await this.core.storage.getItem(this.storageKey);
  }
  async persist() {
    await this.setExpirations(this.values), this.events.emit(v.sync);
  }
  async restore() {
    try {
      const e = await this.getExpirations();
      if (typeof e > "u" || !e.length)
        return;
      if (this.expirations.size) {
        const { message: s } = N("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(s), new Error(s);
      }
      this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({ type: "method", method: "restore", expirations: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
    }
  }
  getExpiration(e) {
    const s = this.expirations.get(e);
    if (!s) {
      const { message: o } = N("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(o), new Error(o);
    }
    return s;
  }
  checkExpiry(e, s) {
    const { expiry: o } = s;
    cjs$4.toMiliseconds(o) - Date.now() <= 0 && this.expire(e, s);
  }
  expire(e, s) {
    this.expirations.delete(e), this.events.emit(v.expired, { target: e, expiration: s });
  }
  checkExpirations() {
    this.core.relayer.connected && this.expirations.forEach((e, s) => this.checkExpiry(s, e));
  }
  registerEventListeners() {
    this.core.heartbeat.on(cjs$5.HEARTBEAT_EVENTS.pulse, () => this.checkExpirations()), this.events.on(v.created, (e) => {
      const s = v.created;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, data: e }), this.persist();
    }), this.events.on(v.expired, (e) => {
      const s = v.expired;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, data: e }), this.persist();
    }), this.events.on(v.deleted, (e) => {
      const s = v.deleted;
      this.logger.info(`Emitting ${s}`), this.logger.debug({ type: "event", event: s, data: e }), this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class qt extends y {
  constructor(e, s) {
    super(e, s), this.projectId = e, this.logger = s, this.name = Z, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (o) => {
      if (this.verifyDisabled || C() || !D$1())
        return;
      const fe = this.getVerifyUrl(o == null ? void 0 : o.verifyUrl);
      this.verifyUrl !== fe && this.removeIframe(), this.verifyUrl = fe;
      try {
        await this.createIframe();
      } catch (me) {
        this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(me);
      }
      if (!this.initialized) {
        this.removeIframe(), this.verifyUrl = ee;
        try {
          await this.createIframe();
        } catch (me) {
          this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(me), this.verifyDisabled = !0;
        }
      }
    }, this.register = async (o) => {
      this.initialized ? this.sendPost(o.attestationId) : (this.addToQueue(o.attestationId), await this.init());
    }, this.resolve = async (o) => {
      if (this.isDevEnv)
        return "";
      const fe = this.getVerifyUrl(o == null ? void 0 : o.verifyUrl);
      let me;
      try {
        me = await this.fetchAttestation(o.attestationId, fe);
      } catch (ye) {
        this.logger.info(`failed to resolve attestation: ${o.attestationId} from url: ${fe}`), this.logger.info(ye), me = await this.fetchAttestation(o.attestationId, ee);
      }
      return me;
    }, this.fetchAttestation = async (o, fe) => {
      this.logger.info(`resolving attestation: ${o} from url: ${fe}`);
      const me = this.startAbortTimer(cjs$4.ONE_SECOND * 2), ye = await fetch(`${fe}/attestation/${o}`, { signal: this.abortController.signal });
      return clearTimeout(me), ye.status === 200 ? await ye.json() : void 0;
    }, this.addToQueue = (o) => {
      this.queue.push(o);
    }, this.processQueue = () => {
      this.queue.length !== 0 && (this.queue.forEach((o) => this.sendPost(o)), this.queue = []);
    }, this.sendPost = (o) => {
      var fe;
      try {
        if (!this.iframe)
          return;
        (fe = this.iframe.contentWindow) == null || fe.postMessage(o, "*"), this.logger.info(`postMessage sent: ${o} ${this.verifyUrl}`);
      } catch {
      }
    }, this.createIframe = async () => {
      let o;
      const fe = (me) => {
        me.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", fe), o());
      };
      await Promise.race([new Promise((me) => {
        if (document.getElementById(Z))
          return me();
        window.addEventListener("message", fe);
        const ye = document.createElement("iframe");
        ye.id = Z, ye.src = `${this.verifyUrl}/${this.projectId}`, ye.style.display = "none", document.body.append(ye), this.iframe = ye, o = me;
      }), new Promise((me, ye) => setTimeout(() => {
        window.removeEventListener("message", fe), ye("verify iframe load timeout");
      }, cjs$4.toMiliseconds(cjs$4.FIVE_SECONDS)))]);
    }, this.removeIframe = () => {
      this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
    }, this.getVerifyUrl = (o) => {
      let fe = o || $;
      return _t.includes(fe) || (this.logger.info(`verify url: ${fe}, not included in trusted list, assigning default: ${$}`), fe = $), fe;
    }, this.logger = cjs$3.generateChildLogger(s, this.name), this.verifyUrl = $, this.abortController = new AbortController(), this.isDevEnv = te$1() && process.env.IS_VITEST;
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  startAbortTimer(e) {
    return this.abortController = new AbortController(), setTimeout(() => this.abortController.abort(), cjs$4.toMiliseconds(e));
  }
}
class Gt extends v$1 {
  constructor(e, s) {
    super(e, s), this.projectId = e, this.logger = s, this.context = St, this.registerDeviceToken = async (o) => {
      const { clientId: fe, token: me, notificationType: ye, enableEncrypted: fr = !1 } = o, Er = `${Tt}/${this.projectId}/clients`;
      await browser$1(Er, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ client_id: fe, type: ye, token: me, always_raw: fr }) });
    }, this.logger = cjs$3.generateChildLogger(s, this.context);
  }
}
var Lr = Object.defineProperty, Yt = Object.getOwnPropertySymbols, Fr = Object.prototype.hasOwnProperty, $r = Object.prototype.propertyIsEnumerable, Ht = (r, e, s) => e in r ? Lr(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, Jt = (r, e) => {
  for (var s in e || (e = {}))
    Fr.call(e, s) && Ht(r, s, e[s]);
  if (Yt)
    for (var s of Yt(e))
      $r.call(e, s) && Ht(r, s, e[s]);
  return r;
};
class te extends n {
  constructor(e) {
    super(e), this.protocol = le$1, this.version = We, this.name = Q$1, this.events = new events.exports.EventEmitter(), this.initialized = !1, this.on = (o, fe) => this.events.on(o, fe), this.once = (o, fe) => this.events.once(o, fe), this.off = (o, fe) => this.events.off(o, fe), this.removeListener = (o, fe) => this.events.removeListener(o, fe), this.projectId = e == null ? void 0 : e.projectId, this.relayUrl = (e == null ? void 0 : e.relayUrl) || ge, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
    const s = typeof (e == null ? void 0 : e.logger) < "u" && typeof (e == null ? void 0 : e.logger) != "string" ? e.logger : cjs$3.pino(cjs$3.getDefaultLoggerOptions({ level: (e == null ? void 0 : e.logger) || Qe.logger }));
    this.logger = cjs$3.generateChildLogger(s, this.name), this.heartbeat = new cjs$5.HeartBeat(), this.crypto = new xt(this, this.logger, e == null ? void 0 : e.keychain), this.history = new Vt(this, this.logger), this.expirer = new jt(this, this.logger), this.storage = e != null && e.storage ? e.storage : new h$3(Jt(Jt({}, Ze), e == null ? void 0 : e.storageOptions)), this.relayer = new Ft({ core: this, logger: this.logger, relayUrl: this.relayUrl, projectId: this.projectId }), this.pairing = new Bt(this, this.logger), this.verify = new qt(this.projectId || "", this.logger), this.echoClient = new Gt(this.projectId || "", this.logger);
  }
  static async init(e) {
    const s = new te(e);
    await s.initialize();
    const o = await s.crypto.getClientId();
    return await s.storage.setItem(yt, o), s;
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  async start() {
    this.initialized || await this.initialize();
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
    } catch (e) {
      throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
    }
  }
}
const Mr = te, X = "wc", F = 2, H = "client", G = `${X}@${F}:${H}:`, M = { name: H, logger: "error", controller: !1, relayUrl: "wss://relay.walletconnect.com" }, ss = { session_proposal: "session_proposal", session_update: "session_update", session_extend: "session_extend", session_ping: "session_ping", session_delete: "session_delete", session_expire: "session_expire", session_request: "session_request", session_request_sent: "session_request_sent", session_event: "session_event", proposal_expire: "proposal_expire" }, ts = { database: ":memory:" }, W = "WALLETCONNECT_DEEPLINK_CHOICE", is = { created: "history_created", updated: "history_updated", deleted: "history_deleted", sync: "history_sync" }, rs = "history", ns = "0.3", ne = "proposal", os = cjs$4.THIRTY_DAYS, oe = "Proposal expired", ae = "session", A = cjs$4.SEVEN_DAYS, ce = "engine", V = { wc_sessionPropose: { req: { ttl: cjs$4.FIVE_MINUTES, prompt: !0, tag: 1100 }, res: { ttl: cjs$4.FIVE_MINUTES, prompt: !1, tag: 1101 } }, wc_sessionSettle: { req: { ttl: cjs$4.FIVE_MINUTES, prompt: !1, tag: 1102 }, res: { ttl: cjs$4.FIVE_MINUTES, prompt: !1, tag: 1103 } }, wc_sessionUpdate: { req: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1104 }, res: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1105 } }, wc_sessionExtend: { req: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1106 }, res: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1107 } }, wc_sessionRequest: { req: { ttl: cjs$4.FIVE_MINUTES, prompt: !0, tag: 1108 }, res: { ttl: cjs$4.FIVE_MINUTES, prompt: !1, tag: 1109 } }, wc_sessionEvent: { req: { ttl: cjs$4.FIVE_MINUTES, prompt: !0, tag: 1110 }, res: { ttl: cjs$4.FIVE_MINUTES, prompt: !1, tag: 1111 } }, wc_sessionDelete: { req: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1112 }, res: { ttl: cjs$4.ONE_DAY, prompt: !1, tag: 1113 } }, wc_sessionPing: { req: { ttl: cjs$4.THIRTY_SECONDS, prompt: !1, tag: 1114 }, res: { ttl: cjs$4.THIRTY_SECONDS, prompt: !1, tag: 1115 } } }, U = { min: cjs$4.FIVE_MINUTES, max: cjs$4.SEVEN_DAYS }, I = { idle: "IDLE", active: "ACTIVE" }, le = "request", pe = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest"];
var as = Object.defineProperty, cs = Object.defineProperties, ls = Object.getOwnPropertyDescriptors, he = Object.getOwnPropertySymbols, ps = Object.prototype.hasOwnProperty, hs = Object.prototype.propertyIsEnumerable, de = (r, e, s) => e in r ? as(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, g = (r, e) => {
  for (var s in e || (e = {}))
    ps.call(e, s) && de(r, s, e[s]);
  if (he)
    for (var s of he(e))
      hs.call(e, s) && de(r, s, e[s]);
  return r;
}, b = (r, e) => cs(r, ls(e));
class ds extends w$3 {
  constructor(e) {
    super(e), this.name = ce, this.events = new events.exports(), this.initialized = !1, this.ignoredPayloadTypes = [_], this.requestQueue = { state: I.idle, queue: [] }, this.sessionRequestQueue = { state: I.idle, queue: [] }, this.requestQueueDelay = cjs$4.ONE_SECOND, this.init = async () => {
      this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({ methods: Object.keys(V) }), this.initialized = !0, setTimeout(() => {
        this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
      }, cjs$4.toMiliseconds(this.requestQueueDelay)));
    }, this.connect = async (s) => {
      await this.isInitialized();
      const o = b(g({}, s), { requiredNamespaces: s.requiredNamespaces || {}, optionalNamespaces: s.optionalNamespaces || {} });
      await this.isValidConnect(o);
      const { pairingTopic: fe, requiredNamespaces: me, optionalNamespaces: ye, sessionProperties: fr, relays: Er } = o;
      let br = fe, wr, kr = !1;
      if (br && (kr = this.client.core.pairing.pairings.get(br).active), !br || !kr) {
        const { topic: ti, uri: On } = await this.client.core.pairing.create();
        br = ti, wr = On;
      }
      const Gr = await this.client.core.crypto.generateKeyPair(), Vr = g({ requiredNamespaces: me, optionalNamespaces: ye, relays: Er != null ? Er : [{ protocol: ht }], proposer: { publicKey: Gr, metadata: this.client.metadata } }, fr && { sessionProperties: fr }), { reject: jr, resolve: Kr, done: bn } = at$1(cjs$4.FIVE_MINUTES, oe);
      if (this.events.once(yt$1("session_connect"), async ({ error: ti, session: On }) => {
        if (ti)
          jr(ti);
        else if (On) {
          On.self.publicKey = Gr;
          const ni = b(g({}, On), { requiredNamespaces: On.requiredNamespaces, optionalNamespaces: On.optionalNamespaces });
          await this.client.session.set(On.topic, ni), await this.setExpiry(On.topic, On.expiry), br && await this.client.core.pairing.updateMetadata({ topic: br, metadata: On.peer.metadata }), Kr(ni);
        }
      }), !br) {
        const { message: ti } = N("NO_MATCHING_KEY", `connect() pairing topic: ${br}`);
        throw new Error(ti);
      }
      const Yr = await this.sendRequest({ topic: br, method: "wc_sessionPropose", params: Vr }), Zr = pt$1(cjs$4.FIVE_MINUTES);
      return await this.setProposal(Yr, g({ id: Yr, expiry: Zr }, Vr)), { uri: wr, approval: bn };
    }, this.pair = async (s) => (await this.isInitialized(), await this.client.core.pairing.pair(s)), this.approve = async (s) => {
      await this.isInitialized(), await this.isValidApprove(s);
      const { id: o, relayProtocol: fe, namespaces: me, sessionProperties: ye } = s, fr = this.client.proposal.get(o);
      let { pairingTopic: Er, proposer: br, requiredNamespaces: wr, optionalNamespaces: kr } = fr;
      Er = Er || "", B$1(wr) || (wr = jt$1(me, "approve()"));
      const Gr = await this.client.core.crypto.generateKeyPair(), Vr = br.publicKey, jr = await this.client.core.crypto.generateSharedKey(Gr, Vr);
      Er && o && (await this.client.core.pairing.updateMetadata({ topic: Er, metadata: br.metadata }), await this.sendResult({ id: o, topic: Er, result: { relay: { protocol: fe != null ? fe : "irn" }, responderPublicKey: Gr } }), await this.client.proposal.delete(o, U$1("USER_DISCONNECTED")), await this.client.core.pairing.activate({ topic: Er }));
      const Kr = g({ relay: { protocol: fe != null ? fe : "irn" }, namespaces: me, requiredNamespaces: wr, optionalNamespaces: kr, pairingTopic: Er, controller: { publicKey: Gr, metadata: this.client.metadata }, expiry: pt$1(A) }, ye && { sessionProperties: ye });
      await this.client.core.relayer.subscribe(jr), await this.sendRequest({ topic: jr, method: "wc_sessionSettle", params: Kr, throwOnFailedPublish: !0 });
      const bn = b(g({}, Kr), { topic: jr, pairingTopic: Er, acknowledged: !1, self: Kr.controller, peer: { publicKey: br.publicKey, metadata: br.metadata }, controller: Gr });
      return await this.client.session.set(jr, bn), await this.setExpiry(jr, pt$1(A)), { topic: jr, acknowledged: () => new Promise((Yr) => setTimeout(() => Yr(this.client.session.get(jr)), 500)) };
    }, this.reject = async (s) => {
      await this.isInitialized(), await this.isValidReject(s);
      const { id: o, reason: fe } = s, { pairingTopic: me } = this.client.proposal.get(o);
      me && (await this.sendError(o, me, fe), await this.client.proposal.delete(o, U$1("USER_DISCONNECTED")));
    }, this.update = async (s) => {
      await this.isInitialized(), await this.isValidUpdate(s);
      const { topic: o, namespaces: fe } = s, me = await this.sendRequest({ topic: o, method: "wc_sessionUpdate", params: { namespaces: fe } }), { done: ye, resolve: fr, reject: Er } = at$1();
      return this.events.once(yt$1("session_update", me), ({ error: br }) => {
        br ? Er(br) : fr();
      }), await this.client.session.update(o, { namespaces: fe }), { acknowledged: ye };
    }, this.extend = async (s) => {
      await this.isInitialized(), await this.isValidExtend(s);
      const { topic: o } = s, fe = await this.sendRequest({ topic: o, method: "wc_sessionExtend", params: {} }), { done: me, resolve: ye, reject: fr } = at$1();
      return this.events.once(yt$1("session_extend", fe), ({ error: Er }) => {
        Er ? fr(Er) : ye();
      }), await this.setExpiry(o, pt$1(A)), { acknowledged: me };
    }, this.request = async (s) => {
      await this.isInitialized(), await this.isValidRequest(s);
      const { chainId: o, request: fe, topic: me, expiry: ye } = s, fr = payloadId(), { done: Er, resolve: br, reject: wr } = at$1(ye, "Request expired. Please try again.");
      return this.events.once(yt$1("session_request", fr), ({ error: kr, result: Gr }) => {
        kr ? wr(kr) : br(Gr);
      }), await Promise.all([new Promise(async (kr) => {
        await this.sendRequest({ clientRpcId: fr, topic: me, method: "wc_sessionRequest", params: { request: fe, chainId: o }, expiry: ye, throwOnFailedPublish: !0 }).catch((Gr) => wr(Gr)), this.client.events.emit("session_request_sent", { topic: me, request: fe, chainId: o, id: fr }), kr();
      }), new Promise(async (kr) => {
        const Gr = await gt$1(this.client.core.storage, W);
        ht$1({ id: fr, topic: me, wcDeepLink: Gr }), kr();
      }), Er()]).then((kr) => kr[2]);
    }, this.respond = async (s) => {
      await this.isInitialized(), await this.isValidRespond(s);
      const { topic: o, response: fe } = s, { id: me } = fe;
      isJsonRpcResult(fe) ? await this.sendResult({ id: me, topic: o, result: fe.result, throwOnFailedPublish: !0 }) : isJsonRpcError(fe) && await this.sendError(me, o, fe.error), this.cleanupAfterResponse(s);
    }, this.ping = async (s) => {
      await this.isInitialized(), await this.isValidPing(s);
      const { topic: o } = s;
      if (this.client.session.keys.includes(o)) {
        const fe = await this.sendRequest({ topic: o, method: "wc_sessionPing", params: {} }), { done: me, resolve: ye, reject: fr } = at$1();
        this.events.once(yt$1("session_ping", fe), ({ error: Er }) => {
          Er ? fr(Er) : ye();
        }), await me();
      } else
        this.client.core.pairing.pairings.keys.includes(o) && await this.client.core.pairing.ping({ topic: o });
    }, this.emit = async (s) => {
      await this.isInitialized(), await this.isValidEmit(s);
      const { topic: o, event: fe, chainId: me } = s;
      await this.sendRequest({ topic: o, method: "wc_sessionEvent", params: { event: fe, chainId: me } });
    }, this.disconnect = async (s) => {
      await this.isInitialized(), await this.isValidDisconnect(s);
      const { topic: o } = s;
      this.client.session.keys.includes(o) ? (await this.sendRequest({ topic: o, method: "wc_sessionDelete", params: U$1("USER_DISCONNECTED"), throwOnFailedPublish: !0 }), await this.deleteSession(o)) : await this.client.core.pairing.disconnect({ topic: o });
    }, this.find = (s) => (this.isInitialized(), this.client.session.getAll().filter((o) => Dt$1(o, s))), this.getPendingSessionRequests = () => (this.isInitialized(), this.client.pendingRequest.getAll()), this.cleanupDuplicatePairings = async (s) => {
      if (s.pairingTopic)
        try {
          const o = this.client.core.pairing.pairings.get(s.pairingTopic), fe = this.client.core.pairing.pairings.getAll().filter((me) => {
            var ye, fr;
            return ((ye = me.peerMetadata) == null ? void 0 : ye.url) && ((fr = me.peerMetadata) == null ? void 0 : fr.url) === s.peer.metadata.url && me.topic && me.topic !== o.topic;
          });
          if (fe.length === 0)
            return;
          this.client.logger.info(`Cleaning up ${fe.length} duplicate pairing(s)`), await Promise.all(fe.map((me) => this.client.core.pairing.disconnect({ topic: me.topic }))), this.client.logger.info("Duplicate pairings clean up finished");
        } catch (o) {
          this.client.logger.error(o);
        }
    }, this.deleteSession = async (s, o) => {
      const { self: fe } = this.client.session.get(s);
      await this.client.core.relayer.unsubscribe(s), this.client.session.delete(s, U$1("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(fe.publicKey) && await this.client.core.crypto.deleteKeyPair(fe.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), o || this.client.core.expirer.del(s), this.client.core.storage.removeItem(W).catch((me) => this.client.logger.warn(me)), this.getPendingSessionRequests().forEach((me) => {
        me.topic === s && this.deletePendingSessionRequest(me.id, U$1("USER_DISCONNECTED"));
      });
    }, this.deleteProposal = async (s, o) => {
      await Promise.all([this.client.proposal.delete(s, U$1("USER_DISCONNECTED")), o ? Promise.resolve() : this.client.core.expirer.del(s)]);
    }, this.deletePendingSessionRequest = async (s, o, fe = !1) => {
      await Promise.all([this.client.pendingRequest.delete(s, o), fe ? Promise.resolve() : this.client.core.expirer.del(s)]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((me) => me.id !== s), fe && (this.sessionRequestQueue.state = I.idle);
    }, this.setExpiry = async (s, o) => {
      this.client.session.keys.includes(s) && await this.client.session.update(s, { expiry: o }), this.client.core.expirer.set(s, o);
    }, this.setProposal = async (s, o) => {
      await this.client.proposal.set(s, o), this.client.core.expirer.set(s, o.expiry);
    }, this.setPendingSessionRequest = async (s) => {
      const o = V.wc_sessionRequest.req.ttl, { id: fe, topic: me, params: ye, verifyContext: fr } = s;
      await this.client.pendingRequest.set(fe, { id: fe, topic: me, params: ye, verifyContext: fr }), o && this.client.core.expirer.set(fe, pt$1(o));
    }, this.sendRequest = async (s) => {
      const { topic: o, method: fe, params: me, expiry: ye, relayRpcId: fr, clientRpcId: Er, throwOnFailedPublish: br } = s, wr = formatJsonRpcRequest(fe, me, Er);
      if (D$1() && pe.includes(fe)) {
        const Vr = Ln(JSON.stringify(wr));
        this.client.core.verify.register({ attestationId: Vr });
      }
      const kr = await this.client.core.crypto.encode(o, wr), Gr = V[fe].req;
      return ye && (Gr.ttl = ye), fr && (Gr.id = fr), this.client.core.history.set(o, wr), br ? (Gr.internal = b(g({}, Gr.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(o, kr, Gr)) : this.client.core.relayer.publish(o, kr, Gr).catch((Vr) => this.client.logger.error(Vr)), wr.id;
    }, this.sendResult = async (s) => {
      const { id: o, topic: fe, result: me, throwOnFailedPublish: ye } = s, fr = formatJsonRpcResult(o, me), Er = await this.client.core.crypto.encode(fe, fr), br = await this.client.core.history.get(fe, o), wr = V[br.request.method].res;
      ye ? (wr.internal = b(g({}, wr.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(fe, Er, wr)) : this.client.core.relayer.publish(fe, Er, wr).catch((kr) => this.client.logger.error(kr)), await this.client.core.history.resolve(fr);
    }, this.sendError = async (s, o, fe) => {
      const me = formatJsonRpcError(s, fe), ye = await this.client.core.crypto.encode(o, me), fr = await this.client.core.history.get(o, s), Er = V[fr.request.method].res;
      this.client.core.relayer.publish(o, ye, Er), await this.client.core.history.resolve(me);
    }, this.cleanup = async () => {
      const s = [], o = [];
      this.client.session.getAll().forEach((fe) => {
        mt$1(fe.expiry) && s.push(fe.topic);
      }), this.client.proposal.getAll().forEach((fe) => {
        mt$1(fe.expiry) && o.push(fe.id);
      }), await Promise.all([...s.map((fe) => this.deleteSession(fe)), ...o.map((fe) => this.deleteProposal(fe))]);
    }, this.onRelayEventRequest = async (s) => {
      this.requestQueue.queue.push(s), await this.processRequestsQueue();
    }, this.processRequestsQueue = async () => {
      if (this.requestQueue.state === I.active) {
        this.client.logger.info("Request queue already active, skipping...");
        return;
      }
      for (this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0; ) {
        this.requestQueue.state = I.active;
        const s = this.requestQueue.queue.shift();
        if (s)
          try {
            this.processRequest(s), await new Promise((o) => setTimeout(o, 300));
          } catch (o) {
            this.client.logger.warn(o);
          }
      }
      this.requestQueue.state = I.idle;
    }, this.processRequest = (s) => {
      const { topic: o, payload: fe } = s, me = fe.method;
      switch (me) {
        case "wc_sessionPropose":
          return this.onSessionProposeRequest(o, fe);
        case "wc_sessionSettle":
          return this.onSessionSettleRequest(o, fe);
        case "wc_sessionUpdate":
          return this.onSessionUpdateRequest(o, fe);
        case "wc_sessionExtend":
          return this.onSessionExtendRequest(o, fe);
        case "wc_sessionPing":
          return this.onSessionPingRequest(o, fe);
        case "wc_sessionDelete":
          return this.onSessionDeleteRequest(o, fe);
        case "wc_sessionRequest":
          return this.onSessionRequest(o, fe);
        case "wc_sessionEvent":
          return this.onSessionEventRequest(o, fe);
        default:
          return this.client.logger.info(`Unsupported request method ${me}`);
      }
    }, this.onRelayEventResponse = async (s) => {
      const { topic: o, payload: fe } = s, me = (await this.client.core.history.get(o, fe.id)).request.method;
      switch (me) {
        case "wc_sessionPropose":
          return this.onSessionProposeResponse(o, fe);
        case "wc_sessionSettle":
          return this.onSessionSettleResponse(o, fe);
        case "wc_sessionUpdate":
          return this.onSessionUpdateResponse(o, fe);
        case "wc_sessionExtend":
          return this.onSessionExtendResponse(o, fe);
        case "wc_sessionPing":
          return this.onSessionPingResponse(o, fe);
        case "wc_sessionRequest":
          return this.onSessionRequestResponse(o, fe);
        default:
          return this.client.logger.info(`Unsupported response method ${me}`);
      }
    }, this.onRelayEventUnknownPayload = (s) => {
      const { topic: o } = s, { message: fe } = N("MISSING_OR_INVALID", `Decoded payload on topic ${o} is not identifiable as a JSON-RPC request or a response.`);
      throw new Error(fe);
    }, this.onSessionProposeRequest = async (s, o) => {
      const { params: fe, id: me } = o;
      try {
        this.isValidConnect(g({}, o.params));
        const ye = pt$1(cjs$4.FIVE_MINUTES), fr = g({ id: me, pairingTopic: s, expiry: ye }, fe);
        await this.setProposal(me, fr);
        const Er = Ln(JSON.stringify(o)), br = await this.getVerifyContext(Er, fr.proposer.metadata);
        this.client.events.emit("session_proposal", { id: me, params: fr, verifyContext: br });
      } catch (ye) {
        await this.sendError(me, s, ye), this.client.logger.error(ye);
      }
    }, this.onSessionProposeResponse = async (s, o) => {
      const { id: fe } = o;
      if (isJsonRpcResult(o)) {
        const { result: me } = o;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", result: me });
        const ye = this.client.proposal.get(fe);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", proposal: ye });
        const fr = ye.proposer.publicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", selfPublicKey: fr });
        const Er = me.responderPublicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", peerPublicKey: Er });
        const br = await this.client.core.crypto.generateSharedKey(fr, Er);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", sessionTopic: br });
        const wr = await this.client.core.relayer.subscribe(br);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", subscriptionId: wr }), await this.client.core.pairing.activate({ topic: s });
      } else
        isJsonRpcError(o) && (await this.client.proposal.delete(fe, U$1("USER_DISCONNECTED")), this.events.emit(yt$1("session_connect"), { error: o.error }));
    }, this.onSessionSettleRequest = async (s, o) => {
      const { id: fe, params: me } = o;
      try {
        this.isValidSessionSettleRequest(me);
        const { relay: ye, controller: fr, expiry: Er, namespaces: br, requiredNamespaces: wr, optionalNamespaces: kr, sessionProperties: Gr, pairingTopic: Vr } = o.params, jr = g({ topic: s, relay: ye, expiry: Er, namespaces: br, acknowledged: !0, pairingTopic: Vr, requiredNamespaces: wr, optionalNamespaces: kr, controller: fr.publicKey, self: { publicKey: "", metadata: this.client.metadata }, peer: { publicKey: fr.publicKey, metadata: fr.metadata } }, Gr && { sessionProperties: Gr });
        await this.sendResult({ id: o.id, topic: s, result: !0 }), this.events.emit(yt$1("session_connect"), { session: jr }), this.cleanupDuplicatePairings(jr);
      } catch (ye) {
        await this.sendError(fe, s, ye), this.client.logger.error(ye);
      }
    }, this.onSessionSettleResponse = async (s, o) => {
      const { id: fe } = o;
      isJsonRpcResult(o) ? (await this.client.session.update(s, { acknowledged: !0 }), this.events.emit(yt$1("session_approve", fe), {})) : isJsonRpcError(o) && (await this.client.session.delete(s, U$1("USER_DISCONNECTED")), this.events.emit(yt$1("session_approve", fe), { error: o.error }));
    }, this.onSessionUpdateRequest = async (s, o) => {
      const { params: fe, id: me } = o;
      try {
        const ye = `${s}_session_update`, fr = tr$1.get(ye);
        if (fr && this.isRequestOutOfSync(fr, me)) {
          this.client.logger.info(`Discarding out of sync request - ${me}`);
          return;
        }
        this.isValidUpdate(g({ topic: s }, fe)), await this.client.session.update(s, { namespaces: fe.namespaces }), await this.sendResult({ id: me, topic: s, result: !0 }), this.client.events.emit("session_update", { id: me, topic: s, params: fe }), tr$1.set(ye, me);
      } catch (ye) {
        await this.sendError(me, s, ye), this.client.logger.error(ye);
      }
    }, this.isRequestOutOfSync = (s, o) => parseInt(o.toString().slice(0, -3)) <= parseInt(s.toString().slice(0, -3)), this.onSessionUpdateResponse = (s, o) => {
      const { id: fe } = o;
      isJsonRpcResult(o) ? this.events.emit(yt$1("session_update", fe), {}) : isJsonRpcError(o) && this.events.emit(yt$1("session_update", fe), { error: o.error });
    }, this.onSessionExtendRequest = async (s, o) => {
      const { id: fe } = o;
      try {
        this.isValidExtend({ topic: s }), await this.setExpiry(s, pt$1(A)), await this.sendResult({ id: fe, topic: s, result: !0 }), this.client.events.emit("session_extend", { id: fe, topic: s });
      } catch (me) {
        await this.sendError(fe, s, me), this.client.logger.error(me);
      }
    }, this.onSessionExtendResponse = (s, o) => {
      const { id: fe } = o;
      isJsonRpcResult(o) ? this.events.emit(yt$1("session_extend", fe), {}) : isJsonRpcError(o) && this.events.emit(yt$1("session_extend", fe), { error: o.error });
    }, this.onSessionPingRequest = async (s, o) => {
      const { id: fe } = o;
      try {
        this.isValidPing({ topic: s }), await this.sendResult({ id: fe, topic: s, result: !0 }), this.client.events.emit("session_ping", { id: fe, topic: s });
      } catch (me) {
        await this.sendError(fe, s, me), this.client.logger.error(me);
      }
    }, this.onSessionPingResponse = (s, o) => {
      const { id: fe } = o;
      setTimeout(() => {
        isJsonRpcResult(o) ? this.events.emit(yt$1("session_ping", fe), {}) : isJsonRpcError(o) && this.events.emit(yt$1("session_ping", fe), { error: o.error });
      }, 500);
    }, this.onSessionDeleteRequest = async (s, o) => {
      const { id: fe } = o;
      try {
        this.isValidDisconnect({ topic: s, reason: o.params }), await Promise.all([new Promise((me) => {
          this.client.core.relayer.once(D.publish, async () => {
            me(await this.deleteSession(s));
          });
        }), this.sendResult({ id: fe, topic: s, result: !0 })]), this.client.events.emit("session_delete", { id: fe, topic: s });
      } catch (me) {
        this.client.logger.error(me);
      }
    }, this.onSessionRequest = async (s, o) => {
      const { id: fe, params: me } = o;
      try {
        this.isValidRequest(g({ topic: s }, me));
        const ye = Ln(JSON.stringify(formatJsonRpcRequest("wc_sessionRequest", me, fe))), fr = this.client.session.get(s), Er = await this.getVerifyContext(ye, fr.peer.metadata), br = { id: fe, topic: s, params: me, verifyContext: Er };
        await this.setPendingSessionRequest(br), this.addSessionRequestToSessionRequestQueue(br), this.processSessionRequestQueue();
      } catch (ye) {
        await this.sendError(fe, s, ye), this.client.logger.error(ye);
      }
    }, this.onSessionRequestResponse = (s, o) => {
      const { id: fe } = o;
      isJsonRpcResult(o) ? this.events.emit(yt$1("session_request", fe), { result: o.result }) : isJsonRpcError(o) && this.events.emit(yt$1("session_request", fe), { error: o.error });
    }, this.onSessionEventRequest = async (s, o) => {
      const { id: fe, params: me } = o;
      try {
        const ye = `${s}_session_event_${me.event.name}`, fr = tr$1.get(ye);
        if (fr && this.isRequestOutOfSync(fr, fe)) {
          this.client.logger.info(`Discarding out of sync request - ${fe}`);
          return;
        }
        this.isValidEmit(g({ topic: s }, me)), this.client.events.emit("session_event", { id: fe, topic: s, params: me }), tr$1.set(ye, fe);
      } catch (ye) {
        await this.sendError(fe, s, ye), this.client.logger.error(ye);
      }
    }, this.addSessionRequestToSessionRequestQueue = (s) => {
      this.sessionRequestQueue.queue.push(s);
    }, this.cleanupAfterResponse = (s) => {
      this.deletePendingSessionRequest(s.response.id, { message: "fulfilled", code: 0 }), setTimeout(() => {
        this.sessionRequestQueue.state = I.idle, this.processSessionRequestQueue();
      }, cjs$4.toMiliseconds(this.requestQueueDelay));
    }, this.processSessionRequestQueue = () => {
      if (this.sessionRequestQueue.state === I.active) {
        this.client.logger.info("session request queue is already active.");
        return;
      }
      const s = this.sessionRequestQueue.queue[0];
      if (!s) {
        this.client.logger.info("session request queue is empty.");
        return;
      }
      try {
        this.sessionRequestQueue.state = I.active, this.client.events.emit("session_request", s);
      } catch (o) {
        this.client.logger.error(o);
      }
    }, this.onPairingCreated = (s) => {
      if (s.active)
        return;
      const o = this.client.proposal.getAll().find((fe) => fe.pairingTopic === s.topic);
      o && this.onSessionProposeRequest(s.topic, formatJsonRpcRequest("wc_sessionPropose", { requiredNamespaces: o.requiredNamespaces, optionalNamespaces: o.optionalNamespaces, relays: o.relays, proposer: o.proposer, sessionProperties: o.sessionProperties }, o.id));
    }, this.isValidConnect = async (s) => {
      if (!Ht$1(s)) {
        const { message: Er } = N("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(s)}`);
        throw new Error(Er);
      }
      const { pairingTopic: o, requiredNamespaces: fe, optionalNamespaces: me, sessionProperties: ye, relays: fr } = s;
      if (w$2(o) || await this.isValidPairingTopic(o), !xt$1(fr, !0)) {
        const { message: Er } = N("MISSING_OR_INVALID", `connect() relays: ${fr}`);
        throw new Error(Er);
      }
      !w$2(fe) && B$1(fe) !== 0 && this.validateNamespaces(fe, "requiredNamespaces"), !w$2(me) && B$1(me) !== 0 && this.validateNamespaces(me, "optionalNamespaces"), w$2(ye) || this.validateSessionProps(ye, "sessionProperties");
    }, this.validateNamespaces = (s, o) => {
      const fe = Lt$1(s, "connect()", o);
      if (fe)
        throw new Error(fe.message);
    }, this.isValidApprove = async (s) => {
      if (!Ht$1(s))
        throw new Error(N("MISSING_OR_INVALID", `approve() params: ${s}`).message);
      const { id: o, namespaces: fe, relayProtocol: me, sessionProperties: ye } = s;
      await this.isValidProposalId(o);
      const fr = this.client.proposal.get(o), Er = ln(fe, "approve()");
      if (Er)
        throw new Error(Er.message);
      const br = fn(fr.requiredNamespaces, fe, "approve()");
      if (br)
        throw new Error(br.message);
      if (!h$1(me, !0)) {
        const { message: wr } = N("MISSING_OR_INVALID", `approve() relayProtocol: ${me}`);
        throw new Error(wr);
      }
      w$2(ye) || this.validateSessionProps(ye, "sessionProperties");
    }, this.isValidReject = async (s) => {
      if (!Ht$1(s)) {
        const { message: me } = N("MISSING_OR_INVALID", `reject() params: ${s}`);
        throw new Error(me);
      }
      const { id: o, reason: fe } = s;
      if (await this.isValidProposalId(o), !qt$1(fe)) {
        const { message: me } = N("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(fe)}`);
        throw new Error(me);
      }
    }, this.isValidSessionSettleRequest = (s) => {
      if (!Ht$1(s)) {
        const { message: br } = N("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${s}`);
        throw new Error(br);
      }
      const { relay: o, controller: fe, namespaces: me, expiry: ye } = s;
      if (!dn(o)) {
        const { message: br } = N("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
        throw new Error(br);
      }
      const fr = Kt$1(fe, "onSessionSettleRequest()");
      if (fr)
        throw new Error(fr.message);
      const Er = ln(me, "onSessionSettleRequest()");
      if (Er)
        throw new Error(Er.message);
      if (mt$1(ye)) {
        const { message: br } = N("EXPIRED", "onSessionSettleRequest()");
        throw new Error(br);
      }
    }, this.isValidUpdate = async (s) => {
      if (!Ht$1(s)) {
        const { message: Er } = N("MISSING_OR_INVALID", `update() params: ${s}`);
        throw new Error(Er);
      }
      const { topic: o, namespaces: fe } = s;
      await this.isValidSessionTopic(o);
      const me = this.client.session.get(o), ye = ln(fe, "update()");
      if (ye)
        throw new Error(ye.message);
      const fr = fn(me.requiredNamespaces, fe, "update()");
      if (fr)
        throw new Error(fr.message);
    }, this.isValidExtend = async (s) => {
      if (!Ht$1(s)) {
        const { message: fe } = N("MISSING_OR_INVALID", `extend() params: ${s}`);
        throw new Error(fe);
      }
      const { topic: o } = s;
      await this.isValidSessionTopic(o);
    }, this.isValidRequest = async (s) => {
      if (!Ht$1(s)) {
        const { message: Er } = N("MISSING_OR_INVALID", `request() params: ${s}`);
        throw new Error(Er);
      }
      const { topic: o, request: fe, chainId: me, expiry: ye } = s;
      await this.isValidSessionTopic(o);
      const { namespaces: fr } = this.client.session.get(o);
      if (!zt$1(fr, me)) {
        const { message: Er } = N("MISSING_OR_INVALID", `request() chainId: ${me}`);
        throw new Error(Er);
      }
      if (!Bt$1(fe)) {
        const { message: Er } = N("MISSING_OR_INVALID", `request() ${JSON.stringify(fe)}`);
        throw new Error(Er);
      }
      if (!Yt$1(fr, me, fe.method)) {
        const { message: Er } = N("MISSING_OR_INVALID", `request() method: ${fe.method}`);
        throw new Error(Er);
      }
      if (ye && !Xt(ye, U)) {
        const { message: Er } = N("MISSING_OR_INVALID", `request() expiry: ${ye}. Expiry must be a number (in seconds) between ${U.min} and ${U.max}`);
        throw new Error(Er);
      }
    }, this.isValidRespond = async (s) => {
      var o;
      if (!Ht$1(s)) {
        const { message: ye } = N("MISSING_OR_INVALID", `respond() params: ${s}`);
        throw new Error(ye);
      }
      const { topic: fe, response: me } = s;
      try {
        await this.isValidSessionTopic(fe);
      } catch (ye) {
        throw (o = s == null ? void 0 : s.response) != null && o.id && this.cleanupAfterResponse(s), ye;
      }
      if (!Gt$1(me)) {
        const { message: ye } = N("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(me)}`);
        throw new Error(ye);
      }
    }, this.isValidPing = async (s) => {
      if (!Ht$1(s)) {
        const { message: fe } = N("MISSING_OR_INVALID", `ping() params: ${s}`);
        throw new Error(fe);
      }
      const { topic: o } = s;
      await this.isValidSessionOrPairingTopic(o);
    }, this.isValidEmit = async (s) => {
      if (!Ht$1(s)) {
        const { message: fr } = N("MISSING_OR_INVALID", `emit() params: ${s}`);
        throw new Error(fr);
      }
      const { topic: o, event: fe, chainId: me } = s;
      await this.isValidSessionTopic(o);
      const { namespaces: ye } = this.client.session.get(o);
      if (!zt$1(ye, me)) {
        const { message: fr } = N("MISSING_OR_INVALID", `emit() chainId: ${me}`);
        throw new Error(fr);
      }
      if (!Wt(fe)) {
        const { message: fr } = N("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(fe)}`);
        throw new Error(fr);
      }
      if (!Jt$1(ye, me, fe.name)) {
        const { message: fr } = N("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(fe)}`);
        throw new Error(fr);
      }
    }, this.isValidDisconnect = async (s) => {
      if (!Ht$1(s)) {
        const { message: fe } = N("MISSING_OR_INVALID", `disconnect() params: ${s}`);
        throw new Error(fe);
      }
      const { topic: o } = s;
      await this.isValidSessionOrPairingTopic(o);
    }, this.getVerifyContext = async (s, o) => {
      const fe = { verified: { verifyUrl: o.verifyUrl || $, validation: "UNKNOWN", origin: o.url || "" } };
      try {
        const me = await this.client.core.verify.resolve({ attestationId: s, verifyUrl: o.verifyUrl });
        me && (fe.verified.origin = me.origin, fe.verified.isScam = me.isScam, fe.verified.validation = me.origin === new URL(o.url).origin ? "VALID" : "INVALID");
      } catch (me) {
        this.client.logger.info(me);
      }
      return this.client.logger.info(`Verify context: ${JSON.stringify(fe)}`), fe;
    }, this.validateSessionProps = (s, o) => {
      Object.values(s).forEach((fe) => {
        if (!h$1(fe, !1)) {
          const { message: me } = N("MISSING_OR_INVALID", `${o} must be in Record<string, string> format. Received: ${JSON.stringify(fe)}`);
          throw new Error(me);
        }
      });
    };
  }
  async isInitialized() {
    if (!this.initialized) {
      const { message: e } = N("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
    await this.client.core.relayer.confirmOnlineStateOrThrow();
  }
  registerRelayerEvents() {
    this.client.core.relayer.on(D.message, async (e) => {
      const { topic: s, message: o } = e;
      if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(o)))
        return;
      const fe = await this.client.core.crypto.decode(s, o);
      try {
        isJsonRpcRequest(fe) ? (this.client.core.history.set(s, fe), this.onRelayEventRequest({ topic: s, payload: fe })) : isJsonRpcResponse(fe) ? (await this.client.core.history.resolve(fe), await this.onRelayEventResponse({ topic: s, payload: fe }), this.client.core.history.delete(s, fe.id)) : this.onRelayEventUnknownPayload({ topic: s, payload: fe });
      } catch (me) {
        this.client.logger.error(me);
      }
    });
  }
  registerExpirerEvents() {
    this.client.core.expirer.on(v.expired, async (e) => {
      const { topic: s, id: o } = ft$1(e.target);
      if (o && this.client.pendingRequest.keys.includes(o))
        return await this.deletePendingSessionRequest(o, N("EXPIRED"), !0);
      s ? this.client.session.keys.includes(s) && (await this.deleteSession(s, !0), this.client.events.emit("session_expire", { topic: s })) : o && (await this.deleteProposal(o, !0), this.client.events.emit("proposal_expire", { id: o }));
    });
  }
  registerPairingEvents() {
    this.client.core.pairing.events.on(V$1.create, (e) => this.onPairingCreated(e));
  }
  isValidPairingTopic(e) {
    if (!h$1(e, !1)) {
      const { message: s } = N("MISSING_OR_INVALID", `pairing topic should be a string: ${e}`);
      throw new Error(s);
    }
    if (!this.client.core.pairing.pairings.keys.includes(e)) {
      const { message: s } = N("NO_MATCHING_KEY", `pairing topic doesn't exist: ${e}`);
      throw new Error(s);
    }
    if (mt$1(this.client.core.pairing.pairings.get(e).expiry)) {
      const { message: s } = N("EXPIRED", `pairing topic: ${e}`);
      throw new Error(s);
    }
  }
  async isValidSessionTopic(e) {
    if (!h$1(e, !1)) {
      const { message: s } = N("MISSING_OR_INVALID", `session topic should be a string: ${e}`);
      throw new Error(s);
    }
    if (!this.client.session.keys.includes(e)) {
      const { message: s } = N("NO_MATCHING_KEY", `session topic doesn't exist: ${e}`);
      throw new Error(s);
    }
    if (mt$1(this.client.session.get(e).expiry)) {
      await this.deleteSession(e);
      const { message: s } = N("EXPIRED", `session topic: ${e}`);
      throw new Error(s);
    }
  }
  async isValidSessionOrPairingTopic(e) {
    if (this.client.session.keys.includes(e))
      await this.isValidSessionTopic(e);
    else if (this.client.core.pairing.pairings.keys.includes(e))
      this.isValidPairingTopic(e);
    else if (h$1(e, !1)) {
      const { message: s } = N("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${e}`);
      throw new Error(s);
    } else {
      const { message: s } = N("MISSING_OR_INVALID", `session or pairing topic should be a string: ${e}`);
      throw new Error(s);
    }
  }
  async isValidProposalId(e) {
    if (!Ft$1(e)) {
      const { message: s } = N("MISSING_OR_INVALID", `proposal id should be a number: ${e}`);
      throw new Error(s);
    }
    if (!this.client.proposal.keys.includes(e)) {
      const { message: s } = N("NO_MATCHING_KEY", `proposal id doesn't exist: ${e}`);
      throw new Error(s);
    }
    if (mt$1(this.client.proposal.get(e).expiry)) {
      await this.deleteProposal(e);
      const { message: s } = N("EXPIRED", `proposal id: ${e}`);
      throw new Error(s);
    }
  }
}
class us extends Kt {
  constructor(e, s) {
    super(e, s, ne, G), this.core = e, this.logger = s;
  }
}
class ue extends Kt {
  constructor(e, s) {
    super(e, s, ae, G), this.core = e, this.logger = s;
  }
}
class gs extends Kt {
  constructor(e, s) {
    super(e, s, le, G, (o) => o.id), this.core = e, this.logger = s;
  }
}
class Q extends b$2 {
  constructor(e) {
    super(e), this.protocol = X, this.version = F, this.name = M.name, this.events = new events.exports.EventEmitter(), this.on = (o, fe) => this.events.on(o, fe), this.once = (o, fe) => this.events.once(o, fe), this.off = (o, fe) => this.events.off(o, fe), this.removeListener = (o, fe) => this.events.removeListener(o, fe), this.removeAllListeners = (o) => this.events.removeAllListeners(o), this.connect = async (o) => {
      try {
        return await this.engine.connect(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.pair = async (o) => {
      try {
        return await this.engine.pair(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.approve = async (o) => {
      try {
        return await this.engine.approve(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.reject = async (o) => {
      try {
        return await this.engine.reject(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.update = async (o) => {
      try {
        return await this.engine.update(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.extend = async (o) => {
      try {
        return await this.engine.extend(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.request = async (o) => {
      try {
        return await this.engine.request(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.respond = async (o) => {
      try {
        return await this.engine.respond(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.ping = async (o) => {
      try {
        return await this.engine.ping(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.emit = async (o) => {
      try {
        return await this.engine.emit(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.disconnect = async (o) => {
      try {
        return await this.engine.disconnect(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.find = (o) => {
      try {
        return this.engine.find(o);
      } catch (fe) {
        throw this.logger.error(fe.message), fe;
      }
    }, this.getPendingSessionRequests = () => {
      try {
        return this.engine.getPendingSessionRequests();
      } catch (o) {
        throw this.logger.error(o.message), o;
      }
    }, this.name = (e == null ? void 0 : e.name) || M.name, this.metadata = (e == null ? void 0 : e.metadata) || Qn();
    const s = typeof (e == null ? void 0 : e.logger) < "u" && typeof (e == null ? void 0 : e.logger) != "string" ? e.logger : cjs$3.pino(cjs$3.getDefaultLoggerOptions({ level: (e == null ? void 0 : e.logger) || M.logger }));
    this.core = (e == null ? void 0 : e.core) || new Mr(e), this.logger = cjs$3.generateChildLogger(s, this.name), this.session = new ue(this.core, this.logger), this.proposal = new us(this.core, this.logger), this.pendingRequest = new gs(this.core, this.logger), this.engine = new ds(this);
  }
  static async init(e) {
    const s = new Q(e);
    return await s.initialize(), s;
  }
  get context() {
    return cjs$3.getLoggerContext(this.logger);
  }
  get pairing() {
    return this.core.pairing.pairings;
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({ verifyUrl: this.metadata.verifyUrl }), this.logger.info("SignClient Initialization Success");
    } catch (e) {
      throw this.logger.info("SignClient Initialization Failure"), this.logger.error(e.message), e;
    }
  }
}
const ms = ue, ws = Q, index_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ENGINE_CONTEXT: ce,
  ENGINE_QUEUE_STATES: I,
  ENGINE_RPC_OPTS: V,
  HISTORY_CONTEXT: rs,
  HISTORY_EVENTS: is,
  HISTORY_STORAGE_VERSION: ns,
  METHODS_TO_VERIFY: pe,
  PROPOSAL_CONTEXT: ne,
  PROPOSAL_EXPIRY: os,
  PROPOSAL_EXPIRY_MESSAGE: oe,
  REQUEST_CONTEXT: le,
  SESSION_CONTEXT: ae,
  SESSION_EXPIRY: A,
  SESSION_REQUEST_EXPIRY_BOUNDARIES: U,
  SIGN_CLIENT_CONTEXT: H,
  SIGN_CLIENT_DEFAULT: M,
  SIGN_CLIENT_EVENTS: ss,
  SIGN_CLIENT_PROTOCOL: X,
  SIGN_CLIENT_STORAGE_OPTIONS: ts,
  SIGN_CLIENT_STORAGE_PREFIX: G,
  SIGN_CLIENT_VERSION: F,
  SessionStore: ms,
  SignClient: ws,
  WALLETCONNECT_DEEPLINK_CHOICE: W,
  default: Q
}, Symbol.toStringTag, { value: "Module" })), require$$1 = /* @__PURE__ */ getAugmentedNamespace(index_es), require$$2 = /* @__PURE__ */ getAugmentedNamespace(index_es$1);
var constants$1 = {}, operation = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.OptionalOperation = r.Operation = void 0, function(e) {
    e.SIGN_TRANSACTION = "mvx_signTransaction", e.SIGN_TRANSACTIONS = "mvx_signTransactions", e.SIGN_MESSAGE = "mvx_signMessage";
  }(r.Operation || (r.Operation = {})), function(e) {
    e.SIGN_LOGIN_TOKEN = "mvx_signLoginToken", e.SIGN_NATIVE_AUTH_TOKEN = "mvx_signNativeAuthToken", e.CANCEL_ACTION = "mvx_cancelAction";
  }(r.OptionalOperation || (r.OptionalOperation = {}));
})(operation);
Object.defineProperty(constants$1, "__esModule", { value: !0 });
constants$1.WALLETCONNECT_SIGN_LOGIN_DELAY = constants$1.WALLETCONNECT_MULTIVERSX_OPTIONAL_METHODS = constants$1.WALLETCONNECT_MULTIVERSX_METHODS = constants$1.WALLETCONNECT_MULTIVERSX_NAMESPACE = void 0;
const operation_1$1 = operation;
constants$1.WALLETCONNECT_MULTIVERSX_NAMESPACE = "mvx";
constants$1.WALLETCONNECT_MULTIVERSX_METHODS = Object.values(operation_1$1.Operation);
constants$1.WALLETCONNECT_MULTIVERSX_OPTIONAL_METHODS = Object.values(operation_1$1.OptionalOperation);
constants$1.WALLETCONNECT_SIGN_LOGIN_DELAY = 200;
var errors$1 = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.WalletConnectV2ProviderErrorMessagesEnum = r.ErrBadAddress = r.ErrNotImplemented = r.Err = void 0;
  class e extends Error {
    constructor(me, ye) {
      super(me), this.inner = void 0, this.inner = ye;
    }
  }
  r.Err = e;
  class s extends e {
    constructor() {
      super("Method not yet implemented");
    }
  }
  r.ErrNotImplemented = s;
  class o extends e {
    constructor(me, ye) {
      super(`Bad address: ${me}`, ye);
    }
  }
  r.ErrBadAddress = o, function(fe) {
    fe.unableToInit = "WalletConnect is unable to init", fe.notInitialized = "WalletConnect is not initialized", fe.unableToConnect = "WalletConnect is unable to connect", fe.unableToConnectExisting = "WalletConnect is unable to connect to existing pairing", fe.unableToSignLoginToken = "WalletConnect could not sign login token", fe.unableToSign = "WalletConnect could not sign the message", fe.unableToLogin = "WalletConnect is unable to login", fe.unableToHandleTopic = "WalletConnect: Unable to handle topic update", fe.unableToHandleEvent = "WalletConnect: Unable to handle events", fe.unableToHandleCleanup = "WalletConnect: Unable to handle cleanup", fe.sessionNotConnected = "WalletConnect Session is not connected", fe.sessionDeleted = "WalletConnect Session Deleted", fe.sessionExpired = "WalletConnect Session Expired", fe.alreadyLoggedOut = "WalletConnect: Already logged out", fe.pingFailed = "WalletConnect Ping Failed", fe.invalidAddress = "WalletConnect: Invalid address", fe.requestDifferentChain = "WalletConnect: Request Chain Id different than Connection Chain Id", fe.invalidMessageResponse = "WalletConnect could not sign the message", fe.invalidMessageSignature = "WalletConnect: Invalid message signature", fe.invalidTransactionResponse = "WalletConnect could not sign the transactions. Invalid signatures", fe.invalidCustomRequestResponse = "WalletConnect could not send the custom request", fe.transactionError = "Transaction canceled", fe.connectionError = "WalletConnect could not establish a connection", fe.invalidGuardian = "WalletConnect: Invalid Guardian";
  }(r.WalletConnectV2ProviderErrorMessagesEnum || (r.WalletConnectV2ProviderErrorMessagesEnum = {}));
})(errors$1);
var logger = {};
Object.defineProperty(logger, "__esModule", { value: !0 });
logger.Logger = void 0;
class Logger {
  static error(e) {
    console.error(e);
  }
  static trace(e) {
    console.trace(e);
  }
}
logger.Logger = Logger;
var utils$5 = {}, __awaiter$2 = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
};
Object.defineProperty(utils$5, "__esModule", { value: !0 });
utils$5.sleep = utils$5.getMetadata = utils$5.applyTransactionSignature = utils$5.getAddressFromSession = utils$5.addressIsValid = utils$5.getConnectionParams = utils$5.getCurrentTopic = utils$5.getCurrentSession = void 0;
const sdk_core_1 = out$4, signature_1 = signature, utils_1 = require$$2, constants_1$1 = constants$1, errors_1$1 = errors$1, logger_1 = logger, operation_1 = operation;
function getCurrentSession(r, e) {
  if (!e)
    throw new Error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
  const s = e.find(getConnectionParams(r)).filter((o) => o.acknowledged);
  if (s.length > 0) {
    const o = s.length - 1;
    return s[o];
  }
  if (e.session.length > 0) {
    const o = e.session.keys.length - 1;
    return e.session.get(e.session.keys[o]);
  }
  throw logger_1.Logger.error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected), new Error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
}
utils$5.getCurrentSession = getCurrentSession;
function getCurrentTopic(r, e) {
  if (!e)
    throw new Error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
  const s = getCurrentSession(r, e);
  if (!(s != null && s.topic))
    throw new Error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
  return s.topic;
}
utils$5.getCurrentTopic = getCurrentTopic;
function getConnectionParams(r, e) {
  var s, o, fe;
  const me = [
    ...constants_1$1.WALLETCONNECT_MULTIVERSX_METHODS,
    ...(s = e == null ? void 0 : e.methods) !== null && s !== void 0 ? s : []
  ];
  !((o = e == null ? void 0 : e.methods) === null || o === void 0) && o.includes(operation_1.OptionalOperation.SIGN_LOGIN_TOKEN) || me.push(operation_1.OptionalOperation.SIGN_LOGIN_TOKEN);
  const ye = [`${constants_1$1.WALLETCONNECT_MULTIVERSX_NAMESPACE}:${r}`], fr = (fe = e == null ? void 0 : e.events) !== null && fe !== void 0 ? fe : [];
  return {
    requiredNamespaces: {
      [constants_1$1.WALLETCONNECT_MULTIVERSX_NAMESPACE]: {
        methods: me,
        chains: ye,
        events: fr
      }
    }
  };
}
utils$5.getConnectionParams = getConnectionParams;
function addressIsValid$1(r) {
  try {
    return !sdk_core_1.Address.fromBech32(r).isEmpty();
  } catch {
    return !1;
  }
}
utils$5.addressIsValid = addressIsValid$1;
function getAddressFromSession(r) {
  const e = r.namespaces[constants_1$1.WALLETCONNECT_MULTIVERSX_NAMESPACE];
  if (e && e.accounts) {
    const s = e.accounts[0], [o, fe, me] = s.split(":");
    return me;
  }
  return "";
}
utils$5.getAddressFromSession = getAddressFromSession;
function applyTransactionSignature({ transaction: r, response: e }) {
  if (!e)
    throw logger_1.Logger.error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.invalidTransactionResponse), new Error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.invalidTransactionResponse);
  const { signature: s, guardianSignature: o, version: fe, options: me, guardian: ye } = e, fr = r.getGuardian().bech32();
  if (fr && fr !== ye)
    throw logger_1.Logger.error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.invalidGuardian), new Error(errors_1$1.WalletConnectV2ProviderErrorMessagesEnum.invalidGuardian);
  return ye && r.setGuardian(sdk_core_1.Address.fromBech32(ye)), fe && r.setVersion(fe), me != null && r.setOptions(me), r.applySignature(new signature_1.Signature(s)), o && r.applyGuardianSignature(new signature_1.Signature(o)), r;
}
utils$5.applyTransactionSignature = applyTransactionSignature;
function getMetadata(r) {
  if (r)
    return Object.assign(Object.assign({}, r), { url: utils_1.getAppMetadata().url });
}
utils$5.getMetadata = getMetadata;
function sleep$1(r) {
  return __awaiter$2(this, void 0, void 0, function* () {
    return yield new Promise((e) => setTimeout(() => {
      e();
    }, r));
  });
}
utils$5.sleep = sleep$1;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__awaiter || function(Gr, Vr, jr, Kr) {
    function bn(Yr) {
      return Yr instanceof jr ? Yr : new jr(function(Zr) {
        Zr(Yr);
      });
    }
    return new (jr || (jr = Promise))(function(Yr, Zr) {
      function ti(In) {
        try {
          ni(Kr.next(In));
        } catch (Br) {
          Zr(Br);
        }
      }
      function On(In) {
        try {
          ni(Kr.throw(In));
        } catch (Br) {
          Zr(Br);
        }
      }
      function ni(In) {
        In.done ? Yr(In.value) : bn(In.value).then(ti, On);
      }
      ni((Kr = Kr.apply(Gr, Vr || [])).next());
    });
  }, s = commonjsGlobal && commonjsGlobal.__importDefault || function(Gr) {
    return Gr && Gr.__esModule ? Gr : { default: Gr };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.WalletConnectV2Provider = r.OptionalOperation = r.Operation = r.WalletConnectV2ProviderErrorMessagesEnum = void 0;
  const o = signature, fe = s(require$$1), me = require$$2, ye = constants$1, fr = errors$1;
  Object.defineProperty(r, "WalletConnectV2ProviderErrorMessagesEnum", { enumerable: !0, get: function() {
    return fr.WalletConnectV2ProviderErrorMessagesEnum;
  } });
  const Er = logger, br = operation;
  Object.defineProperty(r, "Operation", { enumerable: !0, get: function() {
    return br.Operation;
  } }), Object.defineProperty(r, "OptionalOperation", { enumerable: !0, get: function() {
    return br.OptionalOperation;
  } });
  const wr = utils$5;
  class kr {
    constructor(Vr, jr, Kr, bn, Yr) {
      this.chainId = "", this.address = "", this.signature = "", this.isInitializing = !1, this.processingTopic = "", this.options = {}, this.onClientConnect = Vr, this.chainId = jr, this.walletConnectV2Relay = Kr, this.walletConnectV2ProjectId = bn, this.options = Yr;
    }
    reset() {
      this.address = "", this.signature = "", this.walletConnector = void 0, this.session = void 0, this.pairings = void 0;
    }
    init() {
      var Vr, jr;
      return e(this, void 0, void 0, function* () {
        if (this.isInitialized())
          return this.isInitialized();
        try {
          if (!this.isInitializing) {
            this.isInitializing = !0, this.reset();
            const Kr = !((Vr = this.options) === null || Vr === void 0) && Vr.metadata ? {
              metadata: wr.getMetadata((jr = this.options) === null || jr === void 0 ? void 0 : jr.metadata)
            } : {}, bn = yield fe.default.init(Object.assign(Object.assign(Object.assign({}, this.options), { relayUrl: this.walletConnectV2Relay, projectId: this.walletConnectV2ProjectId }), Kr));
            this.walletConnector = bn, this.isInitializing = !1, yield this.subscribeToEvents(bn), yield this.checkPersistedState(bn);
          }
        } catch {
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToInit);
        } finally {
          return this.isInitializing = !1, this.isInitialized();
        }
      });
    }
    isInitialized() {
      return !!this.walletConnector && !this.isInitializing;
    }
    isConnected() {
      return new Promise((Vr, jr) => Vr(Boolean(this.isInitialized() && typeof this.session < "u")));
    }
    connect(Vr) {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        const jr = wr.getConnectionParams(this.chainId, Vr);
        try {
          return yield this.walletConnector.connect(Object.assign({ pairingTopic: Vr == null ? void 0 : Vr.topic }, jr));
        } catch {
          throw this.reset(), Er.Logger.error(Vr != null && Vr.topic ? fr.WalletConnectV2ProviderErrorMessagesEnum.unableToConnectExisting : fr.WalletConnectV2ProviderErrorMessagesEnum.unableToConnect), new Error(Vr != null && Vr.topic ? fr.WalletConnectV2ProviderErrorMessagesEnum.unableToConnectExisting : fr.WalletConnectV2ProviderErrorMessagesEnum.unableToConnect);
        }
      });
    }
    login(Vr) {
      var jr;
      return e(this, void 0, void 0, function* () {
        if (this.isInitializing = !0, typeof this.walletConnector > "u" && (yield this.connect()), typeof this.walletConnector > "u")
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        typeof this.session < "u" && (yield this.logout({ topic: (jr = this.session) === null || jr === void 0 ? void 0 : jr.topic }));
        try {
          if (Vr && Vr.approval) {
            const Kr = yield Vr.approval();
            if (Vr.token) {
              yield wr.sleep(ye.WALLETCONNECT_SIGN_LOGIN_DELAY);
              const bn = wr.getAddressFromSession(Kr), Zr = Kr.namespaces[ye.WALLETCONNECT_MULTIVERSX_NAMESPACE].methods.includes(br.OptionalOperation.SIGN_NATIVE_AUTH_TOKEN) ? br.OptionalOperation.SIGN_NATIVE_AUTH_TOKEN : br.OptionalOperation.SIGN_LOGIN_TOKEN, { signature: ti } = yield this.walletConnector.request({
                chainId: `${ye.WALLETCONNECT_MULTIVERSX_NAMESPACE}:${this.chainId}`,
                topic: Kr.topic,
                request: {
                  method: Zr,
                  params: {
                    token: Vr.token,
                    address: bn
                  }
                }
              });
              if (!ti)
                throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToSignLoginToken), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToSignLoginToken);
              return yield this.onSessionConnected({
                session: Kr,
                signature: ti
              });
            }
            return yield this.onSessionConnected({
              session: Kr,
              signature: ""
            });
          }
        } catch {
          throw this.reset(), Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToLogin), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToLogin);
        } finally {
          this.isInitializing = !1;
        }
        return "";
      });
    }
    logout(Vr) {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        try {
          if (this.processingTopic === ((Vr == null ? void 0 : Vr.topic) || wr.getCurrentTopic(this.chainId, this.walletConnector)))
            return !0;
          if (Vr != null && Vr.topic)
            this.processingTopic = Vr.topic, yield this.walletConnector.disconnect({
              topic: Vr.topic,
              reason: me.getSdkError("USER_DISCONNECTED")
            });
          else {
            const jr = wr.getCurrentTopic(this.chainId, this.walletConnector);
            this.processingTopic = jr, yield this.walletConnector.disconnect({
              topic: jr,
              reason: me.getSdkError("USER_DISCONNECTED")
            }), this.reset(), yield this.cleanupPendingPairings({ deletePairings: !0 });
          }
        } catch {
          Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.alreadyLoggedOut);
        } finally {
          this.processingTopic = "";
        }
        return !0;
      });
    }
    getAddress() {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        return this.address;
      });
    }
    getSignature() {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        return this.signature;
      });
    }
    getPairings() {
      var Vr, jr, Kr, bn, Yr;
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        return (Yr = (bn = (Kr = (jr = (Vr = this.walletConnector) === null || Vr === void 0 ? void 0 : Vr.core) === null || jr === void 0 ? void 0 : jr.pairing) === null || Kr === void 0 ? void 0 : Kr.pairings) === null || bn === void 0 ? void 0 : bn.getAll({ active: !0 })) !== null && Yr !== void 0 ? Yr : [];
      });
    }
    signMessage(Vr) {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        if (typeof this.session > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected), this.onClientConnect.onClientLogout(), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
        try {
          const jr = yield this.getAddress(), { signature: Kr } = yield this.walletConnector.request({
            chainId: `${ye.WALLETCONNECT_MULTIVERSX_NAMESPACE}:${this.chainId}`,
            topic: wr.getCurrentTopic(this.chainId, this.walletConnector),
            request: {
              method: br.Operation.SIGN_MESSAGE,
              params: {
                address: jr,
                message: Vr.message.toString()
              }
            }
          });
          if (!Kr)
            throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidMessageResponse), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidMessageResponse);
          try {
            Vr.applySignature(new o.Signature(Kr));
          } catch {
            throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidMessageSignature), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidMessageSignature);
          }
        } catch {
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToSign);
        }
        return Vr;
      });
    }
    signTransaction(Vr) {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        if (typeof this.session > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected), this.onClientConnect.onClientLogout(), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
        const jr = Vr.toPlainObject();
        if (this.chainId !== Vr.getChainID().valueOf())
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.requestDifferentChain), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.requestDifferentChain);
        try {
          const Kr = yield this.walletConnector.request({
            chainId: `${ye.WALLETCONNECT_MULTIVERSX_NAMESPACE}:${this.chainId}`,
            topic: wr.getCurrentTopic(this.chainId, this.walletConnector),
            request: {
              method: br.Operation.SIGN_TRANSACTION,
              params: {
                transaction: jr
              }
            }
          });
          return wr.applyTransactionSignature({ transaction: Vr, response: Kr });
        } catch {
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.transactionError);
        }
      });
    }
    signTransactions(Vr) {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        if (typeof this.session > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected), this.onClientConnect.onClientLogout(), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
        const jr = Vr.map((Kr) => {
          if (this.chainId !== Kr.getChainID().valueOf())
            throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.requestDifferentChain), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.requestDifferentChain);
          return Kr.toPlainObject();
        });
        try {
          const { signatures: Kr } = yield this.walletConnector.request({
            chainId: `${ye.WALLETCONNECT_MULTIVERSX_NAMESPACE}:${this.chainId}`,
            topic: wr.getCurrentTopic(this.chainId, this.walletConnector),
            request: {
              method: br.Operation.SIGN_TRANSACTIONS,
              params: {
                transactions: jr
              }
            }
          });
          if (!Kr)
            throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidTransactionResponse), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidTransactionResponse);
          if (!Array.isArray(Kr) || Vr.length !== Kr.length)
            throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidTransactionResponse);
          for (const [bn, Yr] of Vr.entries()) {
            const Zr = Kr[bn];
            wr.applyTransactionSignature({ transaction: Yr, response: Zr });
          }
          return Vr;
        } catch {
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.transactionError);
        }
      });
    }
    sendCustomRequest(Vr) {
      var jr;
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        if (typeof this.session > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected), this.onClientConnect.onClientLogout(), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
        if (!((jr = Vr == null ? void 0 : Vr.request) === null || jr === void 0) && jr.method) {
          try {
            const Kr = Object.assign({}, Vr.request);
            let { method: bn } = Kr;
            const { response: Yr } = yield this.walletConnector.request({
              chainId: `${ye.WALLETCONNECT_MULTIVERSX_NAMESPACE}:${this.chainId}`,
              topic: wr.getCurrentTopic(this.chainId, this.walletConnector),
              request: Object.assign(Object.assign({}, Kr), { method: bn })
            });
            Yr || Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidCustomRequestResponse);
          } catch {
            Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.invalidCustomRequestResponse);
          }
          return;
        }
      });
    }
    ping() {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized), new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        typeof this.session > "u" && Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionNotConnected);
        try {
          const Vr = wr.getCurrentTopic(this.chainId, this.walletConnector);
          return yield this.walletConnector.ping({
            topic: Vr
          }), !0;
        } catch {
          return Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.pingFailed), !1;
        }
      });
    }
    loginAccount(Vr) {
      return e(this, void 0, void 0, function* () {
        return Vr ? wr.addressIsValid(Vr.address) ? (this.address = Vr.address, Vr.signature && (this.signature = Vr.signature), this.onClientConnect.onClientLogin(), this.address) : (Er.Logger.error(`${fr.WalletConnectV2ProviderErrorMessagesEnum.invalidAddress} ${Vr.address}`), this.walletConnector && (yield this.logout()), "") : "";
      });
    }
    onSessionConnected(Vr) {
      return e(this, void 0, void 0, function* () {
        if (!Vr)
          return "";
        this.session = Vr.session;
        const jr = wr.getAddressFromSession(Vr.session);
        return jr ? (yield this.loginAccount({ address: jr, signature: Vr.signature }), jr) : "";
      });
    }
    handleTopicUpdateEvent({ topic: Vr }) {
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u") {
          Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
          return;
        }
        try {
          const jr = yield this.getPairings();
          if (this.address && !this.isInitializing && jr)
            if ((jr == null ? void 0 : jr.length) === 0)
              this.onClientConnect.onClientLogout();
            else {
              const Kr = jr[jr.length - 1];
              (Kr == null ? void 0 : Kr.topic) === Vr && this.onClientConnect.onClientLogout();
            }
        } catch {
          Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToHandleTopic);
        } finally {
          this.pairings = yield this.getPairings();
        }
      });
    }
    handleSessionEvents({ topic: Vr, params: jr }) {
      var Kr;
      return e(this, void 0, void 0, function* () {
        if (typeof this.walletConnector > "u")
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        if (this.session && ((Kr = this.session) === null || Kr === void 0 ? void 0 : Kr.topic) !== Vr)
          return;
        const { event: bn } = jr;
        if ((bn == null ? void 0 : bn.name) && wr.getCurrentTopic(this.chainId, this.walletConnector) === Vr) {
          const Yr = bn.data;
          this.onClientConnect.onClientEvent(Yr);
        }
      });
    }
    subscribeToEvents(Vr) {
      var jr, Kr, bn, Yr;
      return e(this, void 0, void 0, function* () {
        if (typeof Vr > "u")
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        try {
          Vr.on("session_update", ({ topic: Zr, params: ti }) => {
            var On;
            if (!this.session || ((On = this.session) === null || On === void 0 ? void 0 : On.topic) !== Zr)
              return;
            const { namespaces: ni } = ti, In = Vr.session.get(Zr), Br = Object.assign(Object.assign({}, In), { namespaces: ni });
            this.onSessionConnected({ session: Br });
          }), Vr.on("session_event", this.handleSessionEvents.bind(this)), Vr.on("session_delete", ({ topic: Zr }) => e(this, void 0, void 0, function* () {
            var ti;
            this.isInitializing && (this.onClientConnect.onClientLogout(), this.reset()), !(!this.session || ((ti = this.session) === null || ti === void 0 ? void 0 : ti.topic) !== Zr) && (Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionDeleted), this.onClientConnect.onClientLogout(), this.reset(), yield this.cleanupPendingPairings({ deletePairings: !0 }));
          })), Vr.on("session_expire", ({ topic: Zr }) => e(this, void 0, void 0, function* () {
            var ti;
            !this.session || ((ti = this.session) === null || ti === void 0 ? void 0 : ti.topic) !== Zr || (Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.sessionExpired), this.onClientConnect.onClientLogout(), this.reset(), yield this.cleanupPendingPairings({ deletePairings: !0 }));
          })), (Kr = (jr = Vr.core) === null || jr === void 0 ? void 0 : jr.pairing) === null || Kr === void 0 || Kr.events.on("pairing_delete", this.handleTopicUpdateEvent.bind(this)), (Yr = (bn = Vr.core) === null || bn === void 0 ? void 0 : bn.pairing) === null || Yr === void 0 || Yr.events.on("pairing_expire", this.handleTopicUpdateEvent.bind(this));
        } catch {
          Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToHandleEvent);
        }
      });
    }
    checkPersistedState(Vr) {
      return e(this, void 0, void 0, function* () {
        if (typeof Vr > "u")
          throw new Error(fr.WalletConnectV2ProviderErrorMessagesEnum.notInitialized);
        if (this.pairings = yield this.getPairings(), !(typeof this.session < "u") && Vr.session.length && !this.address && !this.isInitializing) {
          const jr = wr.getCurrentSession(this.chainId, Vr);
          if (jr)
            return yield this.onSessionConnected({ session: jr }), jr;
        }
      });
    }
    cleanupPendingPairings(Vr = {}) {
      var jr, Kr, bn, Yr, Zr, ti, On, ni;
      return e(this, void 0, void 0, function* () {
        if (!(typeof this.walletConnector > "u"))
          try {
            const In = (bn = (Kr = (jr = this.walletConnector.core) === null || jr === void 0 ? void 0 : jr.pairing) === null || Kr === void 0 ? void 0 : Kr.pairings) === null || bn === void 0 ? void 0 : bn.getAll({ active: !1 });
            if (!me.isValidArray(In))
              return;
            for (const Br of In)
              if (Vr.deletePairings)
                (Zr = (Yr = this.walletConnector.core) === null || Yr === void 0 ? void 0 : Yr.expirer) === null || Zr === void 0 || Zr.set(Br.topic, 0);
              else
                try {
                  yield (ni = (On = (ti = this.walletConnector.core) === null || ti === void 0 ? void 0 : ti.relayer) === null || On === void 0 ? void 0 : On.subscriber) === null || ni === void 0 ? void 0 : ni.unsubscribe(Br.topic);
                } catch {
                  Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToHandleCleanup);
                }
          } catch {
            Er.Logger.error(fr.WalletConnectV2ProviderErrorMessagesEnum.unableToHandleCleanup);
          }
      });
    }
  }
  r.WalletConnectV2Provider = kr;
})(walletConnectV2Provider);
var out = {}, walletProvider = {}, shams = function r() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, s = Symbol("test"), o = Object(s);
  if (typeof s == "string" || Object.prototype.toString.call(s) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
    return !1;
  var fe = 42;
  e[s] = fe;
  for (s in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var me = Object.getOwnPropertySymbols(e);
  if (me.length !== 1 || me[0] !== s || !Object.prototype.propertyIsEnumerable.call(e, s))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var ye = Object.getOwnPropertyDescriptor(e, s);
    if (ye.value !== fe || ye.enumerable !== !0)
      return !1;
  }
  return !0;
}, origSymbol = typeof Symbol < "u" && Symbol, hasSymbolSham = shams, hasSymbols$1 = function r() {
  return typeof origSymbol != "function" || typeof Symbol != "function" || typeof origSymbol("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham();
}, ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", slice = Array.prototype.slice, toStr$1 = Object.prototype.toString, funcType = "[object Function]", implementation$1 = function r(e) {
  var s = this;
  if (typeof s != "function" || toStr$1.call(s) !== funcType)
    throw new TypeError(ERROR_MESSAGE + s);
  for (var o = slice.call(arguments, 1), fe, me = function() {
    if (this instanceof fe) {
      var wr = s.apply(
        this,
        o.concat(slice.call(arguments))
      );
      return Object(wr) === wr ? wr : this;
    } else
      return s.apply(
        e,
        o.concat(slice.call(arguments))
      );
  }, ye = Math.max(0, s.length - o.length), fr = [], Er = 0; Er < ye; Er++)
    fr.push("$" + Er);
  if (fe = Function("binder", "return function (" + fr.join(",") + "){ return binder.apply(this,arguments); }")(me), s.prototype) {
    var br = function() {
    };
    br.prototype = s.prototype, fe.prototype = new br(), br.prototype = null;
  }
  return fe;
}, implementation = implementation$1, functionBind = Function.prototype.bind || implementation, bind$1 = functionBind, src = bind$1.call(Function.call, Object.prototype.hasOwnProperty), undefined$1, $SyntaxError = SyntaxError, $Function = Function, $TypeError$1 = TypeError, getEvalledConstructor = function(r) {
  try {
    return $Function('"use strict"; return (' + r + ").constructor;")();
  } catch {
  }
}, $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD)
  try {
    $gOPD({}, "");
  } catch {
    $gOPD = null;
  }
var throwTypeError = function() {
  throw new $TypeError$1();
}, ThrowTypeError = $gOPD ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols = hasSymbols$1(), getProto = Object.getPrototypeOf || function(r) {
  return r.__proto__;
}, needsEval = {}, TypedArray = typeof Uint8Array > "u" ? undefined$1 : getProto(Uint8Array), INTRINSICS = {
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$1,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet
}, doEval = function r(e) {
  var s;
  if (e === "%AsyncFunction%")
    s = getEvalledConstructor("async function () {}");
  else if (e === "%GeneratorFunction%")
    s = getEvalledConstructor("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    s = getEvalledConstructor("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var o = r("%AsyncGeneratorFunction%");
    o && (s = o.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var fe = r("%AsyncGenerator%");
    fe && (s = getProto(fe.prototype));
  }
  return INTRINSICS[e] = s, s;
}, LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind = functionBind, hasOwn$1 = src, $concat$1 = bind.call(Function.call, Array.prototype.concat), $spliceApply = bind.call(Function.apply, Array.prototype.splice), $replace$1 = bind.call(Function.call, String.prototype.replace), $strSlice = bind.call(Function.call, String.prototype.slice), $exec = bind.call(Function.call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function r(e) {
  var s = $strSlice(e, 0, 1), o = $strSlice(e, -1);
  if (s === "%" && o !== "%")
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  if (o === "%" && s !== "%")
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  var fe = [];
  return $replace$1(e, rePropName, function(me, ye, fr, Er) {
    fe[fe.length] = fr ? $replace$1(Er, reEscapeChar, "$1") : ye || me;
  }), fe;
}, getBaseIntrinsic = function r(e, s) {
  var o = e, fe;
  if (hasOwn$1(LEGACY_ALIASES, o) && (fe = LEGACY_ALIASES[o], o = "%" + fe[0] + "%"), hasOwn$1(INTRINSICS, o)) {
    var me = INTRINSICS[o];
    if (me === needsEval && (me = doEval(o)), typeof me > "u" && !s)
      throw new $TypeError$1("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: fe,
      name: o,
      value: me
    };
  }
  throw new $SyntaxError("intrinsic " + e + " does not exist!");
}, getIntrinsic = function r(e, s) {
  if (typeof e != "string" || e.length === 0)
    throw new $TypeError$1("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof s != "boolean")
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, e) === null)
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var o = stringToPath(e), fe = o.length > 0 ? o[0] : "", me = getBaseIntrinsic("%" + fe + "%", s), ye = me.name, fr = me.value, Er = !1, br = me.alias;
  br && (fe = br[0], $spliceApply(o, $concat$1([0, 1], br)));
  for (var wr = 1, kr = !0; wr < o.length; wr += 1) {
    var Gr = o[wr], Vr = $strSlice(Gr, 0, 1), jr = $strSlice(Gr, -1);
    if ((Vr === '"' || Vr === "'" || Vr === "`" || jr === '"' || jr === "'" || jr === "`") && Vr !== jr)
      throw new $SyntaxError("property names with quotes must have matching quotes");
    if ((Gr === "constructor" || !kr) && (Er = !0), fe += "." + Gr, ye = "%" + fe + "%", hasOwn$1(INTRINSICS, ye))
      fr = INTRINSICS[ye];
    else if (fr != null) {
      if (!(Gr in fr)) {
        if (!s)
          throw new $TypeError$1("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if ($gOPD && wr + 1 >= o.length) {
        var Kr = $gOPD(fr, Gr);
        kr = !!Kr, kr && "get" in Kr && !("originalValue" in Kr.get) ? fr = Kr.get : fr = fr[Gr];
      } else
        kr = hasOwn$1(fr, Gr), fr = fr[Gr];
      kr && !Er && (INTRINSICS[ye] = fr);
    }
  }
  return fr;
}, callBind$1 = { exports: {} };
(function(r) {
  var e = functionBind, s = getIntrinsic, o = s("%Function.prototype.apply%"), fe = s("%Function.prototype.call%"), me = s("%Reflect.apply%", !0) || e.call(fe, o), ye = s("%Object.getOwnPropertyDescriptor%", !0), fr = s("%Object.defineProperty%", !0), Er = s("%Math.max%");
  if (fr)
    try {
      fr({}, "a", { value: 1 });
    } catch {
      fr = null;
    }
  r.exports = function(kr) {
    var Gr = me(e, fe, arguments);
    if (ye && fr) {
      var Vr = ye(Gr, "length");
      Vr.configurable && fr(
        Gr,
        "length",
        { value: 1 + Er(0, kr.length - (arguments.length - 1)) }
      );
    }
    return Gr;
  };
  var br = function() {
    return me(e, o, arguments);
  };
  fr ? fr(r.exports, "apply", { value: br }) : r.exports.apply = br;
})(callBind$1);
var GetIntrinsic$1 = getIntrinsic, callBind = callBind$1.exports, $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf")), callBound$1 = function r(e, s) {
  var o = GetIntrinsic$1(e, !!s);
  return typeof o == "function" && $indexOf(e, ".prototype.") > -1 ? callBind(o) : o;
}, hasMap = typeof Map == "function" && Map.prototype, mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get == "function" ? mapSizeDescriptor.get : null, mapForEach = hasMap && Map.prototype.forEach, hasSet = typeof Set == "function" && Set.prototype, setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get == "function" ? setSizeDescriptor.get : null, setForEach = hasSet && Set.prototype.forEach, hasWeakMap = typeof WeakMap == "function" && WeakMap.prototype, weakMapHas = hasWeakMap ? WeakMap.prototype.has : null, hasWeakSet = typeof WeakSet == "function" && WeakSet.prototype, weakSetHas = hasWeakSet ? WeakSet.prototype.has : null, hasWeakRef = typeof WeakRef == "function" && WeakRef.prototype, weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null, booleanValueOf = Boolean.prototype.valueOf, objectToString$2 = Object.prototype.toString, functionToString = Function.prototype.toString, $match = String.prototype.match, $slice = String.prototype.slice, $replace = String.prototype.replace, $toUpperCase = String.prototype.toUpperCase, $toLowerCase = String.prototype.toLowerCase, $test = RegExp.prototype.test, $concat = Array.prototype.concat, $join = Array.prototype.join, $arrSlice = Array.prototype.slice, $floor = Math.floor, bigIntValueOf = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, gOPS = Object.getOwnPropertySymbols, symToString = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, hasShammedSymbols = typeof Symbol == "function" && typeof Symbol.iterator == "object", toStringTag = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null, isEnumerable = Object.prototype.propertyIsEnumerable, gPO = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(r) {
  return r.__proto__;
} : null);
function addNumericSeparator(r, e) {
  if (r === 1 / 0 || r === -1 / 0 || r !== r || r && r > -1e3 && r < 1e3 || $test.call(/e/, e))
    return e;
  var s = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof r == "number") {
    var o = r < 0 ? -$floor(-r) : $floor(r);
    if (o !== r) {
      var fe = String(o), me = $slice.call(e, fe.length + 1);
      return $replace.call(fe, s, "$&_") + "." + $replace.call($replace.call(me, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(e, s, "$&_");
}
var utilInspect = require$$0$4, inspectCustom = utilInspect.custom, inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null, objectInspect = function r(e, s, o, fe) {
  var me = s || {};
  if (has$3(me, "quoteStyle") && me.quoteStyle !== "single" && me.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (has$3(me, "maxStringLength") && (typeof me.maxStringLength == "number" ? me.maxStringLength < 0 && me.maxStringLength !== 1 / 0 : me.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var ye = has$3(me, "customInspect") ? me.customInspect : !0;
  if (typeof ye != "boolean" && ye !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (has$3(me, "indent") && me.indent !== null && me.indent !== "	" && !(parseInt(me.indent, 10) === me.indent && me.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (has$3(me, "numericSeparator") && typeof me.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var fr = me.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return inspectString(e, me);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var Er = String(e);
    return fr ? addNumericSeparator(e, Er) : Er;
  }
  if (typeof e == "bigint") {
    var br = String(e) + "n";
    return fr ? addNumericSeparator(e, br) : br;
  }
  var wr = typeof me.depth > "u" ? 5 : me.depth;
  if (typeof o > "u" && (o = 0), o >= wr && wr > 0 && typeof e == "object")
    return isArray$5(e) ? "[Array]" : "[Object]";
  var kr = getIndent(me, o);
  if (typeof fe > "u")
    fe = [];
  else if (indexOf(fe, e) >= 0)
    return "[Circular]";
  function Gr(En, qr, Jr) {
    if (qr && (fe = $arrSlice.call(fe), fe.push(qr)), Jr) {
      var ri = {
        depth: me.depth
      };
      return has$3(me, "quoteStyle") && (ri.quoteStyle = me.quoteStyle), r(En, ri, o + 1, fe);
    }
    return r(En, me, o + 1, fe);
  }
  if (typeof e == "function" && !isRegExp$1(e)) {
    var Vr = nameOf(e), jr = arrObjKeys(e, Gr);
    return "[Function" + (Vr ? ": " + Vr : " (anonymous)") + "]" + (jr.length > 0 ? " { " + $join.call(jr, ", ") + " }" : "");
  }
  if (isSymbol(e)) {
    var Kr = hasShammedSymbols ? $replace.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(e);
    return typeof e == "object" && !hasShammedSymbols ? markBoxed(Kr) : Kr;
  }
  if (isElement(e)) {
    for (var bn = "<" + $toLowerCase.call(String(e.nodeName)), Yr = e.attributes || [], Zr = 0; Zr < Yr.length; Zr++)
      bn += " " + Yr[Zr].name + "=" + wrapQuotes(quote(Yr[Zr].value), "double", me);
    return bn += ">", e.childNodes && e.childNodes.length && (bn += "..."), bn += "</" + $toLowerCase.call(String(e.nodeName)) + ">", bn;
  }
  if (isArray$5(e)) {
    if (e.length === 0)
      return "[]";
    var ti = arrObjKeys(e, Gr);
    return kr && !singleLineValues(ti) ? "[" + indentedJoin(ti, kr) + "]" : "[ " + $join.call(ti, ", ") + " ]";
  }
  if (isError(e)) {
    var On = arrObjKeys(e, Gr);
    return !("cause" in Error.prototype) && "cause" in e && !isEnumerable.call(e, "cause") ? "{ [" + String(e) + "] " + $join.call($concat.call("[cause]: " + Gr(e.cause), On), ", ") + " }" : On.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + $join.call(On, ", ") + " }";
  }
  if (typeof e == "object" && ye) {
    if (inspectSymbol && typeof e[inspectSymbol] == "function" && utilInspect)
      return utilInspect(e, { depth: wr - o });
    if (ye !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (isMap(e)) {
    var ni = [];
    return mapForEach.call(e, function(En, qr) {
      ni.push(Gr(qr, e, !0) + " => " + Gr(En, e));
    }), collectionOf("Map", mapSize.call(e), ni, kr);
  }
  if (isSet(e)) {
    var In = [];
    return setForEach.call(e, function(En) {
      In.push(Gr(En, e));
    }), collectionOf("Set", setSize.call(e), In, kr);
  }
  if (isWeakMap(e))
    return weakCollectionOf("WeakMap");
  if (isWeakSet(e))
    return weakCollectionOf("WeakSet");
  if (isWeakRef(e))
    return weakCollectionOf("WeakRef");
  if (isNumber(e))
    return markBoxed(Gr(Number(e)));
  if (isBigInt(e))
    return markBoxed(Gr(bigIntValueOf.call(e)));
  if (isBoolean(e))
    return markBoxed(booleanValueOf.call(e));
  if (isString$2(e))
    return markBoxed(Gr(String(e)));
  if (!isDate(e) && !isRegExp$1(e)) {
    var Br = arrObjKeys(e, Gr), Hr = gPO ? gPO(e) === Object.prototype : e instanceof Object || e.constructor === Object, Pn = e instanceof Object ? "" : "null prototype", ei = !Hr && toStringTag && Object(e) === e && toStringTag in e ? $slice.call(toStr(e), 8, -1) : Pn ? "Object" : "", oi = Hr || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", Nn = oi + (ei || Pn ? "[" + $join.call($concat.call([], ei || [], Pn || []), ": ") + "] " : "");
    return Br.length === 0 ? Nn + "{}" : kr ? Nn + "{" + indentedJoin(Br, kr) + "}" : Nn + "{ " + $join.call(Br, ", ") + " }";
  }
  return String(e);
};
function wrapQuotes(r, e, s) {
  var o = (s.quoteStyle || e) === "double" ? '"' : "'";
  return o + r + o;
}
function quote(r) {
  return $replace.call(String(r), /"/g, "&quot;");
}
function isArray$5(r) {
  return toStr(r) === "[object Array]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isDate(r) {
  return toStr(r) === "[object Date]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isRegExp$1(r) {
  return toStr(r) === "[object RegExp]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isError(r) {
  return toStr(r) === "[object Error]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isString$2(r) {
  return toStr(r) === "[object String]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isNumber(r) {
  return toStr(r) === "[object Number]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isBoolean(r) {
  return toStr(r) === "[object Boolean]" && (!toStringTag || !(typeof r == "object" && toStringTag in r));
}
function isSymbol(r) {
  if (hasShammedSymbols)
    return r && typeof r == "object" && r instanceof Symbol;
  if (typeof r == "symbol")
    return !0;
  if (!r || typeof r != "object" || !symToString)
    return !1;
  try {
    return symToString.call(r), !0;
  } catch {
  }
  return !1;
}
function isBigInt(r) {
  if (!r || typeof r != "object" || !bigIntValueOf)
    return !1;
  try {
    return bigIntValueOf.call(r), !0;
  } catch {
  }
  return !1;
}
var hasOwn = Object.prototype.hasOwnProperty || function(r) {
  return r in this;
};
function has$3(r, e) {
  return hasOwn.call(r, e);
}
function toStr(r) {
  return objectToString$2.call(r);
}
function nameOf(r) {
  if (r.name)
    return r.name;
  var e = $match.call(functionToString.call(r), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function indexOf(r, e) {
  if (r.indexOf)
    return r.indexOf(e);
  for (var s = 0, o = r.length; s < o; s++)
    if (r[s] === e)
      return s;
  return -1;
}
function isMap(r) {
  if (!mapSize || !r || typeof r != "object")
    return !1;
  try {
    mapSize.call(r);
    try {
      setSize.call(r);
    } catch {
      return !0;
    }
    return r instanceof Map;
  } catch {
  }
  return !1;
}
function isWeakMap(r) {
  if (!weakMapHas || !r || typeof r != "object")
    return !1;
  try {
    weakMapHas.call(r, weakMapHas);
    try {
      weakSetHas.call(r, weakSetHas);
    } catch {
      return !0;
    }
    return r instanceof WeakMap;
  } catch {
  }
  return !1;
}
function isWeakRef(r) {
  if (!weakRefDeref || !r || typeof r != "object")
    return !1;
  try {
    return weakRefDeref.call(r), !0;
  } catch {
  }
  return !1;
}
function isSet(r) {
  if (!setSize || !r || typeof r != "object")
    return !1;
  try {
    setSize.call(r);
    try {
      mapSize.call(r);
    } catch {
      return !0;
    }
    return r instanceof Set;
  } catch {
  }
  return !1;
}
function isWeakSet(r) {
  if (!weakSetHas || !r || typeof r != "object")
    return !1;
  try {
    weakSetHas.call(r, weakSetHas);
    try {
      weakMapHas.call(r, weakMapHas);
    } catch {
      return !0;
    }
    return r instanceof WeakSet;
  } catch {
  }
  return !1;
}
function isElement(r) {
  return !r || typeof r != "object" ? !1 : typeof HTMLElement < "u" && r instanceof HTMLElement ? !0 : typeof r.nodeName == "string" && typeof r.getAttribute == "function";
}
function inspectString(r, e) {
  if (r.length > e.maxStringLength) {
    var s = r.length - e.maxStringLength, o = "... " + s + " more character" + (s > 1 ? "s" : "");
    return inspectString($slice.call(r, 0, e.maxStringLength), e) + o;
  }
  var fe = $replace.call($replace.call(r, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(fe, "single", e);
}
function lowbyte(r) {
  var e = r.charCodeAt(0), s = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return s ? "\\" + s : "\\x" + (e < 16 ? "0" : "") + $toUpperCase.call(e.toString(16));
}
function markBoxed(r) {
  return "Object(" + r + ")";
}
function weakCollectionOf(r) {
  return r + " { ? }";
}
function collectionOf(r, e, s, o) {
  var fe = o ? indentedJoin(s, o) : $join.call(s, ", ");
  return r + " (" + e + ") {" + fe + "}";
}
function singleLineValues(r) {
  for (var e = 0; e < r.length; e++)
    if (indexOf(r[e], `
`) >= 0)
      return !1;
  return !0;
}
function getIndent(r, e) {
  var s;
  if (r.indent === "	")
    s = "	";
  else if (typeof r.indent == "number" && r.indent > 0)
    s = $join.call(Array(r.indent + 1), " ");
  else
    return null;
  return {
    base: s,
    prev: $join.call(Array(e + 1), s)
  };
}
function indentedJoin(r, e) {
  if (r.length === 0)
    return "";
  var s = `
` + e.prev + e.base;
  return s + $join.call(r, "," + s) + `
` + e.prev;
}
function arrObjKeys(r, e) {
  var s = isArray$5(r), o = [];
  if (s) {
    o.length = r.length;
    for (var fe = 0; fe < r.length; fe++)
      o[fe] = has$3(r, fe) ? e(r[fe], r) : "";
  }
  var me = typeof gOPS == "function" ? gOPS(r) : [], ye;
  if (hasShammedSymbols) {
    ye = {};
    for (var fr = 0; fr < me.length; fr++)
      ye["$" + me[fr]] = me[fr];
  }
  for (var Er in r)
    !has$3(r, Er) || s && String(Number(Er)) === Er && Er < r.length || hasShammedSymbols && ye["$" + Er] instanceof Symbol || ($test.call(/[^\w$]/, Er) ? o.push(e(Er, r) + ": " + e(r[Er], r)) : o.push(Er + ": " + e(r[Er], r)));
  if (typeof gOPS == "function")
    for (var br = 0; br < me.length; br++)
      isEnumerable.call(r, me[br]) && o.push("[" + e(me[br]) + "]: " + e(r[me[br]], r));
  return o;
}
var GetIntrinsic = getIntrinsic, callBound = callBound$1, inspect = objectInspect, $TypeError = GetIntrinsic("%TypeError%"), $WeakMap = GetIntrinsic("%WeakMap%", !0), $Map = GetIntrinsic("%Map%", !0), $weakMapGet = callBound("WeakMap.prototype.get", !0), $weakMapSet = callBound("WeakMap.prototype.set", !0), $weakMapHas = callBound("WeakMap.prototype.has", !0), $mapGet = callBound("Map.prototype.get", !0), $mapSet = callBound("Map.prototype.set", !0), $mapHas = callBound("Map.prototype.has", !0), listGetNode = function(r, e) {
  for (var s = r, o; (o = s.next) !== null; s = o)
    if (o.key === e)
      return s.next = o.next, o.next = r.next, r.next = o, o;
}, listGet = function(r, e) {
  var s = listGetNode(r, e);
  return s && s.value;
}, listSet = function(r, e, s) {
  var o = listGetNode(r, e);
  o ? o.value = s : r.next = {
    key: e,
    next: r.next,
    value: s
  };
}, listHas = function(r, e) {
  return !!listGetNode(r, e);
}, sideChannel = function r() {
  var e, s, o, fe = {
    assert: function(me) {
      if (!fe.has(me))
        throw new $TypeError("Side channel does not contain " + inspect(me));
    },
    get: function(me) {
      if ($WeakMap && me && (typeof me == "object" || typeof me == "function")) {
        if (e)
          return $weakMapGet(e, me);
      } else if ($Map) {
        if (s)
          return $mapGet(s, me);
      } else if (o)
        return listGet(o, me);
    },
    has: function(me) {
      if ($WeakMap && me && (typeof me == "object" || typeof me == "function")) {
        if (e)
          return $weakMapHas(e, me);
      } else if ($Map) {
        if (s)
          return $mapHas(s, me);
      } else if (o)
        return listHas(o, me);
      return !1;
    },
    set: function(me, ye) {
      $WeakMap && me && (typeof me == "object" || typeof me == "function") ? (e || (e = new $WeakMap()), $weakMapSet(e, me, ye)) : $Map ? (s || (s = new $Map()), $mapSet(s, me, ye)) : (o || (o = { key: {}, next: null }), listSet(o, me, ye));
    }
  };
  return fe;
}, replace = String.prototype.replace, percentTwenties = /%20/g, Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, formats$3 = {
  default: Format.RFC3986,
  formatters: {
    RFC1738: function(r) {
      return replace.call(r, percentTwenties, "+");
    },
    RFC3986: function(r) {
      return String(r);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
}, formats$2 = formats$3, has$2 = Object.prototype.hasOwnProperty, isArray$4 = Array.isArray, hexTable = function() {
  for (var r = [], e = 0; e < 256; ++e)
    r.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return r;
}(), compactQueue = function r(e) {
  for (; e.length > 1; ) {
    var s = e.pop(), o = s.obj[s.prop];
    if (isArray$4(o)) {
      for (var fe = [], me = 0; me < o.length; ++me)
        typeof o[me] < "u" && fe.push(o[me]);
      s.obj[s.prop] = fe;
    }
  }
}, arrayToObject = function r(e, s) {
  for (var o = s && s.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, fe = 0; fe < e.length; ++fe)
    typeof e[fe] < "u" && (o[fe] = e[fe]);
  return o;
}, merge = function r(e, s, o) {
  if (!s)
    return e;
  if (typeof s != "object") {
    if (isArray$4(e))
      e.push(s);
    else if (e && typeof e == "object")
      (o && (o.plainObjects || o.allowPrototypes) || !has$2.call(Object.prototype, s)) && (e[s] = !0);
    else
      return [e, s];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(s);
  var fe = e;
  return isArray$4(e) && !isArray$4(s) && (fe = arrayToObject(e, o)), isArray$4(e) && isArray$4(s) ? (s.forEach(function(me, ye) {
    if (has$2.call(e, ye)) {
      var fr = e[ye];
      fr && typeof fr == "object" && me && typeof me == "object" ? e[ye] = r(fr, me, o) : e.push(me);
    } else
      e[ye] = me;
  }), e) : Object.keys(s).reduce(function(me, ye) {
    var fr = s[ye];
    return has$2.call(me, ye) ? me[ye] = r(me[ye], fr, o) : me[ye] = fr, me;
  }, fe);
}, assign = function r(e, s) {
  return Object.keys(s).reduce(function(o, fe) {
    return o[fe] = s[fe], o;
  }, e);
}, decode$2 = function(r, e, s) {
  var o = r.replace(/\+/g, " ");
  if (s === "iso-8859-1")
    return o.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(o);
  } catch {
    return o;
  }
}, encode$2 = function r(e, s, o, fe, me) {
  if (e.length === 0)
    return e;
  var ye = e;
  if (typeof e == "symbol" ? ye = Symbol.prototype.toString.call(e) : typeof e != "string" && (ye = String(e)), o === "iso-8859-1")
    return escape(ye).replace(/%u[0-9a-f]{4}/gi, function(wr) {
      return "%26%23" + parseInt(wr.slice(2), 16) + "%3B";
    });
  for (var fr = "", Er = 0; Er < ye.length; ++Er) {
    var br = ye.charCodeAt(Er);
    if (br === 45 || br === 46 || br === 95 || br === 126 || br >= 48 && br <= 57 || br >= 65 && br <= 90 || br >= 97 && br <= 122 || me === formats$2.RFC1738 && (br === 40 || br === 41)) {
      fr += ye.charAt(Er);
      continue;
    }
    if (br < 128) {
      fr = fr + hexTable[br];
      continue;
    }
    if (br < 2048) {
      fr = fr + (hexTable[192 | br >> 6] + hexTable[128 | br & 63]);
      continue;
    }
    if (br < 55296 || br >= 57344) {
      fr = fr + (hexTable[224 | br >> 12] + hexTable[128 | br >> 6 & 63] + hexTable[128 | br & 63]);
      continue;
    }
    Er += 1, br = 65536 + ((br & 1023) << 10 | ye.charCodeAt(Er) & 1023), fr += hexTable[240 | br >> 18] + hexTable[128 | br >> 12 & 63] + hexTable[128 | br >> 6 & 63] + hexTable[128 | br & 63];
  }
  return fr;
}, compact = function r(e) {
  for (var s = [{ obj: { o: e }, prop: "o" }], o = [], fe = 0; fe < s.length; ++fe)
    for (var me = s[fe], ye = me.obj[me.prop], fr = Object.keys(ye), Er = 0; Er < fr.length; ++Er) {
      var br = fr[Er], wr = ye[br];
      typeof wr == "object" && wr !== null && o.indexOf(wr) === -1 && (s.push({ obj: ye, prop: br }), o.push(wr));
    }
  return compactQueue(s), e;
}, isRegExp = function r(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, isBuffer = function r(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, combine = function r(e, s) {
  return [].concat(e, s);
}, maybeMap = function r(e, s) {
  if (isArray$4(e)) {
    for (var o = [], fe = 0; fe < e.length; fe += 1)
      o.push(s(e[fe]));
    return o;
  }
  return s(e);
}, utils$4 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode: decode$2,
  encode: encode$2,
  isBuffer,
  isRegExp,
  maybeMap,
  merge
}, getSideChannel = sideChannel, utils$3 = utils$4, formats$1 = formats$3, has$1 = Object.prototype.hasOwnProperty, arrayPrefixGenerators = {
  brackets: function r(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function r(e, s) {
    return e + "[" + s + "]";
  },
  repeat: function r(e) {
    return e;
  }
}, isArray$3 = Array.isArray, split = String.prototype.split, push = Array.prototype.push, pushToArray = function(r, e) {
  push.apply(r, isArray$3(e) ? e : [e]);
}, toISO = Date.prototype.toISOString, defaultFormat = formats$1.default, defaults$1 = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: utils$3.encode,
  encodeValuesOnly: !1,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  indices: !1,
  serializeDate: function r(e) {
    return toISO.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, isNonNullishPrimitive = function r(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, sentinel = {}, stringify$1 = function r(e, s, o, fe, me, ye, fr, Er, br, wr, kr, Gr, Vr, jr, Kr) {
  for (var bn = e, Yr = Kr, Zr = 0, ti = !1; (Yr = Yr.get(sentinel)) !== void 0 && !ti; ) {
    var On = Yr.get(e);
    if (Zr += 1, typeof On < "u") {
      if (On === Zr)
        throw new RangeError("Cyclic object value");
      ti = !0;
    }
    typeof Yr.get(sentinel) > "u" && (Zr = 0);
  }
  if (typeof fr == "function" ? bn = fr(s, bn) : bn instanceof Date ? bn = wr(bn) : o === "comma" && isArray$3(bn) && (bn = utils$3.maybeMap(bn, function(Sn) {
    return Sn instanceof Date ? wr(Sn) : Sn;
  })), bn === null) {
    if (fe)
      return ye && !Vr ? ye(s, defaults$1.encoder, jr, "key", kr) : s;
    bn = "";
  }
  if (isNonNullishPrimitive(bn) || utils$3.isBuffer(bn)) {
    if (ye) {
      var ni = Vr ? s : ye(s, defaults$1.encoder, jr, "key", kr);
      if (o === "comma" && Vr) {
        for (var In = split.call(String(bn), ","), Br = "", Hr = 0; Hr < In.length; ++Hr)
          Br += (Hr === 0 ? "" : ",") + Gr(ye(In[Hr], defaults$1.encoder, jr, "value", kr));
        return [Gr(ni) + "=" + Br];
      }
      return [Gr(ni) + "=" + Gr(ye(bn, defaults$1.encoder, jr, "value", kr))];
    }
    return [Gr(s) + "=" + Gr(String(bn))];
  }
  var Pn = [];
  if (typeof bn > "u")
    return Pn;
  var ei;
  if (o === "comma" && isArray$3(bn))
    ei = [{ value: bn.length > 0 ? bn.join(",") || null : void 0 }];
  else if (isArray$3(fr))
    ei = fr;
  else {
    var oi = Object.keys(bn);
    ei = Er ? oi.sort(Er) : oi;
  }
  for (var Nn = 0; Nn < ei.length; ++Nn) {
    var En = ei[Nn], qr = typeof En == "object" && typeof En.value < "u" ? En.value : bn[En];
    if (!(me && qr === null)) {
      var Jr = isArray$3(bn) ? typeof o == "function" ? o(s, En) : s : s + (br ? "." + En : "[" + En + "]");
      Kr.set(e, Zr);
      var ri = getSideChannel();
      ri.set(sentinel, Kr), pushToArray(Pn, r(
        qr,
        Jr,
        o,
        fe,
        me,
        ye,
        fr,
        Er,
        br,
        wr,
        kr,
        Gr,
        Vr,
        jr,
        ri
      ));
    }
  }
  return Pn;
}, normalizeStringifyOptions = function r(e) {
  if (!e)
    return defaults$1;
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var s = e.charset || defaults$1.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var o = formats$1.default;
  if (typeof e.format < "u") {
    if (!has$1.call(formats$1.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    o = e.format;
  }
  var fe = formats$1.formatters[o], me = defaults$1.filter;
  return (typeof e.filter == "function" || isArray$3(e.filter)) && (me = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? defaults$1.allowDots : !!e.allowDots,
    charset: s,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? defaults$1.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : defaults$1.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter: me,
    format: o,
    formatter: fe,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : defaults$1.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : defaults$1.strictNullHandling
  };
}, stringify_1 = function(r, e) {
  var s = r, o = normalizeStringifyOptions(e), fe, me;
  typeof o.filter == "function" ? (me = o.filter, s = me("", s)) : isArray$3(o.filter) && (me = o.filter, fe = me);
  var ye = [];
  if (typeof s != "object" || s === null)
    return "";
  var fr;
  e && e.arrayFormat in arrayPrefixGenerators ? fr = e.arrayFormat : e && "indices" in e ? fr = e.indices ? "indices" : "repeat" : fr = "indices";
  var Er = arrayPrefixGenerators[fr];
  fe || (fe = Object.keys(s)), o.sort && fe.sort(o.sort);
  for (var br = getSideChannel(), wr = 0; wr < fe.length; ++wr) {
    var kr = fe[wr];
    o.skipNulls && s[kr] === null || pushToArray(ye, stringify$1(
      s[kr],
      kr,
      Er,
      o.strictNullHandling,
      o.skipNulls,
      o.encode ? o.encoder : null,
      o.filter,
      o.sort,
      o.allowDots,
      o.serializeDate,
      o.format,
      o.formatter,
      o.encodeValuesOnly,
      o.charset,
      br
    ));
  }
  var Gr = ye.join(o.delimiter), Vr = o.addQueryPrefix === !0 ? "?" : "";
  return o.charsetSentinel && (o.charset === "iso-8859-1" ? Vr += "utf8=%26%2310003%3B&" : Vr += "utf8=%E2%9C%93&"), Gr.length > 0 ? Vr + Gr : "";
}, utils$2 = utils$4, has = Object.prototype.hasOwnProperty, isArray$2 = Array.isArray, defaults = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: utils$2.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, interpretNumericEntities = function(r) {
  return r.replace(/&#(\d+);/g, function(e, s) {
    return String.fromCharCode(parseInt(s, 10));
  });
}, parseArrayValue = function(r, e) {
  return r && typeof r == "string" && e.comma && r.indexOf(",") > -1 ? r.split(",") : r;
}, isoSentinel = "utf8=%26%2310003%3B", charsetSentinel = "utf8=%E2%9C%93", parseValues = function r(e, s) {
  var o = {}, fe = s.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, me = s.parameterLimit === 1 / 0 ? void 0 : s.parameterLimit, ye = fe.split(s.delimiter, me), fr = -1, Er, br = s.charset;
  if (s.charsetSentinel)
    for (Er = 0; Er < ye.length; ++Er)
      ye[Er].indexOf("utf8=") === 0 && (ye[Er] === charsetSentinel ? br = "utf-8" : ye[Er] === isoSentinel && (br = "iso-8859-1"), fr = Er, Er = ye.length);
  for (Er = 0; Er < ye.length; ++Er)
    if (Er !== fr) {
      var wr = ye[Er], kr = wr.indexOf("]="), Gr = kr === -1 ? wr.indexOf("=") : kr + 1, Vr, jr;
      Gr === -1 ? (Vr = s.decoder(wr, defaults.decoder, br, "key"), jr = s.strictNullHandling ? null : "") : (Vr = s.decoder(wr.slice(0, Gr), defaults.decoder, br, "key"), jr = utils$2.maybeMap(
        parseArrayValue(wr.slice(Gr + 1), s),
        function(Kr) {
          return s.decoder(Kr, defaults.decoder, br, "value");
        }
      )), jr && s.interpretNumericEntities && br === "iso-8859-1" && (jr = interpretNumericEntities(jr)), wr.indexOf("[]=") > -1 && (jr = isArray$2(jr) ? [jr] : jr), has.call(o, Vr) ? o[Vr] = utils$2.combine(o[Vr], jr) : o[Vr] = jr;
    }
  return o;
}, parseObject = function(r, e, s, o) {
  for (var fe = o ? e : parseArrayValue(e, s), me = r.length - 1; me >= 0; --me) {
    var ye, fr = r[me];
    if (fr === "[]" && s.parseArrays)
      ye = [].concat(fe);
    else {
      ye = s.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var Er = fr.charAt(0) === "[" && fr.charAt(fr.length - 1) === "]" ? fr.slice(1, -1) : fr, br = parseInt(Er, 10);
      !s.parseArrays && Er === "" ? ye = { 0: fe } : !isNaN(br) && fr !== Er && String(br) === Er && br >= 0 && s.parseArrays && br <= s.arrayLimit ? (ye = [], ye[br] = fe) : Er !== "__proto__" && (ye[Er] = fe);
    }
    fe = ye;
  }
  return fe;
}, parseKeys = function r(e, s, o, fe) {
  if (!!e) {
    var me = o.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, ye = /(\[[^[\]]*])/, fr = /(\[[^[\]]*])/g, Er = o.depth > 0 && ye.exec(me), br = Er ? me.slice(0, Er.index) : me, wr = [];
    if (br) {
      if (!o.plainObjects && has.call(Object.prototype, br) && !o.allowPrototypes)
        return;
      wr.push(br);
    }
    for (var kr = 0; o.depth > 0 && (Er = fr.exec(me)) !== null && kr < o.depth; ) {
      if (kr += 1, !o.plainObjects && has.call(Object.prototype, Er[1].slice(1, -1)) && !o.allowPrototypes)
        return;
      wr.push(Er[1]);
    }
    return Er && wr.push("[" + me.slice(Er.index) + "]"), parseObject(wr, s, o, fe);
  }
}, normalizeParseOptions = function r(e) {
  if (!e)
    return defaults;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var s = typeof e.charset > "u" ? defaults.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? defaults.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : defaults.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : defaults.arrayLimit,
    charset: s,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : defaults.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : defaults.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : defaults.decoder,
    delimiter: typeof e.delimiter == "string" || utils$2.isRegExp(e.delimiter) ? e.delimiter : defaults.delimiter,
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : defaults.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : defaults.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : defaults.strictNullHandling
  };
}, parse$2 = function(r, e) {
  var s = normalizeParseOptions(e);
  if (r === "" || r === null || typeof r > "u")
    return s.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var o = typeof r == "string" ? parseValues(r, s) : r, fe = s.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, me = Object.keys(o), ye = 0; ye < me.length; ++ye) {
    var fr = me[ye], Er = parseKeys(fr, o[fr], s, typeof r == "string");
    fe = utils$2.merge(fe, Er, s);
  }
  return s.allowSparse === !0 ? fe : utils$2.compact(fe);
}, stringify = stringify_1, parse$1 = parse$2, formats = formats$3, lib = {
  formats,
  parse: parse$1,
  stringify
}, constants = {};
Object.defineProperty(constants, "__esModule", { value: !0 });
constants.WALLET_PROVIDER_CALLBACK_PARAM_TX_SIGNED = constants.WALLET_PROVIDER_CALLBACK_PARAM = constants.WALLET_PROVIDER_SIGN_MESSAGE_URL = constants.WALLET_PROVIDER_GUARD_TRANSACTION_URL = constants.WALLET_PROVIDER_SIGN_TRANSACTION_URL = constants.WALLET_PROVIDER_SEND_TRANSACTION_URL = constants.WALLET_PROVIDER_DISCONNECT_URL = constants.WALLET_PROVIDER_CONNECT_URL = constants.XALIAS_PROVIDER_TESTNET = constants.XALIAS_PROVIDER_DEVNET = constants.XALIAS_PROVIDER_MAINNET = constants.WALLET_PROVIDER_TESTNET = constants.WALLET_PROVIDER_DEVNET = constants.WALLET_PROVIDER_MAINNET = void 0;
constants.WALLET_PROVIDER_MAINNET = "https://wallet.multiversx.com/dapp/init";
constants.WALLET_PROVIDER_DEVNET = "https://devnet-wallet.multiversx.com/dapp/init";
constants.WALLET_PROVIDER_TESTNET = "https://testnet-wallet.multiversx.com/dapp/init";
constants.XALIAS_PROVIDER_MAINNET = "https://xalias.com";
constants.XALIAS_PROVIDER_DEVNET = "https://devnet.xalias.com";
constants.XALIAS_PROVIDER_TESTNET = "https://testnet.xalias.com";
constants.WALLET_PROVIDER_CONNECT_URL = "hook/login";
constants.WALLET_PROVIDER_DISCONNECT_URL = "hook/logout";
constants.WALLET_PROVIDER_SEND_TRANSACTION_URL = "hook/transaction";
constants.WALLET_PROVIDER_SIGN_TRANSACTION_URL = "hook/sign";
constants.WALLET_PROVIDER_GUARD_TRANSACTION_URL = "hook/2fa";
constants.WALLET_PROVIDER_SIGN_MESSAGE_URL = "hook/sign-message";
constants.WALLET_PROVIDER_CALLBACK_PARAM = "walletProviderStatus";
constants.WALLET_PROVIDER_CALLBACK_PARAM_TX_SIGNED = "transactionsSigned";
var errors = {};
Object.defineProperty(errors, "__esModule", { value: !0 });
errors.ErrCannotSignedMessage = errors.ErrCannotGetSignedTransactions = void 0;
class ErrCannotGetSignedTransactions extends Error {
  constructor() {
    super("Cannot get signed transaction(s)");
  }
}
errors.ErrCannotGetSignedTransactions = ErrCannotGetSignedTransactions;
class ErrCannotSignedMessage extends Error {
  constructor() {
    super("Cannot get signed message");
  }
}
errors.ErrCannotSignedMessage = ErrCannotSignedMessage;
var plainSignedTransaction = {};
Object.defineProperty(plainSignedTransaction, "__esModule", { value: !0 });
plainSignedTransaction.PlainSignedTransaction = void 0;
class PlainSignedTransaction {
  constructor(e) {
    this.nonce = 0, this.value = "", this.receiver = "", this.sender = "", this.gasPrice = 0, this.gasLimit = 0, this.data = "", this.chainID = "", this.version = 0, this.signature = "", Object.assign(this, e);
  }
}
plainSignedTransaction.PlainSignedTransaction = PlainSignedTransaction;
var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
}, __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(walletProvider, "__esModule", { value: !0 });
walletProvider.WalletProvider = void 0;
const qs_1 = __importDefault(lib), constants_1 = constants, errors_1 = errors, plainSignedTransaction_1 = plainSignedTransaction;
class WalletProvider {
  constructor(e) {
    this.walletUrl = e;
  }
  login(e) {
    return __awaiter$1(this, void 0, void 0, function* () {
      const s = this.buildWalletUrl({
        endpoint: constants_1.WALLET_PROVIDER_CONNECT_URL,
        callbackUrl: e == null ? void 0 : e.callbackUrl,
        params: {
          token: e == null ? void 0 : e.token
        }
      });
      return yield this.redirect(s, e == null ? void 0 : e.redirectDelayMilliseconds), s;
    });
  }
  redirect(e, s) {
    return __awaiter$1(this, void 0, void 0, function* () {
      s ? yield this.redirectLater(e, s) : this.redirectImmediately(e);
    });
  }
  redirectImmediately(e) {
    window.location.href = e;
  }
  redirectLater(e, s) {
    return __awaiter$1(this, void 0, void 0, function* () {
      yield new Promise((o) => {
        setTimeout(() => {
          window.location.href = e, o(!0);
        }, s);
      });
    });
  }
  logout(e) {
    return __awaiter$1(this, void 0, void 0, function* () {
      const s = this.buildWalletUrl({
        endpoint: constants_1.WALLET_PROVIDER_DISCONNECT_URL,
        callbackUrl: e == null ? void 0 : e.callbackUrl
      });
      return yield this.redirect(s, e == null ? void 0 : e.redirectDelayMilliseconds), !0;
    });
  }
  signMessage(e, s) {
    return __awaiter$1(this, void 0, void 0, function* () {
      const o = this.buildWalletUrl({
        endpoint: constants_1.WALLET_PROVIDER_SIGN_MESSAGE_URL,
        callbackUrl: s == null ? void 0 : s.callbackUrl,
        params: {
          message: e.message.toString()
        }
      });
      return yield this.redirect(o), o;
    });
  }
  getMessageSignatureFromWalletUrl() {
    var e, s;
    const o = window.location.search.slice(1);
    console.info("getMessageSignatureFromWalletUrl(), url:", o);
    const fe = qs_1.default.parse(o);
    if ((((e = fe.status) === null || e === void 0 ? void 0 : e.toString()) || "") !== "signed")
      throw new errors_1.ErrCannotSignedMessage();
    return ((s = fe.signature) === null || s === void 0 ? void 0 : s.toString()) || "";
  }
  guardTransactions(e, s) {
    return __awaiter$1(this, void 0, void 0, function* () {
      this.redirectTransactionsToEndpoint(constants_1.WALLET_PROVIDER_GUARD_TRANSACTION_URL, e, s);
    });
  }
  signTransactions(e, s) {
    return __awaiter$1(this, void 0, void 0, function* () {
      this.redirectTransactionsToEndpoint(constants_1.WALLET_PROVIDER_SIGN_TRANSACTION_URL, e, s);
    });
  }
  signTransaction(e, s) {
    return __awaiter$1(this, void 0, void 0, function* () {
      yield this.signTransactions([e], s);
    });
  }
  getTransactionsFromWalletUrl() {
    const e = qs_1.default.parse(window.location.search.slice(1));
    return WalletProvider.isTxSignReturnSuccess(e) ? this.getTxSignReturnValue(e) : [];
  }
  static isTxSignReturnSuccess(e) {
    return e.hasOwnProperty(constants_1.WALLET_PROVIDER_CALLBACK_PARAM) && e[constants_1.WALLET_PROVIDER_CALLBACK_PARAM] === constants_1.WALLET_PROVIDER_CALLBACK_PARAM_TX_SIGNED;
  }
  getTxSignReturnValue(e) {
    console.info("getTxSignReturnValue(), urlParams:", e);
    const s = [
      "nonce",
      "value",
      "receiver",
      "sender",
      "gasPrice",
      "gasLimit",
      "chainID",
      "version",
      "signature"
    ];
    for (let me of s)
      if (!e[me] || !Array.isArray(e[me]))
        throw new errors_1.ErrCannotGetSignedTransactions();
    const o = e.nonce.length;
    for (let me of s)
      if (e[me].length !== o)
        throw new errors_1.ErrCannotGetSignedTransactions();
    const fe = [];
    for (let me = 0; me < o; me++) {
      let ye = new plainSignedTransaction_1.PlainSignedTransaction(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        nonce: parseInt(e.nonce[me]),
        value: e.value[me],
        receiver: e.receiver[me],
        sender: e.sender[me],
        gasPrice: parseInt(e.gasPrice[me]),
        gasLimit: parseInt(e.gasLimit[me]),
        data: e.data && e.data[me] ? e.data[me] : "",
        chainID: e.chainID[me],
        version: parseInt(e.version[me])
      }, e.guardian && e.guardian[me] ? { guardian: e.guardian[me] } : {}), e.guardianSignature && e.guardianSignature[me] ? { guardianSignature: e.guardianSignature[me] } : {}), e.options && e.options[me] ? {
        options: parseInt(e.options[me])
      } : {}), e.senderUsername && e.senderUsername[me] ? { senderUsername: e.senderUsername[me] } : {}), e.receiverUsername && e.receiverUsername[me] ? { receiverUsername: e.receiverUsername[me] } : {}), { signature: e.signature[me] }));
      fe.push(ye);
    }
    return fe;
  }
  static prepareWalletTransaction(e) {
    let s = e.toPlainObject();
    return s.data ? s.data = Buffer.from(s.data, "base64").toString() : s.data = "", s;
  }
  buildWalletUrl(e) {
    const s = (e == null ? void 0 : e.callbackUrl) || window.location.href, o = qs_1.default.stringify(e.params || {}), fe = o ? `${o}&callbackUrl=${s}` : `callbackUrl=${s}`, me = `${this.baseWalletUrl()}/${e.endpoint}?${fe}`;
    return console.info(`Redirecting to Wallet URL: ${decodeURI(me)}`), me;
  }
  baseWalletUrl() {
    const e = this.walletUrl.split("/"), s = e[0], o = e[2];
    return s + "//" + o;
  }
  redirectTransactionsToEndpoint(e, s, o) {
    const fe = {};
    s.map((ye) => {
      let fr = WalletProvider.prepareWalletTransaction(ye);
      for (let Er in fr)
        fr.hasOwnProperty(Er) && !fe.hasOwnProperty(Er) && (fe[Er] = []), fe[Er].push(fr[Er]);
    });
    const me = this.buildWalletUrl({
      endpoint: e,
      callbackUrl: o == null ? void 0 : o.callbackUrl,
      params: fe
    });
    window.location.href = me;
  }
}
walletProvider.WalletProvider = WalletProvider;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, fe, me, ye) {
    ye === void 0 && (ye = me), Object.defineProperty(o, ye, { enumerable: !0, get: function() {
      return fe[me];
    } });
  } : function(o, fe, me, ye) {
    ye === void 0 && (ye = me), o[ye] = fe[me];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, fe) {
    for (var me in o)
      me !== "default" && !Object.prototype.hasOwnProperty.call(fe, me) && e(fe, o, me);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(walletProvider, r), s(constants, r);
})(out);
const DAPP_INIT_ROUTE = "/dapp/init", getProviderType = (r) => {
  switch (r == null ? void 0 : r.constructor) {
    case out.WalletProvider:
      return LoginMethodsEnum.wallet;
    case walletConnectV2Provider.WalletConnectV2Provider:
      return LoginMethodsEnum.walletconnectv2;
    case out$1.HWProvider:
      return LoginMethodsEnum.ledger;
    case out$2.ExtensionProvider:
      return LoginMethodsEnum.extension;
    case EmptyProvider:
      return LoginMethodsEnum.none;
    default:
      return LoginMethodsEnum.extra;
  }
}, newWalletProvider = (r) => new out.WalletProvider(`${r}${DAPP_INIT_ROUTE}`), getLedgerConfiguration = async (r) => {
  if (!r.isInitialized())
    throw new Error("Unable to get version. Provider not initialized");
  const e = r.hwApp, { contractData: s, version: o } = await e.getAppConfiguration();
  return { version: o, dataEnabled: s === LEDGER_CONTRACT_DATA_ENABLED_VALUE };
}, notInitializedError$1 = (r) => `Unable to perform ${r}, Provider not initialized`;
class EmptyProvider {
  init() {
    return Promise.resolve(!1);
  }
  login(e) {
    throw new Error(notInitializedError$1(`login with options: ${e}`));
  }
  logout(e) {
    throw new Error(notInitializedError$1(`logout with options: ${e}`));
  }
  getAddress() {
    throw new Error(notInitializedError$1("getAddress"));
  }
  isInitialized() {
    return !1;
  }
  isConnected() {
    return Promise.resolve(!1);
  }
  sendTransaction(e, s) {
    throw new Error(
      notInitializedError$1(
        `sendTransaction with transactions: ${e} options: ${s}`
      )
    );
  }
  signTransaction(e, s) {
    throw new Error(
      notInitializedError$1(
        `signTransaction with transactions: ${e} options: ${s}`
      )
    );
  }
  signTransactions(e, s) {
    throw new Error(
      notInitializedError$1(
        `signTransactions with transactions: ${e} options: ${s}`
      )
    );
  }
  signMessage(e, s) {
    throw new Error(
      notInitializedError$1(
        `signTransactions with ${e} and options ${s}`
      )
    );
  }
  sendCustomMessage({
    method: e,
    params: s
  }) {
    throw new Error(
      notInitializedError$1(
        `sendCustomMessage with method: ${e} params: ${s}`
      )
    );
  }
  sendCustomRequest(e) {
    throw new Error(
      notInitializedError$1(`sendSessionEvent with options: ${e}`)
    );
  }
  ping() {
    return Promise.resolve(!1);
  }
}
const emptyProvider = new EmptyProvider();
let accountProvider = emptyProvider, externalProvider = null;
function setAccountProvider(r) {
  accountProvider = r;
}
function setExternalProvider(r) {
  externalProvider = r;
}
function setExternalProviderAsAccountProvider() {
  externalProvider != null && (accountProvider = externalProvider);
}
function getAccountProvider() {
  return accountProvider || emptyProvider;
}
const initialState$3 = {
  loginMethod: LoginMethodsEnum.none,
  walletConnectLogin: null,
  ledgerLogin: null,
  tokenLogin: null,
  walletLogin: null,
  extensionLogin: null,
  isLoginSessionInvalid: !1
}, useLoginInfoStore = defineStore("erdjs-login-info", {
  state: () => ({ ...initialState$3 }),
  persist: !0,
  getters: {
    getLoginMethod: (r) => r.loginMethod,
    getTokenLogin: (r) => r.tokenLogin,
    getTokenLoginSignature: (r) => {
      var e;
      return (e = r.tokenLogin) == null ? void 0 : e.signature;
    },
    getWalletLogin: (r) => r.walletLogin,
    getWalletConnectLogin: (r) => r.walletConnectLogin,
    getLedgerLogin: (r) => r.ledgerLogin,
    isLoggedIn: (r) => r.loginMethod != LoginMethodsEnum.none && Boolean(useAccountStore().getAddress),
    getLogoutRoute: (r) => r.logoutRoute
  },
  actions: {
    setLoginMethod(r) {
      this.loginMethod = r;
    },
    setTokenLogin(r) {
      this.tokenLogin = r;
    },
    setTokenLoginSignature(r) {
      this.tokenLogin != null && (this.tokenLogin.signature = r);
    },
    setWalletLogin(r) {
      this.loginMethod = LoginMethodsEnum.wallet, this.walletLogin = r;
    },
    setWalletConnectLogin(r) {
      this.loginMethod = LoginMethodsEnum.walletconnect, this.walletConnectLogin = r;
    },
    setWalletConnectV2Login(r) {
      this.loginMethod = LoginMethodsEnum.walletconnectv2, this.walletConnectLogin = r;
    },
    setLedgerLogin(r) {
      this.loginMethod = LoginMethodsEnum.ledger, this.ledgerLogin = r;
    },
    setLogoutRoute(r) {
      this.logoutRoute = r;
    },
    logout() {
      this.$reset();
    }
  }
});
function getIsLoggedIn() {
  const r = useLoginInfoStore();
  return Boolean(r.isLoggedIn);
}
const initialState$2 = {
  version: "",
  contractDataEnabled: !1,
  errorMessage: "",
  isLoading: !1,
  isLoadingAccounts: !1,
  selectedAddress: null,
  showAddressList: !1,
  startIndex: 0,
  accounts: []
}, useLedgerStore = defineStore("erdjs-ledger", {
  state: () => ({ ...initialState$2 }),
  persist: !1,
  getters: {
    getVersion: (r) => r.version,
    getContractDataEnabled: (r) => r.contractDataEnabled,
    getErrorMessage: (r) => r.errorMessage,
    getIsLoading: (r) => r.isLoading,
    getIsLoadingAccounts: (r) => r.isLoadingAccounts,
    getSelectedAddress: (r) => r.selectedAddress,
    getShowAddressList: (r) => r.showAddressList,
    getStartIndex: (r) => r.startIndex,
    getAccounts: (r) => r.accounts
  },
  actions: {
    logout() {
      this.$reset();
    },
    resetAccounts() {
      this.accounts = [], this.isLoading = !1, this.isLoadingAccounts = !1, this.showAddressList = !1, this.selectedAddress = null, this.startIndex = 0;
    },
    setVersion(r) {
      this.version = r;
    },
    setContractDataEnabled(r) {
      this.contractDataEnabled = r;
    },
    setError(r) {
      this.errorMessage = r;
    },
    setIsLoading(r) {
      this.isLoading = r;
    },
    setIsLoadingAccounts(r) {
      this.isLoadingAccounts = r;
    },
    setSelectedAddress(r) {
      this.selectedAddress = r;
    },
    setShowAddressList(r) {
      this.showAddressList = r;
    },
    setStartIndex(r) {
      this.startIndex = r;
    },
    setAccounts(r) {
      this.accounts = r;
    },
    changePage(r) {
      r === "next" && this.startIndex++, r === "prev" && (this.startIndex = this.startIndex === 0 ? this.startIndex : this.startIndex--);
    }
  }
});
async function logout(r, e) {
  const s = getAccountProvider(), o = getProviderType(s), fe = getIsLoggedIn(), me = o === LoginMethodsEnum.wallet;
  if (!fe || !s) {
    redirectToCallbackUrl(r, e, !1);
    return;
  }
  me && preventRedirects();
  try {
    const fr = me && !r ? window.location.origin : r;
    useLedgerStore().logout(), me ? (useLoginInfoStore().logout(), useAccountStore().logout(), setTimeout(() => {
      s.logout({ callbackUrl: fr });
    })) : (useLoginInfoStore().logout(), useAccountStore().logout(), await s.logout(), redirectToCallbackUrl(r, e, me));
  } catch (ye) {
    console.error("error logging out", ye);
  }
}
function redirectToCallbackUrl(r, e, s) {
  r && !s && (typeof e == "function" ? e(r) : safeRedirect(r));
}
var freeGlobal$1 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal || freeSelf || Function("return this")(), _root = root$1, root = _root, Symbol$3 = root.Symbol, _Symbol = Symbol$3, Symbol$2 = _Symbol, objectProto$1 = Object.prototype, hasOwnProperty = objectProto$1.hasOwnProperty, nativeObjectToString$1 = objectProto$1.toString, symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(r) {
  var e = hasOwnProperty.call(r, symToStringTag$1), s = r[symToStringTag$1];
  try {
    r[symToStringTag$1] = void 0;
    var o = !0;
  } catch {
  }
  var fe = nativeObjectToString$1.call(r);
  return o && (e ? r[symToStringTag$1] = s : delete r[symToStringTag$1]), fe;
}
var _getRawTag = getRawTag$1, objectProto = Object.prototype, nativeObjectToString = objectProto.toString;
function objectToString$1(r) {
  return nativeObjectToString.call(r);
}
var _objectToString = objectToString$1, Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$1(r) {
  return r == null ? r === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(r) ? getRawTag(r) : objectToString(r);
}
var _baseGetTag = baseGetTag$1, isArray$1 = Array.isArray, isArray_1 = isArray$1;
function isObjectLike$1(r) {
  return r != null && typeof r == "object";
}
var isObjectLike_1 = isObjectLike$1, baseGetTag = _baseGetTag, isArray = isArray_1, isObjectLike = isObjectLike_1, stringTag = "[object String]";
function isString$1(r) {
  return typeof r == "string" || !isArray(r) && isObjectLike(r) && baseGetTag(r) == stringTag;
}
var isString_1 = isString$1;
const decodeLoginToken = (r) => {
  if (!r || !isString_1(r))
    return null;
  const e = r.split(".");
  if (e.length !== 4)
    return console.error(
      "Invalid loginToken. You may be trying to decode a nativeAuthToken. Try using decodeNativeAuthToken method instead"
    ), null;
  try {
    const [s, o, fe, me] = e, ye = JSON.parse(decodeBase64(me)), fr = decodeBase64(s);
    return {
      ttl: Number(fe),
      extraInfo: ye,
      origin: fr,
      blockHash: o
    };
  } catch (s) {
    return console.error(`Error trying to decode ${r}:`, s), null;
  }
};
function isString(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}
const decodeNativeAuthToken = (r) => {
  var s;
  if (!r || !isString(r))
    return null;
  const e = r.split(".");
  if (e.length !== 3)
    return console.error(
      "Invalid nativeAuthToken. You may be trying to decode a loginToken. Try using decodeLoginToken method instead"
    ), null;
  try {
    const [o, fe, me] = e, ye = decodeBase64(o), fr = decodeBase64(fe), Er = decodeLoginToken(fr);
    if (!Er)
      return {
        address: ye,
        body: fr,
        signature: me,
        blockHash: "",
        origin: "",
        ttl: 0
      };
    const br = {
      ...Er,
      address: ye,
      body: fr,
      signature: me
    };
    return (s = Er.extraInfo) != null && s.timestamp || delete br.extraInfo, br;
  } catch {
    return null;
  }
};
async function loginWithNativeAuthToken(r) {
  const e = decodeNativeAuthToken(r);
  if (e == null)
    return;
  const { signature: s, address: o } = e;
  if (s && r && o) {
    await logout(), useLoginInfoStore().setTokenLogin({
      loginToken: r,
      signature: s,
      nativeAuthToken: r
    });
    const fe = { address: o, loginMethod: LoginMethodsEnum.extra };
    useAccountStore().setLogin(fe), useLoginInfoStore().setLoginMethod(LoginMethodsEnum.extra);
  }
}
const isWindowAvailable = () => typeof window < "u" && typeof (window == null ? void 0 : window.location) < "u", safeWindow = typeof window < "u" ? window : {}, detectCurrentPlatform = () => safeWindow.ReactNativeWebView ? PlatformsEnum.reactNative : safeWindow.webkit ? PlatformsEnum.ios : PlatformsEnum.web, requestMethods = {
  signTransactions: {
    [PlatformsEnum.ios]: (r) => window.webkit.messageHandlers.signTransactions.postMessage(
      r,
      targetOrigin
    ),
    [PlatformsEnum.reactNative]: (r) => window == null ? void 0 : window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.signTransactionsRequest,
        message: r
      })
    ),
    [PlatformsEnum.web]: (r) => window == null ? void 0 : window.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.signTransactionsRequest,
        message: r
      }),
      targetOrigin
    )
  },
  signMessage: {
    [PlatformsEnum.ios]: (r) => window.webkit.messageHandlers.signMessage.postMessage(r),
    [PlatformsEnum.reactNative]: (r) => window == null ? void 0 : window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.signMessageRequest,
        message: r
      })
    ),
    [PlatformsEnum.web]: (r) => window == null ? void 0 : window.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.signMessageRequest,
        message: r
      }),
      targetOrigin
    )
  },
  logout: {
    [PlatformsEnum.ios]: () => window.webkit.messageHandlers.logout.postMessage(),
    [PlatformsEnum.reactNative]: () => window == null ? void 0 : window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.logoutRequest
      })
    ),
    [PlatformsEnum.web]: () => window == null ? void 0 : window.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.logoutRequest
      }),
      targetOrigin
    )
  },
  login: {
    [PlatformsEnum.ios]: () => window.webkit.messageHandlers.login.postMessage(),
    [PlatformsEnum.reactNative]: () => window == null ? void 0 : window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.loginRequest
      })
    ),
    [PlatformsEnum.web]: () => window == null ? void 0 : window.postMessage(
      JSON.stringify({
        type: WebViewProviderRequestEnums.loginRequest
      }),
      targetOrigin
    )
  }
}, notInitializedError = (r) => () => {
  throw new Error(`Unable to perform ${r}, Provider not initialized`);
}, currentPlatform = detectCurrentPlatform();
var tc, rc;
const targetOrigin = isWindowAvailable() && (rc = (tc = window == null ? void 0 : window.parent) == null ? void 0 : tc.origin) != null ? rc : "*", handleWaitForMessage = (r) => {
  const e = (s) => {
    let o = s.data;
    if (!(s.target.origin != targetOrigin && currentPlatform != PlatformsEnum.reactNative))
      try {
        o = JSON.parse(o), r(o);
      } catch {
        console.error("error parsing response");
      }
  };
  document && document.addEventListener("message", e), window && window.addEventListener("message", e);
}, webviewProvider = {
  init: async () => !0,
  login: async () => !0,
  relogin: async () => {
    try {
      return requestMethods.login[currentPlatform](), await new Promise(
        (e, s) => {
          function o(fe) {
            const { message: me, type: ye } = fe;
            if (ye === WebViewProviderResponseEnums.loginResponse)
              try {
                const { accessToken: fr, error: Er } = me;
                Er ? s(Er) : (loginWithNativeAuthToken(fr), setExternalProviderAsAccountProvider(), e(fr));
              } catch {
                s("Unable to login");
              }
            document && document.removeEventListener("message", o);
          }
          handleWaitForMessage(o);
        }
      );
    } catch (r) {
      throw console.error("error logging in", r), r;
    }
  },
  logout: () => (requestMethods.logout[currentPlatform](), new Promise((r) => {
    r(!0);
  })),
  getAddress: notInitializedError("getAddress"),
  isInitialized: () => !0,
  isConnected: async () => !0,
  sendTransaction: notInitializedError("sendTransaction"),
  signMessage: notInitializedError("signMessage"),
  signTransactions: async (r) => {
    try {
      const e = r.map((o) => o.toPlainObject());
      return requestMethods.signTransactions[currentPlatform](e), await new Promise((o, fe) => {
        window.transactionsSigned = (ye, fr) => {
          if (ye = JSON.parse(ye), fr) {
            fe(fr), window.transactionsSigned = null;
            return;
          }
          o(ye.map((Er) => out$4.Transaction.fromPlainObject(Er))), window.transactionsSigned = null;
        };
        function me(ye) {
          const { message: fr, type: Er } = ye;
          if (Er === WebViewProviderResponseEnums.signTransactionsResponse) {
            const { transactions: br, error: wr } = fr;
            try {
              wr ? fe(wr) : o(
                br.map(
                  (kr) => out$4.Transaction.fromPlainObject(kr)
                )
              );
            } catch {
              fe("Unable to sign");
            }
          }
          document && document.removeEventListener("message", me);
        }
        handleWaitForMessage(me);
      });
    } catch (e) {
      throw console.error("error sending transaction", e), e;
    }
  },
  signTransaction: async function(r) {
    return (await this.signTransactions([r]))[0];
  }
}, emptyAppConfig = {
  shouldUseWebViewProvider: !0,
  withGuardianInfo: !0,
  extensionLogin: {
    callbackRoute: "/"
  },
  ledgerLogin: {
    callbackRoute: "/"
  },
  walletConnectV2Login: {
    callbackRoute: "/",
    logoutRoute: "/login"
  },
  webWalletLogin: {
    callbackRoute: "/"
  }
}, setAppConfig = (r) => {
  r != null && r.shouldUseWebViewProvider && setExternalProvider(webviewProvider), useAppConfigStore().setShouldUseWebViewProvider(r == null ? void 0 : r.shouldUseWebViewProvider), useAppConfigStore().setWithGuardianInfo(r == null ? void 0 : r.withGuardianInfo), useAppConfigStore().setExtensionLogin({
    ...emptyAppConfig.extensionLogin,
    ...r.extensionLogin
  }), useAppConfigStore().setLedgerLogin({
    ...emptyAppConfig.ledgerLogin,
    ...r.ledgerLogin
  }), useAppConfigStore().setWalletConnectV2Login({
    ...emptyAppConfig.walletConnectV2Login,
    ...r.walletConnectV2Login
  }), useAppConfigStore().setWebWalletLogin({
    ...emptyAppConfig.webWalletLogin,
    ...r.webWalletLogin
  });
}, useAppConfigStore = defineStore("erdjs-app-config", {
  state: () => ({ ...emptyAppConfig }),
  persist: !1,
  getters: {
    getExtensionLogin: (r) => r.extensionLogin,
    getLedgerLogin: (r) => r.ledgerLogin,
    getWalletConnectV2Login: (r) => r.walletConnectV2Login,
    getWebWalletLogin: (r) => r.webWalletLogin,
    getShouldUseWebViewProvider: (r) => r.shouldUseWebViewProvider,
    getWithGuardianInfo: (r) => r.withGuardianInfo
  },
  actions: {
    setExtensionLogin(r) {
      this.extensionLogin = r;
    },
    setLedgerLogin(r) {
      this.ledgerLogin = r;
    },
    setWalletConnectV2Login(r) {
      this.walletConnectV2Login = r;
    },
    setWebWalletLogin(r) {
      this.webWalletLogin = r;
    },
    setShouldUseWebViewProvider(r) {
      this.shouldUseWebViewProvider = Boolean(r);
    },
    setWithGuardianInfo(r) {
      this.withGuardianInfo = Boolean(r);
    }
  }
});
async function getAccountFromApi(r) {
  if (!r)
    return null;
  const e = useAppConfigStore().getWithGuardianInfo, o = `${getCleanApiAddress()}/${ACCOUNTS_ENDPOINT}/${r}?withGuardianInfo=${e}`;
  try {
    const { data: fe } = await axios$2.get(o);
    return fe;
  } catch {
    console.error("error fetching configuration for ", o);
  }
  return null;
}
async function getAccount(r) {
  return await getAccountFromApi(r);
}
function getLatestNonce(r) {
  const e = useAccountStore().getAccountNonce;
  return r ? e && !isNaN(e) ? Math.max(e, r.nonce) : r.nonce : e;
}
function calculateGasLimit(r) {
  const e = new BigNumber$1(GAS_LIMIT), s = new BigNumber$1(GAS_PER_DATA_BYTE), o = r ? s.times(Buffer.from(r).length) : 0;
  return e.plus(o).toString(10);
}
async function transformAndSignTransactions({
  transactions: r
}) {
  const e = useAccountStore().getAddress, s = await getAccount(e), o = getLatestNonce(s);
  return r.map((fe) => {
    const {
      value: me,
      receiver: ye,
      data: fr = "",
      chainID: Er,
      version: br = 1,
      options: wr,
      gasPrice: kr = GAS_PRICE,
      gasLimit: Gr = calculateGasLimit(fe.data)
    } = fe;
    let Vr = ye;
    try {
      Vr = new out$4.Address(ye).hex();
    } catch {
      throw "Invalid Receiver address";
    }
    const jr = useDappStore().getChainId.valueOf().toString(), Kr = Er || jr;
    return newTransaction({
      value: me,
      receiver: Vr,
      data: fr,
      gasPrice: kr,
      gasLimit: Number(Gr),
      nonce: Number(o.valueOf().toString()),
      sender: new out$4.Address(e).hex(),
      chainID: Kr,
      version: br,
      options: wr
    });
  });
}
function canTransformToPublicKey(r) {
  try {
    const e = new out$4.Address(r);
    return Boolean(e.bech32());
  } catch {
    return !1;
  }
}
function addressIsValid(r) {
  return (r == null ? void 0 : r.startsWith("erd")) && r.length === 62 && /^\w+$/.test(r) && canTransformToPublicKey(r);
}
const ESDTTransferTypes = [
  "ESDTNFTTransfer",
  "ESDTNFTBurn",
  "ESDTNFTAddQuantity",
  "ESDTNFTCreate",
  "MultiESDTNFTTransfer",
  "ESDTTransfer",
  "ESDTBurn",
  "ESDTLocalMint",
  "ESDTLocalBurn",
  "ESDTWipe",
  "ESDTFreeze"
];
function isContract(r, e, s = "") {
  if (!addressIsValid(r))
    return !1;
  if (new out$4.Address(r).isContractAddress())
    return !0;
  const me = getAddressFromDataField({ receiver: r, data: s });
  return me ? new out$4.Address(
    me
  ).isContractAddress() || isSelfESDTContract(r, e, s) : !1;
}
const isHexValidCharacters = (r) => r.toLowerCase().match(/[0-9a-f]/g), isHexValidLength = (r) => r.length % 2 === 0;
function isSelfESDTContract(r, e, s) {
  const o = s == null ? void 0 : s.split("@");
  if (o == null)
    return !1;
  const [fe, ...me] = o, ye = e != null && r != null && r === e, fr = ESDTTransferTypes.includes(fe), Er = me.every(
    (br) => isHexValidCharacters(br) && isHexValidLength(br)
  );
  return ye && fr && Er;
}
function getAddressFromDataField({
  receiver: r,
  data: e
}) {
  try {
    if (!e)
      return r;
    const s = isStringBase64(e) ? out$4.TransactionPayload.fromEncoded(e).toString() : e, o = getAddressIndex(s), fe = s.split("@");
    return o > -1 ? fe[o] : r;
  } catch (s) {
    console.log(s);
    return;
  }
}
function getAddressIndex(r) {
  return r.includes(TypesOfSmartContractCallsEnum.MultiESDTNFTTransfer) ? 1 : r.includes(TypesOfSmartContractCallsEnum.ESDTNFTTransfer) ? 4 : -1;
}
async function signTransactions({
  transactions: r,
  callbackRoute: e,
  minGasLimit: s = GAS_LIMIT,
  customTransactionInformation: o,
  transactionsDisplayInfo: fe
}) {
  const me = Date.now().toString(), ye = useAccountStore().getAccountBalance, fr = useDappStore().getChainId, Er = Array.isArray(r) ? r : [r], br = calcTotalFee(Er, s);
  if (!new BigNumber$1(
    stringIsFloat(ye) ? ye : "0"
  ).minus(br).isGreaterThan(0)) {
    const bn = {
      type: NotificationTypesEnum.warning,
      title: "Insufficient EGLD funds",
      description: "Current EGLD balance cannot cover the transaction fees."
    };
    return useNotificationsStore().addNotification(bn), { error: "insufficient funds", sessionId: null };
  }
  if (!(Er == null ? void 0 : Er.every(
    (bn) => bn.getChainID().valueOf() === fr.valueOf()
  ))) {
    const bn = {
      type: NotificationTypesEnum.warning,
      title: "Network change detected",
      description: "The application tried to change the transaction network"
    };
    return useNotificationsStore().addNotification(bn), { error: "Invalid ChainID", sessionId: null };
  }
  const Vr = useAccountStore().getAddress, jr = {
    sessionId: me,
    callbackRoute: e,
    customTransactionInformation: o,
    transactions: Er.map((bn) => {
      const Yr = bn.getGasLimit().valueOf().toString();
      let Zr = Number(calculateGasLimit(bn.getData().valueOf().toString()));
      bn.getSender().valueOf().toString() !== Vr && (bn.sender = new out$4.Address(Vr));
      const ti = bn.getReceiver().valueOf().toString();
      return isContract(ti) && (Zr += 5e7), Number(Yr) < Zr && bn.setGasLimit(Zr), bn.toPlainObject();
    })
  };
  useTransactionsStore().setSignTransactionsCancelMessage(null), useTransactionsStore().setTransactionsToSign(jr);
  const Kr = {
    type: NotificationTypesEnum.success,
    title: "Testing",
    description: "Lorem ipsum dolor vet."
  };
  return useNotificationsStore().addNotification(Kr), useTransactionsInfoStore().setTransactionsDisplayInfo({ sessionId: me, transactionsDisplayInfo: fe }), { sessionId: me };
}
async function sendTransactions({
  transactions: r,
  transactionsDisplayInfo: e,
  redirectAfterSign: s = !0,
  callbackRoute: o = window.location.pathname,
  signWithoutSending: fe,
  completedTransactionsDelay: me,
  sessionInformation: ye,
  minGasLimit: fr
}) {
  try {
    const Er = Array.isArray(r) ? r : [r], br = Er.every(
      (kr) => Object.getPrototypeOf(kr).toPlainObject != null
    );
    let wr = Er;
    return br || (wr = await transformAndSignTransactions({
      transactions: Er,
      minGasLimit: fr
    })), signTransactions({
      transactions: wr,
      minGasLimit: fr,
      callbackRoute: o,
      transactionsDisplayInfo: e,
      customTransactionInformation: {
        redirectAfterSign: s,
        completedTransactionsDelay: me,
        sessionInformation: ye,
        signWithoutSending: fe
      }
    });
  } catch (Er) {
    return console.error("error signing transaction", Er), { error: Er, sessionId: null };
  }
}
const initialState$1 = {
  getWalletConnectUri: "",
  getCurrent: emptyProvider
}, useNetworkProviderStore = defineStore("erdjs-provider", {
  state: () => ({ ...initialState$1 }),
  persist: !0,
  actions: {
    setWalletConnectUri(r) {
      this.getWalletConnectUri = r;
    },
    setCurrent(r) {
      this.getCurrent = r;
    }
  }
});
function getAccountProviderType() {
  const r = getAccountProvider();
  return getProviderType(r);
}
function getIsProviderEqualTo(r) {
  return getAccountProviderType() === r;
}
function getAddress() {
  const { search: r } = window.location, e = useAccountStore(), s = getAccountProvider(), o = e.getAddress, fe = getIsLoggedIn();
  if (!s)
    throw "provider not initialized";
  return getIsProviderEqualTo(LoginMethodsEnum.ledger) && fe ? new Promise((me) => {
    me(o);
  }) : !getIsProviderEqualTo(LoginMethodsEnum.none) && !getIsProviderEqualTo(LoginMethodsEnum.wallet) && !getIsProviderEqualTo(LoginMethodsEnum.extra) ? s.getAddress() : new Promise((me) => {
    const ye = new URLSearchParams(r), fr = Object.fromEntries(ye);
    addressIsValid(fr.address) && me(fr.address), fe && me(o), me("");
  });
}
const setNewAccount = async () => {
  try {
    const r = await getAddress();
    try {
      const e = await getAccount(r);
      if (e != null) {
        const s = {
          ...e,
          nonce: getLatestNonce(e)
        };
        return useAccountStore().setAccount(s), s;
      }
    } catch (e) {
      console.error("Failed getting account ", e);
    }
  } catch (r) {
    console.error("Failed getting address ", r);
  }
  return null;
};
async function refreshAccount() {
  const r = getAccountProvider();
  if (r == null)
    throw "Provider not initialized";
  if (!r.isInitialized || r.isInitialized())
    return setNewAccount();
  try {
    if (!r.init)
      throw "Current provider does not have init() function";
    return await r.init() ? setNewAccount() : void 0;
  } catch (e) {
    console.error("Failed initializing provider ", e);
  }
}
const escape$1 = (r) => r.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, ""), encodeValue = (r) => escape$1(Buffer.from(r, "utf8").toString("base64"));
function sleep(r) {
  return new Promise((e) => {
    setTimeout(() => e(), r);
  });
}
const executeAsyncCall = async (r, e, s, o = 0) => {
  try {
    return await r(...s);
  } catch {
    return o < e.retries ? ((e == null ? void 0 : e.delay) != null && await sleep(e.delay), executeAsyncCall(r, e, s, o + 1)) : null;
  }
}, retryMultipleTimes = (r, e = { retries: 5, delay: 500 }) => async (...s) => executeAsyncCall(r, e, s), getBlockFromPosition = 4, cachingDurationMs = 3e4, cachedResponse = {
  current: null
}, requestPromise = {
  current: null
}, getLatestBlockHashFromServer = retryMultipleTimes(
  async (r, e) => {
    const { data: s } = await axios$2.get(
      `${r}/${BLOCKS_ENDPOINT}?from=${getBlockFromPosition}&size=1&fields=hash,timestamp${e ? "&shard=" + e : ""}`
    ), [o] = s;
    return o;
  }
);
async function getLatestBlockHash(r, e) {
  if (r == null)
    throw new Error("missing api url");
  const s = Date.now();
  if (cachedResponse.current != null && s < cachedResponse.current.timestamp * 1e3 + cachingDurationMs)
    return cachedResponse.current;
  if (requestPromise.current != null)
    return await requestPromise.current;
  requestPromise.current = getLatestBlockHashFromServer(r, e);
  try {
    const o = await requestPromise.current;
    if (o == null)
      throw requestPromise.current = null, new Error("could not get block hash");
    return cachedResponse.current = {
      hash: o.hash,
      timestamp: o.timestamp
    }, requestPromise.current = null, o;
  } catch {
    return requestPromise.current = null, null;
  }
}
const getUnixTimestamp = () => Date.now() / 1e3, getTokenExpiration = (r) => {
  const e = decodeNativeAuthToken(r);
  if (!e)
    return {
      isExpired: !1
    };
  const s = getUnixTimestamp(), { ttl: o, extraInfo: fe } = e, me = fe == null ? void 0 : fe.timestamp;
  if (!me)
    return {
      isExpired: !1
    };
  const ye = me + o, fr = s > ye, Er = ye - s;
  return { isExpired: fr, expiresAt: ye, secondsUntilExpires: Er };
};
var nc;
const defaultNativeAuthConfig = {
  origin: typeof window < "u" ? (nc = window == null ? void 0 : window.location) == null ? void 0 : nc.origin : "",
  apiAddress: "https://api.multiversx.com",
  expirySeconds: 60 * 60 * 24,
  tokenExpirationToastWarningSeconds: 5 * 60
}, getNativeAuthConfig = (r) => {
  var s, o, fe, me, ye;
  return r === !0 ? defaultNativeAuthConfig : {
    origin: (s = r == null ? void 0 : r.origin) != null ? s : defaultNativeAuthConfig.origin,
    blockHashShard: (o = r == null ? void 0 : r.blockHashShard) != null ? o : null,
    expirySeconds: (fe = r == null ? void 0 : r.expirySeconds) != null ? fe : defaultNativeAuthConfig.expirySeconds,
    apiAddress: (me = r == null ? void 0 : r.apiAddress) != null ? me : defaultNativeAuthConfig.apiAddress,
    tokenExpirationToastWarningSeconds: (ye = r == null ? void 0 : r.tokenExpirationToastWarningSeconds) != null ? ye : defaultNativeAuthConfig.tokenExpirationToastWarningSeconds
  };
}, getToken = ({
  address: r,
  token: e,
  signature: s
}) => {
  const o = encodeValue(r), fe = encodeValue(e);
  return `${o}.${fe}.${s}`;
}, nativeAuth = (r) => {
  const { origin: e, apiAddress: s, expirySeconds: o, blockHashShard: fe } = getNativeAuthConfig(r);
  return {
    getNativeAuthConfig,
    initialize: async (ye = {}, fr) => {
      if (!s || !e)
        return "";
      const Er = fr != null ? fr : await getLatestBlockHash(s, fe), { hash: br, timestamp: wr } = Er, kr = encodeValue(
        JSON.stringify({ ...ye, ...wr ? { timestamp: wr } : {} })
      );
      return `${encodeValue(e)}.${br}.${o}.${kr}`;
    },
    getToken,
    getTokenExpiration
  };
}, getApiAddress = (r, e) => {
  var s;
  return e ? e === !0 ? r : (s = e.apiAddress) != null ? s : r : null;
}, useLoginService = (r) => {
  const e = useDappStore().getNetworkConfig, s = useLoginInfoStore().getTokenLogin, o = ref(s == null ? void 0 : s.loginToken), fe = getApiAddress(e.apiAddress, r), me = getNativeAuthConfig({
    ...r === !0 ? {} : r,
    ...fe ? { apiAddress: fe } : {}
  }), ye = Boolean(r), fr = nativeAuth(me), { address: Er } = useAccountStore().getAccount, br = (Vr) => {
    o.value = Vr, useLoginInfoStore().setTokenLogin({
      loginToken: Vr,
      ...fe ? { nativeAuthConfig: me } : {}
    });
  }, wr = async () => {
    try {
      return await fr.initialize();
    } catch (Vr) {
      console.error("Unable to get block. Login failed.", Vr);
      return;
    }
  }, kr = ({
    address: Vr,
    signature: jr
  }) => {
    const Kr = o.value;
    if (!Kr)
      throw "Token not found. Call `setLoginToken` first.";
    if (!ye) {
      useLoginInfoStore().setTokenLogin({
        loginToken: Kr,
        signature: jr
      });
      return;
    }
    const bn = fr.getToken({
      address: Vr,
      token: Kr,
      signature: jr
    });
    useLoginInfoStore().setTokenLogin({
      loginToken: Kr,
      signature: jr,
      nativeAuthToken: bn,
      ...fe ? { nativeAuthConfig: me } : {}
    });
  };
  return {
    configuration: me,
    setLoginToken: br,
    getNativeAuthLoginToken: wr,
    setTokenLoginInfo: kr,
    refreshNativeAuthTokenLogin: async ({
      signMessageCallback: Vr
    }) => {
      const jr = await wr();
      if (o.value = jr, !jr)
        return;
      const Kr = new out$4.SignableMessage({
        address: new out$4.Address(Er),
        message: Buffer.from(jr)
      }), bn = await Vr(Kr, {});
      kr({
        address: Er,
        signature: bn.toJSON().signature
      });
    }
  };
}, sanitizeCallbackUrl = (r, e = ["address"]) => {
  const s = new URL(r), o = new URLSearchParams(s.search);
  e.forEach((ye) => o.delete(ye));
  const fe = Array.from(o.values()).length > 0 ? "?" : "", me = s.pathname === "/" && !r.endsWith("/") ? "" : s.pathname;
  return s.protocol === "vscode:" ? r : `${s.origin}${me}${fe}${o.toString()}`;
}, useWebWalletLogin = ({
  callbackRoute: r,
  token: e,
  nativeAuth: s,
  redirectDelayMilliseconds: o = 100
}) => {
  const fe = getIsLoggedIn();
  let me = "";
  const ye = !1, fr = Boolean(s), Er = useLoginService(s);
  let br = e;
  async function wr() {
    if (fe)
      throw new Error(SECOND_LOGIN_ATTEMPT_ERROR);
    try {
      const Gr = useDappStore().getNetworkConfig, Vr = newWalletProvider(Gr.walletAddress), jr = new Date(), Kr = jr.setMinutes(jr.getMinutes() + 3) / 1e3, bn = {
        data: {},
        expires: Kr
      };
      if (fr && !br && (br = await Er.getNativeAuthLoginToken(), !br)) {
        console.warn("Login cancelled.");
        return;
      }
      br && Er.setLoginToken(br);
      const Yr = window != null && window.location ? `${window.location.origin}${r}` : `${r}`;
      new URLSearchParams(document.location.search).get("address") || (useLoginInfoStore().setWalletLogin(bn), useLoginInfoStore().setLoginMethod(LoginMethodsEnum.wallet));
      const On = sanitizeCallbackUrl(Yr), In = {
        callbackUrl: encodeURIComponent(On),
        ...br && { token: br },
        redirectDelayMilliseconds: o
      };
      await Vr.login(In);
    } catch (Gr) {
      console.error("error loging in", Gr), me = "error logging in: " + Gr.message, alert(me);
    }
  }
  return [
    wr,
    {
      loginFailed: !1,
      error: me,
      isLoading: ye,
      isLoggedIn: !1
    }
  ];
};
async function tryAuthenticateWalletUser() {
  const r = useDappStore().getNetworkConfig;
  if (useLoginInfoStore().getLoginMethod == LoginMethodsEnum.wallet) {
    const e = newWalletProvider(r.walletAddress);
    setAccountProvider(e);
    try {
      const s = await getAddress();
      if (s) {
        useAccountStore().setLogin({ address: s, loginMethod: LoginMethodsEnum.wallet });
        const o = await getAccount(s);
        o && useAccountStore().setAccount({
          ...o,
          nonce: getLatestNonce(o)
        });
      }
      parseWalletSignature();
    } catch (s) {
      console.error("Failed authenticating wallet user ", s);
    }
    useLoginInfoStore().setWalletLogin(null), useLoginInfoStore().setLoginMethod(LoginMethodsEnum.wallet);
  }
}
function parseWalletSignature() {
  var me;
  let r = {};
  if ((me = window == null ? void 0 : window.location) != null && me.search) {
    const ye = new URLSearchParams(window.location.search);
    r = Object.fromEntries(ye);
  }
  const { signature: e, loginToken: s, address: o, ...fe } = r;
  e && useLoginInfoStore().setTokenLoginSignature(e), clearWalletLoginHistory(fe);
}
function clearWalletLoginHistory(r) {
  const e = new URLSearchParams(r).toString(), { pathname: s } = window.location, o = e ? `?${e}` : "", fe = s ? `${s}${o}` : "./";
  window.history.replaceState({}, document == null ? void 0 : document.title, fe);
}
const useExtensionLogin = ({
  callbackRoute: r,
  token: e,
  nativeAuth: s,
  onLoginRedirect: o
}) => {
  const fe = getIsLoggedIn(), me = Boolean(s), ye = useLoginService(s);
  let fr = "";
  const Er = !1;
  async function br() {
    if (fe)
      throw new Error(SECOND_LOGIN_ATTEMPT_ERROR);
    const kr = out$2.ExtensionProvider.getInstance();
    try {
      if (!await kr.init()) {
        console.warn(
          "Something went wrong trying to redirect to wallet login.."
        );
        return;
      }
      const Vr = encodeURIComponent(
        `${window.location.origin}${r != null ? r : window.location.pathname}`
      );
      if (me && !e && (e = await ye.getNativeAuthLoginToken(), !e)) {
        console.warn("Fetching block failed. Login cancelled.");
        return;
      }
      e && ye.setLoginToken(e);
      const jr = {
        callbackUrl: Vr,
        ...e && { token: e }
      };
      await kr.login(jr), setAccountProvider(kr);
      const { signature: Kr, address: bn } = kr.account;
      if (!bn) {
        console.warn("Login cancelled."), alert("Login cancelled. Please try again.");
        return;
      }
      Kr && e && ye.setTokenLoginInfo({
        signature: Kr,
        address: bn
      }), useAccountStore().setLogin({ address: bn, loginMethod: LoginMethodsEnum.extension }), useLoginInfoStore().setLoginMethod(LoginMethodsEnum.extension), optionalRedirect$1({
        callbackRoute: r,
        onLoginRedirect: o,
        options: { signature: Kr, address: bn }
      });
    } catch (Gr) {
      console.error("error loging in", Gr), fr = "error logging in" + Gr.message;
    }
  }
  return [
    br,
    {
      loginFailed: !1,
      error: fr,
      isLoading: Er,
      isLoggedIn: !1
    }
  ];
};
async function setExtensionProvider() {
  try {
    const r = await getAddress(), e = out$2.ExtensionProvider.getInstance().setAddress(r);
    await e.init() ? setAccountProvider(e) : console.error(
      "Could not initialise extension, make sure Elrond wallet extension is installed."
    );
  } catch (r) {
    console.error("Unable to login to ExtensionProvider", r);
  }
}
const useGetAccountProvider = () => {
  const r = getAccountProvider(), e = getProviderType(r);
  return { provider: r, providerType: e };
}, useWalletConnectV2Login = ({
  logoutRoute: r,
  callbackRoute: e,
  token: s,
  nativeAuth: o,
  onLoginRedirect: fe
}) => {
  const me = Boolean(o), ye = useLoginService(o);
  let fr = s;
  const Er = ref(!0), br = ref(""), wr = ref([]), kr = ref(""), Gr = ref(""), Vr = useNetworkProviderStore(), { getWalletConnectUri: jr } = storeToRefs(Vr), { provider: Kr } = useGetAccountProvider();
  useNetworkProviderStore().setCurrent(Kr);
  const bn = useDappStore().getWalletConnectV2RelaySelector, Yr = useDappStore().getWalletConnectV2ProjectIdSelector, Zr = useDappStore().getWalletConnectV2OptionsSelector, ti = useDappStore().getChainId, On = useDappStore().getWalletConnectDeepLink;
  Gr.value = Er.value ? "" : `${On}?wallet-connect=${encodeURIComponent(br.value)}`, watch$3(br, (Jr) => {
    Er.value = !Jr;
  }, {
    immediate: !0
  }), watch$3(jr, (Jr) => {
    Gr.value = `${On}?wallet-connect=${encodeURIComponent(Jr)}`;
  }, {
    immediate: !0
  });
  const ni = () => {
    logout(r);
  }, In = (Jr) => {
    console.log("wc2 session event: ", Jr);
  }, Br = () => {
    alert("cancel login");
  }, Hr = () => wr.value, Pn = async () => {
    try {
      const Jr = useNetworkProviderStore().getCurrent;
      if (getIsLoggedIn() || Jr == null || !getIsProviderEqualTo(LoginMethodsEnum.walletconnectv2))
        return;
      const Sn = await Jr.getAddress();
      if (!Sn) {
        console.warn("Login cancelled."), alert("Login cancelled. Please try again.");
        return;
      }
      const ai = await Jr.getSignature(), di = {
        address: Sn,
        loginMethod: LoginMethodsEnum.walletconnectv2
      }, ii = {
        logoutRoute: r,
        loginType: "walletConnectV2",
        callbackRoute: e != null ? e : window.location.href
      };
      useLoginInfoStore().setWalletConnectV2Login(ii), ai && ye.setTokenLoginInfo({ signature: ai, address: Sn }), useAccountStore().setLogin(di), optionalRedirect$1({
        callbackRoute: e,
        onLoginRedirect: fe,
        options: { address: Sn, signature: ai }
      });
    } catch (Jr) {
      kr.value = "Invalid address", console.error(Jr);
    }
  };
  async function ei() {
    var Sn, ai;
    if (!bn || !Yr) {
      kr.value = "Invalid WalletConnect setup";
      return;
    }
    try {
      const { uri: di, approval: ii } = await ((Sn = useNetworkProviderStore().getCurrent) == null ? void 0 : Sn.connect());
      if (!Boolean(di))
        return;
      if (br.value = di, useNetworkProviderStore().setWalletConnectUri(br.value), me && !fr && (fr = await ye.getNativeAuthLoginToken(), !fr)) {
        console.warn("Fetching block failed. Login cancelled."), alert("Login cancelled (Fetching block failed). Please try again.");
        return;
      }
      fr && ye.setLoginToken(fr);
      try {
        await ((ai = useNetworkProviderStore().getCurrent) == null ? void 0 : ai.login({ approval: ii, token: fr }));
      } catch {
        kr.value = "User rejected connection proposal", Er.value = !0, await oi();
      }
    } catch {
      kr.value = "User rejected connection proposal";
    }
    if (!Boolean(br.value) || !fr)
      return;
    const ri = `${br.value}&token=${fr}`;
    useNetworkProviderStore().setWalletConnectUri(ri);
  }
  async function oi(Jr = !0) {
    if (!Yr || !bn) {
      kr.value = "Invalid WalletConnect setup";
      return;
    }
    const ri = {
      onClientLogin: Pn,
      onClientLogout: ni,
      onClientEvent: In
    }, Sn = new walletConnectV2Provider.WalletConnectV2Provider(
      ri,
      ti,
      bn,
      Yr,
      Zr
    );
    await Sn.init(), useNetworkProviderStore().setCurrent(Sn), setAccountProvider(Sn), wr.value = Sn.pairings, Jr && await ei();
  }
  const Nn = Boolean(kr.value), En = async (Jr) => {
    var ri, Sn, ai;
    if (!bn || !Yr) {
      kr.value = "Invalid WalletConnect setup";
      return;
    }
    if (!Jr || !Jr.topic) {
      kr.value = "Expired connection";
      return;
    }
    try {
      const { approval: di } = await ((ri = useNetworkProviderStore().getCurrent) == null ? void 0 : ri.connect({
        topic: Jr.topic
      }));
      if (me && !fr && (fr = await ye.getNativeAuthLoginToken(), !fr)) {
        console.warn("Fetching block failed. Login cancelled."), alert("Login cancelled (Fetching block failed). Please try again.");
        return;
      }
      fr && ye.setLoginToken(fr);
      try {
        await ((Sn = useNetworkProviderStore().getCurrent) == null ? void 0 : Sn.login({ approval: di }));
      } catch {
        kr.value = "User rejected existing connection proposal", Er.value = !0, await oi();
      }
    } catch (di) {
      console.error("Unable to connect to existing session", di), kr.value = "Unable to connect to existing session";
    } finally {
      wr.value = (ai = useNetworkProviderStore().getCurrent) == null ? void 0 : ai.pairings;
    }
  }, qr = async (Jr) => {
    var ri, Sn, ai;
    try {
      Jr && await ((ri = useNetworkProviderStore().getCurrent) == null ? void 0 : ri.logout({
        topic: Jr
      }));
    } catch (di) {
      console.error("Unable to remove existing pairing", di), kr.value = "Unable to remove existing pairing", alert(kr.value);
    } finally {
      if (Jr) {
        const di = (Sn = useNetworkProviderStore().getCurrent) == null ? void 0 : Sn.pairings;
        wr.value = di.filter((ii) => ii.topic !== Jr);
      } else
        wr.value = (ai = useNetworkProviderStore().getCurrent) == null ? void 0 : ai.pairings;
    }
  };
  return [
    oi,
    {
      loginFailed: Nn,
      error: kr.value,
      isLoading: Er.value,
      isLoggedIn: !1
    },
    {
      uriDeepLink: Gr,
      walletConnectUri: br,
      cancelLogin: Br,
      connectExisting: En,
      removeExistingPairing: qr,
      getWcPairings: Hr
    }
  ];
};
async function fetchAccount(r, e) {
  if (r && e)
    try {
      const s = await getAccount(r);
      s && useAccountStore().setAccount({
        ...s,
        address: r,
        nonce: s.nonce.valueOf()
      });
    } catch (s) {
      console.error("Failed getting account ", s);
    }
}
function initializeProvider(r) {
  if (r != null)
    switch (r) {
      case LoginMethodsEnum.ledger: {
        console.log("ledger");
        break;
      }
      case LoginMethodsEnum.walletconnectv2: {
        const [e] = useWalletConnectV2Login({
          logoutRoute: "/login",
          callbackRoute: "/login"
        });
        e(!1), console.log("walletconnect v2");
        break;
      }
      case LoginMethodsEnum.extension: {
        setExtensionProvider();
        break;
      }
      case LoginMethodsEnum.extra: {
        setExternalProviderAsAccountProvider();
        break;
      }
      case LoginMethodsEnum.wallet:
      case LoginMethodsEnum.none: {
        tryAuthenticateWalletUser();
        break;
      }
      default:
        return;
    }
}
async function sendSignedTransactions(r) {
  const { apiAddress: e, apiTimeout: s } = useDappStore().getNetworkConfig, o = r.map((me) => axios$2.post(
    `${e}/transactions`,
    me.toPlainObject(),
    { timeout: parseInt(s) }
  ));
  return (await Promise.all(o)).map(({ data: me }) => me.txHash);
}
async function getTransactionsByHashes(r) {
  const e = useDappStore().getApiAddress, s = r.map((fe) => fe.hash), { data: o } = await axios$2.get(`${e}/transactions`, {
    params: {
      hashes: s.join(","),
      withScResults: !0
    }
  });
  return r.map(({ hash: fe, previousStatus: me }) => {
    const ye = o.find(
      (fr) => (fr == null ? void 0 : fr.txHash) === fe
    );
    return {
      hash: fe,
      data: ye == null ? void 0 : ye.data,
      invalidTransaction: ye == null,
      status: ye == null ? void 0 : ye.status,
      results: ye == null ? void 0 : ye.results,
      sender: ye == null ? void 0 : ye.sender,
      receiver: ye == null ? void 0 : ye.receiver,
      previousStatus: me,
      hasStatusChanged: ye && ye.status !== me
    };
  });
}
function setNonce(r) {
  useAccountStore().setAccountNonce(r);
}
const optionalRedirect = (r) => {
  const e = r.redirectRoute;
  e && safeRedirect(e);
}, transactionSender = ({
  sendSignedTransactionsAsync: r = sendSignedTransactions
}) => {
  const e = useAccountStore().getAccount, s = useTransactionsStore().getSignedTransactions, o = ref(!1), fe = () => {
    useTransactionsStore().clearAllTransactionsToSign(), o.value = !1;
  };
  async function me() {
    var fr;
    const ye = Object.keys(s);
    for (const Er of ye) {
      const br = s == null ? void 0 : s[Er], wr = (fr = br == null ? void 0 : br.customTransactionInformation) == null ? void 0 : fr.signWithoutSending;
      if (!Er || wr) {
        optionalRedirect(br);
        continue;
      }
      try {
        if (!(s[Er].status === TransactionBatchStatusesEnum.signed && !o.value))
          continue;
        const { transactions: Vr } = s[Er];
        if (!Vr)
          continue;
        o.value = !0;
        const jr = Vr.map((Zr) => {
          const ti = newTransaction(Zr), On = new Signature_1(Zr.signature);
          return ti.applySignature(On), ti;
        }), Kr = await r(
          jr
        ), bn = TransactionServerStatusesEnum.pending, Yr = Vr.map((Zr) => Kr.includes(Zr.hash) ? { ...Zr, status: bn } : Zr);
        useTransactionsStore().updateSignedTransactions({
          sessionId: Er,
          status: TransactionBatchStatusesEnum.sent,
          transactions: Yr
        }), fe(), setNonce(e.nonce + Vr.length), optionalRedirect(br), history.pushState({}, document == null ? void 0 : document.title, "?");
      } catch (kr) {
        console.error("Unable to send transactions", kr), useTransactionsStore().updateSignedTransactions({
          sessionId: Er,
          status: TransactionBatchStatusesEnum.fail,
          errorMessage: kr.message
        }), fe();
      } finally {
        o.value = !1;
      }
    }
  }
  return watch$3([s, e], () => {
    me();
  }, {
    immediate: !0
  }), null;
}, initialState = {
  customToasts: [],
  transactionToasts: [],
  failTransactionToast: null
}, useToastsStore = defineStore("erdjs-toasts", {
  state: () => ({ ...initialState }),
  persist: !0,
  getters: {
    getCustomToasts: (r) => r.customToasts,
    getTransactionToasts: (r) => r.transactionToasts,
    getFailTransactionToast: (r) => r.failTransactionToast
  },
  actions: {
    addCustomToast(r) {
      this.customToasts.push({
        ...r,
        type: ToastsEnum.custom,
        toastId: r.toastId || `custom-toast-${this.customToasts.length + 1}`
      });
    },
    removeCustomToast(r) {
      this.customToasts = this.customToasts.filter(
        (e) => e.toastId !== r
      );
    },
    addTransactionToast(r) {
      this.transactionToasts.push({
        type: ToastsEnum.transaction,
        startTimestamp: getUnixTimestamp(),
        toastId: r || `custom-toast-${this.transactionToasts.length + 1}`
      });
    },
    removeTransactionToast(r) {
      this.transactionToasts = this.transactionToasts.filter((e) => e.toastId !== r);
    },
    addFailTransactionToast(r) {
      this.failTransactionToast = {
        ...r,
        toastId: TRANSACTION_STATUS_TOAST_ID
      };
    },
    removeFailTransactionToast() {
      this.failTransactionToast = null;
    }
  }
}), getWebviewToken = () => {
  var o;
  const r = typeof window < "u" ? (o = window == null ? void 0 : window.location) == null ? void 0 : o.search : "", e = new URLSearchParams(r), s = Object.fromEntries(e);
  return s == null ? void 0 : s.accessToken;
};
function useWebViewLogin(r = "") {
  const e = useAppConfigStore().getShouldUseWebViewProvider, s = r || getWebviewToken();
  !e || loginWithNativeAuthToken(s);
}
class Dapp {
  constructor(e, s = {}, o) {
    Va(this, "environment");
    Va(this, "customNetworkConfig");
    Va(this, "appConfiguration");
    if (!e)
      throw new Error("missing environment flag");
    this.environment = e, this.customNetworkConfig = {
      ...s
    }, this.appConfiguration = {
      ...o
    };
  }
  init() {
    const s = {
      ...fallbackNetworkConfigurations[this.environment] || {},
      ...this.customNetworkConfig
    };
    this.initializeNetworkConfig(s), this.setupWatchers(), setAppConfig(this.appConfiguration), useWebViewLogin();
  }
  initializeNetworkConfig(e) {
    const s = useDappStore();
    s.updateNetworkConfig(e), s.updateChainId(e.chainId);
  }
  setupWatchers() {
    const { getAddress: e } = storeToRefs(useAccountStore()), { isLoggedIn: s } = storeToRefs(useLoginInfoStore());
    watch$3([e, s], () => {
      fetchAccount(e.value, s.value);
    }, {
      immediate: !0
    });
    const { loginMethod: o } = storeToRefs(useLoginInfoStore());
    watch$3(o, () => {
      initializeProvider(o.value);
    }, {
      immediate: !0
    }), transactionSender({ sendSignedTransactionsAsync: sendSignedTransactions });
  }
  getNetworkConfig() {
    return useDappStore().getNetworkConfig;
  }
  getDappStore() {
    return useDappStore();
  }
  getAccountStore() {
    return useAccountStore();
  }
  getLoginInfoStore() {
    return useLoginInfoStore();
  }
  getNotificationsStore() {
    return useNotificationsStore();
  }
  getProviderStore() {
    return useNetworkProviderStore();
  }
  getToastsStore() {
    return useToastsStore();
  }
  getTransactionsStore() {
    return useTransactionsStore();
  }
  getTransactionsInfoStore() {
    return useTransactionsInfoStore();
  }
  async sendTransaction(e) {
    return await sendTransactions({
      transactions: [e],
      signWithoutSending: !1,
      transactionsDisplayInfo: {
        errorMessage: ""
      }
    });
  }
  logout(e, s) {
    logout(e, s);
  }
}
const _export_sfc = (r, e) => {
  const s = r.__vccOpts || r;
  for (const [o, fe] of e)
    s[o] = fe;
  return s;
}, _sfc_main$a = {
  name: "ErdjsLoginExtension",
  data() {
    return {
      error: null
    };
  },
  props: {
    selectedMode: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.selectedMode === LoginMethodsEnum.extension && this.login();
  },
  computed: {
    isExtensionInstalled() {
      return window.elrondWallet;
    },
    getDeFiExtensionUrl() {
      return this.isFirefox ? "https://addons.mozilla.org/en-US/firefox/addon/maiar-defi-wallet/" : "https://chrome.google.com/webstore/detail/dngmlblcodfobpdpecaadgfbcggfjfnm?authuser=0&hl=en";
    }
  },
  methods: {
    isFirefox() {
      return navigator.userAgent.indexOf("Firefox") != -1;
    },
    login() {
      const r = useAppConfigStore().getExtensionLogin, [e] = useExtensionLogin(r);
      e();
    }
  }
}, _hoisted_1$9 = { class: "erdjs-vue__login-wrappper px-2 text-center" }, _hoisted_2$8 = {
  key: 0,
  class: "dapp-login__tab-error"
}, _hoisted_3$8 = /* @__PURE__ */ createElementVNode("h4", null, "Extension login", -1), _hoisted_4$8 = ["href"], _hoisted_5$7 = {
  key: 2,
  class: "dapp-login__tab-text"
}, _hoisted_6$5 = { class: "back-button" };
function _sfc_render$a(r, e, s, o, fe, me) {
  return openBlock(), createElementBlock("div", _hoisted_1$9, [
    fe.error ? (openBlock(), createElementBlock("div", _hoisted_2$8, toDisplayString(fe.error), 1)) : createCommentVNode("", !0),
    _hoisted_3$8,
    me.isExtensionInstalled ? (openBlock(), createElementBlock("p", _hoisted_5$7, " Please unlock Maiar DeFi Extension and select the wallet you want to connect. ")) : (openBlock(), createElementBlock("a", {
      key: 1,
      href: me.getDeFiExtensionUrl,
      target: "_blank",
      rel: "noreferrer",
      class: "dapp-login__tab-link"
    }, "Install Maiar DeFi Extension", 8, _hoisted_4$8)),
    createElementVNode("div", _hoisted_6$5, [
      createElementVNode("button", {
        onClick: e[0] || (e[0] = withModifiers((ye) => r.$emit("hide-login-tab"), ["prevent"])),
        class: "btn btn-secondary"
      }, "Back")
    ])
  ]);
}
const ErdjsLoginExtension = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]), _sfc_main$9 = {
  name: "ErdjsLoginWebWallet",
  data() {
    return {
      error: null
    };
  },
  props: {
    selectedMode: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.selectedMode === LoginMethodsEnum.wallet && this.login();
  },
  methods: {
    login() {
      const r = useAppConfigStore().getWebWalletLogin, [e] = useWebWalletLogin(r);
      e();
    }
  }
}, _hoisted_1$8 = { class: "erdjs-vue__login-wrappper px-2 text-center" }, _hoisted_2$7 = {
  key: 0,
  class: "dapp-login__tab-error"
}, _hoisted_3$7 = /* @__PURE__ */ createElementVNode("h4", null, "Web Wallet Login", -1), _hoisted_4$7 = /* @__PURE__ */ createElementVNode("p", { class: "dapp-login__tab-text" }, " Please wait a moment, you'll be redirected to MultiversX Web Wallet... ", -1), _hoisted_5$6 = { class: "back-button" };
function _sfc_render$9(r, e, s, o, fe, me) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    fe.error ? (openBlock(), createElementBlock("div", _hoisted_2$7, toDisplayString(fe.error), 1)) : createCommentVNode("", !0),
    _hoisted_3$7,
    _hoisted_4$7,
    createElementVNode("div", _hoisted_5$6, [
      createElementVNode("button", {
        onClick: e[0] || (e[0] = withModifiers((ye) => r.$emit("hide-login-tab"), ["prevent"])),
        class: "btn btn-secondary"
      }, "Back")
    ])
  ]);
}
const ErdjsLoginWebWallet = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
var browser = {}, canPromise$1 = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, qrcode = {}, utils$1 = {};
let toSJISFunction;
const CODEWORDS_COUNT = [
  0,
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
utils$1.getSymbolSize = function r(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
utils$1.getSymbolTotalCodewords = function r(e) {
  return CODEWORDS_COUNT[e];
};
utils$1.getBCHDigit = function(r) {
  let e = 0;
  for (; r !== 0; )
    e++, r >>>= 1;
  return e;
};
utils$1.setToSJISFunction = function r(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  toSJISFunction = e;
};
utils$1.isKanjiModeEnabled = function() {
  return typeof toSJISFunction < "u";
};
utils$1.toSJIS = function r(e) {
  return toSJISFunction(e);
};
var errorCorrectionLevel = {};
(function(r) {
  r.L = { bit: 1 }, r.M = { bit: 0 }, r.Q = { bit: 3 }, r.H = { bit: 2 };
  function e(s) {
    if (typeof s != "string")
      throw new Error("Param is not a string");
    switch (s.toLowerCase()) {
      case "l":
      case "low":
        return r.L;
      case "m":
      case "medium":
        return r.M;
      case "q":
      case "quartile":
        return r.Q;
      case "h":
      case "high":
        return r.H;
      default:
        throw new Error("Unknown EC Level: " + s);
    }
  }
  r.isValid = function(o) {
    return o && typeof o.bit < "u" && o.bit >= 0 && o.bit < 4;
  }, r.from = function(o, fe) {
    if (r.isValid(o))
      return o;
    try {
      return e(o);
    } catch {
      return fe;
    }
  };
})(errorCorrectionLevel);
function BitBuffer$1() {
  this.buffer = [], this.length = 0;
}
BitBuffer$1.prototype = {
  get: function(r) {
    const e = Math.floor(r / 8);
    return (this.buffer[e] >>> 7 - r % 8 & 1) === 1;
  },
  put: function(r, e) {
    for (let s = 0; s < e; s++)
      this.putBit((r >>> e - s - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(r) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), r && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var bitBuffer = BitBuffer$1;
function BitMatrix$1(r) {
  if (!r || r < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = r, this.data = new Uint8Array(r * r), this.reservedBit = new Uint8Array(r * r);
}
BitMatrix$1.prototype.set = function(r, e, s, o) {
  const fe = r * this.size + e;
  this.data[fe] = s, o && (this.reservedBit[fe] = !0);
};
BitMatrix$1.prototype.get = function(r, e) {
  return this.data[r * this.size + e];
};
BitMatrix$1.prototype.xor = function(r, e, s) {
  this.data[r * this.size + e] ^= s;
};
BitMatrix$1.prototype.isReserved = function(r, e) {
  return this.reservedBit[r * this.size + e];
};
var bitMatrix = BitMatrix$1, alignmentPattern = {};
(function(r) {
  const e = utils$1.getSymbolSize;
  r.getRowColCoords = function(o) {
    if (o === 1)
      return [];
    const fe = Math.floor(o / 7) + 2, me = e(o), ye = me === 145 ? 26 : Math.ceil((me - 13) / (2 * fe - 2)) * 2, fr = [me - 7];
    for (let Er = 1; Er < fe - 1; Er++)
      fr[Er] = fr[Er - 1] - ye;
    return fr.push(6), fr.reverse();
  }, r.getPositions = function(o) {
    const fe = [], me = r.getRowColCoords(o), ye = me.length;
    for (let fr = 0; fr < ye; fr++)
      for (let Er = 0; Er < ye; Er++)
        fr === 0 && Er === 0 || fr === 0 && Er === ye - 1 || fr === ye - 1 && Er === 0 || fe.push([me[fr], me[Er]]);
    return fe;
  };
})(alignmentPattern);
var finderPattern = {};
const getSymbolSize = utils$1.getSymbolSize, FINDER_PATTERN_SIZE = 7;
finderPattern.getPositions = function r(e) {
  const s = getSymbolSize(e);
  return [
    [0, 0],
    [s - FINDER_PATTERN_SIZE, 0],
    [0, s - FINDER_PATTERN_SIZE]
  ];
};
var maskPattern = {};
(function(r) {
  r.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  r.isValid = function(fe) {
    return fe != null && fe !== "" && !isNaN(fe) && fe >= 0 && fe <= 7;
  }, r.from = function(fe) {
    return r.isValid(fe) ? parseInt(fe, 10) : void 0;
  }, r.getPenaltyN1 = function(fe) {
    const me = fe.size;
    let ye = 0, fr = 0, Er = 0, br = null, wr = null;
    for (let kr = 0; kr < me; kr++) {
      fr = Er = 0, br = wr = null;
      for (let Gr = 0; Gr < me; Gr++) {
        let Vr = fe.get(kr, Gr);
        Vr === br ? fr++ : (fr >= 5 && (ye += e.N1 + (fr - 5)), br = Vr, fr = 1), Vr = fe.get(Gr, kr), Vr === wr ? Er++ : (Er >= 5 && (ye += e.N1 + (Er - 5)), wr = Vr, Er = 1);
      }
      fr >= 5 && (ye += e.N1 + (fr - 5)), Er >= 5 && (ye += e.N1 + (Er - 5));
    }
    return ye;
  }, r.getPenaltyN2 = function(fe) {
    const me = fe.size;
    let ye = 0;
    for (let fr = 0; fr < me - 1; fr++)
      for (let Er = 0; Er < me - 1; Er++) {
        const br = fe.get(fr, Er) + fe.get(fr, Er + 1) + fe.get(fr + 1, Er) + fe.get(fr + 1, Er + 1);
        (br === 4 || br === 0) && ye++;
      }
    return ye * e.N2;
  }, r.getPenaltyN3 = function(fe) {
    const me = fe.size;
    let ye = 0, fr = 0, Er = 0;
    for (let br = 0; br < me; br++) {
      fr = Er = 0;
      for (let wr = 0; wr < me; wr++)
        fr = fr << 1 & 2047 | fe.get(br, wr), wr >= 10 && (fr === 1488 || fr === 93) && ye++, Er = Er << 1 & 2047 | fe.get(wr, br), wr >= 10 && (Er === 1488 || Er === 93) && ye++;
    }
    return ye * e.N3;
  }, r.getPenaltyN4 = function(fe) {
    let me = 0;
    const ye = fe.data.length;
    for (let Er = 0; Er < ye; Er++)
      me += fe.data[Er];
    return Math.abs(Math.ceil(me * 100 / ye / 5) - 10) * e.N4;
  };
  function s(o, fe, me) {
    switch (o) {
      case r.Patterns.PATTERN000:
        return (fe + me) % 2 === 0;
      case r.Patterns.PATTERN001:
        return fe % 2 === 0;
      case r.Patterns.PATTERN010:
        return me % 3 === 0;
      case r.Patterns.PATTERN011:
        return (fe + me) % 3 === 0;
      case r.Patterns.PATTERN100:
        return (Math.floor(fe / 2) + Math.floor(me / 3)) % 2 === 0;
      case r.Patterns.PATTERN101:
        return fe * me % 2 + fe * me % 3 === 0;
      case r.Patterns.PATTERN110:
        return (fe * me % 2 + fe * me % 3) % 2 === 0;
      case r.Patterns.PATTERN111:
        return (fe * me % 3 + (fe + me) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + o);
    }
  }
  r.applyMask = function(fe, me) {
    const ye = me.size;
    for (let fr = 0; fr < ye; fr++)
      for (let Er = 0; Er < ye; Er++)
        me.isReserved(Er, fr) || me.xor(Er, fr, s(fe, Er, fr));
  }, r.getBestMask = function(fe, me) {
    const ye = Object.keys(r.Patterns).length;
    let fr = 0, Er = 1 / 0;
    for (let br = 0; br < ye; br++) {
      me(br), r.applyMask(br, fe);
      const wr = r.getPenaltyN1(fe) + r.getPenaltyN2(fe) + r.getPenaltyN3(fe) + r.getPenaltyN4(fe);
      r.applyMask(br, fe), wr < Er && (Er = wr, fr = br);
    }
    return fr;
  };
})(maskPattern);
var errorCorrectionCode = {};
const ECLevel$1 = errorCorrectionLevel, EC_BLOCKS_TABLE = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], EC_CODEWORDS_TABLE = [
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
errorCorrectionCode.getBlocksCount = function r(e, s) {
  switch (s) {
    case ECLevel$1.L:
      return EC_BLOCKS_TABLE[(e - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_BLOCKS_TABLE[(e - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_BLOCKS_TABLE[(e - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_BLOCKS_TABLE[(e - 1) * 4 + 3];
    default:
      return;
  }
};
errorCorrectionCode.getTotalCodewordsCount = function r(e, s) {
  switch (s) {
    case ECLevel$1.L:
      return EC_CODEWORDS_TABLE[(e - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_CODEWORDS_TABLE[(e - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_CODEWORDS_TABLE[(e - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_CODEWORDS_TABLE[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var polynomial = {}, galoisField = {};
const EXP_TABLE = new Uint8Array(512), LOG_TABLE = new Uint8Array(256);
(function r() {
  let e = 1;
  for (let s = 0; s < 255; s++)
    EXP_TABLE[s] = e, LOG_TABLE[e] = s, e <<= 1, e & 256 && (e ^= 285);
  for (let s = 255; s < 512; s++)
    EXP_TABLE[s] = EXP_TABLE[s - 255];
})();
galoisField.log = function r(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return LOG_TABLE[e];
};
galoisField.exp = function r(e) {
  return EXP_TABLE[e];
};
galoisField.mul = function r(e, s) {
  return e === 0 || s === 0 ? 0 : EXP_TABLE[LOG_TABLE[e] + LOG_TABLE[s]];
};
(function(r) {
  const e = galoisField;
  r.mul = function(o, fe) {
    const me = new Uint8Array(o.length + fe.length - 1);
    for (let ye = 0; ye < o.length; ye++)
      for (let fr = 0; fr < fe.length; fr++)
        me[ye + fr] ^= e.mul(o[ye], fe[fr]);
    return me;
  }, r.mod = function(o, fe) {
    let me = new Uint8Array(o);
    for (; me.length - fe.length >= 0; ) {
      const ye = me[0];
      for (let Er = 0; Er < fe.length; Er++)
        me[Er] ^= e.mul(fe[Er], ye);
      let fr = 0;
      for (; fr < me.length && me[fr] === 0; )
        fr++;
      me = me.slice(fr);
    }
    return me;
  }, r.generateECPolynomial = function(o) {
    let fe = new Uint8Array([1]);
    for (let me = 0; me < o; me++)
      fe = r.mul(fe, new Uint8Array([1, e.exp(me)]));
    return fe;
  };
})(polynomial);
const Polynomial = polynomial;
function ReedSolomonEncoder$1(r) {
  this.genPoly = void 0, this.degree = r, this.degree && this.initialize(this.degree);
}
ReedSolomonEncoder$1.prototype.initialize = function r(e) {
  this.degree = e, this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
ReedSolomonEncoder$1.prototype.encode = function r(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const s = new Uint8Array(e.length + this.degree);
  s.set(e);
  const o = Polynomial.mod(s, this.genPoly), fe = this.degree - o.length;
  if (fe > 0) {
    const me = new Uint8Array(this.degree);
    return me.set(o, fe), me;
  }
  return o;
};
var reedSolomonEncoder = ReedSolomonEncoder$1, version = {}, mode = {}, versionCheck = {};
versionCheck.isValid = function r(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var regex = {};
const numeric = "[0-9]+", alphanumeric = "[A-Z $%*+\\-./:]+";
let kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
const byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + `)(?:.|[\r
]))+`;
regex.KANJI = new RegExp(kanji, "g");
regex.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
regex.BYTE = new RegExp(byte, "g");
regex.NUMERIC = new RegExp(numeric, "g");
regex.ALPHANUMERIC = new RegExp(alphanumeric, "g");
const TEST_KANJI = new RegExp("^" + kanji + "$"), TEST_NUMERIC = new RegExp("^" + numeric + "$"), TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
regex.testKanji = function r(e) {
  return TEST_KANJI.test(e);
};
regex.testNumeric = function r(e) {
  return TEST_NUMERIC.test(e);
};
regex.testAlphanumeric = function r(e) {
  return TEST_ALPHANUMERIC.test(e);
};
(function(r) {
  const e = versionCheck, s = regex;
  r.NUMERIC = {
    id: "Numeric",
    bit: 1 << 0,
    ccBits: [10, 12, 14]
  }, r.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 1 << 1,
    ccBits: [9, 11, 13]
  }, r.BYTE = {
    id: "Byte",
    bit: 1 << 2,
    ccBits: [8, 16, 16]
  }, r.KANJI = {
    id: "Kanji",
    bit: 1 << 3,
    ccBits: [8, 10, 12]
  }, r.MIXED = {
    bit: -1
  }, r.getCharCountIndicator = function(me, ye) {
    if (!me.ccBits)
      throw new Error("Invalid mode: " + me);
    if (!e.isValid(ye))
      throw new Error("Invalid version: " + ye);
    return ye >= 1 && ye < 10 ? me.ccBits[0] : ye < 27 ? me.ccBits[1] : me.ccBits[2];
  }, r.getBestModeForData = function(me) {
    return s.testNumeric(me) ? r.NUMERIC : s.testAlphanumeric(me) ? r.ALPHANUMERIC : s.testKanji(me) ? r.KANJI : r.BYTE;
  }, r.toString = function(me) {
    if (me && me.id)
      return me.id;
    throw new Error("Invalid mode");
  }, r.isValid = function(me) {
    return me && me.bit && me.ccBits;
  };
  function o(fe) {
    if (typeof fe != "string")
      throw new Error("Param is not a string");
    switch (fe.toLowerCase()) {
      case "numeric":
        return r.NUMERIC;
      case "alphanumeric":
        return r.ALPHANUMERIC;
      case "kanji":
        return r.KANJI;
      case "byte":
        return r.BYTE;
      default:
        throw new Error("Unknown mode: " + fe);
    }
  }
  r.from = function(me, ye) {
    if (r.isValid(me))
      return me;
    try {
      return o(me);
    } catch {
      return ye;
    }
  };
})(mode);
(function(r) {
  const e = utils$1, s = errorCorrectionCode, o = errorCorrectionLevel, fe = mode, me = versionCheck, ye = 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0, fr = e.getBCHDigit(ye);
  function Er(Gr, Vr, jr) {
    for (let Kr = 1; Kr <= 40; Kr++)
      if (Vr <= r.getCapacity(Kr, jr, Gr))
        return Kr;
  }
  function br(Gr, Vr) {
    return fe.getCharCountIndicator(Gr, Vr) + 4;
  }
  function wr(Gr, Vr) {
    let jr = 0;
    return Gr.forEach(function(Kr) {
      const bn = br(Kr.mode, Vr);
      jr += bn + Kr.getBitsLength();
    }), jr;
  }
  function kr(Gr, Vr) {
    for (let jr = 1; jr <= 40; jr++)
      if (wr(Gr, jr) <= r.getCapacity(jr, Vr, fe.MIXED))
        return jr;
  }
  r.from = function(Vr, jr) {
    return me.isValid(Vr) ? parseInt(Vr, 10) : jr;
  }, r.getCapacity = function(Vr, jr, Kr) {
    if (!me.isValid(Vr))
      throw new Error("Invalid QR Code version");
    typeof Kr > "u" && (Kr = fe.BYTE);
    const bn = e.getSymbolTotalCodewords(Vr), Yr = s.getTotalCodewordsCount(Vr, jr), Zr = (bn - Yr) * 8;
    if (Kr === fe.MIXED)
      return Zr;
    const ti = Zr - br(Kr, Vr);
    switch (Kr) {
      case fe.NUMERIC:
        return Math.floor(ti / 10 * 3);
      case fe.ALPHANUMERIC:
        return Math.floor(ti / 11 * 2);
      case fe.KANJI:
        return Math.floor(ti / 13);
      case fe.BYTE:
      default:
        return Math.floor(ti / 8);
    }
  }, r.getBestVersionForData = function(Vr, jr) {
    let Kr;
    const bn = o.from(jr, o.M);
    if (Array.isArray(Vr)) {
      if (Vr.length > 1)
        return kr(Vr, bn);
      if (Vr.length === 0)
        return 1;
      Kr = Vr[0];
    } else
      Kr = Vr;
    return Er(Kr.mode, Kr.getLength(), bn);
  }, r.getEncodedBits = function(Vr) {
    if (!me.isValid(Vr) || Vr < 7)
      throw new Error("Invalid QR Code version");
    let jr = Vr << 12;
    for (; e.getBCHDigit(jr) - fr >= 0; )
      jr ^= ye << e.getBCHDigit(jr) - fr;
    return Vr << 12 | jr;
  };
})(version);
var formatInfo = {};
const Utils$3 = utils$1, G15 = 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0, G15_MASK = 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1, G15_BCH = Utils$3.getBCHDigit(G15);
formatInfo.getEncodedBits = function r(e, s) {
  const o = e.bit << 3 | s;
  let fe = o << 10;
  for (; Utils$3.getBCHDigit(fe) - G15_BCH >= 0; )
    fe ^= G15 << Utils$3.getBCHDigit(fe) - G15_BCH;
  return (o << 10 | fe) ^ G15_MASK;
};
var segments = {};
const Mode$4 = mode;
function NumericData(r) {
  this.mode = Mode$4.NUMERIC, this.data = r.toString();
}
NumericData.getBitsLength = function r(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function r() {
  return this.data.length;
};
NumericData.prototype.getBitsLength = function r() {
  return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function r(e) {
  let s, o, fe;
  for (s = 0; s + 3 <= this.data.length; s += 3)
    o = this.data.substr(s, 3), fe = parseInt(o, 10), e.put(fe, 10);
  const me = this.data.length - s;
  me > 0 && (o = this.data.substr(s), fe = parseInt(o, 10), e.put(fe, me * 3 + 1));
};
var numericData = NumericData;
const Mode$3 = mode, ALPHA_NUM_CHARS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function AlphanumericData(r) {
  this.mode = Mode$3.ALPHANUMERIC, this.data = r;
}
AlphanumericData.getBitsLength = function r(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
AlphanumericData.prototype.getLength = function r() {
  return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function r() {
  return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function r(e) {
  let s;
  for (s = 0; s + 2 <= this.data.length; s += 2) {
    let o = ALPHA_NUM_CHARS.indexOf(this.data[s]) * 45;
    o += ALPHA_NUM_CHARS.indexOf(this.data[s + 1]), e.put(o, 11);
  }
  this.data.length % 2 && e.put(ALPHA_NUM_CHARS.indexOf(this.data[s]), 6);
};
var alphanumericData = AlphanumericData, encodeUtf8$1 = function r(e) {
  for (var s = [], o = e.length, fe = 0; fe < o; fe++) {
    var me = e.charCodeAt(fe);
    if (me >= 55296 && me <= 56319 && o > fe + 1) {
      var ye = e.charCodeAt(fe + 1);
      ye >= 56320 && ye <= 57343 && (me = (me - 55296) * 1024 + ye - 56320 + 65536, fe += 1);
    }
    if (me < 128) {
      s.push(me);
      continue;
    }
    if (me < 2048) {
      s.push(me >> 6 | 192), s.push(me & 63 | 128);
      continue;
    }
    if (me < 55296 || me >= 57344 && me < 65536) {
      s.push(me >> 12 | 224), s.push(me >> 6 & 63 | 128), s.push(me & 63 | 128);
      continue;
    }
    if (me >= 65536 && me <= 1114111) {
      s.push(me >> 18 | 240), s.push(me >> 12 & 63 | 128), s.push(me >> 6 & 63 | 128), s.push(me & 63 | 128);
      continue;
    }
    s.push(239, 191, 189);
  }
  return new Uint8Array(s).buffer;
};
const encodeUtf8 = encodeUtf8$1, Mode$2 = mode;
function ByteData(r) {
  this.mode = Mode$2.BYTE, this.data = new Uint8Array(encodeUtf8(r));
}
ByteData.getBitsLength = function r(e) {
  return e * 8;
};
ByteData.prototype.getLength = function r() {
  return this.data.length;
};
ByteData.prototype.getBitsLength = function r() {
  return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(r) {
  for (let e = 0, s = this.data.length; e < s; e++)
    r.put(this.data[e], 8);
};
var byteData = ByteData;
const Mode$1 = mode, Utils$2 = utils$1;
function KanjiData(r) {
  this.mode = Mode$1.KANJI, this.data = r;
}
KanjiData.getBitsLength = function r(e) {
  return e * 13;
};
KanjiData.prototype.getLength = function r() {
  return this.data.length;
};
KanjiData.prototype.getBitsLength = function r() {
  return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(r) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let s = Utils$2.toSJIS(this.data[e]);
    if (s >= 33088 && s <= 40956)
      s -= 33088;
    else if (s >= 57408 && s <= 60351)
      s -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    s = (s >>> 8 & 255) * 192 + (s & 255), r.put(s, 13);
  }
};
var kanjiData = KanjiData, dijkstra = { exports: {} };
(function(r) {
  var e = {
    single_source_shortest_paths: function(s, o, fe) {
      var me = {}, ye = {};
      ye[o] = 0;
      var fr = e.PriorityQueue.make();
      fr.push(o, 0);
      for (var Er, br, wr, kr, Gr, Vr, jr, Kr, bn; !fr.empty(); ) {
        Er = fr.pop(), br = Er.value, kr = Er.cost, Gr = s[br] || {};
        for (wr in Gr)
          Gr.hasOwnProperty(wr) && (Vr = Gr[wr], jr = kr + Vr, Kr = ye[wr], bn = typeof ye[wr] > "u", (bn || Kr > jr) && (ye[wr] = jr, fr.push(wr, jr), me[wr] = br));
      }
      if (typeof fe < "u" && typeof ye[fe] > "u") {
        var Yr = ["Could not find a path from ", o, " to ", fe, "."].join("");
        throw new Error(Yr);
      }
      return me;
    },
    extract_shortest_path_from_predecessor_list: function(s, o) {
      for (var fe = [], me = o; me; )
        fe.push(me), s[me], me = s[me];
      return fe.reverse(), fe;
    },
    find_path: function(s, o, fe) {
      var me = e.single_source_shortest_paths(s, o, fe);
      return e.extract_shortest_path_from_predecessor_list(
        me,
        fe
      );
    },
    PriorityQueue: {
      make: function(s) {
        var o = e.PriorityQueue, fe = {}, me;
        s = s || {};
        for (me in o)
          o.hasOwnProperty(me) && (fe[me] = o[me]);
        return fe.queue = [], fe.sorter = s.sorter || o.default_sorter, fe;
      },
      default_sorter: function(s, o) {
        return s.cost - o.cost;
      },
      push: function(s, o) {
        var fe = { value: s, cost: o };
        this.queue.push(fe), this.queue.sort(this.sorter);
      },
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  r.exports = e;
})(dijkstra);
(function(r) {
  const e = mode, s = numericData, o = alphanumericData, fe = byteData, me = kanjiData, ye = regex, fr = utils$1, Er = dijkstra.exports;
  function br(Yr) {
    return unescape(encodeURIComponent(Yr)).length;
  }
  function wr(Yr, Zr, ti) {
    const On = [];
    let ni;
    for (; (ni = Yr.exec(ti)) !== null; )
      On.push({
        data: ni[0],
        index: ni.index,
        mode: Zr,
        length: ni[0].length
      });
    return On;
  }
  function kr(Yr) {
    const Zr = wr(ye.NUMERIC, e.NUMERIC, Yr), ti = wr(ye.ALPHANUMERIC, e.ALPHANUMERIC, Yr);
    let On, ni;
    return fr.isKanjiModeEnabled() ? (On = wr(ye.BYTE, e.BYTE, Yr), ni = wr(ye.KANJI, e.KANJI, Yr)) : (On = wr(ye.BYTE_KANJI, e.BYTE, Yr), ni = []), Zr.concat(ti, On, ni).sort(function(Br, Hr) {
      return Br.index - Hr.index;
    }).map(function(Br) {
      return {
        data: Br.data,
        mode: Br.mode,
        length: Br.length
      };
    });
  }
  function Gr(Yr, Zr) {
    switch (Zr) {
      case e.NUMERIC:
        return s.getBitsLength(Yr);
      case e.ALPHANUMERIC:
        return o.getBitsLength(Yr);
      case e.KANJI:
        return me.getBitsLength(Yr);
      case e.BYTE:
        return fe.getBitsLength(Yr);
    }
  }
  function Vr(Yr) {
    return Yr.reduce(function(Zr, ti) {
      const On = Zr.length - 1 >= 0 ? Zr[Zr.length - 1] : null;
      return On && On.mode === ti.mode ? (Zr[Zr.length - 1].data += ti.data, Zr) : (Zr.push(ti), Zr);
    }, []);
  }
  function jr(Yr) {
    const Zr = [];
    for (let ti = 0; ti < Yr.length; ti++) {
      const On = Yr[ti];
      switch (On.mode) {
        case e.NUMERIC:
          Zr.push([
            On,
            { data: On.data, mode: e.ALPHANUMERIC, length: On.length },
            { data: On.data, mode: e.BYTE, length: On.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          Zr.push([
            On,
            { data: On.data, mode: e.BYTE, length: On.length }
          ]);
          break;
        case e.KANJI:
          Zr.push([
            On,
            { data: On.data, mode: e.BYTE, length: br(On.data) }
          ]);
          break;
        case e.BYTE:
          Zr.push([
            { data: On.data, mode: e.BYTE, length: br(On.data) }
          ]);
      }
    }
    return Zr;
  }
  function Kr(Yr, Zr) {
    const ti = {}, On = { start: {} };
    let ni = ["start"];
    for (let In = 0; In < Yr.length; In++) {
      const Br = Yr[In], Hr = [];
      for (let Pn = 0; Pn < Br.length; Pn++) {
        const ei = Br[Pn], oi = "" + In + Pn;
        Hr.push(oi), ti[oi] = { node: ei, lastCount: 0 }, On[oi] = {};
        for (let Nn = 0; Nn < ni.length; Nn++) {
          const En = ni[Nn];
          ti[En] && ti[En].node.mode === ei.mode ? (On[En][oi] = Gr(ti[En].lastCount + ei.length, ei.mode) - Gr(ti[En].lastCount, ei.mode), ti[En].lastCount += ei.length) : (ti[En] && (ti[En].lastCount = ei.length), On[En][oi] = Gr(ei.length, ei.mode) + 4 + e.getCharCountIndicator(ei.mode, Zr));
        }
      }
      ni = Hr;
    }
    for (let In = 0; In < ni.length; In++)
      On[ni[In]].end = 0;
    return { map: On, table: ti };
  }
  function bn(Yr, Zr) {
    let ti;
    const On = e.getBestModeForData(Yr);
    if (ti = e.from(Zr, On), ti !== e.BYTE && ti.bit < On.bit)
      throw new Error('"' + Yr + '" cannot be encoded with mode ' + e.toString(ti) + `.
 Suggested mode is: ` + e.toString(On));
    switch (ti === e.KANJI && !fr.isKanjiModeEnabled() && (ti = e.BYTE), ti) {
      case e.NUMERIC:
        return new s(Yr);
      case e.ALPHANUMERIC:
        return new o(Yr);
      case e.KANJI:
        return new me(Yr);
      case e.BYTE:
        return new fe(Yr);
    }
  }
  r.fromArray = function(Zr) {
    return Zr.reduce(function(ti, On) {
      return typeof On == "string" ? ti.push(bn(On, null)) : On.data && ti.push(bn(On.data, On.mode)), ti;
    }, []);
  }, r.fromString = function(Zr, ti) {
    const On = kr(Zr, fr.isKanjiModeEnabled()), ni = jr(On), In = Kr(ni, ti), Br = Er.find_path(In.map, "start", "end"), Hr = [];
    for (let Pn = 1; Pn < Br.length - 1; Pn++)
      Hr.push(In.table[Br[Pn]].node);
    return r.fromArray(Vr(Hr));
  }, r.rawSplit = function(Zr) {
    return r.fromArray(
      kr(Zr, fr.isKanjiModeEnabled())
    );
  };
})(segments);
const Utils$1 = utils$1, ECLevel = errorCorrectionLevel, BitBuffer = bitBuffer, BitMatrix = bitMatrix, AlignmentPattern = alignmentPattern, FinderPattern = finderPattern, MaskPattern = maskPattern, ECCode = errorCorrectionCode, ReedSolomonEncoder = reedSolomonEncoder, Version = version, FormatInfo = formatInfo, Mode = mode, Segments = segments;
function setupFinderPattern(r, e) {
  const s = r.size, o = FinderPattern.getPositions(e);
  for (let fe = 0; fe < o.length; fe++) {
    const me = o[fe][0], ye = o[fe][1];
    for (let fr = -1; fr <= 7; fr++)
      if (!(me + fr <= -1 || s <= me + fr))
        for (let Er = -1; Er <= 7; Er++)
          ye + Er <= -1 || s <= ye + Er || (fr >= 0 && fr <= 6 && (Er === 0 || Er === 6) || Er >= 0 && Er <= 6 && (fr === 0 || fr === 6) || fr >= 2 && fr <= 4 && Er >= 2 && Er <= 4 ? r.set(me + fr, ye + Er, !0, !0) : r.set(me + fr, ye + Er, !1, !0));
  }
}
function setupTimingPattern(r) {
  const e = r.size;
  for (let s = 8; s < e - 8; s++) {
    const o = s % 2 === 0;
    r.set(s, 6, o, !0), r.set(6, s, o, !0);
  }
}
function setupAlignmentPattern(r, e) {
  const s = AlignmentPattern.getPositions(e);
  for (let o = 0; o < s.length; o++) {
    const fe = s[o][0], me = s[o][1];
    for (let ye = -2; ye <= 2; ye++)
      for (let fr = -2; fr <= 2; fr++)
        ye === -2 || ye === 2 || fr === -2 || fr === 2 || ye === 0 && fr === 0 ? r.set(fe + ye, me + fr, !0, !0) : r.set(fe + ye, me + fr, !1, !0);
  }
}
function setupVersionInfo(r, e) {
  const s = r.size, o = Version.getEncodedBits(e);
  let fe, me, ye;
  for (let fr = 0; fr < 18; fr++)
    fe = Math.floor(fr / 3), me = fr % 3 + s - 8 - 3, ye = (o >> fr & 1) === 1, r.set(fe, me, ye, !0), r.set(me, fe, ye, !0);
}
function setupFormatInfo(r, e, s) {
  const o = r.size, fe = FormatInfo.getEncodedBits(e, s);
  let me, ye;
  for (me = 0; me < 15; me++)
    ye = (fe >> me & 1) === 1, me < 6 ? r.set(me, 8, ye, !0) : me < 8 ? r.set(me + 1, 8, ye, !0) : r.set(o - 15 + me, 8, ye, !0), me < 8 ? r.set(8, o - me - 1, ye, !0) : me < 9 ? r.set(8, 15 - me - 1 + 1, ye, !0) : r.set(8, 15 - me - 1, ye, !0);
  r.set(o - 8, 8, 1, !0);
}
function setupData(r, e) {
  const s = r.size;
  let o = -1, fe = s - 1, me = 7, ye = 0;
  for (let fr = s - 1; fr > 0; fr -= 2)
    for (fr === 6 && fr--; ; ) {
      for (let Er = 0; Er < 2; Er++)
        if (!r.isReserved(fe, fr - Er)) {
          let br = !1;
          ye < e.length && (br = (e[ye] >>> me & 1) === 1), r.set(fe, fr - Er, br), me--, me === -1 && (ye++, me = 7);
        }
      if (fe += o, fe < 0 || s <= fe) {
        fe -= o, o = -o;
        break;
      }
    }
}
function createData(r, e, s) {
  const o = new BitBuffer();
  s.forEach(function(Er) {
    o.put(Er.mode.bit, 4), o.put(Er.getLength(), Mode.getCharCountIndicator(Er.mode, r)), Er.write(o);
  });
  const fe = Utils$1.getSymbolTotalCodewords(r), me = ECCode.getTotalCodewordsCount(r, e), ye = (fe - me) * 8;
  for (o.getLengthInBits() + 4 <= ye && o.put(0, 4); o.getLengthInBits() % 8 !== 0; )
    o.putBit(0);
  const fr = (ye - o.getLengthInBits()) / 8;
  for (let Er = 0; Er < fr; Er++)
    o.put(Er % 2 ? 17 : 236, 8);
  return createCodewords(o, r, e);
}
function createCodewords(r, e, s) {
  const o = Utils$1.getSymbolTotalCodewords(e), fe = ECCode.getTotalCodewordsCount(e, s), me = o - fe, ye = ECCode.getBlocksCount(e, s), fr = o % ye, Er = ye - fr, br = Math.floor(o / ye), wr = Math.floor(me / ye), kr = wr + 1, Gr = br - wr, Vr = new ReedSolomonEncoder(Gr);
  let jr = 0;
  const Kr = new Array(ye), bn = new Array(ye);
  let Yr = 0;
  const Zr = new Uint8Array(r.buffer);
  for (let Br = 0; Br < ye; Br++) {
    const Hr = Br < Er ? wr : kr;
    Kr[Br] = Zr.slice(jr, jr + Hr), bn[Br] = Vr.encode(Kr[Br]), jr += Hr, Yr = Math.max(Yr, Hr);
  }
  const ti = new Uint8Array(o);
  let On = 0, ni, In;
  for (ni = 0; ni < Yr; ni++)
    for (In = 0; In < ye; In++)
      ni < Kr[In].length && (ti[On++] = Kr[In][ni]);
  for (ni = 0; ni < Gr; ni++)
    for (In = 0; In < ye; In++)
      ti[On++] = bn[In][ni];
  return ti;
}
function createSymbol(r, e, s, o) {
  let fe;
  if (Array.isArray(r))
    fe = Segments.fromArray(r);
  else if (typeof r == "string") {
    let br = e;
    if (!br) {
      const wr = Segments.rawSplit(r);
      br = Version.getBestVersionForData(wr, s);
    }
    fe = Segments.fromString(r, br || 40);
  } else
    throw new Error("Invalid data");
  const me = Version.getBestVersionForData(fe, s);
  if (!me)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = me;
  else if (e < me)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + me + `.
`
    );
  const ye = createData(e, s, fe), fr = Utils$1.getSymbolSize(e), Er = new BitMatrix(fr);
  return setupFinderPattern(Er, e), setupTimingPattern(Er), setupAlignmentPattern(Er, e), setupFormatInfo(Er, s, 0), e >= 7 && setupVersionInfo(Er, e), setupData(Er, ye), isNaN(o) && (o = MaskPattern.getBestMask(
    Er,
    setupFormatInfo.bind(null, Er, s)
  )), MaskPattern.applyMask(o, Er), setupFormatInfo(Er, s, o), {
    modules: Er,
    version: e,
    errorCorrectionLevel: s,
    maskPattern: o,
    segments: fe
  };
}
qrcode.create = function r(e, s) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let o = ECLevel.M, fe, me;
  return typeof s < "u" && (o = ECLevel.from(s.errorCorrectionLevel, ECLevel.M), fe = Version.from(s.version), me = MaskPattern.from(s.maskPattern), s.toSJISFunc && Utils$1.setToSJISFunction(s.toSJISFunc)), createSymbol(e, fe, o, me);
};
var canvas = {}, utils = {};
(function(r) {
  function e(s) {
    if (typeof s == "number" && (s = s.toString()), typeof s != "string")
      throw new Error("Color should be defined as hex string");
    let o = s.slice().replace("#", "").split("");
    if (o.length < 3 || o.length === 5 || o.length > 8)
      throw new Error("Invalid hex color: " + s);
    (o.length === 3 || o.length === 4) && (o = Array.prototype.concat.apply([], o.map(function(me) {
      return [me, me];
    }))), o.length === 6 && o.push("F", "F");
    const fe = parseInt(o.join(""), 16);
    return {
      r: fe >> 24 & 255,
      g: fe >> 16 & 255,
      b: fe >> 8 & 255,
      a: fe & 255,
      hex: "#" + o.slice(0, 6).join("")
    };
  }
  r.getOptions = function(o) {
    o || (o = {}), o.color || (o.color = {});
    const fe = typeof o.margin > "u" || o.margin === null || o.margin < 0 ? 4 : o.margin, me = o.width && o.width >= 21 ? o.width : void 0, ye = o.scale || 4;
    return {
      width: me,
      scale: me ? 4 : ye,
      margin: fe,
      color: {
        dark: e(o.color.dark || "#000000ff"),
        light: e(o.color.light || "#ffffffff")
      },
      type: o.type,
      rendererOpts: o.rendererOpts || {}
    };
  }, r.getScale = function(o, fe) {
    return fe.width && fe.width >= o + fe.margin * 2 ? fe.width / (o + fe.margin * 2) : fe.scale;
  }, r.getImageWidth = function(o, fe) {
    const me = r.getScale(o, fe);
    return Math.floor((o + fe.margin * 2) * me);
  }, r.qrToImageData = function(o, fe, me) {
    const ye = fe.modules.size, fr = fe.modules.data, Er = r.getScale(ye, me), br = Math.floor((ye + me.margin * 2) * Er), wr = me.margin * Er, kr = [me.color.light, me.color.dark];
    for (let Gr = 0; Gr < br; Gr++)
      for (let Vr = 0; Vr < br; Vr++) {
        let jr = (Gr * br + Vr) * 4, Kr = me.color.light;
        if (Gr >= wr && Vr >= wr && Gr < br - wr && Vr < br - wr) {
          const bn = Math.floor((Gr - wr) / Er), Yr = Math.floor((Vr - wr) / Er);
          Kr = kr[fr[bn * ye + Yr] ? 1 : 0];
        }
        o[jr++] = Kr.r, o[jr++] = Kr.g, o[jr++] = Kr.b, o[jr] = Kr.a;
      }
  };
})(utils);
(function(r) {
  const e = utils;
  function s(fe, me, ye) {
    fe.clearRect(0, 0, me.width, me.height), me.style || (me.style = {}), me.height = ye, me.width = ye, me.style.height = ye + "px", me.style.width = ye + "px";
  }
  function o() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  r.render = function(me, ye, fr) {
    let Er = fr, br = ye;
    typeof Er > "u" && (!ye || !ye.getContext) && (Er = ye, ye = void 0), ye || (br = o()), Er = e.getOptions(Er);
    const wr = e.getImageWidth(me.modules.size, Er), kr = br.getContext("2d"), Gr = kr.createImageData(wr, wr);
    return e.qrToImageData(Gr.data, me, Er), s(kr, br, wr), kr.putImageData(Gr, 0, 0), br;
  }, r.renderToDataURL = function(me, ye, fr) {
    let Er = fr;
    typeof Er > "u" && (!ye || !ye.getContext) && (Er = ye, ye = void 0), Er || (Er = {});
    const br = r.render(me, ye, Er), wr = Er.type || "image/png", kr = Er.rendererOpts || {};
    return br.toDataURL(wr, kr.quality);
  };
})(canvas);
var svgTag = {};
const Utils = utils;
function getColorAttrib(r, e) {
  const s = r.a / 255, o = e + '="' + r.hex + '"';
  return s < 1 ? o + " " + e + '-opacity="' + s.toFixed(2).slice(1) + '"' : o;
}
function svgCmd(r, e, s) {
  let o = r + e;
  return typeof s < "u" && (o += " " + s), o;
}
function qrToPath(r, e, s) {
  let o = "", fe = 0, me = !1, ye = 0;
  for (let fr = 0; fr < r.length; fr++) {
    const Er = Math.floor(fr % e), br = Math.floor(fr / e);
    !Er && !me && (me = !0), r[fr] ? (ye++, fr > 0 && Er > 0 && r[fr - 1] || (o += me ? svgCmd("M", Er + s, 0.5 + br + s) : svgCmd("m", fe, 0), fe = 0, me = !1), Er + 1 < e && r[fr + 1] || (o += svgCmd("h", ye), ye = 0)) : fe++;
  }
  return o;
}
svgTag.render = function r(e, s, o) {
  const fe = Utils.getOptions(s), me = e.modules.size, ye = e.modules.data, fr = me + fe.margin * 2, Er = fe.color.light.a ? "<path " + getColorAttrib(fe.color.light, "fill") + ' d="M0 0h' + fr + "v" + fr + 'H0z"/>' : "", br = "<path " + getColorAttrib(fe.color.dark, "stroke") + ' d="' + qrToPath(ye, me, fe.margin) + '"/>', wr = 'viewBox="0 0 ' + fr + " " + fr + '"', Gr = '<svg xmlns="http://www.w3.org/2000/svg" ' + (fe.width ? 'width="' + fe.width + '" height="' + fe.width + '" ' : "") + wr + ' shape-rendering="crispEdges">' + Er + br + `</svg>
`;
  return typeof o == "function" && o(null, Gr), Gr;
};
const canPromise = canPromise$1, QRCode = qrcode, CanvasRenderer = canvas, SvgRenderer = svgTag;
function renderCanvas(r, e, s, o, fe) {
  const me = [].slice.call(arguments, 1), ye = me.length, fr = typeof me[ye - 1] == "function";
  if (!fr && !canPromise())
    throw new Error("Callback required as last argument");
  if (fr) {
    if (ye < 2)
      throw new Error("Too few arguments provided");
    ye === 2 ? (fe = s, s = e, e = o = void 0) : ye === 3 && (e.getContext && typeof fe > "u" ? (fe = o, o = void 0) : (fe = o, o = s, s = e, e = void 0));
  } else {
    if (ye < 1)
      throw new Error("Too few arguments provided");
    return ye === 1 ? (s = e, e = o = void 0) : ye === 2 && !e.getContext && (o = s, s = e, e = void 0), new Promise(function(Er, br) {
      try {
        const wr = QRCode.create(s, o);
        Er(r(wr, e, o));
      } catch (wr) {
        br(wr);
      }
    });
  }
  try {
    const Er = QRCode.create(s, o);
    fe(null, r(Er, e, o));
  } catch (Er) {
    fe(Er);
  }
}
browser.create = QRCode.create;
browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
browser.toString = renderCanvas.bind(null, function(r, e, s) {
  return SvgRenderer.render(r, s);
});
const _sfc_main$8 = defineComponent({
  mounted() {
    this.generateQRCode(), this.selectedMode === LoginMethodsEnum.walletconnectv2 && this.login();
  },
  setup() {
    const r = ref(""), e = ref(""), s = ref(""), o = useAppConfigStore().getWalletConnectV2Login, [
      fe,
      { error: me },
      {
        uriDeepLink: ye,
        walletConnectUri: fr,
        getWcPairings: Er,
        connectExisting: br,
        removeExistingPairing: wr
      }
    ] = useWalletConnectV2Login(o);
    me && (r.value = me), watch$3(fr, () => {
      Gr();
    });
    const kr = async () => {
      await fe();
    }, Gr = async () => {
      if (!!Boolean(fr.value) && fr.value) {
        const bn = await browser.toString(fr.value, {
          type: "svg"
        });
        bn && (e.value = bn);
      }
    };
    return {
      login: kr,
      generateQRCode: Gr,
      errorMessage: r,
      qrCodeSvg: e,
      getWcPairings: Er,
      pairingSelected: (Kr) => {
        br(Kr), s.value = Kr.topic;
      },
      pairingRemoved: (Kr) => {
        s.value = "", wr(Kr.topic);
      },
      topicLoading: s,
      LoginMethodsEnum,
      uriDeepLink: ye
    };
  },
  props: {
    selectedMode: {
      type: String,
      default: ""
    }
  },
  computed: {
    isMobileDevice() {
      return "ontouchstart" in window || "onmsgesturechange" in window;
    },
    wcPairings() {
      return this.getWcPairings();
    },
    activeWcPairings() {
      var s;
      const r = this.getWcPairings();
      return (s = r == null ? void 0 : r.filter((o) => {
        const fe = r.some(
          (me) => {
            var ye, fr, Er, br;
            return ((ye = o.peerMetadata) == null ? void 0 : ye.name) === ((fr = me == null ? void 0 : me.peerMetadata) == null ? void 0 : fr.name) && ((Er = o.peerMetadata) == null ? void 0 : Er.url) === ((br = me == null ? void 0 : me.peerMetadata) == null ? void 0 : br.url) && o.expiry < me.expiry;
          }
        );
        return Boolean(o.active) && o.peerMetadata && !fe;
      })) != null ? s : [];
    }
  }
}), ErdjsLoginWalletConnectV2_vue_vue_type_style_index_0_lang = "", _hoisted_1$7 = { class: "erdjs-vue__login-wrappper d-flex flex-column justify-content-start align-items-center" }, _hoisted_2$6 = {
  key: 0,
  class: "dapp-login__tab-error"
}, _hoisted_3$6 = /* @__PURE__ */ createElementVNode("h4", null, "xPortal Login", -1), _hoisted_4$6 = /* @__PURE__ */ createElementVNode("strong", { class: "mb-2" }, "Choose a session:", -1), _hoisted_5$5 = ["src", "alt"], _hoisted_6$4 = { class: "d-flex flex-column align-items-start" }, _hoisted_7$4 = { key: 0 }, _hoisted_8$3 = { key: 1 }, _hoisted_9$3 = ["onClick"], _hoisted_10$3 = ["onClick"], _hoisted_11$3 = { key: 2 }, _hoisted_12$3 = ["href"], _hoisted_13$3 = /* @__PURE__ */ createElementVNode("p", { class: "mb-2" }, "Scan the QR Code with xPortal app", -1), _hoisted_14$2 = ["innerHTML"], _hoisted_15$2 = { class: "back-button my-3" };
function _sfc_render$8(r, e, s, o, fe, me) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    r.errorMessage ? (openBlock(), createElementBlock("div", _hoisted_2$6, toDisplayString(r.errorMessage), 1)) : createCommentVNode("", !0),
    _hoisted_3$6,
    r.activeWcPairings.length ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
      _hoisted_4$6,
      (openBlock(!0), createElementBlock(Fragment, null, renderList(r.activeWcPairings, (ye, fr) => {
        var Er, br;
        return openBlock(), createElementBlock("div", {
          key: fr,
          class: "w-100 mb-2"
        }, [
          ye.peerMetadata ? (openBlock(), createElementBlock("div", {
            key: ye.topic,
            class: "pairing d-flex flex-row align-items-center p-2 rounded mx-3"
          }, [
            (br = (Er = ye.peerMetadata) == null ? void 0 : Er.icons) != null && br[0] ? (openBlock(), createElementBlock("img", {
              key: 0,
              src: ye.peerMetadata.icons[0],
              alt: ye.peerMetadata.name,
              class: "pairing--img me-2"
            }, null, 8, _hoisted_5$5)) : createCommentVNode("", !0),
            createElementVNode("div", _hoisted_6$4, [
              r.topicLoading === ye.topic ? (openBlock(), createElementBlock("strong", _hoisted_7$4, " Confirm on " + toDisplayString(ye.peerMetadata.name), 1)) : (openBlock(), createElementBlock("strong", _hoisted_8$3, toDisplayString(ye.peerMetadata.name), 1)),
              createElementVNode("span", null, toDisplayString(ye.peerMetadata.description), 1),
              createElementVNode("span", null, toDisplayString(ye.peerMetadata.url), 1),
              createElementVNode("a", {
                href: "#",
                onClick: withModifiers((wr) => r.pairingSelected(ye), ["prevent"]),
                class: "pairing--link",
                title: "Connect pairing"
              }, null, 8, _hoisted_9$3),
              createElementVNode("button", {
                class: "btn btn-pairing-remove",
                onClick: withModifiers((wr) => r.pairingRemoved(ye), ["prevent"])
              }, "\xD7", 8, _hoisted_10$3)
            ])
          ])) : createCommentVNode("", !0)
        ]);
      }), 128))
    ], 64)) : createCommentVNode("", !0),
    r.isMobileDevice && r.uriDeepLink ? (openBlock(), createElementBlock("div", _hoisted_11$3, [
      createElementVNode("a", {
        href: r.uriDeepLink,
        class: "btn btn-primary w-100 mb-4"
      }, "Click to login", 8, _hoisted_12$3)
    ])) : createCommentVNode("", !0),
    _hoisted_13$3,
    r.qrCodeSvg ? (openBlock(), createElementBlock("div", {
      key: 3,
      innerHTML: r.qrCodeSvg,
      class: "wallet-connect-qrcode px-4"
    }, null, 8, _hoisted_14$2)) : createCommentVNode("", !0),
    createElementVNode("div", _hoisted_15$2, [
      createElementVNode("button", {
        onClick: e[0] || (e[0] = withModifiers((ye) => r.$emit("hide-login-tab"), ["prevent"])),
        class: "btn btn-secondary"
      }, "Back")
    ])
  ]);
}
const ErdjsLoginWalletConnectV2 = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]), failInitializeErrorText = "Check if the MultiversX App is open on Ledger";
function useLedgerLogin({
  callbackRoute: r,
  token: e,
  addressesPerPage: s,
  nativeAuth: o,
  onLoginRedirect: fe
}) {
  const me = useAccountStore().getLedgerAccount, ye = getIsLoggedIn(), fr = Boolean(o), Er = useLoginService(o);
  let br = e;
  const wr = s != null ? s : 10, kr = new out$1.HWProvider(), Gr = useLedgerStore();
  function Vr({
    provider: ni,
    address: In,
    index: Br,
    signature: Hr
  }) {
    setAccountProvider(ni), useLoginInfoStore().setLedgerLogin({ index: Br, loginType: LoginMethodsEnum.ledger }), Hr && Er.setTokenLoginInfo({ signature: Hr, address: In });
    const Pn = { address: In, loginMethod: LoginMethodsEnum.ledger };
    useAccountStore().setLogin(Pn), optionalRedirect$1({
      callbackRoute: r,
      onLoginRedirect: fe,
      options: { address: In, signature: Hr }
    });
  }
  const jr = (ni, In = "") => {
    const { errorMessage: Br } = getLedgerErrorCodes(ni);
    Br && Gr.setError(`${Br}.${In}`), Gr.setIsLoading(!1), console.warn(ni), useAccountStore().setLedgerAccount(null);
  };
  async function Kr(ni) {
    var Br;
    if (Gr.getSelectedAddress == null)
      return !1;
    const In = (Br = Gr.selectedAddress) != null && Br.index ? Gr.selectedAddress.index : 0;
    if (fr && !br && (br = await Er.getNativeAuthLoginToken(), !br)) {
      console.warn("Fetching block failed. Login cancelled."), alert("Login cancelled. Please try again.");
      return;
    }
    if (br) {
      Er.setLoginToken(br);
      try {
        const Hr = await ni.tokenLogin({
          token: Buffer.from(`${br}{}`),
          addressIndex: In
        });
        Vr({
          address: Hr.address,
          provider: ni,
          index: In,
          signature: Hr.signature.toString("hex")
        });
      } catch (Hr) {
        jr(Hr, ". Update MultiversX App to continue.");
      }
    } else
      try {
        const Hr = await ni.login({ addressIndex: In });
        Vr({
          address: Hr,
          provider: ni,
          index: In
        });
      } catch (Hr) {
        return jr(Hr), !1;
      }
    return !0;
  }
  async function bn() {
    try {
      if (Gr.setIsLoading(!0), Gr.selectedAddress == null)
        return !1;
      me ? useAccountStore().updateLedgerAccount(Gr.selectedAddress) : useAccountStore().setLedgerAccount({
        ...Gr.selectedAddress,
        version: Gr.getVersion,
        hasContractDataEnabled: Gr.getContractDataEnabled
      });
      const ni = new out$1.HWProvider();
      if (!await ni.init())
        return Gr.setError(failInitializeErrorText), console.warn(failInitializeErrorText), !1;
      Gr.setIsLoading(!1), await Kr(ni);
    } catch (ni) {
      const { errorMessage: In } = getLedgerErrorCodes(ni);
      In && Gr.setError(In), console.warn(failInitializeErrorText, ni);
    } finally {
      Gr.setIsLoading(!1);
    }
    return Gr.setShowAddressList(!1), !0;
  }
  async function Yr() {
    try {
      if (Gr.setIsLoadingAccounts(!0), Gr.setShowAddressList(!0), !await kr.init()) {
        Gr.setError(failInitializeErrorText), console.warn(failInitializeErrorText), Gr.setIsLoadingAccounts(!1);
        return;
      }
      const In = await kr.getAccounts(
        Gr.getStartIndex,
        wr
      ), Br = await getLedgerConfiguration(kr);
      Gr.setVersion(Br.version), Gr.setContractDataEnabled(Br.dataEnabled), Gr.setAccounts(In), Gr.setIsLoadingAccounts(!1);
    } catch (ni) {
      const { errorMessage: In, defaultErrorMessage: Br } = getLedgerErrorCodes(ni);
      Gr.setError(In != null ? In : Br), Gr.setIsLoadingAccounts(!1);
    }
  }
  async function Zr() {
    var ni;
    if (ye)
      throw new Error(SECOND_LOGIN_ATTEMPT_ERROR);
    Gr.setError("");
    try {
      if (Gr.setIsLoading(!0), me != null) {
        const In = new out$1.HWProvider();
        if (!await In.init() || !Gr.getSelectedAddress) {
          console.warn(failInitializeErrorText);
          return;
        }
        const Hr = await In.login({
          addressIndex: Gr.getSelectedAddress.index.valueOf()
        });
        if (setAccountProvider(In), !Hr) {
          Gr.setIsLoading(!1), console.warn("Login cancelled.");
          return;
        }
        const Pn = { address: Hr, loginMethod: LoginMethodsEnum.ledger };
        useAccountStore().setLogin(Pn), optionalRedirect$1({
          callbackRoute: r,
          onLoginRedirect: fe
        });
      } else
        ((ni = Gr.getAccounts) == null ? void 0 : ni.length) > 0 || await Yr(), Gr.setShowAddressList(!0);
    } catch (In) {
      console.error("error ", In);
      const { defaultErrorMessage: Br } = getLedgerErrorCodes();
      Gr.setError(Br);
    } finally {
      Gr.setIsLoading(!1);
    }
  }
  const { startIndex: ti, selectedAddress: On } = storeToRefs(useLedgerStore());
  return watch$3(ti, () => {
    Yr();
  }), watch$3(On, () => {
    bn();
  }), [
    Zr,
    bn
  ];
}
const ErdjsLoginLedgerAddressTable_vue_vue_type_style_index_0_lang = "", _sfc_main$7 = {
  name: "ErdjsLoginLedgerAddressTable",
  data() {
    return {
      showConfirmationModal: !1
    };
  },
  beforeUnmount() {
    useLedgerStore().logout();
  },
  computed: {
    getAccounts() {
      return useLedgerStore().getAccounts;
    },
    getAddress() {
      return useLedgerStore().getSelectedAddress.address;
    },
    getLoginToken() {
      var r;
      return (r = useLoginInfoStore().getTokenLogin) == null ? void 0 : r.loginToken;
    },
    showAddressList() {
      return useLedgerStore().showAddressList;
    },
    getErrorMessage() {
      return useLedgerStore().getErrorMessage;
    },
    getIsLoading() {
      return useLedgerStore().getIsLoadingAccounts;
    },
    isFirstPage() {
      return useLedgerStore().getStartIndex === 0;
    },
    isConfirmationModalVisible() {
      return this.showConfirmationModal;
    }
  },
  methods: {
    selectLedgerAddress(r, e) {
      const s = this.getAddressIndex(e);
      useLedgerStore().setSelectedAddress({
        address: r,
        index: s
      }), this.showConfirmationModal = !0;
    },
    nextPage() {
      useLedgerStore().changePage("next");
    },
    prevPage() {
      useLedgerStore().changePage("next");
    },
    getAddressIndex(r) {
      return 10 * useLedgerStore().getStartIndex + r;
    },
    getAddressShort(r) {
      return [
        r.substr(0, 8),
        r.substr(r.length - 8, 8)
      ].join("....");
    }
  }
}, _hoisted_1$6 = {
  key: 0,
  class: "erdjs-vue__login-wrappper px-2 text-center"
}, _hoisted_2$5 = { class: "row justify-content-center" }, _hoisted_3$5 = { class: "col-12" }, _hoisted_4$5 = { class: "card mb-4 w-100" }, _hoisted_5$4 = /* @__PURE__ */ createElementVNode("div", { class: "card-header" }, " Ledger Login ", -1), _hoisted_6$3 = { class: "card-body" }, _hoisted_7$3 = { class: "d-flex flex-column w-100" }, _hoisted_8$2 = {
  key: 0,
  class: "d-flex flex-column justify-content-center"
}, _hoisted_9$2 = /* @__PURE__ */ createElementVNode("strong", { "mb-2": "" }, "For security, please confirm that your address:", -1), _hoisted_10$2 = { class: "mb-2" }, _hoisted_11$2 = /* @__PURE__ */ createElementVNode("strong", null, "and Auth Token: ", -1), _hoisted_12$2 = { class: "mb-2" }, _hoisted_13$2 = /* @__PURE__ */ createElementVNode("strong", null, "is displayed on your Ledger device screen now.", -1), _hoisted_14$1 = {
  key: 0,
  class: "dapp-login__tab-error"
}, _hoisted_15$1 = { class: "text-danger mb-3" }, _hoisted_16$1 = /* @__PURE__ */ createElementVNode("div", { class: "d-block mb-3" }, [
  /* @__PURE__ */ createElementVNode("strong", null, "Access your wallet"),
  /* @__PURE__ */ createElementVNode("p", null, "Choose the wallet you want to access")
], -1), _hoisted_17$1 = { class: "d-flex flex-column justify-content-start align-items-start" }, _hoisted_18$1 = ["onClick"], _hoisted_19$1 = ["name", "id"], _hoisted_20$1 = {
  key: 0,
  class: "d-flex flex-row justify-content-center gap-3"
}, _hoisted_21$1 = {
  key: 2,
  class: "d-flex flex-column justify-contente-center align-items-center"
}, _hoisted_22$1 = /* @__PURE__ */ createElementVNode("strong", { class: "mb-2" }, "Loading Ledger Accounts...", -1), _hoisted_23$1 = /* @__PURE__ */ createElementVNode("div", {
  class: "spinner-border",
  style: { width: "3rem", height: "3rem" },
  role: "status"
}, [
  /* @__PURE__ */ createElementVNode("span", { class: "visually-hidden" }, "Loading ledger addresses...")
], -1), _hoisted_24$1 = [
  _hoisted_22$1,
  _hoisted_23$1
];
function _sfc_render$7(r, e, s, o, fe, me) {
  return me.showAddressList ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("div", _hoisted_2$5, [
      createElementVNode("div", _hoisted_3$5, [
        createElementVNode("div", _hoisted_4$5, [
          _hoisted_5$4,
          createElementVNode("div", _hoisted_6$3, [
            createElementVNode("div", _hoisted_7$3, [
              me.isConfirmationModalVisible ? (openBlock(), createElementBlock("div", _hoisted_8$2, [
                _hoisted_9$2,
                createElementVNode("code", _hoisted_10$2, toDisplayString(me.getAddress), 1),
                me.getLoginToken ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  _hoisted_11$2,
                  createElementVNode("code", _hoisted_12$2, toDisplayString(me.getLoginToken), 1)
                ], 64)) : createCommentVNode("", !0),
                _hoisted_13$2
              ])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                me.getErrorMessage ? (openBlock(), createElementBlock("div", _hoisted_14$1, [
                  createElementVNode("div", _hoisted_15$1, toDisplayString(me.getErrorMessage), 1)
                ])) : createCommentVNode("", !0),
                !me.getIsLoading && me.getAccounts ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  _hoisted_16$1,
                  createElementVNode("ul", _hoisted_17$1, [
                    (openBlock(!0), createElementBlock(Fragment, null, renderList(me.getAccounts, (ye, fr) => (openBlock(), createElementBlock("li", {
                      key: `ledger-account-${fr}`,
                      onClick: withModifiers((Er) => me.selectLedgerAddress(ye, fr), ["prevent"]),
                      class: "d-flex flex-row justfy-content-start mb-2 ledger-account mw-100 overflow-auto"
                    }, [
                      createElementVNode("input", {
                        class: "form-check-input me-2",
                        type: "radio",
                        name: `ledgerRadio${ye}`,
                        id: `ledgerRadio${ye}`
                      }, null, 8, _hoisted_19$1),
                      createElementVNode("span", null, "(" + toDisplayString(me.getAddressIndex(fr)) + ")", 1),
                      createElementVNode("span", null, toDisplayString(ye), 1)
                    ], 8, _hoisted_18$1))), 128))
                  ]),
                  me.getAccounts.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_20$1, [
                    createElementVNode("button", {
                      onClick: e[0] || (e[0] = withModifiers((ye) => me.prevPage(), ["prevent"])),
                      class: "btn btn-link",
                      disabled: "isFirstPage"
                    }, "Previous"),
                    createElementVNode("button", {
                      onClick: e[1] || (e[1] = withModifiers((ye) => me.nextPage(), ["prevent"])),
                      class: "btn btn-link"
                    }, "Next")
                  ])) : createCommentVNode("", !0)
                ], 64)) : createCommentVNode("", !0),
                me.getIsLoading ? (openBlock(), createElementBlock("div", _hoisted_21$1, _hoisted_24$1)) : createCommentVNode("", !0)
              ], 64))
            ])
          ])
        ])
      ])
    ])
  ])) : createCommentVNode("", !0);
}
const ErdjsLoginLedgerAddressTable = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]), _sfc_main$6 = {
  name: "ErdjsLoginLedger",
  components: {
    ErdjsLoginLedgerAddressTable
  },
  data() {
    return {
      error: null
    };
  },
  props: {
    selectedMode: {
      type: String,
      default: ""
    }
  },
  computed: {
    getAccounts() {
      return useLedgerStore().getAccounts;
    },
    showAddressList() {
      return useLedgerStore().showAddressList;
    }
  },
  methods: {
    login() {
      const r = useAppConfigStore().getLedgerLogin, [
        e
      ] = useLedgerLogin(r);
      e();
    }
  }
}, _hoisted_1$5 = { class: "erdjs-vue__login-wrappper px-2 text-center" }, _hoisted_2$4 = {
  key: 0,
  class: "dapp-login__tab-error"
}, _hoisted_3$4 = /* @__PURE__ */ createElementVNode("h4", { class: "mb-3" }, "MultiversX login", -1), _hoisted_4$4 = {
  key: 1,
  class: "mb-3"
}, _hoisted_5$3 = /* @__PURE__ */ createElementVNode("strong", null, "Connect Ledger", -1), _hoisted_6$2 = /* @__PURE__ */ createElementVNode("p", null, "Unlock your device & open the MultiversX App", -1), _hoisted_7$2 = { class: "back-button" };
function _sfc_render$6(r, e, s, o, fe, me) {
  const ye = resolveComponent("ErdjsLoginLedgerAddressTable");
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    fe.error ? (openBlock(), createElementBlock("div", _hoisted_2$4, toDisplayString(fe.error), 1)) : createCommentVNode("", !0),
    _hoisted_3$4,
    me.showAddressList ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", _hoisted_4$4, [
      _hoisted_5$3,
      _hoisted_6$2,
      createElementVNode("button", {
        onClick: e[0] || (e[0] = withModifiers((fr) => me.login(), ["prevent"])),
        class: "btn btn-primary"
      }, "Connect Ledger")
    ])),
    createVNode(ye),
    createElementVNode("div", _hoisted_7$2, [
      createElementVNode("button", {
        onClick: e[1] || (e[1] = withModifiers((fr) => r.$emit("hide-login-tab"), ["prevent"])),
        class: "btn btn-secondary"
      }, "Back")
    ])
  ]);
}
const ErdjsLoginLedger = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]), useGetNetworkConfig = () => useDappStore().getNetworkConfig;
let errorMessageDisplayed = !1;
function logError(r) {
  errorMessageDisplayed || (console.error(r), errorMessageDisplayed = !0);
}
function getExplorerLink({
  explorerAddress: r,
  to: e
}) {
  try {
    return new URL(e).href;
  } catch {
    return e.startsWith("/") || (logError(`Link not prepended by / : ${e}`), e = `/${e}`), r ? `${r}${e}` : e;
  }
}
function getExplorerUrl(r) {
  const e = useGetNetworkConfig();
  return getExplorerLink({
    explorerAddress: String(e.explorerAddress),
    to: r
  });
}
const explorerUrlBuilder = {
  shard: (r) => `/${BLOCKS_ENDPOINT}?shard=${r}`,
  receiverShard: (r) => `/${TRANSACTIONS_ENDPOINT}?receivershard=${r}`,
  senderShard: (r) => `/${TRANSACTIONS_ENDPOINT}?sendershard=${r}`,
  transactionDetails: (r) => `/${TRANSACTIONS_ENDPOINT}/${r}`,
  transactionDetailsScResults: (r) => `/${TRANSACTIONS_ENDPOINT}/${r}/${SC_RESULTS_ENDPOINT}`,
  transactionDetailsLogs: (r) => `/${TRANSACTIONS_ENDPOINT}/${r}/${LOGS_ENDPOINT}`,
  nodeDetails: (r) => `/${NODES_ENDPOINT}/${r}`,
  accountDetails: (r) => `/${ACCOUNTS_ENDPOINT}/${r}`,
  accountDetailsContractCode: (r) => `/${ACCOUNTS_ENDPOINT}/${r}/${CODE_ENDPOINT}`,
  accountDetailsTokens: (r) => `/${ACCOUNTS_ENDPOINT}/${r}/${TOKENS_ENDPOINT}`,
  accountDetailsNfts: (r) => `/${ACCOUNTS_ENDPOINT}/${r}/${NFTS_ENDPOINT}`,
  accountDetailsScResults: (r) => `/${ACCOUNTS_ENDPOINT}/${r}/${SC_RESULTS_ENDPOINT}`,
  accountDetailsContracts: (r) => `/${ACCOUNTS_ENDPOINT}/${r}/${CONTRACTS_ENDPOINT}`,
  identityDetails: (r) => `/${IDENTITIES_ENDPOINT}/${r}`,
  tokenDetails: (r) => `/${TOKENS_ENDPOINT}/${r}`,
  tokenDetailsAccounts: (r) => `/${TOKENS_ENDPOINT}/${r}/${ACCOUNTS_ENDPOINT}`,
  tokenDetailsLockedAccounts: (r) => `/${TOKENS_ENDPOINT}/${r}/${LOCKED_ACCOUNTS_ENDPOINT}`,
  tokenDetailsRoles: (r) => `/${TOKENS_ENDPOINT}/${r}/${ROLES_ENDPOINT}`,
  collectionDetails: (r) => `/${COLLECTIONS_ENDPOINT}/${r}`,
  nftDetails: (r) => `/${NFTS_ENDPOINT}/${r}`,
  providerDetails: (r) => `/${PROVIDERS_ENDPOINT}/${r}`,
  providerDetailsTransactions: (r) => `/${PROVIDERS_ENDPOINT}/${r}/${TRANSACTIONS_ENDPOINT}`
};
TransactionActionsEnum.reDelegateRewards, TransactionActionsEnum.claimRewards, TransactionActionsEnum.unBond;
TransactionActionsEnum.wrapEgld, TransactionActionsEnum.unwrapEgld;
TransactionActionsEnum.unStake;
TransactionActionsEnum.unDelegate;
const _sfc_main$5 = {
  name: "ErdjsLoginCard",
  components: {
    ErdjsLoginExtension,
    ErdjsLoginWebWallet,
    ErdjsLoginWalletConnectV2,
    ErdjsLoginLedger
  },
  props: {
    cssClassButtonsWrap: {
      type: String,
      default: "login-method d-flex flex-column flex-md-row justify-content-center flex-wrap"
    },
    cssClassExplorerButton: {
      type: String,
      default: "btn btn-outline-secondary mx-2"
    },
    cssClassLogoutButton: {
      type: String,
      default: "btn btn-outline-secondary mx-2"
    }
  },
  data() {
    return {
      loginMethod: "",
      title: "MultiversX Login",
      description: "",
      buttonTextExtension: "Extension",
      buttonTextLedger: "Ledger",
      buttonTextWebWallet: "Web Wallet",
      buttonTextMaiarApp: "Maiar App",
      buttonTextXPortal: "xPortal App"
    };
  },
  computed: {
    isLoggedIn() {
      return this.$erdjs.getDapp().getLoginInfoStore().isLoggedIn;
    },
    getAddress() {
      return this.$erdjs.getDapp().getAccountStore().getAddress;
    },
    getExplorerUrl() {
      const r = explorerUrlBuilder.accountDetails(this.getAddress);
      return getExplorerUrl(r);
    },
    getAddressShort() {
      return [
        this.getAddress.substr(0, 6),
        this.getAddress.substr(this.getAddress.length - 6, 6)
      ].join("....");
    }
  },
  methods: {
    getLoginMethods() {
      return LoginMethodsEnum;
    },
    logout() {
      this.loginMethod = this.getLoginMethods().none, logout();
    }
  }
}, _hoisted_1$4 = { class: "mb-4" }, _hoisted_2$3 = { class: "text-center" }, _hoisted_3$3 = { class: "d-flex flex-row justify-content-center" }, _hoisted_4$3 = ["href"];
function _sfc_render$5(r, e, s, o, fe, me) {
  const ye = resolveComponent("ErdjsLoginExtension"), fr = resolveComponent("ErdjsLoginWebWallet"), Er = resolveComponent("ErdjsLoginWalletConnectV2"), br = resolveComponent("ErdjsLoginLedger");
  return openBlock(), createElementBlock("div", null, [
    me.isLoggedIn ? createCommentVNode("", !0) : (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      fe.loginMethod ? createCommentVNode("", !0) : (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        renderSlot(r.$slots, "title", {}, () => [
          createElementVNode("h4", null, toDisplayString(fe.title), 1)
        ]),
        renderSlot(r.$slots, "description", {}, () => [
          createElementVNode("p", _hoisted_1$4, toDisplayString(fe.description), 1)
        ]),
        createElementVNode("div", {
          class: normalizeClass(s.cssClassButtonsWrap)
        }, [
          createElementVNode("button", {
            onClick: e[0] || (e[0] = withModifiers((wr) => fe.loginMethod = me.getLoginMethods().extension, ["prevent"])),
            class: "m-2 btn btn-primary"
          }, [
            renderSlot(r.$slots, "extension", {}, () => [
              createTextVNode(toDisplayString(fe.buttonTextExtension), 1)
            ])
          ]),
          createElementVNode("button", {
            onClick: e[1] || (e[1] = withModifiers((wr) => fe.loginMethod = me.getLoginMethods().walletconnectv2, ["prevent"])),
            class: "m-2 btn btn-primary"
          }, [
            renderSlot(r.$slots, "xportal", {}, () => [
              createTextVNode(toDisplayString(fe.buttonTextXPortal), 1)
            ])
          ]),
          createElementVNode("button", {
            onClick: e[2] || (e[2] = withModifiers((wr) => fe.loginMethod = me.getLoginMethods().ledger, ["prevent"])),
            class: "m-2 btn btn-primary"
          }, [
            renderSlot(r.$slots, "ledger", {}, () => [
              createTextVNode(toDisplayString(fe.buttonTextLedger), 1)
            ])
          ]),
          createElementVNode("button", {
            onClick: e[3] || (e[3] = withModifiers((wr) => fe.loginMethod = me.getLoginMethods().wallet, ["prevent"])),
            class: "m-2 btn btn-primary"
          }, [
            renderSlot(r.$slots, "webwallet", {}, () => [
              createTextVNode(toDisplayString(fe.buttonTextWebWallet), 1)
            ])
          ])
        ], 2)
      ], 64)),
      fe.loginMethod === me.getLoginMethods().extension ? (openBlock(), createBlock(ye, {
        key: 1,
        "selected-mode": fe.loginMethod,
        onHideLoginTab: e[4] || (e[4] = (wr) => fe.loginMethod = me.getLoginMethods().none)
      }, null, 8, ["selected-mode"])) : createCommentVNode("", !0),
      fe.loginMethod === me.getLoginMethods().wallet ? (openBlock(), createBlock(fr, {
        key: 2,
        "selected-mode": fe.loginMethod,
        onHideLoginTab: e[5] || (e[5] = (wr) => fe.loginMethod = me.getLoginMethods().none)
      }, null, 8, ["selected-mode"])) : createCommentVNode("", !0),
      fe.loginMethod === me.getLoginMethods().walletconnectv2 ? (openBlock(), createBlock(Er, {
        key: 3,
        "selected-mode": fe.loginMethod,
        onHideLoginTab: e[6] || (e[6] = (wr) => fe.loginMethod = me.getLoginMethods().none),
        onChangeLoginTab: e[7] || (e[7] = (wr) => fe.loginMethod = wr)
      }, null, 8, ["selected-mode"])) : createCommentVNode("", !0),
      fe.loginMethod === me.getLoginMethods().ledger ? (openBlock(), createBlock(br, {
        key: 4,
        "selected-mode": fe.loginMethod,
        onHideLoginTab: e[8] || (e[8] = (wr) => fe.loginMethod = me.getLoginMethods().none),
        onChangeLoginTab: e[9] || (e[9] = (wr) => fe.loginMethod = wr)
      }, null, 8, ["selected-mode"])) : createCommentVNode("", !0)
    ], 64)),
    me.isLoggedIn ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
      createElementVNode("p", _hoisted_2$3, [
        createTextVNode("MultiversX address: "),
        createElementVNode("strong", null, toDisplayString(me.getAddressShort), 1)
      ]),
      createElementVNode("div", _hoisted_3$3, [
        createElementVNode("a", {
          href: me.getExplorerUrl,
          target: "_blank",
          class: normalizeClass(s.cssClassExplorerButton)
        }, "View in explorer", 10, _hoisted_4$3),
        createElementVNode("button", {
          onClick: e[10] || (e[10] = withModifiers((wr) => me.logout(), ["prevent"])),
          class: normalizeClass(s.cssClassLogoutButton)
        }, "Logout", 2)
      ])
    ], 64)) : createCommentVNode("", !0)
  ]);
}
const ErdjsLoginCard = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]), index$2 = {
  install(r) {
    r.component(ErdjsLoginCard.name, ErdjsLoginCard);
  }
}, _sfc_main$4 = {
  name: "ErdjsLogin",
  components: {
    ErdjsLoginCard
  },
  computed: {
    txToSign() {
      return useTransactionsStore().getTransactionsToSign;
    }
  }
}, _hoisted_1$3 = { class: "erdjs-vue--login d-flex flex-column flex-grow-1" }, _hoisted_2$2 = { class: "d-flex flex-fill align-items-center" }, _hoisted_3$2 = { class: "m-auto mw-100" }, _hoisted_4$2 = { class: "card shadow-sm rounded p-4 border-0 text-center" }, _hoisted_5$2 = { class: "card-body py-4 px-2 px-sm-2 mx-lg-4" };
function _sfc_render$4(r, e, s, o, fe, me) {
  const ye = resolveComponent("ErdjsLoginCard");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    createElementVNode("div", _hoisted_2$2, [
      createElementVNode("div", _hoisted_3$2, [
        createElementVNode("div", _hoisted_4$2, [
          createElementVNode("div", _hoisted_5$2, [
            createVNode(ye)
          ])
        ])
      ])
    ])
  ]);
}
const ErdjsLogin = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]), index$1 = {
  install(r) {
    r.component(ErdjsLogin.name, ErdjsLogin);
  }
};
function parseTransactionAfterSigning(r) {
  const s = Object.getPrototypeOf(r).toPlainObject != null ? r : newTransaction(r);
  return {
    ...s.toPlainObject(),
    hash: s.getHash().hex(),
    status: TransactionServerStatusesEnum.pending
  };
}
function useParseSignedTransactions(r) {
  const { search: e } = window.location, s = useDappStore().getNetworkConfig, o = ref(e);
  watch$3(o, () => {
    if (e != null) {
      const fe = lib.parse(e.replace("?", ""));
      if (fe && WALLET_SIGN_SESSION in fe) {
        const me = String(fe[WALLET_SIGN_SESSION]), ye = new out.WalletProvider(
          `${s.walletAddress}${DAPP_INIT_ROUTE$1}`
        ).getTransactionsFromWalletUrl();
        if (fe.status === TransactionBatchStatusesEnum.cancelled) {
          useTransactionsStore().moveTransactionsToSignedState({
            sessionId: me,
            status: TransactionBatchStatusesEnum.cancelled
          }), r(), history.pushState({}, document == null ? void 0 : document.title, "?");
          return;
        }
        ye.length > 0 && (useTransactionsStore().moveTransactionsToSignedState({
          sessionId: me,
          status: TransactionBatchStatusesEnum.signed,
          transactions: ye.map(
            (fr) => parseTransactionAfterSigning(fr)
          )
        }), history.pushState({}, document == null ? void 0 : document.title, "?"));
      }
    }
  }, {
    immediate: !0
  });
}
function buildUrlParams(r, e) {
  const s = new URLSearchParams(r), o = Object.fromEntries(s);
  return { nextUrlParams: new URLSearchParams({
    ...o,
    ...e
  }).toString(), params: o };
}
function builtCallbackUrl({
  callbackUrl: r,
  urlParams: e = {}
}) {
  let s = r;
  if (Object.entries(e).length > 0) {
    const { search: o, origin: fe, pathname: me } = new URL(r), { nextUrlParams: ye } = buildUrlParams(o, e);
    s = `${fe}${me}?${ye}`;
  }
  return s;
}
function getShouldMoveTransactionsToSignedState(r) {
  const e = useTransactionsStore().getTransactionsToSign, s = Object.keys(r).length === (e == null ? void 0 : e.transactions.length);
  return r && (r && s);
}
const useSignTransactionsCommonData = () => {
  const { provider: r } = useGetAccountProvider();
  let e = null;
  const s = (br) => {
    e = br;
  }, o = useTransactionsStore().getTransactionsToSign, fe = useTransactionsStore().getSignTransactionsCancelMessage, me = Boolean(o == null ? void 0 : o.transactions), ye = () => {
    e = null, useTransactionsStore().setSignTransactionsCancelMessage(null);
  }, fr = (br) => {
    ye(), Er(br);
  };
  useParseSignedTransactions(fr);
  function Er(br) {
    var kr, Gr;
    const wr = r instanceof out$2.ExtensionProvider;
    useTransactionsStore().clearAllTransactionsToSign(), useTransactionsInfoStore().clearTransactionsInfoForSessionId(br), wr && (ye(), (Gr = (kr = out$2.ExtensionProvider.getInstance()) == null ? void 0 : kr.cancelAction) == null || Gr.call(kr));
  }
  return {
    error: e,
    canceledTransactionsMessage: fe,
    clearTransactionStatusMessage: ye,
    onAbort: fr,
    setError: s,
    hasTransactions: me,
    transactionsToSign: o
  };
}, setTransactionNonces = (r, e) => e.map((s, o) => (s.setNonce(r + o), s)), useSignTransactions = () => {
  const r = ref("/"), e = useAccountStore(), { address: s, isGuarded: o } = e, { provider: fe } = useGetAccountProvider(), me = getProviderType(fe), ye = ref(!1), fr = useTransactionsStore().getSignTransactionsCancelMessage, {
    transactionsToSign: Er,
    error: br,
    setError: wr,
    hasTransactions: kr,
    onAbort: Gr,
    clearTransactionStatusMessage: Vr
  } = useSignTransactionsCommonData();
  useParseSignedTransactions(Gr);
  function jr(On) {
    var In, Br;
    const ni = fe instanceof out$2.ExtensionProvider;
    useTransactionsStore().clearAllTransactionsToSign, useTransactionsInfoStore().clearTransactionsInfoForSessionId(On), ni && (Vr(), (Br = (In = out$2.ExtensionProvider.getInstance()) == null ? void 0 : In.cancelAction) == null || Br.call(In));
  }
  const Kr = (On, ni) => {
    const In = On.includes(TRANSACTION_CANCELLED);
    if (jr(ni), In) {
      useTransactionsStore().setSignTransactionsCancelMessage(TRANSACTION_CANCELLED);
      return;
    }
    wr(On);
  }, bn = (On, ni, In = "") => {
    const Br = { [WALLET_SIGN_SESSION]: ni }, Hr = `${window.location.origin}${In}`, Pn = builtCallbackUrl({ callbackUrl: Hr, urlParams: Br }), ei = o ? On.map((oi) => (oi.setVersion(out$4.TransactionVersion.withTxOptions()), oi.setOptions(
      out$4.TransactionOptions.withOptions({ guarded: !0 })
    ), oi)) : On;
    fe.signTransactions(ei, {
      callbackUrl: encodeURIComponent(Pn)
    });
  }, Yr = async () => {
    var Nn;
    if (ye.value)
      return;
    const {
      sessionId: On,
      transactions: ni,
      callbackRoute: In,
      customTransactionInformation: Br
    } = Er, { redirectAfterSign: Hr } = Br, Pn = In || window.location.pathname, ei = window.location.pathname.includes(Pn), oi = Hr && !ei;
    try {
      if (!await ((Nn = fe == null ? void 0 : fe.init) == null ? void 0 : Nn.call(fe)))
        return;
    } catch (En) {
      const qr = (En == null ? void 0 : En.message) || En || PROVIDER_NOT_INITIALIZED;
      Kr(qr);
      return;
    }
    try {
      ye.value = !0;
      const En = await fe.signTransactions(
        ni
      );
      if (ye.value = !1, !getShouldMoveTransactionsToSignedState(
        En
      ))
        return;
      const Jr = Object.values(
        En
      ).map((Sn) => parseTransactionAfterSigning(Sn)), ri = {
        sessionId: On,
        transactions: Jr,
        status: TransactionBatchStatusesEnum.signed
      };
      oi && (ri.redirectRoute = Pn), useTransactionsStore().moveTransactionsToSignedState(ri);
    } catch (En) {
      ye.value = !1;
      const qr = (En == null ? void 0 : En.message) || En || ERROR_SIGNING_TX;
      console.error(qr), useTransactionsStore().moveTransactionsToSignedState({
        sessionId: On,
        status: TransactionBatchStatusesEnum.cancelled
      }), Kr(
        qr.includes("cancel") ? TRANSACTION_CANCELLED : qr,
        On
      );
    }
  }, Zr = async () => {
    if (!Er)
      return;
    Vr();
    const { sessionId: On, transactions: ni, callbackRoute: In } = Er;
    if (!fe) {
      console.error(MISSING_PROVIDER_MESSAGE);
      return;
    }
    r.value = In || window.location.pathname;
    try {
      const Br = await getAccount(s);
      if (Br == null)
        return;
      const Hr = me === LoginMethodsEnum.wallet, Pn = getLatestNonce(Br), ei = setTransactionNonces(
        Pn,
        ni
      );
      if (Hr)
        return bn(ei, On, In);
      Yr();
    } catch (Br) {
      const Pn = (Br == null ? void 0 : Br.message) || ERROR_SIGNING;
      console.error(Pn), Kr(Pn, On), useTransactionsStore().moveTransactionsToSignedState({
        sessionId: On,
        status: TransactionBatchStatusesEnum.cancelled
      }), console.error(Pn, Br);
    }
  }, ti = ref(Er);
  return watch$3(ti, () => {
    Zr();
  }, {
    immediate: !0
  }), {
    error: br,
    canceledTransactionsMessage: fr,
    onAbort: Gr,
    hasTransactions: kr,
    callbackRoute: r.value,
    sessionId: Er == null ? void 0 : Er.sessionId,
    transactions: Er == null ? void 0 : Er.transactions
  };
}, component_vue_vue_type_style_index_0_scoped_aaa0cc97_lang = "", _sfc_main$3 = {
  name: "ErdjsTxModal",
  data() {
    return {
      xportal: "walletconnectv2",
      waitingForXPortalToSign: !1
    };
  },
  watch: {
    currentTx(r) {
      r === null && (this.waitingForXPortalToSign = !1);
    }
  },
  computed: {
    getLoginMethod() {
      return this.$erdjs.getDapp().getLoginInfoStore().getLoginMethod;
    },
    getIsXPortalLogin() {
      return this.$erdjs.getDapp().getLoginInfoStore().getLoginMethod === this.xportal;
    },
    getConfirmButtonLabel() {
      return this.getLoginMethod === this.xportal && this.getWaitingForXportalToSign ? "Sign on xPortal" : "Confirm";
    },
    getWaitingForXportalToSign() {
      return this.waitingForXPortalToSign;
    },
    myAddress() {
      return this.$erdjs.getDapp().getAccountStore().getAddress;
    },
    txToSign() {
      return this.$erdjs.getDapp().getTransactionsStore().getTransactionsToSign;
    },
    currentTx() {
      var r;
      return (r = this.txToSign) != null && r.transactions[0] ? this.txToSign.transactions[0] : null;
    },
    getModal() {
      return this.$erdjs.getDapp().getNotificationsStore().getNotificationModal;
    },
    address() {
      return this.$erdjs.getDapp().getProviderStore().getCurrent;
    },
    getSenderAddress() {
      return this.currentTx && this.currentTx.sender ? this.currentTx.sender : "";
    },
    getReceiverAddress() {
      return this.currentTx && this.currentTx.receiver ? this.currentTx.receiver : "";
    },
    getTxValue() {
      return this.currentTx && this.currentTx.value ? this.currentTx.value : 0;
    },
    getGasValue() {
      return this.currentTx && this.currentTx.getGasLimit().valueOf().toString() ? this.currentTx.getGasLimit().valueOf().toString() : 0;
    },
    getTxData() {
      return this.currentTx && this.currentTx.data ? this.currentTx.data : "";
    },
    getTxFormattedValue() {
      return formatAmount({
        input: this.getTxValue,
        addCommas: !1,
        showLastNonZeroDecimal: !0
      });
    },
    getEgldLabel() {
      return useDappStore().getEgldLabel;
    }
  },
  mounted() {
    this.waitingForXPortalToSign = !1, useSignTransactionsCommonData();
  },
  methods: {
    signTx() {
      this.waitingForXPortalToSign = !0, useSignTransactions();
    },
    rejectTx() {
      this.waitingForXPortalToSign = !1, useTransactionsStore().clearAllTransactionsToSign();
    }
  }
}, _withScopeId$1 = (r) => (pushScopeId("data-v-aaa0cc97"), r = r(), popScopeId(), r), _hoisted_1$2 = { key: 0 }, _hoisted_2$1 = {
  class: "modal fade show",
  style: { display: "block" },
  tabindex: "-1"
}, _hoisted_3$1 = { class: "modal-dialog" }, _hoisted_4$1 = { class: "modal-content" }, _hoisted_5$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "modal-header" }, [
  /* @__PURE__ */ createElementVNode("h5", { class: "modal-title" }, "Sign Transaction")
], -1)), _hoisted_6$1 = { class: "modal-body" }, _hoisted_7$1 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}, _hoisted_8$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", null, [
  /* @__PURE__ */ createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /* @__PURE__ */ createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)), _hoisted_9$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "fs-4 ms-3" }, " Check your phone to sign the transaction with xPortal app ", -1)), _hoisted_10$1 = [
  _hoisted_8$1,
  _hoisted_9$1
], _hoisted_11$1 = { class: "mb-3" }, _hoisted_12$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "fw-bold" }, "Sender address", -1)), _hoisted_13$1 = { class: "fw-normal text-break" }, _hoisted_14 = { class: "mb-3" }, _hoisted_15 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "fw-bold" }, "Receiver address", -1)), _hoisted_16 = { class: "fw-normal text-break" }, _hoisted_17 = {
  key: 0,
  class: "mb-3"
}, _hoisted_18 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "fw-bold" }, "Value", -1)), _hoisted_19 = { class: "fw-normal text-break" }, _hoisted_20 = {
  key: 1,
  class: "mb-3"
}, _hoisted_21 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "fw-bold" }, "Gas Limit", -1)), _hoisted_22 = { class: "fw-normal text-break" }, _hoisted_23 = {
  key: 2,
  class: "mb-3"
}, _hoisted_24 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "fw-bold" }, "Data", -1)), _hoisted_25 = { class: "tx-data fw-normal border rounded-2 bg-secondary bg-opacity-10 p-2" }, _hoisted_26 = { class: "modal-footer flex flex-row justify-content-between" }, _hoisted_27 = ["disabled"], _hoisted_28 = {
  key: 0,
  class: "me-2"
}, _hoisted_29 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /* @__PURE__ */ createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)), _hoisted_30 = [
  _hoisted_29
], _hoisted_31 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1));
function _sfc_render$3(r, e, s, o, fe, me) {
  return me.txToSign ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("div", _hoisted_2$1, [
      createElementVNode("div", _hoisted_3$1, [
        createElementVNode("div", _hoisted_4$1, [
          _hoisted_5$1,
          createElementVNode("div", _hoisted_6$1, [
            me.getIsXPortalLogin && me.getWaitingForXportalToSign ? (openBlock(), createElementBlock("div", _hoisted_7$1, _hoisted_10$1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createElementVNode("div", _hoisted_11$1, [
                _hoisted_12$1,
                createElementVNode("div", _hoisted_13$1, toDisplayString(me.getSenderAddress), 1)
              ]),
              createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                createElementVNode("div", _hoisted_16, toDisplayString(me.getReceiverAddress), 1)
              ]),
              me.getTxValue ? (openBlock(), createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                createElementVNode("div", _hoisted_19, toDisplayString(me.getTxFormattedValue) + " " + toDisplayString(me.getEgldLabel), 1)
              ])) : createCommentVNode("", !0),
              me.getGasValue ? (openBlock(), createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                createElementVNode("div", _hoisted_22, toDisplayString(me.getGasValue), 1)
              ])) : createCommentVNode("", !0),
              me.getTxData ? (openBlock(), createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                createElementVNode("div", _hoisted_25, toDisplayString(me.getTxData), 1)
              ])) : createCommentVNode("", !0)
            ], 64))
          ]),
          createElementVNode("div", _hoisted_26, [
            createElementVNode("button", {
              onClick: e[0] || (e[0] = withModifiers((ye) => me.rejectTx(), ["prevent"])),
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel"),
            createElementVNode("button", {
              onClick: e[1] || (e[1] = withModifiers((ye) => me.signTx(), ["prevent"])),
              type: "button",
              class: "btn btn-primary",
              disabled: me.getWaitingForXportalToSign
            }, [
              me.getWaitingForXportalToSign ? (openBlock(), createElementBlock("span", _hoisted_28, _hoisted_30)) : createCommentVNode("", !0),
              createTextVNode(" " + toDisplayString(me.getConfirmButtonLabel), 1)
            ], 8, _hoisted_27)
          ])
        ])
      ])
    ]),
    _hoisted_31
  ])) : createCommentVNode("", !0);
}
const ErdjsTxModal = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-aaa0cc97"]]);
function useGetTransactionDisplayInfo(r) {
  return useTransactionsInfoStore().getTransactionDisplayInfo(r);
}
const getToastDataStateByStatus = ({
  status: r,
  toastId: e,
  classes: s = {
    success: "success",
    danger: "danger",
    warning: "warning"
  },
  transactionDisplayInfo: o
}) => {
  var Er, br, wr, kr;
  const fe = {
    id: e,
    icon: "faCheck",
    expires: 3e4,
    hasCloseButton: !0,
    title: (Er = o == null ? void 0 : o.successMessage) != null ? Er : TransactionsDefaultTitles.success,
    iconClassName: s.success
  }, me = {
    id: e,
    expires: !1,
    icon: "faHourglass",
    hasCloseButton: !1,
    title: (br = o == null ? void 0 : o.processingMessage) != null ? br : TransactionsDefaultTitles.pending,
    iconClassName: s.warning
  }, ye = {
    id: e,
    icon: "faTimes",
    title: (wr = o == null ? void 0 : o.errorMessage) != null ? wr : TransactionsDefaultTitles.failed,
    hasCloseButton: !0,
    iconClassName: s.danger
  }, fr = {
    id: e,
    icon: "faTimes",
    title: (kr = o == null ? void 0 : o.timedOutMessage) != null ? kr : TransactionsDefaultTitles.timedOut,
    hasCloseButton: !0,
    iconClassName: s.warning
  };
  switch (r) {
    case TransactionBatchStatusesEnum.signed:
    case TransactionBatchStatusesEnum.sent:
      return me;
    case TransactionBatchStatusesEnum.success:
      return fe;
    case TransactionBatchStatusesEnum.cancelled:
    case TransactionBatchStatusesEnum.fail:
      return ye;
    case TransactionBatchStatusesEnum.timedOut:
      return fr;
    default:
      return me;
  }
};
function removeSignedTransaction(r) {
  useTransactionsStore().clearSignedTransaction(r);
}
const component_vue_vue_type_style_index_0_scoped_66a6f7d7_lang = "", _sfc_main$2 = {
  name: "ErdjsToast",
  props: {
    toastId: {
      type: String,
      default: ""
    },
    toast: {
      default: {}
    }
  },
  data() {
    return {
      show: !0
    };
  },
  mounted() {
    var r;
    (r = this.getTx) != null && r.transactions || this.closeThis(this.toastId), (this.getTxStatus === "success" || this.getTxStatus === "fail") && setTimeout(() => {
      this.closeThis(this.toastId);
    }, 8e3);
  },
  watch: {
    getTxStatus: {
      handler(r) {
        (r === "success" || r === "fail") && setTimeout(() => {
          this.closeThis(this.toastId);
        }, 8e3);
      }
    }
  },
  computed: {
    getTx() {
      return useTransactionsStore().getTransaction(this.toastId);
    },
    getTxStatus() {
      return useTransactionsStore().getTransactionStatus(this.toastId);
    },
    getTxTitle() {
      var r;
      return (r = this.getToastData) != null && r.title ? this.getToastData.title : "";
    },
    getTxDisplayInfo() {
      return useGetTransactionDisplayInfo(this.toastId);
    },
    getToastData() {
      return getToastDataStateByStatus({
        status: this.getTxStatus,
        toastId: this.toastId,
        transactionDisplayInfo: this.getTxDisplayInfo
      });
    },
    getIsPending() {
      return getIsTransactionPending(this.getTxStatus);
    },
    getIsTimedOut() {
      return getIsTransactionTimedOut(this.getTxStatus);
    },
    getBorderColor() {
      let r = "";
      switch (this.getTxStatus) {
        case "fail":
          r = "border-danger";
          break;
        case "success":
          r = "border-success";
          break;
      }
      return r;
    },
    getTxHash() {
      var e;
      if (!((e = this.getTx) != null && e.transactions))
        return "";
      const r = this.getTx.transactions[0];
      return r != null && r.hash ? r == null ? void 0 : r.hash : "";
    },
    getExplorerUrl() {
      var o;
      if (!((o = this.getTx) != null && o.transactions))
        return;
      const r = this.getTx.transactions[0];
      if (!(r != null && r.hash))
        return "";
      const e = useGetNetworkConfig(), s = explorerUrlBuilder.transactionDetails(r.hash);
      return getExplorerLink({
        explorerAddress: String(e.explorerAddress),
        to: s
      });
    }
  },
  methods: {
    closeThis(r) {
      this.show = !1, this.handleDeleteTransactionToast(r);
    },
    handleDeleteTransactionToast(r) {
      useToastsStore().removeTransactionToast(r), removeSignedTransaction(r);
    }
  }
}, _withScopeId = (r) => (pushScopeId("data-v-66a6f7d7"), r = r(), popScopeId(), r), _hoisted_1$1 = {
  class: /* @__PURE__ */ normalizeClass(["toast-header d-flex justify-content-between"])
}, _hoisted_2 = { class: "left" }, _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}, _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, null, -1)), _hoisted_5 = [
  _hoisted_4
], _hoisted_6 = {
  key: 1,
  class: "badge bg-danger"
}, _hoisted_7 = {
  key: 2,
  class: "badge bg-success"
}, _hoisted_8 = {
  key: 3,
  class: "badge bg-danger"
}, _hoisted_9 = { class: "mx-2" }, _hoisted_10 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", { "aria-hidden": "true" }, "\xD7", -1)), _hoisted_11 = [
  _hoisted_10
], _hoisted_12 = { class: "toast-body" }, _hoisted_13 = ["href"];
function _sfc_render$2(r, e, s, o, fe, me) {
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("div", {
      class: normalizeClass(["toast erdjs-vue--toast", { show: fe.show }, me.getBorderColor]),
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, [
      createElementVNode("div", _hoisted_1$1, [
        createElementVNode("div", _hoisted_2, [
          me.getIsPending ? (openBlock(), createElementBlock("div", _hoisted_3, _hoisted_5)) : createCommentVNode("", !0),
          me.getIsTimedOut ? (openBlock(), createElementBlock("span", _hoisted_6, "x")) : createCommentVNode("", !0),
          me.getTxStatus === "success" ? (openBlock(), createElementBlock("span", _hoisted_7, "\u2713")) : createCommentVNode("", !0),
          me.getTxStatus === "fail" ? (openBlock(), createElementBlock("span", _hoisted_8, "x")) : createCommentVNode("", !0),
          createElementVNode("strong", _hoisted_9, toDisplayString(me.getTxTitle), 1)
        ]),
        createElementVNode("button", {
          type: "button",
          class: "ml-2 mb-1 close btn btn-light",
          "data-dismiss": "toast",
          "aria-label": "Close",
          onClick: e[0] || (e[0] = (ye) => me.closeThis(s.toast.toastId))
        }, _hoisted_11)
      ]),
      createElementVNode("div", _hoisted_12, [
        me.getTxHash ? (openBlock(), createElementBlock("a", {
          key: 0,
          href: me.getExplorerUrl,
          target: "_blank"
        }, toDisplayString(me.getTxHash), 9, _hoisted_13)) : createCommentVNode("", !0)
      ])
    ], 2)
  ]);
}
const ErdjsToast = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-66a6f7d7"]]);
function useGetSignedTransactions() {
  const r = useTransactionsStore().signedTransactions, e = Object.entries(r), s = (e == null ? void 0 : e.length) > 0;
  return {
    signedTransactions: r,
    signedTransactionsArray: e,
    hasSignedTransactions: s
  };
}
const _sfc_main$1 = {
  name: "ErdjsToasts",
  components: {
    ErdjsToast
  },
  data() {
    return {
      show: !0
    };
  },
  mounted() {
    setTimeout(() => {
      useTransactionsStore().getPendingSignedTransactions;
    }, 500);
  },
  watch: {
    getSignedTxs: {
      handler(r) {
        this.handleSignedTransactionsListUpdate(r);
      },
      deep: !0
    }
  },
  computed: {
    getSignedTxs() {
      return useGetSignedTransactions().signedTransactions;
    },
    getTxToasts() {
      return this.$erdjs.getDapp().getToastsStore().getTransactionToasts;
    }
  },
  methods: {
    handleSignedTransactionsListUpdate(r) {
      for (const e in r)
        this.getTxToasts.some(
          (o) => o.toastId === e
        ) || useToastsStore().addTransactionToast(e);
    }
  }
};
function _sfc_render$1(r, e, s, o, fe, me) {
  const ye = resolveComponent("ErdjsToast");
  return openBlock(), createElementBlock("div", null, [
    me.getTxToasts ? (openBlock(!0), createElementBlock(Fragment, { key: 0 }, renderList(me.getTxToasts, (fr, Er) => (openBlock(), createBlock(ye, {
      "toast-id": fr.toastId,
      toast: fr,
      key: Er
    }, null, 8, ["toast-id", "toast"]))), 128)) : createCommentVNode("", !0)
  ]);
}
const ErdjsToasts = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]), component_vue_vue_type_style_index_0_scoped_be8ebbe8_lang = "", _sfc_main = {
  name: "ErdjsFooter",
  components: {
    ErdjsTxModal,
    ErdjsToasts
  },
  watch: {
    webviewToken(r) {
      r !== "" && useWebViewLogin(r);
    }
  },
  computed: {
    webviewToken() {
      return getWebviewToken();
    }
  }
}, _hoisted_1 = { class: "erdjs-vue--footer" };
function _sfc_render(r, e, s, o, fe, me) {
  const ye = resolveComponent("ErdjsTxModal"), fr = resolveComponent("ErdjsToasts");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode(ye),
    createVNode(fr)
  ]);
}
const ErdjsFooter = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-be8ebbe8"]]), index = {
  install(r) {
    r.component(ErdjsFooter.name, ErdjsFooter);
  }
}, components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ErdjsLogin: index$1,
  ErdjsLoginCard: index$2,
  ErdjsFooter: index
}, Symbol.toStringTag, { value: "Module" }));
var react = { exports: {} }, react_production_min = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production_min;
function requireReact_production_min() {
  if (hasRequiredReact_production_min)
    return react_production_min;
  hasRequiredReact_production_min = 1;
  var r = Symbol.for("react.element"), e = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), fe = Symbol.for("react.profiler"), me = Symbol.for("react.provider"), ye = Symbol.for("react.context"), fr = Symbol.for("react.forward_ref"), Er = Symbol.for("react.suspense"), br = Symbol.for("react.memo"), wr = Symbol.for("react.lazy"), kr = Symbol.iterator;
  function Gr(ii) {
    return ii === null || typeof ii != "object" ? null : (ii = kr && ii[kr] || ii["@@iterator"], typeof ii == "function" ? ii : null);
  }
  var Vr = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, jr = Object.assign, Kr = {};
  function bn(ii, fi, Ei) {
    this.props = ii, this.context = fi, this.refs = Kr, this.updater = Ei || Vr;
  }
  bn.prototype.isReactComponent = {}, bn.prototype.setState = function(ii, fi) {
    if (typeof ii != "object" && typeof ii != "function" && ii != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, ii, fi, "setState");
  }, bn.prototype.forceUpdate = function(ii) {
    this.updater.enqueueForceUpdate(this, ii, "forceUpdate");
  };
  function Yr() {
  }
  Yr.prototype = bn.prototype;
  function Zr(ii, fi, Ei) {
    this.props = ii, this.context = fi, this.refs = Kr, this.updater = Ei || Vr;
  }
  var ti = Zr.prototype = new Yr();
  ti.constructor = Zr, jr(ti, bn.prototype), ti.isPureReactComponent = !0;
  var On = Array.isArray, ni = Object.prototype.hasOwnProperty, In = { current: null }, Br = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Hr(ii, fi, Ei) {
    var bi, Si = {}, Ii = null, yi = null;
    if (fi != null)
      for (bi in fi.ref !== void 0 && (yi = fi.ref), fi.key !== void 0 && (Ii = "" + fi.key), fi)
        ni.call(fi, bi) && !Br.hasOwnProperty(bi) && (Si[bi] = fi[bi]);
    var ui = arguments.length - 2;
    if (ui === 1)
      Si.children = Ei;
    else if (1 < ui) {
      for (var hi = Array(ui), gi = 0; gi < ui; gi++)
        hi[gi] = arguments[gi + 2];
      Si.children = hi;
    }
    if (ii && ii.defaultProps)
      for (bi in ui = ii.defaultProps, ui)
        Si[bi] === void 0 && (Si[bi] = ui[bi]);
    return { $$typeof: r, type: ii, key: Ii, ref: yi, props: Si, _owner: In.current };
  }
  function Pn(ii, fi) {
    return { $$typeof: r, type: ii.type, key: fi, ref: ii.ref, props: ii.props, _owner: ii._owner };
  }
  function ei(ii) {
    return typeof ii == "object" && ii !== null && ii.$$typeof === r;
  }
  function oi(ii) {
    var fi = { "=": "=0", ":": "=2" };
    return "$" + ii.replace(/[=:]/g, function(Ei) {
      return fi[Ei];
    });
  }
  var Nn = /\/+/g;
  function En(ii, fi) {
    return typeof ii == "object" && ii !== null && ii.key != null ? oi("" + ii.key) : fi.toString(36);
  }
  function qr(ii, fi, Ei, bi, Si) {
    var Ii = typeof ii;
    (Ii === "undefined" || Ii === "boolean") && (ii = null);
    var yi = !1;
    if (ii === null)
      yi = !0;
    else
      switch (Ii) {
        case "string":
        case "number":
          yi = !0;
          break;
        case "object":
          switch (ii.$$typeof) {
            case r:
            case e:
              yi = !0;
          }
      }
    if (yi)
      return yi = ii, Si = Si(yi), ii = bi === "" ? "." + En(yi, 0) : bi, On(Si) ? (Ei = "", ii != null && (Ei = ii.replace(Nn, "$&/") + "/"), qr(Si, fi, Ei, "", function(gi) {
        return gi;
      })) : Si != null && (ei(Si) && (Si = Pn(Si, Ei + (!Si.key || yi && yi.key === Si.key ? "" : ("" + Si.key).replace(Nn, "$&/") + "/") + ii)), fi.push(Si)), 1;
    if (yi = 0, bi = bi === "" ? "." : bi + ":", On(ii))
      for (var ui = 0; ui < ii.length; ui++) {
        Ii = ii[ui];
        var hi = bi + En(Ii, ui);
        yi += qr(Ii, fi, Ei, hi, Si);
      }
    else if (hi = Gr(ii), typeof hi == "function")
      for (ii = hi.call(ii), ui = 0; !(Ii = ii.next()).done; )
        Ii = Ii.value, hi = bi + En(Ii, ui++), yi += qr(Ii, fi, Ei, hi, Si);
    else if (Ii === "object")
      throw fi = String(ii), Error("Objects are not valid as a React child (found: " + (fi === "[object Object]" ? "object with keys {" + Object.keys(ii).join(", ") + "}" : fi) + "). If you meant to render a collection of children, use an array instead.");
    return yi;
  }
  function Jr(ii, fi, Ei) {
    if (ii == null)
      return ii;
    var bi = [], Si = 0;
    return qr(ii, bi, "", "", function(Ii) {
      return fi.call(Ei, Ii, Si++);
    }), bi;
  }
  function ri(ii) {
    if (ii._status === -1) {
      var fi = ii._result;
      fi = fi(), fi.then(function(Ei) {
        (ii._status === 0 || ii._status === -1) && (ii._status = 1, ii._result = Ei);
      }, function(Ei) {
        (ii._status === 0 || ii._status === -1) && (ii._status = 2, ii._result = Ei);
      }), ii._status === -1 && (ii._status = 0, ii._result = fi);
    }
    if (ii._status === 1)
      return ii._result.default;
    throw ii._result;
  }
  var Sn = { current: null }, ai = { transition: null }, di = { ReactCurrentDispatcher: Sn, ReactCurrentBatchConfig: ai, ReactCurrentOwner: In };
  return react_production_min.Children = { map: Jr, forEach: function(ii, fi, Ei) {
    Jr(ii, function() {
      fi.apply(this, arguments);
    }, Ei);
  }, count: function(ii) {
    var fi = 0;
    return Jr(ii, function() {
      fi++;
    }), fi;
  }, toArray: function(ii) {
    return Jr(ii, function(fi) {
      return fi;
    }) || [];
  }, only: function(ii) {
    if (!ei(ii))
      throw Error("React.Children.only expected to receive a single React element child.");
    return ii;
  } }, react_production_min.Component = bn, react_production_min.Fragment = s, react_production_min.Profiler = fe, react_production_min.PureComponent = Zr, react_production_min.StrictMode = o, react_production_min.Suspense = Er, react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = di, react_production_min.cloneElement = function(ii, fi, Ei) {
    if (ii == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + ii + ".");
    var bi = jr({}, ii.props), Si = ii.key, Ii = ii.ref, yi = ii._owner;
    if (fi != null) {
      if (fi.ref !== void 0 && (Ii = fi.ref, yi = In.current), fi.key !== void 0 && (Si = "" + fi.key), ii.type && ii.type.defaultProps)
        var ui = ii.type.defaultProps;
      for (hi in fi)
        ni.call(fi, hi) && !Br.hasOwnProperty(hi) && (bi[hi] = fi[hi] === void 0 && ui !== void 0 ? ui[hi] : fi[hi]);
    }
    var hi = arguments.length - 2;
    if (hi === 1)
      bi.children = Ei;
    else if (1 < hi) {
      ui = Array(hi);
      for (var gi = 0; gi < hi; gi++)
        ui[gi] = arguments[gi + 2];
      bi.children = ui;
    }
    return { $$typeof: r, type: ii.type, key: Si, ref: Ii, props: bi, _owner: yi };
  }, react_production_min.createContext = function(ii) {
    return ii = { $$typeof: ye, _currentValue: ii, _currentValue2: ii, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, ii.Provider = { $$typeof: me, _context: ii }, ii.Consumer = ii;
  }, react_production_min.createElement = Hr, react_production_min.createFactory = function(ii) {
    var fi = Hr.bind(null, ii);
    return fi.type = ii, fi;
  }, react_production_min.createRef = function() {
    return { current: null };
  }, react_production_min.forwardRef = function(ii) {
    return { $$typeof: fr, render: ii };
  }, react_production_min.isValidElement = ei, react_production_min.lazy = function(ii) {
    return { $$typeof: wr, _payload: { _status: -1, _result: ii }, _init: ri };
  }, react_production_min.memo = function(ii, fi) {
    return { $$typeof: br, type: ii, compare: fi === void 0 ? null : fi };
  }, react_production_min.startTransition = function(ii) {
    var fi = ai.transition;
    ai.transition = {};
    try {
      ii();
    } finally {
      ai.transition = fi;
    }
  }, react_production_min.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
  }, react_production_min.useCallback = function(ii, fi) {
    return Sn.current.useCallback(ii, fi);
  }, react_production_min.useContext = function(ii) {
    return Sn.current.useContext(ii);
  }, react_production_min.useDebugValue = function() {
  }, react_production_min.useDeferredValue = function(ii) {
    return Sn.current.useDeferredValue(ii);
  }, react_production_min.useEffect = function(ii, fi) {
    return Sn.current.useEffect(ii, fi);
  }, react_production_min.useId = function() {
    return Sn.current.useId();
  }, react_production_min.useImperativeHandle = function(ii, fi, Ei) {
    return Sn.current.useImperativeHandle(ii, fi, Ei);
  }, react_production_min.useInsertionEffect = function(ii, fi) {
    return Sn.current.useInsertionEffect(ii, fi);
  }, react_production_min.useLayoutEffect = function(ii, fi) {
    return Sn.current.useLayoutEffect(ii, fi);
  }, react_production_min.useMemo = function(ii, fi) {
    return Sn.current.useMemo(ii, fi);
  }, react_production_min.useReducer = function(ii, fi, Ei) {
    return Sn.current.useReducer(ii, fi, Ei);
  }, react_production_min.useRef = function(ii) {
    return Sn.current.useRef(ii);
  }, react_production_min.useState = function(ii) {
    return Sn.current.useState(ii);
  }, react_production_min.useSyncExternalStore = function(ii, fi, Ei) {
    return Sn.current.useSyncExternalStore(ii, fi, Ei);
  }, react_production_min.useTransition = function() {
    return Sn.current.useTransition();
  }, react_production_min.version = "18.2.0", react_production_min;
}
var react_development = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_development;
function requireReact_development() {
  return hasRequiredReact_development || (hasRequiredReact_development = 1, function(r, e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var s = "18.2.0", o = Symbol.for("react.element"), fe = Symbol.for("react.portal"), me = Symbol.for("react.fragment"), ye = Symbol.for("react.strict_mode"), fr = Symbol.for("react.profiler"), Er = Symbol.for("react.provider"), br = Symbol.for("react.context"), wr = Symbol.for("react.forward_ref"), kr = Symbol.for("react.suspense"), Gr = Symbol.for("react.suspense_list"), Vr = Symbol.for("react.memo"), jr = Symbol.for("react.lazy"), Kr = Symbol.for("react.offscreen"), bn = Symbol.iterator, Yr = "@@iterator";
      function Zr(Rn) {
        if (Rn === null || typeof Rn != "object")
          return null;
        var mi = bn && Rn[bn] || Rn[Yr];
        return typeof mi == "function" ? mi : null;
      }
      var ti = {
        current: null
      }, On = {
        transition: null
      }, ni = {
        current: null,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, In = {
        current: null
      }, Br = {}, Hr = null;
      function Pn(Rn) {
        Hr = Rn;
      }
      Br.setExtraStackFrame = function(Rn) {
        Hr = Rn;
      }, Br.getCurrentStack = null, Br.getStackAddendum = function() {
        var Rn = "";
        Hr && (Rn += Hr);
        var mi = Br.getCurrentStack;
        return mi && (Rn += mi() || ""), Rn;
      };
      var ei = !1, oi = !1, Nn = !1, En = !1, qr = !1, Jr = {
        ReactCurrentDispatcher: ti,
        ReactCurrentBatchConfig: On,
        ReactCurrentOwner: In
      };
      Jr.ReactDebugCurrentFrame = Br, Jr.ReactCurrentActQueue = ni;
      function ri(Rn) {
        {
          for (var mi = arguments.length, Ti = new Array(mi > 1 ? mi - 1 : 0), Ci = 1; Ci < mi; Ci++)
            Ti[Ci - 1] = arguments[Ci];
          ai("warn", Rn, Ti);
        }
      }
      function Sn(Rn) {
        {
          for (var mi = arguments.length, Ti = new Array(mi > 1 ? mi - 1 : 0), Ci = 1; Ci < mi; Ci++)
            Ti[Ci - 1] = arguments[Ci];
          ai("error", Rn, Ti);
        }
      }
      function ai(Rn, mi, Ti) {
        {
          var Ci = Jr.ReactDebugCurrentFrame, Ri = Ci.getStackAddendum();
          Ri !== "" && (mi += "%s", Ti = Ti.concat([Ri]));
          var ki = Ti.map(function(xi) {
            return String(xi);
          });
          ki.unshift("Warning: " + mi), Function.prototype.apply.call(console[Rn], console, ki);
        }
      }
      var di = {};
      function ii(Rn, mi) {
        {
          var Ti = Rn.constructor, Ci = Ti && (Ti.displayName || Ti.name) || "ReactClass", Ri = Ci + "." + mi;
          if (di[Ri])
            return;
          Sn("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", mi, Ci), di[Ri] = !0;
        }
      }
      var fi = {
        isMounted: function(Rn) {
          return !1;
        },
        enqueueForceUpdate: function(Rn, mi, Ti) {
          ii(Rn, "forceUpdate");
        },
        enqueueReplaceState: function(Rn, mi, Ti, Ci) {
          ii(Rn, "replaceState");
        },
        enqueueSetState: function(Rn, mi, Ti, Ci) {
          ii(Rn, "setState");
        }
      }, Ei = Object.assign, bi = {};
      Object.freeze(bi);
      function Si(Rn, mi, Ti) {
        this.props = Rn, this.context = mi, this.refs = bi, this.updater = Ti || fi;
      }
      Si.prototype.isReactComponent = {}, Si.prototype.setState = function(Rn, mi) {
        if (typeof Rn != "object" && typeof Rn != "function" && Rn != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, Rn, mi, "setState");
      }, Si.prototype.forceUpdate = function(Rn) {
        this.updater.enqueueForceUpdate(this, Rn, "forceUpdate");
      };
      {
        var Ii = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, yi = function(Rn, mi) {
          Object.defineProperty(Si.prototype, Rn, {
            get: function() {
              ri("%s(...) is deprecated in plain JavaScript React classes. %s", mi[0], mi[1]);
            }
          });
        };
        for (var ui in Ii)
          Ii.hasOwnProperty(ui) && yi(ui, Ii[ui]);
      }
      function hi() {
      }
      hi.prototype = Si.prototype;
      function gi(Rn, mi, Ti) {
        this.props = Rn, this.context = mi, this.refs = bi, this.updater = Ti || fi;
      }
      var Qr = gi.prototype = new hi();
      Qr.constructor = gi, Ei(Qr, Si.prototype), Qr.isPureReactComponent = !0;
      function wn() {
        var Rn = {
          current: null
        };
        return Object.seal(Rn), Rn;
      }
      var ci = Array.isArray;
      function vi(Rn) {
        return ci(Rn);
      }
      function Ni(Rn) {
        {
          var mi = typeof Symbol == "function" && Symbol.toStringTag, Ti = mi && Rn[Symbol.toStringTag] || Rn.constructor.name || "Object";
          return Ti;
        }
      }
      function Fi(Rn) {
        try {
          return Pi(Rn), !1;
        } catch {
          return !0;
        }
      }
      function Pi(Rn) {
        return "" + Rn;
      }
      function Li(Rn) {
        if (Fi(Rn))
          return Sn("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ni(Rn)), Pi(Rn);
      }
      function oo(Rn, mi, Ti) {
        var Ci = Rn.displayName;
        if (Ci)
          return Ci;
        var Ri = mi.displayName || mi.name || "";
        return Ri !== "" ? Ti + "(" + Ri + ")" : Ti;
      }
      function ao(Rn) {
        return Rn.displayName || "Context";
      }
      function zi(Rn) {
        if (Rn == null)
          return null;
        if (typeof Rn.tag == "number" && Sn("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Rn == "function")
          return Rn.displayName || Rn.name || null;
        if (typeof Rn == "string")
          return Rn;
        switch (Rn) {
          case me:
            return "Fragment";
          case fe:
            return "Portal";
          case fr:
            return "Profiler";
          case ye:
            return "StrictMode";
          case kr:
            return "Suspense";
          case Gr:
            return "SuspenseList";
        }
        if (typeof Rn == "object")
          switch (Rn.$$typeof) {
            case br:
              var mi = Rn;
              return ao(mi) + ".Consumer";
            case Er:
              var Ti = Rn;
              return ao(Ti._context) + ".Provider";
            case wr:
              return oo(Rn, Rn.render, "ForwardRef");
            case Vr:
              var Ci = Rn.displayName || null;
              return Ci !== null ? Ci : zi(Rn.type) || "Memo";
            case jr: {
              var Ri = Rn, ki = Ri._payload, xi = Ri._init;
              try {
                return zi(xi(ki));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Ki = Object.prototype.hasOwnProperty, Vi = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Yi, eo, Ui;
      Ui = {};
      function ji(Rn) {
        if (Ki.call(Rn, "ref")) {
          var mi = Object.getOwnPropertyDescriptor(Rn, "ref").get;
          if (mi && mi.isReactWarning)
            return !1;
        }
        return Rn.ref !== void 0;
      }
      function si(Rn) {
        if (Ki.call(Rn, "key")) {
          var mi = Object.getOwnPropertyDescriptor(Rn, "key").get;
          if (mi && mi.isReactWarning)
            return !1;
        }
        return Rn.key !== void 0;
      }
      function Wr(Rn, mi) {
        var Ti = function() {
          Yi || (Yi = !0, Sn("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", mi));
        };
        Ti.isReactWarning = !0, Object.defineProperty(Rn, "key", {
          get: Ti,
          configurable: !0
        });
      }
      function Xr(Rn, mi) {
        var Ti = function() {
          eo || (eo = !0, Sn("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", mi));
        };
        Ti.isReactWarning = !0, Object.defineProperty(Rn, "ref", {
          get: Ti,
          configurable: !0
        });
      }
      function li(Rn) {
        if (typeof Rn.ref == "string" && In.current && Rn.__self && In.current.stateNode !== Rn.__self) {
          var mi = zi(In.current.type);
          Ui[mi] || (Sn('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mi, Rn.ref), Ui[mi] = !0);
        }
      }
      var _i = function(Rn, mi, Ti, Ci, Ri, ki, xi) {
        var qi = {
          $$typeof: o,
          type: Rn,
          key: mi,
          ref: Ti,
          props: xi,
          _owner: ki
        };
        return qi._store = {}, Object.defineProperty(qi._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(qi, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ci
        }), Object.defineProperty(qi, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ri
        }), Object.freeze && (Object.freeze(qi.props), Object.freeze(qi)), qi;
      };
      function $i(Rn, mi, Ti) {
        var Ci, Ri = {}, ki = null, xi = null, qi = null, io = null;
        if (mi != null) {
          ji(mi) && (xi = mi.ref, li(mi)), si(mi) && (Li(mi.key), ki = "" + mi.key), qi = mi.__self === void 0 ? null : mi.__self, io = mi.__source === void 0 ? null : mi.__source;
          for (Ci in mi)
            Ki.call(mi, Ci) && !Vi.hasOwnProperty(Ci) && (Ri[Ci] = mi[Ci]);
        }
        var lo = arguments.length - 2;
        if (lo === 1)
          Ri.children = Ti;
        else if (lo > 1) {
          for (var po = Array(lo), go = 0; go < lo; go++)
            po[go] = arguments[go + 2];
          Object.freeze && Object.freeze(po), Ri.children = po;
        }
        if (Rn && Rn.defaultProps) {
          var Oo = Rn.defaultProps;
          for (Ci in Oo)
            Ri[Ci] === void 0 && (Ri[Ci] = Oo[Ci]);
        }
        if (ki || xi) {
          var xo = typeof Rn == "function" ? Rn.displayName || Rn.name || "Unknown" : Rn;
          ki && Wr(Ri, xo), xi && Xr(Ri, xo);
        }
        return _i(Rn, ki, xi, qi, io, In.current, Ri);
      }
      function Ai(Rn, mi) {
        var Ti = _i(Rn.type, mi, Rn.ref, Rn._self, Rn._source, Rn._owner, Rn.props);
        return Ti;
      }
      function Di(Rn, mi, Ti) {
        if (Rn == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + Rn + ".");
        var Ci, Ri = Ei({}, Rn.props), ki = Rn.key, xi = Rn.ref, qi = Rn._self, io = Rn._source, lo = Rn._owner;
        if (mi != null) {
          ji(mi) && (xi = mi.ref, lo = In.current), si(mi) && (Li(mi.key), ki = "" + mi.key);
          var po;
          Rn.type && Rn.type.defaultProps && (po = Rn.type.defaultProps);
          for (Ci in mi)
            Ki.call(mi, Ci) && !Vi.hasOwnProperty(Ci) && (mi[Ci] === void 0 && po !== void 0 ? Ri[Ci] = po[Ci] : Ri[Ci] = mi[Ci]);
        }
        var go = arguments.length - 2;
        if (go === 1)
          Ri.children = Ti;
        else if (go > 1) {
          for (var Oo = Array(go), xo = 0; xo < go; xo++)
            Oo[xo] = arguments[xo + 2];
          Ri.children = Oo;
        }
        return _i(Rn.type, ki, xi, qi, io, lo, Ri);
      }
      function Mi(Rn) {
        return typeof Rn == "object" && Rn !== null && Rn.$$typeof === o;
      }
      var to = ".", so = ":";
      function no(Rn) {
        var mi = /[=:]/g, Ti = {
          "=": "=0",
          ":": "=2"
        }, Ci = Rn.replace(mi, function(Ri) {
          return Ti[Ri];
        });
        return "$" + Ci;
      }
      var Po = !1, Uo = /\/+/g;
      function jo(Rn) {
        return Rn.replace(Uo, "$&/");
      }
      function Go(Rn, mi) {
        return typeof Rn == "object" && Rn !== null && Rn.key != null ? (Li(Rn.key), no("" + Rn.key)) : mi.toString(36);
      }
      function fo(Rn, mi, Ti, Ci, Ri) {
        var ki = typeof Rn;
        (ki === "undefined" || ki === "boolean") && (Rn = null);
        var xi = !1;
        if (Rn === null)
          xi = !0;
        else
          switch (ki) {
            case "string":
            case "number":
              xi = !0;
              break;
            case "object":
              switch (Rn.$$typeof) {
                case o:
                case fe:
                  xi = !0;
              }
          }
        if (xi) {
          var qi = Rn, io = Ri(qi), lo = Ci === "" ? to + Go(qi, 0) : Ci;
          if (vi(io)) {
            var po = "";
            lo != null && (po = jo(lo) + "/"), fo(io, mi, po, "", function(cc) {
              return cc;
            });
          } else
            io != null && (Mi(io) && (io.key && (!qi || qi.key !== io.key) && Li(io.key), io = Ai(
              io,
              Ti + (io.key && (!qi || qi.key !== io.key) ? jo("" + io.key) + "/" : "") + lo
            )), mi.push(io));
          return 1;
        }
        var go, Oo, xo = 0, Bo = Ci === "" ? to : Ci + so;
        if (vi(Rn))
          for (var Ua = 0; Ua < Rn.length; Ua++)
            go = Rn[Ua], Oo = Bo + Go(go, Ua), xo += fo(go, mi, Ti, Oo, Ri);
        else {
          var Xa = Zr(Rn);
          if (typeof Xa == "function") {
            var Ja = Rn;
            Xa === Ja.entries && (Po || ri("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Po = !0);
            for (var oc = Xa.call(Ja), Za, ac = 0; !(Za = oc.next()).done; )
              go = Za.value, Oo = Bo + Go(go, ac++), xo += fo(go, mi, Ti, Oo, Ri);
          } else if (ki === "object") {
            var ec = String(Rn);
            throw new Error("Objects are not valid as a React child (found: " + (ec === "[object Object]" ? "object with keys {" + Object.keys(Rn).join(", ") + "}" : ec) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return xo;
      }
      function co(Rn, mi, Ti) {
        if (Rn == null)
          return Rn;
        var Ci = [], Ri = 0;
        return fo(Rn, Ci, "", "", function(ki) {
          return mi.call(Ti, ki, Ri++);
        }), Ci;
      }
      function _o(Rn) {
        var mi = 0;
        return co(Rn, function() {
          mi++;
        }), mi;
      }
      function Eo(Rn, mi, Ti) {
        co(Rn, function() {
          mi.apply(this, arguments);
        }, Ti);
      }
      function vo(Rn) {
        return co(Rn, function(mi) {
          return mi;
        }) || [];
      }
      function mo(Rn) {
        if (!Mi(Rn))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return Rn;
      }
      function Io(Rn) {
        var mi = {
          $$typeof: br,
          _currentValue: Rn,
          _currentValue2: Rn,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
          _defaultValue: null,
          _globalName: null
        };
        mi.Provider = {
          $$typeof: Er,
          _context: mi
        };
        var Ti = !1, Ci = !1, Ri = !1;
        {
          var ki = {
            $$typeof: br,
            _context: mi
          };
          Object.defineProperties(ki, {
            Provider: {
              get: function() {
                return Ci || (Ci = !0, Sn("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), mi.Provider;
              },
              set: function(xi) {
                mi.Provider = xi;
              }
            },
            _currentValue: {
              get: function() {
                return mi._currentValue;
              },
              set: function(xi) {
                mi._currentValue = xi;
              }
            },
            _currentValue2: {
              get: function() {
                return mi._currentValue2;
              },
              set: function(xi) {
                mi._currentValue2 = xi;
              }
            },
            _threadCount: {
              get: function() {
                return mi._threadCount;
              },
              set: function(xi) {
                mi._threadCount = xi;
              }
            },
            Consumer: {
              get: function() {
                return Ti || (Ti = !0, Sn("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), mi.Consumer;
              }
            },
            displayName: {
              get: function() {
                return mi.displayName;
              },
              set: function(xi) {
                Ri || (ri("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", xi), Ri = !0);
              }
            }
          }), mi.Consumer = ki;
        }
        return mi._currentRenderer = null, mi._currentRenderer2 = null, mi;
      }
      var yo = -1, bo = 0, $o = 1, Co = 2;
      function So(Rn) {
        if (Rn._status === yo) {
          var mi = Rn._result, Ti = mi();
          if (Ti.then(function(ki) {
            if (Rn._status === bo || Rn._status === yo) {
              var xi = Rn;
              xi._status = $o, xi._result = ki;
            }
          }, function(ki) {
            if (Rn._status === bo || Rn._status === yo) {
              var xi = Rn;
              xi._status = Co, xi._result = ki;
            }
          }), Rn._status === yo) {
            var Ci = Rn;
            Ci._status = bo, Ci._result = Ti;
          }
        }
        if (Rn._status === $o) {
          var Ri = Rn._result;
          return Ri === void 0 && Sn(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Ri), "default" in Ri || Sn(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Ri), Ri.default;
        } else
          throw Rn._result;
      }
      function wo(Rn) {
        var mi = {
          _status: yo,
          _result: Rn
        }, Ti = {
          $$typeof: jr,
          _payload: mi,
          _init: So
        };
        {
          var Ci, Ri;
          Object.defineProperties(Ti, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return Ci;
              },
              set: function(ki) {
                Sn("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ci = ki, Object.defineProperty(Ti, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Ri;
              },
              set: function(ki) {
                Sn("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ri = ki, Object.defineProperty(Ti, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return Ti;
      }
      function uo(Rn) {
        Rn != null && Rn.$$typeof === Vr ? Sn("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof Rn != "function" ? Sn("forwardRef requires a render function but was given %s.", Rn === null ? "null" : typeof Rn) : Rn.length !== 0 && Rn.length !== 2 && Sn("forwardRef render functions accept exactly two parameters: props and ref. %s", Rn.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), Rn != null && (Rn.defaultProps != null || Rn.propTypes != null) && Sn("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var mi = {
          $$typeof: wr,
          render: Rn
        };
        {
          var Ti;
          Object.defineProperty(mi, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Ti;
            },
            set: function(Ci) {
              Ti = Ci, !Rn.name && !Rn.displayName && (Rn.displayName = Ci);
            }
          });
        }
        return mi;
      }
      var To;
      To = Symbol.for("react.module.reference");
      function Ao(Rn) {
        return !!(typeof Rn == "string" || typeof Rn == "function" || Rn === me || Rn === fr || qr || Rn === ye || Rn === kr || Rn === Gr || En || Rn === Kr || ei || oi || Nn || typeof Rn == "object" && Rn !== null && (Rn.$$typeof === jr || Rn.$$typeof === Vr || Rn.$$typeof === Er || Rn.$$typeof === br || Rn.$$typeof === wr || Rn.$$typeof === To || Rn.getModuleId !== void 0));
      }
      function Yo(Rn, mi) {
        Ao(Rn) || Sn("memo: The first argument must be a component. Instead received: %s", Rn === null ? "null" : typeof Rn);
        var Ti = {
          $$typeof: Vr,
          type: Rn,
          compare: mi === void 0 ? null : mi
        };
        {
          var Ci;
          Object.defineProperty(Ti, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Ci;
            },
            set: function(Ri) {
              Ci = Ri, !Rn.name && !Rn.displayName && (Rn.displayName = Ri);
            }
          });
        }
        return Ti;
      }
      function Ro() {
        var Rn = ti.current;
        return Rn === null && Sn(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), Rn;
      }
      function Xo(Rn) {
        var mi = Ro();
        if (Rn._context !== void 0) {
          var Ti = Rn._context;
          Ti.Consumer === Rn ? Sn("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : Ti.Provider === Rn && Sn("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return mi.useContext(Rn);
      }
      function Mo(Rn) {
        var mi = Ro();
        return mi.useState(Rn);
      }
      function Jo(Rn, mi, Ti) {
        var Ci = Ro();
        return Ci.useReducer(Rn, mi, Ti);
      }
      function Zo(Rn) {
        var mi = Ro();
        return mi.useRef(Rn);
      }
      function ea(Rn, mi) {
        var Ti = Ro();
        return Ti.useEffect(Rn, mi);
      }
      function ta(Rn, mi) {
        var Ti = Ro();
        return Ti.useInsertionEffect(Rn, mi);
      }
      function ra(Rn, mi) {
        var Ti = Ro();
        return Ti.useLayoutEffect(Rn, mi);
      }
      function Vo(Rn, mi) {
        var Ti = Ro();
        return Ti.useCallback(Rn, mi);
      }
      function na(Rn, mi) {
        var Ti = Ro();
        return Ti.useMemo(Rn, mi);
      }
      function ia(Rn, mi, Ti) {
        var Ci = Ro();
        return Ci.useImperativeHandle(Rn, mi, Ti);
      }
      function sa(Rn, mi) {
        {
          var Ti = Ro();
          return Ti.useDebugValue(Rn, mi);
        }
      }
      function oa() {
        var Rn = Ro();
        return Rn.useTransition();
      }
      function aa(Rn) {
        var mi = Ro();
        return mi.useDeferredValue(Rn);
      }
      function qo() {
        var Rn = Ro();
        return Rn.useId();
      }
      function ca(Rn, mi, Ti) {
        var Ci = Ro();
        return Ci.useSyncExternalStore(Rn, mi, Ti);
      }
      var Ho = 0, Fo, Aa, Ia, Ca, Na, Oa, Ra;
      function ua() {
      }
      ua.__reactDisabledLog = !0;
      function ja() {
        {
          if (Ho === 0) {
            Fo = console.log, Aa = console.info, Ia = console.warn, Ca = console.error, Na = console.group, Oa = console.groupCollapsed, Ra = console.groupEnd;
            var Rn = {
              configurable: !0,
              enumerable: !0,
              value: ua,
              writable: !0
            };
            Object.defineProperties(console, {
              info: Rn,
              log: Rn,
              warn: Rn,
              error: Rn,
              group: Rn,
              groupCollapsed: Rn,
              groupEnd: Rn
            });
          }
          Ho++;
        }
      }
      function la() {
        {
          if (Ho--, Ho === 0) {
            var Rn = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: Ei({}, Rn, {
                value: Fo
              }),
              info: Ei({}, Rn, {
                value: Aa
              }),
              warn: Ei({}, Rn, {
                value: Ia
              }),
              error: Ei({}, Rn, {
                value: Ca
              }),
              group: Ei({}, Rn, {
                value: Na
              }),
              groupCollapsed: Ei({}, Rn, {
                value: Oa
              }),
              groupEnd: Ei({}, Rn, {
                value: Ra
              })
            });
          }
          Ho < 0 && Sn("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ga = Jr.ReactCurrentDispatcher, ma;
      function ya(Rn, mi, Ti) {
        {
          if (ma === void 0)
            try {
              throw Error();
            } catch (Ri) {
              var Ci = Ri.stack.trim().match(/\n( *(at )?)/);
              ma = Ci && Ci[1] || "";
            }
          return `
` + ma + Rn;
        }
      }
      var wa = !1, Ea;
      {
        var Ga = typeof WeakMap == "function" ? WeakMap : Map;
        Ea = new Ga();
      }
      function $a(Rn, mi) {
        if (!Rn || wa)
          return "";
        {
          var Ti = Ea.get(Rn);
          if (Ti !== void 0)
            return Ti;
        }
        var Ci;
        wa = !0;
        var Ri = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ki;
        ki = ga.current, ga.current = null, ja();
        try {
          if (mi) {
            var xi = function() {
              throw Error();
            };
            if (Object.defineProperty(xi.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(xi, []);
              } catch (Bo) {
                Ci = Bo;
              }
              Reflect.construct(Rn, [], xi);
            } else {
              try {
                xi.call();
              } catch (Bo) {
                Ci = Bo;
              }
              Rn.call(xi.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Bo) {
              Ci = Bo;
            }
            Rn();
          }
        } catch (Bo) {
          if (Bo && Ci && typeof Bo.stack == "string") {
            for (var qi = Bo.stack.split(`
`), io = Ci.stack.split(`
`), lo = qi.length - 1, po = io.length - 1; lo >= 1 && po >= 0 && qi[lo] !== io[po]; )
              po--;
            for (; lo >= 1 && po >= 0; lo--, po--)
              if (qi[lo] !== io[po]) {
                if (lo !== 1 || po !== 1)
                  do
                    if (lo--, po--, po < 0 || qi[lo] !== io[po]) {
                      var go = `
` + qi[lo].replace(" at new ", " at ");
                      return Rn.displayName && go.includes("<anonymous>") && (go = go.replace("<anonymous>", Rn.displayName)), typeof Rn == "function" && Ea.set(Rn, go), go;
                    }
                  while (lo >= 1 && po >= 0);
                break;
              }
          }
        } finally {
          wa = !1, ga.current = ki, la(), Error.prepareStackTrace = Ri;
        }
        var Oo = Rn ? Rn.displayName || Rn.name : "", xo = Oo ? ya(Oo) : "";
        return typeof Rn == "function" && Ea.set(Rn, xo), xo;
      }
      function Ha(Rn, mi, Ti) {
        return $a(Rn, !1);
      }
      function qa(Rn) {
        var mi = Rn.prototype;
        return !!(mi && mi.isReactComponent);
      }
      function da(Rn, mi, Ti) {
        if (Rn == null)
          return "";
        if (typeof Rn == "function")
          return $a(Rn, qa(Rn));
        if (typeof Rn == "string")
          return ya(Rn);
        switch (Rn) {
          case kr:
            return ya("Suspense");
          case Gr:
            return ya("SuspenseList");
        }
        if (typeof Rn == "object")
          switch (Rn.$$typeof) {
            case wr:
              return Ha(Rn.render);
            case Vr:
              return da(Rn.type, mi, Ti);
            case jr: {
              var Ci = Rn, Ri = Ci._payload, ki = Ci._init;
              try {
                return da(ki(Ri), mi, Ti);
              } catch {
              }
            }
          }
        return "";
      }
      var fa = {}, Wo = Jr.ReactDebugCurrentFrame;
      function va(Rn) {
        if (Rn) {
          var mi = Rn._owner, Ti = da(Rn.type, Rn._source, mi ? mi.type : null);
          Wo.setExtraStackFrame(Ti);
        } else
          Wo.setExtraStackFrame(null);
      }
      function Wa(Rn, mi, Ti, Ci, Ri) {
        {
          var ki = Function.call.bind(Ki);
          for (var xi in Rn)
            if (ki(Rn, xi)) {
              var qi = void 0;
              try {
                if (typeof Rn[xi] != "function") {
                  var io = Error((Ci || "React class") + ": " + Ti + " type `" + xi + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Rn[xi] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw io.name = "Invariant Violation", io;
                }
                qi = Rn[xi](mi, xi, Ci, Ti, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (lo) {
                qi = lo;
              }
              qi && !(qi instanceof Error) && (va(Ri), Sn("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ci || "React class", Ti, xi, typeof qi), va(null)), qi instanceof Error && !(qi.message in fa) && (fa[qi.message] = !0, va(Ri), Sn("Failed %s type: %s", Ti, qi.message), va(null));
            }
        }
      }
      function ko(Rn) {
        if (Rn) {
          var mi = Rn._owner, Ti = da(Rn.type, Rn._source, mi ? mi.type : null);
          Pn(Ti);
        } else
          Pn(null);
      }
      var Sa;
      Sa = !1;
      function Pa() {
        if (In.current) {
          var Rn = zi(In.current.type);
          if (Rn)
            return `

Check the render method of \`` + Rn + "`.";
        }
        return "";
      }
      function za(Rn) {
        if (Rn !== void 0) {
          var mi = Rn.fileName.replace(/^.*[\\\/]/, ""), Ti = Rn.lineNumber;
          return `

Check your code at ` + mi + ":" + Ti + ".";
        }
        return "";
      }
      function Ka(Rn) {
        return Rn != null ? za(Rn.__source) : "";
      }
      var Da = {};
      function zo(Rn) {
        var mi = Pa();
        if (!mi) {
          var Ti = typeof Rn == "string" ? Rn : Rn.displayName || Rn.name;
          Ti && (mi = `

Check the top-level render call using <` + Ti + ">.");
        }
        return mi;
      }
      function Ta(Rn, mi) {
        if (!(!Rn._store || Rn._store.validated || Rn.key != null)) {
          Rn._store.validated = !0;
          var Ti = zo(mi);
          if (!Da[Ti]) {
            Da[Ti] = !0;
            var Ci = "";
            Rn && Rn._owner && Rn._owner !== In.current && (Ci = " It was passed a child from " + zi(Rn._owner.type) + "."), ko(Rn), Sn('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ti, Ci), ko(null);
          }
        }
      }
      function xa(Rn, mi) {
        if (typeof Rn == "object") {
          if (vi(Rn))
            for (var Ti = 0; Ti < Rn.length; Ti++) {
              var Ci = Rn[Ti];
              Mi(Ci) && Ta(Ci, mi);
            }
          else if (Mi(Rn))
            Rn._store && (Rn._store.validated = !0);
          else if (Rn) {
            var Ri = Zr(Rn);
            if (typeof Ri == "function" && Ri !== Rn.entries)
              for (var ki = Ri.call(Rn), xi; !(xi = ki.next()).done; )
                Mi(xi.value) && Ta(xi.value, mi);
          }
        }
      }
      function ha(Rn) {
        {
          var mi = Rn.type;
          if (mi == null || typeof mi == "string")
            return;
          var Ti;
          if (typeof mi == "function")
            Ti = mi.propTypes;
          else if (typeof mi == "object" && (mi.$$typeof === wr || mi.$$typeof === Vr))
            Ti = mi.propTypes;
          else
            return;
          if (Ti) {
            var Ci = zi(mi);
            Wa(Ti, Rn.props, "prop", Ci, Rn);
          } else if (mi.PropTypes !== void 0 && !Sa) {
            Sa = !0;
            var Ri = zi(mi);
            Sn("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ri || "Unknown");
          }
          typeof mi.getDefaultProps == "function" && !mi.getDefaultProps.isReactClassApproved && Sn("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Qa(Rn) {
        {
          for (var mi = Object.keys(Rn.props), Ti = 0; Ti < mi.length; Ti++) {
            var Ci = mi[Ti];
            if (Ci !== "children" && Ci !== "key") {
              ko(Rn), Sn("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ci), ko(null);
              break;
            }
          }
          Rn.ref !== null && (ko(Rn), Sn("Invalid attribute `ref` supplied to `React.Fragment`."), ko(null));
        }
      }
      function ba(Rn, mi, Ti) {
        var Ci = Ao(Rn);
        if (!Ci) {
          var Ri = "";
          (Rn === void 0 || typeof Rn == "object" && Rn !== null && Object.keys(Rn).length === 0) && (Ri += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ki = Ka(mi);
          ki ? Ri += ki : Ri += Pa();
          var xi;
          Rn === null ? xi = "null" : vi(Rn) ? xi = "array" : Rn !== void 0 && Rn.$$typeof === o ? (xi = "<" + (zi(Rn.type) || "Unknown") + " />", Ri = " Did you accidentally export a JSX literal instead of a component?") : xi = typeof Rn, Sn("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", xi, Ri);
        }
        var qi = $i.apply(this, arguments);
        if (qi == null)
          return qi;
        if (Ci)
          for (var io = 2; io < arguments.length; io++)
            xa(arguments[io], Rn);
        return Rn === me ? Qa(qi) : ha(qi), qi;
      }
      var La = !1;
      function Ba(Rn) {
        var mi = ba.bind(null, Rn);
        return mi.type = Rn, La || (La = !0, ri("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(mi, "type", {
          enumerable: !1,
          get: function() {
            return ri("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: Rn
            }), Rn;
          }
        }), mi;
      }
      function Ma(Rn, mi, Ti) {
        for (var Ci = Di.apply(this, arguments), Ri = 2; Ri < arguments.length; Ri++)
          xa(arguments[Ri], Ci.type);
        return ha(Ci), Ci;
      }
      function Fa(Rn, mi) {
        var Ti = On.transition;
        On.transition = {};
        var Ci = On.transition;
        On.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          Rn();
        } finally {
          if (On.transition = Ti, Ti === null && Ci._updatedFibers) {
            var Ri = Ci._updatedFibers.size;
            Ri > 10 && ri("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Ci._updatedFibers.clear();
          }
        }
      }
      var Ko = !1, pa = null;
      function Ya(Rn) {
        if (pa === null)
          try {
            var mi = ("require" + Math.random()).slice(0, 7), Ti = r && r[mi];
            pa = Ti.call(r, "timers").setImmediate;
          } catch {
            pa = function(Ri) {
              Ko === !1 && (Ko = !0, typeof MessageChannel > "u" && Sn("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var ki = new MessageChannel();
              ki.port1.onmessage = Ri, ki.port2.postMessage(void 0);
            };
          }
        return pa(Rn);
      }
      var Qo = 0, ka = !1;
      function pi(Rn) {
        {
          var mi = Qo;
          Qo++, ni.current === null && (ni.current = []);
          var Ti = ni.isBatchingLegacy, Ci;
          try {
            if (ni.isBatchingLegacy = !0, Ci = Rn(), !Ti && ni.didScheduleLegacyUpdate) {
              var Ri = ni.current;
              Ri !== null && (ni.didScheduleLegacyUpdate = !1, ho(Ri));
            }
          } catch (Oo) {
            throw wi(mi), Oo;
          } finally {
            ni.isBatchingLegacy = Ti;
          }
          if (Ci !== null && typeof Ci == "object" && typeof Ci.then == "function") {
            var ki = Ci, xi = !1, qi = {
              then: function(Oo, xo) {
                xi = !0, ki.then(function(Bo) {
                  wi(mi), Qo === 0 ? Oi(Bo, Oo, xo) : Oo(Bo);
                }, function(Bo) {
                  wi(mi), xo(Bo);
                });
              }
            };
            return !ka && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              xi || (ka = !0, Sn("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), qi;
          } else {
            var io = Ci;
            if (wi(mi), Qo === 0) {
              var lo = ni.current;
              lo !== null && (ho(lo), ni.current = null);
              var po = {
                then: function(Oo, xo) {
                  ni.current === null ? (ni.current = [], Oi(io, Oo, xo)) : Oo(io);
                }
              };
              return po;
            } else {
              var go = {
                then: function(Oo, xo) {
                  Oo(io);
                }
              };
              return go;
            }
          }
        }
      }
      function wi(Rn) {
        Rn !== Qo - 1 && Sn("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Qo = Rn;
      }
      function Oi(Rn, mi, Ti) {
        {
          var Ci = ni.current;
          if (Ci !== null)
            try {
              ho(Ci), Ya(function() {
                Ci.length === 0 ? (ni.current = null, mi(Rn)) : Oi(Rn, mi, Ti);
              });
            } catch (Ri) {
              Ti(Ri);
            }
          else
            mi(Rn);
        }
      }
      var Bi = !1;
      function ho(Rn) {
        if (!Bi) {
          Bi = !0;
          var mi = 0;
          try {
            for (; mi < Rn.length; mi++) {
              var Ti = Rn[mi];
              do
                Ti = Ti(!0);
              while (Ti !== null);
            }
            Rn.length = 0;
          } catch (Ci) {
            throw Rn = Rn.slice(mi + 1), Ci;
          } finally {
            Bi = !1;
          }
        }
      }
      var ro = ba, No = Ma, Do = Ba, Lo = {
        map: co,
        forEach: Eo,
        count: _o,
        toArray: vo,
        only: mo
      };
      e.Children = Lo, e.Component = Si, e.Fragment = me, e.Profiler = fr, e.PureComponent = gi, e.StrictMode = ye, e.Suspense = kr, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Jr, e.cloneElement = No, e.createContext = Io, e.createElement = ro, e.createFactory = Do, e.createRef = wn, e.forwardRef = uo, e.isValidElement = Mi, e.lazy = wo, e.memo = Yo, e.startTransition = Fa, e.unstable_act = pi, e.useCallback = Vo, e.useContext = Xo, e.useDebugValue = sa, e.useDeferredValue = aa, e.useEffect = ea, e.useId = qo, e.useImperativeHandle = ia, e.useInsertionEffect = ta, e.useLayoutEffect = ra, e.useMemo = na, e.useReducer = Jo, e.useRef = Zo, e.useState = Mo, e.useSyncExternalStore = ca, e.useTransition = oa, e.version = s, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(react_development, react_development.exports)), react_development.exports;
}
(function(r) {
  process.env.NODE_ENV === "production" ? r.exports = requireReact_production_min() : r.exports = requireReact_development();
})(react);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(r, e, s, o) {
  function fe(me) {
    return me instanceof s ? me : new s(function(ye) {
      ye(me);
    });
  }
  return new (s || (s = Promise))(function(me, ye) {
    function fr(wr) {
      try {
        br(o.next(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function Er(wr) {
      try {
        br(o.throw(wr));
      } catch (kr) {
        ye(kr);
      }
    }
    function br(wr) {
      wr.done ? me(wr.value) : fe(wr.value).then(fr, Er);
    }
    br((o = o.apply(r, e || [])).next());
  });
}
function __generator(r, e) {
  var s = { label: 0, sent: function() {
    if (me[0] & 1)
      throw me[1];
    return me[1];
  }, trys: [], ops: [] }, o, fe, me, ye;
  return ye = { next: fr(0), throw: fr(1), return: fr(2) }, typeof Symbol == "function" && (ye[Symbol.iterator] = function() {
    return this;
  }), ye;
  function fr(br) {
    return function(wr) {
      return Er([br, wr]);
    };
  }
  function Er(br) {
    if (o)
      throw new TypeError("Generator is already executing.");
    for (; s; )
      try {
        if (o = 1, fe && (me = br[0] & 2 ? fe.return : br[0] ? fe.throw || ((me = fe.return) && me.call(fe), 0) : fe.next) && !(me = me.call(fe, br[1])).done)
          return me;
        switch (fe = 0, me && (br = [br[0] & 2, me.value]), br[0]) {
          case 0:
          case 1:
            me = br;
            break;
          case 4:
            return s.label++, { value: br[1], done: !1 };
          case 5:
            s.label++, fe = br[1], br = [0];
            continue;
          case 7:
            br = s.ops.pop(), s.trys.pop();
            continue;
          default:
            if (me = s.trys, !(me = me.length > 0 && me[me.length - 1]) && (br[0] === 6 || br[0] === 2)) {
              s = 0;
              continue;
            }
            if (br[0] === 3 && (!me || br[1] > me[0] && br[1] < me[3])) {
              s.label = br[1];
              break;
            }
            if (br[0] === 6 && s.label < me[1]) {
              s.label = me[1], me = br;
              break;
            }
            if (me && s.label < me[2]) {
              s.label = me[2], s.ops.push(br);
              break;
            }
            me[2] && s.ops.pop(), s.trys.pop();
            continue;
        }
        br = e.call(r, s);
      } catch (wr) {
        br = [6, wr], fe = 0;
      } finally {
        o = me = 0;
      }
    if (br[0] & 5)
      throw br[1];
    return { value: br[0] ? br[1] : void 0, done: !0 };
  }
}
var noop = function() {
}, UNDEFINED = noop(), OBJECT = Object, isUndefined = function(r) {
  return r === UNDEFINED;
}, isFunction = function(r) {
  return typeof r == "function";
}, mergeObjects = function(r, e) {
  return OBJECT.assign({}, r, e);
}, STR_UNDEFINED = "undefined", hasWindow = function() {
  return typeof window != STR_UNDEFINED;
}, hasDocument = function() {
  return typeof document != STR_UNDEFINED;
}, table = /* @__PURE__ */ new WeakMap(), counter = 0, stableHash = function(r) {
  var e = typeof r, s = r && r.constructor, o = s == Date, fe, me;
  if (OBJECT(r) === r && !o && s != RegExp) {
    if (fe = table.get(r), fe)
      return fe;
    if (fe = ++counter + "~", table.set(r, fe), s == Array) {
      for (fe = "@", me = 0; me < r.length; me++)
        fe += stableHash(r[me]) + ",";
      table.set(r, fe);
    }
    if (s == OBJECT) {
      fe = "#";
      for (var ye = OBJECT.keys(r).sort(); !isUndefined(me = ye.pop()); )
        isUndefined(r[me]) || (fe += me + ":" + stableHash(r[me]) + ",");
      table.set(r, fe);
    }
  } else
    fe = o ? r.toJSON() : e == "symbol" ? r.toString() : e == "string" ? JSON.stringify(r) : "" + r;
  return fe;
}, online = !0, isOnline = function() {
  return online;
}, hasWin = hasWindow(), hasDoc = hasDocument(), onWindowEvent = hasWin && window.addEventListener ? window.addEventListener.bind(window) : noop, onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop, offWindowEvent = hasWin && window.removeEventListener ? window.removeEventListener.bind(window) : noop, offDocumentEvent = hasDoc ? document.removeEventListener.bind(document) : noop, isVisible = function() {
  var r = hasDoc && document.visibilityState;
  return isUndefined(r) || r !== "hidden";
}, initFocus = function(r) {
  return onDocumentEvent("visibilitychange", r), onWindowEvent("focus", r), function() {
    offDocumentEvent("visibilitychange", r), offWindowEvent("focus", r);
  };
}, initReconnect = function(r) {
  var e = function() {
    online = !0, r();
  }, s = function() {
    online = !1;
  };
  return onWindowEvent("online", e), onWindowEvent("offline", s), function() {
    offWindowEvent("online", e), offWindowEvent("offline", s);
  };
}, preset = {
  isOnline,
  isVisible
}, defaultConfigOptions = {
  initFocus,
  initReconnect
}, IS_SERVER = !hasWindow() || "Deno" in window, navigatorConnection = typeof navigator < "u" && navigator.connection, slowConnection = !IS_SERVER && navigatorConnection && (["slow-2g", "2g"].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData), serialize = function(r) {
  if (isFunction(r))
    try {
      r = r();
    } catch {
      r = "";
    }
  var e = [].concat(r);
  r = typeof r == "string" ? r : (Array.isArray(r) ? r.length : r) ? stableHash(r) : "";
  var s = r ? "$err$" + r : "", o = r ? "$req$" + r : "";
  return [r, e, s, o];
}, SWRGlobalState = /* @__PURE__ */ new WeakMap(), FOCUS_EVENT = 0, RECONNECT_EVENT = 1, MUTATE_EVENT = 2, broadcastState = function(r, e, s, o, fe, me, ye) {
  ye === void 0 && (ye = !0);
  var fr = SWRGlobalState.get(r), Er = fr[0], br = fr[1], wr = fr[4], kr = Er[e], Gr = br[e] || [];
  if (ye && Gr)
    for (var Vr = 0; Vr < Gr.length; ++Vr)
      Gr[Vr](s, o, fe);
  return me && (delete wr[e], kr && kr[0]) ? kr[0](MUTATE_EVENT).then(function() {
    return r.get(e);
  }) : r.get(e);
}, __timestamp = 0, getTimestamp = function() {
  return ++__timestamp;
}, internalMutate = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return __awaiter(void 0, void 0, void 0, function() {
    var s, o, fe, me, ye, fr, Er, br, wr, kr, Gr, Vr, jr, Kr, bn, Yr, Zr;
    return __generator(this, function(ti) {
      switch (ti.label) {
        case 0:
          if (s = r[0], o = r[1], fe = r[2], me = r[3], ye = typeof me == "boolean" ? { revalidate: me } : me || {}, fr = ye.revalidate !== !1, Er = ye.populateCache !== !1, br = serialize(o), wr = br[0], kr = br[2], !wr)
            return [2];
          if (Gr = SWRGlobalState.get(s), Vr = Gr[2], jr = Gr[3], r.length < 3)
            return [2, broadcastState(s, wr, s.get(wr), s.get(kr), UNDEFINED, fr, Er)];
          if (Kr = fe, Yr = Vr[wr] = getTimestamp(), jr[wr] = 0, isFunction(Kr))
            try {
              Kr = Kr(s.get(wr));
            } catch (On) {
              bn = On;
            }
          return Kr && isFunction(Kr.then) ? [
            4,
            Kr.catch(function(On) {
              bn = On;
            })
          ] : [3, 2];
        case 1:
          if (Kr = ti.sent(), Yr !== Vr[wr]) {
            if (bn)
              throw bn;
            return [2, Kr];
          }
          ti.label = 2;
        case 2:
          return Er && (bn || s.set(wr, Kr), s.set(kr, bn)), jr[wr] = getTimestamp(), [
            4,
            broadcastState(s, wr, Kr, bn, UNDEFINED, fr, Er)
          ];
        case 3:
          if (Zr = ti.sent(), bn)
            throw bn;
          return [2, Er ? Zr : Kr];
      }
    });
  });
}, revalidateAllKeys = function(r, e) {
  for (var s in r)
    r[s][0] && r[s][0](e);
}, initCache = function(r, e) {
  if (!SWRGlobalState.has(r)) {
    var s = mergeObjects(defaultConfigOptions, e), o = {}, fe = internalMutate.bind(UNDEFINED, r), me = noop;
    if (SWRGlobalState.set(r, [o, {}, {}, {}, {}, fe]), !IS_SERVER) {
      var ye = s.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, o, FOCUS_EVENT))), fr = s.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, o, RECONNECT_EVENT)));
      me = function() {
        ye && ye(), fr && fr(), SWRGlobalState.delete(r);
      };
    }
    return [r, fe, me];
  }
  return [r, SWRGlobalState.get(r)[5]];
}, onErrorRetry = function(r, e, s, o, fe) {
  var me = s.errorRetryCount, ye = fe.retryCount, fr = ~~((Math.random() + 0.5) * (1 << (ye < 8 ? ye : 8))) * s.errorRetryInterval;
  !isUndefined(me) && ye > me || setTimeout(o, fr, fe);
}, _a = initCache(/* @__PURE__ */ new Map()), cache$1 = _a[0], mutate = _a[1];
mergeObjects(
  {
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    errorRetryInterval: slowConnection ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: slowConnection ? 5e3 : 3e3,
    compare: function(r, e) {
      return stableHash(r) == stableHash(e);
    },
    isPaused: function() {
      return !1;
    },
    cache: cache$1,
    mutate,
    fallback: {}
  },
  preset
);
react.exports.createContext({});
function useGetPendingTransactions() {
  const r = useTransactionsStore().getPendingSignedTransactions, e = Object.entries(r), s = (e == null ? void 0 : e.length) > 0;
  return {
    pendingTransactions: r,
    pendingTransactionsArray: e,
    hasPendingTransactions: s
  };
}
function getPendingTransactions(r, e) {
  return r.reduce(
    (o, { status: fe, hash: me }) => (me != null && !e.includes(me) && getIsTransactionPending(fe) && o.push({
      hash: me,
      previousStatus: fe
    }), o),
    []
  );
}
function manageFailedTransactions({
  results: r,
  hash: e,
  sessionId: s
}) {
  const o = r == null ? void 0 : r.find(
    (fe) => (fe == null ? void 0 : fe.returnMessage) !== ""
  );
  useTransactionsStore().updateSignedTransactionStatus({
    transactionHash: e,
    sessionId: s,
    status: TransactionServerStatusesEnum.fail,
    errorMessage: o == null ? void 0 : o.returnMessage
  }), useTransactionsStore().updateSignedTransactions({
    sessionId: s,
    status: TransactionBatchStatusesEnum.fail,
    errorMessage: o == null ? void 0 : o.returnMessage
  });
}
function manageTimedOutTransactions(r) {
  useTransactionsStore().updateSignedTransactions({
    sessionId: r,
    status: TransactionBatchStatusesEnum.timedOut
  });
}
const retries = {}, timeouts = [];
function manageTransaction({
  serverTransaction: r,
  sessionId: e,
  customTransactionInformation: s,
  shouldRefreshBalance: o
}) {
  const {
    hash: fe,
    status: me,
    results: ye,
    invalidTransaction: fr,
    hasStatusChanged: Er
  } = r;
  try {
    if (timeouts.includes(fe))
      return;
    if (retries[fe] > 60) {
      manageTimedOutTransactions(e);
      return;
    }
    if (fr || getIsTransactionPending(me)) {
      retries[fe] = retries[fe] ? retries[fe] + 1 : 1;
      return;
    }
    Er && (getIsTransactionSuccessful(me) && (s == null ? void 0 : s.completedTransactionsDelay) != null ? (timeouts.push(fe), setTimeout(
      () => useTransactionsStore().updateSignedTransactionStatus({
        sessionId: e,
        status: TransactionServerStatusesEnum.success,
        transactionHash: fe
      }),
      s == null ? void 0 : s.completedTransactionsDelay
    )) : useTransactionsStore().updateSignedTransactionStatus({
      sessionId: e,
      status: me,
      transactionHash: fe
    })), o || refreshAccount(), getIsTransactionFailed(me) && manageFailedTransactions({ sessionId: e, hash: fe, results: ye });
  } catch (br) {
    console.error(br), manageTimedOutTransactions(e);
  }
}
async function checkBatch({
  sessionId: r,
  transactionBatch: { transactions: e, customTransactionInformation: s },
  getTransactionsByHash: o = getTransactionsByHashes,
  shouldRefreshBalance: fe
}) {
  try {
    if (e == null)
      return;
    const me = getPendingTransactions(e, timeouts), ye = await o(me);
    for (const fr of ye)
      manageTransaction({
        serverTransaction: fr,
        sessionId: r,
        customTransactionInformation: s,
        shouldRefreshBalance: fe
      });
  } catch (me) {
    console.error(me);
  }
}
function useCheckTransactionStatus() {
  async function r(e) {
    const { pendingTransactionsArray: s } = useGetPendingTransactions(), o = s.filter(
      ([fe, me]) => fe != null && getIsTransactionPending(me.status)
    );
    if (o.length > 0)
      for (const [fe, me] of o)
        await checkBatch({
          sessionId: fe,
          transactionBatch: me,
          ...e
        });
    e.shouldRefreshBalance && refreshAccount();
  }
  return r;
}
async function getWebsocketUrl(r) {
  try {
    const { data: e } = await axios$2.get(
      `${r}/websocket/config`
    );
    return `wss://${e.url}`;
  } catch (e) {
    throw console.error(e), new Error("Can not get websocket url");
  }
}
const PACKET_TYPES = /* @__PURE__ */ Object.create(null);
PACKET_TYPES.open = "0";
PACKET_TYPES.close = "1";
PACKET_TYPES.ping = "2";
PACKET_TYPES.pong = "3";
PACKET_TYPES.message = "4";
PACKET_TYPES.upgrade = "5";
PACKET_TYPES.noop = "6";
const PACKET_TYPES_REVERSE = /* @__PURE__ */ Object.create(null);
Object.keys(PACKET_TYPES).forEach((r) => {
  PACKET_TYPES_REVERSE[PACKET_TYPES[r]] = r;
});
const ERROR_PACKET = { type: "error", data: "parser error" }, withNativeBlob$1 = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", withNativeArrayBuffer$2 = typeof ArrayBuffer == "function", isView$1 = (r) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r && r.buffer instanceof ArrayBuffer, encodePacket = ({ type: r, data: e }, s, o) => withNativeBlob$1 && e instanceof Blob ? s ? o(e) : encodeBlobAsBase64(e, o) : withNativeArrayBuffer$2 && (e instanceof ArrayBuffer || isView$1(e)) ? s ? o(e) : encodeBlobAsBase64(new Blob([e]), o) : o(PACKET_TYPES[r] + (e || "")), encodeBlobAsBase64 = (r, e) => {
  const s = new FileReader();
  return s.onload = function() {
    const o = s.result.split(",")[1];
    e("b" + o);
  }, s.readAsDataURL(r);
}, chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", lookup$1 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let r = 0; r < chars.length; r++)
  lookup$1[chars.charCodeAt(r)] = r;
const decode$1 = (r) => {
  let e = r.length * 0.75, s = r.length, o, fe = 0, me, ye, fr, Er;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  const br = new ArrayBuffer(e), wr = new Uint8Array(br);
  for (o = 0; o < s; o += 4)
    me = lookup$1[r.charCodeAt(o)], ye = lookup$1[r.charCodeAt(o + 1)], fr = lookup$1[r.charCodeAt(o + 2)], Er = lookup$1[r.charCodeAt(o + 3)], wr[fe++] = me << 2 | ye >> 4, wr[fe++] = (ye & 15) << 4 | fr >> 2, wr[fe++] = (fr & 3) << 6 | Er & 63;
  return br;
}, withNativeArrayBuffer$1 = typeof ArrayBuffer == "function", decodePacket = (r, e) => {
  if (typeof r != "string")
    return {
      type: "message",
      data: mapBinary(r, e)
    };
  const s = r.charAt(0);
  return s === "b" ? {
    type: "message",
    data: decodeBase64Packet(r.substring(1), e)
  } : PACKET_TYPES_REVERSE[s] ? r.length > 1 ? {
    type: PACKET_TYPES_REVERSE[s],
    data: r.substring(1)
  } : {
    type: PACKET_TYPES_REVERSE[s]
  } : ERROR_PACKET;
}, decodeBase64Packet = (r, e) => {
  if (withNativeArrayBuffer$1) {
    const s = decode$1(r);
    return mapBinary(s, e);
  } else
    return { base64: !0, data: r };
}, mapBinary = (r, e) => {
  switch (e) {
    case "blob":
      return r instanceof ArrayBuffer ? new Blob([r]) : r;
    case "arraybuffer":
    default:
      return r;
  }
}, SEPARATOR = String.fromCharCode(30), encodePayload = (r, e) => {
  const s = r.length, o = new Array(s);
  let fe = 0;
  r.forEach((me, ye) => {
    encodePacket(me, !1, (fr) => {
      o[ye] = fr, ++fe === s && e(o.join(SEPARATOR));
    });
  });
}, decodePayload = (r, e) => {
  const s = r.split(SEPARATOR), o = [];
  for (let fe = 0; fe < s.length; fe++) {
    const me = decodePacket(s[fe], e);
    if (o.push(me), me.type === "error")
      break;
  }
  return o;
}, protocol$1 = 4;
function Emitter(r) {
  if (r)
    return mixin(r);
}
function mixin(r) {
  for (var e in Emitter.prototype)
    r[e] = Emitter.prototype[e];
  return r;
}
Emitter.prototype.on = Emitter.prototype.addEventListener = function(r, e) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + r] = this._callbacks["$" + r] || []).push(e), this;
};
Emitter.prototype.once = function(r, e) {
  function s() {
    this.off(r, s), e.apply(this, arguments);
  }
  return s.fn = e, this.on(r, s), this;
};
Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(r, e) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var s = this._callbacks["$" + r];
  if (!s)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + r], this;
  for (var o, fe = 0; fe < s.length; fe++)
    if (o = s[fe], o === e || o.fn === e) {
      s.splice(fe, 1);
      break;
    }
  return s.length === 0 && delete this._callbacks["$" + r], this;
};
Emitter.prototype.emit = function(r) {
  this._callbacks = this._callbacks || {};
  for (var e = new Array(arguments.length - 1), s = this._callbacks["$" + r], o = 1; o < arguments.length; o++)
    e[o - 1] = arguments[o];
  if (s) {
    s = s.slice(0);
    for (var o = 0, fe = s.length; o < fe; ++o)
      s[o].apply(this, e);
  }
  return this;
};
Emitter.prototype.emitReserved = Emitter.prototype.emit;
Emitter.prototype.listeners = function(r) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + r] || [];
};
Emitter.prototype.hasListeners = function(r) {
  return !!this.listeners(r).length;
};
const globalThisShim = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())();
function pick(r, ...e) {
  return e.reduce((s, o) => (r.hasOwnProperty(o) && (s[o] = r[o]), s), {});
}
const NATIVE_SET_TIMEOUT = setTimeout, NATIVE_CLEAR_TIMEOUT = clearTimeout;
function installTimerFunctions(r, e) {
  e.useNativeTimers ? (r.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim), r.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim)) : (r.setTimeoutFn = setTimeout.bind(globalThisShim), r.clearTimeoutFn = clearTimeout.bind(globalThisShim));
}
const BASE64_OVERHEAD = 1.33;
function byteLength(r) {
  return typeof r == "string" ? utf8Length(r) : Math.ceil((r.byteLength || r.size) * BASE64_OVERHEAD);
}
function utf8Length(r) {
  let e = 0, s = 0;
  for (let o = 0, fe = r.length; o < fe; o++)
    e = r.charCodeAt(o), e < 128 ? s += 1 : e < 2048 ? s += 2 : e < 55296 || e >= 57344 ? s += 3 : (o++, s += 4);
  return s;
}
class TransportError extends Error {
  constructor(e, s, o) {
    super(e), this.description = s, this.context = o, this.type = "TransportError";
  }
}
class Transport extends Emitter {
  constructor(e) {
    super(), this.writable = !1, installTimerFunctions(this, e), this.opts = e, this.query = e.query, this.readyState = "", this.socket = e.socket;
  }
  onError(e, s, o) {
    return super.emitReserved("error", new TransportError(e, s, o)), this;
  }
  open() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  send(e) {
    this.readyState === "open" && this.write(e);
  }
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  onData(e) {
    const s = decodePacket(e, this.socket.binaryType);
    this.onPacket(s);
  }
  onPacket(e) {
    super.emitReserved("packet", e);
  }
  onClose(e) {
    this.readyState = "closed", super.emitReserved("close", e);
  }
}
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), length = 64, map = {};
let seed = 0, i = 0, prev;
function encode$1(r) {
  let e = "";
  do
    e = alphabet[r % length] + e, r = Math.floor(r / length);
  while (r > 0);
  return e;
}
function yeast() {
  const r = encode$1(+new Date());
  return r !== prev ? (seed = 0, prev = r) : r + "." + encode$1(seed++);
}
for (; i < length; i++)
  map[alphabet[i]] = i;
function encode(r) {
  let e = "";
  for (let s in r)
    r.hasOwnProperty(s) && (e.length && (e += "&"), e += encodeURIComponent(s) + "=" + encodeURIComponent(r[s]));
  return e;
}
function decode(r) {
  let e = {}, s = r.split("&");
  for (let o = 0, fe = s.length; o < fe; o++) {
    let me = s[o].split("=");
    e[decodeURIComponent(me[0])] = decodeURIComponent(me[1]);
  }
  return e;
}
let value = !1;
try {
  value = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch (r) {
}
const hasCORS = value;
function XHR(r) {
  const e = r.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!e || hasCORS))
      return new XMLHttpRequest();
  } catch {
  }
  if (!e)
    try {
      return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
function empty() {
}
const hasXHR2 = function() {
  return new XHR({
    xdomain: !1
  }).responseType != null;
}();
class Polling extends Transport {
  constructor(e) {
    if (super(e), this.polling = !1, typeof location < "u") {
      const o = location.protocol === "https:";
      let fe = location.port;
      fe || (fe = o ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || fe !== e.port, this.xs = e.secure !== o;
    }
    const s = e && e.forceBase64;
    this.supportsBinary = hasXHR2 && !s;
  }
  get name() {
    return "polling";
  }
  doOpen() {
    this.poll();
  }
  pause(e) {
    this.readyState = "pausing";
    const s = () => {
      this.readyState = "paused", e();
    };
    if (this.polling || !this.writable) {
      let o = 0;
      this.polling && (o++, this.once("pollComplete", function() {
        --o || s();
      })), this.writable || (o++, this.once("drain", function() {
        --o || s();
      }));
    } else
      s();
  }
  poll() {
    this.polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  onData(e) {
    const s = (o) => {
      if (this.readyState === "opening" && o.type === "open" && this.onOpen(), o.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(o);
    };
    decodePayload(e, this.socket.binaryType).forEach(s), this.readyState !== "closed" && (this.polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this.poll());
  }
  doClose() {
    const e = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? e() : this.once("open", e);
  }
  write(e) {
    this.writable = !1, encodePayload(e, (s) => {
      this.doWrite(s, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  uri() {
    let e = this.query || {};
    const s = this.opts.secure ? "https" : "http";
    let o = "";
    this.opts.timestampRequests !== !1 && (e[this.opts.timestampParam] = yeast()), !this.supportsBinary && !e.sid && (e.b64 = 1), this.opts.port && (s === "https" && Number(this.opts.port) !== 443 || s === "http" && Number(this.opts.port) !== 80) && (o = ":" + this.opts.port);
    const fe = encode(e), me = this.opts.hostname.indexOf(":") !== -1;
    return s + "://" + (me ? "[" + this.opts.hostname + "]" : this.opts.hostname) + o + this.opts.path + (fe.length ? "?" + fe : "");
  }
  request(e = {}) {
    return Object.assign(e, { xd: this.xd, xs: this.xs }, this.opts), new Request(this.uri(), e);
  }
  doWrite(e, s) {
    const o = this.request({
      method: "POST",
      data: e
    });
    o.on("success", s), o.on("error", (fe, me) => {
      this.onError("xhr post error", fe, me);
    });
  }
  doPoll() {
    const e = this.request();
    e.on("data", this.onData.bind(this)), e.on("error", (s, o) => {
      this.onError("xhr poll error", s, o);
    }), this.pollXhr = e;
  }
}
class Request extends Emitter {
  constructor(e, s) {
    super(), installTimerFunctions(this, s), this.opts = s, this.method = s.method || "GET", this.uri = e, this.async = s.async !== !1, this.data = s.data !== void 0 ? s.data : null, this.create();
  }
  create() {
    const e = pick(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    e.xdomain = !!this.opts.xd, e.xscheme = !!this.opts.xs;
    const s = this.xhr = new XHR(e);
    try {
      s.open(this.method, this.uri, this.async);
      try {
        if (this.opts.extraHeaders) {
          s.setDisableHeaderCheck && s.setDisableHeaderCheck(!0);
          for (let o in this.opts.extraHeaders)
            this.opts.extraHeaders.hasOwnProperty(o) && s.setRequestHeader(o, this.opts.extraHeaders[o]);
        }
      } catch {
      }
      if (this.method === "POST")
        try {
          s.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        s.setRequestHeader("Accept", "*/*");
      } catch {
      }
      "withCredentials" in s && (s.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (s.timeout = this.opts.requestTimeout), s.onreadystatechange = () => {
        s.readyState === 4 && (s.status === 200 || s.status === 1223 ? this.onLoad() : this.setTimeoutFn(() => {
          this.onError(typeof s.status == "number" ? s.status : 0);
        }, 0));
      }, s.send(this.data);
    } catch (o) {
      this.setTimeoutFn(() => {
        this.onError(o);
      }, 0);
      return;
    }
    typeof document < "u" && (this.index = Request.requestsCount++, Request.requests[this.index] = this);
  }
  onError(e) {
    this.emitReserved("error", e, this.xhr), this.cleanup(!0);
  }
  cleanup(e) {
    if (!(typeof this.xhr > "u" || this.xhr === null)) {
      if (this.xhr.onreadystatechange = empty, e)
        try {
          this.xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Request.requests[this.index], this.xhr = null;
    }
  }
  onLoad() {
    const e = this.xhr.responseText;
    e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this.cleanup());
  }
  abort() {
    this.cleanup();
  }
}
Request.requestsCount = 0;
Request.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", unloadHandler);
  else if (typeof addEventListener == "function") {
    const r = "onpagehide" in globalThisShim ? "pagehide" : "unload";
    addEventListener(r, unloadHandler, !1);
  }
}
function unloadHandler() {
  for (let r in Request.requests)
    Request.requests.hasOwnProperty(r) && Request.requests[r].abort();
}
const nextTick = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, s) => s(e, 0))(), WebSocket$1 = globalThisShim.WebSocket || globalThisShim.MozWebSocket, usingBrowserWebSocket = !0, defaultBinaryType = "arraybuffer", isReactNative = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class WS extends Transport {
  constructor(e) {
    super(e), this.supportsBinary = !e.forceBase64;
  }
  get name() {
    return "websocket";
  }
  doOpen() {
    if (!this.check())
      return;
    const e = this.uri(), s = this.opts.protocols, o = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (o.headers = this.opts.extraHeaders);
    try {
      this.ws = usingBrowserWebSocket && !isReactNative ? s ? new WebSocket$1(e, s) : new WebSocket$1(e) : new WebSocket$1(e, s, o);
    } catch (fe) {
      return this.emitReserved("error", fe);
    }
    this.ws.binaryType = this.socket.binaryType || defaultBinaryType, this.addEventListeners();
  }
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (e) => this.onClose({
      description: "websocket connection closed",
      context: e
    }), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
  }
  write(e) {
    this.writable = !1;
    for (let s = 0; s < e.length; s++) {
      const o = e[s], fe = s === e.length - 1;
      encodePacket(o, this.supportsBinary, (me) => {
        const ye = {};
        try {
          usingBrowserWebSocket && this.ws.send(me);
        } catch {
        }
        fe && nextTick(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.close(), this.ws = null);
  }
  uri() {
    let e = this.query || {};
    const s = this.opts.secure ? "wss" : "ws";
    let o = "";
    this.opts.port && (s === "wss" && Number(this.opts.port) !== 443 || s === "ws" && Number(this.opts.port) !== 80) && (o = ":" + this.opts.port), this.opts.timestampRequests && (e[this.opts.timestampParam] = yeast()), this.supportsBinary || (e.b64 = 1);
    const fe = encode(e), me = this.opts.hostname.indexOf(":") !== -1;
    return s + "://" + (me ? "[" + this.opts.hostname + "]" : this.opts.hostname) + o + this.opts.path + (fe.length ? "?" + fe : "");
  }
  check() {
    return !!WebSocket$1;
  }
}
const transports = {
  websocket: WS,
  polling: Polling
}, re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, parts = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function parse(r) {
  const e = r, s = r.indexOf("["), o = r.indexOf("]");
  s != -1 && o != -1 && (r = r.substring(0, s) + r.substring(s, o).replace(/:/g, ";") + r.substring(o, r.length));
  let fe = re.exec(r || ""), me = {}, ye = 14;
  for (; ye--; )
    me[parts[ye]] = fe[ye] || "";
  return s != -1 && o != -1 && (me.source = e, me.host = me.host.substring(1, me.host.length - 1).replace(/;/g, ":"), me.authority = me.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), me.ipv6uri = !0), me.pathNames = pathNames(me, me.path), me.queryKey = queryKey(me, me.query), me;
}
function pathNames(r, e) {
  const s = /\/{2,9}/g, o = e.replace(s, "/").split("/");
  return (e.slice(0, 1) == "/" || e.length === 0) && o.splice(0, 1), e.slice(-1) == "/" && o.splice(o.length - 1, 1), o;
}
function queryKey(r, e) {
  const s = {};
  return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(o, fe, me) {
    fe && (s[fe] = me);
  }), s;
}
class Socket$1 extends Emitter {
  constructor(e, s = {}) {
    super(), e && typeof e == "object" && (s = e, e = null), e ? (e = parse(e), s.hostname = e.host, s.secure = e.protocol === "https" || e.protocol === "wss", s.port = e.port, e.query && (s.query = e.query)) : s.host && (s.hostname = parse(s.host).host), installTimerFunctions(this, s), this.secure = s.secure != null ? s.secure : typeof location < "u" && location.protocol === "https:", s.hostname && !s.port && (s.port = this.secure ? "443" : "80"), this.hostname = s.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = s.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = s.transports || ["polling", "websocket"], this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !0
    }, s), this.opts.path = this.opts.path.replace(/\/$/, "") + "/", typeof this.opts.query == "string" && (this.opts.query = decode(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, typeof addEventListener == "function" && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this.offlineEventListener = () => {
      this.onClose("transport close", {
        description: "network connection lost"
      });
    }, addEventListener("offline", this.offlineEventListener, !1))), this.open();
  }
  createTransport(e) {
    const s = Object.assign({}, this.opts.query);
    s.EIO = protocol$1, s.transport = e, this.id && (s.sid = this.id);
    const o = Object.assign({}, this.opts.transportOptions[e], this.opts, {
      query: s,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    });
    return new transports[e](o);
  }
  open() {
    let e;
    if (this.opts.rememberUpgrade && Socket$1.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      e = "websocket";
    else if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    } else
      e = this.transports[0];
    this.readyState = "opening";
    try {
      e = this.createTransport(e);
    } catch {
      this.transports.shift(), this.open();
      return;
    }
    e.open(), this.setTransport(e);
  }
  setTransport(e) {
    this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (s) => this.onClose("transport close", s));
  }
  probe(e) {
    let s = this.createTransport(e), o = !1;
    Socket$1.priorWebsocketSuccess = !1;
    const fe = () => {
      o || (s.send([{ type: "ping", data: "probe" }]), s.once("packet", (kr) => {
        if (!o)
          if (kr.type === "pong" && kr.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", s), !s)
              return;
            Socket$1.priorWebsocketSuccess = s.name === "websocket", this.transport.pause(() => {
              o || this.readyState !== "closed" && (wr(), this.setTransport(s), s.send([{ type: "upgrade" }]), this.emitReserved("upgrade", s), s = null, this.upgrading = !1, this.flush());
            });
          } else {
            const Gr = new Error("probe error");
            Gr.transport = s.name, this.emitReserved("upgradeError", Gr);
          }
      }));
    };
    function me() {
      o || (o = !0, wr(), s.close(), s = null);
    }
    const ye = (kr) => {
      const Gr = new Error("probe error: " + kr);
      Gr.transport = s.name, me(), this.emitReserved("upgradeError", Gr);
    };
    function fr() {
      ye("transport closed");
    }
    function Er() {
      ye("socket closed");
    }
    function br(kr) {
      s && kr.name !== s.name && me();
    }
    const wr = () => {
      s.removeListener("open", fe), s.removeListener("error", ye), s.removeListener("close", fr), this.off("close", Er), this.off("upgrading", br);
    };
    s.once("open", fe), s.once("error", ye), s.once("close", fr), this.once("close", Er), this.once("upgrading", br), s.open();
  }
  onOpen() {
    if (this.readyState = "open", Socket$1.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade && this.transport.pause) {
      let e = 0;
      const s = this.upgrades.length;
      for (; e < s; e++)
        this.probe(this.upgrades[e]);
    }
  }
  onPacket(e) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
        case "open":
          this.onHandshake(JSON.parse(e.data));
          break;
        case "ping":
          this.resetPingTimeout(), this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
          break;
        case "error":
          const s = new Error("server error");
          s.code = e.data, this.onError(s);
          break;
        case "message":
          this.emitReserved("data", e.data), this.emitReserved("message", e.data);
          break;
      }
  }
  onHandshake(e) {
    this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this.upgrades = this.filterUpgrades(e.upgrades), this.pingInterval = e.pingInterval, this.pingTimeout = e.pingTimeout, this.maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this.resetPingTimeout();
  }
  resetPingTimeout() {
    this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
      this.onClose("ping timeout");
    }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
  }
  onDrain() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const e = this.getWritablePackets();
      this.transport.send(e), this.prevBufferLen = e.length, this.emitReserved("flush");
    }
  }
  getWritablePackets() {
    if (!(this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let s = 1;
    for (let o = 0; o < this.writeBuffer.length; o++) {
      const fe = this.writeBuffer[o].data;
      if (fe && (s += byteLength(fe)), o > 0 && s > this.maxPayload)
        return this.writeBuffer.slice(0, o);
      s += 2;
    }
    return this.writeBuffer;
  }
  write(e, s, o) {
    return this.sendPacket("message", e, s, o), this;
  }
  send(e, s, o) {
    return this.sendPacket("message", e, s, o), this;
  }
  sendPacket(e, s, o, fe) {
    if (typeof s == "function" && (fe = s, s = void 0), typeof o == "function" && (fe = o, o = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    o = o || {}, o.compress = o.compress !== !1;
    const me = {
      type: e,
      data: s,
      options: o
    };
    this.emitReserved("packetCreate", me), this.writeBuffer.push(me), fe && this.once("flush", fe), this.flush();
  }
  close() {
    const e = () => {
      this.onClose("forced close"), this.transport.close();
    }, s = () => {
      this.off("upgrade", s), this.off("upgradeError", s), e();
    }, o = () => {
      this.once("upgrade", s), this.once("upgradeError", s);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? o() : e();
    }) : this.upgrading ? o() : e()), this;
  }
  onError(e) {
    Socket$1.priorWebsocketSuccess = !1, this.emitReserved("error", e), this.onClose("transport error", e);
  }
  onClose(e, s) {
    (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") && (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), typeof removeEventListener == "function" && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", e, s), this.writeBuffer = [], this.prevBufferLen = 0);
  }
  filterUpgrades(e) {
    const s = [];
    let o = 0;
    const fe = e.length;
    for (; o < fe; o++)
      ~this.transports.indexOf(e[o]) && s.push(e[o]);
    return s;
  }
}
Socket$1.protocol = protocol$1;
function url(r, e = "", s) {
  let o = r;
  s = s || typeof location < "u" && location, r == null && (r = s.protocol + "//" + s.host), typeof r == "string" && (r.charAt(0) === "/" && (r.charAt(1) === "/" ? r = s.protocol + r : r = s.host + r), /^(https?|wss?):\/\//.test(r) || (typeof s < "u" ? r = s.protocol + "//" + r : r = "https://" + r), o = parse(r)), o.port || (/^(http|ws)$/.test(o.protocol) ? o.port = "80" : /^(http|ws)s$/.test(o.protocol) && (o.port = "443")), o.path = o.path || "/";
  const me = o.host.indexOf(":") !== -1 ? "[" + o.host + "]" : o.host;
  return o.id = o.protocol + "://" + me + ":" + o.port + e, o.href = o.protocol + "://" + me + (s && s.port === o.port ? "" : ":" + o.port), o;
}
const withNativeArrayBuffer = typeof ArrayBuffer == "function", isView = (r) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r.buffer instanceof ArrayBuffer, toString = Object.prototype.toString, withNativeBlob = typeof Blob == "function" || typeof Blob < "u" && toString.call(Blob) === "[object BlobConstructor]", withNativeFile = typeof File == "function" || typeof File < "u" && toString.call(File) === "[object FileConstructor]";
function isBinary(r) {
  return withNativeArrayBuffer && (r instanceof ArrayBuffer || isView(r)) || withNativeBlob && r instanceof Blob || withNativeFile && r instanceof File;
}
function hasBinary(r, e) {
  if (!r || typeof r != "object")
    return !1;
  if (Array.isArray(r)) {
    for (let s = 0, o = r.length; s < o; s++)
      if (hasBinary(r[s]))
        return !0;
    return !1;
  }
  if (isBinary(r))
    return !0;
  if (r.toJSON && typeof r.toJSON == "function" && arguments.length === 1)
    return hasBinary(r.toJSON(), !0);
  for (const s in r)
    if (Object.prototype.hasOwnProperty.call(r, s) && hasBinary(r[s]))
      return !0;
  return !1;
}
function deconstructPacket(r) {
  const e = [], s = r.data, o = r;
  return o.data = _deconstructPacket(s, e), o.attachments = e.length, { packet: o, buffers: e };
}
function _deconstructPacket(r, e) {
  if (!r)
    return r;
  if (isBinary(r)) {
    const s = { _placeholder: !0, num: e.length };
    return e.push(r), s;
  } else if (Array.isArray(r)) {
    const s = new Array(r.length);
    for (let o = 0; o < r.length; o++)
      s[o] = _deconstructPacket(r[o], e);
    return s;
  } else if (typeof r == "object" && !(r instanceof Date)) {
    const s = {};
    for (const o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (s[o] = _deconstructPacket(r[o], e));
    return s;
  }
  return r;
}
function reconstructPacket(r, e) {
  return r.data = _reconstructPacket(r.data, e), r.attachments = void 0, r;
}
function _reconstructPacket(r, e) {
  if (!r)
    return r;
  if (r && r._placeholder === !0) {
    if (typeof r.num == "number" && r.num >= 0 && r.num < e.length)
      return e[r.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(r))
    for (let s = 0; s < r.length; s++)
      r[s] = _reconstructPacket(r[s], e);
  else if (typeof r == "object")
    for (const s in r)
      Object.prototype.hasOwnProperty.call(r, s) && (r[s] = _reconstructPacket(r[s], e));
  return r;
}
const protocol = 5;
var PacketType;
(function(r) {
  r[r.CONNECT = 0] = "CONNECT", r[r.DISCONNECT = 1] = "DISCONNECT", r[r.EVENT = 2] = "EVENT", r[r.ACK = 3] = "ACK", r[r.CONNECT_ERROR = 4] = "CONNECT_ERROR", r[r.BINARY_EVENT = 5] = "BINARY_EVENT", r[r.BINARY_ACK = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
class Encoder {
  constructor(e) {
    this.replacer = e;
  }
  encode(e) {
    return (e.type === PacketType.EVENT || e.type === PacketType.ACK) && hasBinary(e) ? (e.type = e.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK, this.encodeAsBinary(e)) : [this.encodeAsString(e)];
  }
  encodeAsString(e) {
    let s = "" + e.type;
    return (e.type === PacketType.BINARY_EVENT || e.type === PacketType.BINARY_ACK) && (s += e.attachments + "-"), e.nsp && e.nsp !== "/" && (s += e.nsp + ","), e.id != null && (s += e.id), e.data != null && (s += JSON.stringify(e.data, this.replacer)), s;
  }
  encodeAsBinary(e) {
    const s = deconstructPacket(e), o = this.encodeAsString(s.packet), fe = s.buffers;
    return fe.unshift(o), fe;
  }
}
class Decoder extends Emitter {
  constructor(e) {
    super(), this.reviver = e;
  }
  add(e) {
    let s;
    if (typeof e == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      s = this.decodeString(e), s.type === PacketType.BINARY_EVENT || s.type === PacketType.BINARY_ACK ? (this.reconstructor = new BinaryReconstructor(s), s.attachments === 0 && super.emitReserved("decoded", s)) : super.emitReserved("decoded", s);
    } else if (isBinary(e) || e.base64)
      if (this.reconstructor)
        s = this.reconstructor.takeBinaryData(e), s && (this.reconstructor = null, super.emitReserved("decoded", s));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + e);
  }
  decodeString(e) {
    let s = 0;
    const o = {
      type: Number(e.charAt(0))
    };
    if (PacketType[o.type] === void 0)
      throw new Error("unknown packet type " + o.type);
    if (o.type === PacketType.BINARY_EVENT || o.type === PacketType.BINARY_ACK) {
      const me = s + 1;
      for (; e.charAt(++s) !== "-" && s != e.length; )
        ;
      const ye = e.substring(me, s);
      if (ye != Number(ye) || e.charAt(s) !== "-")
        throw new Error("Illegal attachments");
      o.attachments = Number(ye);
    }
    if (e.charAt(s + 1) === "/") {
      const me = s + 1;
      for (; ++s && !(e.charAt(s) === "," || s === e.length); )
        ;
      o.nsp = e.substring(me, s);
    } else
      o.nsp = "/";
    const fe = e.charAt(s + 1);
    if (fe !== "" && Number(fe) == fe) {
      const me = s + 1;
      for (; ++s; ) {
        const ye = e.charAt(s);
        if (ye == null || Number(ye) != ye) {
          --s;
          break;
        }
        if (s === e.length)
          break;
      }
      o.id = Number(e.substring(me, s + 1));
    }
    if (e.charAt(++s)) {
      const me = this.tryParse(e.substr(s));
      if (Decoder.isPayloadValid(o.type, me))
        o.data = me;
      else
        throw new Error("invalid payload");
    }
    return o;
  }
  tryParse(e) {
    try {
      return JSON.parse(e, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(e, s) {
    switch (e) {
      case PacketType.CONNECT:
        return typeof s == "object";
      case PacketType.DISCONNECT:
        return s === void 0;
      case PacketType.CONNECT_ERROR:
        return typeof s == "string" || typeof s == "object";
      case PacketType.EVENT:
      case PacketType.BINARY_EVENT:
        return Array.isArray(s) && s.length > 0;
      case PacketType.ACK:
      case PacketType.BINARY_ACK:
        return Array.isArray(s);
    }
  }
  destroy() {
    this.reconstructor && this.reconstructor.finishedReconstruction();
  }
}
class BinaryReconstructor {
  constructor(e) {
    this.packet = e, this.buffers = [], this.reconPack = e;
  }
  takeBinaryData(e) {
    if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
      const s = reconstructPacket(this.reconPack, this.buffers);
      return this.finishedReconstruction(), s;
    }
    return null;
  }
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const parser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  protocol,
  get PacketType() {
    return PacketType;
  },
  Encoder,
  Decoder
}, Symbol.toStringTag, { value: "Module" }));
function on(r, e, s) {
  return r.on(e, s), function() {
    r.off(e, s);
  };
}
const RESERVED_EVENTS = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  newListener: 1,
  removeListener: 1
});
class Socket extends Emitter {
  constructor(e, s, o) {
    super(), this.connected = !1, this.receiveBuffer = [], this.sendBuffer = [], this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = s, o && o.auth && (this.auth = o.auth), this.io._autoConnect && this.open();
  }
  get disconnected() {
    return !this.connected;
  }
  subEvents() {
    if (this.subs)
      return;
    const e = this.io;
    this.subs = [
      on(e, "open", this.onopen.bind(this)),
      on(e, "packet", this.onpacket.bind(this)),
      on(e, "error", this.onerror.bind(this)),
      on(e, "close", this.onclose.bind(this))
    ];
  }
  get active() {
    return !!this.subs;
  }
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  open() {
    return this.connect();
  }
  send(...e) {
    return e.unshift("message"), this.emit.apply(this, e), this;
  }
  emit(e, ...s) {
    if (RESERVED_EVENTS.hasOwnProperty(e))
      throw new Error('"' + e + '" is a reserved event name');
    s.unshift(e);
    const o = {
      type: PacketType.EVENT,
      data: s
    };
    if (o.options = {}, o.options.compress = this.flags.compress !== !1, typeof s[s.length - 1] == "function") {
      const ye = this.ids++, fr = s.pop();
      this._registerAckCallback(ye, fr), o.id = ye;
    }
    const fe = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
    return this.flags.volatile && (!fe || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(o), this.packet(o)) : this.sendBuffer.push(o)), this.flags = {}, this;
  }
  _registerAckCallback(e, s) {
    const o = this.flags.timeout;
    if (o === void 0) {
      this.acks[e] = s;
      return;
    }
    const fe = this.io.setTimeoutFn(() => {
      delete this.acks[e];
      for (let me = 0; me < this.sendBuffer.length; me++)
        this.sendBuffer[me].id === e && this.sendBuffer.splice(me, 1);
      s.call(this, new Error("operation has timed out"));
    }, o);
    this.acks[e] = (...me) => {
      this.io.clearTimeoutFn(fe), s.apply(this, [null, ...me]);
    };
  }
  packet(e) {
    e.nsp = this.nsp, this.io._packet(e);
  }
  onopen() {
    typeof this.auth == "function" ? this.auth((e) => {
      this.packet({ type: PacketType.CONNECT, data: e });
    }) : this.packet({ type: PacketType.CONNECT, data: this.auth });
  }
  onerror(e) {
    this.connected || this.emitReserved("connect_error", e);
  }
  onclose(e, s) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", e, s);
  }
  onpacket(e) {
    if (e.nsp === this.nsp)
      switch (e.type) {
        case PacketType.CONNECT:
          if (e.data && e.data.sid) {
            const fe = e.data.sid;
            this.onconnect(fe);
          } else
            this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case PacketType.EVENT:
        case PacketType.BINARY_EVENT:
          this.onevent(e);
          break;
        case PacketType.ACK:
        case PacketType.BINARY_ACK:
          this.onack(e);
          break;
        case PacketType.DISCONNECT:
          this.ondisconnect();
          break;
        case PacketType.CONNECT_ERROR:
          this.destroy();
          const o = new Error(e.data.message);
          o.data = e.data.data, this.emitReserved("connect_error", o);
          break;
      }
  }
  onevent(e) {
    const s = e.data || [];
    e.id != null && s.push(this.ack(e.id)), this.connected ? this.emitEvent(s) : this.receiveBuffer.push(Object.freeze(s));
  }
  emitEvent(e) {
    if (this._anyListeners && this._anyListeners.length) {
      const s = this._anyListeners.slice();
      for (const o of s)
        o.apply(this, e);
    }
    super.emit.apply(this, e);
  }
  ack(e) {
    const s = this;
    let o = !1;
    return function(...fe) {
      o || (o = !0, s.packet({
        type: PacketType.ACK,
        id: e,
        data: fe
      }));
    };
  }
  onack(e) {
    const s = this.acks[e.id];
    typeof s == "function" && (s.apply(this, e.data), delete this.acks[e.id]);
  }
  onconnect(e) {
    this.id = e, this.connected = !0, this.emitBuffered(), this.emitReserved("connect");
  }
  emitBuffered() {
    this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
      this.notifyOutgoingListeners(e), this.packet(e);
    }), this.sendBuffer = [];
  }
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  destroy() {
    this.subs && (this.subs.forEach((e) => e()), this.subs = void 0), this.io._destroy(this);
  }
  disconnect() {
    return this.connected && this.packet({ type: PacketType.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  close() {
    return this.disconnect();
  }
  compress(e) {
    return this.flags.compress = e, this;
  }
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  timeout(e) {
    return this.flags.timeout = e, this;
  }
  onAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
  }
  prependAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
  }
  offAny(e) {
    if (!this._anyListeners)
      return this;
    if (e) {
      const s = this._anyListeners;
      for (let o = 0; o < s.length; o++)
        if (e === s[o])
          return s.splice(o, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  listenersAny() {
    return this._anyListeners || [];
  }
  onAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
  }
  prependAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
  }
  offAnyOutgoing(e) {
    if (!this._anyOutgoingListeners)
      return this;
    if (e) {
      const s = this._anyOutgoingListeners;
      for (let o = 0; o < s.length; o++)
        if (e === s[o])
          return s.splice(o, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  notifyOutgoingListeners(e) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const s = this._anyOutgoingListeners.slice();
      for (const o of s)
        o.apply(this, e.data);
    }
  }
}
function Backoff(r) {
  r = r || {}, this.ms = r.min || 100, this.max = r.max || 1e4, this.factor = r.factor || 2, this.jitter = r.jitter > 0 && r.jitter <= 1 ? r.jitter : 0, this.attempts = 0;
}
Backoff.prototype.duration = function() {
  var r = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var e = Math.random(), s = Math.floor(e * this.jitter * r);
    r = (Math.floor(e * 10) & 1) == 0 ? r - s : r + s;
  }
  return Math.min(r, this.max) | 0;
};
Backoff.prototype.reset = function() {
  this.attempts = 0;
};
Backoff.prototype.setMin = function(r) {
  this.ms = r;
};
Backoff.prototype.setMax = function(r) {
  this.max = r;
};
Backoff.prototype.setJitter = function(r) {
  this.jitter = r;
};
class Manager extends Emitter {
  constructor(e, s) {
    var o;
    super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (s = e, e = void 0), s = s || {}, s.path = s.path || "/socket.io", this.opts = s, installTimerFunctions(this, s), this.reconnection(s.reconnection !== !1), this.reconnectionAttempts(s.reconnectionAttempts || 1 / 0), this.reconnectionDelay(s.reconnectionDelay || 1e3), this.reconnectionDelayMax(s.reconnectionDelayMax || 5e3), this.randomizationFactor((o = s.randomizationFactor) !== null && o !== void 0 ? o : 0.5), this.backoff = new Backoff({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(s.timeout == null ? 2e4 : s.timeout), this._readyState = "closed", this.uri = e;
    const fe = s.parser || parser;
    this.encoder = new fe.Encoder(), this.decoder = new fe.Decoder(), this._autoConnect = s.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(e) {
    return arguments.length ? (this._reconnection = !!e, this) : this._reconnection;
  }
  reconnectionAttempts(e) {
    return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
  }
  reconnectionDelay(e) {
    var s;
    return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (s = this.backoff) === null || s === void 0 || s.setMin(e), this);
  }
  randomizationFactor(e) {
    var s;
    return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (s = this.backoff) === null || s === void 0 || s.setJitter(e), this);
  }
  reconnectionDelayMax(e) {
    var s;
    return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (s = this.backoff) === null || s === void 0 || s.setMax(e), this);
  }
  timeout(e) {
    return arguments.length ? (this._timeout = e, this) : this._timeout;
  }
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  open(e) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new Socket$1(this.uri, this.opts);
    const s = this.engine, o = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const fe = on(s, "open", function() {
      o.onopen(), e && e();
    }), me = on(s, "error", (ye) => {
      o.cleanup(), o._readyState = "closed", this.emitReserved("error", ye), e ? e(ye) : o.maybeReconnectOnOpen();
    });
    if (this._timeout !== !1) {
      const ye = this._timeout;
      ye === 0 && fe();
      const fr = this.setTimeoutFn(() => {
        fe(), s.close(), s.emit("error", new Error("timeout"));
      }, ye);
      this.opts.autoUnref && fr.unref(), this.subs.push(function() {
        clearTimeout(fr);
      });
    }
    return this.subs.push(fe), this.subs.push(me), this;
  }
  connect(e) {
    return this.open(e);
  }
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const e = this.engine;
    this.subs.push(on(e, "ping", this.onping.bind(this)), on(e, "data", this.ondata.bind(this)), on(e, "error", this.onerror.bind(this)), on(e, "close", this.onclose.bind(this)), on(this.decoder, "decoded", this.ondecoded.bind(this)));
  }
  onping() {
    this.emitReserved("ping");
  }
  ondata(e) {
    this.decoder.add(e);
  }
  ondecoded(e) {
    this.emitReserved("packet", e);
  }
  onerror(e) {
    this.emitReserved("error", e);
  }
  socket(e, s) {
    let o = this.nsps[e];
    return o || (o = new Socket(this, e, s), this.nsps[e] = o), o;
  }
  _destroy(e) {
    const s = Object.keys(this.nsps);
    for (const o of s)
      if (this.nsps[o].active)
        return;
    this._close();
  }
  _packet(e) {
    const s = this.encoder.encode(e);
    for (let o = 0; o < s.length; o++)
      this.engine.write(s[o], e.options);
  }
  cleanup() {
    this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
  }
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
  }
  disconnect() {
    return this._close();
  }
  onclose(e, s) {
    this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, s), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const e = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const s = this.backoff.duration();
      this._reconnecting = !0;
      const o = this.setTimeoutFn(() => {
        e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((fe) => {
          fe ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", fe)) : e.onreconnect();
        }));
      }, s);
      this.opts.autoUnref && o.unref(), this.subs.push(function() {
        clearTimeout(o);
      });
    }
  }
  onreconnect() {
    const e = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
  }
}
const cache = {};
function lookup(r, e) {
  typeof r == "object" && (e = r, r = void 0), e = e || {};
  const s = url(r, e.path || "/socket.io"), o = s.source, fe = s.id, me = s.path, ye = cache[fe] && me in cache[fe].nsps, fr = e.forceNew || e["force new connection"] || e.multiplex === !1 || ye;
  let Er;
  return fr ? Er = new Manager(o, e) : (cache[fe] || (cache[fe] = new Manager(o, e)), Er = cache[fe]), s.query && !e.query && (e.query = s.queryKey), Er.socket(s.path, e);
}
Object.assign(lookup, {
  Manager,
  Socket,
  io: lookup,
  connect: lookup
});
const useGetAccount = () => useAccountStore().getAccount;
var WebsocketConnectionStatusEnum = /* @__PURE__ */ ((r) => (r.NOT_INITIALIZED = "not_initialized", r.PENDING = "pending", r.COMPLETED = "completed", r))(WebsocketConnectionStatusEnum || {});
const websocketConnection = {
  current: null,
  status: "not_initialized"
}, TIMEOUT = 3e3, RECONNECTION_ATTEMPTS = 3, RETRY_INTERVAL = 500, MESSAGE_DELAY = 1e3;
function useInitializeWebsocketConnection() {
  const r = ref(null), { address: e } = useGetAccount(), s = ref(e), o = useGetNetworkConfig(), fe = ref(websocketConnection.current), me = (fr) => {
    r.value && clearTimeout(r.value), r.value = setTimeout(() => {
      useAccountStore().setWebsocketEvent(fr);
    }, MESSAGE_DELAY);
  }, ye = watch$3(
    s,
    retryMultipleTimes(
      async () => {
        websocketConnection.status = WebsocketConnectionStatusEnum.PENDING;
        const fr = await getWebsocketUrl(o.apiAddress);
        if (fr == null) {
          console.warn("Can not get websocket url");
          return;
        }
        websocketConnection.current = lookup(fr, {
          forceNew: !0,
          reconnectionAttempts: RECONNECTION_ATTEMPTS,
          timeout: TIMEOUT,
          query: {
            address: e
          }
        }), websocketConnection.status = WebsocketConnectionStatusEnum.COMPLETED, websocketConnection.current.onAny((Er) => {
          me(Er);
        });
      },
      {
        retries: 2,
        delay: RETRY_INTERVAL
      }
    ),
    {
      immediate: !0
    }
  );
  watch$3([s, fe], () => {
    e && websocketConnection.status === WebsocketConnectionStatusEnum.NOT_INITIALIZED && !websocketConnection.current && ye();
  }, {
    immediate: !0
  }), watchEffect(() => () => {
    var fr;
    (fr = websocketConnection.current) == null || fr.close(), r.value && clearTimeout(r.value);
  });
}
function useRegisterWebsocketListener(r) {
  useInitializeWebsocketConnection();
  const e = useAccountStore().getWebsocketEvent, s = ref(e);
  watch$3([r, s], () => {
    var fe;
    const o = (fe = s.value) == null ? void 0 : fe.message;
    o && r(o);
  }, {
    immediate: !0
  });
}
function useTransactionsTracker(r) {
  var fe;
  const e = useCheckTransactionStatus(), s = (fe = r == null ? void 0 : r.getTransactionsByHash) != null ? fe : getTransactionsByHashes, o = () => {
    e({
      shouldRefreshBalance: !0,
      getTransactionsByHash: s
    });
  };
  useRegisterWebsocketListener(o), watchEffect(() => {
    const me = setInterval(o, 2e3);
    return () => {
      clearInterval(me);
    };
  });
}
const styles = "", defaultOptions = {
  loadCss: !0,
  chain: "devnet"
}, defaultCustomNetworkConfig = {
  walletConnectV2ProjectId: ""
};
function erdjsVue(r = defaultOptions, e = defaultCustomNetworkConfig, s = emptyAppConfig) {
  return {
    dapp: {},
    options: r,
    install(fe) {
      if (!r.piniaInstance) {
        const me = createPinia();
        me.use(piniaPluginPersistedstate), fe.use(me);
      }
      this.dapp = new Dapp(r.chain, e, s), this.dapp.init();
      for (const me in components)
        fe.use(components[me]);
      fe.config.globalProperties.$erdjs = this, fe.provide("erdjs", this), setTimeout(() => {
        useTransactionsTracker();
      }, 1e3);
    },
    getDapp() {
      return this.dapp;
    }
  };
}
export {
  erdjsVue,
  explorerUrlBuilder,
  getExplorerLink
};
